webpackJsonp([0],{

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);
var sharedErrors = __webpack_require__(990);

module.exports = function (instance, methodNames) {
  methodNames.forEach(function (methodName) {
    instance[methodName] = function () {
      throw new BraintreeError({
        type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
        code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
        message: methodName + ' cannot be called after teardown.'
      });
    };
  });
};


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-reserved-keys */

var enumerate = __webpack_require__(995);
var errors = __webpack_require__(993);
var VERSION = "3.30.0";

var constants = {
  VERSION: VERSION,
  maxExpirationYearAge: 19,
  externalEvents: {
    FOCUS: 'focus',
    BLUR: 'blur',
    EMPTY: 'empty',
    NOT_EMPTY: 'notEmpty',
    VALIDITY_CHANGE: 'validityChange',
    CARD_TYPE_CHANGE: 'cardTypeChange'
  },
  defaultMaxLengths: {
    number: 19,
    postalCode: 8,
    expirationDate: 7,
    expirationMonth: 2,
    expirationYear: 4,
    cvv: 3
  },
  externalClasses: {
    FOCUSED: 'braintree-hosted-fields-focused',
    INVALID: 'braintree-hosted-fields-invalid',
    VALID: 'braintree-hosted-fields-valid'
  },
  defaultIFrameStyle: {
    border: 'none',
    width: '100%',
    height: '100%',
    'float': 'left'
  },
  tokenizationErrorCodes: {
    81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
    81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
  },
  whitelistedStyles: [
    '-moz-appearance',
    '-moz-osx-font-smoothing',
    '-moz-tap-highlight-color',
    '-moz-transition',
    '-webkit-appearance',
    '-webkit-font-smoothing',
    '-webkit-tap-highlight-color',
    '-webkit-transition',
    'appearance',
    'color',
    'direction',
    'font',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-variant-alternates',
    'font-variant-caps',
    'font-variant-east-asian',
    'font-variant-ligatures',
    'font-variant-numeric',
    'font-weight',
    'letter-spacing',
    'line-height',
    'padding',
    'opacity',
    'outline',
    'text-shadow',
    'transition'
  ],
  whitelistedFields: {
    number: {
      name: 'credit-card-number',
      label: 'Credit Card Number'
    },
    cvv: {
      name: 'cvv',
      label: 'CVV'
    },
    expirationDate: {
      name: 'expiration',
      label: 'Expiration Date'
    },
    expirationMonth: {
      name: 'expiration-month',
      label: 'Expiration Month'
    },
    expirationYear: {
      name: 'expiration-year',
      label: 'Expiration Year'
    },
    postalCode: {
      name: 'postal-code',
      label: 'Postal Code'
    }
  },
  whitelistedAttributes: {
    'aria-invalid': 'boolean',
    'aria-required': 'boolean',
    disabled: 'boolean',
    placeholder: 'string'
  }
};

constants.events = enumerate([
  'FRAME_READY',
  'VALIDATE_STRICT',
  'CONFIGURATION',
  'TOKENIZATION_REQUEST',
  'INPUT_EVENT',
  'TRIGGER_INPUT_FOCUS',
  'ADD_CLASS',
  'REMOVE_CLASS',
  'SET_ATTRIBUTE',
  'REMOVE_ATTRIBUTE',
  'CLEAR_FIELD',
  'AUTOFILL_EXPIRATION_DATE',
  'SET_MESSAGE'
], 'hosted-fields:');

module.exports = constants;


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = function isIos(ua) {
  ua = ua || global.navigator.userAgent;
  return /iPhone|iPod|iPad/i.test(ua);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(122);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(250);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

RadioButtonUnchecked = (0, _pure2.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';

exports.default = RadioButtonUnchecked;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isIe = __webpack_require__(1024);
var isIe9 = __webpack_require__(996);

module.exports = {
  isIe: isIe,
  isIe9: isIe9
};


/***/ }),

/***/ 1005:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ajaxIsAvaliable;
var once = __webpack_require__(997);
var JSONPDriver = __webpack_require__(1026);
var AJAXDriver = __webpack_require__(1027);
var getUserAgent = __webpack_require__(1036);
var isHTTP = __webpack_require__(1037);

function isAjaxAvailable() {
  if (ajaxIsAvaliable == null) {
    ajaxIsAvaliable = !(isHTTP() && /MSIE\s(8|9)/.test(getUserAgent()));
  }

  return ajaxIsAvaliable;
}

module.exports = function (options, cb) {
  cb = once(cb || Function.prototype);
  options.method = (options.method || 'GET').toUpperCase();
  options.timeout = options.timeout == null ? 60000 : options.timeout;
  options.data = options.data || {};

  if (isAjaxAvailable()) {
    AJAXDriver.request(options, cb);
  } else {
    JSONPDriver.request(options, cb);
  }
};


/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

function _notEmpty(obj) {
  var key;

  for (key in obj) {
    if (obj.hasOwnProperty(key)) { return true; }
  }

  return false;
}

/* eslint-disable no-mixed-operators */
function _isArray(value) {
  return value && typeof value === 'object' && typeof value.length === 'number' &&
    Object.prototype.toString.call(value) === '[object Array]' || false;
}
/* eslint-enable no-mixed-operators */

function parse(url) {
  var query, params;

  url = url || global.location.href;

  if (!/\?/.test(url)) {
    return {};
  }

  query = url.replace(/#.*$/, '').replace(/^.*\?/, '').split('&');

  params = query.reduce(function (toReturn, keyValue) {
    var parts = keyValue.split('=');
    var key = decodeURIComponent(parts[0]);
    var value = decodeURIComponent(parts[1]);

    toReturn[key] = value;

    return toReturn;
  }, {});

  return params;
}

function stringify(params, namespace) {
  var k, v, p;
  var query = [];

  for (p in params) {
    if (!params.hasOwnProperty(p)) {
      continue;
    }

    v = params[p];

    if (namespace) {
      if (_isArray(params)) {
        k = namespace + '[]';
      } else {
        k = namespace + '[' + p + ']';
      }
    } else {
      k = p;
    }
    if (typeof v === 'object') {
      query.push(stringify(v, k));
    } else {
      query.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
  }

  return query.join('&');
}

function queryify(url, params) {
  url = url || '';

  if (params != null && typeof params === 'object' && _notEmpty(params)) {
    url += url.indexOf('?') === -1 ? '?' : '';
    url += url.indexOf('=') !== -1 ? '&' : '';
    url += stringify(params);
  }

  return url;
}

module.exports = {
  parse: parse,
  stringify: stringify,
  queryify: queryify
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parser;
var legalHosts = {
  'paypal.com': 1,
  'braintreepayments.com': 1,
  'braintreegateway.com': 1,
  'braintree-api.com': 1
};

function stripSubdomains(domain) {
  return domain.split('.').slice(-2).join('.');
}

function isWhitelistedDomain(url) {
  var mainDomain;

  url = url.toLowerCase();

  if (!/^https:/.test(url)) {
    return false;
  }

  parser = parser || document.createElement('a');
  parser.href = url;
  mainDomain = stripSubdomains(parser.hostname);

  return legalHosts.hasOwnProperty(mainDomain);
}

module.exports = isWhitelistedDomain;


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);

function convertToBraintreeError(originalErr, btErrorObject) {
  if (originalErr instanceof BraintreeError) {
    return originalErr;
  }

  return new BraintreeError({
    type: btErrorObject.type,
    code: btErrorObject.code,
    message: btErrorObject.message,
    details: {
      originalError: originalErr
    }
  });
}

module.exports = convertToBraintreeError;


/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createAuthorizationData = __webpack_require__(1010);
var jsonClone = __webpack_require__(1039);
var constants = __webpack_require__(989);

function addMetadata(configuration, data) {
  var key;
  var attrs = data ? jsonClone(data) : {};
  var authAttrs = createAuthorizationData(configuration.authorization).attrs;
  var _meta = jsonClone(configuration.analyticsMetadata);

  attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;

  for (key in attrs._meta) {
    if (attrs._meta.hasOwnProperty(key)) {
      _meta[key] = attrs._meta[key];
    }
  }

  attrs._meta = _meta;

  if (authAttrs.tokenizationKey) {
    attrs.tokenizationKey = authAttrs.tokenizationKey;
  } else {
    attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
  }

  return attrs;
}

module.exports = addMetadata;


/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var atob = __webpack_require__(1038).atob;

var apiUrls = {
  production: 'https://api.braintreegateway.com:443',
  sandbox: 'https://api.sandbox.braintreegateway.com:443'
};

function _isTokenizationKey(str) {
  return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
}

function _parseTokenizationKey(tokenizationKey) {
  var tokens = tokenizationKey.split('_');
  var environment = tokens[0];
  var merchantId = tokens.slice(2).join('_');

  return {
    merchantId: merchantId,
    environment: environment
  };
}

function createAuthorizationData(authorization) {
  var parsedClientToken, parsedTokenizationKey;
  var data = {
    attrs: {},
    configUrl: ''
  };

  if (_isTokenizationKey(authorization)) {
    parsedTokenizationKey = _parseTokenizationKey(authorization);
    data.attrs.tokenizationKey = authorization;
    data.configUrl = apiUrls[parsedTokenizationKey.environment] + '/merchants/' + parsedTokenizationKey.merchantId + '/client_api/v1/configuration';
  } else {
    parsedClientToken = JSON.parse(atob(authorization));
    data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
    data.configUrl = parsedClientToken.configUrl;
  }

  return data;
}

module.exports = createAuthorizationData;


/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);

module.exports = {
  CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN'
  },
  CLIENT_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_OPTION_REQUIRED'
  },
  CLIENT_OPTION_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_OPTION_INVALID'
  },
  CLIENT_MISSING_GATEWAY_CONFIGURATION: {
    type: BraintreeError.types.INTERNAL,
    code: 'CLIENT_MISSING_GATEWAY_CONFIGURATION',
    message: 'Missing gatewayConfiguration.'
  },
  CLIENT_INVALID_AUTHORIZATION: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_INVALID_AUTHORIZATION',
    message: 'Authorization is invalid. Make sure your client token or tokenization key is valid.'
  },
  CLIENT_GATEWAY_NETWORK: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_GATEWAY_NETWORK',
    message: 'Cannot contact the gateway at this time.'
  },
  CLIENT_REQUEST_TIMEOUT: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_REQUEST_TIMEOUT',
    message: 'Request timed out waiting for a reply.'
  },
  CLIENT_REQUEST_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: 'CLIENT_REQUEST_ERROR',
    message: 'There was a problem with your request.'
  },
  CLIENT_RATE_LIMITED: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_RATE_LIMITED',
    message: 'You are being rate-limited; please try again in a few minutes.'
  },
  CLIENT_AUTHORIZATION_INSUFFICIENT: {
    type: BraintreeError.types.MERCHANT,
    code: 'CLIENT_AUTHORIZATION_INSUFFICIENT',
    message: 'The authorization used has insufficient privileges.'
  }
};


/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);
var Promise = __webpack_require__(987);
var sharedErrors = __webpack_require__(990);
var VERSION = "3.30.0";

function basicComponentVerification(options) {
  var client, clientVersion, name;

  if (!options) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
      code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
      message: 'Options must be passed to basicComponentVerification function.'
    }));
  }

  name = options.name;
  client = options.client;

  if (client == null) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: 'options.client is required when instantiating ' + name + '.'
    }));
  }

  clientVersion = client.getVersion();

  if (clientVersion !== VERSION) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
      code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
      message: 'Client (version ' + clientVersion + ') and ' + name + ' (version ' + VERSION + ') components must be from the same SDK version.'
    }));
  }

  return Promise.resolve();
}

module.exports = {
  verify: basicComponentVerification
};


/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);

module.exports = {
  PAYPAL_NOT_ENABLED: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_NOT_ENABLED',
    message: 'PayPal is not enabled for this merchant.'
  },
  PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED',
    message: 'A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developers.braintreepayments.com/guides/paypal/testing-go-live/#linked-paypal-testing for details on linking your PayPal sandbox with Braintree.'
  },
  PAYPAL_TOKENIZATION_REQUEST_ACTIVE: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_TOKENIZATION_REQUEST_ACTIVE',
    message: 'Another tokenization request is active.'
  },
  PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED',
    message: 'Could not tokenize user\'s PayPal account.'
  },
  PAYPAL_FLOW_FAILED: {
    type: BraintreeError.types.NETWORK,
    code: 'PAYPAL_FLOW_FAILED',
    message: 'Could not initialize PayPal flow.'
  },
  PAYPAL_FLOW_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_FLOW_OPTION_REQUIRED',
    message: 'PayPal flow property is invalid or missing.'
  },
  PAYPAL_POPUP_OPEN_FAILED: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_POPUP_OPEN_FAILED',
    message: 'PayPal popup failed to open, make sure to tokenize in response to a user action.'
  },
  PAYPAL_POPUP_CLOSED: {
    type: BraintreeError.types.CUSTOMER,
    code: 'PAYPAL_POPUP_CLOSED',
    message: 'Customer closed PayPal popup before authorizing.'
  },
  PAYPAL_INVALID_PAYMENT_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: 'PAYPAL_INVALID_PAYMENT_OPTION',
    message: 'PayPal payment options are invalid.'
  }
};


/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(1093);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(393);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = __webpack_require__(394);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuList = __webpack_require__(395);

Object.defineProperty(exports, 'MenuList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuList).default;
  }
});

var _MenuItem = __webpack_require__(1098);

Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpansionPanel = __webpack_require__(1105);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanel).default;
  }
});

var _ExpansionPanelActions = __webpack_require__(1107);

Object.defineProperty(exports, 'ExpansionPanelActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelActions).default;
  }
});

var _ExpansionPanelDetails = __webpack_require__(1108);

Object.defineProperty(exports, 'ExpansionPanelDetails', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelDetails).default;
  }
});

var _ExpansionPanelSummary = __webpack_require__(1109);

Object.defineProperty(exports, 'ExpansionPanelSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelSummary).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1116);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_braintree__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_containers_OrderForm_Steps__ = __webpack_require__(1083);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */








var USER_CONTENT_URL = "https://cdn.foodrevolution.org/checkout/";

var OrderForm = function (_Component) {
  _inherits(OrderForm, _Component);

  function OrderForm(props) {
    _classCallCheck(this, OrderForm);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.startBraintree = _this.startBraintree.bind(_this);
    _this.nextStep = _this.nextStep.bind(_this);
    _this.previousStep = _this.previousStep.bind(_this);
    _this.state = {
      steps: {
        user: __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_containers_OrderForm_Steps__["a" /* A */], options: __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_containers_OrderForm_Steps__["b" /* B */], address: __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_containers_OrderForm_Steps__["c" /* C */], order: __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_containers_OrderForm_Steps__["d" /* D */]
      }
    };
    return _this;
  }

  OrderForm.prototype.componentDidMount = function componentDidMount() {
    var optionsFirst = this.props.offer.optionsFirst;


    var steps = void 0;

    if (!this.props.user.isAuthenticated) {
      steps = optionsFirst ? ['options', 'user'] : ['user', 'options'];
    } else {
      steps = ['options'];
    }

    if (this.props.offer.physicalProducts.length) {
      steps.push('address');
    }

    steps.push('order');
    this.props.setSteps(steps);
    this.props.setOrderFormMessage(0);

    if (this.props.modalOpen) {
      this.props.hideModal();
    }
    window.onbeforeunload = function () {
      return false;
    };
    if (optionsFirst) {
      this.props.history.replace('/checkout/' + this.props.offer.slug + '/#/options');
    }
  };

  OrderForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var optionsFirst = this.props.offer.optionsFirst;


    if (!this.props.offer.slug && !!nextProps.offer.slug) {
      if (!this.props.history.location.hash) {
        var firstStep = this.props.user.isAuthenticated ? 'options' : optionsFirst ? 'options' : 'user';
        this.props.history.replace('/checkout/' + nextProps.offer.slug + '/#/' + firstStep);
      } else if (!this.props.user.isAuthenticated && !this.props.offer.stepValidity.A) {
        optionsFirst ? this.props.history.replace('/checkout/' + nextProps.offer.slug + '/#/options') : this.props.history.replace('/checkout/' + nextProps.offer.slug + '/#/user');
      }
    }

    if (this.props.offer && !this.props.offer.physicalProducts.length && nextProps.offer.physicalProducts.length) {
      var steps = this.props.offer.steps;

      steps.splice(-1, 0, 'address');
      this.props.setSteps(steps);
    }
    if (this.props.offer && this.props.offer.physicalProducts.length && !nextProps.offer.physicalProducts.length) {
      var _steps = this.props.offer.steps;

      _steps.splice(-2, 1);
      this.props.setSteps(_steps);
    }
    if (!this.props.user.isAuthenticated && nextProps.user.isAuthenticated) {
      if (this.props.history.location.hash.substring(2) === 'user') {
        var _steps2 = this.props.offer.steps;

        _steps2.splice(0, 1);
        this.props.setSteps(_steps2);
        this.props.history.push('/checkout/' + this.props.offer.slug + '/#/options');
      }
    }

    if (this.props.user.isAuthenticated && !nextProps.user.isAuthenticated) {
      this.props.history.location.reload();
    }
  };

  OrderForm.prototype.componentWillUnmount = function componentWillUnmount() {
    window.onbeforeunload = null;
  };

  OrderForm.prototype.startBraintree = function startBraintree() {
    Object(__WEBPACK_IMPORTED_MODULE_3_braintree__["a" /* default */])({
      openModal: this.props.openModal,
      processOrder: this.props.processOrder,
      addProducts: this.props.addProducts,
      setPaymentMethod: this.props.setPaymentMethod,
      setSelectedUserPaymentId: this.props.setSelectedUserPaymentId,
      setBraintreeValidity: this.props.setBraintreeValidity,
      blurBraintreeField: this.props.blurBraintreeField,
      setOrderFormMessage: this.props.setOrderFormMessage
    });
  };

  OrderForm.prototype.nextStep = function nextStep() {
    var currentStep = this.props.history.location.hash.substring(2);
    var currentStepIdx = this.props.offer.steps.indexOf(currentStep);
    var nextStep = currentStepIdx + 1;
    this.props.setCurrentStep(nextStep, currentStepIdx);
    if (nextStep <= this.props.offer.steps.length - 1) {
      this.props.history.push('/checkout/' + this.props.offer.slug + '/#/' + this.props.offer.steps[nextStep]);
    }
  };

  OrderForm.prototype.previousStep = function previousStep() {
    this.props.history.goBack();
  };

  OrderForm.prototype.render = function render() {
    var _this2 = this;

    var _props$offer = this.props.offer,
        stepValidity = _props$offer.stepValidity,
        selectedPaymentOption = _props$offer.selectedPaymentOption,
        totals = _props$offer.totals;
    var processOrder = this.props.processOrder;

    var totalIsZero = false;
    if (totals[selectedPaymentOption]) {
      if (parseInt(totals[selectedPaymentOption].transaction.total) === 0) {
        totalIsZero = true;
      }
    }

    var isPPT = this.props.offer.slug.slice(0, 3) === 'ppt';
    var logoUrl = isPPT ? 'assets/images/ppt-logo.svg' : 'assets/images/frs18-logo.svg';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { container: true, justify: 'center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { item: true, xs: 12, md: 9, style: { marginTop: '16px', maxWidth: '600px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'logo', src: '' + USER_CONTENT_URL + logoUrl })
        ),
        this.props.offer.steps.map(function (path, i) {
          var Step = _this2.state.steps[path];

          if (!Step) return;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Step.children, {
            key: Step.id,
            stepId: Step.id,
            display: _this2.props.history.location.hash.substring(2) === Step.path,
            buttonText: Step.buttonText,
            buttonTextInvalid: Step.buttonTextInvalid,
            buttonTextIsZero: Step.buttonTextIsZero,
            nextStep: _this2.nextStep,
            previousStep: _this2.previousStep,
            processOrder: processOrder,
            stepNumber: i + 1,
            subheading: Step.subheading,
            subheadingIsZero: Step.subheadingIsZero,
            totalIsZero: totalIsZero,
            totalSteps: _this2.props.offer.steps.length,
            validity: stepValidity[Step.id],
            startBraintree: _this2.startBraintree
          });
        })
      )
    );
  };

  return OrderForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

OrderForm.propTypes = {
  addProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hideModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    goBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      hash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }),
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired,
  modalOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  offer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    braintreeValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
    optionsFirst: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    slug: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    stepValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      A: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
    }).isRequired,
    physicalProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired
  }).isRequired,
  openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  processOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }).isRequired,
  setBraintreeValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  blurBraintreeField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setOrderFormMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPaymentMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedUserPaymentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* withRouter */])(OrderForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(USER_CONTENT_URL, 'USER_CONTENT_URL', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/index.jsx');

  __REACT_HOT_LOADER__.register(OrderForm, 'OrderForm', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/index.jsx');
}();

;

/***/ }),

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_braintree_web_client__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_braintree_web_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_braintree_web_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_braintree_web_paypal_checkout__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_braintree_web_paypal_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_braintree_web_paypal_checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_braintree_web_hosted_fields__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_braintree_web_hosted_fields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_braintree_web_hosted_fields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_paypal_checkout__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_paypal_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_paypal_checkout__);





// eslint-disable-next-line
var env = undefined ? 'sandbox' : 'production';

var _default = function _default(actions) {
  var button = document.getElementById('submitCreditCardOrder');
  var openModal = actions.openModal,
      processOrder = actions.processOrder,
      addProducts = actions.addProducts,
      setPaymentMethod = actions.setPaymentMethod,
      setSelectedUserPaymentId = actions.setSelectedUserPaymentId,
      setBraintreeValidity = actions.setBraintreeValidity,
      blurBraintreeField = actions.blurBraintreeField,
      setOrderFormMessage = actions.setOrderFormMessage;


  __WEBPACK_IMPORTED_MODULE_0_braintree_web_client___default.a.create({ authorization: "production_3b79p6mh_yk3rxhg7hf7f9d9v" }, function (err, clientInstance) {
    if (err) {
      setOrderFormMessage(999);
    }

    __WEBPACK_IMPORTED_MODULE_2_braintree_web_hosted_fields___default.a.create({
      client: clientInstance,
      styles: {
        input: {
          margin: '0 0 8px 0',
          'font-size': '1.2rem',
          'font-family': 'Proxima Nova, Helvetica, Arial',
          color: 'black'
        },
        '.placeholder': {
          color: 'lightgrey'
        },
        '.invalid': {
          color: 'red'
        }
      },
      fields: {
        number: {
          selector: '#card-number',
          placeholder: 'Card Number'
        },
        cvv: {
          selector: '#cvv',
          placeholder: 'CVV'
        },
        expirationDate: {
          selector: '#expiration-date',
          placeholder: 'Exp.'
        }
      }
    }, function (hostedFieldsErr, hostedFieldsInstance) {
      if (hostedFieldsErr) {
        setOrderFormMessage(999);
      }

      if (!hostedFieldsInstance) {
        setOrderFormMessage(999);
      }

      if (hostedFieldsInstance) {
        hostedFieldsInstance.on('focus', function () {
          setPaymentMethod('braintree');
          setSelectedUserPaymentId('0');
        });

        hostedFieldsInstance.on('validityChange', function (e) {
          var fields = e.fields,
              emittedBy = e.emittedBy;

          var field = emittedBy;
          var thisField = fields[emittedBy];
          var validity = thisField.isValid;
          setBraintreeValidity(field, validity);
        });

        hostedFieldsInstance.on('blur', function (e) {
          var emittedBy = e.emittedBy;

          blurBraintreeField(emittedBy);
        });

        button.addEventListener('click', function () {
          openModal('spinner');
          hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
            if (tokenizeErr) {
              setOrderFormMessage(600);
            } else {
              processOrder(payload.nonce).then(function (resp) {
                if (resp) addProducts(resp);
              }).catch(function () {
                setOrderFormMessage(600);
              });
            }
          });
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_1_braintree_web_paypal_checkout___default.a.create({ client: clientInstance }, function (paypalCheckoutErr, paypalCheckoutInstance) {
      if (paypalCheckoutErr) {
        console.log('ERROR! paypal');
        setOrderFormMessage(999);
      }

      __WEBPACK_IMPORTED_MODULE_3_paypal_checkout___default.a.Button.render({
        env: env,
        payment: function payment() {
          return paypalCheckoutInstance.createPayment({
            flow: 'vault'
          });
        },
        style: {
          size: 'responsive',
          color: 'blue',
          shape: 'pill',
          label: 'buynow'
        },

        onAuthorize: function onAuthorize(data) {
          return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
            processOrder(payload.nonce).then(function (resp) {
              if (resp) addProducts(resp);
            }).catch(function () {
              setOrderFormMessage(600);
            });
          });
        },

        onCancel: function onCancel() {
          setOrderFormMessage(700);
        },

        onError: function onError() {
          setOrderFormMessage(600);
        }
      }, '#paypal-button').then(function () {});
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(env, 'env', '/Users/markromero/Code/frn-platform-frontend/src/braintree/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/braintree/index.js');
}();

;

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);
var Client = __webpack_require__(1022);
var getConfiguration = __webpack_require__(1049).getConfiguration;
var VERSION = "3.30.0";
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);
var sharedErrors = __webpack_require__(990);

var cachedClients = {};

/** @module braintree-web/client */

/**
 * @function create
 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
 * @param {object} options Object containing all {@link Client} options:
 * @param {string} options.authorization A tokenizationKey or clientToken.
 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   // ...
 * });
 * @static
 */
function create(options) {
  if (!options.authorization) {
    return Promise.reject(new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: 'options.authorization is required when instantiating a client.'
    }));
  }

  if (cachedClients[options.authorization]) {
    return Promise.resolve(cachedClients[options.authorization]);
  }

  return getConfiguration(options).then(function (configuration) {
    var client;

    if (options.debug) {
      configuration.isDebug = true;
    }

    client = new Client(configuration);

    cachedClients[options.authorization] = client;

    return client;
  });
}

// Primarily used for testing the client create call
function clearCache() {
  cachedClients = {};
}

module.exports = {
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION,
  _clearCache: clearCache
};


/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GraphQL = __webpack_require__(1023);
var request = __webpack_require__(1005);
var isWhitelistedDomain = __webpack_require__(1007);
var BraintreeError = __webpack_require__(986);
var convertToBraintreeError = __webpack_require__(1008);
var addMetadata = __webpack_require__(1009);
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);
var once = __webpack_require__(997);
var deferred = __webpack_require__(1047);
var assign = __webpack_require__(991).assign;
var analytics = __webpack_require__(992);
var constants = __webpack_require__(1048);
var errors = __webpack_require__(1011);
var sharedErrors = __webpack_require__(990);
var VERSION = __webpack_require__(989).VERSION;
var methods = __webpack_require__(999);
var convertMethodsToError = __webpack_require__(1000);

/**
 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
 * @typedef {object} Client~configuration
 * @property {object} client The braintree-web/client parameters.
 * @property {string} client.authorization A tokenizationKey or clientToken.
 * @property {object} gatewayConfiguration Gateway-supplied configuration.
 * @property {object} analyticsMetadata Analytics-specific data.
 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
 */

/**
 * @class
 * @param {Client~configuration} configuration Options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
 */
function Client(configuration) {
  var configurationJSON, gatewayConfiguration, braintreeApiConfiguration;

  configuration = configuration || {};

  configurationJSON = JSON.stringify(configuration);
  gatewayConfiguration = configuration.gatewayConfiguration;

  if (!gatewayConfiguration) {
    throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
  }

  [
    'assetsUrl',
    'clientApiUrl',
    'configUrl'
  ].forEach(function (property) {
    if (property in gatewayConfiguration && !isWhitelistedDomain(gatewayConfiguration[property])) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: property + ' property is on an invalid domain.'
      });
    }
  });

  /**
   * Returns a copy of the configuration values.
   * @public
   * @returns {Client~configuration} configuration
   */
  this.getConfiguration = function () {
    return JSON.parse(configurationJSON);
  };

  this._request = request;
  this._configuration = this.getConfiguration();

  this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + '/v1/';

  braintreeApiConfiguration = gatewayConfiguration.braintreeApi;
  if (braintreeApiConfiguration) {
    this._braintreeApi = {
      baseUrl: braintreeApiConfiguration.url + '/',
      accessToken: braintreeApiConfiguration.accessToken
    };

    if (!isWhitelistedDomain(this._braintreeApi.baseUrl)) {
      throw new BraintreeError({
        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
        message: 'braintreeApi URL is on an invalid domain.'
      });
    }
  }

  if (gatewayConfiguration.graphQL) {
    this._graphQL = new GraphQL({
      graphQL: gatewayConfiguration.graphQL
    });
  }
}

/**
 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
 * @public
 * @param {object} options Request options:
 * @param {string} options.method HTTP method, e.g. "get" or "post".
 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
 * @param {object} options.data Data to send with the request.
 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
 * @example
 * <caption>Direct Credit Card Tokenization</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-expiration-date'].value,
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @example
 * <caption>Tokenizing Fields for AVS Checks</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-date'].value,
 *       // The billing address can be checked with AVS rules.
 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value,
 *         streetAddress: form['cc-street-address'].value,
 *         countryName: form['cc-country-name'].value,
 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
 *         countryCodeNumeric: form['cc-country-numeric'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
Client.prototype.request = function (options, callback) {
  var self = this; // eslint-disable-line no-invalid-this
  var requestPromise = new Promise(function (resolve, reject) {
    var optionName, api, baseUrl, requestOptions;

    if (!options.method) {
      optionName = 'options.method';
    } else if (!options.endpoint) {
      optionName = 'options.endpoint';
    }

    if (optionName) {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_REQUIRED.type,
        code: errors.CLIENT_OPTION_REQUIRED.code,
        message: optionName + ' is required when making a request.'
      });
    }

    if ('api' in options) {
      api = options.api;
    } else {
      api = 'clientApi';
    }

    requestOptions = {
      method: options.method,
      graphQL: self._graphQL,
      timeout: options.timeout
    };

    if (api === 'clientApi') {
      baseUrl = self._clientApiBaseUrl;

      requestOptions.data = addMetadata(self._configuration, options.data);
    } else if (api === 'braintreeApi') {
      if (!self._braintreeApi) {
        throw new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
      }

      baseUrl = self._braintreeApi.baseUrl;

      requestOptions.data = options.data;

      requestOptions.headers = {
        'Braintree-Version': constants.BRAINTREE_API_VERSION_HEADER,
        Authorization: 'Bearer ' + self._braintreeApi.accessToken
      };
    } else {
      throw new BraintreeError({
        type: errors.CLIENT_OPTION_INVALID.type,
        code: errors.CLIENT_OPTION_INVALID.code,
        message: 'options.api is invalid.'
      });
    }

    requestOptions.url = baseUrl + options.endpoint;
    requestOptions.sendAnalyticsEvent = function (kind) {
      analytics.sendEvent(self, kind);
    };

    self._request(requestOptions, function (err, data, status) {
      var resolvedData, requestError;

      requestError = formatRequestError(status, err);

      if (requestError) {
        reject(requestError);

        return;
      }

      resolvedData = assign({_httpStatus: status}, data);

      resolve(resolvedData);
    });
  });

  if (typeof callback === 'function') {
    callback = once(deferred(callback));

    requestPromise.then(function (response) {
      callback(null, response, response._httpStatus);
    }).catch(function (err) {
      var status = err && err.details && err.details.httpStatus;

      callback(err, null, status);
    });

    return;
  }

  return requestPromise; // eslint-disable-line consistent-return
};

function formatRequestError(status, err) { // eslint-disable-line consistent-return
  var requestError;

  if (status === -1) {
    requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
  } else if (status === 403) {
    requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
  } else if (status === 429) {
    requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
  } else if (status >= 500) {
    requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
  } else if (status < 200 || status >= 400) {
    requestError = convertToBraintreeError(err, {
      type: errors.CLIENT_REQUEST_ERROR.type,
      code: errors.CLIENT_REQUEST_ERROR.code,
      message: errors.CLIENT_REQUEST_ERROR.message
    });
  }

  if (requestError) {
    requestError.details = requestError.details || {};
    requestError.details.httpStatus = status;

    return requestError;
  }
}

Client.prototype.toJSON = function () {
  return this.getConfiguration();
};

/**
 * Returns the Client version.
 * @public
 * @returns {String} The created client's version.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
 * });
 * @returns {void}
 */
Client.prototype.getVersion = function () {
  return VERSION;
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * clientInstance.teardown();
 * @example <caption>With callback</caption>
 * clientInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
Client.prototype.teardown = wrapPromise(function () {
  var self = this; // eslint-disable-line no-invalid-this

  convertMethodsToError(self, methods(Client.prototype));

  return Promise.resolve();
});

module.exports = Client;


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var browserDetection = __webpack_require__(1004);

var features = {
  tokenize_credit_cards: 'payment_methods/credit_cards' // eslint-disable-line camelcase
};

var blacklistedInputPaths = [
  'creditCard.options.unionPayEnrollment'
];

function GraphQL(config) {
  this._config = config.graphQL;
}

GraphQL.prototype.getGraphQLEndpoint = function () {
  return this._config.url;
};

GraphQL.prototype.isGraphQLRequest = function (url, body) {
  var featureEnabled;
  var path = this.getClientApiPath(url);

  if (!this._isGraphQLEnabled() || !path || browserDetection.isIe9()) {
    return false;
  }

  featureEnabled = this._config.features.some(function (feature) {
    return features[feature] === path;
  });

  if (containsBlacklistedKeys(body)) {
    return false;
  }

  return featureEnabled;
};

GraphQL.prototype.getClientApiPath = function (url) {
  var path;
  var clientApiPrefix = '/client_api/v1/';
  var pathParts = url.split(clientApiPrefix);

  if (pathParts.length > 1) {
    path = pathParts[1].split('?')[0];
  }

  return path;
};

GraphQL.prototype._isGraphQLEnabled = function () {
  return Boolean(this._config);
};

function containsBlacklistedKeys(body) {
  return blacklistedInputPaths.some(function (keys) {
    var value = keys.split('.').reduce(function (accumulator, key) {
      return accumulator && accumulator[key];
    }, body);

    return value !== undefined; // eslint-disable-line no-undefined
  });
}

module.exports = GraphQL;


/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var isIE11 = __webpack_require__(1025);

module.exports = function isIE(ua) {
  ua = ua || global.navigator.userAgent;
  return ua.indexOf('MSIE') !== -1 || isIE11(ua);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isIe11(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Trident/7') !== -1;
};


/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var head;
var uuid = __webpack_require__(998);
var querystring = __webpack_require__(1006);
var timeouts = {};

function _removeScript(script) {
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
}

function _createScriptTag(url, callbackName) {
  var script = document.createElement('script');
  var done = false;

  script.src = url;
  script.async = true;
  script.onerror = function () {
    global[callbackName]({message: 'error', status: 500});
  };

  script.onload = script.onreadystatechange = function () {
    if (done) { return; }

    if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
      done = true;
      script.onload = script.onreadystatechange = null;
    }
  };

  return script;
}

function _cleanupGlobal(callbackName) {
  try {
    delete global[callbackName];
  } catch (_) {
    global[callbackName] = null;
  }
}

function _setupTimeout(timeout, callbackName) {
  timeouts[callbackName] = setTimeout(function () {
    timeouts[callbackName] = null;

    global[callbackName]({
      error: 'timeout',
      status: -1
    });

    global[callbackName] = function () {
      _cleanupGlobal(callbackName);
    };
  }, timeout);
}

function _setupGlobalCallback(script, callback, callbackName) {
  global[callbackName] = function (response) {
    var status = response.status || 500;
    var err = null;
    var data = null;

    delete response.status;

    if (status >= 400 || status < 200) {
      err = response;
    } else {
      data = response;
    }

    _cleanupGlobal(callbackName);
    _removeScript(script);

    clearTimeout(timeouts[callbackName]);
    callback(err, data, status);
  };
}

function request(options, callback) {
  var script;
  var callbackName = 'callback_json_' + uuid().replace(/-/g, '');
  var url = options.url;
  var attrs = options.data;
  var method = options.method;
  var timeout = options.timeout;

  url = querystring.queryify(url, attrs);
  url = querystring.queryify(url, {
    _method: method,
    callback: callbackName
  });

  script = _createScriptTag(url, callbackName);
  _setupGlobalCallback(script, callback, callbackName);
  _setupTimeout(timeout, callbackName);

  if (!head) {
    head = document.getElementsByTagName('head')[0];
  }

  head.appendChild(script);
}

module.exports = {
  request: request
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var querystring = __webpack_require__(1006);
var browserDetection = __webpack_require__(1004);
var assign = __webpack_require__(991).assign;
var prepBody = __webpack_require__(1028);
var parseBody = __webpack_require__(1029);
var xhr = __webpack_require__(1030);
var isXHRAvailable = xhr.isAvailable;
var GraphQLRequest = __webpack_require__(1031);
var DefaultRequest = __webpack_require__(1035);

var MAX_TCP_RETRYCOUNT = 1;
var TCP_PRECONNECT_BUG_STATUS_CODE = 408;

function requestShouldRetry(status) {
  return (!status || status === TCP_PRECONNECT_BUG_STATUS_CODE) && browserDetection.isIe();
}

function graphQLRequestShouldRetryWithClientApi(body) {
  var errorType = !body.data && body.errors &&
      body.errors[0] &&
      body.errors[0].extensions &&
      body.errors[0].extensions.errorType;

  return errorType === 'unknown_error';
}

function _requestWithRetry(options, tcpRetryCount, cb) {
  var status, resBody, ajaxRequest, body, method, headers, parsedBody;
  var url = options.url;
  var graphQL = options.graphQL;
  var timeout = options.timeout;
  var req = xhr.getRequestObject();
  var callback = cb;
  var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));

  options.headers = assign({'Content-Type': 'application/json'}, options.headers);

  if (isGraphQLRequest) {
    ajaxRequest = new GraphQLRequest(options);
  } else {
    ajaxRequest = new DefaultRequest(options);
  }

  url = ajaxRequest.getUrl();
  body = ajaxRequest.getBody();
  method = ajaxRequest.getMethod();
  headers = ajaxRequest.getHeaders();

  if (method === 'GET') {
    url = querystring.queryify(url, body);
    body = null;
  }

  if (isXHRAvailable) {
    req.onreadystatechange = function () {
      if (req.readyState !== 4) { return; }

      if (req.status === 0 && isGraphQLRequest) {
        // If a merchant experiences a connection
        // issue to the GraphQL endpoint (possibly
        // due to a Content Security Policy), retry
        // the request against the old client API.
        delete options.graphQL;
        _requestWithRetry(options, tcpRetryCount, cb);

        return;
      }

      parsedBody = parseBody(req.responseText);
      resBody = ajaxRequest.adaptResponseBody(parsedBody);
      status = ajaxRequest.determineStatus(req.status, parsedBody);

      if (status >= 400 || status < 200) {
        if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
          delete options.graphQL;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }

        if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
          tcpRetryCount++;
          _requestWithRetry(options, tcpRetryCount, cb);

          return;
        }
        callback(resBody || 'error', null, status || 500);
      } else {
        callback(null, resBody, status);
      }
    };
  } else {
    if (options.headers) {
      url = querystring.queryify(url, headers);
    }

    req.onload = function () {
      callback(null, parseBody(req.responseText), req.status);
    };

    req.onerror = function () {
      // XDomainRequest does not report a body or status for errors, so
      // hardcode to 'error' and 500, respectively
      callback('error', null, 500);
    };

    // This must remain for IE9 to work
    req.onprogress = function () {};

    req.ontimeout = function () {
      callback('timeout', null, -1);
    };
  }

  try {
    req.open(method, url, true);
  } catch (requestOpenError) {
    // If a merchant has a Content Security Policy and they have
    // not whitelisted our endpoints, some browsers may
    // synchronously throw an error. If it is not a GraphQL
    // request, we throw the error. If it is a GraphQL request
    // we remove the GraphQL option and try the request against
    // the old client API.
    if (!isGraphQLRequest) {
      throw requestOpenError;
    }

    delete options.graphQL;

    _requestWithRetry(options, tcpRetryCount, cb);

    return;
  }

  req.timeout = timeout;

  if (isXHRAvailable) {
    Object.keys(headers).forEach(function (headerKey) {
      req.setRequestHeader(headerKey, headers[headerKey]);
    });
  }

  try {
    req.send(prepBody(method, body));
  } catch (e) { /* ignored */ }
}

function request(options, cb) {
  _requestWithRetry(options, 0, cb);
}

module.exports = {
  request: request
};


/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (method, body) {
  if (typeof method !== 'string') {
    throw new Error('Method must be a string');
  }

  if (method.toLowerCase() !== 'get' && body != null) {
    body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  return body;
};


/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (body) {
  try {
    body = JSON.parse(body);
  } catch (e) { /* ignored */ }

  return body;
};


/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var isXHRAvailable = global.XMLHttpRequest && 'withCredentials' in new global.XMLHttpRequest();

function getRequestObject() {
  return isXHRAvailable ? new XMLHttpRequest() : new XDomainRequest();
}

module.exports = {
  isAvailable: isXHRAvailable,
  getRequestObject: getRequestObject
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BRAINTREE_VERSION = '2017-12-15';

var assign = __webpack_require__(991).assign;

var creditCardTokenizationBodyGenerator = __webpack_require__(1032);
var creditCardTokenizationResponseAdapter = __webpack_require__(1033);

var generators = {
  'payment_methods/credit_cards': creditCardTokenizationBodyGenerator
};
var adapters = {
  'payment_methods/credit_cards': creditCardTokenizationResponseAdapter
};

function GraphQLRequest(options) {
  var clientApiPath = options.graphQL.getClientApiPath(options.url);

  this._graphQL = options.graphQL;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
  this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;

  this._generator = generators[clientApiPath];
  this._adapter = adapters[clientApiPath];

  this._sendAnalyticsEvent('graphql.init');
}

GraphQLRequest.prototype.getUrl = function () {
  return this._graphQL.getGraphQLEndpoint();
};

GraphQLRequest.prototype.getBody = function () {
  var formattedBody = formatBodyKeys(this._data);

  return this._generator(formattedBody);
};

GraphQLRequest.prototype.getMethod = function () {
  return 'POST';
};

GraphQLRequest.prototype.getHeaders = function () {
  var authorization, headers;

  if (this._data.authorizationFingerprint) {
    this._sendAnalyticsEvent('graphql.authorization-fingerprint');
    authorization = this._data.authorizationFingerprint;
  } else {
    this._sendAnalyticsEvent('graphql.tokenization-key');
    authorization = this._data.tokenizationKey;
  }

  headers = {
    Authorization: 'Bearer ' + authorization,
    'Braintree-Version': BRAINTREE_VERSION
  };

  return assign({}, this._headers, headers);
};

GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
  return this._adapter(parsedBody);
};

GraphQLRequest.prototype.determineStatus = function (httpStatus, parsedResponse) {
  var status, errorType;

  if (httpStatus === 200) {
    errorType = parsedResponse.errors &&
      parsedResponse.errors[0] &&
      parsedResponse.errors[0].extensions &&
      parsedResponse.errors[0].extensions.errorType;

    if (parsedResponse.data && !parsedResponse.errors) {
      status = 200;
    } else if (errorType === 'user_error') {
      status = 422;
    } else if (errorType === 'developer_error') {
      status = 403;
    } else if (errorType === 'unknown_error') {
      status = 500;
    } else if (isCoercionOrValidationError(errorType, parsedResponse)) {
      status = 403;
    } else {
      status = 500;
    }
  } else if (!httpStatus) {
    status = 500;
  } else {
    status = httpStatus;
  }

  this._sendAnalyticsEvent('graphql.status.' + httpStatus);
  this._sendAnalyticsEvent('graphql.determinedStatus.' + status);

  return status;
};

function isCoercionOrValidationError(errorType, parsedResponse) {
  return !errorType && parsedResponse.errors[0].message;
}

function snakeCaseToCamelCase(snakeString) {
  if (snakeString.indexOf('_') === -1) {
    return snakeString;
  }

  return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
    return match[1].toUpperCase();
  });
}

function formatBodyKeys(originalBody) {
  var body = {};

  Object.keys(originalBody).forEach(function (key) {
    var camelCaseKey = snakeCaseToCamelCase(key);

    if (typeof originalBody[key] === 'object') {
      body[camelCaseKey] = formatBodyKeys(originalBody[key]);
    } else if (typeof originalBody[key] === 'number') {
      body[camelCaseKey] = String(originalBody[key]);
    } else {
      body[camelCaseKey] = originalBody[key];
    }
  });

  return body;
}

module.exports = GraphQLRequest;


/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(991).assign;

var CREDIT_CARD_TOKENIZATION_MUTATION = 'mutation TokenizeCreditCard($input: TokenizeCreditCardInput!) { ' +
'  tokenizeCreditCard(input: $input) { ' +
'    token ' +
'    creditCard { ' +
'      brand ' +
'      last4 ' +
'      binData { ' +
'        prepaid ' +
'        healthcare ' +
'        debit ' +
'        durbinRegulated ' +
'        commercial ' +
'        payroll ' +
'        issuingBank ' +
'        countryOfIssuance ' +
'        productId ' +
'      } ' +
'    } ' +
'  } ' +
'}';

function createCreditCardTokenizationBody(body) {
  var cc = body.creditCard;
  var billingAddress = cc && cc.billingAddress;
  var expDate = cc && cc.expirationDate;
  var expirationMonth = cc && (cc.expirationMonth || (expDate && expDate.split('/')[0].trim()));
  var expirationYear = cc && (cc.expirationYear || (expDate && expDate.split('/')[1].trim()));
  var variables = {
    input: {
      creditCard: {
        number: cc && cc.number,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cc && cc.cvv,
        cardholderName: cc && cc.cardholderName
      },
      options: {}
    }
  };

  if (billingAddress) {
    variables.input.creditCard.billingAddress = billingAddress;
  }

  variables.input = addValidationRule(body, variables.input);

  return variables;
}

function addValidationRule(body, input) {
  var validate;

  if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === 'boolean') {
    validate = body.creditCard.options.validate;
  } else if ((body.authorizationFingerprint && body.tokenizationKey) || body.authorizationFingerprint) {
    validate = true;
  } else if (body.tokenizationKey) {
    validate = false;
  }

  if (typeof validate === 'boolean') {
    input.options = assign({
      validate: validate
    }, input.options);
  }

  return input;
}

function creditCardTokenization(body) {
  return JSON.stringify({
    query: CREDIT_CARD_TOKENIZATION_MUTATION,
    variables: createCreditCardTokenizationBody(body),
    operationName: 'TokenizeCreditCard'
  });
}

module.exports = creditCardTokenization;


/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errorResponseAdapter = __webpack_require__(1034);

function creditCardTokenizationResponseAdapter(responseBody) {
  var adaptedResponse;

  if (responseBody.data && !responseBody.errors) {
    adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
  } else {
    adaptedResponse = errorResponseAdapter(responseBody);
  }

  return adaptedResponse;
}

function adaptTokenizeCreditCardResponseBody(body) {
  var data = body.data.tokenizeCreditCard;
  var creditCard = data.creditCard;
  var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : '';
  var binData = creditCard.binData;
  var response;

  if (binData) {
    ['issuingBank', 'countryOfIssuance', 'productId'].forEach(function (key) {
      if (binData[key] === null) { binData[key] = 'Unknown'; }
    });
  }

  response = {
    creditCards: [
      {
        binData: binData,
        consumed: false,
        description: lastTwo ? 'ending in ' + lastTwo : '',
        nonce: data.token,
        details: {
          cardType: creditCard.brand || 'Unknown',
          lastFour: creditCard.last4 || '',
          lastTwo: lastTwo
        },
        type: 'CreditCard',
        threeDSecureInfo: null
      }
    ]
  };

  return response;
}

module.exports = creditCardTokenizationResponseAdapter;


/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function errorResponseAdapter(responseBody) {
  var response;
  var errorType = responseBody.errors &&
    responseBody.errors[0] &&
    responseBody.errors[0].extensions &&
    responseBody.errors[0].extensions.errorType;

  if (errorType === 'user_error') {
    response = userErrorResponseAdapter(responseBody);
  } else if (errorType) {
    response = errorWithTypeResponseAdapter(responseBody);
  } else {
    response = {error: {message: 'There was a problem serving your request'}, fieldErrors: []};
  }

  return response;
}

function errorWithTypeResponseAdapter(responseBody) {
  return {error: {message: responseBody.errors[0].message}, fieldErrors: []};
}

function userErrorResponseAdapter(responseBody) {
  var error = responseBody.errors[0];
  var message = error.extensions.legacyMessage;
  var errorDetails = error.extensions.errorDetails;
  var fieldErrors = buildFieldErrors(errorDetails);

  return {error: {message: message}, fieldErrors: fieldErrors};
}

function buildFieldErrors(errorDetails) {
  var fieldErrors = [];

  errorDetails.forEach(function (detail) {
    addFieldError(detail.inputPath.slice(1), detail, fieldErrors);
  });

  return fieldErrors;
}

function addFieldError(inputPath, errorDetail, fieldErrors) {
  var fieldError;
  var legacyCode = errorDetail.legacyCode;
  var inputField = inputPath[0];

  if (inputPath.length === 1) {
    fieldErrors.push({
      code: legacyCode,
      field: inputField,
      message: errorDetail.message
    });

    return;
  }

  fieldErrors.forEach(function (candidate) {
    if (candidate.field === inputField) {
      fieldError = candidate;
    }
  });

  if (!fieldError) {
    fieldError = {field: inputField, fieldErrors: []};
    fieldErrors.push(fieldError);
  }

  addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
}

module.exports = errorResponseAdapter;


/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function DefaultRequest(options) {
  this._url = options.url;
  this._data = options.data;
  this._method = options.method;
  this._headers = options.headers;
}

DefaultRequest.prototype.getUrl = function () {
  return this._url;
};

DefaultRequest.prototype.getBody = function () {
  return this._data;
};

DefaultRequest.prototype.getMethod = function () {
  return this._method;
};

DefaultRequest.prototype.getHeaders = function () {
  return this._headers;
};

DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
  return parsedBody;
};

DefaultRequest.prototype.determineStatus = function (status) {
  return status;
};

module.exports = DefaultRequest;


/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = function getUserAgent() {
  return global.navigator.userAgent;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = function () {
  return global.location.protocol === 'http:';
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var atobNormalized = typeof global.atob === 'function' ? global.atob : atob;

function atob(base64String) {
  var a, b, c, b1, b2, b3, b4, i;
  var base64Matcher = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$');
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var result = '';

  if (!base64Matcher.test(base64String)) {
    throw new Error('Non base64 encoded input passed to window.atob polyfill');
  }

  i = 0;
  do {
    b1 = characters.indexOf(base64String.charAt(i++));
    b2 = characters.indexOf(base64String.charAt(i++));
    b3 = characters.indexOf(base64String.charAt(i++));
    b4 = characters.indexOf(base64String.charAt(i++));

    a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
    b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
    c = (b3 & 0x3) << 6 | b4 & 0x3F;

    result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
  } while (i < base64String.length);

  return result;
}

module.exports = {
  atob: function (base64String) {
    return atobNormalized.call(global, base64String);
  },
  _atob: atob
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};


/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1041).setImmediate))

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1042);
var global = __webpack_require__(1043);
exports.setImmediate = global.setImmediate;
exports.clearImmediate = global.clearImmediate;


/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44), __webpack_require__(167)))

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1044:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function deferred(fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
}

module.exports = deferred;


/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;


/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function promiseOrCallback(promise, callback) { // eslint-disable-line consistent-return
  if (callback) {
    promise
      .then(function (data) {
        callback(null, data);
      })
      .catch(function (err) {
        callback(err);
      });
  } else {
    return promise;
  }
}

module.exports = promiseOrCallback;


/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fn) {
  return function () {
    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
    var args = arguments;

    setTimeout(function () {
      fn.apply(null, args);
    }, 1);
  };
};


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  BRAINTREE_API_VERSION_HEADER: '2017-04-03'
};


/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var BraintreeError = __webpack_require__(986);
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);
var request = __webpack_require__(1005);
var uuid = __webpack_require__(998);
var constants = __webpack_require__(989);
var createAuthorizationData = __webpack_require__(1010);
var errors = __webpack_require__(1011);

function getConfiguration(options) {
  return new Promise(function (resolve, reject) {
    var configuration, authData, attrs, configUrl;
    var sessionId = uuid();
    var analyticsMetadata = {
      merchantAppId: global.location.host,
      platform: constants.PLATFORM,
      sdkVersion: constants.VERSION,
      source: constants.SOURCE,
      integration: constants.INTEGRATION,
      integrationType: constants.INTEGRATION,
      sessionId: sessionId
    };

    try {
      authData = createAuthorizationData(options.authorization);
    } catch (err) {
      reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));

      return;
    }
    attrs = authData.attrs;
    configUrl = authData.configUrl;

    attrs._meta = analyticsMetadata;
    attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
    attrs.configVersion = '3';

    request({
      url: configUrl,
      method: 'GET',
      data: attrs
    }, function (err, response, status) {
      var errorTemplate;

      if (err) {
        if (status === 403) {
          errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
        } else {
          errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
        }

        reject(new BraintreeError({
          type: errorTemplate.type,
          code: errorTemplate.code,
          message: errorTemplate.message,
          details: {
            originalError: err
          }
        }));

        return;
      }

      configuration = {
        authorization: options.authorization,
        authorizationType: attrs.tokenizationKey ? 'TOKENIZATION_KEY' : 'CLIENT_TOKEN',
        analyticsMetadata: analyticsMetadata,
        gatewayConfiguration: response
      };

      resolve(configuration);
    });
  });
}

module.exports = {
  getConfiguration: wrapPromise(getConfiguration)
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module braintree-web/paypal-checkout
 * @description A component to integrate with the [PayPal Checkout.js library](https://github.com/paypal/paypal-checkout).
 */

var BraintreeError = __webpack_require__(986);
var analytics = __webpack_require__(992);
var basicComponentVerification = __webpack_require__(1012);
var errors = __webpack_require__(1013);
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);
var PayPalCheckout = __webpack_require__(1051);
var VERSION = "3.30.0";

/**
 * @static
 * @function create
 * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
 *
 * @param {object} options Creation options:
 * @param {Client} options.client A {@link Client} instance.
 * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
 * @example
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   // set up checkout.js
 * }).catch(function (err) {
 *   console.error('Error!', err);
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
function create(options) {
  return basicComponentVerification.verify({
    name: 'PayPal Checkout',
    client: options.client
  }).then(function () {
    var config = options.client.getConfiguration();

    if (!config.gatewayConfiguration.paypalEnabled) {
      return Promise.reject(new BraintreeError(errors.PAYPAL_NOT_ENABLED));
    }

    if (!config.gatewayConfiguration.paypal.clientId) {
      return Promise.reject(new BraintreeError(errors.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED));
    }

    analytics.sendEvent(options.client, 'paypal-checkout.initialized');

    return new PayPalCheckout(options);
  });
}

/**
 * @static
 * @function isSupported
 * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
 * @deprecated Previously, this method checked for Popup support in the browser. Checkout.js now falls back to a modal if popups are not supported.
 * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
 */
function isSupported() {
  return true;
}

module.exports = {
  create: wrapPromise(create),
  isSupported: isSupported,
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION
};


/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var analytics = __webpack_require__(992);
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);
var BraintreeError = __webpack_require__(986);
var convertToBraintreeError = __webpack_require__(1008);
var errors = __webpack_require__(1013);
var constants = __webpack_require__(1052);
var methods = __webpack_require__(999);
var convertMethodsToError = __webpack_require__(1000);

/**
 * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
 * @typedef {object} PayPalCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact PayPal](https://developers.braintreepayments.com/support/guides/paypal/setup-guide#contacting-paypal-support) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 */

/**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
 * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4|PayPal checkout.js} library. Instances of this class can generate payment data and tokenize authorized payments.
 *
 * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by {@link https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4|checkout.js}.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
 *
 * You must have PayPal's checkout.js script loaded on your page to use PayPal Checkout. You can either use the [paypal-checkout package on npm](https://www.npmjs.com/package/paypal-checkout) with a build tool or use a script hosted by PayPal:
 *
 * ```html
 * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
 * ```
 *
 * Once you have the script loaded, there are two ways to integrate with the checkout.js library.
 *
 * #### Pass a Braintree object into checkout.js
 *
 * You can pass a `braintree` object into PayPal's checkout.js library. This will create the necessary Braintree {@link moudle:braintree-web/client.create|client} and {@link moudle:braintree-web/paypal-checkout.create|PayPal Checkout} components and automatically tokenize the authorized PayPal account. Use this integration option if you are not integrating with any other Braintree components.
 *
 * ```javascript
 * paypal.Button.render({
 *   braintree: braintree, // this object is available on the window by including the client and paypal-checkout component scripts on the page
 *   client: {
 *     production: 'production_authorization',
 *     sandbox: 'sandbox_authorization'
 *   },
 *
 *   env: 'production', // or 'sandbox'
 *
 *   payment: function (data, actions) {
 *     return actions.braintree.create({
 *       // your createPayment options here
 *     });
 *   },
 *
 *   onAuthorize: function (payload, actions) {
 *     // send payload.nonce to your server
 *
 *     // for more data about the user's PayPal account:
 *     // return actions.payment.get().then(function(data) { console.log(data); });
 *   }
 * }, '#paypal-button'); // the PayPal button will be rendered in an html element with the id `paypal-button`
 * ```
 *
 * If you are using `npm` to load braintree, simply pass in the invidual components:
 *
 * ```javascript
 * var btClient = require('braintree-web/client');
 * var btPayPal = require('braintree-web/paypal-checkout');
 *
 * paypal.Button.render({
 *   braintree: {
 *     client: btClient,
 *     paypalCheckout: btPayPal
 *   },
 *   client: {
 *     production: 'production_authorization',
 *     sandbox: 'sandbox_authorization'
 *   },
 *   // rest of checkout.js config
 * ```
 *
 * #### Create the Braintree components manually
 *
 * Alternatively, you can create the Braintree {@link moudle:braintree-web/client.create|client} and {@link moudle:braintree-web/paypal-checkout.create|PayPal Checkout} components manually. Use this integration style if you prefer to have some logic between receiving the authorized PayPal account and tokenizing it.
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production', // or 'sandbox'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         // your createPayment options here
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 */
function PayPalCheckout(options) {
  this._client = options.client;
}

/**
 * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to PayPal's checkout.js library.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the checkout.js library. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `sale` - Payment will be immediately submitted for settlement upon creating a transaction.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {string|number} [options.amount] The amount of the transaction. Required when using the Checkout flow.
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by checkout.js
 * // see https://github.com/paypal/paypal-checkout
 * paypal.Button.render({
 *   // when createPayment resolves, it is automatically passed to checkout.js
 *   payment: function () {
 *    return paypalCheckoutInstance.createPayment({
 *       flow: 'checkout',
 *       amount: '10.00',
 *       currency: 'USD',
 *       intent: 'sale'
 *     });
 *   },
 *   // Add other options, e.g. onAuthorize, env, locale
 * }, '#paypal-button');
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.createPayment = function (options) {
  var endpoint;

  if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
    return Promise.reject(new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED));
  }

  endpoint = 'paypal_hermes/' + constants.FLOW_ENDPOINTS[options.flow];

  analytics.sendEvent(this._client, 'paypal-checkout.createPayment');
  if (options.offerCredit === true) {
    analytics.sendEvent(this._client, 'paypal-checkout.credit.offered');
  }

  return this._client.request({
    endpoint: endpoint,
    method: 'post',
    data: this._formatPaymentResourceData(options)
  }).then(function (response) {
    var flowToken;

    if (options.flow === 'checkout') {
      flowToken = response.paymentResource.paymentToken;
    } else {
      flowToken = response.agreementSetup.tokenId;
    }

    return flowToken;
  }).catch(function (err) {
    var status = err.details && err.details.httpStatus;

    if (status === 422) {
      return Promise.reject(new BraintreeError({
        type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
        code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
        message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
        details: {
          originalError: err
        }
      }));
    }

    return Promise.reject(convertToBraintreeError(err, {
      type: errors.PAYPAL_FLOW_FAILED.type,
      code: errors.PAYPAL_FLOW_FAILED.code,
      message: errors.PAYPAL_FLOW_FAILED.message
    }));
  });
};

/**
 * Tokenizes the authorize data from PayPal's checkout.js library when completing a buyer approval flow.
 * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @public
 * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
 * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onAuthorize` callback.
 * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onAuthorize` callback.
 * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onAuthorize` callback.
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.tokenizePayment = function (tokenizeOptions) {
  var self = this;
  var payload;
  var client = this._client;
  var options = {
    flow: tokenizeOptions.billingToken ? 'vault' : 'checkout',
    intent: tokenizeOptions.intent
  };
  var params = {
    // The paymentToken provided by Checkout.js v4 is the ECToken
    ecToken: tokenizeOptions.paymentToken,
    billingToken: tokenizeOptions.billingToken,
    payerId: tokenizeOptions.payerID,
    paymentId: tokenizeOptions.paymentID
  };

  analytics.sendEvent(client, 'paypal-checkout.tokenization.started');

  return client.request({
    endpoint: 'payment_methods/paypal_accounts',
    method: 'post',
    data: self._formatTokenizeData(options, params)
  }).then(function (response) {
    payload = self._formatTokenizePayload(response);

    analytics.sendEvent(client, 'paypal-checkout.tokenization.success');
    if (payload.creditFinancingOffered) {
      analytics.sendEvent(client, 'paypal-checkout.credit.accepted');
    }

    return payload;
  }).catch(function (err) {
    analytics.sendEvent(client, 'paypal-checkout.tokenization.failed');

    return Promise.reject(convertToBraintreeError(err, {
      type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
      code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
      message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
    }));
  });
};

PayPalCheckout.prototype._formatPaymentResourceData = function (options) {
  var key;
  var gatewayConfiguration = this._client.getConfiguration().gatewayConfiguration;
  var paymentResource = {
    // returnUrl and cancelUrl are required in hermes create_payment_resource route
    // but are not validated and are not actually used with checkout.js
    returnUrl: 'x',
    cancelUrl: 'x',
    offerPaypalCredit: options.offerCredit === true,
    experienceProfile: {
      brandName: options.displayName || gatewayConfiguration.paypal.displayName,
      localeCode: options.locale,
      noShipping: (!options.enableShippingAddress).toString(),
      addressOverride: options.shippingAddressEditable === false,
      landingPageType: options.landingPageType
    }
  };

  if (options.flow === 'checkout') {
    paymentResource.amount = options.amount;
    paymentResource.currencyIsoCode = options.currency;

    if (options.hasOwnProperty('intent')) {
      paymentResource.intent = options.intent;
    }

    for (key in options.shippingAddressOverride) {
      if (options.shippingAddressOverride.hasOwnProperty(key)) {
        paymentResource[key] = options.shippingAddressOverride[key];
      }
    }
  } else {
    paymentResource.shippingAddress = options.shippingAddressOverride;

    if (options.billingAgreementDescription) {
      paymentResource.description = options.billingAgreementDescription;
    }
  }

  return paymentResource;
};

PayPalCheckout.prototype._formatTokenizeData = function (options, params) {
  var clientConfiguration = this._client.getConfiguration();
  var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
  var isTokenizationKey = clientConfiguration.authorizationType === 'TOKENIZATION_KEY';
  var data = {
    paypalAccount: {
      correlationId: params.billingToken || params.ecToken,
      options: {
        validate: options.flow === 'vault' && !isTokenizationKey
      }
    }
  };

  if (params.billingToken) {
    data.paypalAccount.billingAgreementToken = params.billingToken;
  } else {
    data.paypalAccount.paymentToken = params.paymentId;
    data.paypalAccount.payerId = params.payerId;
    data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;

    if (options.intent) {
      data.paypalAccount.intent = options.intent;
    }
  }

  return data;
};

PayPalCheckout.prototype._formatTokenizePayload = function (response) {
  var payload;
  var account = {};

  if (response.paypalAccounts) {
    account = response.paypalAccounts[0];
  }

  payload = {
    nonce: account.nonce,
    details: {},
    type: account.type
  };

  if (account.details && account.details.payerInfo) {
    payload.details = account.details.payerInfo;
  }

  if (account.details && account.details.creditFinancingOffered) {
    payload.creditFinancingOffered = account.details.creditFinancingOffered;
  }

  return payload;
};

/**
 * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * paypalCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
PayPalCheckout.prototype.teardown = function () {
  convertMethodsToError(this, methods(PayPalCheckout.prototype));

  return Promise.resolve();
};

module.exports = wrapPromise.wrapPrototype(PayPalCheckout);


/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  LANDING_FRAME_NAME: 'braintreepaypallanding',
  FLOW_ENDPOINTS: {
    checkout: 'create_payment_resource',
    vault: 'setup_billing_agreement'
  }
};


/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module braintree-web/hosted-fields */

var HostedFields = __webpack_require__(1054);
var basicComponentVerification = __webpack_require__(1012);
var errors = __webpack_require__(993);
var supportsInputFormatting = __webpack_require__(1075);
var wrapPromise = __webpack_require__(988);
var BraintreeError = __webpack_require__(986);
var Promise = __webpack_require__(987);
var VERSION = "3.30.0";

/**
 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
 * @typedef {object} field
 * @property {string} selector A CSS selector to find the container where the hosted field will be inserted.
 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
 * @property {object|boolean} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
 * @property {object|boolean} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input if it is less than the default. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and limiting the length of the postal code input when cards are coming from a known region.
 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
 */

/**
 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
 * @typedef {object} fieldOptions
 * @property {field} [number] A field for card number.
 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
 * @property {field} [expirationYear] A field for expiration year in `YYYY` format. This should be used with the `expirationMonth` property.
 * @property {field} [cvv] A field for 3 or 4 digit CVV or CID.
 * @property {field} [postalCode] A field for postal or region code.
 */

/**
 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
 *
 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
 *
 * Supported CSS properties are:
 * `appearance`
 * `color`
 * `direction`
 * `font-family`
 * `font-size-adjust`
 * `font-size`
 * `font-stretch`
 * `font-style`
 * `font-variant-alternates`
 * `font-variant-caps`
 * `font-variant-east-asian`
 * `font-variant-ligatures`
 * `font-variant-numeric`
 * `font-variant`
 * `font-weight`
 * `font`
 * `letter-spacing`
 * `line-height`
 * `opacity`
 * `outline`
 * `padding`
 * `text-shadow`
 * `transition`
 * `-moz-appearance`
 * `-moz-osx-font-smoothing`
 * `-moz-tap-highlight-color`
 * `-moz-transition`
 * `-webkit-appearance`
 * `-webkit-font-smoothing`
 * `-webkit-tap-highlight-color`
 * `-webkit-transition`
 * @typedef {object} styleOptions
 */

/**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} options.client A {@link Client} instance.
 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
 * @param {styleOptions} options.styles {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
 * @returns {void}
 * @example
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       'font-size': '16pt',
 *       'color': '#3A3A3A'
 *     },
 *     '.number': {
 *       'font-family': 'monospace'
 *     },
 *     '.valid': {
 *       'color': 'green'
 *     }
 *   },
 *   fields: {
 *     number: {
 *       selector: '#card-number'
 *     },
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       selector: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Right to Left Language Support</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       // other styles
 *       direction: 'rtl'
 *     },
 *   },
 *   fields: {
 *     number: {
 *       selector: '#card-number',
 *       // Credit card formatting is not currently supported
 *       // with RTL languages, so we need to turn it off for the number input
 *       formatInput: false
 *     },
 *     cvv: {
 *       selector: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       selector: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Creating an expiration date update form with prefilled data</caption>
 * var storedCreditCardInformation = {
 *   // get this info from your server
 *   // with a payment method lookup
 *   month: '09',
 *   year: '2017'
 * };
 *
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     expirationMonth: {
 *       selector: '#expiration-month',
 *       prefill: storedCreditCardInformation.month
 *     },
 *     expirationMonth: {
 *       selector: '#expiration-year',
 *       prefill: storedCreditCardInformation.year
 *     }
 *   }
 * }, callback);
 */
function create(options) {
  return basicComponentVerification.verify({
    name: 'Hosted Fields',
    client: options.client
  }).then(function () {
    var integration = new HostedFields(options);

    return new Promise(function (resolve, reject) {
      integration.on('ready', function () {
        resolve(integration);
      });
      integration.on('timeout', function () {
        reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
      });
    });
  });
}

module.exports = {
  /**
   * @static
   * @function supportsInputFormatting
   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/master/README.md#browsers-where-formatting-is-turned-off-automatically).
   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
   * @example
   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
   * var canFormat = braintree.hostedFields.supportsInputFormatting();
   * var fields = {
   *   number: {
   *     selector: '#card-number'
   *   },
   *   cvv: {
   *     selector: '#cvv'
   *   }
   * };
   *
   * if (canFormat) {
   *   fields.expirationDate = {
   *     selection: '#expiration-date'
   *   };
   *   functionToCreateAndInsertExpirationDateDivToForm();
   * } else {
   *   fields.expirationMonth = {
   *     selection: '#expiration-month'
   *   };
   *   fields.expirationYear = {
   *     selection: '#expiration-year'
   *   };
   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
   * }
   *
   * braintree.hostedFields.create({
   *   client: clientInstance,
   *   styles: {
   *     // Styles
   *   },
   *   fields: fields
   * }, callback);
   */
  supportsInputFormatting: supportsInputFormatting,
  create: wrapPromise(create),
  /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */
  VERSION: VERSION
};


/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Destructor = __webpack_require__(1055);
var classlist = __webpack_require__(1057);
var iFramer = __webpack_require__(1058);
var Bus = __webpack_require__(1062);
var BraintreeError = __webpack_require__(986);
var composeUrl = __webpack_require__(1066);
var constants = __webpack_require__(1001);
var errors = __webpack_require__(993);
var INTEGRATION_TIMEOUT_MS = __webpack_require__(989).INTEGRATION_TIMEOUT_MS;
var uuid = __webpack_require__(998);
var findParentTags = __webpack_require__(1068);
var browserDetection = __webpack_require__(1069);
var events = constants.events;
var EventEmitter = __webpack_require__(1071);
var injectFrame = __webpack_require__(1072);
var analytics = __webpack_require__(992);
var whitelistedFields = constants.whitelistedFields;
var methods = __webpack_require__(999);
var convertMethodsToError = __webpack_require__(1000);
var sharedErrors = __webpack_require__(990);
var getCardTypes = __webpack_require__(1073);
var attributeValidationError = __webpack_require__(1074);
var Promise = __webpack_require__(987);
var wrapPromise = __webpack_require__(988);

/**
 * @typedef {object} HostedFields~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `CreditCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */

/**
 * @typedef {object} HostedFields~stateObject
 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
 * @property {HostedFields~hostedFieldsCard[]} cards
 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
 * an open-source card detection library.
 * @property {string} emittedBy
 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
 * - `"number"`
 * - `"cvv"`
 * - `"expirationDate"`
 * - `"expirationMonth"`
 * - `"expirationYear"`
 * - `"postalCode"`
 * @property {object} fields
 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsFieldData
 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
 * @property {boolean} isFocused Whether or not the input is currently focused.
 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
 * @property {boolean} isPotentiallyValid
 * A determination based on the future validity of the input value.
 * This is helpful when a user is entering a card number and types <code>"41"</code>.
 * While that value is not valid for submission, it is still possible for
 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
 * it is clear that the card number can never become valid and isPotentiallyValid will
 * return false.
 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
 */

/**
 * @typedef {object} HostedFields~hostedFieldsCard
 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
 * - `american-express`
 * - `diners-club`
 * - `discover`
 * - `jcb`
 * - `maestro`
 * - `master-card`
 * - `unionpay`
 * - `visa`
 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
 * - `American Express`
 * - `Diners Club`
 * - `Discover`
 * - `JCB`
 * - `Maestro`
 * - `MasterCard`
 * - `UnionPay`
 * - `Visa`
 * @property {object} code
 * This object contains data relevant to the security code requirements of the card brand.
 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
 * American Express card requires a 4-digit <code>CID</code>.
 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
 */

/**
 * @name HostedFields#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. `event` should be {@link HostedFields#event:blur|blur}, {@link HostedFields#event:focus|focus}, {@link HostedFields#event:empty|empty}, {@link HostedFields#event:notEmpty|notEmpty}, {@link HostedFields#event:cardTypeChange|cardTypeChange}, or {@link HostedFields#event:validityChange|validityChange}. Events will emit a {@link HostedFields~stateObject|stateObject}.
 * @example
 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   });
 * });
 * @returns {void}
 */

/**
 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
 * @event HostedFields#inputSubmitRequest
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
 * var hostedFields = require('braintree-web/hosted-fields');
 * var submitButton = document.querySelector('input[type="submit"]');
 *
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
 *     // User requested submission, e.g. by pressing Enter or equivalent
 *     submitButton.click();
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from having data to being empty.
 * @event HostedFields#empty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an empty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('empty', function (event) {
 *     console.log(event.emittedBy, 'is now empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field transitions from being empty to having data.
 * @event HostedFields#notEmpty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an notEmpty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('notEmpty', function (event) {
 *     console.log(event.emittedBy, 'is now not empty');
 *   });
 * });
 */

/**
 * This event is emitted when a field loses focus.
 * @event HostedFields#blur
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a blur event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('blur', function (event) {
 *     console.log(event.emittedBy, 'lost focus');
 *   });
 * });
 */

/**
 * This event is emitted when a field gains focus.
 * @event HostedFields#focus
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a focus event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'gained focus');
 *   });
 * });
 */

/**
 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
 * @event HostedFields#cardTypeChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a cardTypeChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
 *     if (event.cards.length === 1) {
 *       console.log(event.cards[0].type);
 *     } else {
 *       console.log('Type of card not yet known');
 *     }
 *   });
 * });
 */

/**
 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
 * @event HostedFields#validityChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a validityChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('validityChange', function (event) {
 *     var field = event.fields[event.emittedBy];
 *
 *     if (field.isValid) {
 *       console.log(event.emittedBy, 'is fully valid');
 *     } else if (field.isPotentiallyValid) {
 *       console.log(event.emittedBy, 'is potentially valid');
 *     } else {
 *       console.log(event.emittedBy, 'is not valid');
 *     }
 *   });
 * });
 */

function createInputEventHandler(fields) {
  return function (eventData) {
    var field;
    var merchantPayload = eventData.merchantPayload;
    var emittedBy = merchantPayload.emittedBy;
    var container = fields[emittedBy].containerElement;

    Object.keys(merchantPayload.fields).forEach(function (key) {
      merchantPayload.fields[key].container = fields[key].containerElement;
    });

    field = merchantPayload.fields[emittedBy];

    if (eventData.type === 'blur') {
      performBlurFixForIos(container);
    }

    classlist.toggle(container, constants.externalClasses.FOCUSED, field.isFocused);
    classlist.toggle(container, constants.externalClasses.VALID, field.isValid);
    classlist.toggle(container, constants.externalClasses.INVALID, !field.isPotentiallyValid);

    this._state = { // eslint-disable-line no-invalid-this
      cards: merchantPayload.cards,
      fields: merchantPayload.fields
    };

    this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
  };
}

// iOS Safari has a bug where inputs in iframes
// will not dismiss the keyboard when they lose
// focus. We create a hidden button input that we
// can focus on and blur to force the keyboard to
// dismiss. See #229
function performBlurFixForIos(container) {
  var hiddenInput;

  if (!browserDetection.isIos()) {
    return;
  }

  if (document.activeElement === document.body) {
    hiddenInput = container.querySelector('input');

    if (!hiddenInput) {
      hiddenInput = document.createElement('input');

      hiddenInput.type = 'button';
      hiddenInput.style.height = '0px';
      hiddenInput.style.width = '0px';
      hiddenInput.style.opacity = '0';
      hiddenInput.style.padding = '0';
      hiddenInput.style.position = 'absolute';
      hiddenInput.style.left = '-200%';
      hiddenInput.style.top = '0px';

      container.insertBefore(hiddenInput, container.firstChild);
    }

    hiddenInput.focus();
    hiddenInput.blur();
  }
}

/**
 * @class HostedFields
 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
 */
function HostedFields(options) {
  var failureTimeout, clientConfig;
  var self = this;
  var fields = {};
  var fieldCount = 0;
  var componentId = uuid();

  clientConfig = options.client.getConfiguration();

  if (!options.fields) {
    throw new BraintreeError({
      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
      message: 'options.fields is required when instantiating Hosted Fields.'
    });
  }

  EventEmitter.call(this);

  this._injectedNodes = [];
  this._destructor = new Destructor();
  this._fields = fields;
  this._state = {
    fields: {},
    cards: getCardTypes('')
  };

  this._bus = new Bus({
    channel: componentId,
    merchantUrl: location.href
  });

  this._destructor.registerFunctionForTeardown(function () {
    self._bus.teardown();
  });

  this._client = options.client;

  analytics.sendEvent(this._client, 'custom.hosted-fields.initialized');

  Object.keys(options.fields).forEach(function (key) {
    var field, container, frame;

    if (!constants.whitelistedFields.hasOwnProperty(key)) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
        code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
        message: '"' + key + '" is not a valid field.'
      });
    }

    field = options.fields[key];

    container = document.querySelector(field.selector);

    if (!container) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
        code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
        message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
        details: {
          fieldSelector: field.selector,
          fieldKey: key
        }
      });
    } else if (container.querySelector('iframe[name^="braintree-"]')) {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
        code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
        message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
        details: {
          fieldSelector: field.selector,
          fieldKey: key
        }
      });
    }

    if (field.maxlength && typeof field.maxlength !== 'number') {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: 'The value for maxlength must be a number.',
        details: {
          fieldKey: key
        }
      });
    }

    if (field.minlength && typeof field.minlength !== 'number') {
      throw new BraintreeError({
        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
        message: 'The value for minlength must be a number.',
        details: {
          fieldKey: key
        }
      });
    }

    frame = iFramer({
      type: key,
      name: 'braintree-hosted-field-' + key,
      style: constants.defaultIFrameStyle
    });

    this._injectedNodes = this._injectedNodes.concat(injectFrame(frame, container));
    this._setupLabelFocus(key, container);
    fields[key] = {
      frameElement: frame,
      containerElement: container
    };
    fieldCount++;

    this._state.fields[key] = {
      isEmpty: true,
      isValid: false,
      isPotentiallyValid: true,
      isFocused: false,
      container: container
    };

    setTimeout(function () {
      // Edge has an intermittent issue where
      // the iframes load, but the JavaScript
      // can't message out to the parent page.
      // We can fix this by setting the src
      // to about:blank first followed by
      // the actual source. Both instances
      // of setting the src need to be in a
      // setTimeout to work.
      // In Safari, including this behavior
      // results in a new history event for
      // each iframe. So we only do this
      // hack in browsers that are not
      // safari based.
      if (global.navigator && global.navigator.vendor && global.navigator.vendor.indexOf('Apple') === -1) { // TODO - move to browser detection module
        frame.src = 'about:blank';
      }
      setTimeout(function () {
        frame.src = composeUrl(clientConfig.gatewayConfiguration.assetsUrl, componentId, clientConfig.isDebug);
      }, 0);
    }, 0);
  }.bind(this));

  failureTimeout = setTimeout(function () {
    analytics.sendEvent(self._client, 'custom.hosted-fields.load.timed-out');
    self._emit('timeout');
  }, INTEGRATION_TIMEOUT_MS);

  this._bus.on(events.FRAME_READY, function (reply) {
    fieldCount--;
    if (fieldCount === 0) {
      clearTimeout(failureTimeout);
      reply(options);
      self._emit('ready');
    }
  });

  this._bus.on(
    events.INPUT_EVENT,
    createInputEventHandler(fields).bind(this)
  );

  this._destructor.registerFunctionForTeardown(function () {
    var j, node, parent;

    for (j = 0; j < self._injectedNodes.length; j++) {
      node = self._injectedNodes[j];
      parent = node.parentNode;

      parent.removeChild(node);

      classlist.remove(
        parent,
        constants.externalClasses.FOCUSED,
        constants.externalClasses.INVALID,
        constants.externalClasses.VALID
      );
    }
  });

  this._destructor.registerFunctionForTeardown(function () {
    var methodNames = methods(HostedFields.prototype).concat(methods(EventEmitter.prototype));

    convertMethodsToError(self, methodNames);
  });
}

HostedFields.prototype = Object.create(EventEmitter.prototype, {
  constructor: HostedFields
});

HostedFields.prototype._setupLabelFocus = function (type, container) {
  var labels, i;
  var shouldSkipLabelFocus = browserDetection.isIos();
  var bus = this._bus;

  if (shouldSkipLabelFocus) { return; }
  if (container.id == null) { return; }

  function triggerFocus() {
    bus.emit(events.TRIGGER_INPUT_FOCUS, type);
  }

  labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
  labels = labels.concat(findParentTags(container, 'label'));

  for (i = 0; i < labels.length; i++) {
    labels[i].addEventListener('click', triggerFocus, false);
  }

  this._destructor.registerFunctionForTeardown(function () {
    for (i = 0; i < labels.length; i++) {
      labels[i].removeEventListener('click', triggerFocus, false);
    }
  });
};

/**
 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
 * @example
 * hostedFieldsInstance.teardown(function (teardownErr) {
 *   if (teardownErr) {
 *     console.error('Could not tear down Hosted Fields!');
 *   } else {
 *     console.info('Hosted Fields has been torn down!');
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.teardown = function () {
  var self = this;

  return new Promise(function (resolve, reject) {
    self._destructor.teardown(function (err) {
      analytics.sendEvent(self._client, 'custom.hosted-fields.teardown-completed');

      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
};

/**
 * Tokenizes fields and returns a nonce payload.
 * @public
 * @param {object} [options] All tokenization options for the Hosted Fields component.
 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID.
 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
 *
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
 * @example <caption>Tokenize a card</caption>
 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     switch (tokenizeErr.code) {
 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
 *         // occurs when none of the fields are filled in
 *         console.error('All fields are empty! Please fill out the form.');
 *         break;
 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
 *         // occurs when certain fields do not pass client side validation
 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the fail on duplicate payment method
 *         //     option is set to true
 *         //   * the card being tokenized has previously been vaulted (with any customer)
 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
 *         console.error('This payment method already exists in your vault.');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the verify card option is set to true
 *         //     and you have credit card verification turned on in the Braintree
 *         //     control panel
 *         //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
 *         console.error('CVV did not pass verification');
 *         break;
 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
 *         // occurs for any other tokenization error on the server
 *         console.error('Tokenization failed server side. Is the card valid?');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
 *         // occurs when the Braintree gateway cannot be contacted
 *         console.error('Network error occurred when tokenizing.');
 *         break;
 *       default:
 *         console.error('Something bad happened!', tokenizeErr);
 *     }
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize and vault a card</caption>
 * hostedFieldsInstance.tokenize({
 *   vault: true
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with cardholder name</caption>
 * hostedFieldsInstance.tokenize({
 *   cardholderName: 'First Last'
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with the postal code option</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     postalCode: '11111'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with additional billing address options</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     firstName: 'First',
 *     lastName: 'Last',
 *     company: 'Company',
 *     streetAddress: '123 Street',
 *     extendedAddress: 'Unit 1',
 *     // passing just one of the country options is sufficient to
 *     // associate the card details with a particular country
 *     // valid country names and codes can be found here:
 *     // https://developers.braintreepayments.com/reference/general/countries/ruby#list-of-countries
 *     countryName: 'United States',
 *     countryCodeAlpha2: 'US',
 *     countryCodeAlpha3: 'USA',
 *     countryCodeNumeric: '840'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.tokenize = function (options) {
  var self = this;

  if (!options) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    self._bus.emit(events.TOKENIZATION_REQUEST, options, function (response) {
      var err = response[0];
      var payload = response[1];

      if (err) {
        reject(err);
      } else {
        resolve(payload);
      }
    });
  });
};

/**
 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be added.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *   }
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.addClass = function (field, classname) {
  var err;

  if (!whitelistedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.ADD_CLASS, field, classname);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be removed.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *     return;
 *   }
 *
 *   // some time later...
 *   hostedFieldsInstance.removeClass('number', 'custom-class');
 * });
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeClass = function (field, classname) {
  var err;

  if (!whitelistedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.REMOVE_CLASS, field, classname);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to add to the field.
 * @param {string} options.value The value for the attribute.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
 *
 * @example <caption>Set the placeholder attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'placeholder',
 *   value: '1111 1111 1111 1111'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @example <caption>Set the aria-required attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'aria-required',
 *   value: true
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setAttribute = function (options) {
  var attributeErr, err;

  if (!whitelistedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    attributeErr = attributeValidationError(options.attribute, options.value);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.SET_ATTRIBUTE, options.field, options.attribute, options.value);
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Sets a visually hidden message (for screenreaders) on a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
 * @param {string} options.message The message to set.
 *
 * @example <caption>Set an error message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: 'Invalid card number'
 * });
 *
 * @example <caption>Remove the message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: ''
 * });
 *
 * @returns {void}
 */
HostedFields.prototype.setMessage = function (options) {
  this._bus.emit(events.SET_MESSAGE, options.field, options.message);
};

/**
 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to remove.
 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
 *
 * @example <caption>Remove the placeholder attribute of a field</caption>
 * hostedFieldsInstance.removeAttribute({
 *   field: 'number',
 *   attribute: 'placeholder'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.removeAttribute = function (options) {
  var attributeErr, err;

  if (!whitelistedFields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
    });
  } else if (!this._fields.hasOwnProperty(options.field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    attributeErr = attributeValidationError(options.attribute);

    if (attributeErr) {
      err = attributeErr;
    } else {
      this._bus.emit(events.REMOVE_ATTRIBUTE, options.field, options.attribute);
    }
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
 *
 * @public
 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
 *
 * @returns {Promise|void} Returns a promise if no callback is provided.
 */
HostedFields.prototype.setPlaceholder = function (field, placeholder) {
  return this.setAttribute({
    field: field,
    attribute: 'placeholder',
    value: placeholder
  });
};

/**
 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * hostedFieldsInstance.clear('number', function (clearErr) {
 *   if (clearErr) {
 *     console.error(clearErr);
 *   }
 * });
 *
 * @example <caption>Clear several fields</caption>
 * hostedFieldsInstance.clear('number');
 * hostedFieldsInstance.clear('cvv');
 * hostedFieldsInstance.clear('expirationDate');
 */
HostedFields.prototype.clear = function (field) {
  var err;

  if (!whitelistedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.CLEAR_FIELD, field);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
 * @returns {void}
 * @example
 * hostedFieldsInstance.focus('number', function (focusErr) {
 *   if (focusErr) {
 *     console.error(focusErr);
 *   }
 * });
 * @example <caption>Using an event listener</caption>
 * myElement.addEventListener('click', function (e) {
 *   // Note: In Firefox, the focus method can be suppressed
 *   // if the element has a tabindex property or the element
 *   // is an anchor link with an href property.
 *   e.preventDefault();
 *   hostedFieldsInstance.focus('number');
 * });
 */
HostedFields.prototype.focus = function (field) {
  var err;

  if (!whitelistedFields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
      message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
    });
  } else if (!this._fields.hasOwnProperty(field)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
      message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
    });
  } else {
    this._bus.emit(events.TRIGGER_INPUT_FOCUS, field);
  }

  if (err) {
    return Promise.reject(err);
  }

  return Promise.resolve();
};

/**
 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
 * @public
 * @returns {object} {@link HostedFields~stateObject|stateObject}
 * @example <caption>Check if all fields are valid</caption>
 * var state = hostedFields.getState();
 *
 * var formValid = Object.keys(state.fields).every(function (key) {
 *   return state.fields[key].isValid;
 * });
 */
HostedFields.prototype.getState = function () {
  return this._state;
};

module.exports = wrapPromise.wrapPrototype(HostedFields);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var batchExecuteFunctions = __webpack_require__(1056);

function Destructor() {
  this._teardownRegistry = [];

  this._isTearingDown = false;
}

Destructor.prototype.registerFunctionForTeardown = function (fn) {
  if (typeof fn === 'function') {
    this._teardownRegistry.push(fn);
  }
};

Destructor.prototype.teardown = function (callback) {
  if (this._isTearingDown) {
    callback(new Error('Destructor is already tearing down'));

    return;
  }

  this._isTearingDown = true;

  batchExecuteFunctions(this._teardownRegistry, function (err) {
    this._teardownRegistry = [];
    this._isTearingDown = false;

    if (typeof callback === 'function') {
      callback(err);
    }
  }.bind(this));
};

module.exports = Destructor;


/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var once = __webpack_require__(997);

function call(fn, callback) {
  var isSync = fn.length === 0;

  if (isSync) {
    fn();
    callback(null);
  } else {
    fn(callback);
  }
}

module.exports = function (functions, cb) {
  var i;
  var length = functions.length;
  var remaining = length;
  var callback = once(cb);

  if (length === 0) {
    callback(null);

    return;
  }

  function finish(err) {
    if (err) {
      callback(err);

      return;
    }

    remaining -= 1;
    if (remaining === 0) {
      callback(null);
    }
  }

  for (i = 0; i < length; i++) {
    call(functions[i], finish);
  }
};


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classesOf(element) {
  return element.className.trim().split(/\s+/);
}

function add(element) {
  var toAdd = Array.prototype.slice.call(arguments, 1);
  var className = _classesOf(element).filter(function (classname) {
    return toAdd.indexOf(classname) === -1;
  }).concat(toAdd).join(' ');

  element.className = className;
}

function remove(element) {
  var toRemove = Array.prototype.slice.call(arguments, 1);
  var className = _classesOf(element).filter(function (classname) {
    return toRemove.indexOf(classname) === -1;
  }).join(' ');

  element.className = className;
}

function toggle(element, classname, adding) {
  if (adding) {
    add(element, classname);
  } else {
    remove(element, classname);
  }
}

module.exports = {
  add: add,
  remove: remove,
  toggle: toggle
};


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setAttributes = __webpack_require__(1059);
var defaultAttributes = __webpack_require__(1060);
var assign = __webpack_require__(1061);

module.exports = function createFrame(options) {
  var iframe = document.createElement('iframe');
  var config = assign({}, defaultAttributes, options);

  if (config.style && typeof config.style !== 'string') {
    assign(iframe.style, config.style);
    delete config.style;
  }

  setAttributes(iframe, config);

  if (!iframe.getAttribute('id')) {
    iframe.id = iframe.name;
  }

  return iframe;
};


/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function setAttributes(element, attributes) {
  var value;

  for (var key in attributes) {
    if (attributes.hasOwnProperty(key)) {
      value = attributes[key];

      if (value == null) {
        element.removeAttribute(key);
      } else {
        element.setAttribute(key, value);
      }
    }
  }
};


/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  src: 'about:blank',
  frameBorder: 0,
  allowtransparency: true,
  scrolling: 'no'
};


/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function assign(target) {
  var objs = Array.prototype.slice.call(arguments, 1);

  objs.forEach(function (obj) {
    if (typeof obj !== 'object') { return; }

    Object.keys(obj).forEach(function (key) {
      target[key] = obj[key];
    });
  });

  return target;
}


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bus = __webpack_require__(1063);
var events = __webpack_require__(1064);
var checkOrigin = __webpack_require__(1065).checkOrigin;
var BraintreeError = __webpack_require__(986);

function BraintreeBus(options) {
  options = options || {};

  this.channel = options.channel;
  if (!this.channel) {
    throw new BraintreeError({
      type: BraintreeError.types.INTERNAL,
      code: 'MISSING_CHANNEL_ID',
      message: 'Channel ID must be specified.'
    });
  }

  this.merchantUrl = options.merchantUrl;

  this._isDestroyed = false;
  this._isVerbose = false;

  this._listeners = [];

  this._log('new bus on channel ' + this.channel, [location.href]);
}

BraintreeBus.prototype.on = function (eventName, originalHandler) {
  var namespacedEvent, args;
  var handler = originalHandler;
  var self = this;

  if (this._isDestroyed) { return; }

  if (this.merchantUrl) {
    handler = function () {
      /* eslint-disable no-invalid-this */
      if (checkOrigin(this.origin, self.merchantUrl)) {
        originalHandler.apply(this, arguments);
      }
      /* eslint-enable no-invalid-this */
    };
  }

  namespacedEvent = this._namespaceEvent(eventName);
  args = Array.prototype.slice.call(arguments);
  args[0] = namespacedEvent;
  args[1] = handler;

  this._log('on', args);
  bus.on.apply(bus, args);

  this._listeners.push({
    eventName: eventName,
    handler: handler,
    originalHandler: originalHandler
  });
};

BraintreeBus.prototype.emit = function (eventName) {
  var args;

  if (this._isDestroyed) { return; }

  args = Array.prototype.slice.call(arguments);
  args[0] = this._namespaceEvent(eventName);

  this._log('emit', args);
  bus.emit.apply(bus, args);
};

BraintreeBus.prototype._offDirect = function (eventName) {
  var args = Array.prototype.slice.call(arguments);

  if (this._isDestroyed) { return; }

  args[0] = this._namespaceEvent(eventName);

  this._log('off', args);
  bus.off.apply(bus, args);
};

BraintreeBus.prototype.off = function (eventName, originalHandler) {
  var i, listener;
  var handler = originalHandler;

  if (this._isDestroyed) { return; }

  if (this.merchantUrl) {
    for (i = 0; i < this._listeners.length; i++) {
      listener = this._listeners[i];

      if (listener.originalHandler === originalHandler) {
        handler = listener.handler;
      }
    }
  }

  this._offDirect(eventName, handler);
};

BraintreeBus.prototype._namespaceEvent = function (eventName) {
  return ['braintree', this.channel, eventName].join(':');
};

BraintreeBus.prototype.teardown = function () {
  var listener, i;

  for (i = 0; i < this._listeners.length; i++) {
    listener = this._listeners[i];
    this._offDirect(listener.eventName, listener.handler);
  }

  this._listeners.length = 0;

  this._isDestroyed = true;
};

BraintreeBus.prototype._log = function (functionName, args) {
  if (this._isVerbose) {
    console.log(functionName, args); // eslint-disable-line no-console
  }
};

BraintreeBus.events = events;

module.exports = BraintreeBus;


/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
(function (root, factory) {
  if (true) {
    module.exports = factory(typeof global === 'undefined' ? root : global);
  } else if (typeof define === 'function' && define.amd) {
    define([], function () { return factory(root); });
  } else {
    root.framebus = factory(root);
  }
})(this, function (root) { // eslint-disable-line no-invalid-this
  var win, framebus;
  var popups = [];
  var subscribers = {};
  var prefix = '/*framebus*/';

  function include(popup) {
    if (popup == null) { return false; }
    if (popup.Window == null) { return false; }
    if (popup.constructor !== popup.Window) { return false; }

    popups.push(popup);
    return true;
  }

  function target(origin) {
    var key;
    var targetedFramebus = {};

    for (key in framebus) {
      if (!framebus.hasOwnProperty(key)) { continue; }

      targetedFramebus[key] = framebus[key];
    }

    targetedFramebus._origin = origin || '*';

    return targetedFramebus;
  }

  function publish(event) {
    var payload, args;
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_isntString(event)) { return false; }
    if (_isntString(origin)) { return false; }

    args = Array.prototype.slice.call(arguments, 1);

    payload = _packagePayload(event, args, origin);
    if (payload === false) { return false; }

    _broadcast(win.top || win.self, payload, origin);

    return true;
  }

  function subscribe(event, fn) {
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

    subscribers[origin] = subscribers[origin] || {};
    subscribers[origin][event] = subscribers[origin][event] || [];
    subscribers[origin][event].push(fn);

    return true;
  }

  function unsubscribe(event, fn) {
    var i, subscriberList;
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

    subscriberList = subscribers[origin] && subscribers[origin][event];
    if (!subscriberList) { return false; }

    for (i = 0; i < subscriberList.length; i++) {
      if (subscriberList[i] === fn) {
        subscriberList.splice(i, 1);
        return true;
      }
    }

    return false;
  }

  function _getOrigin(scope) {
    return scope && scope._origin || '*';
  }

  function _isntString(string) {
    return typeof string !== 'string';
  }

  function _packagePayload(event, args, origin) {
    var packaged = false;
    var payload = {
      event: event,
      origin: origin
    };
    var reply = args[args.length - 1];

    if (typeof reply === 'function') {
      payload.reply = _subscribeReplier(reply, origin);
      args = args.slice(0, -1);
    }

    payload.args = args;

    try {
      packaged = prefix + JSON.stringify(payload);
    } catch (e) {
      throw new Error('Could not stringify event: ' + e.message);
    }
    return packaged;
  }

  function _unpackPayload(e) {
    var payload, replyOrigin, replySource, replyEvent;

    if (e.data.slice(0, prefix.length) !== prefix) { return false; }

    try {
      payload = JSON.parse(e.data.slice(prefix.length));
    } catch (err) {
      return false;
    }

    if (payload.reply != null) {
      replyOrigin = e.origin;
      replySource = e.source;
      replyEvent = payload.reply;

      payload.reply = function reply(data) { // eslint-disable-line consistent-return
        var replyPayload = _packagePayload(replyEvent, [data], replyOrigin);

        if (replyPayload === false) { return false; }

        replySource.postMessage(replyPayload, replyOrigin);
      };

      payload.args.push(payload.reply);
    }

    return payload;
  }

  function _attach(w) {
    if (win) { return; }
    win = w || root;

    if (win.addEventListener) {
      win.addEventListener('message', _onmessage, false);
    } else if (win.attachEvent) {
      win.attachEvent('onmessage', _onmessage);
    } else if (win.onmessage === null) {
      win.onmessage = _onmessage;
    } else {
      win = null;
    }
  }

  function _uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : r & 0x3 | 0x8;

      return v.toString(16);
    });
  }

  function _onmessage(e) {
    var payload;

    if (_isntString(e.data)) { return; }

    payload = _unpackPayload(e);
    if (!payload) { return; }

    _dispatch('*', payload.event, payload.args, e);
    _dispatch(e.origin, payload.event, payload.args, e);
    _broadcastPopups(e.data, payload.origin, e.source);
  }

  function _dispatch(origin, event, args, e) {
    var i;

    if (!subscribers[origin]) { return; }
    if (!subscribers[origin][event]) { return; }

    for (i = 0; i < subscribers[origin][event].length; i++) {
      subscribers[origin][event][i].apply(e, args);
    }
  }

  function _hasOpener(frame) {
    if (frame.top !== frame) { return false; }
    if (frame.opener == null) { return false; }
    if (frame.opener === frame) { return false; }
    if (frame.opener.closed === true) { return false; }

    return true;
  }

  function _broadcast(frame, payload, origin) {
    var i;

    try {
      frame.postMessage(payload, origin);

      if (_hasOpener(frame)) {
        _broadcast(frame.opener.top, payload, origin);
      }

      for (i = 0; i < frame.frames.length; i++) {
        _broadcast(frame.frames[i], payload, origin);
      }
    } catch (_) { /* ignored */ }
  }

  function _broadcastPopups(payload, origin, source) {
    var i, popup;

    for (i = popups.length - 1; i >= 0; i--) {
      popup = popups[i];

      if (popup.closed === true) {
        popups = popups.slice(i, 1);
      } else if (source !== popup) {
        _broadcast(popup.top, payload, origin);
      }
    }
  }

  function _subscribeReplier(fn, origin) {
    var uuid = _uuid();

    function replier(d, o) {
      fn(d, o);
      framebus.target(origin).unsubscribe(uuid, replier);
    }

    framebus.target(origin).subscribe(uuid, replier);
    return uuid;
  }

  function _subscriptionArgsInvalid(event, fn, origin) {
    if (_isntString(event)) { return true; }
    if (typeof fn !== 'function') { return true; }
    if (_isntString(origin)) { return true; }

    return false;
  }

  _attach();

  framebus = {
    target: target,
    include: include,
    publish: publish,
    pub: publish,
    trigger: publish,
    emit: publish,
    subscribe: subscribe,
    sub: subscribe,
    on: subscribe,
    unsubscribe: unsubscribe,
    unsub: unsubscribe,
    off: unsubscribe
  };

  return framebus;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enumerate = __webpack_require__(995);

module.exports = enumerate([
  'CONFIGURATION_REQUEST'
], 'bus:');


/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isWhitelistedDomain = __webpack_require__(1007);

function checkOrigin(postMessageOrigin, merchantUrl) {
  var merchantOrigin, merchantHost;
  var a = document.createElement('a');

  a.href = merchantUrl;

  if (a.protocol === 'https:') {
    merchantHost = a.host.replace(/:443$/, '');
  } else if (a.protocol === 'http:') {
    merchantHost = a.host.replace(/:80$/, '');
  } else {
    merchantHost = a.host;
  }

  merchantOrigin = a.protocol + '//' + merchantHost;

  if (merchantOrigin === postMessageOrigin) { return true; }

  a.href = postMessageOrigin;

  return isWhitelistedDomain(postMessageOrigin);
}

module.exports = {
  checkOrigin: checkOrigin
};


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1001);
var useMin = __webpack_require__(1067);

module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
  return assetsUrl +
    '/web/' +
    constants.VERSION +
    '/html/hosted-fields-frame' + useMin(isDebug) + '.html#' +
    componentId;
};


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function useMin(isDebug) {
  return isDebug ? '' : '.min';
}

module.exports = useMin;


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function findParentTags(element, tag) {
  var parent = element.parentNode;
  var parents = [];

  while (parent != null) {
    if (parent.tagName != null && parent.tagName.toLowerCase() === tag) {
      parents.push(parent);
    }

    parent = parent.parentNode;
  }

  return parents;
}

module.exports = findParentTags;


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isIe9: __webpack_require__(996),
  isIos: __webpack_require__(1002),
  isIosWebview: __webpack_require__(1070)
};


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var isIos = __webpack_require__(1002);

// The Google Search iOS app is technically a webview and doesn't support popups.
function isGoogleSearchApp(ua) {
  return /\bGSA\b/.test(ua);
}

module.exports = function isIosWebview(ua) {
  ua = ua || global.navigator.userAgent;
  if (isIos(ua)) {
    if (isGoogleSearchApp(ua)) {
      return true;
    }
    return /.+AppleWebKit(?!.*Safari)/.test(ua);
  }
  return false;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function EventEmitter() {
  this._events = {};
}

EventEmitter.prototype.on = function (event, callback) {
  if (this._events[event]) {
    this._events[event].push(callback);
  } else {
    this._events[event] = [callback];
  }
};

EventEmitter.prototype._emit = function (event) {
  var i, args;
  var callbacks = this._events[event];

  if (!callbacks) { return; }

  args = Array.prototype.slice.call(arguments, 1);

  for (i = 0; i < callbacks.length; i++) {
    callbacks[i].apply(null, args);
  }
};

module.exports = EventEmitter;


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function injectFrame(frame, container) {
  var clearboth = document.createElement('div');
  var fragment = document.createDocumentFragment();

  clearboth.style.clear = 'both';

  fragment.appendChild(frame);
  fragment.appendChild(clearboth);

  container.appendChild(fragment);

  return [frame, clearboth];
};


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var types = {};
var VISA = 'visa';
var MASTERCARD = 'master-card';
var AMERICAN_EXPRESS = 'american-express';
var DINERS_CLUB = 'diners-club';
var DISCOVER = 'discover';
var JCB = 'jcb';
var UNIONPAY = 'unionpay';
var MAESTRO = 'maestro';
var CVV = 'CVV';
var CID = 'CID';
var CVC = 'CVC';
var CVN = 'CVN';
var testOrder = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO
];

function clone(originalObject) {
  var dupe;

  if (!originalObject) { return null; }

  dupe = JSON.parse(JSON.stringify(originalObject));
  delete dupe.prefixPattern;
  delete dupe.exactPattern;

  return dupe;
}

types[VISA] = {
  niceType: 'Visa',
  type: VISA,
  prefixPattern: /^4$/,
  exactPattern: /^4\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[MASTERCARD] = {
  niceType: 'Mastercard',
  type: MASTERCARD,
  prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27|27[0-2]|2720)$/,
  exactPattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3
  }
};

types[AMERICAN_EXPRESS] = {
  niceType: 'American Express',
  type: AMERICAN_EXPRESS,
  prefixPattern: /^(3|34|37)$/,
  exactPattern: /^3[47]\d*$/,
  isAmex: true,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4
  }
};

types[DINERS_CLUB] = {
  niceType: 'Diners Club',
  type: DINERS_CLUB,
  prefixPattern: /^(3|3[0689]|30[0-5])$/,
  exactPattern: /^3(0[0-5]|[689])\d*$/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[DISCOVER] = {
  niceType: 'Discover',
  type: DISCOVER,
  prefixPattern: /^(6|60|601|6011|65|64|64[4-9])$/,
  exactPattern: /^(6011|65|64[4-9])\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3
  }
};

types[JCB] = {
  niceType: 'JCB',
  type: JCB,
  prefixPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
  exactPattern: /^(2131|1800|35)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[UNIONPAY] = {
  niceType: 'UnionPay',
  type: UNIONPAY,
  prefixPattern: /^((6|62|62\d|(621(?!83|88|98|99))|622(?!06)|627[02,06,07]|628(?!0|1)|629[1,2])|622018)$/,
  exactPattern: /^(((620|(621(?!83|88|98|99))|622(?!06|018)|62[3-6]|627[02,06,07]|628(?!0|1)|629[1,2]))\d*|622018\d{12})$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3
  }
};

types[MAESTRO] = {
  niceType: 'Maestro',
  type: MAESTRO,
  prefixPattern: /^(5|5[06-9]|6\d*)$/,
  exactPattern: /^(5[06-9]|6[37])\d*$/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3
  }
};

function creditCardType(cardNumber) {
  var type, value, i;
  var prefixResults = [];
  var exactResults = [];

  if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
    return [];
  }

  for (i = 0; i < testOrder.length; i++) {
    type = testOrder[i];
    value = types[type];

    if (cardNumber.length === 0) {
      prefixResults.push(clone(value));
      continue;
    }

    if (value.exactPattern.test(cardNumber)) {
      exactResults.push(clone(value));
    } else if (value.prefixPattern.test(cardNumber)) {
      prefixResults.push(clone(value));
    }
  }

  return exactResults.length ? exactResults : prefixResults;
}

creditCardType.getTypeInfo = function (type) {
  return clone(types[type]);
};

creditCardType.types = {
  VISA: VISA,
  MASTERCARD: MASTERCARD,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS,
  DINERS_CLUB: DINERS_CLUB,
  DISCOVER: DISCOVER,
  JCB: JCB,
  UNIONPAY: UNIONPAY,
  MAESTRO: MAESTRO
};

module.exports = creditCardType;


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);
var errors = __webpack_require__(993);
var whitelist = __webpack_require__(1001).whitelistedAttributes;

function attributeValidationError(attribute, value) {
  var err;

  if (!whitelist.hasOwnProperty(attribute)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
      message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
    });
  } else if (value != null && !_isValid(attribute, value)) {
    err = new BraintreeError({
      type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
      code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
      message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
    });
  }

  return err;
}

function _isValid(attribute, value) {
  if (whitelist[attribute] === 'string') {
    return typeof value === 'string' || typeof value === 'number';
  } else if (whitelist[attribute] === 'boolean') {
    return String(value) === 'true' || String(value) === 'false';
  }

  return false;
}

module.exports = attributeValidationError;


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var device = __webpack_require__(1076);

module.exports = function () {
  // Digits get dropped in samsung browser
  return !device.isSamsungBrowser();
};


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var UA = global.navigator && global.navigator.userAgent;

var isAndroid = __webpack_require__(1077);
var isChrome = __webpack_require__(1078);
var isIos = __webpack_require__(1002);
var isIE9 = __webpack_require__(996);

// Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
// https://developer.chrome.com/multidevice/user-agent#webview_user_agent
var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;

function _isOldSamsungBrowserOrSamsungWebview(ua) {
  return !isChrome(ua) && ua.indexOf('Samsung') > -1;
}

function isKitKatWebview(uaArg) {
  var ua = uaArg || UA;

  return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
}

function isAndroidChrome(uaArg) {
  var ua = uaArg || UA;

  return isAndroid(ua) && isChrome(ua);
}

function isSamsungBrowser(ua) {
  ua = ua || UA;
  return /SamsungBrowser/.test(ua) || _isOldSamsungBrowserOrSamsungWebview(ua);
}

module.exports = {
  isIE9: isIE9,
  isAndroidChrome: isAndroidChrome,
  isIos: isIos,
  isKitKatWebview: isKitKatWebview,
  isSamsungBrowser: isSamsungBrowser
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = function isAndroid(ua) {
  ua = ua || global.navigator.userAgent;
  return /Android/.test(ua);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isEdge = __webpack_require__(1079);
var isSamsung = __webpack_require__(1080);

module.exports = function isChrome(ua) {
  ua = ua || navigator.userAgent;
  return (ua.indexOf('Chrome') !== -1 || ua.indexOf('CriOS') !== -1) && !isEdge(ua) && !isSamsung(ua);
};


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isEdge(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('Edge/') !== -1;
};


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = function isSamsungBrowser(ua) {
  ua = ua || global.navigator.userAgent;
  return /SamsungBrowser/i.test(ua);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1082);
module.exports.default = module.exports;


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory() : "function" == typeof define && define.amd ? define("paypal", [], factory) : "object" == typeof exports ? exports.paypal = factory() : root.paypal = factory();
}("undefined" != typeof self ? self : this, function() {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        var installedModules = {};
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = "./src/index.js");
    }({
        "./node_modules/Base64/base64.js": function(module, exports, __webpack_require__) {
            !function() {
                function InvalidCharacterError(message) {
                    this.message = message;
                }
                var object = exports, chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                InvalidCharacterError.prototype = new Error();
                InvalidCharacterError.prototype.name = "InvalidCharacterError";
                object.btoa || (object.btoa = function(input) {
                    for (var block, charCode, str = String(input), idx = 0, map = chars, output = ""; str.charAt(0 | idx) || (map = "=", 
                    idx % 1); output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
                        charCode = str.charCodeAt(idx += .75);
                        if (charCode > 255) throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
                        block = block << 8 | charCode;
                    }
                    return output;
                });
                object.atob || (object.atob = function(input) {
                    var str = String(input).replace(/[=]+$/, "");
                    if (str.length % 4 == 1) throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
                    for (var bs, buffer, bc = 0, idx = 0, output = ""; buffer = str.charAt(idx++); ~buffer && (bs = bc % 4 ? 64 * bs + buffer : buffer, 
                    bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) buffer = chars.indexOf(buffer);
                    return output;
                });
            }();
        },
        "./node_modules/beaver-logger/client/builders.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function addPayloadBuilder(builder) {
                payloadBuilders.push(builder);
            }
            function addMetaBuilder(builder) {
                metaBuilders.push(builder);
            }
            function addTrackingBuilder(builder) {
                trackingBuilders.push(builder);
            }
            function addHeaderBuilder(builder) {
                headerBuilders.push(builder);
            }
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return payloadBuilders;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return metaBuilders;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return trackingBuilders;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return headerBuilders;
            });
            __webpack_exports__.c = addPayloadBuilder;
            __webpack_exports__.b = addMetaBuilder;
            __webpack_exports__.d = addTrackingBuilder;
            __webpack_exports__.a = addHeaderBuilder;
            var payloadBuilders = [], metaBuilders = [], trackingBuilders = [], headerBuilders = [];
        },
        "./node_modules/beaver-logger/client/config.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return config;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return logLevels;
            });
            var config = {
                uri: "",
                prefix: "",
                initial_state_name: "init",
                flushInterval: 6e5,
                debounceInterval: 10,
                sizeLimit: 300,
                silent: !1,
                heartbeat: !0,
                heartbeatConsoleLog: !0,
                heartbeatInterval: 5e3,
                heartbeatTooBusy: !1,
                heartbeatTooBusyThreshold: 1e4,
                logLevel: "warn",
                autoLog: [ "warn", "error" ],
                logUnload: !0,
                logPerformance: !0
            }, logLevels = [ "error", "warn", "info", "debug" ];
        },
        "./node_modules/beaver-logger/client/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/beaver-logger/client/interface.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.addMetaBuilder;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.addPayloadBuilder;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.addTrackingBuilder;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.config;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.debug;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.error;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.flush;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.getTransport;
            });
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.immediateFlush;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.info;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.init;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.logLevels;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.prefix;
            });
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.setTransport;
            });
            __webpack_require__.d(__webpack_exports__, "o", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.track;
            });
            __webpack_require__.d(__webpack_exports__, "p", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.warn;
            });
        },
        "./node_modules/beaver-logger/client/init.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function init(conf) {
                Object(__WEBPACK_IMPORTED_MODULE_1__util__.b)(__WEBPACK_IMPORTED_MODULE_0__config__.a, conf || {});
                if (!initiated) {
                    initiated = !0;
                    __WEBPACK_IMPORTED_MODULE_0__config__.a.logPerformance && Object(__WEBPACK_IMPORTED_MODULE_2__performance__.b)();
                    __WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeat && Object(__WEBPACK_IMPORTED_MODULE_2__performance__.a)();
                    if (__WEBPACK_IMPORTED_MODULE_0__config__.a.logUnload) {
                        window.addEventListener("beforeunload", function() {
                            Object(__WEBPACK_IMPORTED_MODULE_3__logger__.g)("window_beforeunload");
                            Object(__WEBPACK_IMPORTED_MODULE_3__logger__.f)({
                                fireAndForget: !0
                            });
                        });
                        window.addEventListener("unload", function() {
                            Object(__WEBPACK_IMPORTED_MODULE_3__logger__.g)("window_unload");
                            Object(__WEBPACK_IMPORTED_MODULE_3__logger__.f)({
                                fireAndForget: !0
                            });
                        });
                    }
                    __WEBPACK_IMPORTED_MODULE_0__config__.a.flushInterval && setInterval(__WEBPACK_IMPORTED_MODULE_3__logger__.d, __WEBPACK_IMPORTED_MODULE_0__config__.a.flushInterval);
                    if (window.beaverLogQueue) {
                        window.beaverLogQueue.forEach(function(payload) {
                            Object(__WEBPACK_IMPORTED_MODULE_3__logger__.h)(payload.level, payload.event, payload);
                        });
                        delete window.beaverLogQueue;
                    }
                }
            }
            __webpack_exports__.a = init;
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js"), __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js"), __WEBPACK_IMPORTED_MODULE_2__performance__ = __webpack_require__("./node_modules/beaver-logger/client/performance.js"), __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js"), initiated = !1;
        },
        "./node_modules/beaver-logger/client/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js");
            __webpack_require__.d(__webpack_exports__, "track", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.l;
            });
            __webpack_require__.d(__webpack_exports__, "buffer", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.a;
            });
            __webpack_require__.d(__webpack_exports__, "tracking", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.m;
            });
            __webpack_require__.d(__webpack_exports__, "getTransport", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.e;
            });
            __webpack_require__.d(__webpack_exports__, "setTransport", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.k;
            });
            __webpack_require__.d(__webpack_exports__, "print", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.j;
            });
            __webpack_require__.d(__webpack_exports__, "immediateFlush", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.f;
            });
            __webpack_require__.d(__webpack_exports__, "flush", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.d;
            });
            __webpack_require__.d(__webpack_exports__, "log", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.h;
            });
            __webpack_require__.d(__webpack_exports__, "prefix", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.i;
            });
            __webpack_require__.d(__webpack_exports__, "debug", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.b;
            });
            __webpack_require__.d(__webpack_exports__, "info", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.g;
            });
            __webpack_require__.d(__webpack_exports__, "warn", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.n;
            });
            __webpack_require__.d(__webpack_exports__, "error", function() {
                return __WEBPACK_IMPORTED_MODULE_0__logger__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("./node_modules/beaver-logger/client/init.js");
            __webpack_require__.d(__webpack_exports__, "init", function() {
                return __WEBPACK_IMPORTED_MODULE_1__init__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__transitions__ = __webpack_require__("./node_modules/beaver-logger/client/transitions.js");
            __webpack_require__.d(__webpack_exports__, "startTransition", function() {
                return __WEBPACK_IMPORTED_MODULE_2__transitions__.b;
            });
            __webpack_require__.d(__webpack_exports__, "endTransition", function() {
                return __WEBPACK_IMPORTED_MODULE_2__transitions__.a;
            });
            __webpack_require__.d(__webpack_exports__, "transition", function() {
                return __WEBPACK_IMPORTED_MODULE_2__transitions__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_3__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js");
            __webpack_require__.d(__webpack_exports__, "payloadBuilders", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.g;
            });
            __webpack_require__.d(__webpack_exports__, "metaBuilders", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.f;
            });
            __webpack_require__.d(__webpack_exports__, "trackingBuilders", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.h;
            });
            __webpack_require__.d(__webpack_exports__, "headerBuilders", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.e;
            });
            __webpack_require__.d(__webpack_exports__, "addPayloadBuilder", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.c;
            });
            __webpack_require__.d(__webpack_exports__, "addMetaBuilder", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.b;
            });
            __webpack_require__.d(__webpack_exports__, "addTrackingBuilder", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.d;
            });
            __webpack_require__.d(__webpack_exports__, "addHeaderBuilder", function() {
                return __WEBPACK_IMPORTED_MODULE_3__builders__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");
            __webpack_require__.d(__webpack_exports__, "config", function() {
                return __WEBPACK_IMPORTED_MODULE_4__config__.a;
            });
            __webpack_require__.d(__webpack_exports__, "logLevels", function() {
                return __WEBPACK_IMPORTED_MODULE_4__config__.b;
            });
        },
        "./node_modules/beaver-logger/client/logger.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getTransport() {
                return transport;
            }
            function setTransport(newTransport) {
                transport = newTransport;
            }
            function print(level, event, payload) {
                if (!loaded) return setTimeout(function() {
                    return print(level, event, payload);
                }, 1);
                if (window.console && window.console.log) {
                    var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_2__config__.a.logLevel;
                    if (!(__WEBPACK_IMPORTED_MODULE_2__config__.b.indexOf(level) > __WEBPACK_IMPORTED_MODULE_2__config__.b.indexOf(logLevel))) {
                        payload = payload || {};
                        var args = [ event ];
                        Object(__WEBPACK_IMPORTED_MODULE_0__util__.c)() && (payload = JSON.stringify(payload));
                        args.push(payload);
                        (payload.error || payload.warning) && args.push("\n\n", payload.error || payload.warning);
                        try {
                            window.console[level] && window.console[level].apply ? window.console[level].apply(window.console, args) : window.console.log && window.console.log.apply && window.console.log.apply(window.console, args);
                        } catch (err) {}
                    }
                }
            }
            function immediateFlush() {
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref$fireAndForget = _ref.fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
                if (__WEBPACK_IMPORTED_MODULE_2__config__.a.uri) {
                    var hasBuffer = buffer.length, hasTracking = tracking.length;
                    if (hasBuffer || hasTracking) {
                        for (var meta = {}, _iterator = __WEBPACK_IMPORTED_MODULE_1__builders__.f, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref2;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref2 = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref2 = _i.value;
                            }
                            var builder = _ref2;
                            try {
                                Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(meta, builder(meta), !1);
                            } catch (err) {
                                console.error("Error in custom meta builder:", err.stack || err.toString());
                            }
                        }
                        for (var headers = {}, _iterator2 = __WEBPACK_IMPORTED_MODULE_1__builders__.e, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                            var _ref3;
                            if (_isArray2) {
                                if (_i2 >= _iterator2.length) break;
                                _ref3 = _iterator2[_i2++];
                            } else {
                                _i2 = _iterator2.next();
                                if (_i2.done) break;
                                _ref3 = _i2.value;
                            }
                            var _builder = _ref3;
                            try {
                                Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(headers, _builder(headers), !1);
                            } catch (err) {
                                console.error("Error in custom header builder:", err.stack || err.toString());
                            }
                        }
                        var events = buffer, req = transport(headers, {
                            events: events,
                            meta: meta,
                            tracking: tracking
                        }, {
                            fireAndForget: fireAndForget
                        });
                        buffer = [];
                        tracking = [];
                        return req;
                    }
                }
            }
            function enqueue(level, event, payload) {
                buffer.push({
                    level: level,
                    event: event,
                    payload: payload
                });
                __WEBPACK_IMPORTED_MODULE_2__config__.a.autoLog.indexOf(level) > -1 && _flush();
            }
            function log(level, event, payload) {
                __WEBPACK_IMPORTED_MODULE_2__config__.a.prefix && (event = __WEBPACK_IMPORTED_MODULE_2__config__.a.prefix + "_" + event);
                payload = payload || {};
                "string" == typeof payload ? payload = {
                    message: payload
                } : payload instanceof Error && (payload = {
                    error: payload.stack || payload.toString()
                });
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                payload.timestamp = Date.now();
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1__builders__.g, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                    var _ref4;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref4 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref4 = _i3.value;
                    }
                    var builder = _ref4;
                    try {
                        Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom payload builder:", err.stack || err.toString());
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__config__.a.silent || print(level, event, payload);
                buffer.length === __WEBPACK_IMPORTED_MODULE_2__config__.a.sizeLimit ? enqueue("info", "logger_max_buffer_length") : buffer.length < __WEBPACK_IMPORTED_MODULE_2__config__.a.sizeLimit && enqueue(level, event, payload);
            }
            function prefix(name) {
                return {
                    debug: function(event, payload) {
                        return log("debug", name + "_" + event, payload);
                    },
                    info: function(event, payload) {
                        return log("info", name + "_" + event, payload);
                    },
                    warn: function(event, payload) {
                        return log("warn", name + "_" + event, payload);
                    },
                    error: function(event, payload) {
                        return log("error", name + "_" + event, payload);
                    },
                    track: function(payload) {
                        return _track(payload);
                    },
                    flush: function() {
                        return _flush();
                    }
                };
            }
            function debug(event, payload) {
                return log("debug", event, payload);
            }
            function info(event, payload) {
                return log("info", event, payload);
            }
            function warn(event, payload) {
                return log("warn", event, payload);
            }
            function error(event, payload) {
                return log("error", event, payload);
            }
            function _track(payload) {
                if (payload) {
                    try {
                        JSON.stringify(payload);
                    } catch (err) {
                        return;
                    }
                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1__builders__.h, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                        var _ref5;
                        if (_isArray4) {
                            if (_i4 >= _iterator4.length) break;
                            _ref5 = _iterator4[_i4++];
                        } else {
                            _i4 = _iterator4.next();
                            if (_i4.done) break;
                            _ref5 = _i4.value;
                        }
                        var builder = _ref5;
                        try {
                            Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(payload, builder(payload), !1);
                        } catch (err) {
                            console.error("Error in custom tracking builder:", err.stack || err.toString());
                        }
                    }
                    print("debug", "tracking", payload);
                    tracking.push(payload);
                }
            }
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return _track;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return buffer;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return tracking;
            });
            __webpack_exports__.e = getTransport;
            __webpack_exports__.k = setTransport;
            __webpack_exports__.j = print;
            __webpack_exports__.f = immediateFlush;
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return _flush;
            });
            __webpack_exports__.h = log;
            __webpack_exports__.i = prefix;
            __webpack_exports__.b = debug;
            __webpack_exports__.g = info;
            __webpack_exports__.n = warn;
            __webpack_exports__.c = error;
            var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js"), __WEBPACK_IMPORTED_MODULE_1__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, buffer = [], tracking = [];
            Function.prototype.bind && window.console && "object" === _typeof(console.log) && [ "log", "info", "warn", "error" ].forEach(function(method) {
                console[method] = this.bind(console[method], console);
            }, Function.prototype.call);
            var transport = function(headers, data, options) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__util__.a)("post", __WEBPACK_IMPORTED_MODULE_2__config__.a.uri, headers, data, options);
            }, loaded = !1;
            setTimeout(function() {
                loaded = !0;
            }, 1);
            var _flush = Object(__WEBPACK_IMPORTED_MODULE_0__util__.d)(immediateFlush, __WEBPACK_IMPORTED_MODULE_2__config__.a.debounceInterval);
        },
        "./node_modules/beaver-logger/client/performance.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function now() {
                return enablePerformance ? performance.now() : Date.now();
            }
            function timer(startTime) {
                startTime = void 0 !== startTime ? startTime : now();
                return {
                    startTime: startTime,
                    elapsed: function() {
                        return parseInt(now() - startTime, 10);
                    },
                    reset: function() {
                        startTime = now();
                    }
                };
            }
            function reqStartElapsed() {
                if (enablePerformance) {
                    var timing = window.performance.timing;
                    return parseInt(timing.connectEnd - timing.navigationStart, 10);
                }
            }
            function initHeartBeat() {
                var heartBeatTimer = timer(), heartbeatCount = 0;
                Object(__WEBPACK_IMPORTED_MODULE_3__util__.e)(function() {
                    if (!(__WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatMaxThreshold && heartbeatCount > __WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatMaxThreshold)) {
                        heartbeatCount += 1;
                        var elapsed = heartBeatTimer.elapsed(), lag = elapsed - __WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatInterval, heartbeatPayload = {
                            count: heartbeatCount,
                            elapsed: elapsed
                        };
                        if (__WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatTooBusy) {
                            heartbeatPayload.lag = lag;
                            lag >= __WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatTooBusyThreshold && Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("toobusy", heartbeatPayload, {
                                noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatConsoleLog
                            });
                        }
                        Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("heartbeat", heartbeatPayload, {
                            noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatConsoleLog
                        });
                    }
                }, __WEBPACK_IMPORTED_MODULE_0__config__.a.heartbeatInterval);
            }
            function initPerformance() {
                if (!enablePerformance) return Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("no_performance_data");
                Object(__WEBPACK_IMPORTED_MODULE_2__builders__.c)(function() {
                    var payload = {};
                    payload.client_elapsed = clientTimer.elapsed();
                    enablePerformance && (payload.req_elapsed = reqTimer.elapsed());
                    return payload;
                });
                __WEBPACK_IMPORTED_MODULE_3__util__.g.then(function() {
                    var keys = [ "connectEnd", "connectStart", "domComplete", "domContentLoadedEventEnd", "domContentLoadedEventStart", "domInteractive", "domLoading", "domainLookupEnd", "domainLookupStart", "fetchStart", "loadEventEnd", "loadEventStart", "navigationStart", "redirectEnd", "redirectStart", "requestStart", "responseEnd", "responseStart", "secureConnectionStart", "unloadEventEnd", "unloadEventStart" ], timing = {};
                    keys.forEach(function(key) {
                        timing[key] = parseInt(window.performance.timing[key], 10) || 0;
                    });
                    var offset = timing.connectEnd - timing.navigationStart;
                    timing.connectEnd && Object.keys(timing).forEach(function(name) {
                        var time = timing[name];
                        time && Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("timing_" + name, {
                            client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                            req_elapsed: parseInt(time - timing.connectEnd, 10)
                        });
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("timing", timing);
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("memory", window.performance.memory);
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)("navigation", window.performance.navigation);
                    window.performance.getEntries && window.performance.getEntries().forEach(function(resource) {
                        [ "link", "script", "img", "css" ].indexOf(resource.initiatorType) > -1 && Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)(resource.initiatorType, resource);
                    });
                });
            }
            __webpack_exports__.c = now;
            __webpack_exports__.d = reqStartElapsed;
            __webpack_exports__.a = initHeartBeat;
            __webpack_exports__.b = initPerformance;
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js"), __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js"), __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js"), __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js"), enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0, clientTimer = timer(), reqTimer = timer(reqStartElapsed());
        },
        "./node_modules/beaver-logger/client/transitions.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function startTransition() {
                startTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__.c)();
            }
            function endTransition(toState) {
                startTime = startTime || Object(__WEBPACK_IMPORTED_MODULE_0__performance__.d)();
                var currentTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__.c)(), elapsedTime = void 0;
                void 0 !== startTime && (elapsedTime = parseInt(currentTime - startTime, 0));
                var transitionName = "transition_" + currentState + "_to_" + toState;
                Object(__WEBPACK_IMPORTED_MODULE_1__logger__.g)(transitionName, {
                    duration: elapsedTime
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__logger__.l)({
                    transition: transitionName,
                    transition_time: elapsedTime
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__logger__.f)();
                startTime = currentTime;
                currentState = toState;
                pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__.f)();
            }
            function transition(toState) {
                startTransition();
                endTransition(toState);
            }
            __webpack_exports__.b = startTransition;
            __webpack_exports__.a = endTransition;
            __webpack_exports__.c = transition;
            var __WEBPACK_IMPORTED_MODULE_0__performance__ = __webpack_require__("./node_modules/beaver-logger/client/performance.js"), __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js"), __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js"), __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js"), __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js"), windowID = Object(__WEBPACK_IMPORTED_MODULE_3__util__.f)(), pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__.f)(), currentState = __WEBPACK_IMPORTED_MODULE_4__config__.a.initial_state_name, startTime = void 0;
            Object(__WEBPACK_IMPORTED_MODULE_2__builders__.c)(function() {
                return {
                    windowID: windowID,
                    pageID: pageID
                };
            });
            Object(__WEBPACK_IMPORTED_MODULE_2__builders__.b)(function() {
                return {
                    state: "ui_" + currentState
                };
            });
        },
        "./node_modules/beaver-logger/client/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function extend(dest, src) {
                var over = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                dest = dest || {};
                src = src || {};
                for (var i in src) src.hasOwnProperty(i) && (!over && dest.hasOwnProperty(i) || (dest[i] = src[i]));
                return dest;
            }
            function isSameProtocol(url) {
                return window.location.protocol === url.split("/")[0];
            }
            function isSameDomain(url) {
                var match = url.match(/https?:\/\/[^\/]+/);
                return !match || match[0] === window.location.protocol + "//" + window.location.host;
            }
            function ajax(method, url) {
                var headers = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, data = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, _ref = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {}, _ref$fireAndForget = _ref.fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
                return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve) {
                    var XRequest = window.XMLHttpRequest || window.ActiveXObject;
                    if (window.XDomainRequest && !isSameDomain(url)) {
                        if (!isSameProtocol(url)) return resolve();
                        XRequest = window.XDomainRequest;
                    }
                    var req = new XRequest("MSXML2.XMLHTTP.3.0");
                    req.open(method.toUpperCase(), url, !0);
                    if ("function" == typeof req.setRequestHeader) {
                        req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                        req.setRequestHeader("Content-type", "application/json");
                        for (var headerName in headers) headers.hasOwnProperty(headerName) && req.setRequestHeader(headerName, headers[headerName]);
                    }
                    fireAndForget ? resolve() : req.onreadystatechange = function() {
                        req.readyState > 3 && resolve();
                    };
                    req.send(JSON.stringify(data).replace(/&/g, "%26"));
                });
            }
            function promiseDebounce(method, interval) {
                var debounce = {};
                return function() {
                    var args = arguments;
                    if (debounce.timeout) {
                        clearTimeout(debounce.timeout);
                        delete debounce.timeout;
                    }
                    debounce.timeout = setTimeout(function() {
                        var resolver = debounce.resolver, rejector = debounce.rejector;
                        delete debounce.promise;
                        delete debounce.resolver;
                        delete debounce.rejector;
                        delete debounce.timeout;
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve().then(function() {
                            return method.apply(null, args);
                        }).then(resolver, rejector);
                    }, interval);
                    debounce.promise = debounce.promise || new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolver, rejector) {
                        debounce.resolver = resolver;
                        debounce.rejector = rejector;
                    });
                    return debounce.promise;
                };
            }
            function safeInterval(method, time) {
                function loop() {
                    timeout = setTimeout(function() {
                        method();
                        loop();
                    }, time);
                }
                var timeout = void 0;
                loop();
                return {
                    cancel: function() {
                        clearTimeout(timeout);
                    }
                };
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                });
            }
            function isIE() {
                return Boolean(window.document.documentMode);
            }
            __webpack_exports__.b = extend;
            __webpack_exports__.a = ajax;
            __webpack_exports__.d = promiseDebounce;
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return windowReady;
            });
            __webpack_exports__.e = safeInterval;
            __webpack_exports__.f = uniqueID;
            __webpack_exports__.c = isIE;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), windowReady = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve) {
                "undefined" != typeof document && "complete" === document.readyState && resolve();
                window.addEventListener && window.addEventListener("load", resolve);
            });
        },
        "./node_modules/bowser/bowser.min.js": function(module, exports, __webpack_require__) {
            /*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */
            !function(e, t, n) {
                void 0 !== module && module.exports ? module.exports = n() : __webpack_require__("./node_modules/webpack/buildin/amd-define.js")(t, n);
            }(0, "bowser", function() {
                function t(t) {
                    function n(e) {
                        var n = t.match(e);
                        return n && n.length > 1 && n[1] || "";
                    }
                    function r(e) {
                        var n = t.match(e);
                        return n && n.length > 1 && n[2] || "";
                    }
                    var T, i = n(/(ipod|iphone|ipad)/i).toLowerCase(), s = /like android/i.test(t), o = !s && /android/i.test(t), u = /nexus\s*[0-6]\s*/i.test(t), a = !u && /nexus\s*[0-9]+/i.test(t), f = /CrOS/.test(t), l = /silk/i.test(t), c = /sailfish/i.test(t), h = /tizen/i.test(t), p = /(web|hpw)os/i.test(t), d = /windows phone/i.test(t), m = (/SamsungBrowser/i.test(t), 
                    !d && /windows/i.test(t)), g = !i && !l && /macintosh/i.test(t), y = !o && !c && !h && !p && /linux/i.test(t), b = r(/edg([ea]|ios)\/(\d+(\.\d+)?)/i), w = n(/version\/(\d+(\.\d+)?)/i), E = /tablet/i.test(t) && !/tablet pc/i.test(t), S = !E && /[^-]mobi/i.test(t), x = /xbox/i.test(t);
                    /opera/i.test(t) ? T = {
                        name: "Opera",
                        opera: e,
                        version: w || n(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
                    } : /opr\/|opios/i.test(t) ? T = {
                        name: "Opera",
                        opera: e,
                        version: n(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || w
                    } : /SamsungBrowser/i.test(t) ? T = {
                        name: "Samsung Internet for Android",
                        samsungBrowser: e,
                        version: w || n(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
                    } : /coast/i.test(t) ? T = {
                        name: "Opera Coast",
                        coast: e,
                        version: w || n(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
                    } : /yabrowser/i.test(t) ? T = {
                        name: "Yandex Browser",
                        yandexbrowser: e,
                        version: w || n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
                    } : /ucbrowser/i.test(t) ? T = {
                        name: "UC Browser",
                        ucbrowser: e,
                        version: n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /mxios/i.test(t) ? T = {
                        name: "Maxthon",
                        maxthon: e,
                        version: n(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /epiphany/i.test(t) ? T = {
                        name: "Epiphany",
                        epiphany: e,
                        version: n(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /puffin/i.test(t) ? T = {
                        name: "Puffin",
                        puffin: e,
                        version: n(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
                    } : /sleipnir/i.test(t) ? T = {
                        name: "Sleipnir",
                        sleipnir: e,
                        version: n(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /k-meleon/i.test(t) ? T = {
                        name: "K-Meleon",
                        kMeleon: e,
                        version: n(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
                    } : d ? (T = {
                        name: "Windows Phone",
                        osname: "Windows Phone",
                        windowsphone: e
                    }, b ? (T.msedge = e, T.version = b) : (T.msie = e, T.version = n(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? T = {
                        name: "Internet Explorer",
                        msie: e,
                        version: n(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                    } : f ? T = {
                        name: "Chrome",
                        osname: "Chrome OS",
                        chromeos: e,
                        chromeBook: e,
                        chrome: e,
                        version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                    } : /edg([ea]|ios)/i.test(t) ? T = {
                        name: "Microsoft Edge",
                        msedge: e,
                        version: b
                    } : /vivaldi/i.test(t) ? T = {
                        name: "Vivaldi",
                        vivaldi: e,
                        version: n(/vivaldi\/(\d+(\.\d+)?)/i) || w
                    } : c ? T = {
                        name: "Sailfish",
                        osname: "Sailfish OS",
                        sailfish: e,
                        version: n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
                    } : /seamonkey\//i.test(t) ? T = {
                        name: "SeaMonkey",
                        seamonkey: e,
                        version: n(/seamonkey\/(\d+(\.\d+)?)/i)
                    } : /firefox|iceweasel|fxios/i.test(t) ? (T = {
                        name: "Firefox",
                        firefox: e,
                        version: n(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
                    }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (T.firefoxos = e, T.osname = "Firefox OS")) : l ? T = {
                        name: "Amazon Silk",
                        silk: e,
                        version: n(/silk\/(\d+(\.\d+)?)/i)
                    } : /phantom/i.test(t) ? T = {
                        name: "PhantomJS",
                        phantom: e,
                        version: n(/phantomjs\/(\d+(\.\d+)?)/i)
                    } : /slimerjs/i.test(t) ? T = {
                        name: "SlimerJS",
                        slimer: e,
                        version: n(/slimerjs\/(\d+(\.\d+)?)/i)
                    } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? T = {
                        name: "BlackBerry",
                        osname: "BlackBerry OS",
                        blackberry: e,
                        version: w || n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
                    } : p ? (T = {
                        name: "WebOS",
                        osname: "WebOS",
                        webos: e,
                        version: w || n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
                    }, /touchpad\//i.test(t) && (T.touchpad = e)) : /bada/i.test(t) ? T = {
                        name: "Bada",
                        osname: "Bada",
                        bada: e,
                        version: n(/dolfin\/(\d+(\.\d+)?)/i)
                    } : h ? T = {
                        name: "Tizen",
                        osname: "Tizen",
                        tizen: e,
                        version: n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || w
                    } : /qupzilla/i.test(t) ? T = {
                        name: "QupZilla",
                        qupzilla: e,
                        version: n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || w
                    } : /chromium/i.test(t) ? T = {
                        name: "Chromium",
                        chromium: e,
                        version: n(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || w
                    } : /chrome|crios|crmo/i.test(t) ? T = {
                        name: "Chrome",
                        chrome: e,
                        version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                    } : o ? T = {
                        name: "Android",
                        version: w
                    } : /safari|applewebkit/i.test(t) ? (T = {
                        name: "Safari",
                        safari: e
                    }, w && (T.version = w)) : i ? (T = {
                        name: "iphone" == i ? "iPhone" : "ipad" == i ? "iPad" : "iPod"
                    }, w && (T.version = w)) : T = /googlebot/i.test(t) ? {
                        name: "Googlebot",
                        googlebot: e,
                        version: n(/googlebot\/(\d+(\.\d+))/i) || w
                    } : {
                        name: n(/^(.*)\/(.*) /),
                        version: r(/^(.*)\/(.*) /)
                    }, !T.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (T.name = T.name || "Blink", 
                    T.blink = e) : (T.name = T.name || "Webkit", T.webkit = e), !T.version && w && (T.version = w)) : !T.opera && /gecko\//i.test(t) && (T.name = T.name || "Gecko", 
                    T.gecko = e, T.version = T.version || n(/gecko\/(\d+(\.\d+)?)/i)), T.windowsphone || !o && !T.silk ? !T.windowsphone && i ? (T[i] = e, 
                    T.ios = e, T.osname = "iOS") : g ? (T.mac = e, T.osname = "macOS") : x ? (T.xbox = e, 
                    T.osname = "Xbox") : m ? (T.windows = e, T.osname = "Windows") : y && (T.linux = e, 
                    T.osname = "Linux") : (T.android = e, T.osname = "Android");
                    var C = "";
                    T.windows ? C = function(e) {
                        switch (e) {
                          case "NT":
                            return "NT";

                          case "XP":
                            return "XP";

                          case "NT 5.0":
                            return "2000";

                          case "NT 5.1":
                            return "XP";

                          case "NT 5.2":
                            return "2003";

                          case "NT 6.0":
                            return "Vista";

                          case "NT 6.1":
                            return "7";

                          case "NT 6.2":
                            return "8";

                          case "NT 6.3":
                            return "8.1";

                          case "NT 10.0":
                            return "10";

                          default:
                            return;
                        }
                    }(n(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : T.windowsphone ? C = n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : T.mac ? (C = n(/Mac OS X (\d+([_\.\s]\d+)*)/i), 
                    C = C.replace(/[_\s]/g, ".")) : i ? (C = n(/os (\d+([_\s]\d+)*) like mac os x/i), 
                    C = C.replace(/[_\s]/g, ".")) : o ? C = n(/android[ \/-](\d+(\.\d+)*)/i) : T.webos ? C = n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : T.blackberry ? C = n(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : T.bada ? C = n(/bada\/(\d+(\.\d+)*)/i) : T.tizen && (C = n(/tizen[\/\s](\d+(\.\d+)*)/i)), 
                    C && (T.osversion = C);
                    var k = !T.windows && C.split(".")[0];
                    E || a || "ipad" == i || o && (3 == k || k >= 4 && !S) || T.silk ? T.tablet = e : (S || "iphone" == i || "ipod" == i || o || u || T.blackberry || T.webos || T.bada) && (T.mobile = e);
                    return T.msedge || T.msie && T.version >= 10 || T.yandexbrowser && T.version >= 15 || T.vivaldi && T.version >= 1 || T.chrome && T.version >= 20 || T.samsungBrowser && T.version >= 4 || T.firefox && T.version >= 20 || T.safari && T.version >= 6 || T.opera && T.version >= 10 || T.ios && T.osversion && T.osversion.split(".")[0] >= 6 || T.blackberry && T.version >= 10.1 || T.chromium && T.version >= 20 ? T.a = e : T.msie && T.version < 10 || T.chrome && T.version < 20 || T.firefox && T.version < 20 || T.safari && T.version < 6 || T.opera && T.version < 10 || T.ios && T.osversion && T.osversion.split(".")[0] < 6 || T.chromium && T.version < 20 ? T.c = e : T.x = e, 
                    T;
                }
                function r(e) {
                    return e.split(".").length;
                }
                function i(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for (r = 0; r < e.length; r++) n.push(t(e[r]));
                    return n;
                }
                function s(e) {
                    for (var t = Math.max(r(e[0]), r(e[1])), n = i(e, function(e) {
                        var n = t - r(e);
                        return e += new Array(n + 1).join(".0"), i(e.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    }); --t >= 0; ) {
                        if (n[0][t] > n[1][t]) return 1;
                        if (n[0][t] !== n[1][t]) return -1;
                        if (0 === t) return 0;
                    }
                }
                function o(e, r, i) {
                    var o = n;
                    "string" == typeof r && (i = r, r = void 0), void 0 === r && (r = !1), i && (o = t(i));
                    var u = "" + o.version;
                    for (var a in e) if (e.hasOwnProperty(a) && o[a]) {
                        if ("string" != typeof e[a]) throw new Error("Browser version in the minVersion map should be a string: " + a + ": " + String(e));
                        return s([ u, e[a] ]) < 0;
                    }
                    return r;
                }
                function u(e, t, n) {
                    return !o(e, t, n);
                }
                var e = !0, n = t("undefined" != typeof navigator ? navigator.userAgent || "" : "");
                return n.test = function(e) {
                    for (var t = 0; t < e.length; ++t) {
                        var r = e[t];
                        if ("string" == typeof r && r in n) return !0;
                    }
                    return !1;
                }, n.isUnsupportedBrowser = o, n.compareVersions = s, n.check = u, n._detect = t, 
                n;
            });
        },
        "./node_modules/braintree-paypal-client-config/dist/braintree-paypal-client-config.js": function(module, exports, __webpack_require__) {
            (function(module) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                !function(root, factory) {
                    "object" == _typeof(exports) && "object" == _typeof(module) ? module.exports = factory() : (__WEBPACK_AMD_DEFINE_ARRAY__ = [], 
                    __WEBPACK_AMD_DEFINE_FACTORY__ = factory, void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = "function" == typeof __WEBPACK_AMD_DEFINE_FACTORY__ ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                }(0, function() {
                    return function(modules) {
                        function __webpack_require__(moduleId) {
                            if (installedModules[moduleId]) return installedModules[moduleId].exports;
                            var module = installedModules[moduleId] = {
                                i: moduleId,
                                l: !1,
                                exports: {}
                            };
                            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                            module.l = !0;
                            return module.exports;
                        }
                        var installedModules = {};
                        __webpack_require__.m = modules;
                        __webpack_require__.c = installedModules;
                        __webpack_require__.d = function(exports, name, getter) {
                            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                                configurable: !1,
                                enumerable: !0,
                                get: getter
                            });
                        };
                        __webpack_require__.n = function(module) {
                            var getter = module && module.__esModule ? function() {
                                return module.default;
                            } : function() {
                                return module;
                            };
                            __webpack_require__.d(getter, "a", getter);
                            return getter;
                        };
                        __webpack_require__.o = function(object, property) {
                            return Object.prototype.hasOwnProperty.call(object, property);
                        };
                        __webpack_require__.p = "";
                        return __webpack_require__(__webpack_require__.s = "./src/index.js");
                    }({
                        "./src/config.js": function(module, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            function get(key, def) {
                                return __WEBPACK_IMPORTED_MODULE_0__store__.a.has(key) ? __WEBPACK_IMPORTED_MODULE_0__store__.a.get(key) : def;
                            }
                            function set(key, value) {
                                __WEBPACK_IMPORTED_MODULE_0__store__.a.set(key, value);
                                if (listeners[key]) for (var _iterator = listeners[key], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                                    var _ref;
                                    if (_isArray) {
                                        if (_i >= _iterator.length) break;
                                        _ref = _iterator[_i++];
                                    } else {
                                        _i = _iterator.next();
                                        if (_i.done) break;
                                        _ref = _i.value;
                                    }
                                    var listener = _ref;
                                    listener(value);
                                }
                                return value;
                            }
                            function get_or_set(key, value) {
                                return __WEBPACK_IMPORTED_MODULE_0__store__.a.has(key) ? get(key) : set(key, value);
                            }
                            function on(key, handler) {
                                listeners[key] = listeners[key] || [];
                                listeners[key].push(handler);
                                return {
                                    cancel: function() {
                                        listeners[key].splice(listeners[key].indexOf(handler), 1);
                                    }
                                };
                            }
                            __webpack_exports__.a = get;
                            __webpack_exports__.d = set;
                            __webpack_exports__.b = get_or_set;
                            __webpack_exports__.c = on;
                            var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("./src/store.js"), listeners = {};
                        },
                        "./src/constants.js": function(module, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            __webpack_require__.d(__webpack_exports__, "a", function() {
                                return CONFIG_KEY;
                            });
                            __webpack_require__.d(__webpack_exports__, "d", function() {
                                return STORE;
                            });
                            __webpack_require__.d(__webpack_exports__, "b", function() {
                                return KEY;
                            });
                            __webpack_require__.d(__webpack_exports__, "c", function() {
                                return PAYPAL_FUNDING;
                            });
                            var CONFIG_KEY = "__braintree_paypal_config__", STORE = {
                                SESSIONSTORAGE: "sessionstorage",
                                GLOBAL: "global"
                            }, KEY = {
                                LOGGER_SESSION_ID: "logger_session_id",
                                PAYPAL_FUNDING_DISALLOW: "paypal_funding_disallow"
                            }, PAYPAL_FUNDING = {
                                PAYPAL: "paypal",
                                VENMO: "venmo",
                                CREDIT: "credit",
                                CARD: "card",
                                IDEAL: "ideal",
                                ELV: "elv"
                            };
                        },
                        "./src/index.js": function(module, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            Object.defineProperty(__webpack_exports__, "__esModule", {
                                value: !0
                            });
                            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config.js");
                            __webpack_require__.d(__webpack_exports__, "get", function() {
                                return __WEBPACK_IMPORTED_MODULE_0__config__.a;
                            });
                            __webpack_require__.d(__webpack_exports__, "set", function() {
                                return __WEBPACK_IMPORTED_MODULE_0__config__.d;
                            });
                            __webpack_require__.d(__webpack_exports__, "get_or_set", function() {
                                return __WEBPACK_IMPORTED_MODULE_0__config__.b;
                            });
                            __webpack_require__.d(__webpack_exports__, "on", function() {
                                return __WEBPACK_IMPORTED_MODULE_0__config__.c;
                            });
                            var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/constants.js");
                            __webpack_require__.d(__webpack_exports__, "CONFIG_KEY", function() {
                                return __WEBPACK_IMPORTED_MODULE_1__constants__.a;
                            });
                            __webpack_require__.d(__webpack_exports__, "STORE", function() {
                                return __WEBPACK_IMPORTED_MODULE_1__constants__.d;
                            });
                            __webpack_require__.d(__webpack_exports__, "KEY", function() {
                                return __WEBPACK_IMPORTED_MODULE_1__constants__.b;
                            });
                            __webpack_require__.d(__webpack_exports__, "PAYPAL_FUNDING", function() {
                                return __WEBPACK_IMPORTED_MODULE_1__constants__.c;
                            });
                        },
                        "./src/store.js": function(module, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            function _defineProperty(obj, key, value) {
                                key in obj ? Object.defineProperty(obj, key, {
                                    value: value,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : obj[key] = value;
                                return obj;
                            }
                            __webpack_require__.d(__webpack_exports__, "a", function() {
                                return store;
                            });
                            var _stores, __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/constants.js"), __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/util.js"), stores = (_stores = {}, 
                            _defineProperty(_stores, __WEBPACK_IMPORTED_MODULE_0__constants__.d.GLOBAL, {
                                get: function(key) {
                                    return (window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {})[key];
                                },
                                set: function(key, value) {
                                    var storage = window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {};
                                    storage[key] = value;
                                    window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] = storage;
                                    return value;
                                },
                                has: function(key) {
                                    return (window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {}).hasOwnProperty(key);
                                }
                            }), _defineProperty(_stores, __WEBPACK_IMPORTED_MODULE_0__constants__.d.SESSIONSTORAGE, {
                                get: function(key) {
                                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                                    storage = storage ? JSON.parse(storage) : {};
                                    return storage[key];
                                },
                                set: function(key, value) {
                                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                                    storage = storage ? JSON.parse(storage) : {};
                                    storage[key] = value;
                                    window.sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a, JSON.stringify(storage));
                                    return value;
                                },
                                has: function(key) {
                                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                                    storage = storage ? JSON.parse(storage) : {};
                                    return storage.hasOwnProperty(key);
                                }
                            }), _stores), store = Object(__WEBPACK_IMPORTED_MODULE_1__util__.a)() ? stores[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SESSIONSTORAGE] : stores[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GLOBAL];
                        },
                        "./src/util.js": function(module, __webpack_exports__, __webpack_require__) {
                            "use strict";
                            function isSessionStorageEnabled() {
                                try {
                                    if (window.sessionStorage) {
                                        var value = Math.random().toString();
                                        window.sessionStorage.setItem("__test__sessionStorage__", value);
                                        var result = window.sessionStorage.getItem("__test__sessionStorage__");
                                        window.sessionStorage.removeItem("__test__sessionStorage__");
                                        if (value === result) return !0;
                                    }
                                } catch (err) {}
                                return !1;
                            }
                            __webpack_exports__.a = isSessionStorageEnabled;
                        }
                    });
                });
            }).call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module));
        },
        "./node_modules/braintree-paypal-client-config/index.js": function(module, exports, __webpack_require__) {
            module.exports = __webpack_require__("./node_modules/braintree-paypal-client-config/dist/braintree-paypal-client-config.js");
        },
        "./node_modules/cross-domain-safe-weakmap/src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/interface.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.WeakMap;
            });
        },
        "./node_modules/cross-domain-safe-weakmap/src/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__weakmap__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/weakmap.js");
            __webpack_require__.d(__webpack_exports__, "WeakMap", function() {
                return __WEBPACK_IMPORTED_MODULE_0__weakmap__.a;
            });
        },
        "./node_modules/cross-domain-safe-weakmap/src/native.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function hasNativeWeakMap() {
                if (!window.WeakMap) return !1;
                if (!window.Object.freeze) return !1;
                try {
                    var testWeakMap = new window.WeakMap(), testKey = {};
                    window.Object.freeze(testKey);
                    testWeakMap.set(testKey, "__testvalue__");
                    return "__testvalue__" === testWeakMap.get(testKey);
                } catch (err) {
                    return !1;
                }
            }
            __webpack_exports__.a = hasNativeWeakMap;
        },
        "./node_modules/cross-domain-safe-weakmap/src/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function safeIndexOf(collection, item) {
                for (var i = 0; i < collection.length; i++) try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            function noop() {}
            __webpack_exports__.b = safeIndexOf;
            __webpack_exports__.a = noop;
        },
        "./node_modules/cross-domain-safe-weakmap/src/weakmap.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return CrossDomainSafeWeakMap;
            });
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__native__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/native.js"), __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/util.js"), defineProperty = Object.defineProperty, counter = Date.now() % 1e9, CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    _classCallCheck(this, CrossDomainSafeWeakMap);
                    counter += 1;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__" + counter;
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__native__.a)()) try {
                        this.weakmap = new window.WeakMap();
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                CrossDomainSafeWeakMap.prototype._cleanupClosedWindows = function() {
                    for (var weakmap = this.weakmap, keys = this.keys, i = 0; i < keys.length; i++) {
                        var value = keys[i];
                        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.x)(value) && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.y)(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                CrossDomainSafeWeakMap.prototype.isSafeToReadWrite = function(key) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.x)(key)) return !1;
                    try {
                        Object(__WEBPACK_IMPORTED_MODULE_2__util__.a)(key && key.self);
                        Object(__WEBPACK_IMPORTED_MODULE_2__util__.a)(key && key[this.name]);
                    } catch (err) {
                        return !1;
                    }
                    return !0;
                };
                CrossDomainSafeWeakMap.prototype.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var name = this.name, entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : defineProperty(key, name, {
                            value: [ key, value ],
                            writable: !0
                        });
                    } else {
                        this._cleanupClosedWindows();
                        var keys = this.keys, values = this.values, index = Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(keys, key);
                        if (-1 === index) {
                            keys.push(key);
                            values.push(value);
                        } else values[index] = value;
                    }
                };
                CrossDomainSafeWeakMap.prototype.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (!this.isSafeToReadWrite(key)) {
                        this._cleanupClosedWindows();
                        var keys = this.keys, index = Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(keys, key);
                        if (-1 === index) return;
                        return this.values[index];
                    }
                    var entry = key[this.name];
                    if (entry && entry[0] === key) return entry[1];
                };
                CrossDomainSafeWeakMap.prototype.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } else {
                        this._cleanupClosedWindows();
                        var keys = this.keys, index = Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(keys, key);
                        if (-1 !== index) {
                            keys.splice(index, 1);
                            this.values.splice(index, 1);
                        }
                    }
                };
                CrossDomainSafeWeakMap.prototype.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        return weakmap.has(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    }
                    this._cleanupClosedWindows();
                    return -1 !== Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(this.keys, key);
                };
                return CrossDomainSafeWeakMap;
            }();
        },
        "./node_modules/cross-domain-utils/src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isFileProtocol() {
                return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window).location.protocol === CONSTANTS.FILE_PROTOCOL;
            }
            function getActualDomain(win) {
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if (protocol === CONSTANTS.FILE_PROTOCOL) return CONSTANTS.FILE_PROTOCOL + "//";
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                win = win || window;
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf(CONSTANTS.MOCK_PROTOCOL) ? win.mockDomain : domain;
            }
            function isBlankDomain(win) {
                try {
                    if (!win.location.href) return !0;
                    if ("about:blank" === win.location.href) return !0;
                } catch (err) {}
                return !1;
            }
            function isActuallySameDomain(win) {
                try {
                    var desc = Object.getOwnPropertyDescriptor(win, "location");
                    if (desc && !1 === desc.enumerable) return !1;
                } catch (err) {}
                try {
                    if (isBlankDomain(win)) return !0;
                    if (getActualDomain(win) === getActualDomain(window)) return !0;
                } catch (err) {}
                return !1;
            }
            function isSameDomain(win) {
                if (!isActuallySameDomain(win)) return !1;
                try {
                    if (isBlankDomain(win)) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function getParent(win) {
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {
                    return;
                }
            }
            function getOpener(win) {
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {
                    return;
                }
            }
            function getParents(win) {
                var result = [];
                try {
                    for (;win.parent !== win; ) {
                        result.push(win.parent);
                        win = win.parent;
                    }
                } catch (err) {}
                return result;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== getParents(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [], frames = void 0;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len = void 0;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for (var i = 0; i < len; i++) {
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for (var _i = 0; _i < 100; _i++) {
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            function getAllChildFrames(win) {
                for (var result = [], _iterator = getFrames(win), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i2 >= _iterator.length) break;
                        _ref = _iterator[_i2++];
                    } else {
                        _i2 = _iterator.next();
                        if (_i2.done) break;
                        _ref = _i2.value;
                    }
                    var frame = _ref;
                    result.push(frame);
                    for (var _iterator2 = getAllChildFrames(frame), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i3 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i3++];
                        } else {
                            _i3 = _iterator2.next();
                            if (_i3.done) break;
                            _ref2 = _i3.value;
                        }
                        var childFrame = _ref2;
                        result.push(childFrame);
                    }
                }
                return result;
            }
            function getTop(win) {
                if (win) {
                    try {
                        if (win.top) return win.top;
                    } catch (err) {}
                    if (getParent(win) === win) return win;
                    try {
                        if (isAncestorParent(window, win) && window.top) return window.top;
                    } catch (err) {}
                    try {
                        if (isAncestorParent(win, window) && window.top) return window.top;
                    } catch (err) {}
                    for (var _iterator3 = getAllChildFrames(win), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                        var _ref3;
                        if (_isArray3) {
                            if (_i4 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i4++];
                        } else {
                            _i4 = _iterator3.next();
                            if (_i4.done) break;
                            _ref3 = _i4.value;
                        }
                        var frame = _ref3;
                        try {
                            if (frame.top) return frame.top;
                        } catch (err) {}
                        if (getParent(frame) === frame) return frame;
                    }
                }
            }
            function getAllFramesInWindow(win) {
                var top = getTop(win);
                return getAllChildFrames(top).concat(top);
            }
            function isTop(win) {
                return win === getTop(win);
            }
            function isFrameWindowClosed(frame) {
                if (!frame.contentWindow) return !0;
                if (!frame.parentNode) return !0;
                var doc = frame.ownerDocument;
                return !(!doc || !doc.body || doc.body.contains(frame));
            }
            function safeIndexOf(collection, item) {
                for (var i = 0; i < collection.length; i++) try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            function isWindowClosed(win) {
                var allowMock = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                try {
                    Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(win === win);
                } catch (err) {
                    return !0;
                }
                var iframeIndex = safeIndexOf(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && isFrameWindowClosed(frame)) return !0;
                }
                return !1;
            }
            function cleanIframes() {
                for (var i = 0; i < iframeFrames.length; i++) if (isFrameWindowClosed(iframeFrames[i])) {
                    iframeFrames.splice(i, 1);
                    iframeWindows.splice(i, 1);
                }
                for (var _i5 = 0; _i5 < iframeWindows.length; _i5++) if (isWindowClosed(iframeWindows[_i5])) {
                    iframeFrames.splice(_i5, 1);
                    iframeWindows.splice(_i5, 1);
                }
            }
            function linkFrameWindow(frame) {
                cleanIframes();
                if (frame && frame.contentWindow) try {
                    iframeWindows.push(frame.contentWindow);
                    iframeFrames.push(frame);
                } catch (err) {}
            }
            function getUserAgent(win) {
                win = win || window;
                return win.navigator.mockUserAgent || win.navigator.userAgent;
            }
            function getFrameByName(win, name) {
                for (var winFrames = getFrames(win), _iterator4 = winFrames, _isArray4 = Array.isArray(_iterator4), _i6 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                    var _ref4;
                    if (_isArray4) {
                        if (_i6 >= _iterator4.length) break;
                        _ref4 = _iterator4[_i6++];
                    } else {
                        _i6 = _iterator4.next();
                        if (_i6.done) break;
                        _ref4 = _i6.value;
                    }
                    var childFrame = _ref4;
                    try {
                        if (isSameDomain(childFrame) && childFrame.name === name && -1 !== winFrames.indexOf(childFrame)) return childFrame;
                    } catch (err) {}
                }
                try {
                    if (-1 !== winFrames.indexOf(win.frames[name])) return win.frames[name];
                } catch (err) {}
                try {
                    if (-1 !== winFrames.indexOf(win[name])) return win[name];
                } catch (err) {}
            }
            function findChildFrameByName(win, name) {
                var frame = getFrameByName(win, name);
                if (frame) return frame;
                for (var _iterator5 = getFrames(win), _isArray5 = Array.isArray(_iterator5), _i7 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator](); ;) {
                    var _ref5;
                    if (_isArray5) {
                        if (_i7 >= _iterator5.length) break;
                        _ref5 = _iterator5[_i7++];
                    } else {
                        _i7 = _iterator5.next();
                        if (_i7.done) break;
                        _ref5 = _i7.value;
                    }
                    var childFrame = _ref5, namedFrame = findChildFrameByName(childFrame, name);
                    if (namedFrame) return namedFrame;
                }
            }
            function findFrameByName(win, name) {
                var frame = void 0;
                frame = getFrameByName(win, name);
                return frame || findChildFrameByName(getTop(win) || win, name);
            }
            function isOpener(parent, child) {
                return parent === getOpener(child);
            }
            function getAncestor(win) {
                win = win || window;
                var opener = getOpener(win);
                if (opener) return opener;
                var parent = getParent(win);
                return parent || void 0;
            }
            function isAncestor(parent, child) {
                var actualParent = getAncestor(child);
                if (actualParent) return actualParent === parent;
                if (child === parent) return !1;
                if (getTop(child) === child) return !1;
                for (var _iterator7 = getFrames(parent), _isArray7 = Array.isArray(_iterator7), _i9 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator](); ;) {
                    var _ref7;
                    if (_isArray7) {
                        if (_i9 >= _iterator7.length) break;
                        _ref7 = _iterator7[_i9++];
                    } else {
                        _i9 = _iterator7.next();
                        if (_i9.done) break;
                        _ref7 = _i9.value;
                    }
                    if (_ref7 === child) return !0;
                }
                return !1;
            }
            function isPopup() {
                return Boolean(getOpener(window));
            }
            function isIframe() {
                return Boolean(getParent(window));
            }
            function anyMatch(collection1, collection2) {
                for (var _iterator8 = collection1, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator](); ;) {
                    var _ref8;
                    if (_isArray8) {
                        if (_i10 >= _iterator8.length) break;
                        _ref8 = _iterator8[_i10++];
                    } else {
                        _i10 = _iterator8.next();
                        if (_i10.done) break;
                        _ref8 = _i10.value;
                    }
                    for (var item1 = _ref8, _iterator9 = collection2, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator](); ;) {
                        var _ref9;
                        if (_isArray9) {
                            if (_i11 >= _iterator9.length) break;
                            _ref9 = _iterator9[_i11++];
                        } else {
                            _i11 = _iterator9.next();
                            if (_i11.done) break;
                            _ref9 = _i11.value;
                        }
                        if (item1 === _ref9) return !0;
                    }
                }
                return !1;
            }
            function getDistanceFromTop() {
                for (var win = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window, distance = 0, parent = win; parent; ) {
                    parent = getParent(parent);
                    parent && (distance += 1);
                }
                return distance;
            }
            function getNthParent(win) {
                for (var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, parent = win, i = 0; i < n; i++) {
                    if (!parent) return;
                    parent = getParent(parent);
                }
                return parent;
            }
            function getNthParentFromTop(win) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return getNthParent(win, getDistanceFromTop(win) - n);
            }
            function isSameTopWindow(win1, win2) {
                var top1 = getTop(win1) || win1, top2 = getTop(win2) || win2;
                try {
                    if (top1 && top2) return top1 === top2;
                } catch (err) {}
                var allFrames1 = getAllFramesInWindow(win1), allFrames2 = getAllFramesInWindow(win2);
                if (anyMatch(allFrames1, allFrames2)) return !0;
                var opener1 = getOpener(top1), opener2 = getOpener(top2);
                return (!opener1 || !anyMatch(getAllFramesInWindow(opener1), allFrames2)) && (opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1), 
                !1);
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return pattern === CONSTANTS.WILDCARD || origin === pattern;
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__.a)(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return Object(__WEBPACK_IMPORTED_MODULE_0__util__.a)(pattern) ? Object(__WEBPACK_IMPORTED_MODULE_0__util__.a)(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !Object(__WEBPACK_IMPORTED_MODULE_0__util__.a)(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function getDomainFromUrl(url) {
                var domain = void 0;
                if (!url.match(/^(https?|mock|file):\/\//)) return getDomain();
                domain = url;
                domain = domain.split("/").slice(0, 3).join("/");
                return domain;
            }
            function onCloseWindow(win, callback) {
                var delay = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3, maxtime = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0, timeout = void 0;
                !function check() {
                    if (isWindowClosed(win)) {
                        timeout && clearTimeout(timeout);
                        return callback();
                    }
                    if (maxtime <= 0) clearTimeout(timeout); else {
                        maxtime -= delay;
                        timeout = setTimeout(check, delay);
                    }
                }();
                return {
                    cancel: function() {
                        timeout && clearTimeout(timeout);
                    }
                };
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === Object.prototype.toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(obj === obj);
                } catch (err) {
                    return !0;
                }
                try {
                    Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)(obj && obj.__cross_domain_utils_window_check__);
                } catch (err) {
                    return !0;
                }
                return !1;
            }
            __webpack_exports__.q = isFileProtocol;
            __webpack_exports__.b = getActualDomain;
            __webpack_exports__.f = getDomain;
            __webpack_exports__.o = isActuallySameDomain;
            __webpack_exports__.u = isSameDomain;
            __webpack_exports__.l = getParent;
            __webpack_exports__.k = getOpener;
            __webpack_exports__.i = getFrames;
            __webpack_exports__.m = getTop;
            __webpack_exports__.c = getAllFramesInWindow;
            __webpack_exports__.w = isTop;
            __webpack_exports__.y = isWindowClosed;
            __webpack_exports__.z = linkFrameWindow;
            __webpack_exports__.n = getUserAgent;
            __webpack_exports__.h = getFrameByName;
            __webpack_exports__.a = findFrameByName;
            __webpack_exports__.s = isOpener;
            __webpack_exports__.d = getAncestor;
            __webpack_exports__.p = isAncestor;
            __webpack_exports__.t = isPopup;
            __webpack_exports__.r = isIframe;
            __webpack_exports__.e = getDistanceFromTop;
            __webpack_exports__.j = getNthParentFromTop;
            __webpack_exports__.v = isSameTopWindow;
            __webpack_exports__.A = matchDomain;
            __webpack_exports__.g = getDomainFromUrl;
            __webpack_exports__.B = onCloseWindow;
            __webpack_exports__.x = isWindow;
            var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/cross-domain-utils/src/util.js"), CONSTANTS = {
                MOCK_PROTOCOL: "mock:",
                FILE_PROTOCOL: "file:",
                WILDCARD: "*"
            }, IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n", iframeWindows = [], iframeFrames = [];
        },
        "./node_modules/cross-domain-utils/src/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isRegex(item) {
                return "[object RegExp]" === Object.prototype.toString.call(item);
            }
            function noop() {}
            __webpack_exports__.a = isRegex;
            __webpack_exports__.b = noop;
        },
        "./node_modules/hi-base32/src/base32.js": function(module, exports, __webpack_require__) {
            (function(process, global, module) {
                var __WEBPACK_AMD_DEFINE_RESULT__, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                /*
 * [hi-base32]{@link https://github.com/emn178/hi-base32}
 *
 * @version 0.3.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2017
 * @license MIT
 */
                !function() {
                    "use strict";
                    var root = "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)) ? window : {};
                    !root.HI_BASE32_NO_NODE_JS && "object" === (void 0 === process ? "undefined" : _typeof(process)) && process.versions && process.versions.node && (root = global);
                    var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && "object" === _typeof(module) && module.exports, AMD = __webpack_require__("./node_modules/webpack/buildin/amd-options.js"), BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), BASE32_DECODE_CHAR = {
                        A: 0,
                        B: 1,
                        C: 2,
                        D: 3,
                        E: 4,
                        F: 5,
                        G: 6,
                        H: 7,
                        I: 8,
                        J: 9,
                        K: 10,
                        L: 11,
                        M: 12,
                        N: 13,
                        O: 14,
                        P: 15,
                        Q: 16,
                        R: 17,
                        S: 18,
                        T: 19,
                        U: 20,
                        V: 21,
                        W: 22,
                        X: 23,
                        Y: 24,
                        Z: 25,
                        "2": 26,
                        "3": 27,
                        "4": 28,
                        "5": 29,
                        "6": 30,
                        "7": 31
                    }, blocks = [ 0, 0, 0, 0, 0, 0, 0, 0 ], toUtf8String = function(bytes) {
                        for (var b, c, str = "", length = bytes.length, i = 0, followingChars = 0; i < length; ) {
                            b = bytes[i++];
                            if (b <= 127) str += String.fromCharCode(b); else {
                                if (b > 191 && b <= 223) {
                                    c = 31 & b;
                                    followingChars = 1;
                                } else if (b <= 239) {
                                    c = 15 & b;
                                    followingChars = 2;
                                } else {
                                    if (!(b <= 247)) throw "not a UTF-8 string";
                                    c = 7 & b;
                                    followingChars = 3;
                                }
                                for (var j = 0; j < followingChars; ++j) {
                                    b = bytes[i++];
                                    if (b < 128 || b > 191) throw "not a UTF-8 string";
                                    c <<= 6;
                                    c += 63 & b;
                                }
                                if (c >= 55296 && c <= 57343) throw "not a UTF-8 string";
                                if (c > 1114111) throw "not a UTF-8 string";
                                if (c <= 65535) str += String.fromCharCode(c); else {
                                    c -= 65536;
                                    str += String.fromCharCode(55296 + (c >> 10));
                                    str += String.fromCharCode(56320 + (1023 & c));
                                }
                            }
                        }
                        return str;
                    }, decodeAsBytes = function(base32Str) {
                        base32Str = base32Str.replace(/=/g, "");
                        for (var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = base32Str.length, i = 0, count = length >> 3 << 3; i < count; ) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                            bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                            bytes[index++] = 255 & (v7 << 5 | v8);
                        }
                        var remain = length - count;
                        if (2 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                        } else if (4 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                        } else if (5 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                        } else if (7 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                            bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                        }
                        return bytes;
                    }, encodeAscii = function(str) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = str.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i++);
                            v5 = str.charCodeAt(i++);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) {
                            v1 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }, encodeUtf8 = function(str) {
                        var v1, v2, v3, v4, v5, code, i, end = !1, base32Str = "", index = 0, start = 0, bytes = 0, length = str.length;
                        do {
                            blocks[0] = blocks[5];
                            blocks[1] = blocks[6];
                            blocks[2] = blocks[7];
                            for (i = start; index < length && i < 5; ++index) {
                                code = str.charCodeAt(index);
                                if (code < 128) blocks[i++] = code; else if (code < 2048) {
                                    blocks[i++] = 192 | code >> 6;
                                    blocks[i++] = 128 | 63 & code;
                                } else if (code < 55296 || code >= 57344) {
                                    blocks[i++] = 224 | code >> 12;
                                    blocks[i++] = 128 | code >> 6 & 63;
                                    blocks[i++] = 128 | 63 & code;
                                } else {
                                    code = 65536 + ((1023 & code) << 10 | 1023 & str.charCodeAt(++index));
                                    blocks[i++] = 240 | code >> 18;
                                    blocks[i++] = 128 | code >> 12 & 63;
                                    blocks[i++] = 128 | code >> 6 & 63;
                                    blocks[i++] = 128 | 63 & code;
                                }
                            }
                            bytes += i - start;
                            start = i - 5;
                            index === length && ++index;
                            index > length && i < 6 && (end = !0);
                            v1 = blocks[0];
                            if (i > 4) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                v4 = blocks[3];
                                v5 = blocks[4];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                            } else if (1 === i) base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======"; else if (2 === i) {
                                v2 = blocks[1];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                            } else if (3 === i) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                            } else if (4 === i) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                v4 = blocks[3];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                            }
                        } while (!end);
                        return base32Str;
                    }, encodeBytes = function(bytes) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i++];
                            v5 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) {
                            v1 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }, encode = function(input, asciiOnly) {
                        var notString = "string" != typeof input;
                        notString && input.constructor === ArrayBuffer && (input = new Uint8Array(input));
                        return notString ? encodeBytes(input) : asciiOnly ? encodeAscii(input) : encodeUtf8(input);
                    }, decode = function(base32Str, asciiOnly) {
                        if (!asciiOnly) return toUtf8String(decodeAsBytes(base32Str));
                        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
                        -1 === length && (length = base32Str.length);
                        for (var i = 0, count = length >> 3 << 3; i < count; ) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3)) + String.fromCharCode(255 & (v7 << 5 | v8));
                        }
                        var remain = length - count;
                        if (2 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2));
                        } else if (4 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4));
                        } else if (5 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1));
                        } else if (7 === remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3));
                        }
                        return str;
                    }, exports = {
                        encode: encode,
                        decode: decode
                    };
                    decode.asBytes = decodeAsBytes;
                    if (COMMON_JS) module.exports = exports; else {
                        root.base32 = exports;
                        AMD && void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
                            return exports;
                        }.call(exports, __webpack_require__, exports, module)) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                    }
                }();
            }).call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module));
        },
        "./node_modules/post-robot/src/bridge/bridge.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function deleteTunnelWindow(id) {
                try {
                    __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows[id] && delete __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows[id].source;
                } catch (err) {}
                delete __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows[id];
            }
            function cleanTunnelWindows() {
                for (var tunnelWindows = __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows, _iterator = Object.keys(tunnelWindows), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref, tunnelWindow = tunnelWindows[key];
                    try {
                        Object(__WEBPACK_IMPORTED_MODULE_3__lib__.j)(tunnelWindow.source);
                    } catch (err) {
                        deleteTunnelWindow(key);
                        continue;
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(tunnelWindow.source) && deleteTunnelWindow(key);
                }
            }
            function addTunnelWindow(_ref2) {
                var name = _ref2.name, source = _ref2.source, canary = _ref2.canary, sendMessage = _ref2.sendMessage;
                cleanTunnelWindows();
                __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindowId += 1;
                __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows[__WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindowId] = {
                    name: name,
                    source: source,
                    canary: canary,
                    sendMessage: sendMessage
                };
                return __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindowId;
            }
            function getTunnelWindow(id) {
                return __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows[id];
            }
            var __WEBPACK_IMPORTED_MODULE_1__conf__ = (__webpack_require__("./node_modules/zalgo-promise/src/index.js"), 
            __webpack_require__("./node_modules/post-robot/src/conf/index.js")), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_5__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js");
            __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows = __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindows || {};
            __WEBPACK_IMPORTED_MODULE_4__global__.a.tunnelWindowId = 0;
            __WEBPACK_IMPORTED_MODULE_4__global__.a.openTunnelToParent = function(_ref3) {
                var name = _ref3.name, source = _ref3.source, canary = _ref3.canary, sendMessage = _ref3.sendMessage, parentWindow = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.l)(window);
                if (!parentWindow) throw new Error("No parent window found to open tunnel to");
                var id = addTunnelWindow({
                    name: name,
                    source: source,
                    canary: canary,
                    sendMessage: sendMessage
                });
                return Object(__WEBPACK_IMPORTED_MODULE_5__interface__.send)(parentWindow, __WEBPACK_IMPORTED_MODULE_1__conf__.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                    name: name,
                    sendMessage: function() {
                        var tunnelWindow = getTunnelWindow(id);
                        try {
                            Object(__WEBPACK_IMPORTED_MODULE_3__lib__.j)(tunnelWindow && tunnelWindow.source);
                        } catch (err) {
                            deleteTunnelWindow(id);
                            return;
                        }
                        if (tunnelWindow && tunnelWindow.source && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(tunnelWindow.source)) {
                            try {
                                tunnelWindow.canary();
                            } catch (err) {
                                return;
                            }
                            tunnelWindow.sendMessage.apply(this, arguments);
                        }
                    }
                }, {
                    domain: __WEBPACK_IMPORTED_MODULE_1__conf__.b.WILDCARD
                });
            };
        },
        "./node_modules/post-robot/src/bridge/child.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function openTunnelToOpener() {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    var opener = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.k)(window);
                    if (opener && Object(__WEBPACK_IMPORTED_MODULE_5__common__.e)({
                        win: opener
                    })) {
                        Object(__WEBPACK_IMPORTED_MODULE_5__common__.j)(opener);
                        return awaitRemoteBridgeForWindow(opener).then(function(bridge) {
                            return bridge ? window.name ? bridge[__WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_PROPS.POSTROBOT].openTunnelToParent({
                                name: window.name,
                                source: window,
                                canary: function() {},
                                sendMessage: function(message) {
                                    try {
                                        Object(__WEBPACK_IMPORTED_MODULE_3__lib__.j)(window);
                                    } catch (err) {
                                        return;
                                    }
                                    if (window && !window.closed) try {
                                        Object(__WEBPACK_IMPORTED_MODULE_4__drivers__.g)({
                                            data: message,
                                            origin: this.origin,
                                            source: this.source
                                        });
                                    } catch (err) {
                                        __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.reject(err);
                                    }
                                }
                            }).then(function(_ref2) {
                                var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                                if (source !== opener) throw new Error("Source does not match opener");
                                Object(__WEBPACK_IMPORTED_MODULE_5__common__.i)(source, origin, data.sendMessage);
                            }).catch(function(err) {
                                Object(__WEBPACK_IMPORTED_MODULE_5__common__.k)(opener, err);
                                throw err;
                            }) : Object(__WEBPACK_IMPORTED_MODULE_5__common__.k)(opener, new Error("Can not register with opener: window does not have a name")) : Object(__WEBPACK_IMPORTED_MODULE_5__common__.k)(opener, new Error("Can not register with opener: no bridge found in opener"));
                        });
                    }
                });
            }
            __webpack_exports__.a = openTunnelToOpener;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js"), awaitRemoteBridgeForWindow = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.q)(function(win) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.i)(win), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        var _frame = _ref;
                        try {
                            if (_frame && _frame !== window && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.u)(_frame) && _frame[__WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_PROPS.POSTROBOT]) return _frame;
                        } catch (err) {
                            continue;
                        }
                    }
                    try {
                        var frame = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.h)(win, Object(__WEBPACK_IMPORTED_MODULE_5__common__.c)(Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.f)()));
                        if (!frame) return;
                        return Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.u)(frame) && frame[__WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_PROPS.POSTROBOT] ? frame : new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve) {
                            var interval = void 0, timeout = void 0;
                            interval = setInterval(function() {
                                if (frame && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.u)(frame) && frame[__WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_PROPS.POSTROBOT]) {
                                    clearInterval(interval);
                                    clearTimeout(timeout);
                                    return resolve(frame);
                                }
                            }, 100);
                            timeout = setTimeout(function() {
                                clearInterval(interval);
                                return resolve();
                            }, 2e3);
                        });
                    } catch (err) {
                        return;
                    }
                });
            });
        },
        "./node_modules/post-robot/src/bridge/common.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function needsBridgeForBrowser() {
                return !!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.n)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !__WEBPACK_IMPORTED_MODULE_3__conf__.a.ALLOW_POSTMESSAGE_POPUP;
            }
            function needsBridgeForWin(win) {
                return !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.v)(window, win);
            }
            function needsBridgeForDomain(domain, win) {
                if (domain) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)() !== Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(domain)) return !0;
                } else if (win && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.u)(win)) return !0;
                return !1;
            }
            function needsBridge(_ref) {
                var win = _ref.win, domain = _ref.domain;
                return !!needsBridgeForBrowser() && (!(domain && !needsBridgeForDomain(domain, win)) && !(win && !needsBridgeForWin(win)));
            }
            function getBridgeName(domain) {
                domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(domain);
                var sanitizedDomain = domain.replace(/[^a-zA-Z0-9]+/g, "_");
                return __WEBPACK_IMPORTED_MODULE_3__conf__.b.BRIDGE_NAME_PREFIX + "_" + sanitizedDomain;
            }
            function isBridge() {
                return Boolean(window.name && window.name === getBridgeName(Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)()));
            }
            function registerRemoteWindow(win) {
                arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__conf__.a.BRIDGE_TIMEOUT;
                __WEBPACK_IMPORTED_MODULE_4__global__.a.remoteWindows.set(win, {
                    sendMessagePromise: new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a()
                });
            }
            function findRemoteWindow(win) {
                return __WEBPACK_IMPORTED_MODULE_4__global__.a.remoteWindows.get(win);
            }
            function registerRemoteSendMessage(win, domain, sendMessage) {
                var remoteWindow = findRemoteWindow(win);
                if (!remoteWindow) throw new Error("Window not found to register sendMessage to");
                var sendMessageWrapper = function(remoteWin, message, remoteDomain) {
                    if (remoteWin !== win) throw new Error("Remote window does not match window");
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.A)(remoteDomain, domain)) throw new Error("Remote domain " + remoteDomain + " does not match domain " + domain);
                    sendMessage(message);
                };
                remoteWindow.sendMessagePromise.resolve(sendMessageWrapper);
                remoteWindow.sendMessagePromise = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.resolve(sendMessageWrapper);
            }
            function rejectRemoteSendMessage(win, err) {
                var remoteWindow = findRemoteWindow(win);
                if (!remoteWindow) throw new Error("Window not found on which to reject sendMessage");
                remoteWindow.sendMessagePromise.asyncReject(err);
            }
            function sendBridgeMessage(win, message, domain) {
                var messagingChild = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.s)(window, win), messagingParent = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.s)(win, window);
                if (!messagingChild && !messagingParent) throw new Error("Can only send messages to and from parent and popup windows");
                var remoteWindow = findRemoteWindow(win);
                if (!remoteWindow) throw new Error("Window not found to send message to");
                return remoteWindow.sendMessagePromise.then(function(sendMessage) {
                    return sendMessage(win, message, domain);
                });
            }
            __webpack_exports__.f = needsBridgeForBrowser;
            __webpack_exports__.h = needsBridgeForWin;
            __webpack_exports__.g = needsBridgeForDomain;
            __webpack_exports__.e = needsBridge;
            __webpack_exports__.c = getBridgeName;
            __webpack_exports__.d = isBridge;
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return documentBodyReady;
            });
            __webpack_exports__.j = registerRemoteWindow;
            __webpack_exports__.b = findRemoteWindow;
            __webpack_exports__.i = registerRemoteSendMessage;
            __webpack_exports__.k = rejectRemoteSendMessage;
            __webpack_exports__.l = sendBridgeMessage;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_5__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), documentBodyReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            __WEBPACK_IMPORTED_MODULE_4__global__.a.remoteWindows = __WEBPACK_IMPORTED_MODULE_4__global__.a.remoteWindows || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
            __WEBPACK_IMPORTED_MODULE_4__global__.a.receiveMessage = function(event) {
                Object(__WEBPACK_IMPORTED_MODULE_5__drivers__.g)(event);
            };
        },
        "./node_modules/post-robot/src/bridge/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_1__child__ = (__webpack_require__("./node_modules/post-robot/src/bridge/bridge.js"), 
            __webpack_require__("./node_modules/post-robot/src/bridge/child.js"));
            __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() {
                return __WEBPACK_IMPORTED_MODULE_1__child__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js");
            __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.f;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.h;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.g;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.e;
            });
            __webpack_require__.d(__webpack_exports__, "getBridgeName", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.c;
            });
            __webpack_require__.d(__webpack_exports__, "isBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.d;
            });
            __webpack_require__.d(__webpack_exports__, "documentBodyReady", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.a;
            });
            __webpack_require__.d(__webpack_exports__, "registerRemoteWindow", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.j;
            });
            __webpack_require__.d(__webpack_exports__, "findRemoteWindow", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.b;
            });
            __webpack_require__.d(__webpack_exports__, "registerRemoteSendMessage", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.i;
            });
            __webpack_require__.d(__webpack_exports__, "rejectRemoteSendMessage", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.k;
            });
            __webpack_require__.d(__webpack_exports__, "sendBridgeMessage", function() {
                return __WEBPACK_IMPORTED_MODULE_2__common__.l;
            });
            var __WEBPACK_IMPORTED_MODULE_3__parent__ = __webpack_require__("./node_modules/post-robot/src/bridge/parent.js");
            __webpack_require__.d(__webpack_exports__, "hasBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_3__parent__.b;
            });
            __webpack_require__.d(__webpack_exports__, "openBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_3__parent__.d;
            });
            __webpack_require__.d(__webpack_exports__, "linkUrl", function() {
                return __WEBPACK_IMPORTED_MODULE_3__parent__.c;
            });
            __webpack_require__.d(__webpack_exports__, "destroyBridges", function() {
                return __WEBPACK_IMPORTED_MODULE_3__parent__.a;
            });
        },
        "./node_modules/post-robot/src/bridge/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/post-robot/src/bridge/index.js");
            __webpack_require__.d(__webpack_exports__, "openBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.openBridge;
            });
            __webpack_require__.d(__webpack_exports__, "linkUrl", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.linkUrl;
            });
            __webpack_require__.d(__webpack_exports__, "isBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.isBridge;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.needsBridge;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.needsBridgeForBrowser;
            });
            __webpack_require__.d(__webpack_exports__, "hasBridge", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.hasBridge;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.needsBridgeForWin;
            });
            __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.needsBridgeForDomain;
            });
            __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.openTunnelToOpener;
            });
            __webpack_require__.d(__webpack_exports__, "destroyBridges", function() {
                return __WEBPACK_IMPORTED_MODULE_0__index__.destroyBridges;
            });
        },
        "./node_modules/post-robot/src/bridge/parent.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function listenForRegister(source, domain) {
                Object(__WEBPACK_IMPORTED_MODULE_6__interface__.on)(__WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                    window: source,
                    domain: domain
                }, function(_ref) {
                    var origin = _ref.origin, data = _ref.data;
                    if (origin !== domain) throw new Error("Domain " + domain + " does not match origin " + origin);
                    if (!data.name) throw new Error("Register window expected to be passed window name");
                    if (!data.sendMessage) throw new Error("Register window expected to be passed sendMessage method");
                    if (!__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name]) throw new Error("Window with name " + data.name + " does not exist, or was not opened by this window");
                    if (!__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name].domain) throw new Error("We do not have a registered domain for window " + data.name);
                    if (__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name].domain !== origin) throw new Error("Message origin " + origin + " does not matched registered window origin " + __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name].domain);
                    Object(__WEBPACK_IMPORTED_MODULE_8__common__.i)(__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name].win, domain, data.sendMessage);
                    return {
                        sendMessage: function(message) {
                            if (window && !window.closed) {
                                var winDetails = __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[data.name];
                                if (winDetails) try {
                                    Object(__WEBPACK_IMPORTED_MODULE_7__drivers__.g)({
                                        data: message,
                                        origin: winDetails.domain,
                                        source: winDetails.win
                                    });
                                } catch (err) {
                                    __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.reject(err);
                                }
                            }
                        }
                    };
                });
            }
            function openBridgeFrame(name, url) {
                __WEBPACK_IMPORTED_MODULE_4__lib__.i.debug("Opening bridge:", name, url);
                var iframe = document.createElement("iframe");
                iframe.setAttribute("name", name);
                iframe.setAttribute("id", name);
                iframe.setAttribute("style", "display: none; margin: 0; padding: 0; border: 0px none; overflow: hidden;");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("border", "0");
                iframe.setAttribute("scrolling", "no");
                iframe.setAttribute("allowTransparency", "true");
                iframe.setAttribute("tabindex", "-1");
                iframe.setAttribute("hidden", "true");
                iframe.setAttribute("title", "");
                iframe.setAttribute("role", "presentation");
                iframe.src = url;
                return iframe;
            }
            function hasBridge(url, domain) {
                domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(url);
                return Boolean(__WEBPACK_IMPORTED_MODULE_5__global__.a.bridges[domain]);
            }
            function openBridge(url, domain) {
                domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(url);
                if (__WEBPACK_IMPORTED_MODULE_5__global__.a.bridges[domain]) return __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges[domain];
                __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges[domain] = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)() === domain) throw new Error("Can not open bridge on the same domain as current domain: " + domain);
                    var name = Object(__WEBPACK_IMPORTED_MODULE_8__common__.c)(domain);
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.h)(window, name)) throw new Error("Frame with name " + name + " already exists on page");
                    var iframe = openBridgeFrame(name, url);
                    __WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames[domain] = iframe;
                    return __WEBPACK_IMPORTED_MODULE_8__common__.a.then(function(body) {
                        body.appendChild(iframe);
                        var bridge = iframe.contentWindow;
                        listenForRegister(bridge, domain);
                        return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                            iframe.onload = resolve;
                            iframe.onerror = reject;
                        }).then(function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_4__lib__.k)(bridge, __WEBPACK_IMPORTED_MODULE_3__conf__.a.BRIDGE_TIMEOUT, "Bridge " + url);
                        }).then(function() {
                            return bridge;
                        });
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges[domain];
            }
            function linkUrl(win, url) {
                var winOptions = __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByWin.get(win);
                if (winOptions) {
                    winOptions.domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(url);
                    Object(__WEBPACK_IMPORTED_MODULE_8__common__.j)(win);
                }
            }
            function destroyBridges() {
                for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref3;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref3 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref3 = _i2.value;
                    }
                    var domain = _ref3, frame = __WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames[domain];
                    frame.parentNode && frame.parentNode.removeChild(frame);
                }
                __WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames = {};
                __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges = {};
            }
            __webpack_exports__.b = hasBridge;
            __webpack_exports__.d = openBridge;
            __webpack_exports__.c = linkUrl;
            __webpack_exports__.a = destroyBridges;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_5__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_6__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js"), __WEBPACK_IMPORTED_MODULE_7__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js");
            __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges = __WEBPACK_IMPORTED_MODULE_5__global__.a.bridges || {};
            __WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames = __WEBPACK_IMPORTED_MODULE_5__global__.a.bridgeFrames || {};
            __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByWin = __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByWin || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
            __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName = __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName || {};
            var windowOpen = window.open;
            window.open = function(url, name, options, last) {
                var domain = url;
                if (url && 0 === url.indexOf(__WEBPACK_IMPORTED_MODULE_3__conf__.b.MOCK_PROTOCOL)) {
                    var _url$split = url.split("|");
                    domain = _url$split[0];
                    url = _url$split[1];
                }
                domain && (domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(domain));
                var win = windowOpen.call(this, url, name, options, last);
                if (!win) return win;
                url && Object(__WEBPACK_IMPORTED_MODULE_8__common__.j)(win);
                for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref2 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref2 = _i.value;
                    }
                    var winName = _ref2;
                    Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(__WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[winName].win) && delete __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[winName];
                }
                if (name && win) {
                    var winOptions = __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByWin.get(win) || __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[name] || {};
                    winOptions.name = winOptions.name || name;
                    winOptions.win = winOptions.win || win;
                    winOptions.domain = winOptions.domain || domain;
                    __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByWin.set(win, winOptions);
                    __WEBPACK_IMPORTED_MODULE_5__global__.a.popupWindowsByName[name] = winOptions;
                }
                return win;
            };
        },
        "./node_modules/post-robot/src/clean.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function cleanUpWindow(win) {
                var requestPromises = __WEBPACK_IMPORTED_MODULE_0__global__.a.requestPromises.get(win);
                if (requestPromises) for (var _iterator = requestPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var promise = _ref;
                    promise.reject(new Error("No response from window - cleaned up"));
                }
                __WEBPACK_IMPORTED_MODULE_0__global__.a.popupWindowsByWin && __WEBPACK_IMPORTED_MODULE_0__global__.a.popupWindowsByWin.delete(win);
                __WEBPACK_IMPORTED_MODULE_0__global__.a.remoteWindows && __WEBPACK_IMPORTED_MODULE_0__global__.a.remoteWindows.delete(win);
                __WEBPACK_IMPORTED_MODULE_0__global__.a.requestPromises.delete(win);
                __WEBPACK_IMPORTED_MODULE_0__global__.a.methods.delete(win);
                __WEBPACK_IMPORTED_MODULE_0__global__.a.readyPromises.delete(win);
            }
            __webpack_exports__.a = cleanUpWindow;
            var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
        },
        "./node_modules/post-robot/src/compat/ie.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function emulateIERestrictions(sourceWindow, targetWindow) {
                if (!__WEBPACK_IMPORTED_MODULE_1__conf__.a.ALLOW_POSTMESSAGE_POPUP && !1 === Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.v)(sourceWindow, targetWindow)) throw new Error("Can not send and receive post messages between two different windows (disabled to emulate IE)");
            }
            __webpack_exports__.a = emulateIERestrictions;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
        },
        "./node_modules/post-robot/src/compat/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__ie__ = __webpack_require__("./node_modules/post-robot/src/compat/ie.js");
            __webpack_require__.d(__webpack_exports__, "emulateIERestrictions", function() {
                return __WEBPACK_IMPORTED_MODULE_0__ie__.a;
            });
        },
        "./node_modules/post-robot/src/conf/config.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return CONFIG;
            });
            var _ALLOWED_POST_MESSAGE, __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./node_modules/post-robot/src/conf/constants.js"), CONFIG = {
                ALLOW_POSTMESSAGE_POPUP: !("__ALLOW_POSTMESSAGE_POPUP__" in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
                LOG_LEVEL: "info",
                BRIDGE_TIMEOUT: 5e3,
                ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 2e3 : 1e3,
                RES_TIMEOUT: 1 / 0,
                LOG_TO_PAGE: !1,
                ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__.a.SEND_STRATEGIES.POST_MESSAGE] = !0, 
                _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__.a.SEND_STRATEGIES.BRIDGE] = !0, 
                _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__.a.SEND_STRATEGIES.GLOBAL] = !0, 
                _ALLOWED_POST_MESSAGE)
            };
            0 === window.location.href.indexOf(__WEBPACK_IMPORTED_MODULE_0__constants__.a.FILE_PROTOCOL) && (CONFIG.ALLOW_POSTMESSAGE_POPUP = !0);
        },
        "./node_modules/post-robot/src/conf/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return CONSTANTS;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return POST_MESSAGE_NAMES_LIST;
            });
            var CONSTANTS = {
                POST_MESSAGE_TYPE: {
                    REQUEST: "postrobot_message_request",
                    RESPONSE: "postrobot_message_response",
                    ACK: "postrobot_message_ack"
                },
                POST_MESSAGE_ACK: {
                    SUCCESS: "success",
                    ERROR: "error"
                },
                POST_MESSAGE_NAMES: {
                    METHOD: "postrobot_method",
                    READY: "postrobot_ready",
                    OPEN_TUNNEL: "postrobot_open_tunnel"
                },
                WINDOW_TYPES: {
                    FULLPAGE: "fullpage",
                    POPUP: "popup",
                    IFRAME: "iframe"
                },
                WINDOW_PROPS: {
                    POSTROBOT: "__postRobot__"
                },
                SERIALIZATION_TYPES: {
                    METHOD: "postrobot_method",
                    ERROR: "postrobot_error",
                    PROMISE: "postrobot_promise",
                    ZALGO_PROMISE: "postrobot_zalgo_promise",
                    REGEX: "regex"
                },
                SEND_STRATEGIES: {
                    POST_MESSAGE: "postrobot_post_message",
                    BRIDGE: "postrobot_bridge",
                    GLOBAL: "postrobot_global"
                },
                MOCK_PROTOCOL: "mock:",
                FILE_PROTOCOL: "file:",
                BRIDGE_NAME_PREFIX: "__postrobot_bridge__",
                POSTROBOT_PROXY: "__postrobot_proxy__",
                WILDCARD: "*"
            }, POST_MESSAGE_NAMES_LIST = Object.keys(CONSTANTS.POST_MESSAGE_NAMES).map(function(key) {
                return CONSTANTS.POST_MESSAGE_NAMES[key];
            });
        },
        "./node_modules/post-robot/src/conf/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/post-robot/src/conf/config.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__config__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./node_modules/post-robot/src/conf/constants.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.a;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.b;
            });
        },
        "./node_modules/post-robot/src/drivers/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__receive__ = __webpack_require__("./node_modules/post-robot/src/drivers/receive/index.js");
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_0__receive__.a;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_0__receive__.b;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_0__receive__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_1__send__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/index.js");
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_1__send__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__listeners__ = __webpack_require__("./node_modules/post-robot/src/drivers/listeners.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_2__listeners__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_2__listeners__.b;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_2__listeners__.c;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_2__listeners__.g;
            });
        },
        "./node_modules/post-robot/src/drivers/listeners.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function addResponseListener(hash, listener) {
                __WEBPACK_IMPORTED_MODULE_3__global__.a.responseListeners[hash] = listener;
            }
            function getResponseListener(hash) {
                return __WEBPACK_IMPORTED_MODULE_3__global__.a.responseListeners[hash];
            }
            function deleteResponseListener(hash) {
                delete __WEBPACK_IMPORTED_MODULE_3__global__.a.responseListeners[hash];
            }
            function markResponseListenerErrored(hash) {
                __WEBPACK_IMPORTED_MODULE_3__global__.a.erroredResponseListeners[hash] = !0;
            }
            function isResponseListenerErrored(hash) {
                return Boolean(__WEBPACK_IMPORTED_MODULE_3__global__.a.erroredResponseListeners[hash]);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                win === __WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD && (win = null);
                domain === __WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                var nameListeners = __WEBPACK_IMPORTED_MODULE_3__global__.a.requestListeners[name];
                if (nameListeners) for (var _arr = [ win, __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD ], _i = 0; _i < _arr.length; _i++) {
                    var winQualifier = _arr[_i], winListeners = winQualifier && nameListeners.get(winQualifier);
                    if (winListeners) {
                        if (domain && "string" == typeof domain) {
                            if (winListeners[domain]) return winListeners[domain];
                            if (winListeners[__DOMAIN_REGEX__]) for (var _iterator = winListeners[__DOMAIN_REGEX__], _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                                var _ref3;
                                if (_isArray) {
                                    if (_i2 >= _iterator.length) break;
                                    _ref3 = _iterator[_i2++];
                                } else {
                                    _i2 = _iterator.next();
                                    if (_i2.done) break;
                                    _ref3 = _i2.value;
                                }
                                var _ref4 = _ref3, regex = _ref4.regex, listener = _ref4.listener;
                                if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.A)(regex, domain)) return listener;
                            }
                        }
                        if (winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD]) return winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD];
                    }
                }
            }
            function addRequestListener(_ref5, listener) {
                var name = _ref5.name, win = _ref5.win, domain = _ref5.domain;
                if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                if (Array.isArray(win)) {
                    for (var listenersCollection = [], _iterator2 = win, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref6;
                        if (_isArray2) {
                            if (_i3 >= _iterator2.length) break;
                            _ref6 = _iterator2[_i3++];
                        } else {
                            _i3 = _iterator2.next();
                            if (_i3.done) break;
                            _ref6 = _i3.value;
                        }
                        var item = _ref6;
                        listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: item
                        }, listener));
                    }
                    return {
                        cancel: function() {
                            for (var _iterator3 = listenersCollection, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                                var _ref7;
                                if (_isArray3) {
                                    if (_i4 >= _iterator3.length) break;
                                    _ref7 = _iterator3[_i4++];
                                } else {
                                    _i4 = _iterator3.next();
                                    if (_i4.done) break;
                                    _ref7 = _i4.value;
                                }
                                _ref7.cancel();
                            }
                        }
                    };
                }
                if (Array.isArray(domain)) {
                    for (var _listenersCollection = [], _iterator4 = domain, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                        var _ref8;
                        if (_isArray4) {
                            if (_i5 >= _iterator4.length) break;
                            _ref8 = _iterator4[_i5++];
                        } else {
                            _i5 = _iterator4.next();
                            if (_i5.done) break;
                            _ref8 = _i5.value;
                        }
                        var _item = _ref8;
                        _listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _item
                        }, listener));
                    }
                    return {
                        cancel: function() {
                            for (var _iterator5 = _listenersCollection, _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator](); ;) {
                                var _ref9;
                                if (_isArray5) {
                                    if (_i6 >= _iterator5.length) break;
                                    _ref9 = _iterator5[_i6++];
                                } else {
                                    _i6 = _iterator5.next();
                                    if (_i6.done) break;
                                    _ref9 = _i6.value;
                                }
                                _ref9.cancel();
                            }
                        }
                    };
                }
                var existingListener = getRequestListener({
                    name: name,
                    win: win,
                    domain: domain
                });
                win && win !== __WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD || (win = __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD);
                domain = domain || __WEBPACK_IMPORTED_MODULE_5__conf__.b.WILDCARD;
                if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                var requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__.a.requestListeners, nameListeners = requestListeners[name];
                if (!nameListeners) {
                    nameListeners = new __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__.a();
                    requestListeners[name] = nameListeners;
                }
                var winListeners = nameListeners.get(win);
                if (!winListeners) {
                    winListeners = {};
                    nameListeners.set(win, winListeners);
                }
                var strDomain = domain.toString(), regexListeners = winListeners[__DOMAIN_REGEX__], regexListener = void 0;
                if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__.e)(domain)) {
                    if (!regexListeners) {
                        regexListeners = [];
                        winListeners[__DOMAIN_REGEX__] = regexListeners;
                    }
                    regexListener = {
                        regex: domain,
                        listener: listener
                    };
                    regexListeners.push(regexListener);
                } else winListeners[strDomain] = listener;
                return {
                    cancel: function() {
                        if (winListeners) {
                            delete winListeners[strDomain];
                            win && 0 === Object.keys(winListeners).length && nameListeners.delete(win);
                            regexListener && regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                        }
                    }
                };
            }
            __webpack_exports__.b = addResponseListener;
            __webpack_exports__.e = getResponseListener;
            __webpack_exports__.c = deleteResponseListener;
            __webpack_exports__.g = markResponseListenerErrored;
            __webpack_exports__.f = isResponseListenerErrored;
            __webpack_exports__.d = getRequestListener;
            __webpack_exports__.a = addRequestListener;
            var __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__ = (__webpack_require__("./node_modules/zalgo-promise/src/index.js"), 
            __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js")), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_5__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
            __WEBPACK_IMPORTED_MODULE_3__global__.a.responseListeners = __WEBPACK_IMPORTED_MODULE_3__global__.a.responseListeners || {};
            __WEBPACK_IMPORTED_MODULE_3__global__.a.requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__.a.requestListeners || {};
            __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD = __WEBPACK_IMPORTED_MODULE_3__global__.a.WINDOW_WILDCARD || new function() {}();
            __WEBPACK_IMPORTED_MODULE_3__global__.a.erroredResponseListeners = __WEBPACK_IMPORTED_MODULE_3__global__.a.erroredResponseListeners || {};
            var __DOMAIN_REGEX__ = "__domain_regex__";
        },
        "./node_modules/post-robot/src/drivers/receive/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function parseMessage(message) {
                var parsedMessage = void 0;
                try {
                    parsedMessage = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.f)(message);
                } catch (err) {
                    return;
                }
                if (parsedMessage && "object" === (void 0 === parsedMessage ? "undefined" : _typeof(parsedMessage)) && null !== parsedMessage) {
                    parsedMessage = parsedMessage[__WEBPACK_IMPORTED_MODULE_1__conf__.b.WINDOW_PROPS.POSTROBOT];
                    if (parsedMessage && "object" === (void 0 === parsedMessage ? "undefined" : _typeof(parsedMessage)) && null !== parsedMessage && parsedMessage.type && "string" == typeof parsedMessage.type && __WEBPACK_IMPORTED_MODULE_4__types__.a[parsedMessage.type]) return parsedMessage;
                }
            }
            function receiveMessage(event) {
                if (!window || window.closed) throw new Error("Message recieved in closed window");
                try {
                    if (!event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin, data = event.data, message = parseMessage(data);
                if (message) {
                    if (!message.sourceDomain || "string" != typeof message.sourceDomain) throw new Error("Expected message to have sourceDomain");
                    0 !== message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__.b.MOCK_PROTOCOL) && 0 !== message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__.b.FILE_PROTOCOL) || (origin = message.sourceDomain);
                    if (-1 === __WEBPACK_IMPORTED_MODULE_3__global__.a.receivedMessages.indexOf(message.id)) {
                        __WEBPACK_IMPORTED_MODULE_3__global__.a.receivedMessages.push(message.id);
                        var level = void 0;
                        level = -1 !== __WEBPACK_IMPORTED_MODULE_1__conf__.c.indexOf(message.name) || message.type === __WEBPACK_IMPORTED_MODULE_1__conf__.b.POST_MESSAGE_TYPE.ACK ? "debug" : "error" === message.ack ? "error" : "info";
                        __WEBPACK_IMPORTED_MODULE_2__lib__.i.logLevel(level, [ "\n\n\t", "#receive", message.type.replace(/^postrobot_message_/, ""), "::", message.name, "::", origin, "\n\n", message ]);
                        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.y)(source)) __WEBPACK_IMPORTED_MODULE_2__lib__.i.debug("Source window is closed - can not send " + message.type + " " + message.name); else {
                            message.data && (message.data = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.b)(source, origin, message.data));
                            __WEBPACK_IMPORTED_MODULE_4__types__.a[message.type](source, origin, message);
                        }
                    }
                }
            }
            function messageListener(event) {
                try {
                    event.source;
                } catch (err) {
                    return;
                }
                var messageEvent = {
                    source: event.source || event.sourceElement,
                    origin: event.origin || event.originalEvent && event.originalEvent.origin,
                    data: event.data
                };
                try {
                    __webpack_require__("./node_modules/post-robot/src/compat/index.js").emulateIERestrictions(messageEvent.source, window);
                } catch (err) {
                    return;
                }
                receiveMessage(messageEvent);
            }
            function listenForMessages() {
                Object(__WEBPACK_IMPORTED_MODULE_2__lib__.a)(window, "message", messageListener);
            }
            __webpack_exports__.c = receiveMessage;
            __webpack_exports__.b = messageListener;
            __webpack_exports__.a = listenForMessages;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__("./node_modules/post-robot/src/drivers/receive/types.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            __WEBPACK_IMPORTED_MODULE_3__global__.a.receivedMessages = __WEBPACK_IMPORTED_MODULE_3__global__.a.receivedMessages || [];
        },
        "./node_modules/post-robot/src/drivers/receive/types.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return RECEIVE_MESSAGE_TYPES;
            });
            var _RECEIVE_MESSAGE_TYPE, __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__send__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/index.js"), __WEBPACK_IMPORTED_MODULE_5__listeners__ = __webpack_require__("./node_modules/post-robot/src/drivers/listeners.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, RECEIVE_MESSAGE_TYPES = (_RECEIVE_MESSAGE_TYPE = {}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.ACK] = function(source, origin, message) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.f)(message.hash)) {
                    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.e)(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.A)(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                    options.ack = !0;
                }
            }, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.REQUEST] = function(source, origin, message) {
                function respond(data) {
                    return message.fireAndForget || Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.y)(source) ? __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve() : Object(__WEBPACK_IMPORTED_MODULE_4__send__.a)(source, _extends({
                        target: message.originalSource,
                        hash: message.hash,
                        name: message.name
                    }, data), origin);
                }
                var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.d)({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ respond({
                    type: __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.ACK
                }), __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.A)(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                    var data = message.data;
                    return options.handler({
                        source: source,
                        origin: origin,
                        data: data
                    });
                }).then(function(data) {
                    return respond({
                        type: __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.RESPONSE,
                        ack: __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_ACK.SUCCESS,
                        data: data
                    });
                }, function(err) {
                    var error = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.o)(err).replace(/^Error: /, "");
                    return respond({
                        type: __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.RESPONSE,
                        ack: __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_ACK.ERROR,
                        error: error
                    });
                }) ]).then(__WEBPACK_IMPORTED_MODULE_3__lib__.j).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    __WEBPACK_IMPORTED_MODULE_3__lib__.i.error(Object(__WEBPACK_IMPORTED_MODULE_3__lib__.o)(err));
                });
            }, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.RESPONSE] = function(source, origin, message) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.f)(message.hash)) {
                    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.e)(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.A)(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + options.domain);
                    Object(__WEBPACK_IMPORTED_MODULE_5__listeners__.c)(message.hash);
                    if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_ACK.ERROR) return options.respond(new Error(message.error), null);
                    if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_ACK.SUCCESS) {
                        var data = message.data || message.response;
                        return options.respond(null, {
                            source: source,
                            origin: origin,
                            data: data
                        });
                    }
                }
            }, _RECEIVE_MESSAGE_TYPE);
        },
        "./node_modules/post-robot/src/drivers/send/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function buildMessage(win, message) {
                var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, id = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.p)(), type = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.c)(), sourceDomain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.f)(window);
                return _extends({}, message, options, {
                    sourceDomain: sourceDomain,
                    id: message.id || id,
                    windowType: type
                });
            }
            function sendMessage(win, message, domain) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                    var _jsonStringify;
                    message = buildMessage(win, message, {
                        data: Object(__WEBPACK_IMPORTED_MODULE_3__lib__.n)(win, domain, message.data),
                        domain: domain
                    });
                    var level = void 0;
                    level = -1 !== __WEBPACK_IMPORTED_MODULE_2__conf__.c.indexOf(message.name) || message.type === __WEBPACK_IMPORTED_MODULE_2__conf__.b.POST_MESSAGE_TYPE.ACK ? "debug" : "error" === message.ack ? "error" : "info";
                    __WEBPACK_IMPORTED_MODULE_3__lib__.i.logLevel(level, [ "\n\n\t", "#send", message.type.replace(/^postrobot_message_/, ""), "::", message.name, "::", domain || __WEBPACK_IMPORTED_MODULE_2__conf__.b.WILDCARD, "\n\n", message ]);
                    if (win === window) throw new Error("Attemping to send message to self");
                    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.y)(win)) throw new Error("Window is closed");
                    __WEBPACK_IMPORTED_MODULE_3__lib__.i.debug("Running send message strategies", message);
                    var messages = [], serializedMessage = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.g)((_jsonStringify = {}, 
                    _jsonStringify[__WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_PROPS.POSTROBOT] = message, 
                    _jsonStringify), null, 2);
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.map(Object.keys(__WEBPACK_IMPORTED_MODULE_4__strategies__.a), function(strategyName) {
                        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                            if (!__WEBPACK_IMPORTED_MODULE_2__conf__.a.ALLOWED_POST_MESSAGE_METHODS[strategyName]) throw new Error("Strategy disallowed: " + strategyName);
                            return __WEBPACK_IMPORTED_MODULE_4__strategies__.a[strategyName](win, serializedMessage, domain);
                        }).then(function() {
                            messages.push(strategyName + ": success");
                            return !0;
                        }, function(err) {
                            messages.push(strategyName + ": " + Object(__WEBPACK_IMPORTED_MODULE_3__lib__.o)(err) + "\n");
                            return !1;
                        });
                    }).then(function(results) {
                        var success = results.some(Boolean), status = message.type + " " + message.name + " " + (success ? "success" : "error") + ":\n  - " + messages.join("\n  - ") + "\n";
                        __WEBPACK_IMPORTED_MODULE_3__lib__.i.debug(status);
                        if (!success) throw new Error(status);
                    });
                });
            }
            __webpack_exports__.a = sendMessage;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__strategies__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/strategies.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            };
        },
        "./node_modules/post-robot/src/drivers/send/strategies.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return SEND_MESSAGE_STRATEGIES;
            });
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__.b.SEND_STRATEGIES.POST_MESSAGE] = function(win, serializedMessage, domain) {
                try {
                    __webpack_require__("./node_modules/post-robot/src/compat/index.js").emulateIERestrictions(window, win);
                } catch (err) {
                    return;
                }
                var domains = void 0;
                domains = Array.isArray(domain) ? domain : domain ? [ domain ] : [ __WEBPACK_IMPORTED_MODULE_1__conf__.b.WILDCARD ];
                domains = domains.map(function(dom) {
                    if (0 === dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__.b.MOCK_PROTOCOL)) {
                        if (window.location.protocol === __WEBPACK_IMPORTED_MODULE_1__conf__.b.FILE_PROTOCOL) return __WEBPACK_IMPORTED_MODULE_1__conf__.b.WILDCARD;
                        if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.o)(win)) throw new Error("Attempting to send messsage to mock domain " + dom + ", but window is actually cross-domain");
                        return Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.b)(win);
                    }
                    return 0 === dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__.b.FILE_PROTOCOL) ? __WEBPACK_IMPORTED_MODULE_1__conf__.b.WILDCARD : dom;
                });
                domains.forEach(function(dom) {
                    return win.postMessage(serializedMessage, dom);
                });
            };
            var _require = __webpack_require__("./node_modules/post-robot/src/bridge/index.js"), sendBridgeMessage = _require.sendBridgeMessage, needsBridgeForBrowser = _require.needsBridgeForBrowser, isBridge = _require.isBridge;
            SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__.b.SEND_STRATEGIES.BRIDGE] = function(win, serializedMessage, domain) {
                if (needsBridgeForBrowser() || isBridge()) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.u)(win)) throw new Error("Post message through bridge disabled between same domain windows");
                    if (!1 !== Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.v)(window, win)) throw new Error("Can only use bridge to communicate between two different windows, not between frames");
                    return sendBridgeMessage(win, serializedMessage, domain);
                }
            };
            SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__.b.SEND_STRATEGIES.GLOBAL] = function(win, serializedMessage, domain) {
                if (needsBridgeForBrowser()) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.u)(win)) throw new Error("Post message through global disabled between different domain windows");
                    if (!1 !== Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.v)(window, win)) throw new Error("Can only use global to communicate between two different windows, not between frames");
                    var foreignGlobal = win[__WEBPACK_IMPORTED_MODULE_1__conf__.b.WINDOW_PROPS.POSTROBOT];
                    if (!foreignGlobal) throw new Error("Can not find postRobot global on foreign window");
                    return foreignGlobal.receiveMessage({
                        source: window,
                        origin: Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.f)(),
                        data: serializedMessage
                    });
                }
            };
        },
        "./node_modules/post-robot/src/global.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return global;
            });
            var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), global = window[__WEBPACK_IMPORTED_MODULE_0__conf__.b.WINDOW_PROPS.POSTROBOT] = window[__WEBPACK_IMPORTED_MODULE_0__conf__.b.WINDOW_PROPS.POSTROBOT] || {};
            global.registerSelf = function() {};
        },
        "./node_modules/post-robot/src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js");
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "init", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.init;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.bridge;
            });
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.Promise;
            });
            __webpack_require__.d(__webpack_exports__, "parent", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.parent;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.send;
            });
            __webpack_require__.d(__webpack_exports__, "request", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.request;
            });
            __webpack_require__.d(__webpack_exports__, "sendToParent", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.sendToParent;
            });
            __webpack_require__.d(__webpack_exports__, "client", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.client;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.on;
            });
            __webpack_require__.d(__webpack_exports__, "listen", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.listen;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.once;
            });
            __webpack_require__.d(__webpack_exports__, "listener", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.listener;
            });
            __webpack_require__.d(__webpack_exports__, "CONFIG", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.CONFIG;
            });
            __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.CONSTANTS;
            });
            __webpack_require__.d(__webpack_exports__, "disable", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.disable;
            });
            __webpack_exports__.default = __WEBPACK_IMPORTED_MODULE_0__interface__;
        },
        "./node_modules/post-robot/src/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function init() {
                if (!__WEBPACK_IMPORTED_MODULE_2__global__.a.initialized) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__drivers__.d)();
                    __webpack_require__("./node_modules/post-robot/src/bridge/index.js").openTunnelToOpener();
                    Object(__WEBPACK_IMPORTED_MODULE_0__lib__.d)();
                    Object(__WEBPACK_IMPORTED_MODULE_0__lib__.h)();
                }
                __WEBPACK_IMPORTED_MODULE_2__global__.a.initialized = !0;
            }
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            __webpack_exports__.init = init;
            __webpack_require__.d(__webpack_exports__, "bridge", function() {
                return bridge;
            });
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_3__clean__ = __webpack_require__("./node_modules/post-robot/src/clean.js");
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return __WEBPACK_IMPORTED_MODULE_3__clean__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_4__bridge_interface__ = __webpack_require__("./node_modules/post-robot/src/bridge/interface.js"), __WEBPACK_IMPORTED_MODULE_5__public__ = __webpack_require__("./node_modules/post-robot/src/public/index.js");
            __webpack_require__.d(__webpack_exports__, "parent", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.i;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.k;
            });
            __webpack_require__.d(__webpack_exports__, "request", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.j;
            });
            __webpack_require__.d(__webpack_exports__, "sendToParent", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.l;
            });
            __webpack_require__.d(__webpack_exports__, "client", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.c;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.g;
            });
            __webpack_require__.d(__webpack_exports__, "listen", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.e;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.h;
            });
            __webpack_require__.d(__webpack_exports__, "listener", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.f;
            });
            __webpack_require__.d(__webpack_exports__, "CONFIG", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.a;
            });
            __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.b;
            });
            __webpack_require__.d(__webpack_exports__, "disable", function() {
                return __WEBPACK_IMPORTED_MODULE_5__public__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_6_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return __WEBPACK_IMPORTED_MODULE_6_zalgo_promise_src__.a;
            });
            init();
            var bridge = __WEBPACK_IMPORTED_MODULE_4__bridge_interface__;
        },
        "./node_modules/post-robot/src/lib/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.a;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.b;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.c;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.d;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.e;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.f;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.g;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.i;
            });
            __webpack_require__.d(__webpack_exports__, "o", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.j;
            });
            __webpack_require__.d(__webpack_exports__, "p", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.k;
            });
            __webpack_require__.d(__webpack_exports__, "q", function() {
                return __WEBPACK_IMPORTED_MODULE_0__util__.l;
            });
            var __WEBPACK_IMPORTED_MODULE_1__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js");
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return __WEBPACK_IMPORTED_MODULE_1__log__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__serialize__ = __webpack_require__("./node_modules/post-robot/src/lib/serialize.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_2__serialize__.a;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_2__serialize__.b;
            });
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return __WEBPACK_IMPORTED_MODULE_2__serialize__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_3__ready__ = __webpack_require__("./node_modules/post-robot/src/lib/ready.js");
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_3__ready__.a;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_3__ready__.b;
            });
        },
        "./node_modules/post-robot/src/lib/log.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return log;
            });
            var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, LOG_LEVELS = [ "debug", "info", "warn", "error" ];
            Function.prototype.bind && window.console && "object" === _typeof(console.log) && [ "log", "info", "warn", "error" ].forEach(function(method) {
                console[method] = this.bind(console[method], console);
            }, Function.prototype.call);
            var log = {
                clearLogs: function() {
                    window.console && window.console.clear && window.console.clear();
                    if (__WEBPACK_IMPORTED_MODULE_1__conf__.a.LOG_TO_PAGE) {
                        var container = document.getElementById("postRobotLogs");
                        container && container.parentNode && container.parentNode.removeChild(container);
                    }
                },
                writeToPage: function(level, args) {
                    setTimeout(function() {
                        var container = document.getElementById("postRobotLogs");
                        if (!container) {
                            container = document.createElement("div");
                            container.id = "postRobotLogs";
                            container.style.cssText = "width: 800px; font-family: monospace; white-space: pre-wrap;";
                            document.body && document.body.appendChild(container);
                        }
                        var el = document.createElement("div"), date = new Date().toString().split(" ")[4], payload = Array.prototype.slice.call(args).map(function(item) {
                            if ("string" == typeof item) return item;
                            if (!item) return Object.prototype.toString.call(item);
                            var json = void 0;
                            try {
                                json = Object(__WEBPACK_IMPORTED_MODULE_0__util__.e)(item, null, 2);
                            } catch (e) {
                                json = "[object]";
                            }
                            return "\n\n" + json + "\n\n";
                        }).join(" "), msg = date + " " + level + " " + payload;
                        el.innerHTML = msg;
                        var color = {
                            log: "#ddd",
                            warn: "orange",
                            error: "red",
                            info: "blue",
                            debug: "#aaa"
                        }[level];
                        el.style.cssText = "margin-top: 10px; color: " + color + ";";
                        container.childNodes.length ? container.insertBefore(el, container.childNodes[0]) : container.appendChild(el);
                    });
                },
                logLevel: function(level, args) {
                    setTimeout(function() {
                        try {
                            var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_1__conf__.a.LOG_LEVEL;
                            if (LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(logLevel)) return;
                            args = Array.prototype.slice.call(args);
                            args.unshift("" + window.location.host + window.location.pathname);
                            args.unshift("::");
                            args.unshift("" + Object(__WEBPACK_IMPORTED_MODULE_0__util__.b)().toLowerCase());
                            args.unshift("[post-robot]");
                            __WEBPACK_IMPORTED_MODULE_1__conf__.a.LOG_TO_PAGE && log.writeToPage(level, args);
                            if (!window.console) return;
                            window.console[level] || (level = "log");
                            if (!window.console[level]) return;
                            window.console[level].apply(window.console, args);
                        } catch (err) {}
                    }, 1);
                },
                debug: function() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                    log.logLevel("debug", args);
                },
                info: function() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                    log.logLevel("info", args);
                },
                warn: function() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
                    log.logLevel("warn", args);
                },
                error: function() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
                    log.logLevel("error", args);
                }
            };
        },
        "./node_modules/post-robot/src/lib/ready.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function initOnReady() {
                Object(__WEBPACK_IMPORTED_MODULE_4__interface__.on)(__WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_NAMES.READY, {
                    domain: __WEBPACK_IMPORTED_MODULE_3__conf__.b.WILDCARD
                }, function(event) {
                    var win = event.source, promise = __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises.get(win);
                    if (promise) promise.resolve(event); else {
                        promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a().resolve(event);
                        __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises.set(win, promise);
                    }
                });
                var parent = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.d)();
                parent && Object(__WEBPACK_IMPORTED_MODULE_4__interface__.send)(parent, __WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_NAMES.READY, {}, {
                    domain: __WEBPACK_IMPORTED_MODULE_3__conf__.b.WILDCARD,
                    timeout: 1 / 0
                }).catch(function(err) {
                    __WEBPACK_IMPORTED_MODULE_5__log__.a.debug(Object(__WEBPACK_IMPORTED_MODULE_7__util__.j)(err));
                });
            }
            function onWindowReady(win) {
                var timeout = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3, name = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Window", promise = __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises.get(win);
                if (promise) return promise;
                promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a();
                __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises.set(win, promise);
                setTimeout(function() {
                    return promise.reject(new Error(name + " did not load after " + timeout + "ms"));
                }, timeout);
                return promise;
            }
            __webpack_exports__.a = initOnReady;
            __webpack_exports__.b = onWindowReady;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_4__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js"), __WEBPACK_IMPORTED_MODULE_5__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js"), __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");
            __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises = __WEBPACK_IMPORTED_MODULE_6__global__.a.readyPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
        },
        "./node_modules/post-robot/src/lib/serialize.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isSerialized(item, type) {
                return "object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item && item.__type__ === type;
            }
            function serializeMethod(destination, domain, method, name) {
                var id = Object(__WEBPACK_IMPORTED_MODULE_4__util__.k)(), methods = __WEBPACK_IMPORTED_MODULE_7__global__.a.methods.get(destination);
                if (!methods) {
                    methods = {};
                    __WEBPACK_IMPORTED_MODULE_7__global__.a.methods.set(destination, methods);
                }
                methods[id] = {
                    domain: domain,
                    method: method
                };
                return {
                    __type__: __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.METHOD,
                    __id__: id,
                    __name__: name
                };
            }
            function serializeError(err) {
                return {
                    __type__: __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.ERROR,
                    __message__: Object(__WEBPACK_IMPORTED_MODULE_4__util__.j)(err)
                };
            }
            function serializePromise(destination, domain, promise, name) {
                return {
                    __type__: __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.PROMISE,
                    __then__: serializeMethod(destination, domain, function(resolve, reject) {
                        return promise.then(resolve, reject);
                    }, name + ".then")
                };
            }
            function serializeZalgoPromise(destination, domain, promise, name) {
                return {
                    __type__: __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
                    __then__: serializeMethod(destination, domain, function(resolve, reject) {
                        return promise.then(resolve, reject);
                    }, name + ".then")
                };
            }
            function serializeRegex(regex) {
                return {
                    __type__: __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.REGEX,
                    __source__: regex.source
                };
            }
            function serializeMethods(destination, domain, obj) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util__.h)({
                    obj: obj
                }, function(item, key) {
                    return "function" == typeof item ? serializeMethod(destination, domain, item, key.toString()) : item instanceof Error ? serializeError(item) : window.Promise && item instanceof window.Promise ? serializePromise(destination, domain, item, key.toString()) : __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a.isPromise(item) ? serializeZalgoPromise(destination, domain, item, key.toString()) : Object(__WEBPACK_IMPORTED_MODULE_4__util__.c)(item) ? serializeRegex(item) : void 0;
                }).obj;
            }
            function deserializeMethod(source, origin, obj) {
                function wrapper() {
                    var args = Array.prototype.slice.call(arguments);
                    __WEBPACK_IMPORTED_MODULE_6__log__.a.debug("Call foreign method", obj.__name__, args);
                    return Object(__WEBPACK_IMPORTED_MODULE_5__interface__.send)(source, __WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_NAMES.METHOD, {
                        id: obj.__id__,
                        name: obj.__name__,
                        args: args
                    }, {
                        domain: origin,
                        timeout: 1 / 0
                    }).then(function(_ref2) {
                        var data = _ref2.data;
                        __WEBPACK_IMPORTED_MODULE_6__log__.a.debug("Got foreign method result", obj.__name__, data.result);
                        return data.result;
                    }, function(err) {
                        __WEBPACK_IMPORTED_MODULE_6__log__.a.debug("Got foreign method error", Object(__WEBPACK_IMPORTED_MODULE_4__util__.j)(err));
                        throw err;
                    });
                }
                wrapper.__name__ = obj.__name__;
                wrapper.__xdomain__ = !0;
                wrapper.source = source;
                wrapper.origin = origin;
                return wrapper;
            }
            function deserializeError(source, origin, obj) {
                return new Error(obj.__message__);
            }
            function deserializeZalgoPromise(source, origin, prom) {
                return new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a(function(resolve, reject) {
                    return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
                });
            }
            function deserializePromise(source, origin, prom) {
                return window.Promise ? new window.Promise(function(resolve, reject) {
                    return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
                }) : deserializeZalgoPromise(source, origin, prom);
            }
            function deserializeRegex(source, origin, item) {
                return new RegExp(item.__source__);
            }
            function deserializeMethods(source, origin, obj) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__util__.h)({
                    obj: obj
                }, function(item, key) {
                    if ("object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item) return isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.METHOD) ? deserializeMethod(source, origin, item) : isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.ERROR) ? deserializeError(source, origin, item) : isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.PROMISE) ? deserializePromise(source, origin, item) : isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? deserializeZalgoPromise(source, origin, item) : isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__.b.SERIALIZATION_TYPES.REGEX) ? deserializeRegex(source, origin, item) : void 0;
                }).obj;
            }
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return listenForMethods;
            });
            __webpack_exports__.c = serializeMethods;
            __webpack_exports__.a = deserializeMethods;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_5__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js"), __WEBPACK_IMPORTED_MODULE_6__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js"), __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__("./node_modules/post-robot/src/global.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            __WEBPACK_IMPORTED_MODULE_7__global__.a.methods = __WEBPACK_IMPORTED_MODULE_7__global__.a.methods || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
            var listenForMethods = Object(__WEBPACK_IMPORTED_MODULE_4__util__.g)(function() {
                Object(__WEBPACK_IMPORTED_MODULE_5__interface__.on)(__WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_NAMES.METHOD, {
                    origin: __WEBPACK_IMPORTED_MODULE_3__conf__.b.WILDCARD
                }, function(_ref) {
                    var source = _ref.source, origin = _ref.origin, data = _ref.data, methods = __WEBPACK_IMPORTED_MODULE_7__global__.a.methods.get(source);
                    if (!methods) throw new Error("Could not find any methods this window has privileges to call");
                    var meth = methods[data.id];
                    if (!meth) throw new Error("Could not find method with id: " + data.id);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.A)(meth.domain, origin)) throw new Error("Method domain " + meth.domain + " does not match origin " + origin);
                    __WEBPACK_IMPORTED_MODULE_6__log__.a.debug("Call local method", data.name, data.args);
                    return __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a.try(function() {
                        return meth.method.apply({
                            source: source,
                            origin: origin,
                            data: data
                        }, data.args);
                    }).then(function(result) {
                        return {
                            result: result,
                            id: data.id,
                            name: data.name
                        };
                    });
                });
            });
        },
        "./node_modules/post-robot/src/lib/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function stringifyError(err) {
                var level = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + Object.prototype.toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack, message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return "function" == typeof err.toString ? err.toString() : Object.prototype.toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function noop() {}
            function addEventListener(obj, event, handler) {
                obj.addEventListener ? obj.addEventListener(event, handler) : obj.attachEvent("on" + event, handler);
                return {
                    cancel: function() {
                        obj.removeEventListener ? obj.removeEventListener(event, handler) : obj.detachEvent("on" + event, handler);
                    }
                };
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                });
            }
            function eachArray(item, callback) {
                for (var i = 0; i < item.length; i++) callback(item[i], i);
            }
            function eachObject(item, callback) {
                for (var _key in item) item.hasOwnProperty(_key) && callback(item[_key], _key);
            }
            function each(item, callback) {
                Array.isArray(item) ? eachArray(item, callback) : "object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item && eachObject(item, callback);
            }
            function replaceObject(item, callback) {
                var depth = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                if (depth >= 100) throw new Error("Self-referential object passed, or object contained too many layers");
                var newobj = void 0;
                if ("object" !== (void 0 === item ? "undefined" : _typeof(item)) || null === item || Array.isArray(item)) {
                    if (!Array.isArray(item)) throw new Error("Invalid type: " + (void 0 === item ? "undefined" : _typeof(item)));
                    newobj = [];
                } else newobj = {};
                each(item, function(childItem, key) {
                    var result = callback(childItem, key);
                    void 0 !== result ? newobj[key] = result : "object" === (void 0 === childItem ? "undefined" : _typeof(childItem)) && null !== childItem ? newobj[key] = replaceObject(childItem, callback, depth + 1) : newobj[key] = childItem;
                });
                return newobj;
            }
            function safeInterval(method, time) {
                function runInterval() {
                    timeout = setTimeout(runInterval, time);
                    method.call();
                }
                var timeout = void 0;
                timeout = setTimeout(runInterval, time);
                return {
                    cancel: function() {
                        clearTimeout(timeout);
                    }
                };
            }
            function isRegex(item) {
                return "[object RegExp]" === Object.prototype.toString.call(item);
            }
            function getWindowType() {
                return Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.t)() ? __WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_TYPES.POPUP : Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.r)() ? __WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_TYPES.IFRAME : __WEBPACK_IMPORTED_MODULE_2__conf__.b.WINDOW_TYPES.FULLPAGE;
            }
            function jsonStringify(obj, replacer, indent) {
                var objectToJSON = void 0, arrayToJSON = void 0;
                try {
                    if ("{}" !== JSON.stringify({})) {
                        objectToJSON = Object.prototype.toJSON;
                        delete Object.prototype.toJSON;
                    }
                    if ("{}" !== JSON.stringify({})) throw new Error("Can not correctly serialize JSON objects");
                    if ("[]" !== JSON.stringify([])) {
                        arrayToJSON = Array.prototype.toJSON;
                        delete Array.prototype.toJSON;
                    }
                    if ("[]" !== JSON.stringify([])) throw new Error("Can not correctly serialize JSON objects");
                } catch (err) {
                    throw new Error("Can not repair JSON.stringify: " + err.message);
                }
                var result = JSON.stringify.call(this, obj, replacer, indent);
                try {
                    objectToJSON && (Object.prototype.toJSON = objectToJSON);
                    arrayToJSON && (Array.prototype.toJSON = arrayToJSON);
                } catch (err) {
                    throw new Error("Can not repair JSON.stringify: " + err.message);
                }
                return result;
            }
            function jsonParse(item) {
                return JSON.parse(item);
            }
            __webpack_exports__.j = stringifyError;
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return once;
            });
            __webpack_exports__.f = noop;
            __webpack_exports__.a = addEventListener;
            __webpack_exports__.k = uniqueID;
            __webpack_exports__.h = replaceObject;
            __webpack_exports__.i = safeInterval;
            __webpack_exports__.c = isRegex;
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return weakMapMemoize;
            });
            __webpack_exports__.b = getWindowType;
            __webpack_exports__.e = jsonStringify;
            __webpack_exports__.d = jsonParse;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, once = function(method) {
                if (!method) return method;
                var called = !1;
                return function() {
                    if (!called) {
                        called = !0;
                        return method.apply(this, arguments);
                    }
                };
            }, weakMapMemoize = function(method) {
                var weakmap = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
                return function(arg) {
                    var result = weakmap.get(arg);
                    if (void 0 !== result) return result;
                    result = method.call(this, arg);
                    void 0 !== result && weakmap.set(arg, result);
                    return result;
                };
            };
        },
        "./node_modules/post-robot/src/public/client.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function request(options) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                    if (!options.name) throw new Error("Expected options.name");
                    var name = options.name, targetWindow = void 0, domain = void 0;
                    if ("string" == typeof options.window) {
                        var el = document.getElementById(options.window);
                        if (!el) throw new Error("Expected options.window " + Object.prototype.toString.call(options.window) + " to be a valid element id");
                        if ("iframe" !== el.tagName.toLowerCase()) throw new Error("Expected options.window " + Object.prototype.toString.call(options.window) + " to be an iframe");
                        if (!el.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                        targetWindow = el.contentWindow;
                    } else if (options.window instanceof HTMLIFrameElement) {
                        if ("iframe" !== options.window.tagName.toLowerCase()) throw new Error("Expected options.window " + Object.prototype.toString.call(options.window) + " to be an iframe");
                        if (options.window && !options.window.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                        options.window && options.window.contentWindow && (targetWindow = options.window.contentWindow);
                    } else targetWindow = options.window;
                    if (!targetWindow) throw new Error("Expected options.window to be a window object, iframe, or iframe element id.");
                    var win = targetWindow;
                    domain = options.domain || __WEBPACK_IMPORTED_MODULE_3__conf__.b.WILDCARD;
                    var hash = options.name + "_" + Object(__WEBPACK_IMPORTED_MODULE_5__lib__.p)();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(win)) throw new Error("Target window is closed");
                    var hasResult = !1, requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__.a.requestPromises.get(win);
                    if (!requestPromises) {
                        requestPromises = [];
                        __WEBPACK_IMPORTED_MODULE_6__global__.a.requestPromises.set(win, requestPromises);
                    }
                    var requestPromise = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.p)(window, win)) return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.resolve(Object(__WEBPACK_IMPORTED_MODULE_5__lib__.k)(win));
                    }).then(function() {
                        return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                            var responseListener = void 0;
                            if (!options.fireAndForget) {
                                responseListener = {
                                    name: name,
                                    window: win,
                                    domain: domain,
                                    respond: function(err, result) {
                                        if (!err) {
                                            hasResult = !0;
                                            requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                                        }
                                        err ? reject(err) : resolve(result);
                                    }
                                };
                                Object(__WEBPACK_IMPORTED_MODULE_4__drivers__.b)(hash, responseListener);
                            }
                            Object(__WEBPACK_IMPORTED_MODULE_4__drivers__.h)(win, {
                                type: __WEBPACK_IMPORTED_MODULE_3__conf__.b.POST_MESSAGE_TYPE.REQUEST,
                                hash: hash,
                                name: name,
                                data: options.data,
                                fireAndForget: options.fireAndForget
                            }, domain).catch(reject);
                            if (options.fireAndForget) return resolve();
                            var ackTimeout = __WEBPACK_IMPORTED_MODULE_3__conf__.a.ACK_TIMEOUT, resTimeout = options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__.a.RES_TIMEOUT, cycleTime = 100, cycle = function cycle() {
                                if (!hasResult) {
                                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(win)) return reject(responseListener.ack ? new Error("Window closed for " + name + " before response") : new Error("Window closed for " + name + " before ack"));
                                    ackTimeout -= cycleTime;
                                    resTimeout -= cycleTime;
                                    if (responseListener.ack) {
                                        if (resTimeout === 1 / 0) return;
                                        cycleTime = Math.min(resTimeout, 2e3);
                                    } else {
                                        if (ackTimeout <= 0) return reject(new Error("No ack for postMessage " + name + " in " + Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)() + " in " + __WEBPACK_IMPORTED_MODULE_3__conf__.a.ACK_TIMEOUT + "ms"));
                                        if (resTimeout <= 0) return reject(new Error("No response for postMessage " + name + " in " + Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)() + " in " + (options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__.a.RES_TIMEOUT) + "ms"));
                                    }
                                    setTimeout(cycle, cycleTime);
                                }
                            };
                            setTimeout(cycle, cycleTime);
                        });
                    });
                    requestPromise.catch(function() {
                        Object(__WEBPACK_IMPORTED_MODULE_4__drivers__.e)(hash);
                        Object(__WEBPACK_IMPORTED_MODULE_4__drivers__.c)(hash);
                    });
                    requestPromises.push(requestPromise);
                    return requestPromise;
                });
            }
            function _send(window, name, data, options) {
                options = options || {};
                options.window = window;
                options.name = name;
                options.data = data;
                return request(options);
            }
            function sendToParent(name, data, options) {
                var win = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.d)();
                return win ? _send(win, name, data, options) : new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    return reject(new Error("Window does not have a parent"));
                });
            }
            function client() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!options.window) throw new Error("Expected options.window");
                var win = options.window;
                return {
                    send: function(name, data) {
                        return _send(win, name, data, options);
                    }
                };
            }
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return _send;
            });
            __webpack_exports__.b = request;
            __webpack_exports__.d = sendToParent;
            __webpack_exports__.a = client;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_4__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
            __WEBPACK_IMPORTED_MODULE_6__global__.a.requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__.a.requestPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
        },
        "./node_modules/post-robot/src/public/config.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function disable() {
                delete window[__WEBPACK_IMPORTED_MODULE_0__conf__.b.WINDOW_PROPS.POSTROBOT];
                window.removeEventListener("message", __WEBPACK_IMPORTED_MODULE_1__drivers__.f);
            }
            __webpack_exports__.c = disable;
            var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__conf__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_0__conf__.b;
            });
        },
        "./node_modules/post-robot/src/public/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return parent;
            });
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("./node_modules/post-robot/src/public/client.js");
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_1__client__.a;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_1__client__.b;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_1__client__.c;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_1__client__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_2__server__ = __webpack_require__("./node_modules/post-robot/src/public/server.js");
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_2__server__.a;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_2__server__.b;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_2__server__.c;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_2__server__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./node_modules/post-robot/src/public/config.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_3__config__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_3__config__.b;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_3__config__.c;
            });
            var parent = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.d)();
        },
        "./node_modules/post-robot/src/public/server.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function listen(options) {
                if (!options.name) throw new Error("Expected options.name");
                if (!options.handler) throw new Error("Expected options.handler");
                var name = options.name, win = options.window, domain = options.domain, listenerOptions = {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || __WEBPACK_IMPORTED_MODULE_4__conf__.b.WILDCARD,
                    name: name
                }, requestListener = Object(__WEBPACK_IMPORTED_MODULE_3__drivers__.a)({
                    name: name,
                    win: win,
                    domain: domain
                }, listenerOptions);
                if (options.once) {
                    var _handler = listenerOptions.handler;
                    listenerOptions.handler = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.l)(function() {
                        requestListener.cancel();
                        return _handler.apply(this, arguments);
                    });
                }
                if (listenerOptions.window && options.errorOnClose) var interval = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.m)(function() {
                    if (win && "object" === (void 0 === win ? "undefined" : _typeof(win)) && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.y)(win)) {
                        interval.cancel();
                        listenerOptions.handleError(new Error("Post message target window is closed"));
                    }
                }, 50);
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function _on(name, options, handler) {
                if ("function" == typeof options) {
                    handler = options;
                    options = {};
                }
                options = options || {};
                options.name = name;
                options.handler = handler || options.handler;
                return listen(options);
            }
            function once(name) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, handler = arguments[2];
                if ("function" == typeof options) {
                    handler = options;
                    options = {};
                }
                options = options || {};
                handler = handler || options.handler;
                var errorHandler = options.errorHandler, promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    options = options || {};
                    options.name = name;
                    options.once = !0;
                    options.handler = function(event) {
                        resolve(event);
                        if (handler) return handler(event);
                    };
                    options.errorHandler = function(err) {
                        reject(err);
                        if (errorHandler) return errorHandler(err);
                    };
                }), onceListener = listen(options);
                promise.cancel = onceListener.cancel;
                return promise;
            }
            function listener() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return {
                    on: function(name, handler) {
                        return _on(name, options, handler);
                    }
                };
            }
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return _on;
            });
            __webpack_exports__.a = listen;
            __webpack_exports__.d = once;
            __webpack_exports__.b = listener;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_3__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_4__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        },
        "./node_modules/process/browser.js": function(module, exports) {
            function defaultSetTimout() {
                throw new Error("setTimeout has not been defined");
            }
            function defaultClearTimeout() {
                throw new Error("clearTimeout has not been defined");
            }
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            function cleanUpNextTick() {
                if (draining && currentQueue) {
                    draining = !1;
                    currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1;
                    queue.length && drainQueue();
                }
            }
            function drainQueue() {
                if (!draining) {
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = !0;
                    for (var len = queue.length; len; ) {
                        currentQueue = queue;
                        queue = [];
                        for (;++queueIndex < len; ) currentQueue && currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = !1;
                    runClearTimeout(timeout);
                }
            }
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            function noop() {}
            var cachedSetTimeout, cachedClearTimeout, process = module.exports = {};
            !function() {
                try {
                    cachedSetTimeout = "function" == typeof setTimeout ? setTimeout : defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    cachedClearTimeout = "function" == typeof clearTimeout ? clearTimeout : defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            }();
            var currentQueue, queue = [], draining = !1, queueIndex = -1;
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                1 !== queue.length || draining || runTimeout(drainQueue);
            };
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = "browser";
            process.browser = !0;
            process.env = {};
            process.argv = [];
            process.version = "";
            process.versions = {};
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
            process.listeners = function(name) {
                return [];
            };
            process.binding = function(name) {
                throw new Error("process.binding is not supported");
            };
            process.cwd = function() {
                return "/";
            };
            process.chdir = function(dir) {
                throw new Error("process.chdir is not supported");
            };
            process.umask = function() {
                return 0;
            };
        },
        "./node_modules/webpack/buildin/amd-define.js": function(module, exports) {
            module.exports = function() {
                throw new Error("define cannot be used indirect");
            };
        },
        "./node_modules/webpack/buildin/amd-options.js": function(module, exports) {
            (function(__webpack_amd_options__) {
                module.exports = __webpack_amd_options__;
            }).call(exports, {});
        },
        "./node_modules/webpack/buildin/global.js": function(module, exports) {
            var g, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            g = function() {
                return this;
            }();
            try {
                g = g || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)) && (g = window);
            }
            module.exports = g;
        },
        "./node_modules/webpack/buildin/module.js": function(module, exports) {
            module.exports = function(module) {
                if (!module.webpackPolyfill) {
                    module.deprecate = function() {};
                    module.paths = [];
                    module.children || (module.children = []);
                    Object.defineProperty(module, "loaded", {
                        enumerable: !0,
                        get: function() {
                            return module.l;
                        }
                    });
                    Object.defineProperty(module, "id", {
                        enumerable: !0,
                        get: function() {
                            return module.i;
                        }
                    });
                    module.webpackPolyfill = 1;
                }
                return module;
            };
        },
        "./node_modules/xcomponent/node_modules/hi-base32/src/base32.js": function(module, exports, __webpack_require__) {
            (function(global) {
                !function(root, undefined) {
                    "use strict";
                    var NODE_JS = void 0 !== module;
                    NODE_JS && (root = global);
                    var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), BASE32_DECODE_CHAR = {
                        A: 0,
                        B: 1,
                        C: 2,
                        D: 3,
                        E: 4,
                        F: 5,
                        G: 6,
                        H: 7,
                        I: 8,
                        J: 9,
                        K: 10,
                        L: 11,
                        M: 12,
                        N: 13,
                        O: 14,
                        P: 15,
                        Q: 16,
                        R: 17,
                        S: 18,
                        T: 19,
                        U: 20,
                        V: 21,
                        W: 22,
                        X: 23,
                        Y: 24,
                        Z: 25,
                        "2": 26,
                        "3": 27,
                        "4": 28,
                        "5": 29,
                        "6": 30,
                        "7": 31
                    }, blocks = [ 0, 0, 0, 0, 0, 0, 0, 0 ], toUtf8String = function(bytes) {
                        for (var b, c, str = "", length = bytes.length, i = 0, followingChars = 0; i < length; ) {
                            b = bytes[i++];
                            if (b <= 127) str += String.fromCharCode(b); else {
                                if (b > 191 && b <= 223) {
                                    c = 31 & b;
                                    followingChars = 1;
                                } else if (b <= 239) {
                                    c = 15 & b;
                                    followingChars = 2;
                                } else {
                                    if (!(b <= 247)) throw "not a UTF-8 string";
                                    c = 7 & b;
                                    followingChars = 3;
                                }
                                for (var j = 0; j < followingChars; ++j) {
                                    b = bytes[i++];
                                    if (b < 128 || b > 191) throw "not a UTF-8 string";
                                    c <<= 6;
                                    c += 63 & b;
                                }
                                if (c >= 55296 && c <= 57343) throw "not a UTF-8 string";
                                if (c > 1114111) throw "not a UTF-8 string";
                                if (c <= 65535) str += String.fromCharCode(c); else {
                                    c -= 65536;
                                    str += String.fromCharCode(55296 + (c >> 10));
                                    str += String.fromCharCode(56320 + (1023 & c));
                                }
                            }
                        }
                        return str;
                    }, decodeAsBytes = function(base32Str) {
                        base32Str = base32Str.replace(/=/g, "");
                        for (var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = base32Str.length, i = 0, count = length >> 3 << 3; i < count; ) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                            bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                            bytes[index++] = 255 & (v7 << 5 | v8);
                        }
                        var remain = length - count;
                        if (2 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                        } else if (4 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                        } else if (5 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                        } else if (7 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                            bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                            bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                            bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                        }
                        return bytes;
                    }, encodeAscii = function(str) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = str.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i++);
                            v5 = str.charCodeAt(i++);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 == remain) {
                            v1 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 == remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 == remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 == remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }, encodeUtf8 = function(str) {
                        var v1, v2, v3, v4, v5, code, i, end = !1, base32Str = "", index = 0, start = 0, bytes = 0, length = str.length;
                        do {
                            blocks[0] = blocks[5];
                            blocks[1] = blocks[6];
                            blocks[2] = blocks[7];
                            for (i = start; index < length && i < 5; ++index) {
                                code = str.charCodeAt(index);
                                if (code < 128) blocks[i++] = code; else if (code < 2048) {
                                    blocks[i++] = 192 | code >> 6;
                                    blocks[i++] = 128 | 63 & code;
                                } else if (code < 55296 || code >= 57344) {
                                    blocks[i++] = 224 | code >> 12;
                                    blocks[i++] = 128 | code >> 6 & 63;
                                    blocks[i++] = 128 | 63 & code;
                                } else {
                                    code = 65536 + ((1023 & code) << 10 | 1023 & str.charCodeAt(++index));
                                    blocks[i++] = 240 | code >> 18;
                                    blocks[i++] = 128 | code >> 12 & 63;
                                    blocks[i++] = 128 | code >> 6 & 63;
                                    blocks[i++] = 128 | 63 & code;
                                }
                            }
                            bytes += i - start;
                            start = i - 5;
                            index == length && ++index;
                            index > length && i < 6 && (end = !0);
                            v1 = blocks[0];
                            if (i > 4) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                v4 = blocks[3];
                                v5 = blocks[4];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                            } else if (1 == i) base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======"; else if (2 == i) {
                                v2 = blocks[1];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                            } else if (3 == i) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                            } else if (4 == i) {
                                v2 = blocks[1];
                                v3 = blocks[2];
                                v4 = blocks[3];
                                base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                            }
                        } while (!end);
                        return base32Str;
                    }, encodeBytes = function(bytes) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i++];
                            v5 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 == remain) {
                            v1 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 == remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 == remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 == remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }, encode = function(input, asciiOnly) {
                        var notString = "string" != typeof input;
                        notString && input.constructor == ArrayBuffer && (input = new Uint8Array(input));
                        return notString ? encodeBytes(input) : asciiOnly ? encodeAscii(input) : encodeUtf8(input);
                    }, decode = function(base32Str, asciiOnly) {
                        if (!asciiOnly) return toUtf8String(decodeAsBytes(base32Str));
                        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
                        -1 == length && (length = base32Str.length);
                        for (var i = 0, count = length >> 3 << 3; i < count; ) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3)) + String.fromCharCode(255 & (v7 << 5 | v8));
                        }
                        var remain = length - count;
                        if (2 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2));
                        } else if (4 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4));
                        } else if (5 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1));
                        } else if (7 == remain) {
                            v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                            str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3));
                        }
                        return str;
                    };
                    decode.asBytes = decodeAsBytes;
                    var exports = {
                        encode: encode,
                        decode: decode
                    };
                    root.HI_BASE32_TEST && (exports.toUtf8String = toUtf8String);
                    !root.HI_BASE32_TEST && NODE_JS ? module.exports = exports : root && (root.base32 = exports);
                }(this);
            }).call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"));
        },
        "./node_modules/xcomponent/src/component/base.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function cleanup(obj) {
                var tasks = [], cleaned = !1;
                return {
                    set: function(name, item) {
                        if (cleaned) return item;
                        obj[name] = item;
                        this.register(function() {
                            delete obj[name];
                        });
                        return item;
                    },
                    register: function(name, method) {
                        if ("function" == typeof name) {
                            method = name;
                            name = "<anonymous-cleanup-handler>";
                        }
                        if ("function" != typeof method) throw new Error("Expected to be passed function to clean.register");
                        cleaned ? method() : tasks.push({
                            complete: !1,
                            name: name,
                            run: function() {
                                if (!this.complete) {
                                    this.complete = !0;
                                    method && method();
                                }
                            }
                        });
                    },
                    hasTasks: function() {
                        return Boolean(tasks.filter(function(item) {
                            return !item.complete;
                        }).length);
                    },
                    all: function() {
                        var results = [];
                        cleaned = !0;
                        for (;tasks.length; ) results.push(tasks.pop().run());
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all(results).then(function() {});
                    },
                    run: function(name) {
                        for (var results = [], _iterator = tasks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            var item = _ref;
                            item.name === name && results.push(item.run());
                        }
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all(results).then(function() {});
                    }
                };
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return BaseComponent;
            });
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), BaseComponent = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            function() {
                function BaseComponent() {
                    _classCallCheck(this, BaseComponent);
                    this.clean = cleanup(this);
                    this.event = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.s)();
                }
                BaseComponent.prototype.addProp = function(options, name, def) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__lib__.g)(options, this, name, def);
                };
                BaseComponent.prototype.on = function(eventName, handler) {
                    return this.event.on(eventName, handler);
                };
                BaseComponent.prototype.listeners = function() {
                    throw new Error("Expected listeners to be implemented");
                };
                BaseComponent.prototype.error = function(err) {
                    throw new Error("Expected error to be implemented - got " + Object(__WEBPACK_IMPORTED_MODULE_2__lib__.X)(err));
                };
                BaseComponent.prototype.listen = function(win, domain) {
                    var _this = this;
                    if (!win) throw this.component.createError("window to listen to not set");
                    if (!domain) throw new Error("Must pass domain to listen to");
                    if (this.listeners) for (var listeners = this.listeners(), _iterator2 = Object.keys(listeners), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2, _ret = function() {
                            if (_isArray2) {
                                if (_i2 >= _iterator2.length) return "break";
                                _ref2 = _iterator2[_i2++];
                            } else {
                                _i2 = _iterator2.next();
                                if (_i2.done) return "break";
                                _ref2 = _i2.value;
                            }
                            var listenerName = _ref2, name = listenerName.replace(/^xcomponent_/, ""), listener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.on)(listenerName, {
                                window: win,
                                domain: domain,
                                errorHandler: function(err) {
                                    _this.error(err);
                                }
                            }, function(_ref3) {
                                var source = _ref3.source, data = _ref3.data;
                                _this.component.log("listener_" + name);
                                return listeners[listenerName].call(_this, source, data);
                            }), errorListener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.on)(listenerName, {
                                window: win,
                                errorHandler: function(err) {
                                    _this.error(err);
                                }
                            }, function(_ref4) {
                                var origin = _ref4.origin;
                                _ref4.data;
                                _this.component.logError("unexpected_listener_" + name, {
                                    origin: origin,
                                    domain: domain.toString()
                                });
                                _this.error(new Error("Unexpected " + name + " message from domain " + origin + " -- expected message from " + domain.toString()));
                            });
                            _this.clean.register(function() {
                                listener.cancel();
                                errorListener.cancel();
                            });
                        }();
                        if ("break" === _ret) break;
                    }
                };
                return BaseComponent;
            }());
        },
        "./node_modules/xcomponent/src/component/child/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return ChildComponent;
            });
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js"), __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js"), __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), __WEBPACK_IMPORTED_MODULE_8__props__ = __webpack_require__("./node_modules/xcomponent/src/component/child/props.js"), __WEBPACK_IMPORTED_MODULE_9__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js"), _extends = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/component/props.js"), 
            Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, ChildComponent = function(_BaseComponent) {
                function ChildComponent(component) {
                    _classCallCheck(this, ChildComponent);
                    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));
                    _this.component = component;
                    if (!_this.hasValidParentDomain()) {
                        _this.error(new __WEBPACK_IMPORTED_MODULE_9__error__.c("Can not be rendered by domain: " + _this.getParentDomain()));
                        return _possibleConstructorReturn(_this);
                    }
                    _this.sendLogsToOpener();
                    _this.component.log("construct_child");
                    _this.onPropHandlers = [];
                    _this.setProps(_this.getInitialProps(), Object(__WEBPACK_IMPORTED_MODULE_5__window__.d)());
                    _this.props.logLevel && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.S)(_this.props.logLevel);
                    _this.component.log("init_child");
                    _this.setWindows();
                    _this.listenForResize();
                    _this.onInit = _this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.INIT, {
                        exports: _this.exports()
                    }).then(function(_ref) {
                        var origin = _ref.origin, data = _ref.data;
                        _this.context = data.context;
                        _this.setProps(data.props, origin);
                        _this.watchForResize();
                        return _this;
                    }).catch(function(err) {
                        _this.error(err);
                        throw err;
                    });
                    return _this;
                }
                _inherits(ChildComponent, _BaseComponent);
                ChildComponent.prototype.listenForResize = function() {
                    var _this2 = this;
                    window.addEventListener("resize", function() {
                        _this2.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.ONRESIZE, {}, {
                            fireAndForget: !0
                        });
                    });
                };
                ChildComponent.prototype.hasValidParentDomain = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.A)(this.component.allowedParentDomains, this.getParentDomain());
                };
                ChildComponent.prototype.init = function() {
                    return this.onInit;
                };
                ChildComponent.prototype.getParentDomain = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__window__.d)();
                };
                ChildComponent.prototype.onProps = function(handler) {
                    this.onPropHandlers.push(handler);
                };
                ChildComponent.prototype.getParentComponentWindow = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)();
                };
                ChildComponent.prototype.getParentRenderWindow = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__window__.e)();
                };
                ChildComponent.prototype.getInitialProps = function() {
                    var _this3 = this, componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__.b)(), props = componentMeta.props;
                    if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__.INITIAL_PROPS.RAW) props = props.value; else {
                        if (props.type !== __WEBPACK_IMPORTED_MODULE_7__constants__.INITIAL_PROPS.UID) throw new Error("Unrecognized props type: " + props.type);
                        var parentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)();
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.u)(parentComponentWindow)) {
                            if ("file:" === window.location.protocol) throw new Error("Can not get props from file:// domain");
                            throw new Error("Parent component window is on a different domain - expected " + Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.f)() + " - can not retrieve props");
                        }
                        var global = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.z)(parentComponentWindow);
                        if (!global) throw new Error("Can not find global for parent component - can not retrieve props");
                        props = global.props[componentMeta.uid];
                    }
                    if (!props) throw new Error("Initial props not found");
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.k)(props, function(_ref2) {
                        var fullKey = _ref2.fullKey, self = _ref2.self, args = _ref2.args;
                        return _this3.onInit.then(function() {
                            var func = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.v)(_this3.props, fullKey);
                            if ("function" != typeof func) throw new Error("Expected " + (void 0 === func ? "undefined" : _typeof(func)) + " to be function");
                            return func.apply(self, args);
                        });
                    });
                };
                ChildComponent.prototype.setProps = function(props, origin) {
                    var required = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    this.props = this.props || {};
                    var normalizedProps = Object(__WEBPACK_IMPORTED_MODULE_8__props__.a)(this.component, props, origin, required);
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__.t)(this.props, normalizedProps);
                    window.xprops = this.props;
                    for (var _iterator = this.onPropHandlers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref3;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref3 = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref3 = _i.value;
                        }
                        _ref3.call(this, this.props);
                    }
                };
                ChildComponent.prototype.sendToParent = function(name) {
                    var data = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, parentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)();
                    if (!parentWindow) throw new Error("Can not find parent component window to message");
                    this.component.log("send_to_parent_" + name);
                    return Object(__WEBPACK_IMPORTED_MODULE_2_post_robot_src__.send)(parentWindow, name, data, _extends({
                        domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__.d)()
                    }, options));
                };
                ChildComponent.prototype.setWindows = function() {
                    if (window.__activeXComponent__) throw this.component.createError("Can not attach multiple components to the same window");
                    window.__activeXComponent__ = this;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)()) throw this.component.createError("Can not find parent window");
                    var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__.b)();
                    if (componentMeta.tag !== this.component.tag) throw this.component.createError("Parent is " + componentMeta.tag + " - can not attach " + this.component.tag);
                    this.watchForClose();
                };
                ChildComponent.prototype.sendLogsToOpener = function() {
                };
                ChildComponent.prototype.watchForClose = function() {
                    var _this4 = this;
                    window.addEventListener("unload", function() {
                        return _this4.checkClose();
                    });
                };
                ChildComponent.prototype.enableAutoResize = function() {
                    var _ref5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref5$width = _ref5.width, width = void 0 === _ref5$width || _ref5$width, _ref5$height = _ref5.height, height = void 0 === _ref5$height || _ref5$height;
                    this.autoResize = {
                        width: width,
                        height: height
                    };
                    this.watchForResize();
                };
                ChildComponent.prototype.getAutoResize = function() {
                    var width = !1, height = !1, autoResize = this.autoResize || this.component.autoResize;
                    if ("object" === (void 0 === autoResize ? "undefined" : _typeof(autoResize))) {
                        width = Boolean(autoResize.width);
                        height = Boolean(autoResize.height);
                    } else if (autoResize) {
                        width = !0;
                        height = !0;
                    }
                    var element = void 0;
                    element = autoResize.element ? Object(__WEBPACK_IMPORTED_MODULE_6__lib__.x)(autoResize.element) : window.navigator.userAgent.match(/MSIE (9|10)\./) ? document.body : document.documentElement;
                    return {
                        width: width,
                        height: height,
                        element: element
                    };
                };
                ChildComponent.prototype.watchForResize = function() {
                    var _this5 = this, _getAutoResize = this.getAutoResize(), width = _getAutoResize.width, height = _getAutoResize.height, element = _getAutoResize.element;
                    if ((width || height) && this.context !== __WEBPACK_IMPORTED_MODULE_7__constants__.CONTEXT_TYPES.POPUP && !this.watchingForResize) {
                        this.watchingForResize = !0;
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            return __WEBPACK_IMPORTED_MODULE_6__lib__.n;
                        }).then(function() {
                            if (!Object(__WEBPACK_IMPORTED_MODULE_6__lib__.m)(element, {
                                width: width,
                                height: height
                            })) return _this5.resizeToElement(element, {
                                width: width,
                                height: height
                            });
                        }).then(function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.h)(function() {
                                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.K)(element, {
                                    width: width,
                                    height: height
                                }).then(function(dimensions) {
                                    return _this5.resizeToElement(element, {
                                        width: width,
                                        height: height
                                    });
                                });
                            });
                        });
                    }
                };
                ChildComponent.prototype.exports = function() {
                    var self = this;
                    return {
                        updateProps: function(props) {
                            var _this6 = this;
                            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                                return self.setProps(props, _this6.origin, !1);
                            });
                        },
                        close: function() {
                            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                                return self.destroy();
                            });
                        }
                    };
                };
                ChildComponent.prototype.resize = function(width, height) {
                    var _this7 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.resolve().then(function() {
                        _this7.component.log("resize", {
                            width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(width),
                            height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(height)
                        });
                        if (_this7.context !== __WEBPACK_IMPORTED_MODULE_7__constants__.CONTEXT_TYPES.POPUP) return _this7.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.RESIZE, {
                            width: width,
                            height: height
                        }).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                    });
                };
                ChildComponent.prototype.resizeToElement = function(el, _ref6) {
                    var _this8 = this, width = _ref6.width, height = _ref6.height, history = [];
                    return function resize() {
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            for (var tracker = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Z)(el, {
                                width: width,
                                height: height
                            }), _tracker$check = tracker.check(), dimensions = _tracker$check.dimensions, _iterator3 = history, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                                var _ref7;
                                if (_isArray3) {
                                    if (_i4 >= _iterator3.length) break;
                                    _ref7 = _iterator3[_i4++];
                                } else {
                                    _i4 = _iterator3.next();
                                    if (_i4.done) break;
                                    _ref7 = _i4.value;
                                }
                                var size = _ref7, widthMatch = !width || size.width === dimensions.width, heightMatch = !height || size.height === dimensions.height;
                                if (widthMatch && heightMatch) return;
                            }
                            history.push({
                                width: dimensions.width,
                                height: dimensions.height
                            });
                            return _this8.resize(width ? dimensions.width : null, height ? dimensions.height : null).then(function() {
                                if (tracker.check().changed) return resize();
                            });
                        });
                    }();
                };
                ChildComponent.prototype.hide = function() {
                    return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.HIDE).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                };
                ChildComponent.prototype.show = function() {
                    return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.SHOW).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                };
                ChildComponent.prototype.userClose = function() {
                    return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.USER_CLOSED);
                };
                ChildComponent.prototype.close = function() {
                    var reason = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.CHILD_CALL;
                    this.component.log("close_child");
                    this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.CLOSE, {
                        reason: reason
                    });
                };
                ChildComponent.prototype.checkClose = function() {
                    this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.CHECK_CLOSE, {}, {
                        fireAndForget: !0
                    });
                };
                ChildComponent.prototype.destroy = function() {
                    __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g().then(function() {
                        window.close();
                    });
                };
                ChildComponent.prototype.focus = function() {
                    this.component.log("focus");
                    window.focus();
                };
                ChildComponent.prototype.error = function(err) {
                    var stringifiedError = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.X)(err);
                    this.component.logError("error", {
                        error: stringifiedError
                    });
                    return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.ERROR, {
                        error: stringifiedError
                    }).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                };
                return ChildComponent;
            }(__WEBPACK_IMPORTED_MODULE_4__base__.a);
            Object(__WEBPACK_IMPORTED_MODULE_5__window__.g)() && window.console && function() {
                var logLevels = __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.l;
                _loop5: for (var _iterator4 = logLevels, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                    var _ref8, _ret4 = function() {
                        if (_isArray4) {
                            if (_i5 >= _iterator4.length) return "break";
                            _ref8 = _iterator4[_i5++];
                        } else {
                            _i5 = _iterator4.next();
                            if (_i5.done) return "break";
                            _ref8 = _i5.value;
                        }
                        var level = _ref8;
                        try {
                            var _original = window.console[level];
                            if (!_original || !_original.apply) return "continue";
                            window.console[level] = function() {
                                try {
                                    var logLevel = window.LOG_LEVEL;
                                    if (!logLevel || -1 === logLevels.indexOf(logLevel)) return _original.apply(this, arguments);
                                    if (logLevels.indexOf(level) > logLevels.indexOf(logLevel)) return;
                                    return _original.apply(this, arguments);
                                } catch (err2) {}
                            };
                            "info" === level && (window.console.log = window.console[level]);
                        } catch (err) {}
                    }();
                    switch (_ret4) {
                      case "break":
                        break _loop5;

                      case "continue":
                        continue;
                    }
                }
            }();
        },
        "./node_modules/xcomponent/src/component/child/props.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function normalizeChildProp(component, props, key, value) {
                var prop = component.getProp(key);
                if (!prop) {
                    if (component.looseProps) return value;
                    throw new Error("Unrecognized prop: " + key);
                }
                "function" == typeof prop.childDecorate && (value = prop.childDecorate(value));
                return value;
            }
            function normalizeChildProps(component, props, origin) {
                for (var required = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], result = {}, _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var _key = _ref, prop = component.getProp(_key), value = props[_key];
                    if (!prop || !prop.sameDomain || origin === Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.f)(window)) {
                        result[_key] = normalizeChildProp(component, props, _key, value);
                        prop && prop.alias && !result[prop.alias] && (result[prop.alias] = value);
                    }
                }
                if (required) for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var key = _ref2;
                    props.hasOwnProperty(key) || (result[key] = normalizeChildProp(component, props, key, props[key]));
                }
                return result;
            }
            __webpack_exports__.a = normalizeChildProps;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
            __webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/component/props.js");
        },
        "./node_modules/xcomponent/src/component/component/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return Component;
            });
            var _class, __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js"), __WEBPACK_IMPORTED_MODULE_4__child__ = __webpack_require__("./node_modules/xcomponent/src/component/child/index.js"), __WEBPACK_IMPORTED_MODULE_5__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js"), __WEBPACK_IMPORTED_MODULE_6__delegate__ = __webpack_require__("./node_modules/xcomponent/src/component/delegate/index.js"), __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__("./node_modules/xcomponent/src/component/component/props.js"), __WEBPACK_IMPORTED_MODULE_8__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js"), __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__("./node_modules/xcomponent/src/component/component/validate.js"), __WEBPACK_IMPORTED_MODULE_11__templates__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/index.js"), __WEBPACK_IMPORTED_MODULE_12__drivers__ = __webpack_require__("./node_modules/xcomponent/src/drivers/index.js"), __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, Component = (_class = function(_BaseComponent) {
                function Component(options) {
                    _classCallCheck(this, Component);
                    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));
                    Object(__WEBPACK_IMPORTED_MODULE_10__validate__.a)(options);
                    _this.addProp(options, "tag");
                    _this.addProp(options, "defaultLogLevel", "info");
                    _this.addProp(options, "allowedParentDomains", __WEBPACK_IMPORTED_MODULE_9__constants__.WILDCARD);
                    Object(__WEBPACK_IMPORTED_MODULE_13__lib__.S)(_this.defaultLogLevel);
                    if (Component.components[_this.tag]) throw new Error("Can not register multiple components with the same tag");
                    _this.addProp(options, "name", _this.tag.replace(/-/g, "_"));
                    _this.builtinProps = Object(__WEBPACK_IMPORTED_MODULE_7__props__.a)();
                    _this.props = options.props || {};
                    options.props || (_this.looseProps = !0);
                    _this.addProp(options, "dimensions");
                    _this.addProp(options, "scrolling");
                    _this.addProp(options, "version", "latest");
                    _this.addProp(options, "defaultEnv");
                    _this.addProp(options, "buildUrl");
                    _this.addProp(options, "url");
                    _this.addProp(options, "domain");
                    _this.addProp(options, "bridgeUrl");
                    _this.addProp(options, "bridgeDomain");
                    _this.addProp(options, "attributes", {});
                    _this.addProp(options, "contexts", {
                        iframe: !0,
                        popup: !1
                    });
                    _this.addProp(options, "defaultContext");
                    _this.addProp(options, "autoResize", !1);
                    _this.addProp(options, "containerTemplate", __WEBPACK_IMPORTED_MODULE_11__templates__.a);
                    _this.addProp(options, "prerenderTemplate", __WEBPACK_IMPORTED_MODULE_11__templates__.b);
                    _this.addProp(options, "validate");
                    _this.addProp(options, "unsafeRenderTo", !1);
                    Component.components[_this.tag] = _this;
                    _this.registerDrivers();
                    _this.registerChild();
                    _this.listenDelegate();
                    return _this;
                }
                _inherits(Component, _BaseComponent);
                Component.prototype.getPropNames = function() {
                    for (var props = Object.keys(this.props), _iterator = Object.keys(this.builtinProps), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        var key = _ref;
                        -1 === props.indexOf(key) && props.push(key);
                    }
                    return props;
                };
                Component.prototype.getProp = function(name) {
                    return this.props[name] || this.builtinProps[name];
                };
                Component.prototype.registerDrivers = function() {
                    this.driverCache = {};
                    for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_12__drivers__), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }
                        var driverName = _ref2;
                        if (0 !== driverName.indexOf("_")) {
                            var driver = __WEBPACK_IMPORTED_MODULE_12__drivers__[driverName], glob = driver.global();
                            glob && this.driver(driverName, glob);
                        }
                    }
                };
                Component.prototype.driver = function(name, dep) {
                    if (!__WEBPACK_IMPORTED_MODULE_12__drivers__[name]) throw new Error("Could not find driver for framework: " + name);
                    this.driverCache[name] || (this.driverCache[name] = __WEBPACK_IMPORTED_MODULE_12__drivers__[name].register(this, dep));
                    return this.driverCache[name];
                };
                Component.prototype.registerChild = function() {
                    var _this2 = this;
                    Object(__WEBPACK_IMPORTED_MODULE_8__window__.g)() && __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        if (Object(__WEBPACK_IMPORTED_MODULE_8__window__.b)().tag === _this2.tag) {
                            window.xchild = new __WEBPACK_IMPORTED_MODULE_4__child__.a(_this2);
                            window.xprops = window.xchild.props;
                        }
                    });
                };
                Component.prototype.listenDelegate = function() {
                    var _this3 = this;
                    Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.on)(__WEBPACK_IMPORTED_MODULE_9__constants__.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name, function(_ref3) {
                        _ref3.source, _ref3.origin, _ref3.data;
                        return !0;
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.on)(__WEBPACK_IMPORTED_MODULE_9__constants__.POST_MESSAGE.DELEGATE + "_" + this.name, function(_ref4) {
                        var source = _ref4.source, origin = _ref4.origin, data = _ref4.data, domain = _this3.getDomain(null, data.env || _this3.defaultEnv);
                        if (!domain) throw new Error("Could not determine domain to allow remote render");
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.A)(domain, origin)) throw new Error("Can not render from " + origin + " - expected " + domain.toString());
                        var delegate = _this3.delegate(source, data.options);
                        return {
                            overrides: delegate.getOverrides(data.context),
                            destroy: function() {
                                return delegate.destroy();
                            }
                        };
                    });
                };
                Component.prototype.canRenderTo = function(win) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.send)(win, __WEBPACK_IMPORTED_MODULE_9__constants__.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name).then(function(_ref5) {
                        return _ref5.data;
                    }).catch(function() {
                        return !1;
                    });
                };
                Component.prototype.getValidDomain = function(url) {
                    if (url) {
                        var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(url);
                        if ("string" == typeof this.domain && domain === this.domain) return domain;
                        if (this.domain && "object" === _typeof(this.domain)) for (var _iterator3 = Object.keys(this.domain), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                            var _ref6;
                            if (_isArray3) {
                                if (_i3 >= _iterator3.length) break;
                                _ref6 = _iterator3[_i3++];
                            } else {
                                _i3 = _iterator3.next();
                                if (_i3.done) break;
                                _ref6 = _i3.value;
                            }
                            var env = _ref6;
                            if ("test" !== env && domain === this.domain[env]) return domain;
                        }
                    }
                };
                Component.prototype.getDomain = function(url, env) {
                    var domain = this.getForEnv(this.domain, env);
                    if (domain) return domain;
                    domain = this.getValidDomain(url);
                    if (domain) return domain;
                    var envUrl = this.getForEnv(this.url, env);
                    return envUrl ? Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(envUrl) : url ? Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(url) : void 0;
                };
                Component.prototype.getBridgeUrl = function(env) {
                    return this.getForEnv(this.bridgeUrl, env);
                };
                Component.prototype.getForEnv = function(item, env) {
                    if (item) {
                        if ("string" == typeof item || item instanceof RegExp) return item;
                        env || (env = this.defaultEnv);
                        if (env) return env && "object" === (void 0 === item ? "undefined" : _typeof(item)) && item[env] ? item[env] : void 0;
                    }
                };
                Component.prototype.getBridgeDomain = function(env) {
                    var bridgeDomain = this.getForEnv(this.bridgeDomain, env);
                    if (bridgeDomain) return bridgeDomain;
                    var bridgeUrl = this.getBridgeUrl(env);
                    return bridgeUrl ? Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.g)(bridgeUrl) : void 0;
                };
                Component.prototype.getUrl = function(env, props) {
                    var url = this.getForEnv(this.url, env);
                    return url || (this.buildUrl ? this.buildUrl(props) : void 0);
                };
                Component.prototype.isXComponent = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_8__window__.g)();
                };
                Component.prototype.isChild = function() {
                    return Object(__WEBPACK_IMPORTED_MODULE_8__window__.g)() && window.xprops && Object(__WEBPACK_IMPORTED_MODULE_8__window__.b)().tag === this.tag;
                };
                Component.prototype.createError = function(message, tag) {
                    return new Error("[" + (tag || this.tag) + "] " + message);
                };
                Component.prototype.init = function(props, context, element) {
                    return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(this, this.getRenderContext(context, element), {
                        props: props
                    });
                };
                Component.prototype.delegate = function(source, options) {
                    return new __WEBPACK_IMPORTED_MODULE_6__delegate__.a(this, source, options);
                };
                Component.prototype.validateRenderContext = function(context, element) {
                    if (context && !this.contexts[context]) throw new Error("[" + this.tag + "] Can not render to " + context);
                    if (!element && context === __WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME) throw new Error("[" + this.tag + "] Context type " + __WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME + " requires an element selector");
                };
                Component.prototype.getDefaultContext = function() {
                    if (this.defaultContext) return this.defaultContext;
                    if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME]) return __WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME;
                    if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.POPUP]) return __WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.POPUP;
                    throw new Error("Can not determine default context");
                };
                Component.prototype.getRenderContext = function(context, element) {
                    context = context || this.getDefaultContext();
                    this.validateRenderContext(context, element);
                    return context;
                };
                Component.prototype.render = function(props, element) {
                    var _this4 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this4, _this4.getRenderContext(null, element), {
                            props: props
                        }).render(element);
                    });
                };
                Component.prototype.renderIframe = function(props, element) {
                    var _this5 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this5, _this5.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME, element), {
                            props: props
                        }).render(element);
                    });
                };
                Component.prototype.renderPopup = function(props) {
                    var _this6 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this6, _this6.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.POPUP), {
                            props: props
                        }).render();
                    });
                };
                Component.prototype.renderTo = function(win, props, element) {
                    var _this7 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this7, _this7.getRenderContext(null, element), {
                            props: props
                        }).renderTo(win, element);
                    });
                };
                Component.prototype.renderIframeTo = function(win, props, element) {
                    var _this8 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this8, _this8.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.IFRAME, element), {
                            props: props
                        }).renderTo(win, element);
                    });
                };
                Component.prototype.renderPopupTo = function(win, props) {
                    var _this9 = this;
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return new __WEBPACK_IMPORTED_MODULE_5__parent__.a(_this9, _this9.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__.CONTEXT_TYPES.POPUP), {
                            props: props
                        }).renderTo(win);
                    });
                };
                Component.prototype.prerender = function(props, element) {
                    var instance = new __WEBPACK_IMPORTED_MODULE_5__parent__.a(this, this.getRenderContext(null, element), {
                        props: props
                    });
                    instance.prefetch();
                    return {
                        render: function(innerProps, innerElement) {
                            innerProps && instance.updateProps(innerProps);
                            return instance.render(innerElement);
                        },
                        renderTo: function(win, innerProps, innerElement) {
                            innerProps && instance.updateProps(innerProps);
                            return instance.renderTo(win, innerElement);
                        },
                        get html() {
                            return instance.html;
                        },
                        set html(value) {
                            instance.html = value;
                        }
                    };
                };
                Component.prototype.log = function(event) {
                    var payload = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    Object(__WEBPACK_IMPORTED_MODULE_13__lib__.C)(this.name, event, payload);
                };
                Component.prototype.logWarning = function(event, payload) {
                    Object(__WEBPACK_IMPORTED_MODULE_13__lib__._2)(this.name, event, payload);
                };
                Component.prototype.logError = function(event, payload) {
                    Object(__WEBPACK_IMPORTED_MODULE_13__lib__.r)(this.name, event, payload);
                };
                Component.getByTag = function(tag) {
                    return Component.components[tag];
                };
                return Component;
            }(__WEBPACK_IMPORTED_MODULE_3__base__.a), function(target, property, decorators, descriptor, context) {
                var desc = {};
                Object.keys(descriptor).forEach(function(key) {
                    desc[key] = descriptor[key];
                });
                desc.enumerable = !!desc.enumerable;
                desc.configurable = !!desc.configurable;
                ("value" in desc || desc.initializer) && (desc.writable = !0);
                desc = decorators.slice().reverse().reduce(function(desc, decorator) {
                    return decorator(target, property, desc) || desc;
                }, desc);
                if (context && void 0 !== desc.initializer) {
                    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                    desc.initializer = void 0;
                }
                if (void 0 === desc.initializer) {
                    Object.defineProperty(target, property, desc);
                    desc = null;
                }
                return desc;
            }(_class.prototype, "getPropNames", [ __WEBPACK_IMPORTED_MODULE_13__lib__.G ], Object.getOwnPropertyDescriptor(_class.prototype, "getPropNames"), _class.prototype), 
            _class);
            Component.components = {};
        },
        "./node_modules/xcomponent/src/component/component/props.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getInternalProps() {
                return {
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultEnv;
                        }
                    },
                    uid: {
                        type: "string",
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_1__lib__._0)();
                        },
                        queryParam: !0
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultLogLevel;
                        }
                    },
                    url: {
                        type: "string",
                        required: !1,
                        promise: !0,
                        sendToChild: !1
                    },
                    version: {
                        type: "string",
                        required: !1,
                        queryParam: !0
                    },
                    timeout: {
                        type: "number",
                        required: !1,
                        sendToChild: !1
                    },
                    onDisplay: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        memoize: !0,
                        sendToChild: !1
                    },
                    onEnter: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onRender: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onClose: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onTimeout: {
                        type: "function",
                        required: !1,
                        memoize: !0,
                        promisify: !0,
                        sendToChild: !1,
                        def: function() {
                            return function(err) {
                                if (this.props.onError) return this.props.onError(err);
                                throw err;
                            };
                        }
                    },
                    onError: {
                        type: "function",
                        required: !1,
                        promisify: !0,
                        sendToChild: !0,
                        once: !0
                    }
                };
            }
            __webpack_exports__.a = getInternalProps;
            var __WEBPACK_IMPORTED_MODULE_1__lib__ = (__webpack_require__("./node_modules/zalgo-promise/src/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/lib/index.js"));
        },
        "./node_modules/xcomponent/src/component/component/templates/component.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function defaultPrerenderTemplate(_ref) {
                var jsxDom = _ref.jsxDom;
                return jsxDom("html", null, jsxDom("head", null, jsxDom("style", null, "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    ")), jsxDom("body", null, jsxDom("div", {
                    class: "spinner"
                }, jsxDom("div", {
                    id: "loader",
                    class: "loader"
                }))));
            }
            __webpack_exports__.a = defaultPrerenderTemplate;
            __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
        },
        "./node_modules/xcomponent/src/component/component/templates/container.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function defaultContainerTemplate(_ref) {
                var id = _ref.id, tag = _ref.tag, context = _ref.context, CLASS = _ref.CLASS, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _ref$dimensions = _ref.dimensions, width = _ref$dimensions.width, height = _ref$dimensions.height;
                return jsxDom("div", {
                    id: id,
                    class: CLASS.XCOMPONENT + " " + CLASS.XCOMPONENT + "-tag-" + tag + " " + CLASS.XCOMPONENT + "-context-" + context
                }, jsxDom("style", null, "\n                    #" + id + ", #" + id + " > ." + CLASS.OUTLET + " {\n                        width: " + width + ";\n                        height: " + height + ";\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                    }\n                "), outlet);
            }
            __webpack_exports__.a = defaultContainerTemplate;
            __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
        },
        "./node_modules/xcomponent/src/component/component/templates/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/container.jsx");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__container__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/component.jsx");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__component__.a;
            });
        },
        "./node_modules/xcomponent/src/component/component/validate.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function validatePropDefinitions(options) {
                if (options.props && "object" !== _typeof(options.props)) throw new Error("Expected options.props to be an object");
                if (options.props) for (var _iterator = Object.keys(options.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref, prop = options.props[key];
                    if (!prop || "object" !== (void 0 === prop ? "undefined" : _typeof(prop))) throw new Error("Expected options.props." + key + " to be an object");
                    if (!prop.type) throw new Error("Expected prop.type");
                    if (-1 === __WEBPACK_IMPORTED_MODULE_0__constants__.PROP_TYPES_LIST.indexOf(prop.type)) throw new Error("Expected prop.type to be one of " + __WEBPACK_IMPORTED_MODULE_0__constants__.PROP_TYPES_LIST.join(", "));
                    if (prop.required && prop.def) throw new Error("Required prop can not have a default value");
                }
            }
            function validate(options) {
                if (!options) throw new Error("Expecred options to be passed");
                if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) throw new Error("Invalid options.tag: " + options.tag);
                validatePropDefinitions(options);
                if (options.dimensions) {
                    if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__.E)(options.dimensions.width) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__.D)(options.dimensions.width)) throw new Error("Expected options.dimensions.width to be a px or % string value");
                    if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__.E)(options.dimensions.height) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__.D)(options.dimensions.height)) throw new Error("Expected options.dimensions.height to be a px or % string value");
                }
                if (options.contexts) {
                    if (options.contexts.popup, !1) throw new Error("Popups not supported in this build -- please use the full xcomponent.js build");
                    for (var anyEnabled = !1, _iterator2 = Object.keys(options.contexts), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }
                        var context = _ref2;
                        if (-1 === __WEBPACK_IMPORTED_MODULE_0__constants__.CONTEXT_TYPES_LIST.indexOf(context)) throw new Error("Unsupported context type: " + context);
                        (options.contexts && options.contexts[context] || options.contexts && void 0 === options.contexts[context]) && (anyEnabled = !0);
                    }
                    if (!anyEnabled) throw new Error("No context type is enabled");
                }
                if (options.defaultContext) {
                    if (-1 === __WEBPACK_IMPORTED_MODULE_0__constants__.CONTEXT_TYPES_LIST.indexOf(options.defaultContext)) throw new Error("Unsupported context type: " + (options.defaultContext || "unknown"));
                    if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) throw new Error("Disallowed default context type: " + (options.defaultContext || "unknown"));
                }
                if (!options.url && !options.buildUrl) throw new Error("Expected options.url to be passed");
                if (options.url && options.buildUrl) throw new Error("Can not pass options.url and options.buildUrl");
                if (options.defaultEnv) {
                    if ("string" != typeof options.defaultEnv) throw new Error("Expected options.defaultEnv to be a string");
                    if (!options.buildUrl && "object" !== _typeof(options.url)) throw new Error("Expected options.url to be an object mapping env->url");
                    if (options.url && "object" === _typeof(options.url) && !options.url[options.defaultEnv]) throw new Error("No url found for default env: " + options.defaultEnv);
                }
                if (options.url && "object" === _typeof(options.url)) {
                    if (!options.defaultEnv) throw new Error("Must pass options.defaultEnv with env->url mapping");
                    for (var _iterator3 = Object.keys(options.url), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                        var _ref3;
                        if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                        } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                        }
                        var env = _ref3;
                        if (!options.url[env]) throw new Error("No url specified for env: " + env);
                    }
                }
                if (options.prerenderTemplate && "function" != typeof options.prerenderTemplate) throw new Error("Expected options.prerenderTemplate to be a function");
                if (options.containerTemplate && "function" != typeof options.containerTemplate) throw new Error("Expected options.containerTemplate to be a function");
            }
            __webpack_exports__.a = validate;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), _typeof = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            });
        },
        "./node_modules/xcomponent/src/component/delegate/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return DelegateComponent;
            });
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__base__ = (__webpack_require__("./node_modules/zalgo-promise/src/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/base.js")), __WEBPACK_IMPORTED_MODULE_3__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js"), __WEBPACK_IMPORTED_MODULE_4__parent_drivers__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/drivers.js"), _createClass = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            function() {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || !1;
                        descriptor.configurable = !0;
                        "value" in descriptor && (descriptor.writable = !0);
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    protoProps && defineProperties(Constructor.prototype, protoProps);
                    staticProps && defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }()), DelegateComponent = function(_BaseComponent) {
                function DelegateComponent(component, source, options) {
                    _classCallCheck(this, DelegateComponent);
                    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));
                    _this.component = component;
                    _this.clean.set("source", source);
                    _this.context = options.context;
                    _this.props = {
                        uid: options.props.uid,
                        dimensions: options.props.dimensions,
                        onClose: options.props.onClose,
                        onDisplay: options.props.onDisplay
                    };
                    for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        var propName = _ref;
                        _this.component.getProp(propName).allowDelegate && (_this.props[propName] = options.props[propName]);
                    }
                    _this.focus = function() {
                        if (_this.driver.openOnFocus) try {
                            var win = window.open("", _this.childWindowName);
                            win && win.focus();
                        } catch (err) {}
                        return options.overrides.focus.call(_this);
                    };
                    _this.clean.register("destroyFocusOverride", function() {
                        _this.focus = function() {};
                    });
                    _this.userClose = options.overrides.userClose;
                    _this.getDomain = options.overrides.getDomain;
                    _this.error = options.overrides.error;
                    _this.on = options.overrides.on;
                    for (var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__.a[options.context].delegateOverrides, _iterator2 = Object.keys(delegateOverrides), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }
                        var key = _ref2;
                        _this[key] = __WEBPACK_IMPORTED_MODULE_3__parent__.a.prototype[key];
                    }
                    _this.childWindowName = options.childWindowName;
                    __WEBPACK_IMPORTED_MODULE_3__parent__.a.prototype.registerActiveComponent.call(_this);
                    _this.watchForClose();
                    return _this;
                }
                _inherits(DelegateComponent, _BaseComponent);
                DelegateComponent.prototype.watchForClose = function() {
                    var _this2 = this, closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.B)(this.source, function() {
                        return _this2.destroy();
                    }, 3e3);
                    this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
                };
                DelegateComponent.prototype.getOverrides = function(context) {
                    for (var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__.a[context].delegateOverrides, overrides = {}, self = this, _iterator3 = Object.keys(delegateOverrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                        var _ref3;
                        if ("break" === function() {
                            if (_isArray3) {
                                if (_i3 >= _iterator3.length) return "break";
                                _ref3 = _iterator3[_i3++];
                            } else {
                                _i3 = _iterator3.next();
                                if (_i3.done) return "break";
                                _ref3 = _i3.value;
                            }
                            var key = _ref3;
                            overrides[key] = function() {
                                return __WEBPACK_IMPORTED_MODULE_3__parent__.a.prototype[key].apply(self, arguments);
                            };
                        }()) break;
                    }
                    return overrides;
                };
                DelegateComponent.prototype.destroy = function() {
                    return this.clean.all();
                };
                _createClass(DelegateComponent, [ {
                    key: "driver",
                    get: function() {
                        if (!this.context) throw new Error("Context not set");
                        return __WEBPACK_IMPORTED_MODULE_4__parent_drivers__.a[this.context];
                    }
                } ]);
                return DelegateComponent;
            }(__WEBPACK_IMPORTED_MODULE_2__base__.a);
        },
        "./node_modules/xcomponent/src/component/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/index.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.a;
            });
            __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/child/index.js");
        },
        "./node_modules/xcomponent/src/component/parent/drivers.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return RENDER_DRIVERS;
            });
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js"), __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, RENDER_DRIVERS = {};
            RENDER_DRIVERS[__WEBPACK_IMPORTED_MODULE_4__constants__.CONTEXT_TYPES.IFRAME] = {
                focusable: !1,
                renderedIntoContainerTemplate: !0,
                allowResize: !0,
                openOnClick: !1,
                openOnFocus: !1,
                needsBridge: !1,
                open: function(url) {
                    var _this = this, attributes = this.component.attributes.iframe || {};
                    this.iframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.B)({
                        url: url,
                        attributes: _extends({
                            name: this.childWindowName,
                            scrolling: this.component.scrolling ? "yes" : "no"
                        }, attributes),
                        class: [ __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.COMPONENT_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.INVISIBLE ]
                    }, this.element);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.f)(this.iframe).then(function(frameWindow) {
                        _this.window = frameWindow;
                        var detectClose = function() {
                            __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                return _this.props.onClose(__WEBPACK_IMPORTED_MODULE_4__constants__.CLOSE_REASONS.CLOSE_DETECTED);
                            }).finally(function() {
                                return _this.destroy();
                            });
                        }, iframeWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__._3)(_this.iframe, detectClose), elementWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__._3)(_this.element, detectClose);
                        _this.clean.register("destroyWindow", function() {
                            iframeWatcher.cancel();
                            elementWatcher.cancel();
                            Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.cleanUpWindow)(_this.window);
                            delete _this.window;
                            if (_this.iframe) {
                                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.l)(_this.iframe);
                                delete _this.iframe;
                            }
                        });
                    });
                },
                openPrerender: function() {
                    var _this2 = this, attributes = this.component.attributes.iframe || {};
                    this.prerenderIframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.B)({
                        attributes: _extends({
                            name: "__prerender__" + this.childWindowName,
                            scrolling: this.component.scrolling ? "yes" : "no"
                        }, attributes),
                        class: [ __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.PRERENDER_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.VISIBLE ]
                    }, this.element);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.f)(this.prerenderIframe).then(function(prerenderFrameWindow) {
                        _this2.prerenderWindow = prerenderFrameWindow;
                        _this2.clean.register("destroyPrerender", function() {
                            if (_this2.prerenderIframe) {
                                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.l)(_this2.prerenderIframe);
                                delete _this2.prerenderIframe;
                            }
                        });
                    });
                },
                switchPrerender: function() {
                    var _this3 = this;
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.a)(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.INVISIBLE);
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.P)(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.VISIBLE);
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.a)(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.VISIBLE);
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.P)(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__.CLASS_NAMES.INVISIBLE);
                    setTimeout(function() {
                        _this3.prerenderIframe && Object(__WEBPACK_IMPORTED_MODULE_3__lib__.l)(_this3.prerenderIframe);
                    }, 1e3);
                },
                delegateOverrides: {
                    openContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    destroyComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    destroyContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    cancelContainerEvents: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    createPrerenderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    elementReady: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    showContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    showComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hideContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hideComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hide: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    show: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    resize: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    loadUrl: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hijackSubmit: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    openPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    switchPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    renderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    openContainerFrame: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    getOutlet: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    open: function(original, override) {
                        return function() {
                            var _this4 = this;
                            return override.apply(this, arguments).then(function() {
                                _this4.clean.set("window", Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.a)(Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)(), _this4.childWindowName));
                                if (!_this4.window) throw new Error("Unable to find parent component iframe window");
                            });
                        };
                    }
                },
                resize: function(width, height) {
                    if (width) {
                        this.container.style.width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.Y)(width);
                        this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.Y)(width);
                    }
                    if (height) {
                        this.container.style.height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.Y)(height);
                        this.element.style.height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.Y)(height);
                    }
                },
                show: function() {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.V)(this.element);
                },
                hide: function() {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__.A)(this.element);
                },
                loadUrl: function(url) {
                    this.iframe.setAttribute("src", url);
                }
            };
            RENDER_DRIVERS[__WEBPACK_IMPORTED_MODULE_4__constants__.CONTEXT_TYPES.POPUP] = {
                focusable: !0,
                renderedIntoContainerTemplate: !1,
                allowResize: !1,
                openOnClick: !0,
                openOnFocus: !0,
                needsBridge: !0,
                open: function() {
                    var _this5 = this, url = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                        var _ref = _this5.component.dimensions || {}, _ref$width = _ref.width, width = void 0 === _ref$width ? __WEBPACK_IMPORTED_MODULE_4__constants__.DEFAULT_DIMENSIONS.WIDTH : _ref$width, _ref$height = _ref.height, height = void 0 === _ref$height ? __WEBPACK_IMPORTED_MODULE_4__constants__.DEFAULT_DIMENSIONS.HEIGHT : _ref$height;
                        width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.J)(width, window.outerWidth);
                        height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.J)(height, window.outerWidth);
                        var _getPosition = Object(__WEBPACK_IMPORTED_MODULE_5__window__.f)({
                            width: width,
                            height: height
                        }), x = _getPosition.x, y = _getPosition.y, attributes = _this5.component.attributes.popup || {};
                        try {
                            _this5.window = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.M)(url || "", _extends({
                                name: _this5.childWindowName,
                                width: width,
                                height: height,
                                top: y,
                                left: x,
                                status: 1,
                                toolbar: 0,
                                menubar: 0,
                                resizable: 1,
                                scrollbars: 1
                            }, attributes));
                        } catch (err) {
                            err instanceof __WEBPACK_IMPORTED_MODULE_6__error__.b && _this5.component.logError("popup_open_error");
                            throw err;
                        }
                        _this5.prerenderWindow = _this5.window;
                        _this5.clean.register("destroyWindow", function() {
                            if (_this5.window) {
                                _this5.window.close();
                                Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.cleanUpWindow)(_this5.window);
                                delete _this5.window;
                                delete _this5.prerenderWindow;
                            }
                        });
                        _this5.resize(width, height);
                    });
                },
                openPrerender: function() {
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {});
                },
                resize: function(width, height) {},
                hide: function() {
                    throw new Error("Can not hide popup");
                },
                show: function() {
                    throw new Error("Can not show popup");
                },
                delegateOverrides: {
                    openContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    destroyContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    elementReady: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    showContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    showComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hideContainer: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hideComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    hide: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    show: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    cancelContainerEvents: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_DELEGATE,
                    open: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    loadUrl: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    createPrerenderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    destroyComponent: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    resize: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    renderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    openContainerFrame: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL,
                    getOutlet: __WEBPACK_IMPORTED_MODULE_4__constants__.DELEGATE.CALL_ORIGINAL
                },
                loadUrl: function(url) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.u)(this.window)) try {
                        if (this.window.location && this.window.location.replace) {
                            this.window.location.replace(url);
                            return;
                        }
                    } catch (err) {}
                    this.window.location = url;
                }
            };
        },
        "./node_modules/xcomponent/src/component/parent/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
                var desc = {};
                Object.keys(descriptor).forEach(function(key) {
                    desc[key] = descriptor[key];
                });
                desc.enumerable = !!desc.enumerable;
                desc.configurable = !!desc.configurable;
                ("value" in desc || desc.initializer) && (desc.writable = !0);
                desc = decorators.slice().reverse().reduce(function(desc, decorator) {
                    return decorator(target, property, desc) || desc;
                }, desc);
                if (context && void 0 !== desc.initializer) {
                    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                    desc.initializer = void 0;
                }
                if (void 0 === desc.initializer) {
                    Object.defineProperty(target, property, desc);
                    desc = null;
                }
                return desc;
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return ParentComponent;
            });
            var _class, __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js"), __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js"), __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), __WEBPACK_IMPORTED_MODULE_8__drivers__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/drivers.js"), __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/validate.js"), __WEBPACK_IMPORTED_MODULE_10__props__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/props.js"), __WEBPACK_IMPORTED_MODULE_11__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js"), _extends = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/component/props.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/child/index.js"), Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, _createClass = function() {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || !1;
                        descriptor.configurable = !0;
                        "value" in descriptor && (descriptor.writable = !0);
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    protoProps && defineProperties(Constructor.prototype, protoProps);
                    staticProps && defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __WEBPACK_IMPORTED_MODULE_6__lib__.y.props = __WEBPACK_IMPORTED_MODULE_6__lib__.y.props || {};
            __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows = __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows || {};
            var ParentComponent = (_class = function(_BaseComponent) {
                function ParentComponent(component, context, _ref) {
                    var props = _ref.props;
                    _classCallCheck(this, ParentComponent);
                    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));
                    _this.component = component;
                    _this.validateParentDomain();
                    _this.context = context;
                    _this.setProps(props);
                    _this.props.logLevel && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.S)(_this.props.logLevel);
                    _this.childWindowName = _this.buildChildWindowName({
                        renderTo: window
                    });
                    _this.registerActiveComponent();
                    _this.component.log("construct_parent");
                    _this.watchForUnload();
                    _this.onInit = new __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a();
                    _this.onInit.catch(function(err) {
                        return _this.error(err);
                    });
                    return _this;
                }
                _inherits(ParentComponent, _BaseComponent);
                ParentComponent.prototype.render = function(element) {
                    var _this2 = this, loadUrl = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    return this.tryInit(function() {
                        _this2.component.log("render_" + _this2.context, {
                            context: _this2.context,
                            element: element,
                            loadUrl: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(loadUrl)
                        });
                        var tasks = {};
                        tasks.onRender = _this2.props.onRender();
                        tasks.getDomain = _this2.getDomain();
                        tasks.elementReady = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            if (element) return _this2.elementReady(element);
                        });
                        tasks.openContainer = tasks.elementReady.then(function() {
                            return _this2.openContainer(element);
                        });
                        tasks.showContainer = tasks.openContainer.then(function() {
                            return _this2.showContainer();
                        });
                        tasks.openPrerender = tasks.openContainer.then(function() {
                            return _this2.openPrerender();
                        });
                        tasks.switchPrerender = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ tasks.openPrerender, _this2.onInit ]).then(function() {
                            return _this2.switchPrerender();
                        });
                        tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then(function() {
                            return _this2.open();
                        });
                        tasks.listen = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ tasks.getDomain, tasks.open ]).then(function(_ref2) {
                            var domain = _ref2[0];
                            _this2.listen(_this2.window, domain);
                        });
                        tasks.watchForClose = tasks.open.then(function() {
                            return _this2.watchForClose();
                        });
                        tasks.linkDomain = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ tasks.getDomain, tasks.open ]).then(function(_ref3) {
                            var domain = _ref3[0];
                            if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge && "string" == typeof domain) return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge.linkUrl(_this2.window, domain);
                        });
                        if (!_this2.html) {
                            tasks.createPrerenderTemplate = tasks.openPrerender.then(function() {
                                return _this2.createPrerenderTemplate();
                            });
                            tasks.showComponent = tasks.createPrerenderTemplate.then(function() {
                                return _this2.showComponent();
                            });
                        }
                        tasks.openBridge = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ tasks.getDomain, tasks.open ]).then(function(_ref4) {
                            var domain = _ref4[0];
                            return _this2.openBridge("string" == typeof domain ? domain : null);
                        });
                        if (_this2.html) tasks.loadHTML = tasks.open.then(function() {
                            return _this2.loadHTML();
                        }); else if (loadUrl) {
                            tasks.buildUrl = _this2.buildUrl();
                            tasks.loadUrl = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate ]).then(function(_ref5) {
                                var url = _ref5[0];
                                return _this2.loadUrl(url);
                            });
                            tasks.runTimeout = tasks.loadUrl.then(function() {
                                return _this2.runTimeout();
                            });
                        }
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.hash(tasks);
                    }).then(function() {
                        return _this2.props.onEnter();
                    });
                };
                ParentComponent.prototype.getOutlet = function() {
                    this.outlet = document.createElement("div");
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__.a)(this.outlet, __WEBPACK_IMPORTED_MODULE_7__constants__.CLASS_NAMES.OUTLET);
                    return this.outlet;
                };
                ParentComponent.prototype.validateParentDomain = function() {
                    var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)();
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.A)(this.component.allowedParentDomains, domain)) throw new __WEBPACK_IMPORTED_MODULE_11__error__.c("Can not be rendered by domain: " + domain);
                };
                ParentComponent.prototype.renderTo = function(win, element) {
                    var _this3 = this;
                    return this.tryInit(function() {
                        if (win === window) return _this3.render(element);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.v)(window, win)) throw new Error("Can only renderTo an adjacent frame");
                        if (element && "string" != typeof element) throw new Error("Element passed to renderTo must be a string selector, got " + (void 0 === element ? "undefined" : _typeof(element)) + " " + element);
                        _this3.checkAllowRenderTo(win);
                        _this3.component.log("render_" + _this3.context + "_to_win", {
                            element: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(element),
                            context: _this3.context
                        });
                        _this3.childWindowName = _this3.buildChildWindowName({
                            renderTo: win
                        });
                        _this3.delegate(win);
                        return _this3.render(element);
                    });
                };
                ParentComponent.prototype.prefetch = function() {
                    var _this4 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this4.html = _this4.buildUrl().then(function(url) {
                            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.N)(url).then(function(html) {
                                return '\n                        <base href="' + url.split("/").slice(0, 3).join("/") + '">\n\n                        ' + html + "\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, '', '/" + url.split("/").slice(3).join("/") + "');\n                            }\n                        <\/script>\n                    ";
                            });
                        });
                    });
                };
                ParentComponent.prototype.loadHTML = function() {
                    var _this5 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (!_this5.html) throw new Error("Html not prefetched");
                        return _this5.html.then(function(html) {
                            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__._5)(_this5.window, html);
                        });
                    });
                };
                ParentComponent.prototype.checkAllowRenderTo = function(win) {
                    if (!win) throw this.component.createError("Must pass window to renderTo");
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.u)(win)) {
                        var origin = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)(), domain = this.component.getDomain(null, this.props.env);
                        if (!domain) throw new Error("Could not determine domain to allow remote render");
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.A)(domain, origin)) throw new Error("Can not render remotely to " + domain.toString() + " - can only render to " + origin);
                    }
                };
                ParentComponent.prototype.registerActiveComponent = function() {
                    var _this6 = this;
                    ParentComponent.activeComponents.push(this);
                    this.clean.register(function() {
                        ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
                    });
                };
                ParentComponent.prototype.getComponentParentRef = function() {
                    var renderToWindow = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window;
                    if (this.context === __WEBPACK_IMPORTED_MODULE_7__constants__.CONTEXT_TYPES.POPUP) return {
                        ref: __WEBPACK_IMPORTED_MODULE_7__constants__.WINDOW_REFERENCES.OPENER
                    };
                    if (renderToWindow === window) return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.w)(window) ? {
                        ref: __WEBPACK_IMPORTED_MODULE_7__constants__.WINDOW_REFERENCES.TOP
                    } : {
                        ref: __WEBPACK_IMPORTED_MODULE_7__constants__.WINDOW_REFERENCES.PARENT,
                        distance: Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.e)(window)
                    };
                    var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__._0)();
                    __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows[uid] = window;
                    this.clean.register(function() {
                        delete __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows[uid];
                    });
                    return {
                        ref: __WEBPACK_IMPORTED_MODULE_7__constants__.WINDOW_REFERENCES.GLOBAL,
                        uid: uid
                    };
                };
                ParentComponent.prototype.getRenderParentRef = function() {
                    var renderToWindow = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window;
                    if (renderToWindow === window) return this.getComponentParentRef(renderToWindow);
                    var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__._0)();
                    __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows[uid] = renderToWindow;
                    this.clean.register(function() {
                        delete __WEBPACK_IMPORTED_MODULE_6__lib__.y.windows[uid];
                    });
                    return {
                        ref: __WEBPACK_IMPORTED_MODULE_7__constants__.WINDOW_REFERENCES.GLOBAL,
                        uid: uid
                    };
                };
                ParentComponent.prototype.buildChildWindowName = function() {
                    var _ref6 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref6$renderTo = _ref6.renderTo, renderTo = void 0 === _ref6$renderTo ? window : _ref6$renderTo, sameDomain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.u)(renderTo), uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__._0)(), tag = this.component.tag, sProps = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.R)(this.getPropsForChild()), componentParent = this.getComponentParentRef(renderTo), renderParent = this.getRenderParentRef(renderTo), secureProps = !sameDomain && !this.component.unsafeRenderTo, props = secureProps ? {
                        type: __WEBPACK_IMPORTED_MODULE_7__constants__.INITIAL_PROPS.UID,
                        uid: uid
                    } : {
                        type: __WEBPACK_IMPORTED_MODULE_7__constants__.INITIAL_PROPS.RAW,
                        value: sProps
                    };
                    if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__.INITIAL_PROPS.UID) {
                        __WEBPACK_IMPORTED_MODULE_6__lib__.y.props[uid] = sProps;
                        this.clean.register(function() {
                            delete __WEBPACK_IMPORTED_MODULE_6__lib__.y.props[uid];
                        });
                    }
                    return Object(__WEBPACK_IMPORTED_MODULE_5__window__.a)(this.component.name, this.component.version, {
                        uid: uid,
                        tag: tag,
                        componentParent: componentParent,
                        renderParent: renderParent,
                        props: props
                    });
                };
                ParentComponent.prototype.sendToParent = function(name, data) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)()) throw new Error("Can not find parent component window to message");
                    this.component.log("send_to_parent_" + name);
                    return Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.send)(Object(__WEBPACK_IMPORTED_MODULE_5__window__.c)(), name, data, {
                        domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__.d)()
                    });
                };
                ParentComponent.prototype.setProps = function(props) {
                    var required = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    Object(__WEBPACK_IMPORTED_MODULE_9__validate__.a)(this.component, props, required);
                    this.component.validate && this.component.validate(this.component, props);
                    this.props = this.props || {};
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__.t)(this.props, Object(__WEBPACK_IMPORTED_MODULE_10__props__.a)(this.component, this, props));
                };
                ParentComponent.prototype.buildUrl = function() {
                    var _this7 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ this.props.url, Object(__WEBPACK_IMPORTED_MODULE_10__props__.b)(_extends({}, this.component.props, this.component.builtinProps), this.props) ]).then(function(_ref7) {
                        var url = _ref7[0], query = _ref7[1];
                        return url && !_this7.component.getValidDomain(url) ? url : __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            return url || _this7.component.getUrl(_this7.props.env, _this7.props);
                        }).then(function(finalUrl) {
                            query[__WEBPACK_IMPORTED_MODULE_7__constants__.XCOMPONENT] = "1";
                            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.u)(finalUrl, {
                                query: query
                            });
                        });
                    });
                };
                ParentComponent.prototype.getDomain = function() {
                    var _this8 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        return _this8.props.url;
                    }).then(function(url) {
                        var domain = _this8.component.getDomain(url, _this8.props.env);
                        return domain || (_this8.component.buildUrl ? __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            return _this8.component.buildUrl(_this8.props);
                        }).then(function(builtUrl) {
                            return _this8.component.getDomain(builtUrl, _this8.props.env);
                        }) : void 0);
                    }).then(function(domain) {
                        if (!domain) throw new Error("Could not determine domain");
                        return domain;
                    });
                };
                ParentComponent.prototype.getPropsForChild = function() {
                    for (var result = {}, _iterator = Object.keys(this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref8;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref8 = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref8 = _i.value;
                        }
                        var key = _ref8, prop = this.component.getProp(key);
                        prop && !1 === prop.sendToChild || (result[key] = this.props[key]);
                    }
                    return result;
                };
                ParentComponent.prototype.updateProps = function(props) {
                    var _this9 = this;
                    this.setProps(props, !1);
                    return this.onInit.then(function() {
                        if (_this9.childExports) return _this9.childExports.updateProps(_this9.getPropsForChild());
                        throw new Error("Child exports were not available");
                    });
                };
                ParentComponent.prototype.openBridge = function(domain) {
                    var _this10 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge && _this10.driver.needsBridge) {
                            var needsBridgeParams = {
                                win: _this10.window
                            };
                            domain && (needsBridgeParams.domain = domain);
                            var needsBridge = __WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge.needsBridge(needsBridgeParams), bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);
                            if (bridgeUrl) {
                                bridgeUrl = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.u)(bridgeUrl, {
                                    query: {
                                        version: _this10.component.version
                                    }
                                });
                                var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);
                                if (!bridgeDomain) throw new Error("Can not determine domain for bridge");
                                return needsBridge ? __WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge.openBridge(bridgeUrl, bridgeDomain).then(function(result) {
                                    if (result) return result;
                                }) : void 0;
                            }
                            if (needsBridge && domain && !__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge.hasBridge(domain, domain)) throw new Error("Bridge url needed to render " + _this10.context);
                        }
                    });
                };
                ParentComponent.prototype.open = function() {
                    var _this11 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this11.component.log("open_" + _this11.context, {
                            windowName: _this11.childWindowName
                        });
                        return _this11.driver.open.call(_this11);
                    });
                };
                ParentComponent.prototype.openPrerender = function() {
                    var _this12 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (_this12.component.prerenderTemplate) return _this12.driver.openPrerender.call(_this12);
                    });
                };
                ParentComponent.prototype.switchPrerender = function() {
                    var _this13 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (_this13.prerenderWindow && _this13.driver.switchPrerender) return _this13.driver.switchPrerender.call(_this13);
                    });
                };
                ParentComponent.prototype.elementReady = function(element) {
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.p)(element).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                };
                ParentComponent.prototype.delegate = function(win) {
                    var _this14 = this;
                    this.component.log("delegate_" + this.context);
                    for (var props = {
                        uid: this.props.uid,
                        dimensions: this.props.dimensions,
                        onClose: this.props.onClose,
                        onDisplay: this.props.onDisplay
                    }, _iterator2 = this.component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref9;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref9 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref9 = _i2.value;
                        }
                        var propName = _ref9;
                        this.component.getProp(propName).allowDelegate && (props[propName] = this.props[propName]);
                    }
                    var delegate = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.send)(win, __WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.DELEGATE + "_" + this.component.name, {
                        context: this.context,
                        env: this.props.env,
                        options: {
                            context: this.context,
                            childWindowName: this.childWindowName,
                            props: props,
                            overrides: {
                                focus: function() {
                                    return _this14.focus();
                                },
                                userClose: function() {
                                    return _this14.userClose();
                                },
                                getDomain: function() {
                                    return _this14.getDomain();
                                },
                                error: function(err) {
                                    return _this14.error(err);
                                },
                                on: function(eventName, handler) {
                                    return _this14.on(eventName, handler);
                                }
                            }
                        }
                    }).then(function(_ref10) {
                        var data = _ref10.data;
                        _this14.clean.register(data.destroy);
                        return data;
                    }).catch(function(err) {
                        throw new Error("Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n" + Object(__WEBPACK_IMPORTED_MODULE_6__lib__.X)(err));
                    }), overrides = this.driver.delegateOverrides;
                    _loop2: for (var _iterator3 = Object.keys(overrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                        var _ref11, _ret = function() {
                            if (_isArray3) {
                                if (_i3 >= _iterator3.length) return "break";
                                _ref11 = _iterator3[_i3++];
                            } else {
                                _i3 = _iterator3.next();
                                if (_i3.done) return "break";
                                _ref11 = _i3.value;
                            }
                            var key = _ref11, val = overrides[key];
                            if (val === __WEBPACK_IMPORTED_MODULE_7__constants__.DELEGATE.CALL_ORIGINAL) return "continue";
                            var original = _this14[key];
                            _this14[key] = function() {
                                var _this15 = this, _arguments = arguments;
                                return delegate.then(function(data) {
                                    var override = data.overrides[key];
                                    if (val === __WEBPACK_IMPORTED_MODULE_7__constants__.DELEGATE.CALL_DELEGATE) return override.apply(_this15, _arguments);
                                    if (val instanceof Function) return val(original, override).apply(_this15, _arguments);
                                    throw new Error("Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method");
                                });
                            };
                        }();
                        switch (_ret) {
                          case "break":
                            break _loop2;

                          case "continue":
                            continue;
                        }
                    }
                };
                ParentComponent.prototype.watchForClose = function() {
                    var _this16 = this, closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.B)(this.window, function() {
                        _this16.component.log("detect_close_child");
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            return _this16.props.onClose(__WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.CLOSE_DETECTED);
                        }).finally(function() {
                            return _this16.destroy();
                        });
                    }, 3e3);
                    this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
                };
                ParentComponent.prototype.watchForUnload = function() {
                    var _this17 = this, onunload = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.L)(function() {
                        _this17.component.log("navigate_away");
                        __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g();
                        _this17.destroyComponent();
                    }), unloadWindowListener = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.b)(window, "unload", onunload);
                    this.clean.register("destroyUnloadWindowListener", unloadWindowListener.cancel);
                };
                ParentComponent.prototype.loadUrl = function(url) {
                    var _this18 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this18.component.log("load_url");
                        if (window.location.href.split("#")[0] === url.split("#")[0]) {
                            var _query;
                            url = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.u)(url, {
                                query: (_query = {}, _query[Object(__WEBPACK_IMPORTED_MODULE_6__lib__._0)()] = "1", 
                                _query)
                            });
                        }
                        return _this18.driver.loadUrl.call(_this18, url);
                    });
                };
                ParentComponent.prototype.hijack = function(targetElement) {
                    targetElement.target = this.childWindowName;
                };
                ParentComponent.prototype.runTimeout = function() {
                    var _this19 = this;
                    if (this.props.timeout) {
                        this.timeout = setTimeout(function() {
                            _this19.component.log("timed_out", {
                                timeout: _this19.props.timeout
                            });
                            var error = _this19.component.createError("Loading component timed out after " + _this19.props.timeout + " milliseconds");
                            _this19.onInit.reject(error);
                            _this19.props.onTimeout(error);
                        }, this.props.timeout);
                        this.clean.register(function() {
                            clearTimeout(_this19.timeout);
                            delete _this19.timeout;
                        });
                    }
                };
                ParentComponent.prototype.listeners = function() {
                    var _ref12;
                    return _ref12 = {}, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.INIT] = function(source, data) {
                        this.childExports = data.exports;
                        this.onInit.resolve(this);
                        this.timeout && clearTimeout(this.timeout);
                        return {
                            props: this.getPropsForChild(),
                            context: this.context
                        };
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.CLOSE] = function(source, data) {
                        this.close(data.reason);
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.CHECK_CLOSE] = function(source, data) {
                        this.checkClose();
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.RESIZE] = function(source, data) {
                        var _this20 = this;
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            if (_this20.driver.allowResize) return _this20.resize(data.width, data.height);
                        });
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.ONRESIZE] = function(source, data) {
                        this.event.trigger("resize");
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.HIDE] = function(source, data) {
                        this.hide();
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.SHOW] = function(source, data) {
                        this.show();
                    }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__.POST_MESSAGE.ERROR] = function(source, data) {
                        this.error(new Error(data.error));
                    }, _ref12;
                };
                ParentComponent.prototype.resize = function(width, height) {
                    var _this21 = this, _ref13 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, _ref13$waitForTransit = _ref13.waitForTransition, waitForTransition = void 0 === _ref13$waitForTransit || _ref13$waitForTransit;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this21.component.log("resize", {
                            height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(height),
                            width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__.W)(width)
                        });
                        _this21.driver.resize.call(_this21, width, height);
                        if (waitForTransition && (_this21.element || _this21.iframe)) {
                            var overflow = void 0;
                            _this21.element && (overflow = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.T)(_this21.element, "hidden"));
                            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.q)(_this21.element || _this21.iframe).then(function() {
                                overflow && overflow.reset();
                            });
                        }
                    });
                };
                ParentComponent.prototype.hide = function() {
                    this.container && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.A)(this.container);
                    return this.driver.hide.call(this);
                };
                ParentComponent.prototype.show = function() {
                    this.container && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.V)(this.container);
                    return this.driver.show.call(this);
                };
                ParentComponent.prototype.checkClose = function() {
                    var _this22 = this, closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.B)(this.window, function() {
                        _this22.userClose();
                    }, 50, 500);
                    this.clean.register(closeWindowListener.cancel);
                };
                ParentComponent.prototype.userClose = function() {
                    return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.USER_CLOSED);
                };
                ParentComponent.prototype.close = function() {
                    var _this23 = this, reason = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.PARENT_CALL;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this23.component.log("close", {
                            reason: reason
                        });
                        _this23.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__.EVENTS.CLOSE);
                        return _this23.props.onClose(reason);
                    }).then(function() {
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ _this23.closeComponent(), _this23.closeContainer() ]);
                    }).then(function() {
                        return _this23.destroy();
                    });
                };
                ParentComponent.prototype.closeContainer = function() {
                    var _this24 = this, reason = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.PARENT_CALL;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this24.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__.EVENTS.CLOSE);
                        return _this24.props.onClose(reason);
                    }).then(function() {
                        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all([ _this24.closeComponent(reason), _this24.hideContainer() ]);
                    }).then(function() {
                        return _this24.destroyContainer();
                    });
                };
                ParentComponent.prototype.destroyContainer = function() {
                    var _this25 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this25.clean.run("destroyContainerEvents");
                        _this25.clean.run("destroyContainerTemplate");
                    });
                };
                ParentComponent.prototype.closeComponent = function() {
                    var _this26 = this, reason = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__.CLOSE_REASONS.PARENT_CALL, win = this.window;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        return _this26.cancelContainerEvents();
                    }).then(function() {
                        _this26.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__.EVENTS.CLOSE);
                        return _this26.props.onClose(reason);
                    }).then(function() {
                        return _this26.hideComponent();
                    }).then(function() {
                        return _this26.destroyComponent();
                    }).then(function() {
                        _this26.childExports && _this26.context === __WEBPACK_IMPORTED_MODULE_7__constants__.CONTEXT_TYPES.POPUP && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(win) && _this26.childExports.close().catch(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                    });
                };
                ParentComponent.prototype.destroyComponent = function() {
                    this.clean.run("destroyUnloadWindowListener");
                    this.clean.run("destroyCloseWindowListener");
                    this.clean.run("destroyContainerEvents");
                    this.clean.run("destroyWindow");
                };
                ParentComponent.prototype.showContainer = function() {
                    var _this27 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (_this27.props.onDisplay) return _this27.props.onDisplay();
                    }).then(function() {
                        if (_this27.container) return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.U)(_this27.container, __WEBPACK_IMPORTED_MODULE_7__constants__.ANIMATION_NAMES.SHOW_CONTAINER, _this27.clean.register);
                    });
                };
                ParentComponent.prototype.showComponent = function() {
                    var _this28 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (_this28.props.onDisplay) return _this28.props.onDisplay();
                    }).then(function() {
                        if (_this28.element) return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.U)(_this28.element, __WEBPACK_IMPORTED_MODULE_7__constants__.ANIMATION_NAMES.SHOW_COMPONENT, _this28.clean.register);
                    });
                };
                ParentComponent.prototype.hideContainer = function() {
                    var _this29 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        return _this29.container ? Object(__WEBPACK_IMPORTED_MODULE_6__lib__.c)(_this29.container, __WEBPACK_IMPORTED_MODULE_7__constants__.ANIMATION_NAMES.HIDE_CONTAINER, _this29.clean.register) : __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.resolve();
                    });
                };
                ParentComponent.prototype.hideComponent = function() {
                    var _this30 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        return _this30.element ? Object(__WEBPACK_IMPORTED_MODULE_6__lib__.c)(_this30.element, __WEBPACK_IMPORTED_MODULE_7__constants__.ANIMATION_NAMES.HIDE_COMPONENT, _this30.clean.register) : __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.resolve();
                    });
                };
                ParentComponent.prototype.focus = function() {
                    if (!this.window || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.y)(this.window)) throw new Error("No window to focus");
                    if (this.driver.openOnFocus) try {
                        window.open("", this.childWindowName).focus();
                    } catch (err) {}
                    this.component.log("focus");
                    this.window.focus();
                };
                ParentComponent.prototype.createPrerenderTemplate = function() {
                    var _this31 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        return _this31.component.prerenderTemplate ? __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                            return _this31.prerenderIframe ? Object(__WEBPACK_IMPORTED_MODULE_6__lib__.e)(_this31.prerenderIframe).then(function() {
                                return _this31.prerenderWindow;
                            }) : _this31.prerenderWindow;
                        }).then(function(win) {
                            var doc = void 0;
                            try {
                                doc = win.document;
                            } catch (err) {
                                return;
                            }
                            try {
                                Object(__WEBPACK_IMPORTED_MODULE_6__lib__._4)(win, _this31.renderTemplate(_this31.component.prerenderTemplate, {
                                    jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__.F.bind(doc),
                                    document: doc
                                }));
                            } catch (err) {
                                return;
                            }
                        }) : __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.resolve();
                    });
                };
                ParentComponent.prototype.renderTemplate = function(renderer) {
                    var _this32 = this, options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _ref14 = this.component.dimensions || {}, _ref14$width = _ref14.width, width = void 0 === _ref14$width ? __WEBPACK_IMPORTED_MODULE_7__constants__.DEFAULT_DIMENSIONS.WIDTH + "px" : _ref14$width, _ref14$height = _ref14.height, height = void 0 === _ref14$height ? __WEBPACK_IMPORTED_MODULE_7__constants__.DEFAULT_DIMENSIONS.HEIGHT + "px" : _ref14$height;
                    return renderer.call(this, _extends({
                        id: __WEBPACK_IMPORTED_MODULE_7__constants__.CLASS_NAMES.XCOMPONENT + "-" + this.component.tag + "-" + this.props.uid,
                        props: renderer.__xdomain__ ? null : this.props,
                        tag: this.component.tag,
                        context: this.context,
                        outlet: this.getOutlet(),
                        CLASS: __WEBPACK_IMPORTED_MODULE_7__constants__.CLASS_NAMES,
                        ANIMATION: __WEBPACK_IMPORTED_MODULE_7__constants__.ANIMATION_NAMES,
                        CONTEXT: __WEBPACK_IMPORTED_MODULE_7__constants__.CONTEXT_TYPES,
                        EVENT: __WEBPACK_IMPORTED_MODULE_7__constants__.EVENTS,
                        actions: {
                            close: function() {
                                return _this32.userClose();
                            },
                            focus: function() {
                                return _this32.focus();
                            }
                        },
                        on: function(eventName, handler) {
                            return _this32.on(eventName, handler);
                        },
                        jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__.F,
                        document: document,
                        dimensions: {
                            width: width,
                            height: height
                        }
                    }, options));
                };
                ParentComponent.prototype.openContainer = function(element) {
                    var _this33 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        var el = void 0;
                        el = element ? Object(__WEBPACK_IMPORTED_MODULE_6__lib__.x)(element) : document.body;
                        if (!el) throw new Error("Could not find element to open container into");
                        if (_this33.component.containerTemplate) {
                            var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                                container: el
                            });
                            _this33.container = container;
                            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.A)(_this33.container);
                            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.d)(el, _this33.container);
                            if (_this33.driver.renderedIntoContainerTemplate) {
                                _this33.element = _this33.getOutlet();
                                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.A)(_this33.element);
                                if (!_this33.element) throw new Error("Could not find element to render component into");
                                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.A)(_this33.element);
                            }
                            _this33.clean.register("destroyContainerTemplate", function() {
                                _this33.container && _this33.container.parentNode && _this33.container.parentNode.removeChild(_this33.container);
                                delete _this33.container;
                            });
                        } else if (_this33.driver.renderedIntoContainerTemplate) throw new Error("containerTemplate needed to render " + _this33.context);
                    });
                };
                ParentComponent.prototype.cancelContainerEvents = function() {
                    this.clean.run("destroyContainerEvents");
                };
                ParentComponent.prototype.destroy = function() {
                    var _this34 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        if (_this34.clean.hasTasks()) {
                            _this34.component.log("destroy");
                            __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g();
                            return _this34.clean.all();
                        }
                    });
                };
                ParentComponent.prototype.tryInit = function(method) {
                    var _this35 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(method).catch(function(err) {
                        _this35.onInit.reject(err);
                    }).then(function() {
                        return _this35.onInit;
                    });
                };
                ParentComponent.prototype.error = function(err) {
                    var _this36 = this;
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.try(function() {
                        _this36.handledErrors = _this36.handledErrors || [];
                        if (-1 === _this36.handledErrors.indexOf(err)) {
                            _this36.handledErrors.push(err);
                            _this36.onInit.reject(err);
                            return _this36.destroy();
                        }
                    }).then(function() {
                        if (_this36.props.onError) return _this36.props.onError(err);
                    }).catch(function(errErr) {
                        throw new Error("An error was encountered while handling error:\n\n " + Object(__WEBPACK_IMPORTED_MODULE_6__lib__.X)(err) + "\n\n" + Object(__WEBPACK_IMPORTED_MODULE_6__lib__.X)(errErr));
                    }).then(function() {
                        if (!_this36.props.onError) throw err;
                    });
                };
                ParentComponent.destroyAll = function() {
                    for (var results = []; ParentComponent.activeComponents.length; ) results.push(ParentComponent.activeComponents[0].destroy());
                    return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__.a.all(results).then(__WEBPACK_IMPORTED_MODULE_6__lib__.I);
                };
                _createClass(ParentComponent, [ {
                    key: "driver",
                    get: function() {
                        if (!this.context) throw new Error("Context not set");
                        return __WEBPACK_IMPORTED_MODULE_8__drivers__.a[this.context];
                    }
                } ]);
                return ParentComponent;
            }(__WEBPACK_IMPORTED_MODULE_4__base__.a), _applyDecoratedDescriptor(_class.prototype, "getOutlet", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "getOutlet"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "prefetch", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "prefetch"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "loadHTML", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "loadHTML"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "buildUrl", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "buildUrl"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "open", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "openPrerender", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "openPrerender"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "switchPrerender", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "switchPrerender"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "close", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "closeContainer", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "closeContainer"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "destroyContainer", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "destroyContainer"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "closeComponent", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "closeComponent"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "showContainer", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "showContainer"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "showComponent", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "showComponent"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "hideContainer", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "hideContainer"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "hideComponent", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "hideComponent"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "createPrerenderTemplate", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "createPrerenderTemplate"), _class.prototype), 
            _applyDecoratedDescriptor(_class.prototype, "openContainer", [ __WEBPACK_IMPORTED_MODULE_6__lib__.H ], Object.getOwnPropertyDescriptor(_class.prototype, "openContainer"), _class.prototype), 
            _class);
            ParentComponent.activeComponents = [];
        },
        "./node_modules/xcomponent/src/component/parent/props.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isDefined(value) {
                return null !== value && void 0 !== value && "" !== value;
            }
            function normalizeProp(component, instance, props, key, value) {
                var prop = component.getProp(key), resultValue = void 0;
                resultValue = prop.value ? prop.value : !prop.def || props.hasOwnProperty(key) && isDefined(value) ? value : prop.def.call(component, props);
                !resultValue && prop.alias && props[prop.alias] && (resultValue = props[prop.alias]);
                var decorated = !1;
                if (prop.decorate && null !== resultValue && void 0 !== resultValue) {
                    resultValue = prop.decorate(resultValue, props);
                    decorated = !0;
                }
                if ("boolean" === prop.type) resultValue = Boolean(resultValue); else if ("function" === prop.type) {
                    if (!resultValue && prop.noop) {
                        resultValue = __WEBPACK_IMPORTED_MODULE_1__lib__.I;
                        !decorated && prop.decorate && (resultValue = prop.decorate(resultValue, props));
                    }
                    if (resultValue && "function" == typeof resultValue) {
                        resultValue = resultValue.bind(instance);
                        prop.denodeify && (resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__.j)(resultValue));
                        prop.promisify && (resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__.O)(resultValue));
                        var original = resultValue;
                        resultValue = function() {
                            component.log("call_prop_" + key);
                            return original.apply(this, arguments);
                        };
                        prop.once && (resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__.L)(resultValue));
                        prop.memoize && (resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__.G)(resultValue));
                    }
                } else "string" === prop.type || "object" === prop.type || "number" === prop.type && void 0 !== resultValue && (resultValue = parseInt(resultValue, 10));
                return resultValue;
            }
            function normalizeProps(component, instance, props) {
                var result = (!(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], 
                {});
                props = props || {};
                result.version = component.version;
                for (var _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref;
                    -1 !== component.getPropNames().indexOf(key) ? result[key] = normalizeProp(component, instance, props, key, props[key]) : result[key] = props[key];
                }
                for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var _key = _ref2;
                    if (!(props.hasOwnProperty(_key) || instance.props && instance.props.hasOwnProperty(_key))) {
                        var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);
                        void 0 !== normalizedProp && (result[_key] = normalizedProp);
                    }
                }
                return result;
            }
            function getQueryParam(prop, key, value) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    return "function" == typeof prop.queryParam ? prop.queryParam(value) : "string" == typeof prop.queryParam ? prop.queryParam : key;
                });
            }
            function getQueryValue(prop, key, value) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    return "function" == typeof prop.queryValue ? prop.queryValue(value) : value;
                });
            }
            function propsToQuery(propsDef, props) {
                var params = {};
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all(Object.keys(props).map(function(key) {
                    var prop = propsDef[key];
                    if (prop) return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve().then(function() {
                        var value = props[key];
                        if (value && prop.queryParam) return value;
                    }).then(function(value) {
                        value && __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ getQueryParam(prop, key, value), getQueryValue(prop, key, value) ]).then(function(_ref3) {
                            var queryParam = _ref3[0], queryValue = _ref3[1], result = void 0;
                            if ("boolean" == typeof queryValue) result = "1"; else if ("string" == typeof queryValue) result = queryValue.toString(); else {
                                if ("function" == typeof queryValue) return;
                                if ("object" === (void 0 === queryValue ? "undefined" : _typeof(queryValue)) && null !== queryValue) {
                                    if ("json" !== prop.serialization) {
                                        result = Object(__WEBPACK_IMPORTED_MODULE_1__lib__.o)(queryValue, key);
                                        for (var dotkey in result) params[dotkey] = result[dotkey];
                                        return;
                                    }
                                    result = JSON.stringify(queryValue);
                                } else "number" == typeof queryValue && (result = queryValue.toString());
                            }
                            params[queryParam] = result;
                        });
                    });
                })).then(function() {
                    return params;
                });
            }
            __webpack_exports__.a = normalizeProps;
            __webpack_exports__.b = propsToQuery;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), _typeof = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/component/props.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js"), 
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            });
        },
        "./node_modules/xcomponent/src/component/parent/validate.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function validateProp(prop, key, value, props) {
                var required = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                if (null !== value && void 0 !== value && "" !== value) {
                    if (!value || "function" != typeof value.then || !prop.promise) {
                        if ("function" === prop.type) {
                            if (!(value instanceof Function)) throw new Error("Prop is not of type function: " + key);
                        } else if ("string" === prop.type) {
                            if ("string" != typeof value) throw new Error("Prop is not of type string: " + key);
                        } else if ("object" === prop.type) try {
                            JSON.stringify(value);
                        } catch (err) {
                            throw new Error("Unable to serialize prop: " + key);
                        } else if ("number" === prop.type && isNaN(parseInt(value, 10))) throw new Error("Prop is not a number: " + key);
                        "function" == typeof prop.validate && value && prop.validate(value, props);
                    }
                } else if (required && !1 !== prop.required && !prop.hasOwnProperty("def")) throw new Error("Prop is required: " + key);
            }
            function validateProps(component, props) {
                var required = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                props = props || {};
                if (props.env && "object" === _typeof(component.url) && !component.url[props.env]) throw new Error("Invalid env: " + props.env);
                for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref, prop = component.getProp(key);
                    if (prop.alias && props.hasOwnProperty(prop.alias)) {
                        var value = props[prop.alias];
                        delete props[prop.alias];
                        props[key] || (props[key] = value);
                    }
                }
                for (var _iterator2 = Object.keys(props), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var _key = _ref2, _prop = component.getProp(_key), _value = props[_key];
                    _prop && validateProp(_prop, _key, _value, props, required);
                }
                for (var _iterator3 = component.getPropNames(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref3 = _i3.value;
                    }
                    var _key2 = _ref3, _prop2 = component.getProp(_key2), _value2 = props[_key2];
                    _prop2 && !props.hasOwnProperty(_key2) && validateProp(_prop2, _key2, _value2, props, required);
                }
            }
            __webpack_exports__.a = validateProps;
            var _typeof = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/component/props.js"), 
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            });
        },
        "./node_modules/xcomponent/src/component/window.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function normalize(str) {
                return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, "").replace(/[^a-z0-9A-Z]+/g, "_");
            }
            function buildChildWindowName(name, version) {
                var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                options.id = Object(__WEBPACK_IMPORTED_MODULE_2__lib__._0)();
                options.domain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.f)(window);
                var encodedName = normalize(name), encodedVersion = normalize(version), encodedOptions = __WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.encode(JSON.stringify(options)).replace(/\=/g, "").toLowerCase();
                if (!encodedName) throw new Error("Invalid name: " + name + " - must contain alphanumeric characters");
                if (!encodedVersion) throw new Error("Invalid version: " + version + " - must contain alphanumeric characters");
                return [ __WEBPACK_IMPORTED_MODULE_3__constants__.XCOMPONENT, encodedName, encodedVersion, encodedOptions, "" ].join("__");
            }
            function getParentDomain() {
                return getComponentMeta().domain;
            }
            function getWindowByRef(_ref) {
                var ref = _ref.ref, uid = _ref.uid, distance = _ref.distance, result = void 0;
                ref === __WEBPACK_IMPORTED_MODULE_3__constants__.WINDOW_REFERENCES.OPENER ? result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.k)(window) : ref === __WEBPACK_IMPORTED_MODULE_3__constants__.WINDOW_REFERENCES.TOP ? result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.m)(window) : ref === __WEBPACK_IMPORTED_MODULE_3__constants__.WINDOW_REFERENCES.PARENT && (result = distance ? Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.j)(window, distance) : Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.l)(window));
                if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__.WINDOW_REFERENCES.GLOBAL) {
                    var ancestor = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.d)(window);
                    if (ancestor) for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.c)(ancestor), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref2 = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref2 = _i.value;
                        }
                        var frame = _ref2, global = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.z)(frame);
                        if (global && global.windows && global.windows[uid]) {
                            result = global.windows[uid];
                            break;
                        }
                    }
                }
                if (!result) throw new Error("Unable to find window by ref");
                return result;
            }
            function getPosition(_ref3) {
                var width = _ref3.width, height = _ref3.height, x = 0, y = 0;
                width && (window.outerWidth ? x = Math.round((window.outerWidth - width) / 2) + window.screenX : window.screen.width && (x = Math.round((window.screen.width - width) / 2)));
                height && (window.outerHeight ? y = Math.round((window.outerHeight - height) / 2) + window.screenY : window.screen.height && (y = Math.round((window.screen.height - height) / 2)));
                return {
                    x: x,
                    y: y
                };
            }
            __webpack_exports__.a = buildChildWindowName;
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return isXComponentWindow;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return getComponentMeta;
            });
            __webpack_exports__.d = getParentDomain;
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return getParentComponentWindow;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return getParentRenderWindow;
            });
            __webpack_exports__.f = getPosition;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_hi_base32__ = __webpack_require__("./node_modules/xcomponent/node_modules/hi-base32/src/base32.js"), __WEBPACK_IMPORTED_MODULE_1_hi_base32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hi_base32__), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), isXComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.G)(function() {
                return !!window.name && window.name.split("__")[0] === __WEBPACK_IMPORTED_MODULE_3__constants__.XCOMPONENT;
            }), getComponentMeta = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.G)(function() {
                if (!window.name) throw new Error("Can not get component meta without window name");
                var _window$name$split2 = window.name.split("__"), xcomp = _window$name$split2[0], name = _window$name$split2[1], version = _window$name$split2[2], encodedOptions = _window$name$split2[3];
                if (xcomp !== __WEBPACK_IMPORTED_MODULE_3__constants__.XCOMPONENT) throw new Error("Window not rendered by xcomponent - got " + xcomp);
                var componentMeta = void 0;
                try {
                    componentMeta = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.decode(encodedOptions.toUpperCase()));
                } catch (err) {
                    throw new Error("Can not decode component-meta");
                }
                componentMeta.name = name;
                componentMeta.version = version.replace(/_/g, ".");
                return componentMeta;
            }), getParentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.G)(function() {
                var componentMeta = getComponentMeta();
                if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by xcomponent");
                return getWindowByRef(componentMeta.componentParent);
            }), getParentRenderWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.G)(function() {
                var componentMeta = getComponentMeta();
                if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by xcomponent");
                return getWindowByRef(componentMeta.renderParent);
            });
        },
        "./node_modules/xcomponent/src/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            __webpack_require__.d(__webpack_exports__, "XCOMPONENT", function() {
                return XCOMPONENT;
            });
            __webpack_require__.d(__webpack_exports__, "__XCOMPONENT__", function() {
                return __XCOMPONENT__;
            });
            __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", function() {
                return POST_MESSAGE;
            });
            __webpack_require__.d(__webpack_exports__, "PROP_TYPES", function() {
                return PROP_TYPES;
            });
            __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", function() {
                return INITIAL_PROPS;
            });
            __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", function() {
                return WINDOW_REFERENCES;
            });
            __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", function() {
                return PROP_TYPES_LIST;
            });
            __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", function() {
                return CONTEXT_TYPES;
            });
            __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", function() {
                return CLASS_NAMES;
            });
            __webpack_require__.d(__webpack_exports__, "EVENTS", function() {
                return EVENTS;
            });
            __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() {
                return ATTRIBUTES;
            });
            __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", function() {
                return ANIMATION_NAMES;
            });
            __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", function() {
                return EVENT_NAMES;
            });
            __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", function() {
                return CLOSE_REASONS;
            });
            __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", function() {
                return CONTEXT_TYPES_LIST;
            });
            __webpack_require__.d(__webpack_exports__, "DELEGATE", function() {
                return DELEGATE;
            });
            __webpack_require__.d(__webpack_exports__, "WILDCARD", function() {
                return WILDCARD;
            });
            __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", function() {
                return DEFAULT_DIMENSIONS;
            });
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), XCOMPONENT = "xcomponent", __XCOMPONENT__ = "__" + XCOMPONENT + "__", POST_MESSAGE = {
                INIT: XCOMPONENT + "_init",
                PROPS: XCOMPONENT + "_props",
                PROP_CALLBACK: XCOMPONENT + "_prop_callback",
                CLOSE: XCOMPONENT + "_close",
                CHECK_CLOSE: XCOMPONENT + "_check_close",
                REDIRECT: XCOMPONENT + "_redirect",
                RESIZE: XCOMPONENT + "_resize",
                ONRESIZE: XCOMPONENT + "_onresize",
                DELEGATE: XCOMPONENT + "_delegate",
                ALLOW_DELEGATE: XCOMPONENT + "_allow_delegate",
                ERROR: XCOMPONENT + "_error",
                HIDE: XCOMPONENT + "_hide",
                SHOW: XCOMPONENT + "_show"
            }, PROP_TYPES = {
                STRING: "string",
                OBJECT: "object",
                FUNCTION: "function",
                BOOLEAN: "boolean",
                NUMBER: "number"
            }, INITIAL_PROPS = {
                RAW: "raw",
                UID: "uid"
            }, WINDOW_REFERENCES = {
                OPENER: "opener",
                TOP: "top",
                PARENT: "parent",
                GLOBAL: "global"
            }, PROP_TYPES_LIST = Object(__WEBPACK_IMPORTED_MODULE_0__lib__._1)(PROP_TYPES), CONTEXT_TYPES = {
                IFRAME: "iframe",
                POPUP: "popup"
            }, CLASS_NAMES = {
                XCOMPONENT: "" + XCOMPONENT,
                OUTLET: XCOMPONENT + "-outlet",
                COMPONENT_FRAME: XCOMPONENT + "-component-frame",
                PRERENDER_FRAME: XCOMPONENT + "-prerender-frame",
                VISIBLE: XCOMPONENT + "-visible",
                INVISIBLE: XCOMPONENT + "-invisible"
            }, EVENTS = {
                CLOSE: XCOMPONENT + "-close"
            }, ATTRIBUTES = {
                IFRAME_PLACEHOLDER: "data-xcomponent-" + XCOMPONENT + "-placeholder"
            }, ANIMATION_NAMES = {
                SHOW_CONTAINER: XCOMPONENT + "-show-container",
                SHOW_COMPONENT: XCOMPONENT + "-show-component",
                HIDE_CONTAINER: XCOMPONENT + "-hide-container",
                HIDE_COMPONENT: XCOMPONENT + "-hide-component"
            }, EVENT_NAMES = {
                CLICK: "click"
            }, CLOSE_REASONS = {
                PARENT_CALL: "parent_call",
                CHILD_CALL: "child_call",
                CLOSE_DETECTED: "close_detected",
                USER_CLOSED: "user_closed",
                PARENT_CLOSE_DETECTED: "parent_close_detected"
            }, CONTEXT_TYPES_LIST = Object(__WEBPACK_IMPORTED_MODULE_0__lib__._1)(CONTEXT_TYPES), DELEGATE = {
                CALL_ORIGINAL: "call_original",
                CALL_DELEGATE: "call_delegate"
            }, WILDCARD = "*", DEFAULT_DIMENSIONS = {
                WIDTH: 300,
                HEIGHT: 150
            };
        },
        "./node_modules/xcomponent/src/drivers/angular.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return angular;
            });
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), angular = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            {
                global: function() {
                    return window.angular;
                },
                register: function(component, ng) {
                    return ng.module(component.tag, []).directive(Object(__WEBPACK_IMPORTED_MODULE_0__lib__.i)(component.tag), function() {
                        for (var scope = {}, _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            scope[_ref] = "=";
                        }
                        component.looseProps && (scope.props = "=");
                        return {
                            scope: scope,
                            restrict: "E",
                            controller: [ "$scope", "$element", function($scope, $element) {
                                function safeApply(fn) {
                                    if ("$apply" !== $scope.$root.$$phase && "$digest" !== $scope.$root.$$phase) try {
                                        $scope.$apply();
                                    } catch (err) {
                                        console.warn("Error trying to scope.apply on prop function call:", err);
                                    }
                                }
                                if (component.looseProps && !$scope.props) throw new Error("For angular bindings to work, prop definitions must be passed to xcomponent.create");
                                component.log("instantiate_angular_component");
                                var getProps = function() {
                                    var scopeProps = void 0;
                                    if ($scope.props) scopeProps = $scope.props; else {
                                        scopeProps = {};
                                        for (var _iterator2 = Object.keys(scope), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                                            var _ref2;
                                            if (_isArray2) {
                                                if (_i2 >= _iterator2.length) break;
                                                _ref2 = _iterator2[_i2++];
                                            } else {
                                                _i2 = _iterator2.next();
                                                if (_i2.done) break;
                                                _ref2 = _i2.value;
                                            }
                                            var key = _ref2;
                                            scopeProps[key] = $scope[key];
                                        }
                                    }
                                    scopeProps = Object(__WEBPACK_IMPORTED_MODULE_0__lib__.Q)(scopeProps, function(value, key, fullKey) {
                                        if ("function" == typeof value) return function() {
                                            var result = value.apply(this, arguments);
                                            safeApply();
                                            return result;
                                        };
                                    });
                                    return scopeProps;
                                }, parent = component.init(getProps(), null, $element[0]);
                                parent.render($element[0]);
                                $scope.$watch(function() {
                                    parent.updateProps(getProps());
                                });
                            } ]
                        };
                    });
                }
            });
        },
        "./node_modules/xcomponent/src/drivers/angular2.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return angular2;
            });
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), _extends = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }), angular2 = {
                global: function() {},
                register: function(xcomponent, _ref) {
                    var AngularComponent = _ref.Component, NgModule = _ref.NgModule, ElementRef = _ref.ElementRef, NgZone = _ref.NgZone;
                    xcomponent.log("initializing angular2 component");
                    var getProps = function(component) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0__lib__.Q)(_extends({}, component.internalProps, component.props), function(value, key, fullKey) {
                            if ("function" == typeof value) return function() {
                                var _this = this, _arguments = arguments;
                                return component.zone.run(function() {
                                    return value.apply(_this, _arguments);
                                });
                            };
                        });
                    }, ComponentInstance = AngularComponent({
                        selector: xcomponent.tag,
                        template: "<div></div>",
                        inputs: [ "props" ]
                    }).Class({
                        constructor: [ ElementRef, NgZone, function(elementRef, zone) {
                            this.elementRef = elementRef;
                            this.zone = zone;
                        } ],
                        ngOnInit: function() {
                            var targetElement = this.elementRef.nativeElement, parent = xcomponent.init(getProps(this), null, targetElement);
                            parent.render(targetElement);
                            this.parent = parent;
                        },
                        ngOnChanges: function() {
                            this.parent && this.parent.updateProps(getProps(this));
                        }
                    });
                    return NgModule({
                        declarations: [ ComponentInstance ],
                        exports: [ ComponentInstance ]
                    }).Class({
                        constructor: function() {}
                    });
                }
            };
        },
        "./node_modules/xcomponent/src/drivers/ember.js": function(module, exports) {},
        "./node_modules/xcomponent/src/drivers/glimmer.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return glimmer;
            });
            var _extends = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }), glimmer = {
                global: function() {},
                register: function(component, GlimmerComponent) {
                    return function(_GlimmerComponent) {
                        function _class() {
                            _classCallCheck(this, _class);
                            return _possibleConstructorReturn(this, _GlimmerComponent.apply(this, arguments));
                        }
                        _inherits(_class, _GlimmerComponent);
                        _class.prototype.didInsertElement = function() {
                            component.render(_extends({}, this.args), this.element);
                        };
                        return _class;
                    }(GlimmerComponent);
                }
            };
        },
        "./node_modules/xcomponent/src/drivers/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__script__ = __webpack_require__("./node_modules/xcomponent/src/drivers/script.js");
            __webpack_require__.d(__webpack_exports__, "htmlComponent", function() {
                return __WEBPACK_IMPORTED_MODULE_0__script__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__react__ = __webpack_require__("./node_modules/xcomponent/src/drivers/react.js");
            __webpack_require__.d(__webpack_exports__, "react", function() {
                return __WEBPACK_IMPORTED_MODULE_1__react__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__vue__ = __webpack_require__("./node_modules/xcomponent/src/drivers/vue.js");
            __webpack_require__.d(__webpack_exports__, "vue", function() {
                return __WEBPACK_IMPORTED_MODULE_2__vue__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_3__angular__ = __webpack_require__("./node_modules/xcomponent/src/drivers/angular.js");
            __webpack_require__.d(__webpack_exports__, "angular", function() {
                return __WEBPACK_IMPORTED_MODULE_3__angular__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_4__ember__ = __webpack_require__("./node_modules/xcomponent/src/drivers/ember.js");
            __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ember__);
            for (var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_4__ember__) [ "htmlComponent", "react", "vue", "angular", "default" ].indexOf(__WEBPACK_IMPORT_KEY__) < 0 && function(key) {
                __webpack_require__.d(__webpack_exports__, key, function() {
                    return __WEBPACK_IMPORTED_MODULE_4__ember__[key];
                });
            }(__WEBPACK_IMPORT_KEY__);
            var __WEBPACK_IMPORTED_MODULE_5__glimmer__ = __webpack_require__("./node_modules/xcomponent/src/drivers/glimmer.js");
            __webpack_require__.d(__webpack_exports__, "glimmer", function() {
                return __WEBPACK_IMPORTED_MODULE_5__glimmer__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_6__angular2__ = __webpack_require__("./node_modules/xcomponent/src/drivers/angular2.js");
            __webpack_require__.d(__webpack_exports__, "angular2", function() {
                return __WEBPACK_IMPORTED_MODULE_6__angular2__.a;
            });
        },
        "./node_modules/xcomponent/src/drivers/react.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return react;
            });
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), react = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            {
                global: function() {
                    if (window.React && window.ReactDOM) return {
                        React: window.React,
                        ReactDOM: window.ReactDOM
                    };
                },
                register: function(component, _ref) {
                    var React = _ref.React, ReactDOM = _ref.ReactDOM;
                    React.createClass ? component.react = React.createClass({
                        displayName: "react",
                        render: function() {
                            return React.createElement("div", null);
                        },
                        componentDidMount: function() {
                            component.log("instantiate_react_component");
                            var el = ReactDOM.findDOMNode(this), parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__.t)({}, this.props), null, el);
                            this.setState({
                                parent: parent
                            });
                            parent.render(el);
                        },
                        componentDidUpdate: function() {
                            this.state && this.state.parent && this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__.t)({}, this.props));
                        }
                    }) : component.react = function(_React$Component) {
                        function _class() {
                            _classCallCheck(this, _class);
                            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
                        }
                        _inherits(_class, _React$Component);
                        _class.prototype.render = function() {
                            return React.createElement("div", null);
                        };
                        _class.prototype.componentDidMount = function() {
                            component.log("instantiate_react_component");
                            var el = ReactDOM.findDOMNode(this), parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__.t)({}, this.props), null, el);
                            this.setState({
                                parent: parent
                            });
                            parent.render(el);
                        };
                        _class.prototype.componentDidUpdate = function() {
                            this.state && this.state.parent && this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__.t)({}, this.props));
                        };
                        return _class;
                    }(React.Component);
                    return component.react;
                }
            });
        },
        "./node_modules/xcomponent/src/drivers/script.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return htmlComponent;
            });
            var __WEBPACK_IMPORTED_MODULE_0__component_component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), htmlComponent = {
                global: function() {
                    return window.document;
                },
                register: function register(component, document) {
                    function render(element) {
                        if (element && element.tagName && "script" === element.tagName.toLowerCase() && element.attributes.type && "application/x-component" === element.attributes.type.value && element.parentNode) {
                            var tag = element.getAttribute("data-component");
                            if (tag && tag === component.tag) {
                                component.log("instantiate_script_component");
                                var props = element.innerText ? eval("(" + element.innerText + ")") : {}, container = document.createElement("div");
                                if (!element.parentNode) throw new Error("Element has no parent");
                                element.parentNode.replaceChild(container, element);
                                component.render(props, container);
                            }
                        }
                    }
                    function scan() {
                        for (var scriptTags = Array.prototype.slice.call(document.getElementsByTagName("script")), _iterator = scriptTags, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            render(_ref);
                        }
                    }
                    scan();
                    document.addEventListener("DOMContentLoaded", scan);
                    window.addEventListener("load", scan);
                    document.addEventListener("DOMNodeInserted", function(event) {
                        render(event.target);
                    });
                }
            };
        },
        "./node_modules/xcomponent/src/drivers/vue.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return vue;
            });
            var __WEBPACK_IMPORTED_MODULE_1__lib__ = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/lib/index.js")), vue = {
                global: function() {},
                register: function(component) {
                    return {
                        template: "<div></div>",
                        inheritAttrs: !1,
                        mounted: function() {
                            var el = this.$el;
                            this.parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_1__lib__.t)({}, this.$attrs), null, el);
                            this.parent.render(el);
                        },
                        beforeUpdate: function() {
                            this.parent && this.$attrs && this.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_1__lib__.t)({}, this.$attrs));
                        }
                    };
                }
            };
        },
        "./node_modules/xcomponent/src/error.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function PopupOpenError(message) {
                this.message = message;
            }
            function IntegrationError(message) {
                this.message = message;
            }
            function RenderError(message) {
                this.message = message;
            }
            __webpack_exports__.b = PopupOpenError;
            __webpack_exports__.a = IntegrationError;
            __webpack_exports__.c = RenderError;
            PopupOpenError.prototype = Object.create(Error.prototype);
            IntegrationError.prototype = Object.create(Error.prototype);
            RenderError.prototype = Object.create(Error.prototype);
        },
        "./node_modules/xcomponent/src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/xcomponent/src/interface.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.CONSTANTS;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.PopupOpenError;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.create;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.destroyAll;
            });
        },
        "./node_modules/xcomponent/src/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function create(options) {
                return new __WEBPACK_IMPORTED_MODULE_1__component__.a(options);
            }
            function getByTag(tag) {
                return __WEBPACK_IMPORTED_MODULE_1__component__.a.getByTag(tag);
            }
            function destroyAll() {
                return __WEBPACK_IMPORTED_MODULE_2__component_parent__.a.destroyAll();
            }
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            __webpack_exports__.create = create;
            __webpack_exports__.getByTag = getByTag;
            __webpack_exports__.destroyAll = destroyAll;
            __webpack_require__.d(__webpack_exports__, "postRobot", function() {
                return postRobot;
            });
            __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() {
                return CONSTANTS;
            });
            var __WEBPACK_IMPORTED_MODULE_1__component__ = (__webpack_require__("./node_modules/zalgo-promise/src/index.js"), 
            __webpack_require__("./node_modules/xcomponent/src/component/index.js")), __WEBPACK_IMPORTED_MODULE_2__component_parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
            __webpack_require__.d(__webpack_exports__, "getCurrentScriptDir", function() {
                return __WEBPACK_IMPORTED_MODULE_3__lib__.w;
            });
            var __WEBPACK_IMPORTED_MODULE_4_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js");
            __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() {
                return __WEBPACK_IMPORTED_MODULE_5__error__.b;
            });
            __webpack_require__.d(__webpack_exports__, "IntegrationError", function() {
                return __WEBPACK_IMPORTED_MODULE_5__error__.a;
            });
            __webpack_require__.d(__webpack_exports__, "RenderError", function() {
                return __WEBPACK_IMPORTED_MODULE_5__error__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), postRobot = __WEBPACK_IMPORTED_MODULE_4_post_robot_src__, CONSTANTS = __WEBPACK_IMPORTED_MODULE_6__constants__;
        },
        "./node_modules/xcomponent/src/lib/css.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isPerc(str) {
                return "string" == typeof str && /^[0-9]+%$/.test(str);
            }
            function isPx(str) {
                return "string" == typeof str && /^[0-9]+px$/.test(str);
            }
            function toNum(val) {
                if ("number" == typeof val) return val;
                var match = val.match(/^([0-9]+)(px|%)$/);
                if (!match) throw new Error("Could not match css value from " + val);
                return parseInt(match[1], 10);
            }
            function toPx(val) {
                return toNum(val) + "px";
            }
            function toCSS(val) {
                return "number" == typeof val ? toPx(val) : isPerc(val) ? val : toPx(val);
            }
            function percOf(num, perc) {
                return parseInt(num * toNum(perc) / 100, 10);
            }
            function normalizeDimension(dim, max) {
                if ("number" == typeof dim) return dim;
                if (isPerc(dim)) return percOf(max, dim);
                if (isPx(dim)) return toNum(dim);
                throw new Error("Can not normalize dimension: " + dim);
            }
            __webpack_exports__.a = isPerc;
            __webpack_exports__.b = isPx;
            __webpack_exports__.d = toCSS;
            __webpack_exports__.c = normalizeDimension;
        },
        "./node_modules/xcomponent/src/lib/decorators.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function memoized(target, name, descriptor) {
                var method = descriptor.value;
                descriptor.value = function() {
                    this.__memoized__ = this.__memoized__ || {};
                    this.__memoized__.hasOwnProperty(name) || (this.__memoized__[name] = method.apply(this, arguments));
                    return this.__memoized__[name];
                };
                descriptor.value.displayName = name + ":memoized";
            }
            __webpack_exports__.a = memoized;
            __webpack_require__("./node_modules/zalgo-promise/src/index.js");
        },
        "./node_modules/xcomponent/src/lib/dom.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function appendChild(container, child) {
                container.appendChild(child);
            }
            function isElement(element) {
                return element instanceof window.Element || null !== element && "object" === (void 0 === element ? "undefined" : _typeof(element)) && 1 === element.nodeType && "object" === _typeof(element.style) && "object" === _typeof(element.ownerDocument);
            }
            function querySelectorAll(el, selector) {
                return Array.prototype.slice.call(el.querySelectorAll(selector));
            }
            function getElementSafe(id) {
                if (isElement(id)) return id;
                if ("string" == typeof id) {
                    var element = document.getElementById(id);
                    if (element) return element;
                    document.querySelector && (element = document.querySelector(id));
                    if (element) return element;
                }
            }
            function getElement(id) {
                var element = getElementSafe(id);
                if (element) return element;
                throw new Error("Can not find element: " + Object(__WEBPACK_IMPORTED_MODULE_4__util__.k)(id));
            }
            function isDocumentReady() {
                return "complete" === window.document.readyState;
            }
            function elementReady(id) {
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    var name = Object(__WEBPACK_IMPORTED_MODULE_4__util__.k)(id), el = getElementSafe(id);
                    if (el) return resolve(el);
                    if (isDocumentReady()) return reject(new Error("Document is ready and element " + name + " does not exist"));
                    var interval = setInterval(function() {
                        el = getElementSafe(id);
                        if (el) {
                            clearInterval(interval);
                            return resolve(el);
                        }
                        if (isDocumentReady()) {
                            clearInterval(interval);
                            return reject(new Error("Document is ready and element " + name + " does not exist"));
                        }
                    }, 10);
                });
            }
            function popup(url, options) {
                var params = Object.keys(options).map(function(key) {
                    if (options[key]) return key + "=" + Object(__WEBPACK_IMPORTED_MODULE_4__util__.k)(options[key]);
                }).filter(Boolean).join(","), win = void 0;
                try {
                    win = window.open(url, options.name, params, !0);
                } catch (err) {
                    throw new __WEBPACK_IMPORTED_MODULE_5__error__.b("Can not open popup window - " + (err.stack || err.message));
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.y)(win)) {
                    throw new __WEBPACK_IMPORTED_MODULE_5__error__.b("Can not open popup window - blocked");
                }
                return win;
            }
            function writeToWindow(win, html) {
                try {
                    win.document.open();
                    win.document.write(html);
                    win.document.close();
                } catch (err) {
                    try {
                        win.location = "javascript: document.open(); document.write(" + JSON.stringify(html) + "); document.close();";
                    } catch (err2) {}
                }
            }
            function writeElementToWindow(win, el) {
                var tag = el.tagName.toLowerCase();
                if ("html" !== tag) throw new Error("Expected element to be html, got " + tag);
                for (var documentElement = win.document.documentElement; documentElement.children && documentElement.children.length; ) documentElement.removeChild(documentElement.children[0]);
                for (;el.children.length; ) documentElement.appendChild(el.children[0]);
            }
            function setStyle(el, styleText) {
                var doc = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : window.document;
                el.styleSheet ? el.styleSheet.cssText = styleText : el.appendChild(doc.createTextNode(styleText));
            }
            function createElement() {
                var tag = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "div", options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, container = arguments[2];
                tag = tag.toLowerCase();
                var element = document.createElement(tag);
                options.style && Object(__WEBPACK_IMPORTED_MODULE_4__util__.f)(element.style, options.style);
                options.class && (element.className = options.class.join(" "));
                if (options.attributes) for (var _iterator = Object.keys(options.attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref;
                    element.setAttribute(key, options.attributes[key]);
                }
                options.styleSheet && setStyle(element, options.styleSheet);
                container && appendChild(container, element);
                if (options.html) if ("iframe" === tag) {
                    if (!container || !element.contentWindow) throw new Error("Iframe html can not be written unless container provided and iframe in DOM");
                    writeToWindow(element.contentWindow, options.html);
                } else element.innerHTML = options.html;
                return element;
            }
            function awaitFrameLoad(frame) {
                if (awaitFrameLoadPromises.has(frame)) {
                    var _promise = awaitFrameLoadPromises.get(frame);
                    if (_promise) return _promise;
                }
                var promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    frame.addEventListener("load", function() {
                        Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.z)(frame);
                        resolve(frame);
                    });
                    frame.addEventListener("error", function(err) {
                        frame.contentWindow ? resolve(frame) : reject(err);
                    });
                });
                awaitFrameLoadPromises.set(frame, promise);
                return promise;
            }
            function awaitFrameWindow(frame) {
                return frame.contentWindow ? __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.resolve(frame.contentWindow) : awaitFrameLoad(frame).then(function(loadedFrame) {
                    if (!loadedFrame.contentWindow) throw new Error("Could not find window in iframe");
                    return loadedFrame.contentWindow;
                });
            }
            function iframe() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, container = arguments[1], el = getElement(container), attributes = options.attributes || {}, style = options.style || {}, frame = createElement("iframe", {
                    attributes: _extends({
                        frameBorder: "0",
                        allowTransparency: "true"
                    }, attributes),
                    style: _extends({
                        backgroundColor: "transparent"
                    }, style),
                    html: options.html,
                    class: options.class
                });
                awaitFrameLoad(frame);
                el.appendChild(frame);
                (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) && frame.setAttribute("src", options.url || "about:blank");
                return frame;
            }
            function addEventListener(obj, event, handler) {
                obj.addEventListener(event, handler);
                return {
                    cancel: function() {
                        obj.removeEventListener(event, handler);
                    }
                };
            }
            function formatQuery() {
                var obj = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return Object.keys(obj).filter(function(key) {
                    return "string" == typeof obj[key];
                }).map(function(key) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4__util__.n)(key) + "=" + Object(__WEBPACK_IMPORTED_MODULE_4__util__.n)(obj[key]);
                }).join("&");
            }
            function extendQuery(originalQuery) {
                var props = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return props && Object.keys(props).length ? formatQuery(_extends({}, parseQuery(originalQuery), props)) : originalQuery;
            }
            function extendUrl(url) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, query = options.query || {}, hash = options.hash || {}, originalUrl = void 0, originalQuery = void 0, originalHash = void 0, _url$split = url.split("#");
                originalUrl = _url$split[0];
                originalHash = _url$split[1];
                var _originalUrl$split = originalUrl.split("?");
                originalUrl = _originalUrl$split[0];
                originalQuery = _originalUrl$split[1];
                var queryString = extendQuery(originalQuery, query), hashString = extendQuery(originalHash, hash);
                queryString && (originalUrl = originalUrl + "?" + queryString);
                hashString && (originalUrl = originalUrl + "#" + hashString);
                return originalUrl;
            }
            function elementStoppedMoving(element) {
                var timeout = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3;
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    var el = getElement(element), start = el.getBoundingClientRect(), interval = void 0, timer = void 0;
                    interval = setInterval(function() {
                        var end = el.getBoundingClientRect();
                        if (start.top === end.top && start.bottom === end.bottom && start.left === end.left && start.right === end.right && start.width === end.width && start.height === end.height) {
                            clearTimeout(timer);
                            clearInterval(interval);
                            return resolve();
                        }
                        start = end;
                    }, 50);
                    timer = setTimeout(function() {
                        clearInterval(interval);
                        reject(new Error("Timed out waiting for element to stop animating after " + timeout + "ms"));
                    }, timeout);
                });
            }
            function getCurrentDimensions(el) {
                return {
                    width: el.offsetWidth,
                    height: el.offsetHeight
                };
            }
            function setOverflow(el) {
                var value = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto", _el$style = el.style, overflow = _el$style.overflow, overflowX = _el$style.overflowX, overflowY = _el$style.overflowY;
                el.style.overflow = el.style.overflowX = el.style.overflowY = value;
                return {
                    reset: function() {
                        el.style.overflow = overflow;
                        el.style.overflowX = overflowX;
                        el.style.overflowY = overflowY;
                    }
                };
            }
            function dimensionsDiff(one, two, _ref4) {
                var _ref4$width = _ref4.width, width = void 0 === _ref4$width || _ref4$width, _ref4$height = _ref4.height, height = void 0 === _ref4$height || _ref4$height, _ref4$threshold = _ref4.threshold, threshold = void 0 === _ref4$threshold ? 0 : _ref4$threshold;
                return !!(width && Math.abs(one.width - two.width) > threshold) || !!(height && Math.abs(one.height - two.height) > threshold);
            }
            function trackDimensions(el, _ref5) {
                var _ref5$width = _ref5.width, width = void 0 === _ref5$width || _ref5$width, _ref5$height = _ref5.height, height = void 0 === _ref5$height || _ref5$height, _ref5$threshold = _ref5.threshold, threshold = void 0 === _ref5$threshold ? 0 : _ref5$threshold, currentDimensions = getCurrentDimensions(el);
                return {
                    check: function() {
                        var newDimensions = getCurrentDimensions(el);
                        return {
                            changed: dimensionsDiff(currentDimensions, newDimensions, {
                                width: width,
                                height: height,
                                threshold: threshold
                            }),
                            dimensions: newDimensions
                        };
                    },
                    reset: function() {
                        currentDimensions = getCurrentDimensions(el);
                    }
                };
            }
            function onDimensionsChange(el, _ref6) {
                var _ref6$width = _ref6.width, width = void 0 === _ref6$width || _ref6$width, _ref6$height = _ref6.height, height = void 0 === _ref6$height || _ref6$height, _ref6$delay = _ref6.delay, delay = void 0 === _ref6$delay ? 50 : _ref6$delay, _ref6$threshold = _ref6.threshold, threshold = void 0 === _ref6$threshold ? 0 : _ref6$threshold;
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                    function onWindowResize() {
                        var _tracker$check2 = tracker.check(), changed = _tracker$check2.changed, dimensions = _tracker$check2.dimensions;
                        if (changed) {
                            tracker.reset();
                            window.removeEventListener("resize", onWindowResize);
                            resolver(dimensions);
                        }
                    }
                    var tracker = trackDimensions(el, {
                        width: width,
                        height: height,
                        threshold: threshold
                    }), interval = void 0, resolver = Object(__WEBPACK_IMPORTED_MODULE_3__fn__.a)(function(dimensions) {
                        clearInterval(interval);
                        return resolve(dimensions);
                    }, 4 * delay);
                    interval = setInterval(function() {
                        var _tracker$check = tracker.check(), changed = _tracker$check.changed, dimensions = _tracker$check.dimensions;
                        if (changed) {
                            tracker.reset();
                            return resolver(dimensions);
                        }
                    }, delay);
                    window.addEventListener("resize", onWindowResize);
                });
            }
            function dimensionsMatchViewport(el, _ref7) {
                var width = _ref7.width, height = _ref7.height, dimensions = getCurrentDimensions(el);
                return (!width || dimensions.width === window.innerWidth) && (!height || dimensions.height === window.innerHeight);
            }
            function bindEvents(element, eventNames, handler) {
                handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__.e)(handler);
                for (var _iterator4 = eventNames, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                    var _ref8;
                    if (_isArray4) {
                        if (_i4 >= _iterator4.length) break;
                        _ref8 = _iterator4[_i4++];
                    } else {
                        _i4 = _iterator4.next();
                        if (_i4.done) break;
                        _ref8 = _i4.value;
                    }
                    var eventName = _ref8;
                    element.addEventListener(eventName, handler);
                }
                return {
                    cancel: Object(__WEBPACK_IMPORTED_MODULE_3__fn__.e)(function() {
                        for (var _iterator5 = eventNames, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator](); ;) {
                            var _ref9;
                            if (_isArray5) {
                                if (_i5 >= _iterator5.length) break;
                                _ref9 = _iterator5[_i5++];
                            } else {
                                _i5 = _iterator5.next();
                                if (_i5.done) break;
                                _ref9 = _i5.value;
                            }
                            var eventName = _ref9;
                            element.removeEventListener(eventName, handler);
                        }
                    })
                };
            }
            function setVendorCSS(element, name, value) {
                element.style[name] = value;
                for (var capitalizedName = Object(__WEBPACK_IMPORTED_MODULE_4__util__.a)(name), _iterator6 = VENDOR_PREFIXES, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator](); ;) {
                    var _ref10;
                    if (_isArray6) {
                        if (_i6 >= _iterator6.length) break;
                        _ref10 = _iterator6[_i6++];
                    } else {
                        _i6 = _iterator6.next();
                        if (_i6.done) break;
                        _ref10 = _i6.value;
                    }
                    var prefix = _ref10;
                    element.style["" + prefix + capitalizedName] = value;
                }
            }
            function isValidAnimation(element, name) {
                var stylesheets = element.ownerDocument.styleSheets;
                try {
                    for (var i = 0; i < stylesheets.length; i++) {
                        var cssRules = stylesheets[i].cssRules;
                        if (cssRules) for (var j = 0; j < cssRules.length; j++) {
                            var cssRule = cssRules[j];
                            if (cssRule && (cssRule.type === KEYFRAMES_RULE && cssRule.name === name)) return !0;
                        }
                    }
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            function animate(element, name, clean) {
                var timeout = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e3;
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    function cleanUp() {
                        setVendorCSS(el, "animationName", "");
                        clearTimeout(startTimeout);
                        clearTimeout(endTimeout);
                        startEvent.cancel();
                        endEvent.cancel();
                    }
                    var el = getElement(element);
                    if (!el || !isValidAnimation(el, name)) return resolve();
                    var hasStarted = !1, startTimeout = void 0, endTimeout = void 0, startEvent = void 0, endEvent = void 0;
                    startEvent = bindEvents(el, ANIMATION_START_EVENTS, function(event) {
                        if (event.target === el && event.animationName === name) {
                            clearTimeout(startTimeout);
                            event.stopPropagation();
                            startEvent.cancel();
                            hasStarted = !0;
                            endTimeout = setTimeout(function() {
                                cleanUp();
                                resolve();
                            }, timeout);
                        }
                    });
                    endEvent = bindEvents(el, ANIMATION_END_EVENTS, function(event) {
                        if (event.target === el && event.animationName === name) {
                            cleanUp();
                            return "string" == typeof event.animationName && event.animationName !== name ? reject("Expected animation name to be " + name + ", found " + event.animationName) : resolve();
                        }
                    });
                    setVendorCSS(el, "animationName", name);
                    startTimeout = setTimeout(function() {
                        if (!hasStarted) {
                            cleanUp();
                            return resolve();
                        }
                    }, 200);
                    clean && clean(cleanUp);
                });
            }
            function showElement(element) {
                element.style.setProperty("display", "");
            }
            function hideElement(element) {
                element.style.setProperty("display", STYLE.DISPLAY.NONE, STYLE.IMPORTANT);
            }
            function destroyElement(element) {
                element.parentNode && element.parentNode.removeChild(element);
            }
            function showAndAnimate(element, name, clean) {
                var animation = animate(element, name, clean);
                showElement(element);
                return animation;
            }
            function animateAndHide(element, name, clean) {
                return animate(element, name, clean).then(function() {
                    hideElement(element);
                });
            }
            function addClass(element, name) {
                element.classList ? element.classList.add(name) : -1 === element.className.split(/\s+/).indexOf(name) && (element.className += " " + name);
            }
            function removeClass(element, name) {
                element.classList ? element.classList.remove(name) : -1 !== element.className.split(/\s+/).indexOf(name) && (element.className = element.className.replace(name, ""));
            }
            function getCurrentScriptDir() {
                console.warn("Do not use xcomponent.getCurrentScriptDir() in production -- browser support is limited");
                return document.currentScript ? document.currentScript.src.split("/").slice(0, -1).join("/") : ".";
            }
            function isElementClosed(el) {
                return !el || !el.parentNode;
            }
            function watchElementForClose(element, handler) {
                handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__.e)(handler);
                var interval = void 0;
                isElementClosed(element) ? handler() : interval = Object(__WEBPACK_IMPORTED_MODULE_4__util__.j)(function() {
                    if (isElementClosed(element)) {
                        interval.cancel();
                        handler();
                    }
                }, 50);
                return {
                    cancel: function() {
                        interval && interval.cancel();
                    }
                };
            }
            function getHttpType(contentType, url) {
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    var req = new window.XMLHttpRequest();
                    req.open("GET", url);
                    req.setRequestHeader("Accept", contentType);
                    req.send(null);
                    req.onload = function() {
                        resolve(req.responseText);
                    };
                    req.onerror = function() {
                        return reject(new Error("prefetch failed"));
                    };
                });
            }
            function getHTML(url) {
                return getHttpType("text/html", url);
            }
            function prefetchPage(url) {
                return getHTML(url);
            }
            function fixScripts(el) {
                for (var doc = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.document, _iterator7 = querySelectorAll(el, "script"), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator](); ;) {
                    var _ref11;
                    if (_isArray7) {
                        if (_i7 >= _iterator7.length) break;
                        _ref11 = _iterator7[_i7++];
                    } else {
                        _i7 = _iterator7.next();
                        if (_i7.done) break;
                        _ref11 = _i7.value;
                    }
                    var script = _ref11, newScript = doc.createElement("script");
                    newScript.text = script.textContent;
                    script.parentNode.replaceChild(newScript, script);
                }
            }
            function jsxDom(name, props, content) {
                name = name.toLowerCase();
                var doc = this && this.createElement ? this : window.document, el = doc.createElement(name);
                for (var prop in props) if (prop in JSX_EVENTS) el.addEventListener(JSX_EVENTS[prop], props[prop]); else if ("innerHTML" === prop) {
                    el.innerHTML = props[prop];
                    fixScripts(el, doc);
                } else el.setAttribute(prop, props[prop]);
                if ("style" === name) {
                    if ("string" != typeof content) throw new Error("Expected " + name + " tag content to be string, got " + (void 0 === content ? "undefined" : _typeof(content)));
                    if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                    setStyle(el, content, doc);
                } else if ("iframe" === name) {
                    if (arguments.length > 3) throw new Error("Expected only single child node for iframe");
                    el.addEventListener("load", function() {
                        var win = el.contentWindow;
                        if (!win) throw new Error("Expected frame to have contentWindow");
                        "string" == typeof content ? writeToWindow(win, content) : writeElementToWindow(win, content);
                    });
                } else if ("script" === name) {
                    if ("string" != typeof content) throw new Error("Expected " + name + " tag content to be string, got " + (void 0 === content ? "undefined" : _typeof(content)));
                    if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                    el.text = content;
                } else for (var i = 2; i < arguments.length; i++) if ("string" == typeof arguments[i]) {
                    var textNode = document.createTextNode(arguments[i]);
                    appendChild(el, textNode);
                } else appendChild(el, arguments[i]);
                return el;
            }
            __webpack_exports__.d = appendChild;
            __webpack_exports__.n = getElement;
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return documentReady;
            });
            __webpack_exports__.j = elementReady;
            __webpack_exports__.s = popup;
            __webpack_exports__.B = writeToWindow;
            __webpack_exports__.A = writeElementToWindow;
            __webpack_exports__.e = awaitFrameLoad;
            __webpack_exports__.f = awaitFrameWindow;
            __webpack_exports__.p = iframe;
            __webpack_exports__.b = addEventListener;
            __webpack_exports__.l = extendUrl;
            __webpack_exports__.k = elementStoppedMoving;
            __webpack_exports__.v = setOverflow;
            __webpack_exports__.y = trackDimensions;
            __webpack_exports__.r = onDimensionsChange;
            __webpack_exports__.h = dimensionsMatchViewport;
            __webpack_exports__.x = showElement;
            __webpack_exports__.o = hideElement;
            __webpack_exports__.g = destroyElement;
            __webpack_exports__.w = showAndAnimate;
            __webpack_exports__.c = animateAndHide;
            __webpack_exports__.a = addClass;
            __webpack_exports__.u = removeClass;
            __webpack_exports__.m = getCurrentScriptDir;
            __webpack_exports__.z = watchElementForClose;
            __webpack_exports__.t = prefetchPage;
            __webpack_exports__.q = jsxDom;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__fn__ = __webpack_require__("./node_modules/xcomponent/src/lib/fn.js"), __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, documentReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                if ("complete" === window.document.readyState) return resolve(window.document);
                var interval = setInterval(function() {
                    if ("complete" === window.document.readyState) {
                        clearInterval(interval);
                        return resolve(window.document);
                    }
                }, 10);
            }), awaitFrameLoadPromises = new __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__.a(), parseQuery = Object(__WEBPACK_IMPORTED_MODULE_3__fn__.c)(function(queryString) {
                var params = {};
                if (!queryString) return params;
                if (-1 === queryString.indexOf("=")) throw new Error("Can not parse query string params: " + queryString);
                for (var _iterator2 = queryString.split("&"), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var pair = _ref2;
                    pair = pair.split("=");
                    pair[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
                }
                return params;
            }), VENDOR_PREFIXES = [ "webkit", "moz", "ms", "o" ], CSSRule = window.CSSRule, KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE, ANIMATION_START_EVENTS = [ "animationstart", "webkitAnimationStart", "oAnimationStart", "MSAnimationStart" ], ANIMATION_END_EVENTS = [ "animationend", "webkitAnimationEnd", "oAnimationEnd", "MSAnimationEnd" ], STYLE = {
                DISPLAY: {
                    NONE: "none",
                    BLOCK: "block"
                },
                VISIBILITY: {
                    VISIBLE: "visible",
                    HIDDEN: "hidden"
                },
                IMPORTANT: "important"
            }, JSX_EVENTS = {
                onClick: "click"
            };
        },
        "./node_modules/xcomponent/src/lib/fn.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function noop() {}
            function once(method) {
                var called = !1, result = void 0;
                return function() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                    if (called) return result;
                    called = !0;
                    result = method.apply(this, arguments);
                    return result;
                };
            }
            function memoize(method) {
                var results = {};
                return function() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                    var cacheKey = void 0;
                    try {
                        cacheKey = JSON.stringify(Array.prototype.slice.call(arguments), function(key, val) {
                            return "function" == typeof val ? "xcomponent:memoize[" + Object(__WEBPACK_IMPORTED_MODULE_0__util__.h)(val) + "]" : val;
                        });
                    } catch (err) {
                        throw new Error("Arguments not serializable -- can not be used to memoize");
                    }
                    results.hasOwnProperty(cacheKey) || (results[cacheKey] = method.apply(this, arguments));
                    return results[cacheKey];
                };
            }
            function debounce(method) {
                var time = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100, timeout = void 0;
                return function() {
                    var _this = this, _arguments = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        return method.apply(_this, _arguments);
                    }, time);
                };
            }
            function serializeFunctions(obj) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__util__.i)(obj, function(value, key, fullKey) {
                    if (value instanceof Function) return {
                        __type__: "__function__"
                    };
                });
            }
            function deserializeFunctions(obj, handler) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__util__.i)(obj, function(value, key, fullKey) {
                    if (value && "__function__" === value.__type__) return function() {
                        return handler({
                            key: key,
                            fullKey: fullKey,
                            self: this,
                            args: arguments
                        });
                    };
                });
            }
            __webpack_exports__.d = noop;
            __webpack_exports__.e = once;
            __webpack_exports__.c = memoize;
            __webpack_exports__.a = debounce;
            __webpack_exports__.f = serializeFunctions;
            __webpack_exports__.b = deserializeFunctions;
            var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js");
        },
        "./node_modules/xcomponent/src/lib/global.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function globalFor(win) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__.u)(win)) {
                    win[__WEBPACK_IMPORTED_MODULE_1__constants__.__XCOMPONENT__] || (win[__WEBPACK_IMPORTED_MODULE_1__constants__.__XCOMPONENT__] = {});
                    return win[__WEBPACK_IMPORTED_MODULE_1__constants__.__XCOMPONENT__];
                }
            }
            __webpack_exports__.b = globalFor;
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return global;
            });
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js"), global = function() {
                var global = globalFor(window);
                if (!global) throw new Error("Could not get local global");
                return global;
            }();
        },
        "./node_modules/xcomponent/src/lib/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__("./node_modules/xcomponent/src/lib/dom.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.b;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.c;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.d;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.e;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.f;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.g;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.h;
            });
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.i;
            });
            __webpack_require__.d(__webpack_exports__, "p", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.j;
            });
            __webpack_require__.d(__webpack_exports__, "q", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.k;
            });
            __webpack_require__.d(__webpack_exports__, "u", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.l;
            });
            __webpack_require__.d(__webpack_exports__, "w", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.m;
            });
            __webpack_require__.d(__webpack_exports__, "x", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.n;
            });
            __webpack_require__.d(__webpack_exports__, "A", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.o;
            });
            __webpack_require__.d(__webpack_exports__, "B", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.p;
            });
            __webpack_require__.d(__webpack_exports__, "F", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.q;
            });
            __webpack_require__.d(__webpack_exports__, "K", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.r;
            });
            __webpack_require__.d(__webpack_exports__, "M", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.s;
            });
            __webpack_require__.d(__webpack_exports__, "N", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.t;
            });
            __webpack_require__.d(__webpack_exports__, "P", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.u;
            });
            __webpack_require__.d(__webpack_exports__, "T", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.v;
            });
            __webpack_require__.d(__webpack_exports__, "U", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.w;
            });
            __webpack_require__.d(__webpack_exports__, "V", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.x;
            });
            __webpack_require__.d(__webpack_exports__, "Z", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.y;
            });
            __webpack_require__.d(__webpack_exports__, "_3", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.z;
            });
            __webpack_require__.d(__webpack_exports__, "_4", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.A;
            });
            __webpack_require__.d(__webpack_exports__, "_5", function() {
                return __WEBPACK_IMPORTED_MODULE_0__dom__.B;
            });
            var __WEBPACK_IMPORTED_MODULE_1__fn__ = __webpack_require__("./node_modules/xcomponent/src/lib/fn.js");
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_1__fn__.b;
            });
            __webpack_require__.d(__webpack_exports__, "G", function() {
                return __WEBPACK_IMPORTED_MODULE_1__fn__.c;
            });
            __webpack_require__.d(__webpack_exports__, "I", function() {
                return __WEBPACK_IMPORTED_MODULE_1__fn__.d;
            });
            __webpack_require__.d(__webpack_exports__, "L", function() {
                return __WEBPACK_IMPORTED_MODULE_1__fn__.e;
            });
            __webpack_require__.d(__webpack_exports__, "R", function() {
                return __WEBPACK_IMPORTED_MODULE_1__fn__.f;
            });
            var __WEBPACK_IMPORTED_MODULE_2__promise__ = __webpack_require__("./node_modules/xcomponent/src/lib/promise.js");
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_2__promise__.a;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_2__promise__.b;
            });
            __webpack_require__.d(__webpack_exports__, "O", function() {
                return __WEBPACK_IMPORTED_MODULE_2__promise__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js");
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.b;
            });
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.c;
            });
            __webpack_require__.d(__webpack_exports__, "o", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.d;
            });
            __webpack_require__.d(__webpack_exports__, "s", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.e;
            });
            __webpack_require__.d(__webpack_exports__, "t", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.f;
            });
            __webpack_require__.d(__webpack_exports__, "v", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.g;
            });
            __webpack_require__.d(__webpack_exports__, "Q", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.i;
            });
            __webpack_require__.d(__webpack_exports__, "W", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.k;
            });
            __webpack_require__.d(__webpack_exports__, "X", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.l;
            });
            __webpack_require__.d(__webpack_exports__, "_0", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.m;
            });
            __webpack_require__.d(__webpack_exports__, "_1", function() {
                return __WEBPACK_IMPORTED_MODULE_3__util__.o;
            });
            var __WEBPACK_IMPORTED_MODULE_4__css__ = __webpack_require__("./node_modules/xcomponent/src/lib/css.js");
            __webpack_require__.d(__webpack_exports__, "D", function() {
                return __WEBPACK_IMPORTED_MODULE_4__css__.a;
            });
            __webpack_require__.d(__webpack_exports__, "E", function() {
                return __WEBPACK_IMPORTED_MODULE_4__css__.b;
            });
            __webpack_require__.d(__webpack_exports__, "J", function() {
                return __WEBPACK_IMPORTED_MODULE_4__css__.c;
            });
            __webpack_require__.d(__webpack_exports__, "Y", function() {
                return __WEBPACK_IMPORTED_MODULE_4__css__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__("./node_modules/xcomponent/src/lib/decorators.js");
            __webpack_require__.d(__webpack_exports__, "H", function() {
                return __WEBPACK_IMPORTED_MODULE_5__decorators__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__("./node_modules/xcomponent/src/lib/logger.js");
            __webpack_require__.d(__webpack_exports__, "r", function() {
                return __WEBPACK_IMPORTED_MODULE_6__logger__.a;
            });
            __webpack_require__.d(__webpack_exports__, "C", function() {
                return __WEBPACK_IMPORTED_MODULE_6__logger__.b;
            });
            __webpack_require__.d(__webpack_exports__, "S", function() {
                return __WEBPACK_IMPORTED_MODULE_6__logger__.c;
            });
            __webpack_require__.d(__webpack_exports__, "_2", function() {
                return __WEBPACK_IMPORTED_MODULE_6__logger__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__("./node_modules/xcomponent/src/lib/global.js");
            __webpack_require__.d(__webpack_exports__, "y", function() {
                return __WEBPACK_IMPORTED_MODULE_7__global__.a;
            });
            __webpack_require__.d(__webpack_exports__, "z", function() {
                return __WEBPACK_IMPORTED_MODULE_7__global__.b;
            });
        },
        "./node_modules/xcomponent/src/lib/logger.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function setLogLevel(logLevel) {
                if (-1 === __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.l.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
                __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.d.logLevel = logLevel;
                __WEBPACK_IMPORTED_MODULE_0_post_robot_src__.CONFIG.LOG_LEVEL = logLevel;
                window.LOG_LEVEL = logLevel;
            }
            function info(name, event) {
                var payload = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.j("xc_" + name + "_" + event, payload);
            }
            function warn(name, event) {
                var payload = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p("xc_" + name + "_" + event, payload);
            }
            function error(name, event) {
                var payload = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.f("xc_" + name + "_" + event, payload);
            }
            __webpack_exports__.c = setLogLevel;
            __webpack_exports__.b = info;
            __webpack_exports__.d = warn;
            __webpack_exports__.a = error;
            var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
        },
        "./node_modules/xcomponent/src/lib/promise.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function denodeify(method) {
                return function() {
                    var self = this, args = Array.prototype.slice.call(arguments);
                    return args.length >= method.length ? __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(method.apply(self, args)) : new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve, reject) {
                        args.push(function(err, result) {
                            if (err && !(err instanceof Error)) throw new Error("Passed non-Error object in callback: [ " + err + " ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).");
                            return err ? reject(err) : resolve(result);
                        });
                        method.apply(self, args);
                    });
                };
            }
            function promisify(method) {
                return function() {
                    var _this = this, _arguments = arguments;
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                        return method.apply(_this, _arguments);
                    });
                };
            }
            function cycle(method) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(method).then(function() {
                    return cycle(method);
                });
            }
            __webpack_exports__.b = denodeify;
            __webpack_exports__.c = promisify;
            __webpack_exports__.a = cycle;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
        },
        "./node_modules/xcomponent/src/lib/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function urlEncode(str) {
                return str.replace(/\?/g, "%3F").replace(/\&/g, "%26").replace(/#/g, "%23").replace(/\+/g, "%2B");
            }
            function dasherizeToCamel(string) {
                return string.replace(/-([a-z])/g, function(g) {
                    return g[1].toUpperCase();
                });
            }
            function extend(obj, source) {
                if (!source) return obj;
                for (var key in source) source.hasOwnProperty(key) && (obj[key] = source[key]);
                return obj;
            }
            function values(obj) {
                var results = [];
                for (var key in obj) obj.hasOwnProperty(key) && results.push(obj[key]);
                return results;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                });
            }
            function capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            }
            function get(item, path, def) {
                if (!path) return def;
                for (var pathParts = path.split("."), i = 0; i < pathParts.length; i++) {
                    if ("object" !== (void 0 === item ? "undefined" : _typeof(item)) || null === item) return def;
                    item = item[pathParts[i]];
                }
                return void 0 === item ? def : item;
            }
            function safeInterval(method, time) {
                function runInterval() {
                    timeout = setTimeout(runInterval, time);
                    method.call();
                }
                var timeout = void 0;
                timeout = setTimeout(runInterval, time);
                return {
                    cancel: function() {
                        clearTimeout(timeout);
                    }
                };
            }
            function each(item, callback) {
                if (item) if (item instanceof Array) for (var len = item.length, i = 0; i < len; i++) callback(item[i], i); else if ("object" === (void 0 === item ? "undefined" : _typeof(item))) for (var keys = Object.keys(item), _len = keys.length, _i = 0; _i < _len; _i++) {
                    var key = keys[_i];
                    callback(item[key], key);
                }
            }
            function replaceObject(obj, callback) {
                var parentKey = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "", newobj = obj instanceof Array ? [] : {};
                each(obj, function(item, key) {
                    var fullKey = parentKey ? parentKey + "." + key : key, result = callback(item, key, fullKey);
                    void 0 !== result ? newobj[key] = result : "object" === (void 0 === item ? "undefined" : _typeof(item)) && null !== item ? newobj[key] = replaceObject(item, callback, fullKey) : newobj[key] = item;
                });
                return newobj;
            }
            function copyProp(source, target, name, def) {
                if (source.hasOwnProperty(name)) {
                    var descriptor = Object.getOwnPropertyDescriptor(source, name);
                    Object.defineProperty(target, name, descriptor);
                } else target[name] = def;
            }
            function dotify(obj) {
                var prefix = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", newobj = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                prefix = prefix ? prefix + "." : prefix;
                for (var key in obj) void 0 !== obj[key] && null !== obj[key] && "function" != typeof obj[key] && (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every(function(val) {
                    return "object" !== (void 0 === val ? "undefined" : _typeof(val));
                }) ? newobj["" + prefix + key] = obj[key].join(",") : obj[key] && "object" === _typeof(obj[key]) ? newobj = dotify(obj[key], "" + prefix + key, newobj) : newobj["" + prefix + key] = obj[key].toString());
                return newobj;
            }
            function getObjectID(obj) {
                if (null === obj || void 0 === obj || "object" !== (void 0 === obj ? "undefined" : _typeof(obj)) && "function" != typeof obj) throw new Error("Invalid object");
                var uid = objectIDs.get(obj);
                if (!uid) {
                    uid = (void 0 === obj ? "undefined" : _typeof(obj)) + ":" + uniqueID();
                    objectIDs.set(obj, uid);
                }
                return uid;
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && "function" == typeof item.toString ? item.toString() : Object.prototype.toString.call(item);
            }
            function stringifyError(err) {
                if (err) {
                    var stack = err.stack, message = err.message;
                    if ("string" == typeof stack) return stack;
                    if ("string" == typeof message) return message;
                }
                return stringify(err);
            }
            function eventEmitter() {
                var triggered = {}, handlers = {};
                return {
                    on: function(eventName, handler) {
                        var handlerList = handlers[eventName] = handlers[eventName] || [];
                        handlerList.push(handler);
                        var cancelled = !1;
                        return {
                            cancel: function() {
                                if (!cancelled) {
                                    cancelled = !0;
                                    handlerList.splice(handlerList.indexOf(handler), 1);
                                }
                            }
                        };
                    },
                    once: function(eventName, handler) {
                        var listener = this.on(eventName, function() {
                            listener.cancel();
                            handler();
                        });
                        return listener;
                    },
                    trigger: function(eventName) {
                        var handlerList = handlers[eventName];
                        if (handlerList) for (var _iterator = handlerList, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i2 >= _iterator.length) break;
                                _ref = _iterator[_i2++];
                            } else {
                                _i2 = _iterator.next();
                                if (_i2.done) break;
                                _ref = _i2.value;
                            }
                            var _handler = _ref;
                            _handler();
                        }
                    },
                    triggerOnce: function(eventName) {
                        if (!triggered[eventName]) {
                            triggered[eventName] = !0;
                            this.trigger(eventName);
                        }
                    }
                };
            }
            __webpack_exports__.n = urlEncode;
            __webpack_exports__.c = dasherizeToCamel;
            __webpack_exports__.f = extend;
            __webpack_exports__.o = values;
            __webpack_exports__.m = uniqueID;
            __webpack_exports__.a = capitalizeFirstLetter;
            __webpack_exports__.g = get;
            __webpack_exports__.j = safeInterval;
            __webpack_exports__.i = replaceObject;
            __webpack_exports__.b = copyProp;
            __webpack_exports__.d = dotify;
            __webpack_exports__.h = getObjectID;
            __webpack_exports__.k = stringify;
            __webpack_exports__.l = stringifyError;
            __webpack_exports__.e = eventEmitter;
            var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, objectIDs = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__.a();
        },
        "./node_modules/zalgo-promise/src/exceptions.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function dispatchPossiblyUnhandledError(err) {
                if (-1 === dispatchedErrors.indexOf(err)) {
                    dispatchedErrors.push(err);
                    setTimeout(function() {
                        throw err;
                    }, 1);
                    for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) possiblyUnhandledPromiseHandlers[j](err);
                }
            }
            function onPossiblyUnhandledException(handler) {
                possiblyUnhandledPromiseHandlers.push(handler);
                return {
                    cancel: function() {
                        possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                    }
                };
            }
            __webpack_exports__.a = dispatchPossiblyUnhandledError;
            __webpack_exports__.b = onPossiblyUnhandledException;
            var possiblyUnhandledPromiseHandlers = [], dispatchedErrors = [];
        },
        "./node_modules/zalgo-promise/src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__promise__ = __webpack_require__("./node_modules/zalgo-promise/src/promise.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__promise__.a;
            });
        },
        "./node_modules/zalgo-promise/src/promise.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return ZalgoPromise;
            });
            var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("./node_modules/zalgo-promise/src/utils.js"), __WEBPACK_IMPORTED_MODULE_1__exceptions__ = __webpack_require__("./node_modules/zalgo-promise/src/exceptions.js"), global = window.__zalgopromise__ = window.__zalgopromise__ || {
                flushPromises: [],
                activeCount: 0
            }, ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    _classCallCheck(this, ZalgoPromise);
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result = void 0, _error = void 0, resolved = !1, rejected = !1, isAsync = !1;
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res); else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err); else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            this.reject(err);
                            return;
                        }
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                ZalgoPromise.prototype.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                ZalgoPromise.prototype.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : Object.prototype.toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__.a)(error);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                ZalgoPromise.prototype.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                };
                ZalgoPromise.prototype.dispatch = function() {
                    var _this3 = this, dispatching = this.dispatching, resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        global.activeCount += 1;
                        for (var i = 0; i < handlers.length; i++) {
                            (function(i) {
                                var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise, result = void 0;
                                if (resolved) try {
                                    result = onSuccess ? onSuccess(_this3.value) : _this3.value;
                                } catch (err) {
                                    promise.reject(err);
                                    return "continue";
                                } else if (rejected) {
                                    if (!onError) {
                                        promise.reject(_this3.error);
                                        return "continue";
                                    }
                                    try {
                                        result = onError(_this3.error);
                                    } catch (err) {
                                        promise.reject(err);
                                        return "continue";
                                    }
                                }
                                if (result instanceof ZalgoPromise && (result.resolved || result.rejected)) {
                                    result.resolved ? promise.resolve(result.value) : promise.reject(result.error);
                                    result.errorHandled = !0;
                                } else Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(result) ? result instanceof ZalgoPromise && (result.resolved || result.rejected) ? result.resolved ? promise.resolve(result.value) : promise.reject(result.error) : result.then(function(res) {
                                    promise.resolve(res);
                                }, function(err) {
                                    promise.reject(err);
                                }) : promise.resolve(result);
                            })(i);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        global.activeCount -= 1;
                        0 === global.activeCount && ZalgoPromise.flushQueue();
                    }
                };
                ZalgoPromise.prototype.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise();
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                ZalgoPromise.prototype.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                ZalgoPromise.prototype.finally = function(handler) {
                    return this.then(function(result) {
                        return ZalgoPromise.try(handler).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(handler).then(function() {
                            throw err;
                        });
                    });
                };
                ZalgoPromise.prototype.timeout = function(time, err) {
                    var _this4 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this4.resolved || _this4.rejected || _this4.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                ZalgoPromise.prototype.toPromise = function() {
                    if (!window.Promise) throw new Error("Could not find window.Promise");
                    return window.Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : new ZalgoPromise().resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return new ZalgoPromise().reject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise(), count = promises.length, results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    for (var i = 0; i < promises.length; i++) {
                        (function(i) {
                            var prom = promises[i];
                            if (prom instanceof ZalgoPromise) {
                                if (prom.resolved) {
                                    results[i] = prom.value;
                                    count -= 1;
                                    return "continue";
                                }
                            } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(prom)) {
                                results[i] = prom;
                                count -= 1;
                                return "continue";
                            }
                            ZalgoPromise.resolve(prom).then(function(result) {
                                results[i] = result;
                                count -= 1;
                                0 === count && promise.resolve(results);
                            }, function(err) {
                                promise.reject(err);
                            });
                        })(i);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    return ZalgoPromise.all(Object.keys(promises).map(function(key) {
                        return ZalgoPromise.resolve(promises[key]).then(function(value) {
                            result[key] = value;
                        });
                    })).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__.b)(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    var result = void 0;
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        return ZalgoPromise.reject(err);
                    }
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || Object(__WEBPACK_IMPORTED_MODULE_0__utils__.a)(value);
                };
                ZalgoPromise.flush = function() {
                    var promise = new ZalgoPromise();
                    global.flushPromises.push(promise);
                    0 === global.activeCount && ZalgoPromise.flushQueue();
                    return promise;
                };
                ZalgoPromise.flushQueue = function() {
                    var promisesToFlush = global.flushPromises;
                    global.flushPromises = [];
                    for (var _iterator = promisesToFlush, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        _ref.resolve();
                    }
                };
                return ZalgoPromise;
            }();
        },
        "./node_modules/zalgo-promise/src/utils.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isPromise(item) {
                try {
                    if (!item) return !1;
                    if (window.Promise && item instanceof window.Promise) return !0;
                    if (window.Window && item instanceof window.Window) return !1;
                    if (window.constructor && item instanceof window.constructor) return !1;
                    if (toString) {
                        var name = toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            __webpack_exports__.a = isPromise;
            var toString = {}.toString;
        },
        "./src/api/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__rest__ = __webpack_require__("./src/api/rest.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__rest__.a;
            });
        },
        "./src/api/rest.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function logPaymentResponse(res) {
                var _track;
                if (res) {
                    var paymentToken = void 0, paymentID = void 0;
                    res.id && (paymentID = res.id);
                    if (res.links && res.links.length) for (var i = 0; i < res.links.length; i++) if ("REDIRECT" === res.links[i].method && "approval_url" === res.links[i].rel) {
                        var match = res.links[i].href.match(/token=((EC-)?[A-Z0-9]{17})/);
                        match && (paymentToken = match[1]);
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_5__config__.e.STATE.BUTTON, 
                    _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_5__config__.e.TRANSITION.CREATE_PAYMENT, 
                    _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_5__config__.e.CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_5__config__.j.PAY_ID], 
                    _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.PAY_ID] = paymentID, _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.TOKEN] = paymentToken, 
                    _track[__WEBPACK_IMPORTED_MODULE_5__config__.e.KEY.CONTEXT_ID] = paymentID, _track));
                }
            }
            function getDefaultReturnUrl() {
                return Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.q)() ? "https://www.paypal.com" : window.location.protocol + "//" + window.location.host;
            }
            function createPayment(env, client, paymentDetails) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_create_checkout_token");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                var payment = paymentDetails.payment, experience = paymentDetails.experience, meta = paymentDetails.meta;
                if (!payment) throw new Error("Expected payment details to be passed");
                if (proxyRest.createPayment && !proxyRest.createPayment.source.closed) return proxyRest.createPayment(env, client, {
                    payment: payment,
                    experience: experience,
                    meta: meta
                });
                payment = _extends({}, payment);
                payment.intent = payment.intent || "sale";
                payment.redirect_urls = payment.redirect_urls || {};
                payment.redirect_urls.return_url = payment.redirect_urls.return_url || getDefaultReturnUrl();
                payment.redirect_urls.cancel_url = payment.redirect_urls.cancel_url || getDefaultReturnUrl();
                payment.payer = payment.payer || {};
                payment.payer.payment_method = payment.payer.payment_method || "paypal";
                return createAccessToken(env, client).then(function(accessToken) {
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                        if (experience) return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(createExperienceProfile(env, client, experience));
                    }).then(function(experienceID) {
                        experienceID && (payment.experience_profile_id = experienceID);
                        var headers = {
                            Authorization: "Bearer " + accessToken
                        };
                        meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                            method: "post",
                            url: __WEBPACK_IMPORTED_MODULE_5__config__.n.paymentApiUrls[env],
                            headers: headers,
                            json: payment
                        });
                    });
                }).then(function(res) {
                    logPaymentResponse(res);
                    if (res && res.id) return res.id;
                    throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
                });
            }
            function getPayment(env, client, paymentID) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_get_order");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (!paymentID) throw new Error("Expected payment id");
                return proxyRest.getPayment && !proxyRest.getPayment.source.closed ? proxyRest.getPayment(env, client, paymentID) : createAccessToken(env, client).then(function(accessToken) {
                    var headers = {
                        Authorization: "Bearer " + accessToken
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "get",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.paymentApiUrls[env] + "/" + paymentID,
                        headers: headers
                    });
                });
            }
            function executePayment(env, client, paymentID, payerID) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_get_order");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (!paymentID) throw new Error("Expected payment id");
                return proxyRest.executePayment && !proxyRest.executePayment.source.closed ? proxyRest.executePayment(env, client, paymentID) : createAccessToken(env, client).then(function(accessToken) {
                    var headers = {
                        Authorization: "Bearer " + accessToken
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "post",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.paymentApiUrls[env] + "/" + paymentID + "/execute",
                        headers: headers,
                        json: {
                            payer_id: payerID
                        }
                    });
                });
            }
            function createOrder(env, client, paymentDetails) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_create_order_token");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                var order = paymentDetails.order, meta = paymentDetails.meta;
                if (!order) throw new Error("Expected order details to be passed");
                if (proxyRest.createOrder && !proxyRest.createOrder.source.closed) return proxyRest.createOrder(env, client, {
                    order: order,
                    meta: meta
                });
                order = _extends({}, order);
                order.intent = order.intent || "CAPTURE";
                order.redirect_urls = order.redirect_urls || {};
                order.redirect_urls.return_url = order.redirect_urls.return_url || getDefaultReturnUrl();
                order.redirect_urls.cancel_url = order.redirect_urls.cancel_url || getDefaultReturnUrl();
                order.purchase_units = order.purchase_units || [];
                order.purchase_units[0] = order.purchase_units[0] || {};
                order.purchase_units.forEach(function(unit) {
                    unit.reference_id = unit.reference_id || Math.random().toString();
                });
                return createAccessToken(env, client).then(function(accessToken) {
                    var headers = {
                        Authorization: "Bearer " + accessToken
                    };
                    meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "post",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.orderApiUrls[env],
                        headers: headers,
                        json: order
                    });
                }).then(function(res) {
                    logPaymentResponse(res);
                    if (res && res.id) return res.id;
                    throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
                });
            }
            function getOrder(env, client, orderID) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_get_order");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (!orderID) throw new Error("Expected order id");
                return proxyRest.getOrder && !proxyRest.getOrder.source.closed ? proxyRest.getOrder(env, client, orderID) : createAccessToken(env, client).then(function(accessToken) {
                    var headers = {
                        Authorization: "Bearer " + accessToken
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "get",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.orderApiUrls[env] + "/" + orderID,
                        headers: headers
                    });
                });
            }
            function captureOrder(env, client, orderID) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_get_order");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (!orderID) throw new Error("Expected order id");
                return proxyRest.captureOrder && !proxyRest.captureOrder.source.closed ? proxyRest.captureOrder(env, client, orderID) : createAccessToken(env, client).then(function(accessToken) {
                    var headers = {
                        Authorization: "Bearer " + accessToken
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "post",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.orderApiUrls[env] + "/" + orderID + "/capture",
                        headers: headers,
                        json: {
                            is_final_capture: !0
                        }
                    });
                });
            }
            function createBillingAgreement(env, client, billingDetails, experienceDetails) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_create_billing_token");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (proxyRest.createBillingAgreement && !proxyRest.createBillingAgreement.source.closed) return proxyRest.createBillingAgreement(env, client, billingDetails, experienceDetails);
                billingDetails = _extends({}, billingDetails);
                billingDetails.plan = billingDetails.plan || {};
                billingDetails.plan.merchant_preferences = billingDetails.plan.merchant_preferences || {};
                billingDetails.plan.merchant_preferences.return_url = billingDetails.plan.merchant_preferences.return_url || getDefaultReturnUrl();
                billingDetails.plan.merchant_preferences.cancel_url = billingDetails.plan.merchant_preferences.cancel_url || getDefaultReturnUrl();
                billingDetails.payer = billingDetails.payer || {};
                billingDetails.payer.payment_method = billingDetails.payer.payment_method || "paypal";
                return createAccessToken(env, client).then(function(accessToken) {
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                        if (experienceDetails) return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(createExperienceProfile(env, client, experienceDetails));
                    }).then(function(experienceID) {
                        experienceID && (billingDetails.experience_profile_id = experienceID);
                        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                            method: "post",
                            url: __WEBPACK_IMPORTED_MODULE_5__config__.n.billingApiUrls[env],
                            headers: {
                                Authorization: "Bearer " + accessToken
                            },
                            json: billingDetails
                        });
                    });
                }).then(function(res) {
                    if (res && res.token_id) return res.token_id;
                    throw new Error("Billing Api response error:\n\n" + JSON.stringify(res, null, 4));
                });
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return rest;
            });
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_Base64__ = __webpack_require__("./node_modules/Base64/base64.js"), __WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__ = (__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Base64__), 
            __webpack_require__("./node_modules/beaver-logger/client/index.js")), __WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./src/lib/index.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, proxyRest = {}, createAccessToken = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.G)(function(env, client) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_create_access_token");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                var clientID = client[env];
                if (!clientID) throw new Error("Client ID not found for env: " + env);
                if (proxyRest.createAccessToken && !proxyRest.createAccessToken.source.closed) return proxyRest.createAccessToken(env, client);
                var basicAuth = Object(__WEBPACK_IMPORTED_MODULE_2_Base64__.btoa)(clientID + ":");
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                    method: "post",
                    url: __WEBPACK_IMPORTED_MODULE_5__config__.n.authApiUrls[env],
                    headers: {
                        Authorization: "Basic " + basicAuth
                    },
                    data: {
                        grant_type: "client_credentials"
                    }
                }).then(function(res) {
                    if (res && "invalid_client" === res.error) throw new Error("Auth Api invalid " + env + " client id: " + clientID + ":\n\n" + JSON.stringify(res, null, 4));
                    if (!res || !res.access_token) throw new Error("Auth Api response error:\n\n" + JSON.stringify(res, null, 4));
                    return res.access_token;
                });
            }, {
                time: 6e5
            }), createExperienceProfile = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.G)(function(env, client) {
                var experienceDetails = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("rest_api_create_experience_profile");
                env = env || __WEBPACK_IMPORTED_MODULE_5__config__.n.env;
                if (!client[env]) throw new Error("Client ID not found for env: " + env);
                if (proxyRest.createExperienceProfile && !proxyRest.createExperienceProfile.source.closed) return proxyRest.createExperienceProfile(env, client, experienceDetails);
                experienceDetails.temporary = !0;
                experienceDetails.name = experienceDetails.name ? experienceDetails.name + "_" + Math.random().toString() : Math.random().toString();
                return createAccessToken(env, client).then(function(accessToken) {
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__.Q)({
                        method: "post",
                        url: __WEBPACK_IMPORTED_MODULE_5__config__.n.experienceApiUrls[env],
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        json: experienceDetails
                    });
                }).then(function(res) {
                    if (res && res.error) throw new Error(res.error);
                    if (!res.id) throw new Error("No id in experience profile response:\n\n" + JSON.stringify(res, null, 4));
                    return res.id;
                });
            }, {
                time: 6e5
            }), rest = {
                payment: {
                    create: createPayment,
                    get: getPayment,
                    execute: executePayment
                },
                order: {
                    create: createOrder,
                    get: getOrder,
                    capture: captureOrder
                },
                billingAgreement: {
                    create: createBillingAgreement
                },
                experience: {
                    create: createExperienceProfile
                }
            }, parentWin = Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.d)();
            Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.on)("proxy_rest", {
                domain: __WEBPACK_IMPORTED_MODULE_5__config__.n.paypal_domain_regex
            }, function(_ref) {
                var data = _ref.data;
                proxyRest = data;
            });
            parentWin && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.D)() && !Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.u)(parentWin) && Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.send)(parentWin, "proxy_rest", {
                createAccessToken: createAccessToken,
                createExperienceProfile: createExperienceProfile,
                createPayment: createPayment,
                getPayment: getPayment,
                executePayment: executePayment,
                createBillingAgreement: createBillingAgreement,
                createOrder: createOrder,
                getOrder: getOrder,
                captureOrder: captureOrder
            }).catch(function() {});
        },
        "./src/compat/fallback.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function match(str, pattern) {
                var regmatch = str.match(pattern);
                if (regmatch) return regmatch[1];
            }
            function onLegacyPaymentAuthorize(method) {
                onAuthorize = method;
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                    if (__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.bridge && !Object(__WEBPACK_IMPORTED_MODULE_2__lib__.D)()) return __WEBPACK_IMPORTED_MODULE_0_post_robot_src__.bridge.openBridge(Object(__WEBPACK_IMPORTED_MODULE_2__lib__.g)(__WEBPACK_IMPORTED_MODULE_3__config__.n.postBridgeUrl, {
                        version: Object(__WEBPACK_IMPORTED_MODULE_2__lib__.r)()
                    }), __WEBPACK_IMPORTED_MODULE_3__config__.n.postBridgeDomain).then(function(postBridge) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.send)(postBridge, "onLegacyPaymentAuthorize", {
                            method: method
                        }, {
                            domain: __WEBPACK_IMPORTED_MODULE_3__config__.n.paypalDomain
                        }).then(__WEBPACK_IMPORTED_MODULE_2__lib__.H);
                    });
                });
            }
            __webpack_exports__.a = onLegacyPaymentAuthorize;
            var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js"), onAuthorize = void 0;
            Object(__WEBPACK_IMPORTED_MODULE_2__lib__.D)() && Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.on)("onLegacyPaymentAuthorize", {
                window: window.parent
            }, function(_ref) {
                var data = _ref.data;
                onAuthorize = data.method;
            });
            window.onLegacyPaymentAuthorize = onLegacyPaymentAuthorize;
            window.watchForLegacyFallback = function(win) {
                var interval = setInterval(function() {
                    try {
                        if (!(-1 !== win.document.body.innerHTML.indexOf("merchantpaymentweb") || -1 !== win.document.body.innerHTML.indexOf("wapapp")) || win.ppxoWatching || win.closed) return;
                        win.ppxoWatching = !0;
                        var XMLHttpRequestsend = win.XMLHttpRequest.prototype.send;
                        win.XMLHttpRequest.prototype.send = function() {
                            function listener() {
                                if (self.readyState === self.DONE && 200 === self.status && self.responseText) try {
                                    var response = JSON.parse(self.responseText.replace("while (1);", ""));
                                    if ("redirect" === response.type && response.url && onAuthorize) {
                                        var url = response.url;
                                        clearInterval(interval);
                                        win.close();
                                        onAuthorize({
                                            returnUrl: url,
                                            paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                                            billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                                            payerID: match(url, /PayerID=([A-Z0-9]+)/),
                                            paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
                                        });
                                        onAuthorize = null;
                                        win.PAYPAL && win.PAYPAL.Checkout && win.PAYPAL.Checkout.XhrResponse && win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES && Object.defineProperty(win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES, "Redirect", {
                                            value: Math.random().toString()
                                        });
                                        win.mob && win.mob.Xhr && win.mob.Xhr.prototype._xhrOnReady && (win.mob.Xhr.prototype._xhrOnReady = __WEBPACK_IMPORTED_MODULE_2__lib__.H);
                                    }
                                } catch (err) {
                                    return;
                                }
                                if (onload) return onload.apply(this, arguments);
                            }
                            if (this._patched) return XMLHttpRequestsend.apply(this, arguments);
                            this._patched = !0;
                            var self = this, onload = this.onload;
                            if (this.onload !== listener) try {
                                delete this.onload;
                                this.onload = listener;
                                Object.defineProperty(this, "onload", {
                                    get: function() {
                                        return listener;
                                    },
                                    set: function(handler) {
                                        onload = handler;
                                    }
                                });
                            } catch (err) {}
                            return XMLHttpRequestsend.apply(this, arguments);
                        };
                    } catch (err) {}
                }, 100);
            };
            window.onLegacyFallback = window.watchForLegacyFallback;
        },
        "./src/compat/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__fallback__ = __webpack_require__("./src/compat/fallback.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__fallback__.a;
            });
        },
        "./src/components/button/braintree.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function awaitBraintreeClient(braintree, auth) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(auth).then(function(authorization) {
                    return braintree.client.create({
                        authorization: authorization
                    });
                }).then(function(client) {
                    return braintree.paypalCheckout.create({
                        client: client
                    });
                });
            }
            function validate(obj, supported, name) {
                for (var supportedKeys = Object.keys(supported), _iterator = Object.keys(obj), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref;
                    if (-1 === supportedKeys.indexOf(key)) throw new Error("Unsupported REST key for Braintree: " + name + "." + key);
                    "object" === _typeof(obj[key]) && validate(obj[key], supported[key], name + "." + key);
                }
            }
            function mapPaymentToBraintree(payment) {
                validate(payment, SUPPORTED_REST_FIELDS, "payment");
                var btPayment = {};
                btPayment.intent = payment.intent || "sale";
                btPayment.flow = "checkout";
                btPayment.amount = payment.transactions[0].amount.total;
                btPayment.currency = payment.transactions[0].amount.currency;
                if (payment.payer) {
                    "CREDIT" === payment.payer.external_selected_funding_instrument_type && (btPayment.offerCredit = !0);
                    payment.payer.shipping_address && (btPayment.shippingAddressOverride = {
                        line1: payment.payer.shipping_address.line1,
                        line2: payment.payer.shipping_address.line2,
                        city: payment.payer.shipping_address.city,
                        state: payment.payer.shipping_address.state,
                        postalCode: payment.payer.shipping_address.postal_code,
                        countryCode: payment.payer.shipping_address.country_code,
                        phone: payment.payer.shipping_address.phone,
                        recipientName: payment.payer.shipping_address.recipient_name
                    });
                }
                if (payment.application_context) {
                    btPayment.displayName = payment.application_context.brand_name;
                    btPayment.landingPageType = payment.application_context.landing_page;
                    if (payment.application_context) if ("NO_SHIPPING" === payment.application_context.shipping_preference) btPayment.enableShippingAddress = !1; else if ("GET_FROM_FILE" === payment.application_context.shipping_preference) {
                        btPayment.enableShippingAddress = !0;
                        btPayment.shippingAddressEditable = !0;
                    } else if ("SET_PROVIDED_ADDRESS" === payment.application_context.shipping_preference) {
                        btPayment.enableShippingAddress = !0;
                        btPayment.shippingAddressEditable = !1;
                    }
                }
                return btPayment;
            }
            __webpack_exports__.a = awaitBraintreeClient;
            __webpack_exports__.b = mapPaymentToBraintree;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, SUPPORTED_REST_FIELDS = {
                intent: 1,
                transactions: [ {
                    amount: {
                        total: 1,
                        currency: 1
                    }
                } ],
                payer: {
                    external_selected_funding_instrument_type: 1,
                    shipping_address: {
                        line1: 1,
                        line2: 1,
                        city: 1,
                        state: 1,
                        postal_code: 1,
                        country_code: 1,
                        phone: 1,
                        recipient_name: 1
                    }
                },
                application_context: {
                    brand_name: 1,
                    shipping_preference: 1,
                    landing_page: 1
                }
            };
        },
        "./src/components/button/component.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return Button;
            });
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js"), __WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__ = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/beaver-logger/client/index.js")), __WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__ = __webpack_require__("./node_modules/braintree-paypal-client-config/index.js"), __WEBPACK_IMPORTED_MODULE_5__checkout__ = (__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__), 
            __webpack_require__("./src/components/checkout/index.js")), __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__("./src/api/index.js"), __WEBPACK_IMPORTED_MODULE_9__experiments__ = __webpack_require__("./src/experiments.js"), __WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__ = __webpack_require__("./src/components/checkout/popupBridge.js"), __WEBPACK_IMPORTED_MODULE_11__checkout_util__ = __webpack_require__("./src/components/checkout/util.js"), __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_13__templates__ = __webpack_require__("./src/components/button/templates/index.js"), __WEBPACK_IMPORTED_MODULE_14__templates_component_validate__ = __webpack_require__("./src/components/button/templates/component/validate.js"), __WEBPACK_IMPORTED_MODULE_15__braintree__ = __webpack_require__("./src/components/button/braintree.js"), __WEBPACK_IMPORTED_MODULE_16__templates_funding__ = __webpack_require__("./src/components/button/templates/funding.js"), __WEBPACK_IMPORTED_MODULE_17__templates_config__ = __webpack_require__("./src/components/button/templates/config.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, Button = Object(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__.c)({
                tag: "paypal-button",
                name: "ppbutton",
                buildUrl: function(props) {
                    var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                    return __WEBPACK_IMPORTED_MODULE_6__config__.n.buttonUrls[env];
                },
                contexts: {
                    iframe: !0,
                    popup: !1
                },
                scrolling: !1,
                containerTemplate: __WEBPACK_IMPORTED_MODULE_13__templates__.b,
                prerenderTemplate: function(_ref) {
                    var _this = this, props = _ref.props, jsxDom = _ref.jsxDom, template = jsxDom("div", {
                        innerHTML: Object(__WEBPACK_IMPORTED_MODULE_13__templates__.a)({
                            props: props
                        })
                    });
                    template.addEventListener("click", function() {
                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.p)("button_pre_template_click");
                        if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__.k)("allow_full_page_fallback")) {
                            Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("pre_template_force_full_page");
                            var checkout = __WEBPACK_IMPORTED_MODULE_5__checkout__.a.init({
                                onAuthorize: __WEBPACK_IMPORTED_MODULE_7__lib__.H
                            });
                            checkout.openContainer().then(function() {
                                checkout.showContainer();
                                checkout.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__.a.EVENTS.CLOSE);
                            });
                            _this.props.payment().then(function(token) {
                                window.top.location = Object(__WEBPACK_IMPORTED_MODULE_7__lib__.g)(__WEBPACK_IMPORTED_MODULE_6__config__.n.checkoutUrl, {
                                    token: token
                                });
                            }).catch(function(err) {
                                checkout.error(err);
                            });
                        }
                    });
                    return jsxDom("html", null, jsxDom("body", null, template));
                },
                get version() {
                    return Object(__WEBPACK_IMPORTED_MODULE_7__lib__.r)();
                },
                get domain() {
                    return __WEBPACK_IMPORTED_MODULE_6__config__.n.paypalDomains;
                },
                attributes: {
                    iframe: {
                        allowpaymentrequest: "allowpaymentrequest"
                    }
                },
                validate: function() {
                    Object(__WEBPACK_IMPORTED_MODULE_7__lib__.y)() || Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.p)("button_render_ineligible");
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__.B)()) throw new Error("Can not render button in IE intranet mode");
                },
                props: {
                    sessionID: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_7__lib__.s)();
                        },
                        queryParam: !0
                    },
                    buttonSessionID: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_7__lib__.W)();
                        },
                        queryParam: !0
                    },
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                        },
                        validate: function(env) {
                            if (env && !__WEBPACK_IMPORTED_MODULE_6__config__.n.paypalUrls[env]) throw new Error("Invalid env: " + env);
                        }
                    },
                    client: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {};
                        },
                        sendToChild: !1,
                        validate: function(client, props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                            if (!client[env]) throw new Error("Client ID not found for env: " + env);
                            if ("string" == typeof client[env]) {
                                if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                            } else if (!__WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.isPromise(client[env])) throw new Error("Expected client token to be either a string or a promise");
                        },
                        decorate: function(client) {
                            client && "demo_sandbox_client_id" === client.sandbox && (client.sandbox = "AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R");
                            client && "demo_production_client_id" === client.production && (client.production = "Aco85QiB9jk8Q3GdsidqKVCXuPAAVbnqm0agscHCL2-K2Lu2L6MxDU2AwTZa-ALMn_N0z-s2MXKJBxqJ");
                            return client;
                        }
                    },
                    source: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.l.MANUAL;
                        }
                    },
                    prefetchLogin: {
                        type: "boolean",
                        required: !1
                    },
                    onRememberUser: {
                        type: "function",
                        required: !1,
                        decorate: function(original, props) {
                            if (original) {
                                var source = Object(__WEBPACK_IMPORTED_MODULE_17__templates_config__.h)(props.style && props.style.label);
                                Object(__WEBPACK_IMPORTED_MODULE_7__lib__.z)(source).then(function(result) {
                                    result && original && original();
                                });
                                return original;
                            }
                        }
                    },
                    stage: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function(props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                            if (env === __WEBPACK_IMPORTED_MODULE_6__config__.d.STAGE || env === __WEBPACK_IMPORTED_MODULE_6__config__.d.LOCAL) return __WEBPACK_IMPORTED_MODULE_6__config__.n.stage;
                        }
                    },
                    braintree: {
                        type: "object",
                        required: !1,
                        validate: function(braintree, props) {
                            if (!braintree.paypalCheckout) throw new Error("Expected Braintree paypal-checkout component to be loaded");
                            if (!props.client) throw new Error("Expected client prop to be passed with Braintree authorization keys");
                        },
                        decorate: function(braintree, props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.hash(props.client).then(function(client) {
                                return Object(__WEBPACK_IMPORTED_MODULE_15__braintree__.a)(braintree, client[env]);
                            });
                        }
                    },
                    payment: {
                        type: "function",
                        required: !0,
                        memoize: !1,
                        timeout: 1e4,
                        alias: "billingAgreement",
                        decorate: function(original) {
                            return function() {
                                var _this2 = this, data = {}, actions = {
                                    request: __WEBPACK_IMPORTED_MODULE_7__lib__.Q,
                                    payment: {
                                        create: function(options) {
                                            return _this2.props.braintree ? _this2.props.braintree.then(function(client) {
                                                return client.createPayment(Object(__WEBPACK_IMPORTED_MODULE_15__braintree__.b)(options.payment || options));
                                            }) : __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.hash(_this2.props.client).then(function(client) {
                                                return __WEBPACK_IMPORTED_MODULE_8__api__.a.payment.create(_this2.props.env, client, options);
                                            });
                                        }
                                    },
                                    order: {
                                        create: function(options) {
                                            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.hash(_this2.props.client).then(function(client) {
                                                return __WEBPACK_IMPORTED_MODULE_8__api__.a.order.create(_this2.props.env, client, options);
                                            });
                                        }
                                    },
                                    braintree: {
                                        create: function(options) {
                                            if (!_this2.props.braintree) throw new Error("Can not create using Braintree - no braintree client provided");
                                            return _this2.props.braintree.then(function(client) {
                                                return client.createPayment(options);
                                            });
                                        }
                                    }
                                };
                                if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__.k)("memoize_payment") && this.memoizedToken) return this.memoizedToken;
                                this.memoizedToken = __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(original, this, [ data, actions ]);
                                this.props.env !== __WEBPACK_IMPORTED_MODULE_6__config__.d.PRODUCTION || Object(__WEBPACK_IMPORTED_MODULE_7__lib__.k)("disable_payment_timeout") || (this.memoizedToken = this.memoizedToken.timeout(1e4, new Error("Timed out waiting 10000ms for payment")));
                                this.memoizedToken = this.memoizedToken.then(function(token) {
                                    var _track;
                                    if (!token) {
                                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.f)("no_token_passed_to_payment");
                                        throw new Error("No value passed to payment");
                                    }
                                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.CHECKOUT, 
                                    _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.RECIEVE_PAYMENT, 
                                    _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.CONTEXT_TYPE[Object(__WEBPACK_IMPORTED_MODULE_11__checkout_util__.c)(token)], 
                                    _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.CONTEXT_ID] = token, _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SESSION_UID] = _this2.props.buttonSessionID, 
                                    _track));
                                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                    return token;
                                });
                                return this.memoizedToken;
                            };
                        }
                    },
                    funding: {
                        type: "object",
                        required: !1,
                        queryParam: !0,
                        validate: function() {
                            var _ref2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref2$allowed = _ref2.allowed, allowed = void 0 === _ref2$allowed ? [] : _ref2$allowed, _ref2$disallowed = _ref2.disallowed, disallowed = void 0 === _ref2$disallowed ? [] : _ref2$disallowed;
                            Object(__WEBPACK_IMPORTED_MODULE_16__templates_funding__.c)({
                                allowed: allowed,
                                disallowed: disallowed,
                                remembered: []
                            });
                        },
                        def: function() {
                            return {};
                        },
                        decorate: function() {
                            var _ref3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref3$allowed = _ref3.allowed, allowed = void 0 === _ref3$allowed ? [] : _ref3$allowed, _ref3$disallowed = _ref3.disallowed, disallowed = void 0 === _ref3$disallowed ? [] : _ref3$disallowed;
                            allowed && -1 !== allowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO) && !Object(__WEBPACK_IMPORTED_MODULE_7__lib__.w)() && allowed.splice(allowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO), 1);
                            var remembered = Object(__WEBPACK_IMPORTED_MODULE_7__lib__.o)(function(sources) {
                                return sources;
                            });
                            if (!Object(__WEBPACK_IMPORTED_MODULE_7__lib__.w)() || Object(__WEBPACK_IMPORTED_MODULE_7__lib__.k)("disable_venmo")) {
                                remembered && -1 !== remembered.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO) && remembered.splice(remembered.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO), 1);
                                disallowed && -1 === disallowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO) && disallowed.push(__WEBPACK_IMPORTED_MODULE_6__config__.f.VENMO);
                            }
                            for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__.get)(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__.KEY.PAYPAL_FUNDING_DISALLOW, []), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                                var _ref4;
                                if (_isArray) {
                                    if (_i >= _iterator.length) break;
                                    _ref4 = _iterator[_i++];
                                } else {
                                    _i = _iterator.next();
                                    if (_i.done) break;
                                    _ref4 = _i.value;
                                }
                                var source = _ref4;
                                -1 === disallowed.indexOf(source) && disallowed.push(source);
                            }
                            return {
                                allowed: allowed,
                                disallowed: disallowed,
                                remembered: remembered,
                                remember: function(sources) {
                                    Object(__WEBPACK_IMPORTED_MODULE_7__lib__.P)(sources);
                                }
                            };
                        }
                    },
                    commit: {
                        type: "boolean",
                        required: !1
                    },
                    onRender: {
                        type: "function",
                        promisify: !0,
                        required: !1,
                        noop: !0,
                        decorate: function(original) {
                            return function() {
                                var _track2;
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.LOAD, 
                                _track2[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.BUTTON_RENDER, 
                                _track2[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.BUTTON_TYPE.IFRAME, 
                                _track2[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _track2[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SOURCE] = this.props.source, 
                                _track2));
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                return original.apply(this, arguments);
                            };
                        }
                    },
                    onAuthorize: {
                        type: "function",
                        required: !0,
                        decorate: function(original) {
                            return function(data, actions) {
                                var _track3, _this3 = this;
                                data && !data.intent && Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.p)("button_authorize_no_intent", {
                                    paymentID: data.paymentID,
                                    token: data.paymentToken
                                });
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("button_authorize");
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track3 = {}, _track3[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.CHECKOUT, 
                                _track3[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.CHECKOUT_AUTHORIZE, 
                                _track3[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _track3));
                                Object(__WEBPACK_IMPORTED_MODULE_7__lib__.y)() || Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("button_authorize_ineligible");
                                Object(__WEBPACK_IMPORTED_MODULE_7__lib__.c)("authorize");
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                actions.order = {
                                    get: function() {
                                        return __WEBPACK_IMPORTED_MODULE_8__api__.a.order.get(_this3.props.env, _this3.props.client, data.orderID || data.paymentToken);
                                    },
                                    capture: function() {
                                        return __WEBPACK_IMPORTED_MODULE_8__api__.a.order.capture(_this3.props.env, _this3.props.client, data.orderID || data.paymentToken);
                                    }
                                };
                                var restart = actions.restart;
                                actions.restart = function() {
                                    return restart().then(function() {
                                        return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a();
                                    });
                                };
                                actions.redirect = function(win, url) {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ Object(__WEBPACK_IMPORTED_MODULE_7__lib__.O)(win || window.top, url || data.returnUrl), actions.close() ]);
                                };
                                actions.payment.tokenize = Object(__WEBPACK_IMPORTED_MODULE_7__lib__.G)(function() {
                                    if (!_this3.props.braintree) throw new Error("Must pass in Braintree client to tokenize payment");
                                    return _this3.props.braintree.then(function(client) {
                                        return client.tokenizePayment(data);
                                    }).then(function(res) {
                                        return {
                                            nonce: res.nonce
                                        };
                                    });
                                });
                                var execute = actions.payment.execute;
                                actions.payment.execute = function() {
                                    return execute().then(function(result) {
                                        if (!(result && result.id && result.intent && result.state)) {
                                            Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.p)("execute_result_missing_data");
                                            return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a();
                                        }
                                        return result;
                                    });
                                };
                                actions.request = __WEBPACK_IMPORTED_MODULE_7__lib__.Q;
                                __WEBPACK_IMPORTED_MODULE_9__experiments__.b.trigger({
                                    paymentToken: data.paymentToken
                                });
                                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                    if (_this3.props.braintree) return actions.payment.tokenize().then(function(_ref5) {
                                        var nonce = _ref5.nonce;
                                        Object.defineProperty(data, "nonce", {
                                            get: function() {
                                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("nonce_getter");
                                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                                return nonce;
                                            }
                                        });
                                    });
                                }).then(function() {
                                    return original.call(_this3, data, actions);
                                }).catch(function(err) {
                                    if (_this3.props.onError) return _this3.props.onError(err);
                                    throw err;
                                });
                            };
                        }
                    },
                    onCancel: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        decorate: function(original) {
                            return function(data, actions) {
                                var _track4;
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("button_cancel");
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track4 = {}, _track4[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.CHECKOUT, 
                                _track4[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.CHECKOUT_CANCEL, 
                                _track4[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _track4));
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                var redirect = function(win, url) {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ Object(__WEBPACK_IMPORTED_MODULE_7__lib__.O)(win || window.top, url || data.cancelUrl), actions.close() ]);
                                };
                                return original.call(this, data, _extends({}, actions, {
                                    redirect: redirect
                                }));
                            };
                        }
                    },
                    onClick: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        decorate: function(original) {
                            return function(data) {
                                var _track5;
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.j)("button_click");
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track5 = {}, _track5[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.BUTTON, 
                                _track5[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.BUTTON_CLICK, 
                                _track5[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.BUTTON_TYPE.IFRAME, 
                                _track5[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _track5[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), 
                                _track5));
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                                return original.apply(this, arguments);
                            };
                        }
                    },
                    locale: {
                        type: "string",
                        required: !1,
                        queryParam: "locale.x",
                        def: function() {
                            var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_7__lib__.h)();
                            return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                        },
                        validate: __WEBPACK_IMPORTED_MODULE_14__templates_component_validate__.a
                    },
                    style: {
                        type: "object",
                        required: !1,
                        queryParam: !0,
                        alias: "buttonStyle",
                        def: function() {
                            return {
                                color: __WEBPACK_IMPORTED_MODULE_12__constants__.b.GOLD,
                                shape: __WEBPACK_IMPORTED_MODULE_12__constants__.h.PILL,
                                size: __WEBPACK_IMPORTED_MODULE_12__constants__.i.SMALL,
                                label: __WEBPACK_IMPORTED_MODULE_12__constants__.c.CHECKOUT,
                                fundingicons: !1
                            };
                        },
                        validate: function() {
                            var style = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            Object(__WEBPACK_IMPORTED_MODULE_14__templates_component_validate__.c)(style);
                        }
                    },
                    displayTo: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.m.ALL;
                        }
                    },
                    validate: {
                        type: "function",
                        required: !1
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        get value() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.n.logLevel;
                        }
                    },
                    popupBridge: {
                        type: "object",
                        required: !1,
                        get value() {
                            return {
                                open: Object(__WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__.b)(),
                                awaitOpener: __WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__.a
                            };
                        }
                    },
                    test: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {
                                action: "checkout"
                            };
                        }
                    }
                }
            });
            if (Button.isChild()) {
                Object(__WEBPACK_IMPORTED_MODULE_7__lib__.m)().then(function(pageRenderTime) {
                    var _track6, fundingSources = Array.prototype.slice.call(document.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_6__config__.a.FUNDING_SOURCE + "]")).map(function(el) {
                        return el.getAttribute(__WEBPACK_IMPORTED_MODULE_6__config__.a.CARD) || el.getAttribute(__WEBPACK_IMPORTED_MODULE_6__config__.a.FUNDING_SOURCE);
                    }).filter(function(source) {
                        return source && source !== __WEBPACK_IMPORTED_MODULE_6__config__.f.CARD;
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.o)((_track6 = {}, _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.BUTTON, 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.BUTTON_LOAD, 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.BUTTON_TYPE.IFRAME, 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.FUNDING_LIST] = fundingSources.join(":"), 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.FUNDING_COUNT] = fundingSources.length, 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.PAGE_LOAD_TIME] = pageRenderTime, 
                    _track6[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.BUTTON_LAYOUT] = window.xprops && window.xprops.style && window.xprops.style.layout || __WEBPACK_IMPORTED_MODULE_12__constants__.d.HORIZONTAL, 
                    _track6));
                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__.g)();
                });
                window.xprops.logLevel && Object(__WEBPACK_IMPORTED_MODULE_7__lib__.S)(window.xprops.logLevel);
                Object(__WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__.a)();
            }
        },
        "./src/components/button/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return DEFAULT;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return BUTTON_STYLE_OPTIONS;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return BUTTON_LABEL;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return BUTTON_COLOR;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return BUTTON_LOGO_COLOR;
            });
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return BUTTON_SIZE;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return BUTTON_TAGLINE_COLOR;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return BUTTON_SHAPE;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return BUTTON_BRANDING;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return BUTTON_LAYOUT;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return BUTTON_NUMBER;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return BUTTON_LOGO;
            });
            var DEFAULT = "default", BUTTON_STYLE_OPTIONS = {
                LABEL: "label",
                SIZE: "size",
                SHAPE: "shape",
                COLOR: "color",
                LAYOUT: "layout",
                MAXBUTTONS: "maxbuttons",
                FUNDINGICONS: "fundingicons",
                BRANDING: "branding",
                TAGLINE: "tagline",
                HEIGHT: "height"
            }, BUTTON_LABEL = {
                PAYPAL: "paypal",
                CHECKOUT: "checkout",
                PAY: "pay",
                CREDIT: "credit",
                CARD: "card",
                BUYNOW: "buynow",
                VENMO: "venmo",
                IDEAL: "ideal",
                ELV: "elv"
            }, BUTTON_COLOR = {
                GOLD: "gold",
                BLUE: "blue",
                SILVER: "silver",
                BLACK: "black",
                DARKBLUE: "darkblue",
                TRANSPARENT: "transparent"
            }, BUTTON_LOGO_COLOR = {
                BLUE: "blue",
                WHITE: "white",
                BLACK: "black",
                ANY: "any"
            }, BUTTON_SIZE = {
                TINY: "tiny",
                SMALL: "small",
                MEDIUM: "medium",
                LARGE: "large",
                HUGE: "huge",
                RESPONSIVE: "responsive"
            }, BUTTON_TAGLINE_COLOR = {
                BLACK: "black",
                BLUE: "blue"
            }, BUTTON_SHAPE = {
                PILL: "pill",
                RECT: "rect"
            }, BUTTON_BRANDING = {
                BRANDED: "branded",
                UNBRANDED: "unbranded"
            }, BUTTON_LAYOUT = {
                HORIZONTAL: "horizontal",
                VERTICAL: "vertical"
            }, BUTTON_NUMBER = {
                SINGLE: "single",
                MULTIPLE: "multiple"
            }, BUTTON_LOGO = {
                PP: "pp",
                PAYPAL: "paypal",
                VENMO: "venmo",
                CREDIT: "credit",
                IDEAL: "ideal",
                ELV: "elv"
            };
        },
        "./src/components/button/hacks.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("./src/api/index.js"), __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_7__login__ = __webpack_require__("./src/components/login/index.js"), __WEBPACK_IMPORTED_MODULE_8__checkout__ = __webpack_require__("./src/components/checkout/index.js"), __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("./src/components/button/component.jsx"), __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("./src/components/button/constants.js");
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_4__api__.a.payment, "create", function(_ref) {
                var createOriginal = _ref.original, createContext = _ref.context, _ref$args = _ref.args, env = _ref$args[0], client = _ref$args[1], options = _ref$args[2], experience = _ref$args[3];
                options.payment || (options = {
                    payment: options,
                    experience: experience
                });
                return createOriginal.call(createContext, env, client, options);
            });
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_9__component__.a.props.style, "validate", function(_ref2) {
                var callOriginal = _ref2.callOriginal, _ref2$args = _ref2.args, style = _ref2$args[0];
                if (!style) return callOriginal();
                style && "creditblue" === style.color && (style.color = __WEBPACK_IMPORTED_MODULE_10__constants__.b.DARKBLUE);
                style && "generic" === style.label && (style.label = __WEBPACK_IMPORTED_MODULE_10__constants__.c.PAYPAL);
                if (style && (!style.label || style.label === __WEBPACK_IMPORTED_MODULE_10__constants__.c.CHECKOUT) && "tiny" === style.size) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("unsupported_button_size_tiny");
                    style.size = __WEBPACK_IMPORTED_MODULE_10__constants__.i.SMALL;
                }
                return callOriginal();
            });
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_9__component__.a, "render", function(_ref3) {
                var callOriginal = _ref3.callOriginal, _ref3$args = _ref3.args, props = _ref3$args[0];
                if (props.billingAgreement) {
                    props.payment = props.billingAgreement;
                    delete props.billingAgreement;
                }
                return callOriginal();
            });
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_9__component__.a.props.payment, "decorate", function(_ref4) {
                var original = _ref4.original, context = _ref4.context, _ref4$args = _ref4.args, originalPayment = _ref4$args[0];
                return original.call(context, function(data, actions) {
                    var _this = this;
                    return new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a(function(resolve, reject) {
                        function resolveData(token) {
                            resolve(token);
                        }
                        function rejectActions(err) {
                            reject(err);
                        }
                        Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(actions.payment, "create", function(_ref5) {
                            var createOriginal = _ref5.original, createContext = _ref5.context, _ref5$args = _ref5.args, options = _ref5$args[0], experience = _ref5$args[1];
                            options.payment || (options = {
                                payment: options,
                                experience: experience
                            });
                            return createOriginal.call(createContext, options);
                        });
                        Object(__WEBPACK_IMPORTED_MODULE_6__lib__.f)(resolveData, data);
                        Object(__WEBPACK_IMPORTED_MODULE_6__lib__.f)(resolveData, actions);
                        Object(__WEBPACK_IMPORTED_MODULE_6__lib__.f)(rejectActions, actions);
                        var ctx = {
                            props: {
                                env: _this.props.env,
                                client: _this.props.client
                            }
                        }, result = void 0;
                        try {
                            result = originalPayment.call(ctx, resolveData, rejectActions);
                        } catch (err) {
                            return reject(err);
                        }
                        return result && "function" == typeof result.then ? result.then(resolve, reject) : void 0 !== result ? resolve(result) : void 0;
                    });
                });
            });
            if (__WEBPACK_IMPORTED_MODULE_9__component__.a.isChild()) {
                window.Promise || (window.Promise = __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__.a);
                var debounce = !1;
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_8__checkout__.a, "renderTo", function(_ref6) {
                    var callOriginal = _ref6.callOriginal, _ref6$args = _ref6.args, props = _ref6$args[1];
                    if (!debounce) {
                        debounce = !0;
                        for (var _arr = [ "onAuthorize", "onCancel", "onError", "onClose" ], _i = 0; _i < _arr.length; _i++) !function() {
                            var methodName = _arr[_i], original = props[methodName];
                            props[methodName] = function() {
                                debounce = !1;
                                if (original) return original.apply(this, arguments);
                            };
                        }();
                        return callOriginal();
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("button_mutliple_click_debounce");
                });
                if (window.xprops.validate) {
                    var enabled = !0;
                    window.xprops.validate({
                        enable: function() {
                            enabled = !0;
                        },
                        disable: function() {
                            enabled = !1;
                        }
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_8__checkout__.a, "renderTo", function(_ref7) {
                        var callOriginal = _ref7.callOriginal;
                        if (enabled) return callOriginal();
                    });
                }
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.A)() && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.k)("ie_full_page") && (__WEBPACK_IMPORTED_MODULE_8__checkout__.a.renderTo = function(win) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("force_ie_full_page");
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g)();
                    var checkout = __WEBPACK_IMPORTED_MODULE_8__checkout__.a.init({
                        onAuthorize: __WEBPACK_IMPORTED_MODULE_6__lib__.H
                    });
                    checkout.delegate(win);
                    checkout.openContainer().then(function() {
                        checkout.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__.a.EVENTS.CLOSE);
                        checkout.showContainer();
                    });
                    window.xprops.payment().then(function(token) {
                        window.top.location = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.g)(__WEBPACK_IMPORTED_MODULE_5__config__.n.checkoutUrl, {
                            token: token
                        });
                    }).catch(function(err) {
                        checkout.error(err);
                    });
                });
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.k)("allow_full_page_fallback") && Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_8__checkout__.a, "renderTo", function(_ref8) {
                    var callOriginal = _ref8.callOriginal, _ref8$args = _ref8.args, props = _ref8$args[1], handleError = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.K)(function(err) {
                        try {
                            console.error(err && err.stack);
                        } catch (err2) {}
                        return window.xprops.payment().then(function(token) {
                            window.top.location = Object(__WEBPACK_IMPORTED_MODULE_6__lib__.g)(__WEBPACK_IMPORTED_MODULE_5__config__.n.checkoutUrl, {
                                token: token
                            });
                        });
                    });
                    props.onError = handleError;
                    return callOriginal().catch(handleError);
                });
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_7__login__.a, "prerender", function(_ref9) {
                    var callOriginal = _ref9.callOriginal;
                    delete _ref9.args[0].env;
                    return callOriginal();
                });
                var parent = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__.l)(window), top = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__.m)(window);
                if (top && parent) {
                    var canRenderTop = top === parent;
                    if (!canRenderTop) {
                        __WEBPACK_IMPORTED_MODULE_8__checkout__.a.canRenderTo(top).then(function(result) {
                            canRenderTop = result;
                        });
                        Object(__WEBPACK_IMPORTED_MODULE_6__lib__.M)(__WEBPACK_IMPORTED_MODULE_8__checkout__.a, "renderTo", function(_ref10) {
                            var _ref10$args = _ref10.args, win = _ref10$args[0], props = _ref10$args[1], el = _ref10$args[2], original = _ref10.original, context = _ref10.context;
                            canRenderTop || (win = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__.l)(window));
                            return original.call(context, win, props, el);
                        });
                    }
                }
            }
        },
        "./src/components/button/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_1__component__ = (__webpack_require__("./src/components/button/hacks.js"), 
            __webpack_require__("./src/components/button/component.jsx"));
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_1__component__.a;
            });
        },
        "./src/components/button/templates/component/content.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return componentContent;
            });
            var __WEBPACK_IMPORTED_MODULE_0__content_json__ = __webpack_require__("./src/components/button/templates/component/content.json"), __WEBPACK_IMPORTED_MODULE_0__content_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__content_json__), componentContent = "string" == typeof __WEBPACK_IMPORTED_MODULE_0__content_json___default.a ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__content_json___default.a) : __WEBPACK_IMPORTED_MODULE_0__content_json___default.a;
        },
        "./src/components/button/templates/component/content.json": function(module, exports) {
            module.exports = '{\n    "AD": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        },\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        }\n    },\n    "AG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AL": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "AM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AN": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AO": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AR": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "AT": {\n        "de": {\n            "checkout": "Direkt zu {logo:pp} {logo:paypal}",\n            "safer_tag": "Einfach schneller und sicherer bezahlen",\n            "later_tag": "Kaufen Sie jetzt und bezahlen Sie nach und nach.",\n            "pay": "Mit {logo:paypal} zahlen",\n            "buynow": "{logo:pp} {logo:paypal} Jetzt kaufen"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "AU": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "AW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "AZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BB": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BE": {\n        "en": {\n            "checkout": "Pay with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, faster way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "nl": {\n            "checkout": "Betalen met {logo:pp} {logo:paypal}",\n            "safer_tag": "De veiligere en snellere manier om te betalen.",\n\n            "later_tag": "Koop nu. Betaal later.",\n            "pay": "Betalen met {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Nu kopen"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Le r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        }\n    },\n    "BF": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BH": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BI": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BJ": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BN": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BO": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BR": {\n        "pt": {\n            "checkout": "{logo:pp} {logo:paypal} Finalizar",\n            "safer_tag": "A maneira f\\u00e1cil e segura de enviar pagamentos.",\n            "later_tag": "Compre agora e pague depois.",\n            "pay": "Pague com {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar agora"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BT": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "BY": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "BZ": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "C2": {\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\\u3002",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "CA": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "{logo:pp} {logo:paypal} Payer",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer",\n            "later_tag": "Acheter. Payer plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        }\n    },\n    "CD": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CH": {\n        "de": {\n            "checkout": "Direkt zu {logo:pp} {logo:paypal}",\n            "safer_tag": "Einfach schneller und sicherer bezahlen",\n            "later_tag": "Kaufen Sie jetzt und bezahlen Sie nach und nach.",\n            "pay": "Mit {logo:paypal} zahlen",\n            "buynow": "{logo:pp} {logo:paypal} Jetzt kaufen"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Le r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "CI": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "CK": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CL": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CM": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "CN": {\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CO": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CR": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CV": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "CY": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "CZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "DE": {\n        "de": {\n            "checkout": "Direkt zu {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u00dcberall schnell und sicher bezahlen.",\n            "later_tag": "Kaufen Sie jetzt und bezahlen Sie nach und nach.",\n            "pay": "Mit {logo:paypal} zahlen",\n            "buynow": "{logo:pp} {logo:paypal} Jetzt kaufen"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "DJ": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "DK": {\n        "da": {\n            "checkout": "{logo:pp} {logo:paypal} Betal",\n            "safer_tag": "Betal nemt og sikkert",\n            "later_tag": "K\\u00f8b nu, betal senere.",\n            "pay": "Betal med {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} K\\u00f8b nu"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "DM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "DO": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "DZ": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "EC": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "EE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "ru": {\n            "checkout": "\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.",\n            "later_tag": "\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.",\n            "pay": "\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "EG": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ER": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ES": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "ET": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "FI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "FJ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "FK": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "FM": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "FO": {\n        "da": {\n            "checkout": "Betal med {logo:pp} {logo:paypal}",\n            "safer_tag": "Betal nemt og sikkert",\n\n            "later_tag": "K\\u00f8b nu, betal senere.",\n            "pay": "Betal med {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} K\\u00f8b nu"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "FR": {\n        "fr": {\n            "checkout": "{logo:pp} {logo:paypal} Payer",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Pay",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "GA": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GB": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "GD": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GF": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GL": {\n        "da": {\n            "checkout": "Betal med {logo:pp} {logo:paypal}",\n            "safer_tag": "Betal nemt og sikkert",\n\n            "later_tag": "K\\u00f8b nu, betal senere.",\n            "pay": "Betal med {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} K\\u00f8b nu"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GN": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GP": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GR": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GT": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "GY": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "HK": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal} \\u7d50\\u5e33",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u65b9\\u4fbf\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u5148\\u8cfc\\u8cb7\\uff0c\\u5f8c\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u4f7f\\u7528 {logo:paypal} \\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8cb7"\n        }\n    },\n    "HN": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "HR": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "HU": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ID": {\n        "id": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "Cara yang lebih mudah dan aman untuk membayar.",\n\n            "later_tag": "Beli Sekarang. Bayar dalam Jangka Waktu Tertentu.",\n            "pay": "Bayar dengan {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Beli Sekarang"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "IE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "IL": {\n        "he": {\n            "checkout": "{logo:pp} {logo:paypal} \\u05e9\\u05dc\\u05dd",\n            "safer_tag": ".\\u05d4\\u05d3\\u05e8\\u05da \\u05d4\\u05e7\\u05dc\\u05d4 \\u05d5\\u05d4\\u05d1\\u05d8\\u05d5\\u05d7\\u05d4 \\u05d9\\u05d5\\u05ea\\u05e8 \\u05dc\\u05e9\\u05dc\\u05dd",\n\n            "later_tag": "\\u05e7\\u05e0\\u05d4 \\u05e2\\u05db\\u05e9\\u05d9\\u05d5. \\u05e9\\u05dc\\u05dd \\u05dc\\u05d0\\u05d5\\u05e8\\u05da \\u05d6\\u05de\\u05df.",\n            "pay": "\\u05e9\\u05dc\\u05dd \\u05d1\\u05d0\\u05de\\u05e6\\u05e2\\u05d5\\u05ea {logo:paypal}\\u200f",\n            "buynow": "{logo:pp} {logo:paypal} \\u05e7\\u05e0\\u05d4 \\u05e2\\u05db\\u05e9\\u05d9\\u05d5"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "IN": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "IS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "IT": {\n        "it": {\n            "checkout": "{logo:pp} {logo:paypal} Paga adesso",\n            "safer_tag": "Il modo rapido e sicuro per pagare",\n\n            "later_tag": "Acquista ora. Paga pi\\u00f9 tardi.",\n            "pay": "Paga con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Paga adesso"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "JM": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "JO": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "JP": {\n        "ja": {\n            "checkout": "{logo:pp} {logo:paypal}\\u3067\\u652f\\u6255\\u3046",\n            "safer_tag": "\\u3088\\u308a\\u5b89\\u5168\\u30fb\\u7c21\\u5358\\u306b\\u304a\\u652f\\u6255\\u3044",\n\n            "later_tag": "\\u4eca\\u3059\\u3050\\u8cfc\\u5165\\u3057\\u3066\\u3001\\u5206\\u5272\\u3057\\u3066\\u304a\\u652f\\u6255\\u3044\\u3002",\n            "pay": "{logo:paypal}\\u3067\\u652f\\u6255\\u3046",\n            "buynow": "{logo:pp} {logo:paypal} \\u8cfc\\u5165"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "KE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KH": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "KI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KM": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KN": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KR": {\n        "ko": {\n            "checkout": "{logo:pp} {logo:paypal} \\uccb4\\ud06c \\uc544\\uc6c3",\n            "safer_tag": "\\ub354 \\uc548\\uc804\\ud558\\uace0 \\ube60\\ub978 \\uacb0\\uc81c \\ubc29\\ubc95",\n\n            "later_tag": "\\uc9c0\\uae08 \\uad6c\\ub9e4\\ud558\\uace0 \\ucc9c\\ucc9c\\ud788 \\uacb0\\uc81c\\ud558\\uc138\\uc694.",\n            "pay": "{logo:paypal}\\ub85c \\uc9c0\\ubd88\\ud558\\uae30",\n            "buynow": "{logo:pp} {logo:paypal} \\ubc14\\ub85c \\uad6c\\ub9e4"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "KW": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KY": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "KZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LA": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "LC": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LK": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "LS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LT": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "ru": {\n            "checkout": "\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.",\n\n            "later_tag": "\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.",\n            "pay": "\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LU": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "de": {\n            "checkout": "Direkt zu {logo:pp} {logo:paypal}",\n            "safer_tag": "Einfach schneller und sicherer bezahlen",\n\n            "later_tag": "Kaufen Sie jetzt und bezahlen Sie nach und nach.",\n            "pay": "Mit {logo:paypal} zahlen",\n            "buynow": "{logo:pp} {logo:paypal} Jetzt kaufen"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "LV": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "ru": {\n            "checkout": "\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.",\n\n            "later_tag": "\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.",\n            "pay": "\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MA": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MC": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MD": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "ME": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MH": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MK": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "ML": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MN": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MQ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MR": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MT": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MU": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MV": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "MX": {\n        "es": {\n            "checkout": "Pagar con {logo:pp} {logo:paypal}",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MY": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "MZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NC": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NE": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NF": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "NI": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NL": {\n        "nl": {\n            "checkout": "{logo:pp} {logo:paypal} Betalen",\n            "safer_tag": "Een veilige en makkelijke manier om te betalen.",\n\n            "later_tag": "Koop nu. Betaal later.",\n            "pay": "Betalen met {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Nu kopen"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "NO": {\n        "no": {\n            "checkout": "{logo:pp} {logo:paypal} Betal",\n            "safer_tag": "En trygg og enkel betalingsmetode",\n\n            "later_tag": "Kj\\u00f8p n\\u00e5, betal senere.",\n            "pay": "Betal med {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Kj\\u00f8p n\\u00e5"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "NP": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "NR": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NU": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "NZ": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "{logo:pp} {logo:paypal} Payer",\n            "safer_tag": "Un r\\u00e9flexe s\\u00e9curit\\u00e9.",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar.",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\\u3002",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "OM": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PA": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PE": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PF": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PH": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "PL": {\n        "pl": {\n            "checkout": "{logo:pp} {logo:paypal} Do kasy",\n            "safer_tag": "P\\u0142a\\u0107 wygodnie i bezpiecznie",\n\n            "later_tag": "Kup teraz. P\\u0142a\\u0107 w ratach",\n            "pay": "Zap\\u0142a\\u0107 z {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Kup teraz"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "PM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PN": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PT": {\n        "pt": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A forma r\\u00e1pida e segura de pagar",\n\n            "later_tag": "Compre agora. V\\u00e1 pagando.",\n            "pay": "Pagar com {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar agora"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "PW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "PY": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "QA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        },\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        }\n    },\n    "RE": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "RO": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "RS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "RU": {\n        "ru": {\n            "checkout": "{logo:pp} {logo:paypal}\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u043f\\u043e\\u043a\\u0443\\u043f\\u043a\\u0443",\n            "safer_tag": "\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.",\n\n            "later_tag": "\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.",\n            "pay": "\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "RW": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SA": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SB": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SC": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SE": {\n        "sv": {\n            "checkout": "{logo:pp} {logo:paypal} Betala",\n            "safer_tag": "Ett tryggt och smidigt s\\u00e4tt att betala",\n            "later_tag": "K\\u00f6p nu, betala senare",\n            "pay": "Betala med {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} K\\u00f6p nu"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "SG": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "SH": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SI": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SJ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SK": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SL": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SN": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SO": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SR": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ST": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SV": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "SZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TC": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TD": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TG": {\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TH": {\n        "th": {\n            "checkout": "{logo:pp} {logo:paypal} \\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19",\n            "safer_tag": "\\u0e27\\u0e34\\u0e18\\u0e35\\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19\\u0e17\\u0e35\\u0e48\\u0e1b\\u0e25\\u0e2d\\u0e14\\u0e20\\u0e31\\u0e22\\u0e41\\u0e25\\u0e30\\u0e07\\u0e48\\u0e32\\u0e22\\u0e01\\u0e27\\u0e48\\u0e32",\n\n            "later_tag": "\\u0e0b\\u0e37\\u0e49\\u0e2d\\u0e27\\u0e31\\u0e19\\u0e19\\u0e35\\u0e49 \\u0e41\\u0e25\\u0e49\\u0e27\\u0e04\\u0e48\\u0e2d\\u0e22\\u0e46 \\u0e08\\u0e48\\u0e32\\u0e22\\u0e17\\u0e35\\u0e2b\\u0e25\\u0e31\\u0e07",\n            "pay": "\\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19\\u0e14\\u0e49\\u0e27\\u0e22 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0e0b\\u0e37\\u0e49\\u0e2d\\u0e17\\u0e31\\u0e19\\u0e17\\u0e35"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "TJ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TN": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TO": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "TR": {\n        "tr": {\n            "checkout": "{logo:pp} {logo:paypal} ile Sat\\u0131n Al\\u0131n",\n            "safer_tag": "\\u00d6deme yapman\\u0131n daha g\\u00fcvenli ve kolay yolu",\n\n            "later_tag": "\\u015eimdi Al\\u0131n. Daha Sonra \\u00d6deyin.",\n            "pay": "{logo:paypal} ile \\u00d6de",\n            "buynow": "{logo:pp} {logo:paypal} Hemen Sat\\u0131n Al\\u0131n"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "TT": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TV": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "TW": {\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal} \\u7d50\\u5e33",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u65b9\\u4fbf\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u5148\\u8cfc\\u8cb7\\uff0c\\u5f8c\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u4f7f\\u7528 {logo:paypal} \\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8cfc"\n        },\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "TZ": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "UA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "ru": {\n            "checkout": "\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.",\n\n            "later_tag": "\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.",\n            "pay": "\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "UG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "US": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "dual_tag": "Two easy ways to pay",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "{logo:pp} {logo:paypal} Payer",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "Pagar con {logo:pp} {logo:paypal}",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "\\u4f7f\\u7528{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "UY": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "VA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "VC": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "VE": {\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "VG": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "VN": {\n        "en": {\n            "checkout": "{logo:pp} {logo:paypal} Checkout",\n            "safer_tag": "A safer, faster way to pay.",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "VU": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "WF": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "WS": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    },\n    "YE": {\n        "ar": {\n            "checkout": "\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}",\n            "safer_tag": "\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639",\n            "later_tag": "\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a",\n            "pay": "\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646"\n        },\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "YT": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ZA": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ZM": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        },\n        "fr": {\n            "checkout": "Payer avec {logo:pp} {logo:paypal}",\n            "safer_tag": "Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne",\n            "later_tag": "Achetez maintenant et payez plus tard.",\n            "pay": "Payer avec {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Acheter"\n        },\n        "es": {\n            "checkout": "{logo:pp} {logo:paypal} Pagar",\n            "safer_tag": "La forma r\\u00e1pida y segura de pagar",\n            "later_tag": "Compre ahora y pague m\\u00e1s adelante.",\n            "pay": "Pagar con {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Comprar ahora"\n        },\n        "zh": {\n            "checkout": "{logo:pp} {logo:paypal}\\u7ed3\\u8d26",\n            "safer_tag": "\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f",\n            "later_tag": "\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002",\n            "pay": "\\u7528{logo:paypal}\\u4ed8\\u6b3e",\n            "buynow": "{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70"\n        }\n    },\n    "ZW": {\n        "en": {\n            "checkout": "Check out with {logo:pp} {logo:paypal}",\n            "safer_tag": "The safer, easier way to pay",\n            "later_tag": "Buy Now. Pay Over Time.",\n            "pay": "Pay with {logo:paypal}",\n            "buynow": "{logo:pp} {logo:paypal} Buy Now"\n        }\n    }\n}\n';
        },
        "./src/components/button/templates/component/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/button/templates/component/template.jsx");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__template__.a;
            });
            __webpack_require__("./src/config/constants.js");
        },
        "./src/components/button/templates/component/logos/amex.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(20, 119, 190);"/>\n  <path d="M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
        },
        "./src/components/button/templates/component/logos/credit_white.svg": function(module, exports) {
            module.exports = '<svg width="100" height="32" viewBox="0 0 95 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#ffffff" d="M 52.732 6.347 C 52.83 5.963 53.122 5.675 53.512 5.675 L 60.626 5.675 C 66.571 5.675 70.664 10.187 69.69 15.851 C 68.813 21.515 63.16 25.931 57.313 25.931 L 50.004 25.931 C 49.711 25.931 49.516 25.739 49.614 25.451 L 52.732 6.347 Z M 55.753 21.515 L 57.02 21.515 C 60.236 21.515 63.355 19.787 64.037 15.851 C 64.622 12.203 62.478 10.187 58.97 10.187 L 57.995 10.187 C 57.8 10.187 57.605 10.283 57.605 10.475 L 55.753 21.515 Z"/>\n  <path fill="#ffffff" d="M 43.571 10.763 L 43.084 13.547 L 48.737 13.547 C 49.029 13.547 49.224 13.739 49.224 14.027 L 48.639 17.387 C 48.542 17.771 48.249 17.963 47.859 17.963 L 42.987 17.963 C 42.597 17.963 42.304 18.251 42.207 18.635 L 41.72 21.515 L 47.762 21.515 C 48.054 21.515 48.249 21.707 48.152 21.995 L 47.665 25.355 C 47.567 25.643 47.275 25.931 46.885 25.931 L 36.067 25.931 C 35.775 25.931 35.58 25.643 35.58 25.451 L 38.699 6.347 C 38.796 5.963 39.186 5.675 39.478 5.675 L 50.393 5.675 C 50.588 5.675 50.881 5.963 50.783 6.155 L 50.296 9.515 C 50.198 9.899 49.906 10.091 49.516 10.091 L 44.254 10.091 C 43.864 10.187 43.571 10.379 43.571 10.763 Z"/>\n  <path fill="#ffffff" d="M 74.563 25.931 L 70.274 25.931 C 69.982 25.931 69.787 25.739 69.787 25.451 L 73.003 6.347 C 73.003 5.963 73.393 5.675 73.685 5.675 L 78.071 5.675 C 78.266 5.675 78.558 5.963 78.461 6.251 L 75.342 25.355 C 75.245 25.643 74.952 25.931 74.563 25.931 Z"/>\n  <path fill="#ffffff" d="M 34.118 25.931 L 28.466 25.931 C 28.173 25.931 27.978 25.835 27.881 25.643 L 24.178 18.155 L 24.08 18.155 L 22.911 25.451 C 22.813 25.739 22.618 25.931 22.326 25.931 L 17.843 25.931 C 17.551 25.931 17.356 25.739 17.453 25.451 L 20.572 6.251 C 20.669 5.963 20.864 5.675 21.156 5.675 L 28.855 5.675 C 33.046 5.675 35.97 7.595 35.288 11.915 C 34.8 14.699 32.754 17.195 29.635 17.675 L 34.508 25.355 C 34.703 25.547 34.411 25.931 34.118 25.931 Z M 24.665 14.795 L 25.152 14.795 C 27.004 14.795 29.05 14.411 29.44 12.203 C 29.83 10.091 28.661 9.707 26.711 9.707 L 25.932 9.707 C 25.639 9.707 25.445 9.899 25.445 10.091 L 24.665 14.795 Z"/>\n  <path fill="#ffffff" d="M 86.16 25.931 L 81.872 25.931 C 81.579 25.931 81.384 25.739 81.482 25.451 L 83.918 10.187 L 79.923 10.187 C 79.63 10.187 79.435 9.899 79.533 9.611 L 80.02 6.347 C 80.118 5.963 80.41 5.675 80.8 5.675 L 94.249 5.675 C 94.444 5.675 94.736 5.963 94.639 6.251 L 94.054 9.515 C 94.054 9.899 93.761 10.187 93.372 10.187 L 89.473 10.187 L 86.939 25.355 C 86.939 25.643 86.647 25.931 86.16 25.931 Z"/>\n  <path fill="#ffffff" d="M 17.648 11.435 C 17.648 11.819 17.161 12.011 16.868 11.723 C 15.894 10.763 14.529 10.283 13.068 10.283 C 9.657 10.283 7.025 12.779 6.441 15.851 C 5.953 19.019 7.902 21.323 11.313 21.323 C 12.678 21.323 14.237 20.843 15.407 19.979 C 15.796 19.787 16.284 20.075 16.186 20.459 L 15.407 25.067 C 15.309 25.355 15.114 25.547 14.822 25.643 C 13.165 26.123 11.898 26.507 10.339 26.507 C 1.178 26.507 -0.284 19.019 0.203 15.851 C 1.47 6.923 9.072 4.907 13.652 5.195 C 15.114 5.195 16.479 5.387 17.745 5.867 C 18.233 6.059 18.428 6.443 18.33 6.923 L 17.648 11.435 Z"/>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/discover.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(17, 49, 82);"/>\n  <path d="M 5.498 13.349 C 5.16 13.654 4.722 13.787 4.028 13.787 L 3.738 13.787 L 3.738 10.141 L 4.028 10.141 C 4.722 10.141 5.143 10.265 5.498 10.587 C 5.868 10.917 6.093 11.431 6.093 11.959 C 6.093 12.489 5.869 13.019 5.498 13.349 Z M 4.243 9.206 L 2.666 9.206 L 2.666 14.721 L 4.236 14.721 C 5.069 14.721 5.671 14.524 6.199 14.084 C 6.829 13.564 7.199 12.779 7.199 11.968 C 7.199 10.34 5.985 9.206 4.243 9.206 Z M 7.696 14.721 L 8.77 14.721 L 8.77 9.207 L 7.696 9.207 M 11.393 11.323 C 10.748 11.083 10.559 10.926 10.559 10.628 C 10.559 10.281 10.897 10.018 11.359 10.018 C 11.681 10.018 11.946 10.15 12.226 10.464 L 12.788 9.727 C 12.326 9.322 11.773 9.115 11.17 9.115 C 10.195 9.115 9.452 9.793 9.452 10.695 C 9.452 11.455 9.798 11.845 10.807 12.208 C 11.227 12.356 11.442 12.455 11.55 12.522 C 11.765 12.662 11.872 12.862 11.872 13.092 C 11.872 13.54 11.518 13.872 11.038 13.872 C 10.528 13.872 10.114 13.614 9.868 13.136 L 9.173 13.806 C 9.668 14.532 10.263 14.856 11.08 14.856 C 12.196 14.856 12.98 14.111 12.98 13.044 C 12.98 12.168 12.617 11.771 11.395 11.324 Z M 13.316 11.968 C 13.316 13.588 14.586 14.845 16.223 14.845 C 16.685 14.845 17.081 14.755 17.57 14.525 L 17.57 13.258 C 17.14 13.688 16.76 13.862 16.273 13.862 C 15.191 13.862 14.423 13.077 14.423 11.962 C 14.423 10.902 15.215 10.067 16.223 10.067 C 16.735 10.067 17.123 10.25 17.57 10.687 L 17.57 9.421 C 17.098 9.181 16.71 9.081 16.248 9.081 C 14.621 9.081 13.316 10.364 13.316 11.968 Z M 26.088 12.911 L 24.62 9.206 L 23.446 9.206 L 25.783 14.862 L 26.361 14.862 L 28.741 9.207 L 27.576 9.207 M 29.226 14.721 L 32.272 14.721 L 32.272 13.787 L 30.299 13.787 L 30.299 12.299 L 32.199 12.299 L 32.199 11.365 L 30.299 11.365 L 30.299 10.141 L 32.272 10.141 L 32.272 9.206 L 29.226 9.206 M 34.373 11.745 L 34.059 11.745 L 34.059 10.075 L 34.389 10.075 C 35.059 10.075 35.423 10.355 35.423 10.893 C 35.423 11.447 35.059 11.745 34.373 11.745 Z M 36.528 10.835 C 36.528 9.802 35.818 9.207 34.578 9.207 L 32.986 9.207 L 32.986 14.721 L 34.059 14.721 L 34.059 12.506 L 34.199 12.506 L 35.686 14.721 L 37.006 14.721 L 35.273 12.398 C 36.083 12.233 36.528 11.678 36.528 10.835 Z" style="fill: rgb(255, 255, 255);"/>\n  <g id="MarkingBase_1_" transform="matrix(0.089776, 0, 0, 0.089776, 2.192296, 5.72498)">\n    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="224.3917" y1="44.1731" x2="201.33" y2="80.2807" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F89F21"/>\n      <stop offset="0.2502" style="stop-color:#F79A23"/>\n      <stop offset="0.5331" style="stop-color:#F78E22"/>\n      <stop offset="0.6196" style="stop-color:#F68721"/>\n      <stop offset="0.7232" style="stop-color:#F48220"/>\n      <stop offset="1" style="stop-color:#F27623"/>\n    </linearGradient>\n    <circle fill="url(#SVGID_1_)" cx="207.343" cy="70.866" r="33.307"/>\n    <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="220.7487" y1="44.664" x2="187.0436" y2="110.5426" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F68721;stop-opacity:0"/>\n      <stop offset="0.3587" style="stop-color:#E27027;stop-opacity:0.2704"/>\n      <stop offset="0.703" style="stop-color:#D4612C;stop-opacity:0.5299"/>\n      <stop offset="0.9816" style="stop-color:#D15D2D;stop-opacity:0.74"/>\n    </linearGradient>\n    <circle opacity="0.65" fill="url(#SVGID_2_)" cx="207.343" cy="70.866" r="33.307"/>\n  </g>\n  <g id="Orange_1_" enable-background="new    " transform="matrix(0.469224, 0, 0, 0.469224, 13.785085, 6.199149)">\n    <g id="Orange">\n      <g>\n        <path d="M13,38c20.1,0,40,0,40,0c1.7,0,3-1.3,3-3V18C56,18,51.2,31.8,13,38z" style="fill: rgb(255, 129, 38);"/>\n      </g>\n    </g>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/elo.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(21, 21, 21);"/>\n  <path class="st0" d="M 9.229 8.55 C 9.592 8.431 9.977 8.365 10.382 8.365 C 12.14 8.365 13.602 9.613 13.939 11.268 L 16.427 10.762 C 15.855 7.946 13.365 5.824 10.379 5.824 C 9.693 5.824 9.037 5.935 8.42 6.142 L 9.229 8.55 Z" style="fill: rgb(255, 205, 5);"/>\n  <path class="st1" d="M 6.292 16.616 L 7.973 14.716 C 7.221 14.052 6.749 13.08 6.749 11.999 C 6.749 10.917 7.221 9.945 7.973 9.279 L 6.292 7.38 C 5.015 8.51 4.209 10.16 4.209 11.999 C 4.209 13.836 5.019 15.488 6.292 16.616" style="fill: rgb(0, 164, 224);"/>\n  <path class="st2" d="M 13.939 12.723 C 13.602 14.379 12.136 15.626 10.382 15.626 C 9.977 15.626 9.592 15.562 9.229 15.442 L 8.422 17.849 C 9.039 18.055 9.698 18.167 10.382 18.167 C 13.365 18.167 15.855 16.05 16.427 13.235 L 13.939 12.723 Z" style="fill: rgb(239, 66, 35);"/>\n  <path d="M 18.603 14.794 C 18.521 14.663 18.412 14.453 18.343 14.296 C 17.948 13.381 17.932 12.434 18.264 11.526 C 18.631 10.527 19.33 9.765 20.233 9.378 C 21.366 8.889 22.626 8.986 23.713 9.632 C 24.406 10.028 24.897 10.641 25.269 11.506 C 25.319 11.615 25.358 11.737 25.398 11.835 L 18.603 14.794 Z M 20.87 10.845 C 20.066 11.194 19.65 11.949 19.734 12.834 L 23.151 11.363 C 22.565 10.675 21.802 10.444 20.87 10.845 Z M 23.578 14.044 C 23.578 14.044 23.578 14.044 23.578 14.044 L 23.508 13.998 C 23.302 14.331 22.985 14.595 22.584 14.768 C 21.82 15.1 21.113 15.014 20.602 14.569 L 20.559 14.643 C 20.559 14.643 20.559 14.643 20.559 14.643 L 19.688 15.936 C 19.905 16.088 20.134 16.213 20.376 16.315 C 21.333 16.712 22.311 16.693 23.279 16.273 C 23.978 15.971 24.527 15.509 24.9 14.924 L 23.578 14.044 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 27.77 7.466 L 27.77 14.673 L 28.891 15.13 L 28.254 16.614 L 27.018 16.1 C 26.742 15.979 26.552 15.797 26.409 15.588 C 26.272 15.377 26.171 15.085 26.171 14.698 L 26.171 7.466 L 27.77 7.466 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.037801, 0, 0, 0.037801, 1.0913, 0.089785)">\n    <path d="M782.7,337.2c0-16.2,7.2-30.8,18.5-40.7l-30.4-33.9c-20.6,18.2-33.6,44.9-33.6,74.6c0,29.7,12.9,56.4,33.6,74.7l30.4-34&#10;&#9;&#9;C789.8,367.9,782.6,353.4,782.7,337.2z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.7,391.4c-6,0-11.8-1-17.1-2.8L805,431.7c9.9,3.3,20.6,5.1,31.6,5.2c48.2,0,88.4-34.1,97.7-79.6l-44.7-9.1&#10;&#9;&#9;C884.6,372.9,862.8,391.4,836.7,391.4z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.8,237.6c-11,0-21.7,1.8-31.6,5.1l14.4,43.2c5.4-1.8,11.2-2.8,17.1-2.8c26.2,0,48,18.6,53,43.3l44.7-9.1&#10;&#9;&#9;C925.2,272,885,237.7,836.8,237.6z" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/elv.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#005DA0" d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z"/>\n  <path fill="#005DA0" d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z"/>\n  <path fill="#005DA0" d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z"/>\n  <path fill="#005DA0" d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z"/>\n  <path fill="#005DA0" d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z"/>\n  <path fill="#005DA0" d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z"/>\n  <path fill="#005DA0" d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z"/>\n  <path fill="#005DA0" d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z"/>\n  <path fill="#005DA0" d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z"/>\n  <path fill="#005DA0" d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z"/>\n  <path fill="#005DA0" d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z"/>\n  <path fill="#005DA0" d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z"/>\n  <path fill="#005DA0" d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z"/>\n  <path fill="#005DA0" d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z"/>\n  <path fill="#005DA0" d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z"/>\n  <path fill="#AEB1BC" d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path fill="#005DA0" d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z"/>\n    <path fill="#005DA0" d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z"/>\n    <polygon fill="#005DA0" points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;"/>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/elv_white.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z" style="fill: rgb(255, 255, 255);"/>\n    <polygon points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/hiper.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(243, 97, 24);"/>\n  <path id="path16" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 3.206 6.45 L 3.206 16.929 L 5.586 16.929 L 5.586 12.545 L 9.489 12.545 L 9.489 16.929 L 11.853 16.929 L 11.853 6.45 L 9.489 6.45 L 9.489 10.477 L 5.586 10.477 L 5.586 6.45 L 3.206 6.45"/>\n  <path id="path18" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 32.319 13.882 C 32.351 13.71 32.397 13.353 32.397 12.949 C 32.397 11.068 31.464 9.155 29.008 9.155 C 26.364 9.155 25.167 11.285 25.167 13.213 C 25.167 15.592 26.644 17.085 29.225 17.085 C 30.251 17.085 31.2 16.929 31.977 16.618 L 31.666 15.017 C 31.029 15.219 30.376 15.328 29.567 15.328 C 28.463 15.328 27.499 14.861 27.422 13.882 Z M 27.406 12.265 C 27.468 11.628 27.873 10.725 28.868 10.725 C 29.956 10.725 30.205 11.689 30.205 12.265 L 27.406 12.265"/>\n  <path id="path20" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 33.155 16.929 L 35.519 16.929 L 35.519 13.073 C 35.519 12.887 35.533 12.7 35.565 12.545 C 35.72 11.814 36.31 11.348 37.182 11.348 C 37.446 11.348 37.648 11.378 37.819 11.41 L 37.819 9.186 C 37.648 9.155 37.539 9.155 37.321 9.155 C 36.591 9.155 35.658 9.621 35.269 10.725 L 35.207 10.725 L 35.129 9.326 L 33.092 9.326 C 33.123 9.979 33.155 10.709 33.155 11.829 L 33.155 16.929"/>\n  <path id="path22" style="fill: rgb(254, 234, 1); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 14.256 6.028 C 14.927 6.028 15.472 6.572 15.472 7.243 C 15.472 7.914 14.927 8.458 14.256 8.458 C 13.585 8.458 13.041 7.914 13.041 7.243 C 13.041 6.572 13.585 6.028 14.256 6.028"/>\n  <path id="path24" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 19.247 15.159 L 20.433 15.159 C 21.624 15.159 22.163 14.395 22.163 13.6 C 22.163 12.805 22.106 11.006 20.633 11.006 C 18.943 11.006 19.218 13.238 19.224 14.408 C 19.226 14.658 19.24 14.908 19.247 15.159 Z M 13.041 9.315 L 15.472 9.315 L 15.472 13.6 C 15.472 14.395 15.912 15.157 16.887 15.159 C 16.894 13.229 16.886 11.243 16.822 9.315 L 18.852 9.315 C 18.896 9.687 18.936 10.059 18.973 10.432 C 19.932 8.514 22.954 8.937 23.971 10.555 C 25.022 12.228 25.379 17.017 20.433 17.017 L 19.282 17.017 C 19.293 17.988 19.295 18.963 19.295 19.936 L 16.865 19.936 C 16.865 19.001 16.871 18.022 16.878 17.016 C 14.252 17.007 13.041 15.339 13.041 13.6 L 13.041 9.315"/>\n</svg>';
        },
        "./src/components/button/templates/component/logos/ideal.svg": function(module, exports) {
            module.exports = '<svg width="38" height="32" viewBox="0 0 38 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <polygon id="Fill-1" fill="#000000" points="4.47 27.632 10.452 27.632 10.452 17.982 4.47 17.982"/>\n  <g id="Group-9" transform="matrix(0.952642, 0, 0, 0.930979, 0.31993, 0.181113)">\n    <path d="M11.1102604,13.937999 C11.1102604,15.8893766 9.51859887,17.4723289 7.55546104,17.4723289 C5.59238806,17.4723289 4.00066169,15.8893766 4.00066169,13.937999 C4.00066169,11.9865569 5.59238806,10.4043136 7.55546104,10.4043136 C9.51859887,10.4043136 11.1102604,11.9865569 11.1102604,13.937999" id="Fill-2" fill="#000000"/>\n    <g id="Group-6">\n      <mask id="mask-2" fill="white">\n        <polygon id="" points="39.1898554 33.9678282 0 33.9678282 0 0.001572704 39.1898554 0.001572704" transform="matrix(1, 0, 0, 1, 0, 0)"/>\n      </mask>\n      <g id="Clip-5"/>\n      <path d="M22.1049929,2.25750057 C26.4717361,2.25750057 30.1110886,3.433548 32.6296578,5.65853743 C35.476843,8.17370364 36.9204068,11.9843525 36.9204068,16.9847134 C36.9204068,26.8945533 32.0742264,31.7119261 22.1049929,31.7119261 L2.26942909,31.7119261 L2.26942909,2.25750057 L22.1049929,2.25750057 Z M22.531325,0.001572704 L-1.9452416e-05,0.001572704 L-1.9452416e-05,33.967854 L22.531325,33.967854 L22.531325,33.9614085 C27.4529808,33.8947619 31.3518934,32.6793969 34.1187402,30.3394196 C37.4837488,27.4935988 39.1898554,23.0003706 39.1898554,16.9847134 C39.1898554,14.1090499 38.7410881,11.5297509 37.8560681,9.31836144 C37.0093692,7.2028812 35.758125,5.40419768 34.13722,3.97219912 C31.2823834,1.45020067 27.2749912,0.0865245021 22.531325,0.00904949351 L22.531325,0.001572704 Z" id="Fill-4" fill="#000000" mask="url(#mask-2)"/>\n    </g>\n    <path d="M21.4851352,29.4975138 L13.5194356,29.4975138 L13.5194356,5.00387361 L21.4851352,5.00387361 L21.1636516,5.00387361 C27.8067813,5.00387361 34.8779291,7.60998594 34.8779291,17.282889 C34.8779291,27.5088167 27.8067813,29.4975138 21.1636516,29.4975138 L21.4851352,29.4975138 Z" id="Fill-7" fill="#CD0067"/>\n  </g>\n  <g id="Group-30" transform="matrix(0.952642, 0, 0, 0.930979, 11.685725, 10.562208)" fill="#FFFFFF">\n    <path d="M1.41115607,1.17495169 L1.41115607,5.07048794 L2.30681015,5.07048794 C2.64178075,5.07048794 2.88357428,5.05173151 3.03219074,5.0142831 C3.2267149,4.96613516 3.38810511,4.88459948 3.51649106,4.76961161 C3.64474732,4.65455929 3.749531,4.46538363 3.83058274,4.20189125 C3.91163447,3.93846333 3.95216034,3.57944852 3.95216034,3.12471792 C3.95216034,2.67005177 3.91163447,2.3210275 3.83058274,2.07764511 C3.749531,1.83426272 3.63605858,1.64437805 3.49016546,1.5079911 C3.34420749,1.37160414 3.15915018,1.27930447 2.93492866,1.23109207 C2.76737852,1.19370812 2.43915142,1.17495169 1.95018252,1.17495169 L1.41115607,1.17495169 Z M0.215675421,0.175897919 L2.40271056,0.175897919 C2.89589415,0.175897919 3.27190935,0.213410777 3.53069132,0.288436492 C3.878306,0.390275522 4.17612249,0.571265392 4.42407595,0.831212737 C4.67202941,1.09116008 4.86065301,1.40950373 4.99001157,1.78598587 C5.11937014,2.16253246 5.18408185,2.62686687 5.18408185,3.1789891 C5.18408185,3.66407805 5.12345515,4.08213371 5.00220176,4.433285 C4.85397434,4.86210466 4.6423969,5.20919527 4.36753426,5.47449239 C4.15997698,5.67552779 3.87966767,5.832347 3.52660632,5.94488558 C3.26244251,6.02796818 2.90938115,6.06954171 2.46742226,6.06954171 L0.215675421,6.06954171 L0.215675421,0.175897919 Z" id="Fill-10"/>\n    <path d="M2.40271056,0.337035624 C2.87825729,0.337035624 3.24247136,0.372743739 3.48523751,0.443128689 C3.80302515,0.536201827 4.07944398,0.704171771 4.30645367,0.942075479 C4.53702965,1.18384649 4.7154083,1.48530291 4.83666169,1.83813003 C4.95966581,2.19611355 5.02197838,2.64723467 5.02197838,3.1789891 C5.02197838,3.64390361 4.96375081,4.04829479 4.84885188,4.38094747 C4.70970226,4.78359837 4.50973142,5.11264156 4.25458057,5.35892443 C4.06589213,5.54165459 3.80438682,5.68712971 3.47713234,5.79148248 C3.23060538,5.86895749 2.89070683,5.908404 2.46742226,5.908404 L0.377778888,5.908404 L0.377778888,0.337035624 L2.40271056,0.337035624 Z M0.0535719538,0.0147602138 L0.0535719538,6.23067941 L2.46742226,6.23067941 C2.92390562,6.23067941 3.2967436,6.18614095 3.57549672,6.09848204 C3.95157676,5.97866004 4.25594223,5.80759625 4.48061764,5.58993144 C4.77246872,5.30819828 4.9996081,4.93661473 5.15548679,4.48562252 C5.28205718,4.11919538 5.34618531,3.67954727 5.34618531,3.1789891 C5.34618531,2.61178438 5.27797217,2.12559969 5.1434263,1.73390616 C5.00706486,1.33699177 4.80456521,0.995959927 4.54169823,0.720349996 C4.27494076,0.440679396 3.9502151,0.243317935 3.57646934,0.133873205 C3.29992083,0.0536910833 2.91612466,0.0147602138 2.40271056,0.0147602138 L0.0535719538,0.0147602138 Z" id="Fill-12"/>\n    <path d="M1.9501501,1.33608939 C2.54124418,1.33608939 2.79263424,1.36451409 2.899428,1.38836247 C3.09466542,1.43032272 3.25566658,1.50998921 3.37905974,1.6253638 C3.50439814,1.74254314 3.60457808,1.91180219 3.6766817,2.12824235 C3.75189771,2.35415741 3.79002445,2.68945275 3.79002445,3.12471792 C3.79002445,3.56127219 3.75150867,3.90784717 3.67551456,4.15477459 C3.60360546,4.38861762 3.51354078,4.55523401 3.40791416,4.64991853 C3.30014777,4.74647224 3.16054427,4.81647046 2.99299412,4.85797953 C2.85754047,4.89207627 2.62683481,4.90935023 2.30677773,4.90935023 L1.57329196,4.90935023 L1.57329196,1.33608939 L1.9501501,1.33608939 Z M1.24902018,1.01381398 L1.24902018,5.23162564 L2.30677773,5.23162564 C2.65860709,5.23162564 2.90889484,5.21158011 3.07203577,5.17052222 C3.29100514,5.1163155 3.47729444,5.02163098 3.62500312,4.88924025 C3.77699133,4.7529822 3.89493781,4.54356764 3.98558607,4.24900792 C4.07214932,3.96766148 4.11423138,3.59988078 4.11423138,3.12471792 C4.11423138,2.64833041 4.07176027,2.2893156 3.98441893,2.02698342 C3.89519718,1.75904364 3.76622766,1.54492386 3.60120633,1.39061839 C3.43423976,1.23450819 3.22162485,1.12789948 2.96919733,1.0736283 C2.78932733,1.03347278 2.45558871,1.01381398 1.9501501,1.01381398 L1.24902018,1.01381398 Z" id="Fill-14"/>\n    <polygon id="Fill-16" points="6.53678989 6.06950948 6.53678989 0.175865691 10.9257088 0.175865691 10.9257088 1.17491946 7.73227054 1.17491946 7.73227054 2.48013487 10.702849 2.48013487 10.702849 3.47918864 7.73227054 3.47918864 7.73227054 5.07045571 11.0391813 5.07045571 11.0391813 6.06950948"/>\n    <path d="M10.7636378,0.337035624 L10.7636378,1.01381398 L7.57019949,1.01381398 L7.57019949,2.64130481 L10.5407779,2.64130481 L10.5407779,3.31808317 L7.57019949,3.31808317 L7.57019949,5.23162564 L10.8771102,5.23162564 L10.8771102,5.908404 L6.69892578,5.908404 L6.69892578,0.337035624 L10.7636378,0.337035624 Z M6.37471884,0.0147602138 L6.37471884,6.23067941 L11.2013172,6.23067941 L11.2013172,4.90935023 L7.89440643,4.90935023 L7.89440643,3.64035858 L10.8649849,3.64035858 L10.8649849,2.3190294 L7.89440643,2.3190294 L7.89440643,1.33608939 L11.0878447,1.33608939 L11.0878447,0.0147602138 L6.37471884,0.0147602138 Z" id="Fill-18"/>\n    <path d="M15.5303032,3.73301276 L14.7130424,1.54959685 L13.9121864,3.73301276 L15.5303032,3.73301276 Z M17.7341971,6.06950948 L16.431793,6.06950948 L15.9144884,4.73206653 L13.5458326,4.73206653 L13.055113,6.06950948 L11.7849999,6.06950948 L14.0890089,0.175865691 L15.363207,0.175865691 L17.7341971,6.06950948 Z" id="Fill-20"/>\n    <path d="M15.2534629,0.337035624 C15.3291976,0.525244463 17.332991,5.50626875 17.4947703,5.908404 L16.5431581,5.908404 C16.4751395,5.73244163 16.0257887,4.57096105 16.0257887,4.57096105 L13.4323926,4.57096105 C13.4323926,4.57096105 13.0075518,5.72876769 12.9417378,5.908404 L12.0218979,5.908404 C12.1781008,5.50884695 14.1252876,0.527951577 14.1999201,0.337035624 L15.2534629,0.337035624 Z M13.9780328,0.0147602138 L11.5481019,6.23067941 L13.168553,6.23067941 C13.168553,6.23067941 13.5933289,5.07280832 13.6592077,4.89323646 L15.8031882,4.89323646 C15.871142,5.06913438 16.3204928,6.23067941 16.3204928,6.23067941 L17.9736239,6.23067941 L15.472951,0.0147602138 L13.9780328,0.0147602138 Z" id="Fill-22"/>\n    <path d="M14.7145337,2.01579402 C14.8921991,2.49044124 15.1926093,3.29290701 15.2970039,3.57186861 L14.1437998,3.57186861 C14.2457305,3.2940672 14.5401752,2.49134361 14.7145337,2.01579402 L14.7145337,2.01579402 Z M13.680573,3.89414402 L15.7636025,3.89414402 L14.7114862,1.0833868 L13.680573,3.89414402 Z" id="Fill-24"/>\n    <polygon id="Fill-26" points="18.7343171 6.06950948 18.7343171 0.224207003 19.9297978 0.224207003 19.9297978 5.07045571 22.9084814 5.07045571 22.9084814 6.06950948"/>\n    <path d="M19.7677267,0.385376935 L19.7677267,5.23162564 L22.7464104,5.23162564 L22.7464104,5.908404 L18.8963882,5.908404 L18.8963882,0.385376935 L19.7677267,0.385376935 Z M18.5722461,0.0631015253 L18.5722461,6.23067941 L23.0706173,6.23067941 L23.0706173,4.90935023 L20.0919337,4.90935023 L20.0919337,0.0631015253 L18.5722461,0.0631015253 Z" id="Fill-28"/>\n  </g>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return componentLogos;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return cardLogos;
            });
            var _BUTTON_LOGO$PP, _BUTTON_LOGO$PAYPAL, _BUTTON_LOGO$CREDIT, _BUTTON_LOGO$VENMO, _BUTTON_LOGO$IDEAL, _BUTTON_LOGO$ELV, _componentLogos, _cardLogos, __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_2__pp_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_white.svg"), __WEBPACK_IMPORTED_MODULE_2__pp_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pp_white_svg__), __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_blue.svg"), __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pp_blue_svg__), __WEBPACK_IMPORTED_MODULE_4__pp_black_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_black.svg"), __WEBPACK_IMPORTED_MODULE_4__pp_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pp_black_svg__), __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_white.svg"), __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__paypal_white_svg__), __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_blue.svg"), __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg__), __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_black.svg"), __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__paypal_black_svg__), __WEBPACK_IMPORTED_MODULE_8__credit_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/credit_white.svg"), __WEBPACK_IMPORTED_MODULE_8__credit_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__credit_white_svg__), __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/venmo_white.svg"), __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__venmo_white_svg__), __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/venmo_blue.svg"), __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg__), __WEBPACK_IMPORTED_MODULE_11__ideal_svg__ = __webpack_require__("./src/components/button/templates/component/logos/ideal.svg"), __WEBPACK_IMPORTED_MODULE_11__ideal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ideal_svg__), __WEBPACK_IMPORTED_MODULE_12__elv_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elv.svg"), __WEBPACK_IMPORTED_MODULE_12__elv_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__elv_svg__), __WEBPACK_IMPORTED_MODULE_13__elv_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elv_white.svg"), __WEBPACK_IMPORTED_MODULE_13__elv_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__elv_white_svg__), __WEBPACK_IMPORTED_MODULE_14__visa_svg__ = __webpack_require__("./src/components/button/templates/component/logos/visa.svg"), __WEBPACK_IMPORTED_MODULE_14__visa_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__visa_svg__), __WEBPACK_IMPORTED_MODULE_15__amex_svg__ = __webpack_require__("./src/components/button/templates/component/logos/amex.svg"), __WEBPACK_IMPORTED_MODULE_15__amex_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amex_svg__), __WEBPACK_IMPORTED_MODULE_16__mastercard_svg__ = __webpack_require__("./src/components/button/templates/component/logos/mastercard.svg"), __WEBPACK_IMPORTED_MODULE_16__mastercard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mastercard_svg__), __WEBPACK_IMPORTED_MODULE_17__discover_svg__ = __webpack_require__("./src/components/button/templates/component/logos/discover.svg"), __WEBPACK_IMPORTED_MODULE_17__discover_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__discover_svg__), __WEBPACK_IMPORTED_MODULE_18__hiper_svg__ = __webpack_require__("./src/components/button/templates/component/logos/hiper.svg"), __WEBPACK_IMPORTED_MODULE_18__hiper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__hiper_svg__), __WEBPACK_IMPORTED_MODULE_19__elo_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elo.svg"), __WEBPACK_IMPORTED_MODULE_19__elo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__elo_svg__), __WEBPACK_IMPORTED_MODULE_20__jcb_svg__ = __webpack_require__("./src/components/button/templates/component/logos/jcb.svg"), __WEBPACK_IMPORTED_MODULE_20__jcb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__jcb_svg__), componentLogos = (_componentLogos = {}, 
            _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.PP] = (_BUTTON_LOGO$PP = {}, 
            _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE] = __WEBPACK_IMPORTED_MODULE_2__pp_white_svg___default.a, 
            _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE] = __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg___default.a, 
            _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__.f.BLACK] = __WEBPACK_IMPORTED_MODULE_4__pp_black_svg___default.a, 
            _BUTTON_LOGO$PP), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL] = (_BUTTON_LOGO$PAYPAL = {}, 
            _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE] = __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg___default.a, 
            _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE] = __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg___default.a, 
            _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__.f.BLACK] = __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg___default.a, 
            _BUTTON_LOGO$PAYPAL), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.CREDIT] = (_BUTTON_LOGO$CREDIT = {}, 
            _BUTTON_LOGO$CREDIT[__WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE] = __WEBPACK_IMPORTED_MODULE_8__credit_white_svg___default.a, 
            _BUTTON_LOGO$CREDIT), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.VENMO] = (_BUTTON_LOGO$VENMO = {}, 
            _BUTTON_LOGO$VENMO[__WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE] = __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg___default.a, 
            _BUTTON_LOGO$VENMO[__WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE] = __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg___default.a, 
            _BUTTON_LOGO$VENMO), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.IDEAL] = (_BUTTON_LOGO$IDEAL = {}, 
            _BUTTON_LOGO$IDEAL[__WEBPACK_IMPORTED_MODULE_1__constants__.f.ANY] = __WEBPACK_IMPORTED_MODULE_11__ideal_svg___default.a, 
            _BUTTON_LOGO$IDEAL), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__.e.ELV] = (_BUTTON_LOGO$ELV = {}, 
            _BUTTON_LOGO$ELV[__WEBPACK_IMPORTED_MODULE_1__constants__.f.ANY] = __WEBPACK_IMPORTED_MODULE_12__elv_svg___default.a, 
            _BUTTON_LOGO$ELV[__WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE] = __WEBPACK_IMPORTED_MODULE_13__elv_white_svg___default.a, 
            _BUTTON_LOGO$ELV), _componentLogos), cardLogos = (_cardLogos = {}, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.VISA] = __WEBPACK_IMPORTED_MODULE_14__visa_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.AMEX] = __WEBPACK_IMPORTED_MODULE_15__amex_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.MASTERCARD] = __WEBPACK_IMPORTED_MODULE_16__mastercard_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.DISCOVER] = __WEBPACK_IMPORTED_MODULE_17__discover_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.HIPER] = __WEBPACK_IMPORTED_MODULE_18__hiper_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.ELO] = __WEBPACK_IMPORTED_MODULE_19__elo_svg___default.a, 
            _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__.b.JCB] = __WEBPACK_IMPORTED_MODULE_20__jcb_svg___default.a, 
            _cardLogos);
        },
        "./src/components/button/templates/component/logos/jcb.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <pattern id="pattern-0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" viewBox="0 0 100 100">\n      <path d="M 0 0 L 50 0 L 50 100 L 0 100 Z" style="fill: black;"/>\n    </pattern>\n  </defs>\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(255, 255, 255); stroke: rgb(233, 234, 231);"/>\n  <g transform="matrix(0.100306, 0, 0, 0.100306, 4.733743, 10.105099)" id="g6321">\n    <g transform="matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)" id="g6323">\n      <path style="fill:#ffffff" id="path6325" d="m 174,108.3 c 0,14 -11.4,25.4 -25.4,25.4 l -138.2,0 0,-100.6 c 0,-14 11.4,-25.4 25.4,-25.4 l 138.2,0 0,100.6 z" class="st0"/>\n      <g id="g6327">\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="81.398598" x2="157.3299" y1="81.398598" x1="117.3856" gradientUnits="userSpaceOnUse" id="SVGID_1_">\n          <stop id="stop6330" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6332" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6334" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6336" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_1_)" id="path6338" d="m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z" class="st1"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="157.3318" y1="75.171402" x1="117.3844" gradientUnits="userSpaceOnUse" id="SVGID_2_">\n          <stop id="stop6341" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6343" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6345" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6347" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_2_)" id="path6349" d="m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z" class="st2"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="68.399101" x2="157.33051" y1="68.399101" x1="117.3846" gradientUnits="userSpaceOnUse" id="SVGID_3_">\n          <stop id="stop6352" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6354" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6356" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6358" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_3_)" id="path6360" d="m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z" class="st3"/>\n      </g>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="68.522102" y1="75.171402" x1="27.9594" gradientUnits="userSpaceOnUse" id="SVGID_4_">\n        <stop id="stop6363" style="stop-color:#1F286F" offset="0"/>\n        <stop id="stop6365" style="stop-color:#004E94" offset="0.4751"/>\n        <stop id="stop6367" style="stop-color:#0066B1" offset="0.8261"/>\n        <stop id="stop6369" style="stop-color:#006FBC" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_4_)" id="path6371" d="m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z" class="st4"/>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="111.8553" y1="75.171402" x1="72.459503" gradientUnits="userSpaceOnUse" id="SVGID_5_">\n        <stop id="stop6374" style="stop-color:#6C2C2F" offset="0"/>\n        <stop id="stop6376" style="stop-color:#882730" offset="0.1735"/>\n        <stop id="stop6378" style="stop-color:#BE1833" offset="0.5731"/>\n        <stop id="stop6380" style="stop-color:#DC0436" offset="0.8585"/>\n        <stop id="stop6382" style="stop-color:#E60039" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_5_)" id="path6384" d="m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z" class="st5"/>\n    </g>\n    <g id="g6386"/>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/mastercard.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(62, 57, 57);"/>\n  <path style="fill: rgb(255, 95, 0);" d="M 22.205 3.901 L 15.688 3.901 L 15.688 15.589 L 22.205 15.589"/>\n  <path d="M 16.1 9.747 C 16.1 7.371 17.218 5.265 18.935 3.901 C 17.67 2.912 16.078 2.312 14.342 2.312 C 10.223 2.312 6.892 5.636 6.892 9.746 C 6.892 13.853 10.223 17.178 14.342 17.178 C 16.078 17.178 17.67 16.58 18.935 15.588 C 17.216 14.246 16.099 12.119 16.099 9.745 Z" style="fill: rgb(235, 0, 27);"/>\n  <path d="M 30.996 9.747 C 30.996 13.854 27.663 17.179 23.547 17.179 C 21.81 17.179 20.216 16.581 18.954 15.589 C 20.691 14.227 21.788 12.12 21.788 9.746 C 21.788 7.37 20.671 5.264 18.954 3.9 C 20.216 2.911 21.81 2.311 23.547 2.311 C 27.663 2.311 30.996 5.657 30.996 9.745 Z" style="fill: rgb(247, 158, 27);"/>\n  <path d="M 7.167 22.481 L 7.167 20.43 C 7.167 19.641 6.685 19.127 5.857 19.127 C 5.443 19.127 4.993 19.262 4.683 19.71 C 4.44 19.332 4.096 19.127 3.579 19.127 C 3.233 19.127 2.888 19.23 2.612 19.607 L 2.612 19.197 L 1.886 19.197 L 1.886 22.481 L 2.612 22.481 L 2.612 20.668 C 2.612 20.086 2.921 19.812 3.406 19.812 C 3.888 19.812 4.131 20.121 4.131 20.669 L 4.131 22.481 L 4.856 22.481 L 4.856 20.668 C 4.856 20.086 5.204 19.812 5.651 19.812 C 6.137 19.812 6.377 20.121 6.377 20.669 L 6.377 22.481 L 7.171 22.481 Z M 17.909 19.197 L 16.734 19.197 L 16.734 18.204 L 16.007 18.204 L 16.007 19.197 L 15.352 19.197 L 15.352 19.845 L 16.007 19.845 L 16.007 21.351 C 16.007 22.106 16.319 22.551 17.146 22.551 C 17.459 22.551 17.804 22.449 18.044 22.309 L 17.839 21.695 C 17.632 21.831 17.389 21.867 17.216 21.867 C 16.872 21.867 16.734 21.66 16.734 21.319 L 16.734 19.847 L 17.909 19.847 L 17.909 19.198 Z M 24.053 19.127 C 23.639 19.127 23.364 19.332 23.191 19.607 L 23.191 19.197 L 22.465 19.197 L 22.465 22.481 L 23.191 22.481 L 23.191 20.633 C 23.191 20.086 23.434 19.777 23.882 19.777 C 24.018 19.777 24.192 19.812 24.33 19.847 L 24.538 19.162 C 24.401 19.127 24.192 19.127 24.052 19.127 Z M 14.765 19.469 C 14.42 19.229 13.937 19.127 13.418 19.127 C 12.588 19.127 12.036 19.538 12.036 20.188 C 12.036 20.736 12.453 21.044 13.175 21.146 L 13.524 21.181 C 13.903 21.249 14.108 21.351 14.108 21.523 C 14.108 21.765 13.832 21.934 13.35 21.934 C 12.864 21.934 12.484 21.764 12.244 21.592 L 11.898 22.139 C 12.278 22.411 12.794 22.549 13.313 22.549 C 14.28 22.549 14.831 22.105 14.831 21.488 C 14.831 20.908 14.383 20.599 13.692 20.496 L 13.348 20.462 C 13.037 20.428 12.795 20.36 12.795 20.155 C 12.795 19.914 13.038 19.777 13.418 19.777 C 13.83 19.777 14.245 19.949 14.453 20.052 L 14.764 19.469 Z M 34.033 19.127 C 33.618 19.127 33.342 19.332 33.171 19.607 L 33.171 19.197 L 32.445 19.197 L 32.445 22.481 L 33.171 22.481 L 33.171 20.633 C 33.171 20.086 33.414 19.777 33.862 19.777 C 33.998 19.777 34.17 19.812 34.307 19.847 L 34.515 19.162 C 34.38 19.127 34.172 19.127 34.033 19.127 Z M 24.779 20.838 C 24.779 21.834 25.47 22.551 26.54 22.551 C 27.025 22.551 27.369 22.449 27.715 22.173 L 27.369 21.593 C 27.092 21.798 26.816 21.901 26.504 21.901 C 25.919 21.901 25.505 21.49 25.505 20.84 C 25.505 20.226 25.919 19.813 26.507 19.78 C 26.816 19.78 27.092 19.883 27.369 20.089 L 27.715 19.507 C 27.369 19.233 27.024 19.13 26.54 19.13 C 25.47 19.13 24.779 19.85 24.779 20.841 Z M 31.478 20.838 L 31.478 19.198 L 30.75 19.198 L 30.75 19.608 C 30.51 19.3 30.165 19.128 29.717 19.128 C 28.784 19.128 28.058 19.848 28.058 20.84 C 28.058 21.835 28.784 22.552 29.716 22.552 C 30.197 22.552 30.543 22.382 30.748 22.074 L 30.748 22.484 L 31.477 22.484 L 31.477 20.84 Z M 28.818 20.838 C 28.818 20.259 29.196 19.779 29.819 19.779 C 30.406 19.779 30.821 20.224 30.821 20.84 C 30.821 21.424 30.406 21.902 29.819 21.902 C 29.196 21.869 28.818 21.424 28.818 20.841 Z M 20.148 19.128 C 19.183 19.128 18.494 19.813 18.494 20.84 C 18.494 21.869 19.183 22.552 20.185 22.552 C 20.671 22.552 21.154 22.417 21.533 22.108 L 21.188 21.595 C 20.914 21.799 20.565 21.937 20.222 21.937 C 19.772 21.937 19.323 21.732 19.219 21.149 L 21.671 21.149 L 21.671 20.878 C 21.705 19.815 21.083 19.13 20.15 19.13 Z M 20.148 19.748 C 20.6 19.748 20.911 20.019 20.98 20.532 L 19.253 20.532 C 19.321 20.087 19.633 19.748 20.148 19.748 Z M 38.141 20.84 L 38.141 17.898 L 37.412 17.898 L 37.412 19.61 C 37.173 19.302 36.828 19.13 36.38 19.13 C 35.446 19.13 34.721 19.85 34.721 20.841 C 34.721 21.837 35.446 22.554 36.379 22.554 C 36.861 22.554 37.206 22.383 37.41 22.076 L 37.41 22.486 L 38.14 22.486 L 38.14 20.841 Z M 35.481 20.84 C 35.481 20.261 35.861 19.78 36.484 19.78 C 37.069 19.78 37.486 20.226 37.486 20.841 C 37.486 21.426 37.069 21.904 36.484 21.904 C 35.861 21.87 35.481 21.426 35.481 20.843 Z M 11.237 20.84 L 11.237 19.2 L 10.515 19.2 L 10.515 19.61 C 10.272 19.302 9.928 19.13 9.478 19.13 C 8.545 19.13 7.82 19.85 7.82 20.841 C 7.82 21.837 8.545 22.554 9.477 22.554 C 9.96 22.554 10.304 22.383 10.512 22.076 L 10.512 22.486 L 11.236 22.486 L 11.236 20.841 Z M 8.546 20.84 C 8.546 20.261 8.926 19.78 9.548 19.78 C 10.134 19.78 10.55 20.226 10.55 20.841 C 10.55 21.426 10.134 21.904 9.548 21.904 C 8.926 21.87 8.546 21.426 8.546 20.843 Z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
        },
        "./src/components/button/templates/component/logos/paypal_black.svg": function(module, exports) {
            module.exports = '<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M 12 5.315 L 4.2 5.315 C 3.7 5.315 3.2 5.715 3.1 6.215 L 0 26.215 C -0.1 26.615 0.2 26.915 0.6 26.915 L 4.3 26.915 C 4.8 26.915 5.3 26.515 5.4 26.015 L 6.2 20.615 C 6.3 20.115 6.7 19.715 7.3 19.715 L 9.8 19.715 C 14.9 19.715 17.9 17.215 18.7 12.315 C 19 10.215 18.7 8.515 17.7 7.315 C 16.6 6.015 14.6 5.315 12 5.315 Z M 12.9 12.615 C 12.5 15.415 10.3 15.415 8.3 15.415 L 7.1 15.415 L 7.9 10.215 C 7.9 9.915 8.2 9.715 8.5 9.715 L 9 9.715 C 10.4 9.715 11.7 9.715 12.4 10.515 C 12.9 10.915 13.1 11.615 12.9 12.615 Z" fill="#333030"/>\n  <path d="M 35.2 12.515 L 31.5 12.515 C 31.2 12.515 30.9 12.715 30.9 13.015 L 30.7 14.015 L 30.4 13.615 C 29.6 12.415 27.8 12.015 26 12.015 C 21.9 12.015 18.4 15.115 17.7 19.515 C 17.3 21.715 17.8 23.815 19.1 25.215 C 20.2 26.515 21.9 27.115 23.8 27.115 C 27.1 27.115 29 25.015 29 25.015 L 28.8 26.015 C 28.7 26.415 29 26.815 29.4 26.815 L 32.8 26.815 C 33.3 26.815 33.8 26.415 33.9 25.915 L 35.9 13.115 C 36 12.915 35.6 12.515 35.2 12.515 Z M 30.1 19.815 C 29.7 21.915 28.1 23.415 25.9 23.415 C 24.8 23.415 24 23.115 23.4 22.415 C 22.8 21.715 22.6 20.815 22.8 19.815 C 23.1 17.715 24.9 16.215 27 16.215 C 28.1 16.215 28.9 16.615 29.5 17.215 C 30 17.815 30.2 18.715 30.1 19.815 Z" fill="#333030"/>\n  <path d="M 55.1 12.515 L 51.4 12.515 C 51 12.515 50.7 12.715 50.5 13.015 L 45.3 20.615 L 43.1 13.315 C 43 12.815 42.5 12.515 42.1 12.515 L 38.4 12.515 C 38 12.515 37.6 12.915 37.8 13.415 L 41.9 25.515 L 38 30.915 C 37.7 31.315 38 31.915 38.5 31.915 L 42.2 31.915 C 42.6 31.915 42.9 31.715 43.1 31.415 L 55.6 13.415 C 55.9 13.115 55.6 12.515 55.1 12.515 Z" fill="#333030"/>\n  <path d="M 67.5 5.315 L 59.7 5.315 C 59.2 5.315 58.7 5.715 58.6 6.215 L 55.5 26.115 C 55.4 26.515 55.7 26.815 56.1 26.815 L 60.1 26.815 C 60.5 26.815 60.8 26.515 60.8 26.215 L 61.7 20.515 C 61.8 20.015 62.2 19.615 62.8 19.615 L 65.3 19.615 C 70.4 19.615 73.4 17.115 74.2 12.215 C 74.5 10.115 74.2 8.415 73.2 7.215 C 72 6.015 70.1 5.315 67.5 5.315 Z M 68.4 12.615 C 68 15.415 65.8 15.415 63.8 15.415 L 62.6 15.415 L 63.4 10.215 C 63.4 9.915 63.7 9.715 64 9.715 L 64.5 9.715 C 65.9 9.715 67.2 9.715 67.9 10.515 C 68.4 10.915 68.5 11.615 68.4 12.615 Z" fill="#636363"/>\n  <path d="M 90.7 12.515 L 87 12.515 C 86.7 12.515 86.4 12.715 86.4 13.015 L 86.2 14.015 L 85.9 13.615 C 85.1 12.415 83.3 12.015 81.5 12.015 C 77.4 12.015 73.9 15.115 73.2 19.515 C 72.8 21.715 73.3 23.815 74.6 25.215 C 75.7 26.515 77.4 27.115 79.3 27.115 C 82.6 27.115 84.5 25.015 84.5 25.015 L 84.3 26.015 C 84.2 26.415 84.5 26.815 84.9 26.815 L 88.3 26.815 C 88.8 26.815 89.3 26.415 89.4 25.915 L 91.4 13.115 C 91.4 12.915 91.1 12.515 90.7 12.515 Z M 85.5 19.815 C 85.1 21.915 83.5 23.415 81.3 23.415 C 80.2 23.415 79.4 23.115 78.8 22.415 C 78.2 21.715 78 20.815 78.2 19.815 C 78.5 17.715 80.3 16.215 82.4 16.215 C 83.5 16.215 84.3 16.615 84.9 17.215 C 85.5 17.815 85.7 18.715 85.5 19.815 Z" fill="#636363"/>\n  <path d="M 95.1 5.915 L 91.9 26.215 C 91.8 26.615 92.1 26.915 92.5 26.915 L 95.7 26.915 C 96.2 26.915 96.7 26.515 96.8 26.015 L 100 6.115 C 100.1 5.715 99.8 5.415 99.4 5.415 L 95.8 5.415 C 95.4 5.315 95.2 5.515 95.1 5.915 Z" fill="#636363"/>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/paypal_blue.svg": function(module, exports) {
            module.exports = '<svg width="100" height="32" viewBox="0 0 100 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#003087" d="M 12 4.917 L 4.2 4.917 C 3.7 4.917 3.2 5.317 3.1 5.817 L 0 25.817 C -0.1 26.217 0.2 26.517 0.6 26.517 L 4.3 26.517 C 4.8 26.517 5.3 26.117 5.4 25.617 L 6.2 20.217 C 6.3 19.717 6.7 19.317 7.3 19.317 L 9.8 19.317 C 14.9 19.317 17.9 16.817 18.7 11.917 C 19 9.817 18.7 8.117 17.7 6.917 C 16.6 5.617 14.6 4.917 12 4.917 Z M 12.9 12.217 C 12.5 15.017 10.3 15.017 8.3 15.017 L 7.1 15.017 L 7.9 9.817 C 7.9 9.517 8.2 9.317 8.5 9.317 L 9 9.317 C 10.4 9.317 11.7 9.317 12.4 10.117 C 12.9 10.517 13.1 11.217 12.9 12.217 Z"></path>\n    <path fill="#003087" d="M 35.2 12.117 L 31.5 12.117 C 31.2 12.117 30.9 12.317 30.9 12.617 L 30.7 13.617 L 30.4 13.217 C 29.6 12.017 27.8 11.617 26 11.617 C 21.9 11.617 18.4 14.717 17.7 19.117 C 17.3 21.317 17.8 23.417 19.1 24.817 C 20.2 26.117 21.9 26.717 23.8 26.717 C 27.1 26.717 29 24.617 29 24.617 L 28.8 25.617 C 28.7 26.017 29 26.417 29.4 26.417 L 32.8 26.417 C 33.3 26.417 33.8 26.017 33.9 25.517 L 35.9 12.717 C 36 12.517 35.6 12.117 35.2 12.117 Z M 30.1 19.317 C 29.7 21.417 28.1 22.917 25.9 22.917 C 24.8 22.917 24 22.617 23.4 21.917 C 22.8 21.217 22.6 20.317 22.8 19.317 C 23.1 17.217 24.9 15.717 27 15.717 C 28.1 15.717 28.9 16.117 29.5 16.717 C 30 17.417 30.2 18.317 30.1 19.317 Z"></path>\n    <path fill="#003087" d="M 55.1 12.117 L 51.4 12.117 C 51 12.117 50.7 12.317 50.5 12.617 L 45.3 20.217 L 43.1 12.917 C 43 12.417 42.5 12.117 42.1 12.117 L 38.4 12.117 C 38 12.117 37.6 12.517 37.8 13.017 L 41.9 25.117 L 38 30.517 C 37.7 30.917 38 31.517 38.5 31.517 L 42.2 31.517 C 42.6 31.517 42.9 31.317 43.1 31.017 L 55.6 13.017 C 55.9 12.717 55.6 12.117 55.1 12.117 Z"></path>\n    <path fill="#009cde" d="M 67.5 4.917 L 59.7 4.917 C 59.2 4.917 58.7 5.317 58.6 5.817 L 55.5 25.717 C 55.4 26.117 55.7 26.417 56.1 26.417 L 60.1 26.417 C 60.5 26.417 60.8 26.117 60.8 25.817 L 61.7 20.117 C 61.8 19.617 62.2 19.217 62.8 19.217 L 65.3 19.217 C 70.4 19.217 73.4 16.717 74.2 11.817 C 74.5 9.717 74.2 8.017 73.2 6.817 C 72 5.617 70.1 4.917 67.5 4.917 Z M 68.4 12.217 C 68 15.017 65.8 15.017 63.8 15.017 L 62.6 15.017 L 63.4 9.817 C 63.4 9.517 63.7 9.317 64 9.317 L 64.5 9.317 C 65.9 9.317 67.2 9.317 67.9 10.117 C 68.4 10.517 68.5 11.217 68.4 12.217 Z"></path>\n    <path fill="#009cde" d="M 90.7 12.117 L 87 12.117 C 86.7 12.117 86.4 12.317 86.4 12.617 L 86.2 13.617 L 85.9 13.217 C 85.1 12.017 83.3 11.617 81.5 11.617 C 77.4 11.617 73.9 14.717 73.2 19.117 C 72.8 21.317 73.3 23.417 74.6 24.817 C 75.7 26.117 77.4 26.717 79.3 26.717 C 82.6 26.717 84.5 24.617 84.5 24.617 L 84.3 25.617 C 84.2 26.017 84.5 26.417 84.9 26.417 L 88.3 26.417 C 88.8 26.417 89.3 26.017 89.4 25.517 L 91.4 12.717 C 91.4 12.517 91.1 12.117 90.7 12.117 Z M 85.5 19.317 C 85.1 21.417 83.5 22.917 81.3 22.917 C 80.2 22.917 79.4 22.617 78.8 21.917 C 78.2 21.217 78 20.317 78.2 19.317 C 78.5 17.217 80.3 15.717 82.4 15.717 C 83.5 15.717 84.3 16.117 84.9 16.717 C 85.5 17.417 85.7 18.317 85.5 19.317 Z"></path>\n    <path fill="#009cde" d="M 95.1 5.417 L 91.9 25.717 C 91.8 26.117 92.1 26.417 92.5 26.417 L 95.7 26.417 C 96.2 26.417 96.7 26.017 96.8 25.517 L 100 5.617 C 100.1 5.217 99.8 4.917 99.4 4.917 L 95.8 4.917 C 95.4 4.917 95.2 5.117 95.1 5.417 Z"></path>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/paypal_white.svg": function(module, exports) {
            module.exports = '<svg width="100" height="32" viewBox="0 0 100 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#ffffff" d="M 12 5.315 L 4.2 5.315 C 3.7 5.315 3.2 5.715 3.1 6.215 L 0 26.215 C -0.1 26.615 0.2 26.915 0.6 26.915 L 4.3 26.915 C 4.8 26.915 5.3 26.515 5.4 26.015 L 6.2 20.615 C 6.3 20.115 6.7 19.715 7.3 19.715 L 9.8 19.715 C 14.9 19.715 17.9 17.215 18.7 12.315 C 19 10.215 18.7 8.515 17.7 7.315 C 16.6 6.015 14.6 5.315 12 5.315 Z M 12.9 12.615 C 12.5 15.415 10.3 15.415 8.3 15.415 L 7.1 15.415 L 7.9 10.215 C 7.9 9.915 8.2 9.715 8.5 9.715 L 9 9.715 C 10.4 9.715 11.7 9.715 12.4 10.515 C 12.9 10.915 13.1 11.615 12.9 12.615 Z"></path>\n    <path fill="#ffffff" d="M 35.2 12.515 L 31.5 12.515 C 31.2 12.515 30.9 12.715 30.9 13.015 L 30.7 14.015 L 30.4 13.615 C 29.6 12.415 27.8 12.015 26 12.015 C 21.9 12.015 18.4 15.115 17.7 19.515 C 17.3 21.715 17.8 23.815 19.1 25.215 C 20.2 26.515 21.9 27.115 23.8 27.115 C 27.1 27.115 29 25.015 29 25.015 L 28.8 26.015 C 28.7 26.415 29 26.815 29.4 26.815 L 32.8 26.815 C 33.3 26.815 33.8 26.415 33.9 25.915 L 35.9 13.115 C 36 12.915 35.6 12.515 35.2 12.515 Z M 30.1 19.815 C 29.7 21.915 28.1 23.415 25.9 23.415 C 24.8 23.415 24 23.115 23.4 22.415 C 22.8 21.715 22.6 20.815 22.8 19.815 C 23.1 17.715 24.9 16.215 27 16.215 C 28.1 16.215 28.9 16.615 29.5 17.215 C 30 17.815 30.2 18.715 30.1 19.815 Z"></path>\n    <path fill="#ffffff" d="M 55.1 12.515 L 51.4 12.515 C 51 12.515 50.7 12.715 50.5 13.015 L 45.3 20.615 L 43.1 13.315 C 43 12.815 42.5 12.515 42.1 12.515 L 38.4 12.515 C 38 12.515 37.6 12.915 37.8 13.415 L 41.9 25.515 L 38 30.915 C 37.7 31.315 38 31.915 38.5 31.915 L 42.2 31.915 C 42.6 31.915 42.9 31.715 43.1 31.415 L 55.6 13.415 C 55.9 13.115 55.6 12.515 55.1 12.515 Z"></path>\n    <path fill="#ffffff" d="M 67.5 5.315 L 59.7 5.315 C 59.2 5.315 58.7 5.715 58.6 6.215 L 55.5 26.115 C 55.4 26.515 55.7 26.815 56.1 26.815 L 60.1 26.815 C 60.5 26.815 60.8 26.515 60.8 26.215 L 61.7 20.515 C 61.8 20.015 62.2 19.615 62.8 19.615 L 65.3 19.615 C 70.4 19.615 73.4 17.115 74.2 12.215 C 74.5 10.115 74.2 8.415 73.2 7.215 C 72 6.015 70.1 5.315 67.5 5.315 Z M 68.4 12.615 C 68 15.415 65.8 15.415 63.8 15.415 L 62.6 15.415 L 63.4 10.215 C 63.4 9.915 63.7 9.715 64 9.715 L 64.5 9.715 C 65.9 9.715 67.2 9.715 67.9 10.515 C 68.4 10.915 68.5 11.615 68.4 12.615 Z"></path>\n    <path fill="#ffffff" d="M 90.7 12.515 L 87 12.515 C 86.7 12.515 86.4 12.715 86.4 13.015 L 86.2 14.015 L 85.9 13.615 C 85.1 12.415 83.3 12.015 81.5 12.015 C 77.4 12.015 73.9 15.115 73.2 19.515 C 72.8 21.715 73.3 23.815 74.6 25.215 C 75.7 26.515 77.4 27.115 79.3 27.115 C 82.6 27.115 84.5 25.015 84.5 25.015 L 84.3 26.015 C 84.2 26.415 84.5 26.815 84.9 26.815 L 88.3 26.815 C 88.8 26.815 89.3 26.415 89.4 25.915 L 91.4 13.115 C 91.4 12.915 91.1 12.515 90.7 12.515 Z M 85.5 19.815 C 85.1 21.915 83.5 23.415 81.3 23.415 C 80.2 23.415 79.4 23.115 78.8 22.415 C 78.2 21.715 78 20.815 78.2 19.815 C 78.5 17.715 80.3 16.215 82.4 16.215 C 83.5 16.215 84.3 16.615 84.9 17.215 C 85.5 17.815 85.7 18.715 85.5 19.815 Z"></path>\n    <path fill="#ffffff" d="M 95.1 5.915 L 91.9 26.215 C 91.8 26.615 92.1 26.915 92.5 26.915 L 95.7 26.915 C 96.2 26.915 96.7 26.515 96.8 26.015 L 100 6.115 C 100.1 5.715 99.8 5.415 99.4 5.415 L 95.8 5.415 C 95.4 5.315 95.2 5.515 95.1 5.915 Z"></path>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/pp_black.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="24" height="32" viewBox="0 0 24 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446" style="fill: rgb(99, 99, 99);"/>\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"/>\n  <path d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z" style="fill: rgb(51, 48, 48);"/>\n  <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n    <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"/>\n    <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"/>\n    <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"/>\n  </g>\n</svg>';
        },
        "./src/components/button/templates/component/logos/pp_blue.svg": function(module, exports) {
            module.exports = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#009cde" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 6.675 28.9 C 6.581 29.3 6.862 29.6 7.236 29.6 L 11.356 29.6 C 11.825 29.6 12.292 29.3 12.386 28.8 L 12.386 28.5 L 13.228 23.3 L 13.228 23.1 C 13.322 22.6 13.79 22.2 14.258 22.2 L 14.821 22.2 C 18.845 22.2 21.935 20.5 22.871 15.5 C 23.339 13.4 23.153 11.7 22.029 10.5 C 21.748 10.1 21.279 9.8 20.905 9.5 L 20.905 9.5"></path>\n    <path fill="#012169" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 8.173 18.7 C 8.267 18.1 8.735 17.7 9.296 17.7 L 11.636 17.7 C 16.224 17.7 19.782 15.7 20.905 10.1 C 20.812 9.8 20.905 9.7 20.905 9.5"></path>\n    <path fill="#003087" d="M 9.485 9.5 C 9.577 9.2 9.765 8.9 10.046 8.7 C 10.232 8.7 10.326 8.6 10.513 8.6 L 16.692 8.6 C 17.442 8.6 18.189 8.7 18.753 8.8 C 18.939 8.8 19.127 8.8 19.314 8.9 C 19.501 9 19.688 9 19.782 9.1 C 19.875 9.1 19.968 9.1 20.063 9.1 C 20.343 9.2 20.624 9.4 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.6 C 18.658 3.2 16.506 2.6 13.79 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 9.485 9.5 Z"></path>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/pp_white.svg": function(module, exports) {
            module.exports = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446"></path>\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"></path>\n    <path fill="#ffffff" d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z"></path>\n    <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n        <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"></path>\n        <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"></path>\n        <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"></path>\n    </g>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/venmo_blue.svg": function(module, exports) {
            module.exports = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Blue" fill="#3D93CE">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/venmo_white.svg": function(module, exports) {
            module.exports = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="White" fill="#FFFFFF">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n';
        },
        "./src/components/button/templates/component/logos/visa.svg": function(module, exports) {
            module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(33, 86, 154);"/>\n  <path d="M19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
        },
        "./src/components/button/templates/component/script.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getComponentScript() {
                return function() {
                    function loop(method, delay, instances) {
                        setTimeout(function() {
                            method();
                            instances -= 1;
                            instances && loop(method, delay, instances);
                        }, delay);
                    }
                    function getElements(selector, parent) {
                        parent = parent || document;
                        return Array.prototype.slice.call(parent.querySelectorAll(selector));
                    }
                    function showElement(el) {
                        var displayType = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : STYLE.INLINE_BLOCK;
                        el.style.display = displayType;
                    }
                    function hideElement(el) {
                        el.style.display = STYLE.NONE;
                    }
                    function makeElementVisible(el) {
                        el.style.visibility = STYLE.VISIBLE;
                    }
                    function makeElementInvisible(el) {
                        el.style.visibility = STYLE.HIDDEN;
                    }
                    function hasDimensions(el) {
                        var rect = el.getBoundingClientRect();
                        return Boolean(rect.height && rect.width);
                    }
                    function isHidden(el) {
                        var computedStyle = window.getComputedStyle(el);
                        return !computedStyle || computedStyle.display === STYLE.NONE;
                    }
                    function displayedElementsHaveDimensions(elements) {
                        return elements.every(function(el) {
                            return hasDimensions(el) || isHidden(el);
                        });
                    }
                    function isOverflowing(el) {
                        if (el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight) return !0;
                        var parent = el.parentNode;
                        if (!parent) return !1;
                        var e = el.getBoundingClientRect(), p = parent.getBoundingClientRect();
                        return e.top < p.top || e.left < p.left || e.right > p.right || e.bottom > p.bottom || (e.left < 0 || e.top < 0 || e.left + e.width > window.innerWidth || e.top + e.height > window.innerHeight);
                    }
                    function toggleOptionals() {
                        tagline.some(isOverflowing) ? tagline.forEach(makeElementInvisible) : tagline.forEach(makeElementVisible);
                        cards.forEach(function(el) {
                            return showElement(el);
                        });
                        cards.filter(isOverflowing).forEach(hideElement);
                        text.forEach(function(el) {
                            return showElement(el);
                        });
                        optionals.forEach(function(el) {
                            return showElement(el);
                        });
                        if (images.some(isOverflowing) || text.some(isOverflowing)) {
                            text.forEach(hideElement);
                            optionals.forEach(hideElement);
                        } else {
                            text.forEach(makeElementVisible);
                            optionals.forEach(function(el) {
                                return showElement(el);
                            });
                        }
                    }
                    var STYLE = {
                        BLOCK: "block",
                        INLINE_BLOCK: "inline-block",
                        NONE: "none",
                        VISIBLE: "visible",
                        HIDDEN: "hidden"
                    }, images = getElements(".{ CLASS.BUTTON } .{ CLASS.LOGO }"), text = getElements(".{ CLASS.BUTTON } .{ CLASS.TEXT }"), tagline = getElements(".{ CLASS.TAGLINE }"), cards = getElements(".{ CLASS.FUNDINGICONS } .{ CLASS.CARD }"), optionals = getElements(".{ CLASS.BUTTON }-label-credit .{ CLASS.BUTTON }-logo-paypal");
                    toggleOptionals();
                    !function(elements, method) {
                        if (displayedElementsHaveDimensions(elements)) method(); else var interval = setInterval(function() {
                            if (displayedElementsHaveDimensions(elements)) {
                                clearInterval(interval);
                                method();
                            }
                        }, 5);
                    }(images, function() {
                        images.forEach(makeElementVisible);
                        toggleOptionals();
                        document.addEventListener("DOMContentLoaded", toggleOptionals);
                        window.addEventListener("load", toggleOptionals);
                        window.addEventListener("resize", toggleOptionals);
                        loop(toggleOptionals, 10, 10);
                    });
                };
            }
            __webpack_exports__.a = getComponentScript;
        },
        "./src/components/button/templates/component/style/base.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function componentStyle(_ref) {
                var height = _ref.height, cardNumber = _ref.cardNumber;
                return "\n        " + __WEBPACK_IMPORTED_MODULE_0__page__.a + "\n        " + __WEBPACK_IMPORTED_MODULE_1__button__.a + "\n        " + __WEBPACK_IMPORTED_MODULE_6__color__.a + "\n        " + __WEBPACK_IMPORTED_MODULE_2__layout__.a + "\n        " + __WEBPACK_IMPORTED_MODULE_3__branding__.a + "\n        " + __WEBPACK_IMPORTED_MODULE_4__labels__.a + "\n        " + Object(__WEBPACK_IMPORTED_MODULE_5__responsive__.a)({
                    height: height,
                    cardNumber: cardNumber
                }) + "\n    ";
            }
            __webpack_exports__.a = componentStyle;
            var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__("./src/components/button/templates/component/style/page.js"), __WEBPACK_IMPORTED_MODULE_1__button__ = __webpack_require__("./src/components/button/templates/component/style/button.js"), __WEBPACK_IMPORTED_MODULE_2__layout__ = __webpack_require__("./src/components/button/templates/component/style/layout.js"), __WEBPACK_IMPORTED_MODULE_3__branding__ = __webpack_require__("./src/components/button/templates/component/style/branding.js"), __WEBPACK_IMPORTED_MODULE_4__labels__ = __webpack_require__("./src/components/button/templates/component/style/labels.js"), __WEBPACK_IMPORTED_MODULE_5__responsive__ = __webpack_require__("./src/components/button/templates/component/style/responsive.js"), __WEBPACK_IMPORTED_MODULE_6__color__ = __webpack_require__("./src/components/button/templates/component/style/color.js");
        },
        "./src/components/button/templates/component/style/branding.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return brandingStyle;
            });
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), brandingStyle = "\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BRANDING + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.UNBRANDED + "  {\n        min-width: 60%;\n        width: auto;\n        font-weight: 900;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BRANDING + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.UNBRANDED + " ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.LOGO + " {\n        display: none;\n    }\n";
        },
        "./src/components/button/templates/component/style/button.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return buttonStyle;
            });
            var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_2__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), buttonStyle = "\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CONTAINER + ' {\n        display: block;\n        white-space: nowrap;\n        margin: 0;\n        background: 0;\n        border: 0;\n        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n        text-transform: none;\n        font-weight: 500;R\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        z-index: 0;\n        font-size: 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + ":not(." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CARD + ") {\n        border: 1px solid transparent;\n        border-radius: 0 3px 3px 0;\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        vertical-align: top;\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT + " {\n        cursor: auto;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + " * {\n        cursor: pointer;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CONTAINER + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.ENV + "-" + __WEBPACK_IMPORTED_MODULE_0__config_constants__.e.TEST + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TEXT + " {\n        font-family: Arial !important;\n        background: rgba(0, 0, 0, 0.5) !important;\n        color: transparent  !important;\n        text-shadow: none  !important;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD + ":hover,\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT + ":hover {\n        box-shadow: none;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CARD + ", ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CARD + " * {\n        cursor: pointer;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CARD + ":hover {\n        filter: brightness(1.2);\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + ":focus {\n        box-shadow: -1px -1px 18px 1px rgba(0, 0, 0, 0.25) inset;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT + ":focus {\n        box-shadow: none;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + " {\n        padding: 0;\n        display: inline-block;\n        background: none;\n        border: none;\n        width: auto;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TEXT + " {\n        display: inline-block;\n        white-space: pre;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + ",\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TEXT + " {\n        vertical-align: top;\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n        text-align: left;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.CARD + " {\n        border-radius: 4px;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TEXT + " {\n        visibility: hidden;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TAGLINE + " {\n        max-width: 100%;\n        font-weight: normal;\n        display: block;\n        text-align: center;\n        width: auto;\n        visibility: hidden;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.SEPARATOR + " {\n        height: 80%;\n        border-left: 1px solid rgba(0, 0, 0, 0.15);\n        margin: 0 8px;\n        display: inline-block;\n        position: relative;\n        top: 10%;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.SEPARATOR + " {\n        border-color: rgba(255, 255, 255, 0.45);\n    }\n";
        },
        "./src/components/button/templates/component/style/class.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return CLASS;
            });
            var CLASS = {
                CONTAINER: "paypal-button-container",
                BUTTON: "paypal-button",
                LABEL: "paypal-button-label",
                COLOR: "paypal-button-color",
                LOGO_COLOR: "paypal-button-logo-color",
                SHAPE: "paypal-button-shape",
                BRANDING: "paypal-button-branding",
                LAYOUT: "paypal-button-layout",
                NUMBER: "paypal-button-number",
                ENV: "paypal-button-env",
                TAGLINE: "paypal-button-tagline",
                TAGLINE_COLOR: "paypal-button-tagline-color",
                FUNDINGICONS: "paypal-button-fundingicons",
                TEXT: "paypal-button-text",
                LOGO: "paypal-button-logo",
                CARD: "paypal-button-card",
                SEPARATOR: "paypal-separator"
            };
        },
        "./src/components/button/templates/component/style/color.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return buttonColorStyle;
            });
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), buttonColorStyle = "\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.GOLD + " {\n        background: #ffc439;\n        color: #111;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.BLUE + " {\n        background: #009cde;\n        color: #fff;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.SILVER + " {\n        background: #eee;\n        color: #111;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.BLACK + " {\n        background: #2C2E2F;\n        color: #fff;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.DARKBLUE + " {\n        background: #003087;\n        color: #fff;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.COLOR + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.b.TRANSPARENT + " {\n        background: transparent;\n        color: #111;\n    }\n";
        },
        "./src/components/button/templates/component/style/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("./src/components/button/templates/component/style/base.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__base__.a;
            });
        },
        "./src/components/button/templates/component/style/labels.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return labelStyle;
            });
            var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__("./src/components/button/templates/style.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_2__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), labelStyle = "\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LABEL + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.c.CARD + " {\n        border-radius: 0 !important;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LABEL + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.TEXT + " {\n        display: none !important;\n    }\n\n    ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.g.MULTIPLE + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LABEL + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " {\n        display: none;\n    }\n\n    @media only screen and (max-width : " + __WEBPACK_IMPORTED_MODULE_0__style__.b[__WEBPACK_IMPORTED_MODULE_1__constants__.i.SMALL].minWidth + "px) {\n\n        ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LABEL + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " {\n            display: none;\n        }\n    }\n\n    @media only screen and (min-width : " + __WEBPACK_IMPORTED_MODULE_0__style__.b[__WEBPACK_IMPORTED_MODULE_1__constants__.i.SMALL].minWidth + "px) {\n\n        ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LABEL + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT + " ." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "." + __WEBPACK_IMPORTED_MODULE_2__class__.a.LOGO + "-" + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " {\n            display: inline-block;\n        }\n    }\n";
        },
        "./src/components/button/templates/component/style/layout.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return layoutStyle;
            });
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), layoutStyle = "\n\n    ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.CONTAINER + "." + __WEBPACK_IMPORTED_MODULE_1__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " ." + __WEBPACK_IMPORTED_MODULE_1__class__.a.TAGLINE + " {\n        display: none;\n    }\n";
        },
        "./src/components/button/templates/component/style/page.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return pageStyle;
            });
            var pageStyle = "\n    html, body {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n    }\n\n    * {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: default;\n    }\n";
        },
        "./src/components/button/templates/component/style/responsive.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function buttonResponsiveStyle(_ref) {
                var height = _ref.height, _ref$cardNumber = _ref.cardNumber, cardNumber = void 0 === _ref$cardNumber ? 4 : _ref$cardNumber;
                return Object.keys(__WEBPACK_IMPORTED_MODULE_1__style__.b).map(function(size) {
                    var style = __WEBPACK_IMPORTED_MODULE_1__style__.b[size], buttonHeight = height || style.defaultHeight, minDualWidth = Math.round(buttonHeight * DUAL_BUTTON_MIN_RATIO * 2);
                    return "\n\n            @media only screen and (min-width: " + style.minWidth + "px) {\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CONTAINER + " {\n                    min-width: " + style.minWidth + "px;\n                    max-width: " + style.maxWidth + "px;\n                    font-size: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 32), 10) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + ":not(." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + ") {\n                    height: " + buttonHeight + "px;\n                    min-height: " + (height || style.minHeight) + "px;\n                    max-height: " + (height || style.maxHeight) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BRANDING + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.UNBRANDED + " {\n                    font-size: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 45), 10) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LOGO + " {\n                    height: " + (Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 35) + 5) + "px;\n                    max-height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 60) + "px;\n                    min-height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 40) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.SHAPE + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.h.PILL + " {\n                    border-radius: " + Math.ceil(buttonHeight / 2) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.SHAPE + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.h.RECT + " {\n                    border-radius: 4px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " {\n                    margin-bottom: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.VERTICAL_MARGIN) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.SEPARATOR + " {\n                    margin: 0 " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 5) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.TAGLINE + " {\n                    height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.TAGLINE) + "px;\n                    line-height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.TAGLINE) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.FUNDINGICONS + " {\n                    height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.FUNDINGICONS) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + " {\n                    display: inline-block;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + " {\n                    width: " + (90 / cardNumber).toFixed(2) + "%;\n                    max-width: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 160) + "px;\n                    margin-top: 0;\n                    margin-left: " + (5 / cardNumber).toFixed(2) + "%;\n                    margin-right: " + (5 / cardNumber).toFixed(2) + "%;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + " img {\n                    width: 100%;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.FUNDINGICONS + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + " {\n                    height: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 70) + "px;\n                    margin-top: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 15) + "px;\n                    margin-left: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 7) + "px;\n                    margin-right: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.d)(buttonHeight, 7) + "px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.FUNDINGICONS + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CARD + " img {\n                    height: 100%;\n                }\n            }\n\n            @media only screen and (min-width: " + style.minWidth + "px) and (max-width: " + minDualWidth + "px) {\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-0 {\n                    width: 100%;\n                    margin-right: 0;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-1 {\n                    display: none;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CONTAINER + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.TAGLINE + " {\n                    display: none;\n                }\n            }\n\n            @media only screen and (min-width: " + Object(__WEBPACK_IMPORTED_MODULE_2__util__.b)(style.minWidth, minDualWidth) + "px) {\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-0 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                    margin-right: 4px;\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.BUTTON + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-1 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                }\n\n                ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.CONTAINER + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.LAYOUT + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL + "." + __WEBPACK_IMPORTED_MODULE_3__class__.a.NUMBER + "-" + __WEBPACK_IMPORTED_MODULE_0__constants__.g.MULTIPLE + " ." + __WEBPACK_IMPORTED_MODULE_3__class__.a.TAGLINE + " {\n                    display: block;\n                }\n            }\n        ";
                }).join("\n");
            }
            __webpack_exports__.a = buttonResponsiveStyle;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("./src/components/button/templates/style.js"), __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/components/button/templates/component/util.js"), __WEBPACK_IMPORTED_MODULE_3__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), DUAL_BUTTON_MIN_RATIO = 2.8;
        },
        "./src/components/button/templates/component/template.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getCommonButtonClasses(_ref) {
                var layout = _ref.layout, shape = _ref.shape, branding = _ref.branding, multiple = _ref.multiple, env = _ref.env;
                return [ __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LAYOUT + "-" + layout, __WEBPACK_IMPORTED_MODULE_10__style_class__.a.SHAPE + "-" + shape, __WEBPACK_IMPORTED_MODULE_10__style_class__.a.BRANDING + "-" + (branding ? __WEBPACK_IMPORTED_MODULE_2__constants__.a.BRANDED : __WEBPACK_IMPORTED_MODULE_2__constants__.a.UNBRANDED), __WEBPACK_IMPORTED_MODULE_10__style_class__.a.NUMBER + "-" + (multiple ? __WEBPACK_IMPORTED_MODULE_2__constants__.g.MULTIPLE : __WEBPACK_IMPORTED_MODULE_2__constants__.g.SINGLE), __WEBPACK_IMPORTED_MODULE_10__style_class__.a.ENV + "-" + env ].join(" ");
            }
            function getButtonClasses(_ref2) {
                var label = _ref2.label, color = _ref2.color, logoColor = _ref2.logoColor;
                return [ __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LABEL + "-" + label, __WEBPACK_IMPORTED_MODULE_10__style_class__.a.COLOR + "-" + color, __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LOGO_COLOR + "-" + logoColor ].join(" ");
            }
            function getLocaleContent(locale) {
                var country = locale.country, lang = locale.lang;
                return __WEBPACK_IMPORTED_MODULE_9__content__.a[country][lang];
            }
            function determineButtons(_ref3) {
                var label = _ref3.label, color = _ref3.color, sources = _ref3.sources, multiple = _ref3.multiple;
                return sources.map(function(source, i) {
                    var buttonLabel = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__.d)(source) : label;
                    return {
                        source: source,
                        label: buttonLabel,
                        color: multiple && i > 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(buttonLabel, "secondaryColors")[color] : color
                    };
                });
            }
            function renderCards(_ref4) {
                var cards = _ref4.cards, button = _ref4.button;
                return cards.map(function(name) {
                    var _ref5, logo = __WEBPACK_IMPORTED_MODULE_6__logos__.a[name];
                    return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("img", _extends({}, (_ref5 = {}, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.BUTTON] = button || !1, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.FUNDING_SOURCE] = "" + __WEBPACK_IMPORTED_MODULE_1__config_constants__.g.CARD, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.CARD] = "" + name, _ref5), {
                        class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.CARD + " " + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.CARD + "-" + name + " " + (button ? __WEBPACK_IMPORTED_MODULE_10__style_class__.a.BUTTON : ""),
                        src: "data:image/svg+xml;base64," + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__.btoa)(logo),
                        alt: name
                    }));
                });
            }
            function renderFundingIcons(_ref6) {
                var cards = _ref6.cards;
                if (_ref6.fundingicons) return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("div", {
                    class: "" + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.FUNDINGICONS
                }, renderCards({
                    cards: cards,
                    button: !0
                }));
            }
            function renderContent(text, _ref7) {
                var locale = _ref7.locale, color = _ref7.color, branding = _ref7.branding, logoColor = _ref7.logoColor, funding = _ref7.funding, env = _ref7.env, _cards = _ref7.cards, _content = getLocaleContent(locale);
                return Object(__WEBPACK_IMPORTED_MODULE_11__util__.e)(text, {
                    text: function(value) {
                        return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("span", {
                            class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.TEXT
                        }, value);
                    },
                    logo: function(name) {
                        if (branding) {
                            if (!logoColor) throw new Error("Can not determine logo without logo color");
                            var logo = __WEBPACK_IMPORTED_MODULE_6__logos__.b[name][logoColor] || __WEBPACK_IMPORTED_MODULE_6__logos__.b[name][__WEBPACK_IMPORTED_MODULE_2__constants__.f.ANY];
                            return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("img", {
                                class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LOGO + " " + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LOGO + "-" + name + " " + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.LOGO + "-" + color,
                                src: "data:image/svg+xml;base64," + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__.btoa)(logo),
                                alt: name
                            });
                        }
                    },
                    content: function(name) {
                        for (var contentString = void 0, _iterator = name.split("|"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref8;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref8 = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref8 = _i.value;
                            }
                            var key = _ref8;
                            if (_content[key]) {
                                contentString = _content[key];
                                break;
                            }
                        }
                        if (!contentString && env === __WEBPACK_IMPORTED_MODULE_1__config_constants__.e.TEST) throw new Error("Could not find content " + name + " for " + locale.lang + "_" + locale.country);
                        return renderContent(contentString || "", {
                            locale: locale,
                            color: color,
                            branding: branding,
                            logoColor: logoColor,
                            funding: funding,
                            env: env,
                            cards: _cards
                        });
                    },
                    cards: function() {
                        if (!funding) throw new Error("Can not determine card types without funding");
                        return renderCards({
                            cards: _cards,
                            button: !1
                        });
                    },
                    separator: function() {
                        return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("span", {
                            class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.SEPARATOR
                        });
                    }
                });
            }
            function renderButton(_ref9) {
                var _ref10, label = _ref9.label, color = _ref9.color, locale = _ref9.locale, branding = _ref9.branding, multiple = _ref9.multiple, layout = _ref9.layout, shape = _ref9.shape, source = _ref9.source, funding = _ref9.funding, i = _ref9.i, env = _ref9.env, cards = _ref9.cards, logoColor = Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "logoColors")[color], contentText = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "logoLabel") : Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "label");
                contentText = renderContent(contentText, {
                    locale: locale,
                    color: color,
                    branding: branding,
                    logoColor: logoColor,
                    funding: funding,
                    env: env,
                    cards: cards
                });
                return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("div", _extends({}, (_ref10 = {}, 
                _ref10[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.FUNDING_SOURCE] = source, 
                _ref10[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.BUTTON] = !0, _ref10), {
                    class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.BUTTON + " " + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.NUMBER + "-" + i + " " + getCommonButtonClasses({
                        layout: layout,
                        shape: shape,
                        branding: branding,
                        multiple: multiple,
                        env: env
                    }) + " " + getButtonClasses({
                        label: label,
                        color: color,
                        logoColor: logoColor
                    }),
                    role: "button",
                    "aria-label": source,
                    tabindex: "0"
                }), contentText);
            }
            function renderTagline(_ref11) {
                var label = _ref11.label, tagline = _ref11.tagline, color = _ref11.color, locale = _ref11.locale, multiple = _ref11.multiple, env = _ref11.env, cards = _ref11.cards;
                if (tagline) {
                    var tag = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "dualTag") || Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "tag") : Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "tag"), text = renderContent(tag, {
                        locale: locale,
                        color: color,
                        env: env,
                        cards: cards
                    });
                    if (text) {
                        var tagColor = Object(__WEBPACK_IMPORTED_MODULE_3__config__.e)(label, "tagLineColors")[color];
                        return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("div", {
                            class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.TAGLINE + " " + __WEBPACK_IMPORTED_MODULE_10__style_class__.a.TAGLINE_COLOR + "-" + tagColor
                        }, text);
                    }
                }
            }
            function renderScript() {
                var script = Object(__WEBPACK_IMPORTED_MODULE_8__script__.a)().toString();
                script = script.replace(/\{\s*CLASS\.([A-Z0-9_]+)\s*\}/g, function(match, name) {
                    return __WEBPACK_IMPORTED_MODULE_10__style_class__.a[name];
                });
                return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("script", {
                    innerHTML: "(" + script + ")();"
                });
            }
            function renderStyle(_ref12) {
                var height = _ref12.height, cardNumber = _ref12.cardNumber;
                return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("style", {
                    innerHTML: Object(__WEBPACK_IMPORTED_MODULE_7__style__.a)({
                        height: height,
                        cardNumber: cardNumber
                    })
                });
            }
            function componentTemplate(_ref13) {
                var _ref14, props = _ref13.props;
                if (props && props.style) {
                    var style = props.style;
                    "generic" === style.label && (style.label = "paypal");
                    "creditblue" === style.color && delete style.color;
                    1 !== style.maxbuttons || !1 !== style.tagline || "responsive" !== style.size || "horizontal" !== style.layout || style.height || (style.height = 44);
                }
                Object(__WEBPACK_IMPORTED_MODULE_12__validate__.b)(props);
                var _normalizeProps = Object(__WEBPACK_IMPORTED_MODULE_5__props__.a)(props), label = _normalizeProps.label, locale = _normalizeProps.locale, color = _normalizeProps.color, shape = _normalizeProps.shape, branding = _normalizeProps.branding, tagline = _normalizeProps.tagline, funding = _normalizeProps.funding, layout = _normalizeProps.layout, sources = _normalizeProps.sources, multiple = _normalizeProps.multiple, fundingicons = _normalizeProps.fundingicons, env = _normalizeProps.env, height = _normalizeProps.height, cards = _normalizeProps.cards, buttonNodes = determineButtons({
                    label: label,
                    color: color,
                    sources: sources,
                    multiple: multiple
                }).map(function(button, i) {
                    return renderButton({
                        label: button.label,
                        color: button.color,
                        source: button.source,
                        env: env,
                        i: i,
                        funding: funding,
                        multiple: multiple,
                        locale: locale,
                        branding: branding,
                        layout: layout,
                        shape: shape,
                        cards: cards
                    });
                }), taglineNode = renderTagline({
                    label: label,
                    tagline: tagline,
                    color: color,
                    locale: locale,
                    multiple: multiple,
                    env: env,
                    cards: cards
                }), fundingiconNode = renderFundingIcons({
                    cards: cards,
                    fundingicons: fundingicons
                }), styleNode = renderStyle({
                    height: height,
                    cardNumber: cards.length
                }), scriptNode = renderScript();
                return Object(__WEBPACK_IMPORTED_MODULE_11__util__.a)("div", _extends({}, (_ref14 = {}, 
                _ref14[__WEBPACK_IMPORTED_MODULE_1__config_constants__.a.VERSION] = "4.0.173", _ref14), {
                    class: __WEBPACK_IMPORTED_MODULE_10__style_class__.a.CONTAINER + " " + getCommonButtonClasses({
                        layout: layout,
                        shape: shape,
                        branding: branding,
                        multiple: multiple,
                        env: env
                    })
                }), styleNode, buttonNodes, taglineNode || fundingiconNode, scriptNode).toString();
            }
            __webpack_exports__.a = componentTemplate;
            var __WEBPACK_IMPORTED_MODULE_0_Base64__ = __webpack_require__("./node_modules/Base64/base64.js"), __WEBPACK_IMPORTED_MODULE_1__config_constants__ = (__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Base64__), 
            __webpack_require__("./src/config/constants.js")), __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/components/button/templates/config.js"), __WEBPACK_IMPORTED_MODULE_5__props__ = (__webpack_require__("./src/components/button/templates/funding.js"), 
            __webpack_require__("./src/components/button/templates/props.js")), __WEBPACK_IMPORTED_MODULE_6__logos__ = __webpack_require__("./src/components/button/templates/component/logos/index.js"), __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__("./src/components/button/templates/component/style/index.js"), __WEBPACK_IMPORTED_MODULE_8__script__ = __webpack_require__("./src/components/button/templates/component/script.js"), __WEBPACK_IMPORTED_MODULE_9__content__ = __webpack_require__("./src/components/button/templates/component/content.js"), __WEBPACK_IMPORTED_MODULE_10__style_class__ = __webpack_require__("./src/components/button/templates/component/style/class.js"), __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__("./src/components/button/templates/component/util.js"), __WEBPACK_IMPORTED_MODULE_12__validate__ = __webpack_require__("./src/components/button/templates/component/validate.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            };
        },
        "./src/components/button/templates/component/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !call || "object" != typeof call && "function" != typeof call ? self : call;
            }
            function _inherits(subClass, superClass) {
                if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function encode() {
                return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/\//g, "&#x2F;");
            }
            function perc(pixels, percentage) {
                return Math.round(pixels * percentage / 100);
            }
            function min() {
                return Math.min.apply(Math, arguments);
            }
            function max() {
                return Math.max.apply(Math, arguments);
            }
            function jsxToHTML(name, props) {
                for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) children[_key - 2] = arguments[_key];
                return new JsxHTMLNode(name, props, children);
            }
            function regexMap(str, regex, handler) {
                var results = [];
                str.replace(regex, function() {
                    results.push(handler.apply(null, arguments));
                });
                return results;
            }
            function render(template, renderers) {
                var nodes = regexMap(template, /\{\s*([a-z]+)(?::\s*([^} ]+))?\s*\}|([^${}]+)/g, function(match, type, value, text) {
                    if (type) {
                        if (!renderers[type]) throw new Error("Can not render type: " + type);
                        return renderers[type](value);
                    }
                    return text && text.trim() && renderers.text ? renderers.text(text) : text;
                });
                return new JsxHTMLNodeContainer(nodes);
            }
            __webpack_exports__.d = perc;
            __webpack_exports__.c = min;
            __webpack_exports__.b = max;
            __webpack_exports__.a = jsxToHTML;
            __webpack_exports__.e = render;
            var JsxHTMLNode = function() {
                function JsxHTMLNode(name, props, children) {
                    _classCallCheck(this, JsxHTMLNode);
                    this.name = name;
                    this.props = props;
                    this.children = children;
                }
                JsxHTMLNode.prototype.toString = function() {
                    return "<" + this.name + (this.props ? " " : "") + (this.props ? this.propsToString() : "") + ">" + this.childrenToString() + "</" + this.name + ">";
                };
                JsxHTMLNode.prototype.propsToString = function() {
                    var props = this.props;
                    return props ? Object.keys(props).filter(function(key) {
                        return "innerHTML" !== key && props && !1 !== props[key];
                    }).map(function(key) {
                        return props && !0 === props[key] ? "" + encode(key) : props ? encode(key) + '="' + encode(props[key]) + '"' : "";
                    }).join(" ") : "";
                };
                JsxHTMLNode.prototype.childrenToString = function() {
                    function iterate(children) {
                        for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            var child = _ref;
                            null !== child && void 0 !== child && (Array.isArray(child) ? iterate(child) : result += child instanceof JsxHTMLNode ? child.toString() : encode(child));
                        }
                    }
                    if (this.props && this.props.innerHTML) return this.props.innerHTML;
                    if (!this.children) return "";
                    var result = "";
                    iterate(this.children);
                    return result;
                };
                return JsxHTMLNode;
            }(), JsxHTMLNodeContainer = function(_JsxHTMLNode) {
                function JsxHTMLNodeContainer(children) {
                    _classCallCheck(this, JsxHTMLNodeContainer);
                    return _possibleConstructorReturn(this, _JsxHTMLNode.call(this, "", {}, children));
                }
                _inherits(JsxHTMLNodeContainer, _JsxHTMLNode);
                JsxHTMLNodeContainer.prototype.toString = function() {
                    return this.childrenToString();
                };
                return JsxHTMLNodeContainer;
            }(JsxHTMLNode);
        },
        "./src/components/button/templates/component/validate.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function validateButtonLocale(locale) {
                if (!locale) throw new Error("Expected props.locale to be set");
                if (!locale.match(/^[a-z]{2}[_][A-Z][A-Z0-9]$/)) throw new Error("Expected props.locale to be valid, got " + locale);
                var _locale$split = locale.split("_"), lang = _locale$split[0], country = _locale$split[1];
                if (!__WEBPACK_IMPORTED_MODULE_3__content__.a[country] || !__WEBPACK_IMPORTED_MODULE_3__content__.a[country][lang]) throw new Error("Expected props.locale to be valid");
            }
            function validateButtonStyle() {
                var style = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!style) throw new Error("Expected props.style to be set");
                var label = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LABEL] || Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)("DEFAULT", style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LAYOUT] === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
                if (!__WEBPACK_IMPORTED_MODULE_1__config__.a[label]) throw new Error("Invalid button label: " + label + ", expected: " + Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__.a[label]).join(", "));
                var color = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.COLOR], shape = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.SHAPE], size = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.SIZE], branding = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.BRANDING], fundingicons = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.FUNDINGICONS], tagline = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.TAGLINE], layout = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LAYOUT], maxbuttons = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.MAXBUTTONS], height = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.HEIGHT];
                if (color && -1 === Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "colors").indexOf(color)) throw new Error("Unexpected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.COLOR + " for " + label + " button: " + color + ", expected " + Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "colors").join(", "));
                if (shape && -1 === Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "shapes").indexOf(shape)) throw new Error("Unexpected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.SHAPE + " for " + label + " button: " + shape + ", expected " + Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "shapes").join(", "));
                if (size && -1 === Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "sizes").indexOf(size)) throw new Error("Unexpected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.SIZE + " for " + label + " button: " + size + ", expected " + Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "sizes").join(", "));
                if (!1 === branding) throw new Error("style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.BRANDING + ":false is not allowed");
                if (fundingicons && !Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "allowFundingIcons")) throw new Error("style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.FUNDINGICONS + ":true is not allowed for " + label + " button");
                if (layout && -1 === Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "layouts").indexOf(layout)) throw new Error("Unexpected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.LAYOUT + " for " + label + " button: " + layout + ", expected " + Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "layouts").join(", "));
                if (void 0 !== maxbuttons) {
                    if ("number" != typeof maxbuttons) throw new TypeError("Expected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.MAXBUTTONS + " to be a number, got: " + maxbuttons);
                    if (maxbuttons < 1) throw new Error("Expected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.MAXBUTTONS + " to be a at least 1, got: " + maxbuttons);
                    var minButtons = layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "minVerticalButtons") : Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "minHorizontalButtons");
                    if (maxbuttons < minButtons) throw new Error("Expected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.MAXBUTTONS + " to be no fewer than " + minButtons + ", got " + maxbuttons);
                }
                if (void 0 !== height) {
                    if ("number" != typeof height) throw new TypeError("Expected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.HEIGHT + " to be a number, got: " + maxbuttons);
                    var buttonSize = size || Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "defaultVerticalSize" : "defaultSize"), _ref = size === __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE ? {
                        minHeight: __WEBPACK_IMPORTED_MODULE_2__style__.b[__WEBPACK_IMPORTED_MODULE_0__constants__.i.SMALL].minHeight,
                        maxHeight: __WEBPACK_IMPORTED_MODULE_2__style__.b[__WEBPACK_IMPORTED_MODULE_0__constants__.i.HUGE].maxHeight
                    } : __WEBPACK_IMPORTED_MODULE_2__style__.b[buttonSize], minHeight = _ref.minHeight, maxHeight = _ref.maxHeight;
                    if (height < minHeight || height > maxHeight) throw new Error("Expected style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.HEIGHT + " to be between " + minHeight + "px and " + maxHeight + "px - got " + height + "px");
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "allowPrimary")) throw new Error(label + " can not be used as primary button label");
                if (layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL) {
                    if (size && -1 === [ __WEBPACK_IMPORTED_MODULE_0__constants__.i.MEDIUM, __WEBPACK_IMPORTED_MODULE_0__constants__.i.LARGE, __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE ].indexOf(size)) throw new Error("Button must be at least " + __WEBPACK_IMPORTED_MODULE_0__constants__.i.MEDIUM + " size for " + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " layout");
                    if (style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LABEL]) throw new Error("style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.LABEL + " option is not allowed for " + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " layout - got " + label);
                    if (fundingicons) throw new Error("style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.FUNDINGICONS + " not allowed for " + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " layout - got " + fundingicons);
                    if (tagline) throw new Error("style." + __WEBPACK_IMPORTED_MODULE_0__constants__.j.TAGLINE + " is not allowed for " + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " layout - got " + tagline);
                }
            }
            function validateButtonProps(props) {
                if (!props) throw new Error("Expected props");
                var locale = props.locale, style = props.style;
                validateButtonLocale(locale);
                validateButtonStyle(style);
            }
            __webpack_exports__.a = validateButtonLocale;
            __webpack_exports__.c = validateButtonStyle;
            __webpack_exports__.b = validateButtonProps;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/components/button/templates/config.js"), __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("./src/components/button/templates/style.js"), __WEBPACK_IMPORTED_MODULE_3__content__ = __webpack_require__("./src/components/button/templates/component/content.js");
        },
        "./src/components/button/templates/config.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function labelToFunding(label) {
                return label ? LABEL_TO_FUNDING[label] : __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL;
            }
            function fundingToDefaultLabel(funding) {
                return FUNDING_TO_DEFAULT_LABEL[funding];
            }
            function getConfig(conf, category, key, def) {
                var categoryConfig = conf[category];
                if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
                if (conf[__WEBPACK_IMPORTED_MODULE_1__constants__.l] && conf[__WEBPACK_IMPORTED_MODULE_1__constants__.l].hasOwnProperty(key)) return conf[__WEBPACK_IMPORTED_MODULE_1__constants__.l][key];
                if (arguments.length >= 4) return def;
                throw new Error("No value found for " + category + ":" + key);
            }
            function getButtonConfig(label, key, def) {
                return getConfig(BUTTON_CONFIG, label, key, def);
            }
            function getFundingConfig(source, key, def) {
                return getConfig(FUNDING_CONFIG, source, key, def);
            }
            function getCardConfig(source, key, def) {
                return getConfig(CARD_CONFIG, source, key, def);
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return BUTTON_CONFIG;
            });
            __webpack_exports__.h = labelToFunding;
            __webpack_exports__.d = fundingToDefaultLabel;
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return FUNDING_PRIORITY;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return FUNDING_CONFIG;
            });
            __webpack_exports__.e = getButtonConfig;
            __webpack_exports__.g = getFundingConfig;
            __webpack_exports__.f = getCardConfig;
            var _logoColors, _tagLineColors, _secondaryColors, _logoColors2, _secondaryColors2, _logoColors3, _secondaryColors3, _logoColors4, _secondaryColors4, _logoColors5, _secondaryColors5, _logoColors6, _secondaryColors6, _BUTTON_CONFIG, _FUNDING_TO_DEFAULT_L, _LABEL_TO_FUNDING, _FUNDING_CONFIG, _CARD_CONFIG, __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js"), BUTTON_CONFIG = (_BUTTON_CONFIG = {}, 
            _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.l] = {
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK ],
                sizes: [ __WEBPACK_IMPORTED_MODULE_1__constants__.i.SMALL, __WEBPACK_IMPORTED_MODULE_1__constants__.i.MEDIUM, __WEBPACK_IMPORTED_MODULE_1__constants__.i.LARGE, __WEBPACK_IMPORTED_MODULE_1__constants__.i.RESPONSIVE ],
                shapes: [ __WEBPACK_IMPORTED_MODULE_1__constants__.h.PILL, __WEBPACK_IMPORTED_MODULE_1__constants__.h.RECT ],
                layouts: [ __WEBPACK_IMPORTED_MODULE_1__constants__.d.HORIZONTAL, __WEBPACK_IMPORTED_MODULE_1__constants__.d.VERTICAL ],
                logoColors: (_logoColors = {}, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE, 
                _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE, 
                _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors),
                tagLineColors: (_tagLineColors = {}, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.k.BLUE, 
                _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.k.BLUE, 
                _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.k.BLUE, 
                _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.k.BLACK, 
                _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.k.BLUE, 
                _tagLineColors),
                secondaryColors: (_secondaryColors = {}, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, 
                _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, 
                _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK, 
                _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors),
                tag: "{ content: safer_tag }",
                dualTag: "{ content: dual_tag|safer_tag }",
                defaultLocale: "en_US",
                defaultLabel: __WEBPACK_IMPORTED_MODULE_1__constants__.c.CHECKOUT,
                defaultVerticalLabel: __WEBPACK_IMPORTED_MODULE_1__constants__.c.PAYPAL,
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD,
                defaultSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.SMALL,
                defaultVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.MEDIUM,
                defaultShape: __WEBPACK_IMPORTED_MODULE_1__constants__.h.PILL,
                defaultLayout: __WEBPACK_IMPORTED_MODULE_1__constants__.d.HORIZONTAL,
                defaultBranding: !0,
                defaultVerticalBranding: !0,
                defaultFundingIcons: !1,
                defaultTagline: !0,
                defaultDual: "",
                minimumSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.TINY,
                minimumVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.MEDIUM,
                maximumSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.HUGE,
                maximumVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__.i.HUGE,
                minHorizontalButtons: 1,
                minVerticalButtons: 1,
                maxHorizontalButtons: 2,
                maxVerticalButtons: 4,
                allowUnbranded: !1,
                allowFundingIcons: !0,
                allowPrimary: !1,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !1,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !1
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.PAYPAL] = {
                label: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " }",
                allowPrimary: !0,
                allowPrimaryVertical: !0,
                allowPrimaryHorizontal: !0,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !0
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CHECKOUT] = {
                label: "{ content: checkout }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " }",
                allowPrimary: !0,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !0,
                allowSecondaryVertical: !1,
                allowSecondaryHorizontal: !1
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.PAY] = {
                label: "{ content: pay }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " }",
                allowPrimary: !0,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !0,
                allowSecondaryVertical: !1,
                allowSecondaryHorizontal: !1
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.BUYNOW] = {
                label: "{ content: buynow }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " }",
                defaultBranding: void 0,
                allowPrimary: !0,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !0,
                allowSecondaryVertical: !1,
                allowSecondaryHorizontal: !1,
                allowUnbranded: !0
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT] = {
                label: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.CREDIT + " }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PP + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.PAYPAL + " } { logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.CREDIT + " }",
                tag: "{ content: later_tag }",
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK ],
                logoColors: (_logoColors2 = {}, _logoColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors2),
                secondaryColors: (_secondaryColors2 = {}, _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE, 
                _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE, 
                _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE, 
                _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK, 
                _secondaryColors2),
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE,
                allowPrimary: !0,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !1,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !0,
                allowFundingIcons: !1
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.VENMO] = {
                label: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.VENMO + " }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.VENMO + " }",
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER,
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK ],
                logoColors: (_logoColors3 = {}, _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLUE, 
                _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors3),
                secondaryColors: (_secondaryColors3 = {}, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, 
                _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE, 
                _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK, 
                _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors3),
                allowPrimary: !0,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !0,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !0
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.IDEAL] = {
                label: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.IDEAL + " } Online betalen",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.IDEAL + " } Online betalen",
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER,
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK ],
                logoColors: (_logoColors4 = {}, _logoColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLACK, 
                _logoColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors4),
                secondaryColors: (_secondaryColors4 = {}, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK, 
                _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors4),
                allowPrimary: !1,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !1,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !0
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.ELV] = {
                label: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.ELV + " }",
                logoLabel: "{ logo: " + __WEBPACK_IMPORTED_MODULE_1__constants__.e.ELV + " }",
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER,
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK ],
                logoColors: (_logoColors5 = {}, _logoColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLACK, 
                _logoColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.WHITE, 
                _logoColors5),
                secondaryColors: (_secondaryColors5 = {}, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK, 
                _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER, 
                _secondaryColors5),
                allowPrimary: !1,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !1,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !0
            }, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CARD] = {
                label: "{ cards }",
                logoLabel: "{ cards }",
                defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER,
                colors: [ __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT ],
                logoColors: (_logoColors6 = {}, _logoColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT] = __WEBPACK_IMPORTED_MODULE_1__constants__.f.BLACK, 
                _logoColors6),
                secondaryColors: (_secondaryColors6 = {}, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT, 
                _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT, 
                _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT, 
                _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT, 
                _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__.b.DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__.b.TRANSPARENT, 
                _secondaryColors6),
                allowPrimary: !1,
                allowPrimaryVertical: !1,
                allowPrimaryHorizontal: !1,
                allowSecondaryVertical: !0,
                allowSecondaryHorizontal: !1
            }, _BUTTON_CONFIG), FUNDING_TO_DEFAULT_LABEL = (_FUNDING_TO_DEFAULT_L = {}, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.PAYPAL, 
            _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.VENMO] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.VENMO, 
            _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CARD] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.CARD, 
            _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CREDIT] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT, 
            _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.IDEAL] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.IDEAL, 
            _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.ELV] = __WEBPACK_IMPORTED_MODULE_1__constants__.c.ELV, 
            _FUNDING_TO_DEFAULT_L), LABEL_TO_FUNDING = (_LABEL_TO_FUNDING = {}, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.PAYPAL] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CHECKOUT] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.PAY] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.BUYNOW] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CARD] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CARD, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.CREDIT] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CREDIT, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.VENMO] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.VENMO, 
            _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__.c.IDEAL] = __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.IDEAL, 
            _LABEL_TO_FUNDING), FUNDING_PRIORITY = [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL, __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.VENMO, __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CREDIT, __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.IDEAL, __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.ELV, __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CARD ], FUNDING_CONFIG = (_FUNDING_CONFIG = {}, 
            _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.l] = {
                enabled: !0,
                allowOptIn: !0,
                allowOptOut: !0,
                allowRemember: !0
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.PAYPAL] = {
                default: !0,
                allowOptIn: !1,
                allowOptOut: !1
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CARD] = {
                default: !0
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.VENMO] = {
                allowOptOut: !1,
                allowedCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.US ]
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.CREDIT] = {
                allowedCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.US, __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.GB, __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.DE ],
                defaultVerticalCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.US ],
                platforms: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.l.MOBILE ]
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.IDEAL] = {
                allowedCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.NL ]
            }, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.g.ELV] = {
                allowedCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.DE, __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.AT ],
                defaultVerticalCountries: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.DE, __WEBPACK_IMPORTED_MODULE_0__config_constants__.d.AT ]
            }, _FUNDING_CONFIG), CARD_CONFIG = (_CARD_CONFIG = {}, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__.l] = {
                priority: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.AMEX ]
            }, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.d.US] = {
                priority: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.DISCOVER ]
            }, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.d.BR] = {
                priority: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.HIPER, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.ELO ]
            }, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__.d.JP] = {
                priority: [ __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__.b.JCB ]
            }, _CARD_CONFIG);
        },
        "./src/components/button/templates/container/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/button/templates/container/template.jsx");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__template__.a;
            });
        },
        "./src/components/button/templates/container/template.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function determineResponsiveSize(_ref) {
                var label = _ref.label, layout = _ref.layout, _ref$width = _ref.width, width = void 0 === _ref$width ? 0 : _ref$width, minimumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__.e)(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "minimumVerticalSize" : "minimumSize"), maximumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__.e)(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "maximumVerticalSize" : "maximumSize");
                if (width < __WEBPACK_IMPORTED_MODULE_1__style__.b[minimumSize].minWidth) return minimumSize;
                if (width >= __WEBPACK_IMPORTED_MODULE_1__style__.b[maximumSize].maxWidth) return maximumSize;
                for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_1__style__.b), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref2 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref2 = _i.value;
                    }
                    var size = _ref2, _BUTTON_STYLE$size = __WEBPACK_IMPORTED_MODULE_1__style__.b[size], minWidth = _BUTTON_STYLE$size.minWidth, maxWidth = _BUTTON_STYLE$size.maxWidth;
                    minWidth = _BUTTON_STYLE$size.minResponsiveWidth || minWidth;
                    if (width >= minWidth && width < maxWidth) return size;
                }
                throw new Error("Unable to calculate responsive size for width: " + width);
            }
            function getDimensions(_ref3) {
                var label = _ref3.label, size = _ref3.size, tagline = _ref3.tagline, fundingicons = _ref3.fundingicons, layout = _ref3.layout, number = _ref3.number, viewport = _ref3.viewport, buttonHeight = _ref3.height;
                size === __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE && (size = determineResponsiveSize({
                    label: label,
                    layout: layout,
                    width: viewport.width,
                    height: buttonHeight
                }));
                var _BUTTON_STYLE$size2 = __WEBPACK_IMPORTED_MODULE_1__style__.b[size], defaultWidth = _BUTTON_STYLE$size2.defaultWidth, defaultHeight = _BUTTON_STYLE$size2.defaultHeight, minHeight = _BUTTON_STYLE$size2.minHeight, maxHeight = _BUTTON_STYLE$size2.maxHeight, allowFunding = _BUTTON_STYLE$size2.allowFunding, allowTagline = _BUTTON_STYLE$size2.allowTagline;
                buttonHeight = buttonHeight || Object(__WEBPACK_IMPORTED_MODULE_4__component_util__.c)(Object(__WEBPACK_IMPORTED_MODULE_4__component_util__.b)(defaultHeight, minHeight), maxHeight);
                var width = defaultWidth, height = buttonHeight;
                fundingicons && allowFunding ? height += Object(__WEBPACK_IMPORTED_MODULE_4__component_util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.FUNDINGICONS) : tagline && allowTagline ? height += Object(__WEBPACK_IMPORTED_MODULE_4__component_util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.TAGLINE) : layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL && (height = buttonHeight * number + Object(__WEBPACK_IMPORTED_MODULE_4__component_util__.d)(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__.a.VERTICAL_MARGIN) * (number - 1));
                return {
                    width: width,
                    height: height
                };
            }
            function containerTemplate(_ref4) {
                var id = _ref4.id, props = _ref4.props, CLASS = _ref4.CLASS, on = _ref4.on, container = _ref4.container, tag = _ref4.tag, context = _ref4.context, outlet = _ref4.outlet, jsxDom = _ref4.jsxDom, _normalizeProps = Object(__WEBPACK_IMPORTED_MODULE_3__props__.a)(props), size = _normalizeProps.size, label = _normalizeProps.label, fundingicons = _normalizeProps.fundingicons, tagline = _normalizeProps.tagline, layout = _normalizeProps.layout, sources = _normalizeProps.sources, buttonHeight = _normalizeProps.height, getContainerDimensions = function() {
                    return getDimensions({
                        viewport: {
                            width: container.offsetWidth,
                            height: container.offsetHeight
                        },
                        number: sources.length,
                        height: buttonHeight,
                        label: label,
                        size: size,
                        fundingicons: fundingicons,
                        tagline: tagline,
                        layout: layout
                    });
                }, _getContainerDimensio = getContainerDimensions(), width = _getContainerDimensio.width, height = _getContainerDimensio.height;
                size === __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE && on("resize", function() {
                    outlet.style.height = getContainerDimensions().height + "px";
                });
                var minimumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__.e)(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "minimumVerticalSize" : "minimumSize"), maximumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__.e)(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "maximumVerticalSize" : "maximumSize");
                if (buttonHeight) {
                    var possibleSizes = Object(__WEBPACK_IMPORTED_MODULE_5__lib__.Y)(__WEBPACK_IMPORTED_MODULE_0__constants__.i).filter(function(possibleSize) {
                        return __WEBPACK_IMPORTED_MODULE_1__style__.b[possibleSize] && __WEBPACK_IMPORTED_MODULE_1__style__.b[possibleSize].minHeight <= buttonHeight && __WEBPACK_IMPORTED_MODULE_1__style__.b[possibleSize].maxHeight >= buttonHeight;
                    });
                    possibleSizes.sort(function(sizeA, sizeB) {
                        return __WEBPACK_IMPORTED_MODULE_1__style__.b[sizeA].defaultWidth - __WEBPACK_IMPORTED_MODULE_1__style__.b[sizeB].defaultWidth;
                    });
                    minimumSize = possibleSizes[0];
                    maximumSize = possibleSizes[possibleSizes.length - 1];
                }
                return jsxDom("div", {
                    id: id,
                    class: tag + " " + tag + "-context-" + context + " " + tag + "-label-" + label + " " + tag + "-size-" + size + " " + tag + "-layout-" + layout
                }, jsxDom("style", null, "\n                    #" + id + " {\n                        font-size: 0;\n                        width: 100%;\n                    }\n\n                    #" + id + "." + tag + "-size-" + __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE + " {\n                        text-align: center;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        min-width: " + __WEBPACK_IMPORTED_MODULE_1__style__.b[minimumSize].minWidth + "px;\n                        max-width: " + __WEBPACK_IMPORTED_MODULE_1__style__.b[maximumSize].maxWidth + "px;\n                        position: relative;\n                    }\n\n                    #" + id + "." + tag + "-layout-" + __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL + " > ." + CLASS.OUTLET + " {\n                        min-width: " + __WEBPACK_IMPORTED_MODULE_1__style__.b[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        width:  " + width + "px;\n                        height: " + height + "px;\n                    }\n\n                     #" + id + "." + tag + "-size-" + __WEBPACK_IMPORTED_MODULE_0__constants__.i.RESPONSIVE + " > ." + CLASS.OUTLET + " {\n                        width: 100%;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        min-width: 100%;\n                        max-width: 100%;\n                        width: " + __WEBPACK_IMPORTED_MODULE_1__style__.b[minimumSize].minWidth + "px;\n                        height: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n                        z-index: 100;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n                        transition: opacity .2s linear;\n                        z-index: 200;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                        pointer-events: none;\n                    }\n                "), outlet);
            }
            __webpack_exports__.a = containerTemplate;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("./src/components/button/templates/style.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/components/button/templates/config.js"), __WEBPACK_IMPORTED_MODULE_3__props__ = __webpack_require__("./src/components/button/templates/props.js"), __WEBPACK_IMPORTED_MODULE_4__component_util__ = __webpack_require__("./src/components/button/templates/component/util.js"), __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./src/lib/index.js");
        },
        "./src/components/button/templates/funding.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isFundingEligible(source, _ref) {
                var locale = _ref.locale, funding = _ref.funding, env = _ref.env, layout = _ref.layout;
                if (!(Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "enabled") || env === __WEBPACK_IMPORTED_MODULE_0__config_constants__.e.TEST && Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "test"))) return !1;
                var isVertical = layout === __WEBPACK_IMPORTED_MODULE_1__constants__.d.VERTICAL, label = Object(__WEBPACK_IMPORTED_MODULE_2__config__.d)(source);
                return !(!Object(__WEBPACK_IMPORTED_MODULE_2__config__.e)(label, isVertical ? "allowSecondaryVertical" : "allowSecondaryHorizontal") || -1 !== funding.disallowed.indexOf(source) && Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "allowOptOut") || -1 !== funding.disallowed.indexOf(source) && source === __WEBPACK_IMPORTED_MODULE_0__config_constants__.g.VENMO || -1 === Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "allowedCountries", [ locale.country ]).indexOf(locale.country) || -1 === Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "defaultCountries", []).indexOf(locale.country) && (!isVertical || -1 === Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "defaultVerticalCountries", []).indexOf(locale.country)) && !Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "default") && (-1 === funding.allowed.indexOf(source) || !Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "allowOptIn")) && (-1 === funding.remembered.indexOf(source) || !Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "allowRemember")));
            }
            function determineEligibleFunding(_ref2) {
                var funding = _ref2.funding, selected = _ref2.selected, locale = _ref2.locale, env = _ref2.env, layout = _ref2.layout, eligibleFunding = __WEBPACK_IMPORTED_MODULE_2__config__.c.filter(function(source) {
                    return source !== selected && isFundingEligible(source, {
                        locale: locale,
                        funding: funding,
                        env: env,
                        layout: layout
                    });
                });
                eligibleFunding.unshift(selected);
                return eligibleFunding;
            }
            function determineEligibleCards(_ref3) {
                var funding = _ref3.funding, locale = _ref3.locale;
                return Object(__WEBPACK_IMPORTED_MODULE_2__config__.f)(locale.country, "priority").filter(function(card) {
                    return -1 === funding.disallowed.indexOf(card);
                });
            }
            function validateFunding() {
                var funding = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                    allowed: [],
                    disallowed: [],
                    remembered: []
                };
                if (funding.allowed) for (var _iterator = funding.allowed, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref4;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref4 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref4 = _i.value;
                    }
                    var source = _ref4;
                    if (-1 === __WEBPACK_IMPORTED_MODULE_0__config_constants__.c.indexOf(source)) {
                        if (!__WEBPACK_IMPORTED_MODULE_2__config__.b.hasOwnProperty(source)) throw new Error("Invalid funding source: " + source);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(source, "allowOptIn")) throw new Error("Can not allow funding source: " + source);
                        if (funding.disallowed && -1 !== funding.disallowed.indexOf(source)) throw new Error("Can not allow and disallow funding source: " + source);
                    }
                }
                if (funding.disallowed) for (var _iterator2 = funding.disallowed, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref5;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref5 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref5 = _i2.value;
                    }
                    var _source = _ref5;
                    if (-1 === __WEBPACK_IMPORTED_MODULE_0__config_constants__.c.indexOf(_source)) {
                        if (!__WEBPACK_IMPORTED_MODULE_2__config__.b.hasOwnProperty(_source)) throw new Error("Invalid funding source: " + _source);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_2__config__.g)(_source, "allowOptOut")) throw new Error("Can not disallow funding source: " + _source);
                    }
                }
            }
            __webpack_exports__.b = determineEligibleFunding;
            __webpack_exports__.a = determineEligibleCards;
            __webpack_exports__.c = validateFunding;
            var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js"), __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/components/button/templates/config.js");
        },
        "./src/components/button/templates/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/button/templates/component/index.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./src/components/button/templates/container/index.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__container__.a;
            });
        },
        "./src/components/button/templates/props.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function parseLocale(locale) {
                var _locale$split = locale.split("_"), lang = _locale$split[0];
                return {
                    country: _locale$split[1],
                    lang: lang
                };
            }
            function determineMaxButtons(_ref) {
                var label = _ref.label, layout = _ref.layout, max = _ref.max;
                if (!(layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "allowPrimaryHorizontal") : Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "allowPrimaryVertical"))) return 1;
                var configMax = layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "maxHorizontalButtons") : Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "maxVerticalButtons");
                return max ? Math.min(configMax, max) : configMax;
            }
            function enableTagline(_ref2) {
                var tagline = _ref2.tagline, branding = _ref2.branding, fundingicons = _ref2.fundingicons, layout = _ref2.layout;
                return Boolean(tagline && branding && !fundingicons && layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.HORIZONTAL);
            }
            function normalizeProps(props) {
                var env = props.env, _props$locale = props.locale, locale = void 0 === _props$locale ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)("DEFAULT", "defaultLocale") : _props$locale, _props$style = props.style, style = void 0 === _props$style ? {} : _props$style, funding = props.funding;
                locale = parseLocale(locale);
                var label = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LABEL] || Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)("DEFAULT", style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "defaultVerticalLabel" : "defaultLabel"), _style$BUTTON_STYLE_O = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.SIZE], size = void 0 === _style$BUTTON_STYLE_O ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "defaultVerticalSize" : "defaultSize") : _style$BUTTON_STYLE_O, _style$BUTTON_STYLE_O2 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.COLOR], color = void 0 === _style$BUTTON_STYLE_O2 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "defaultColor") : _style$BUTTON_STYLE_O2, _style$BUTTON_STYLE_O3 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.SHAPE], shape = void 0 === _style$BUTTON_STYLE_O3 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "defaultShape") : _style$BUTTON_STYLE_O3, _style$BUTTON_STYLE_O4 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.BRANDING], branding = void 0 === _style$BUTTON_STYLE_O4 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__.d.VERTICAL ? "defaultVerticalBranding" : "defaultBranding") : _style$BUTTON_STYLE_O4, _style$BUTTON_STYLE_O5 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.FUNDINGICONS], fundingicons = void 0 === _style$BUTTON_STYLE_O5 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "defaultFundingIcons") : _style$BUTTON_STYLE_O5, _style$BUTTON_STYLE_O6 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.TAGLINE], tagline = void 0 === _style$BUTTON_STYLE_O6 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "defaultTagline") : _style$BUTTON_STYLE_O6, _style$BUTTON_STYLE_O7 = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.LAYOUT], layout = void 0 === _style$BUTTON_STYLE_O7 ? Object(__WEBPACK_IMPORTED_MODULE_1__config__.e)(label, "defaultLayout") : _style$BUTTON_STYLE_O7, max = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.MAXBUTTONS], height = style[__WEBPACK_IMPORTED_MODULE_0__constants__.j.HEIGHT];
                max = determineMaxButtons({
                    label: label,
                    layout: layout,
                    max: max
                });
                var selected = Object(__WEBPACK_IMPORTED_MODULE_1__config__.h)(label), sources = Object(__WEBPACK_IMPORTED_MODULE_2__funding__.b)({
                    funding: funding,
                    selected: selected,
                    locale: locale,
                    env: env,
                    layout: layout
                }).slice(0, max), multiple = sources.length > 1;
                multiple && (branding = !0);
                tagline = enableTagline({
                    tagline: tagline,
                    branding: branding,
                    fundingicons: fundingicons,
                    layout: layout
                });
                return {
                    size: size,
                    label: label,
                    locale: locale,
                    color: color,
                    shape: shape,
                    branding: branding,
                    fundingicons: fundingicons,
                    tagline: tagline,
                    funding: funding,
                    layout: layout,
                    sources: sources,
                    max: max,
                    multiple: multiple,
                    env: env,
                    height: height,
                    cards: Object(__WEBPACK_IMPORTED_MODULE_2__funding__.a)({
                        funding: funding,
                        locale: locale
                    })
                };
            }
            __webpack_exports__.a = normalizeProps;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/components/button/templates/config.js"), __WEBPACK_IMPORTED_MODULE_2__funding__ = __webpack_require__("./src/components/button/templates/funding.js");
        },
        "./src/components/button/templates/style.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return BUTTON_RELATIVE_STYLE;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return BUTTON_STYLE;
            });
            var _BUTTON_STYLE, __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js"), BUTTON_RELATIVE_STYLE = {
                FUNDINGICONS: 100,
                TAGLINE: 50,
                VERTICAL_MARGIN: 30
            }, BUTTON_STYLE = (_BUTTON_STYLE = {}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__.i.TINY] = {
                defaultWidth: 75,
                defaultHeight: 25,
                minWidth: 75,
                maxWidth: 150,
                minHeight: 25,
                maxHeight: 30,
                allowFunding: !0,
                allowTagline: !1
            }, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__.i.SMALL] = {
                defaultWidth: 150,
                defaultHeight: 25,
                minWidth: 150,
                maxWidth: 200,
                minHeight: 25,
                maxHeight: 55,
                allowFunding: !0,
                allowTagline: !0
            }, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__.i.MEDIUM] = {
                defaultWidth: 250,
                defaultHeight: 35,
                minWidth: 200,
                maxWidth: 300,
                minHeight: 35,
                maxHeight: 55,
                allowFunding: !0,
                allowTagline: !0
            }, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__.i.LARGE] = {
                defaultWidth: 350,
                defaultHeight: 45,
                minWidth: 300,
                maxWidth: 500,
                minHeight: 30,
                maxHeight: 55,
                allowFunding: !0,
                allowTagline: !0
            }, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__.i.HUGE] = {
                defaultWidth: 500,
                defaultHeight: 55,
                minWidth: 500,
                maxWidth: 750,
                minHeight: 40,
                maxHeight: 55,
                allowFunding: !0,
                allowTagline: !0
            }, _BUTTON_STYLE);
        },
        "./src/components/checkout/component.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function addHeader(name, value) {
                if (window.$Api) return window.$Api.addHeader ? window.$Api.addHeader(name, value) : void 0;
            }
            function allowIframe() {
                if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib__.V)()) return !0;
                var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.l)(window);
                if (parentWindow && Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.u)(parentWindow)) return !0;
                var parentComponentWindow = window.xchild && window.xchild.getParentComponentWindow();
                return !(!parentComponentWindow || !Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__.u)(parentComponentWindow));
            }
            function enableCheckoutIframe() {
                delete Checkout.contexts.iframe;
                Checkout.contexts.iframe = !0;
            }
            __webpack_exports__.b = allowIframe;
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return Checkout;
            });
            __webpack_exports__.c = enableCheckoutIframe;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js"), __WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__ = (__webpack_require__("./node_modules/xcomponent/src/component/component/index.js"), 
            __webpack_require__("./node_modules/cross-domain-utils/src/index.js")), __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_7__compat__ = __webpack_require__("./src/compat/index.js"), __WEBPACK_IMPORTED_MODULE_8__templates__ = __webpack_require__("./src/components/checkout/templates/index.js"), __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("./src/components/checkout/util.js"), __WEBPACK_IMPORTED_MODULE_10__popupBridge__ = __webpack_require__("./src/components/checkout/popupBridge.js"), __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("./src/components/checkout/constants.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, Checkout = Object(__WEBPACK_IMPORTED_MODULE_2_xcomponent_src__.c)({
                tag: "paypal-checkout",
                name: "ppcheckout",
                scrolling: !0,
                buildUrl: function(props) {
                    var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                    if (!props.payment) throw new Error("Can not build url without payment prop");
                    return props.payment().then(function(token) {
                        if (!token) throw new Error("Expected payment id or token to be passed, got " + token);
                        return Object(__WEBPACK_IMPORTED_MODULE_9__util__.b)(env, props.fundingSource, token);
                    });
                },
                get unsafeRenderTo() {
                    return __WEBPACK_IMPORTED_MODULE_6__config__.n.env === __WEBPACK_IMPORTED_MODULE_6__config__.d.LOCAL;
                },
                get domain() {
                    var _extends2;
                    return _extends({}, __WEBPACK_IMPORTED_MODULE_6__config__.n.paypalDomains, (_extends2 = {}, 
                    _extends2[__WEBPACK_IMPORTED_MODULE_6__config__.d.LOCAL] = /^http:\/\/localhost.paypal.com:\d+$/, 
                    _extends2));
                },
                get bridgeUrl() {
                    return __WEBPACK_IMPORTED_MODULE_6__config__.n.metaFrameUrls;
                },
                get bridgeDomain() {
                    return __WEBPACK_IMPORTED_MODULE_6__config__.n.paypalDomains;
                },
                contexts: {
                    iframe: function() {
                        return !Object(__WEBPACK_IMPORTED_MODULE_5__lib__.V)();
                    }(),
                    popup: !0
                },
                get version() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__lib__.r)();
                },
                prerenderTemplate: __WEBPACK_IMPORTED_MODULE_8__templates__.a,
                containerTemplate: __WEBPACK_IMPORTED_MODULE_8__templates__.b,
                props: {
                    sessionID: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_5__lib__.s)();
                        },
                        queryParam: !0
                    },
                    buttonSessionID: {
                        type: "string",
                        required: !1,
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_5__lib__.i)();
                        },
                        queryParam: !0
                    },
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                        },
                        validate: function(env) {
                            if (!__WEBPACK_IMPORTED_MODULE_6__config__.n.paypalUrls[env]) throw new Error("Invalid env: " + env);
                        }
                    },
                    stage: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function(props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                            if (env === __WEBPACK_IMPORTED_MODULE_6__config__.d.STAGE || env === __WEBPACK_IMPORTED_MODULE_6__config__.d.LOCAL) return __WEBPACK_IMPORTED_MODULE_6__config__.n.stage;
                        }
                    },
                    locale: {
                        type: "string",
                        required: !1,
                        queryParam: "locale.x",
                        allowDelegate: !0,
                        def: function() {
                            var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_5__lib__.h)();
                            return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                        }
                    },
                    client: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {};
                        },
                        sendToChild: !1,
                        validate: function(client, props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__.n.env;
                            if (!client[env]) throw new Error("Client ID not found for env: " + env);
                            if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                        }
                    },
                    payment: {
                        type: "function",
                        required: !1,
                        memoize: !0,
                        promisify: !0,
                        queryParam: function(payment) {
                            return payment().then(function(token) {
                                return Object(__WEBPACK_IMPORTED_MODULE_9__util__.a)(token);
                            });
                        },
                        queryValue: function(payment) {
                            return payment();
                        },
                        childDecorate: function(payment) {
                            var token = Object(__WEBPACK_IMPORTED_MODULE_5__lib__.n)("token");
                            return token ? Object(__WEBPACK_IMPORTED_MODULE_5__lib__.G)(function() {
                                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(token);
                            }) : payment;
                        },
                        validate: function(payment, props) {
                            if (!payment && !props.url) throw new Error("Expected either props.payment or props.url to be passed");
                        },
                        alias: "billingAgreement"
                    },
                    style: {
                        type: "object",
                        required: !1,
                        allowDelegate: !0,
                        def: function() {
                            return {};
                        },
                        validate: function(style) {
                            if (style.overlayColor && style.overlayColor !== __WEBPACK_IMPORTED_MODULE_11__constants__.a.BLACK && style.overlayColor !== __WEBPACK_IMPORTED_MODULE_11__constants__.a.WHITE) throw new Error("Invalid background color: " + style.overlayColor);
                        }
                    },
                    commit: {
                        type: "boolean",
                        required: !1
                    },
                    experience: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {};
                        }
                    },
                    fundingSource: {
                        type: "string",
                        required: !1,
                        queryParam: !0
                    },
                    onAuthorize: {
                        type: "function",
                        required: !0,
                        once: !0,
                        decorate: function(original) {
                            if (original) return function(data) {
                                var _this = this, actions = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                data && !data.intent && Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p)("checkout_authorize_no_intent", {
                                    paymentID: data.paymentID,
                                    token: data.paymentToken
                                });
                                Checkout.contexts.iframe = !1;
                                var close = function() {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                        if (actions.close) return actions.close();
                                    }).then(function() {
                                        return _this.closeComponent();
                                    });
                                }, redirect = function(win, url) {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ Object(__WEBPACK_IMPORTED_MODULE_5__lib__.O)(win || window.top, url || data.returnUrl), close() ]);
                                };
                                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                    try {
                                        var isButton = -1 !== window.location.href.indexOf("/webapps/hermes/button"), isGuest = -1 !== _this.window.location.href.indexOf("/webapps/xoonboarding");
                                        if (isButton && isGuest) return Object(__WEBPACK_IMPORTED_MODULE_5__lib__.Q)({
                                            win: _this.window,
                                            method: "get",
                                            url: "/webapps/hermes/api/auth"
                                        }).then(function(result) {
                                            result && result.data && result.data.access_token && addHeader("x-paypal-internal-euat", result.data.access_token);
                                        }).catch(function() {});
                                    } catch (err) {}
                                }).then(function() {
                                    return original.call(_this, data, _extends({}, actions, {
                                        close: close,
                                        redirect: redirect
                                    }));
                                }).catch(function(err) {
                                    return _this.error(err);
                                }).finally(function() {
                                    return _this.close();
                                });
                            };
                        }
                    },
                    onAuth: {
                        type: "function",
                        required: !1,
                        sameDomain: !0
                    },
                    accessToken: {
                        type: "function",
                        required: !1
                    },
                    onCancel: {
                        type: "function",
                        required: !1,
                        once: !0,
                        noop: !0,
                        decorate: function(original) {
                            return function(data) {
                                var _this2 = this, actions = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                Checkout.contexts.iframe = !1;
                                var close = function() {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                        if (actions.close) return actions.close();
                                    }).then(function() {
                                        return _this2.closeComponent();
                                    });
                                }, redirect = function(win, url) {
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ Object(__WEBPACK_IMPORTED_MODULE_5__lib__.O)(win || window.top, url || data.cancelUrl), close() ]);
                                };
                                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                                    return original.call(_this2, data, _extends({}, actions, {
                                        close: close,
                                        redirect: redirect
                                    }));
                                }).finally(function() {
                                    _this2.close();
                                });
                            };
                        }
                    },
                    init: {
                        type: "function",
                        required: !1,
                        once: !0,
                        noop: !0,
                        decorate: function(original) {
                            return function(data) {
                                var _track;
                                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.j)("checkout_init");
                                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.STATE.CHECKOUT, 
                                _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__.e.TRANSITION.CHECKOUT_INIT, 
                                _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__.e.CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_6__config__.j.EC_TOKEN], 
                                _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.TOKEN] = data.paymentToken, _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.SELLER_ID] = data.merchantID, 
                                _track[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.CONTEXT_ID] = data.paymentToken, 
                                _track));
                                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.g)();
                                this.paymentToken = data.paymentToken;
                                this.cancelUrl = data.cancelUrl;
                                return original.apply(this, arguments);
                            };
                        }
                    },
                    onClose: {
                        type: "function",
                        required: !1,
                        once: !0,
                        promisify: !0,
                        noop: !0,
                        decorate: function(original) {
                            return function(reason) {
                                var onClose = original.apply(this, arguments), CLOSE_REASONS = __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__.a.CLOSE_REASONS, shouldCancel = this.props.onCancel && -1 !== [ CLOSE_REASONS.CLOSE_DETECTED, CLOSE_REASONS.USER_CLOSED ].indexOf(reason), hasDetails = this.paymentToken && this.cancelUrl;
                                if (shouldCancel && !hasDetails) {
                                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p)("close_no_token_cancelurl");
                                    return onClose;
                                }
                                if (shouldCancel) {
                                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.j)("close_trigger_cancel");
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.all([ onClose, this.props.onCancel({
                                        paymentToken: this.paymentToken,
                                        cancelUrl: this.cancelUrl
                                    }) ]).then(function() {
                                        return onClose;
                                    });
                                }
                                return onClose;
                            };
                        }
                    },
                    onError: {
                        type: "function",
                        required: !1,
                        promisify: !0,
                        noop: !0,
                        once: !0
                    },
                    fallback: {
                        type: "function",
                        required: !1,
                        once: !0,
                        def: function() {
                            return function(url) {
                                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p)("fallback", {
                                    url: url
                                });
                                if (Object(__WEBPACK_IMPORTED_MODULE_5__lib__.k)("allow_full_page_fallback")) {
                                    window.top.location = url;
                                    return this.close();
                                }
                                return Object(__WEBPACK_IMPORTED_MODULE_7__compat__.a)(this.props.onAuthorize);
                            };
                        }
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        get value() {
                            return __WEBPACK_IMPORTED_MODULE_6__config__.n.logLevel;
                        }
                    },
                    popupBridge: {
                        type: "object",
                        required: !1,
                        get value() {
                            return {
                                open: Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__.b)(),
                                awaitOpener: __WEBPACK_IMPORTED_MODULE_10__popupBridge__.a
                            };
                        }
                    },
                    test: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {
                                action: "checkout"
                            };
                        }
                    }
                },
                autoResize: {
                    width: !1,
                    height: !1
                },
                get dimensions() {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__lib__.w)() ? {
                        width: "100%",
                        height: "535px"
                    } : {
                        width: "450px",
                        height: "535px"
                    };
                }
            });
            Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__.c)(Checkout);
            if (Checkout.isChild()) {
                window.xprops.logLevel && Object(__WEBPACK_IMPORTED_MODULE_5__lib__.S)(window.xprops.logLevel);
                Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__.a)();
                window.xchild.onProps(function() {
                    Object(__WEBPACK_IMPORTED_MODULE_5__lib__.M)(window.xprops, "onAuthorize", function(_ref) {
                        var callOriginal = _ref.callOriginal, _ref$args = _ref.args, data = _ref$args[0];
                        if (data && !data.intent) {
                            Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p)("hermes_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            try {
                                var intent = window.injector.get("$CheckoutCartModel").instance(data.paymentToken).payment_action;
                                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.p)("hermes_intent", {
                                    paymentID: data.paymentID,
                                    token: data.paymentToken,
                                    intent: intent
                                });
                            } catch (err) {}
                            Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.i)();
                        }
                        return callOriginal();
                    });
                });
                if (!Object.assign) try {
                    Object.assign = __WEBPACK_IMPORTED_MODULE_5__lib__.f;
                } catch (err) {}
                __WEBPACK_IMPORTED_MODULE_5__lib__.d.then(function() {
                    if (window.injector) {
                        var $event = window.injector.get("$event");
                        if ($event) {
                            var experimentActive = !1, loggedComplete = !1;
                            $event.on("allLoaded", function() {
                                setTimeout(function() {
                                    var _throttle$logStart, payButton = document.querySelector(".buttons.reviewButton"), topPayButton = document.querySelector(".buttons.reviewButton.topReviewButton"), reviewSection = document.querySelector("section.review"), throttle = Object(__WEBPACK_IMPORTED_MODULE_5__lib__.u)("top_pay_button", 5e3), hash = window.location.hash, logComplete = function() {
                                        if (experimentActive && !loggedComplete && hash && -1 !== hash.indexOf("checkout/review")) {
                                            var _throttle$logComplete;
                                            throttle.logComplete((_throttle$logComplete = {}, _throttle$logComplete[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.FEED] = "hermesnodeweb", 
                                            _throttle$logComplete));
                                            loggedComplete = !0;
                                        }
                                    };
                                    payButton && payButton.addEventListener("click", logComplete);
                                    if (reviewSection && reviewSection.firstChild && payButton && !topPayButton && !(payButton.getBoundingClientRect().bottom < window.innerHeight)) {
                                        experimentActive = !0;
                                        throttle.logStart((_throttle$logStart = {}, _throttle$logStart[__WEBPACK_IMPORTED_MODULE_6__config__.e.KEY.FEED] = "hermesnodeweb", 
                                        _throttle$logStart));
                                        if (throttle.isEnabled()) {
                                            topPayButton = payButton.cloneNode(!0);
                                            topPayButton.className += " topReviewButton";
                                            reviewSection.insertBefore(topPayButton, reviewSection.firstChild);
                                            topPayButton.addEventListener("click", function() {
                                                logComplete();
                                                var button = payButton && payButton.querySelector("button, input");
                                                button && button.click();
                                            });
                                        }
                                    }
                                }, 200);
                            });
                        }
                    }
                });
            }
            Object(__WEBPACK_IMPORTED_MODULE_5__lib__.M)(Checkout, "init", function(_ref2) {
                var _ref2$args = _ref2.args, props = _ref2$args[0], _context = _ref2$args[1], original = _ref2.original, context = _ref2.context;
                return original.call(context, props, _context, "body");
            });
            Object(__WEBPACK_IMPORTED_MODULE_5__lib__.M)(Checkout, "render", function(_ref3) {
                var _ref3$args = _ref3.args, props = _ref3$args[0], original = _ref3.original, context = _ref3.context;
                return original.call(context, props, "body");
            });
            Object(__WEBPACK_IMPORTED_MODULE_5__lib__.M)(Checkout, "renderTo", function(_ref4) {
                var _ref4$args = _ref4.args, win = _ref4$args[0], props = _ref4$args[1], original = _ref4.original, context = _ref4.context, payment = props.payment();
                props.payment = function() {
                    return payment;
                };
                return original.call(context, win, props, "body").catch(function(err) {
                    if (err instanceof __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__.b && Object(__WEBPACK_IMPORTED_MODULE_5__lib__.D)()) {
                        Checkout.contexts.iframe = !0;
                        return original.call(context, win, props, "body");
                    }
                    throw err;
                });
            });
        },
        "./src/components/checkout/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return CHECKOUT_OVERLAY_COLOR;
            });
            var CHECKOUT_OVERLAY_COLOR = {
                BLACK: "black",
                WHITE: "white"
            };
        },
        "./src/components/checkout/hacks.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function type(field, chars) {
                var interval = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 50;
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a.try(function() {
                    field.value = field.value || "";
                    field.value = field.value += chars.slice(0, 1);
                    chars = chars.slice(1);
                    if (chars) return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a.delay(interval).then(function() {
                        return type(field, chars, interval);
                    });
                });
            }
            function waitForPageLoad() {
                return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a(function(resolve) {
                    var count = 1, interval = setInterval(function() {
                        count += 1;
                        if (count >= 50) return clearInterval(interval);
                        if (window.injector) {
                            clearInterval(interval);
                            return resolve(window.injector);
                        }
                    }, 500);
                }).then(function(injector) {
                    if (injector.get("$loader").isLoading()) return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a(function(resolve) {
                        return injector.get("$event").on("allLoaded", resolve);
                    });
                });
            }
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__ = __webpack_require__("./node_modules/zalgo-promise/src/promise.js"), __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("./src/components/checkout/component.js");
            try {
                (function(emailText, passwordText) {
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a.try(function() {
                        if (__WEBPACK_IMPORTED_MODULE_2__component__.a.isChild() && -1 !== window.location.href.indexOf("sandbox.paypal.com")) return waitForPageLoad().then(function() {
                            if (window.root && window.root.token && window.$CheckoutPayeeModel && "YQZCHTGHUK5P8" === window.$CheckoutPayeeModel.instance(window.root.token).merchant.id) {
                                var win = window.injectedUl || window, email = win.document.querySelector("#email"), password = win.document.querySelector("#password");
                                if (email && password) {
                                    email.value = "";
                                    password.value = "";
                                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__.a.try(function() {
                                        return type(email, emailText);
                                    }).then(function() {
                                        return type(password, passwordText);
                                    }).catch(__WEBPACK_IMPORTED_MODULE_1__lib__.H);
                                }
                            }
                        });
                    });
                })("sandbox-user@paypal.com", "passw0rd").catch(__WEBPACK_IMPORTED_MODULE_1__lib__.H);
            } catch (err) {}
        },
        "./src/components/checkout/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/checkout/component.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.b;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.c;
            });
            __webpack_require__("./src/components/checkout/hacks.js");
        },
        "./src/components/checkout/popupBridge.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function ternary(condition, truthyResult, falsyResult) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.resolve(condition).then(function(result) {
                    return result ? truthyResult() : falsyResult();
                });
            }
            function getPopupBridgeOpener() {
                var popupBridge = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.popupBridge;
                if (popupBridge) {
                    popupBridge.opener = popupBridge.opener || function(url, callback) {
                        if (!popupBridge) throw new Error("Popup Bridge not available");
                        popupBridge.onComplete = callback;
                        popupBridge.open(Object(__WEBPACK_IMPORTED_MODULE_3__lib__.g)(url, {
                            redirect_uri: popupBridge.getReturnUrlPrefix()
                        }));
                    };
                    return popupBridge.opener;
                }
                if (window.xprops && window.xprops.popupBridge && window.xprops.popupBridge.open) return window.xprops.popupBridge.open;
            }
            function awaitPopupBridgeOpener() {
                return window.xprops && window.xprops.popupBridge ? window.xprops.popupBridge.awaitOpener().then(function(opener) {
                    window.popupBridge = window.popupBridge || {};
                    window.popupBridge.opener = opener;
                    return opener;
                }) : Object(__WEBPACK_IMPORTED_MODULE_3__lib__.a)(window, "popupBridge").then(function(popupBridge) {
                    var opener = getPopupBridgeOpener(popupBridge);
                    if (opener) return opener;
                    throw new Error("Expected opener to be present");
                });
            }
            function renderThroughPopupBridge(props, openBridge) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                    if (!props.payment && !props.url) throw new Error("Expected props.payment or props.url to be passed");
                    if (!props.onAuthorize) throw new Error("Expected props.onAuthorize to be passed");
                    if (props.env && !__WEBPACK_IMPORTED_MODULE_4__config__.n.checkoutUrls[props.env]) throw new Error("Invalid props.env: " + props.env);
                    var env = props.env = props.env || __WEBPACK_IMPORTED_MODULE_4__config__.n.env, onAuthorize = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__.L)(props.onAuthorize), onCancel = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__.L)(props.onCancel || __WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__.I);
                    return ternary(props.url, function() {
                        return props.url;
                    }, function() {
                        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(props.payment, {
                            props: props
                        }).then(function(token) {
                            if (token) {
                                var _extendUrl;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.g)(Object(__WEBPACK_IMPORTED_MODULE_5__util__.b)(env, __WEBPACK_IMPORTED_MODULE_4__config__.f.PAYPAL, token), (_extendUrl = {}, 
                                _extendUrl[Object(__WEBPACK_IMPORTED_MODULE_5__util__.a)(token)] = token, _extendUrl.useraction = props.commit ? "commit" : "", 
                                _extendUrl.native_xo = "1", _extendUrl));
                            }
                        });
                    }).then(function(url) {
                        return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                            openBridge(url, function(err, payload) {
                                if (err) return reject(err);
                                if (!payload) return reject(new Error("No payload passed in popupBridge.onComplete"));
                                var query = payload.queryItems, data = {
                                    paymentToken: query.token,
                                    billingToken: query.ba_token,
                                    paymentID: query.paymentId,
                                    payerID: query.payerId,
                                    intent: query.intent
                                }, actions = {
                                    close: function() {},
                                    closeComponent: function() {}
                                };
                                if ("payment" === query.opType) {
                                    data.returnUrl = query.return_uri;
                                    actions.redirect = function() {
                                        var win = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window, redirectUrl = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : data.returnUrl;
                                        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.O)(win, redirectUrl);
                                    };
                                    onAuthorize(data, actions);
                                    resolve();
                                } else {
                                    if ("cancel" !== query.opType) return reject(new Error("Did not find opType in popup bridge returned query params"));
                                    data.cancelUrl = query.cancel_uri;
                                    actions.redirect = function() {
                                        var win = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window, redirectUrl = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : data.cancelUrl;
                                        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.O)(win, redirectUrl);
                                    };
                                    onCancel(data, actions);
                                    resolve();
                                }
                            });
                        });
                    });
                });
            }
            function setupPopupBridgeProxy(Checkout) {
                function doRender(props, original) {
                    var openBridge = getPopupBridgeOpener();
                    return openBridge ? renderThroughPopupBridge(props, openBridge).catch(function(err) {
                        Object(__WEBPACK_IMPORTED_MODULE_2_beaver_logger_client__.f)("popup_bridge_error", {
                            err: Object(__WEBPACK_IMPORTED_MODULE_3__lib__.T)(err)
                        });
                        return original();
                    }) : original();
                }
                var render = Checkout.render;
                Checkout.render = function(props) {
                    var _this = this, _arguments = arguments;
                    return doRender(props, function() {
                        return render.apply(_this, _arguments);
                    });
                };
                var renderTo = Checkout.renderTo;
                Checkout.renderTo = function(win, props) {
                    var _this2 = this, _arguments2 = arguments;
                    return doRender(props, function() {
                        return renderTo.apply(_this2, _arguments2);
                    });
                };
                var init = Checkout.init;
                Checkout.init = function(props) {
                    var instance = init.apply(this, arguments), _render = instance.render;
                    instance.render = function() {
                        var _this3 = this, _arguments3 = arguments;
                        return doRender(props, function() {
                            return _render.apply(_this3, _arguments3);
                        });
                    };
                    var _renderTo = instance.renderTo;
                    instance.renderTo = function() {
                        var _this4 = this, _arguments4 = arguments;
                        return doRender(props, function() {
                            return _renderTo.apply(_this4, _arguments4);
                        });
                    };
                    return instance;
                };
            }
            __webpack_exports__.b = getPopupBridgeOpener;
            __webpack_exports__.a = awaitPopupBridgeOpener;
            __webpack_exports__.c = setupPopupBridgeProxy;
            var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__("./src/components/checkout/util.js");
        },
        "./src/components/checkout/templates/component/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/checkout/templates/component/template.jsx");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__template__.a;
            });
        },
        "./src/components/checkout/templates/component/style.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return checkoutComponentStyle;
            });
            var checkoutComponentStyle = "\n\n    body {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0;\n    }\n\n    .spinner {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        z-index: 10\n    }\n\n    .spinner .spinWrap {\n        width: 200px;\n        height: 100px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -100px;\n        margin-top: -50px\n    }\n\n    .spinner .loader,\n    .spinner .spinnerImage {\n        height: 100px;\n        width: 100px;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        opacity: 1;\n        filter: alpha(opacity=100)\n    }\n\n    .spinner .spinnerImage {\n        margin: 28px 0 0 -25px;\n        background: url(https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png) no-repeat\n    }\n\n    .spinner .loader {\n        margin: 0 0 0 -55px;\n        background-color: transparent;\n        -webkit-animation: rotation .7s infinite linear;\n        -moz-animation: rotation .7s infinite linear;\n        -o-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        border-left: 5px solid #cbcbca;\n        border-right: 5px solid #cbcbca;\n        border-bottom: 5px solid #cbcbca;\n        border-top: 5px solid #2380be;\n        border-radius: 100%\n    }\n\n    @-webkit-keyframes rotation {\n        from {\n            -webkit-transform: rotate(0deg)\n        }\n        to {\n            -webkit-transform: rotate(359deg)\n        }\n    }\n    @-moz-keyframes rotation {\n        from {\n            -moz-transform: rotate(0deg)\n        }\n        to {\n            -moz-transform: rotate(359deg)\n        }\n    }\n    @-o-keyframes rotation {\n        from {\n            -o-transform: rotate(0deg)\n        }\n        to {\n            -o-transform: rotate(359deg)\n        }\n    }\n    @keyframes rotation {\n        from {\n            transform: rotate(0deg)\n        }\n        to {\n            transform: rotate(359deg)\n        }\n    }\n";
        },
        "./src/components/checkout/templates/component/template.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function componentTemplate(_ref) {
                var jsxDom = _ref.jsxDom;
                return jsxDom("html", null, jsxDom("head", null, jsxDom("title", null, "PayPal"), jsxDom("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1"
                })), jsxDom("body", null, jsxDom("div", {
                    class: "preloader spinner"
                }, jsxDom("style", null, __WEBPACK_IMPORTED_MODULE_0__style__.a), jsxDom("div", {
                    class: "spinWrap"
                }, jsxDom("p", {
                    class: "spinnerImage"
                }), jsxDom("p", {
                    class: "loader"
                })))));
            }
            __webpack_exports__.a = componentTemplate;
            var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__("./src/components/checkout/templates/component/style.js");
        },
        "./src/components/checkout/templates/container/content.json": function(module, exports) {
            module.exports = '\n{\n    "AT": {\n        "de": {\n            "windowMessage": "Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.",\n            "continue": "Weiter"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ZW": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ZM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ZA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "YT": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "YE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "WS": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "WF": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "VU": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "VG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "VE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "VC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "VA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "UY": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "UG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TV": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "TT": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "TO": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "TN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "TM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TJ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "TD": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "TC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "SZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SV": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "ST": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SR": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "SO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "SM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SL": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SJ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SH": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "SB": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "SA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "RW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "RS": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "RE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "QA": {\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        },\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PY": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "PW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "PN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "PM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "PF": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "PA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "OM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "NU": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "NR": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "NP": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "NI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "NG": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "NF": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "NE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "NC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "NA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MV": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "MU": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MT": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MS": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "MR": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MQ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MN": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "ML": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "MK": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MH": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "MG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ME": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MD": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MC": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "MA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "LS": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "LK": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "LI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "LC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "LA": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "KZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "KY": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "KW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "KN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "KM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "KI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "KH": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "KG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "KE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "JO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "JM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "IS": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "HR": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "HN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "GY": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "GW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GT": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "GP": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "GM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GL": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "da": {\n            "windowMessage": "Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.",\n            "continue": "Forts\\u00E6t"\n        }\n    },\n    "GI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GF": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GD": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "GA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "FO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "da": {\n            "windowMessage": "Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.",\n            "continue": "Forts\\u00E6t"\n        }\n    },\n    "FM": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "FK": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "FJ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "ET": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ER": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "EG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "EC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "DZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "DO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "DM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "DJ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "CY": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "CV": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "CR": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "CO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "CM": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "CL": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "CK": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "CI": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "CG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "CD": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "BZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "BY": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "BW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "BT": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "BS": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "BO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "BN": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "BM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "BJ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "BI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "BH": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "BG": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "BF": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        }\n    },\n    "BB": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "BA": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AW": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "AO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "AM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AL": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "AG": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "AE": {\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        },\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AD": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "CN": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        }\n    },\n    "GB": {\n        "fr": {\n            "windowMessage": "Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\'ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AR": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        }\n    },\n    "US": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Click to Continue"\n        }\n    },\n    "VN": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.  ",\n            "continue": "Continue"\n        }\n    },\n    "UA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 ",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TW": {\n        "zh": {\n            "windowMessage": "\\u770B\\u4E0D\\u5230\\u5B89\\u5168\\u9023\\u7DDA\\u7684 PayPal \\u700F\\u89BD\\u5668\\uFF1F\\u6211\\u5011\\u5C07\\u6703\\u91CD\\u65B0\\u555F\\u52D5\\u8996\\u7A97\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 ",\n            "continue": "\\u7E7C\\u7E8C"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TR": {\n        "tr": {\n            "windowMessage": "G\\u00FCvenli PayPal taray\\u0131c\\u0131s\\u0131n\\u0131 g\\u00F6rm\\u00FCyor musunuz? Al\\u0131\\u015Fveri\\u015Finizi tamamlamak i\\u00E7in pencereyi yeniden ba\\u015Flatman\\u0131za yard\\u0131mc\\u0131 olaca\\u011F\\u0131z.\\u00A0 ",\n            "continue": "Devam"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "TH": {\n        "th": {\n            "windowMessage": "\\u0E16\\u0E49\\u0E32\\u0E04\\u0E38\\u0E13\\u0E44\\u0E21\\u0E48\\u0E40\\u0E2B\\u0E47\\u0E19\\u0E40\\u0E1A\\u0E23\\u0E32\\u0E27\\u0E4C\\u0E40\\u0E0B\\u0E2D\\u0E23\\u0E4C\\u0E17\\u0E35\\u0E48\\u0E21\\u0E35\\u0E23\\u0E30\\u0E1A\\u0E1A\\u0E04\\u0E27\\u0E32\\u0E21\\u0E1B\\u0E25\\u0E2D\\u0E14\\u0E20\\u0E31\\u0E22\\u0E02\\u0E2D\\u0E07 PayPal \\u0E40\\u0E23\\u0E32\\u0E08\\u0E30\\u0E0A\\u0E48\\u0E27\\u0E22\\u0E04\\u0E38\\u0E13\\u0E40\\u0E1B\\u0E34\\u0E14\\u0E2B\\u0E19\\u0E49\\u0E32\\u0E15\\u0E48\\u0E32\\u0E07\\u0E2D\\u0E35\\u0E01\\u0E04\\u0E23\\u0E31\\u0E49\\u0E07\\u0E40\\u0E1E\\u0E37\\u0E48\\u0E2D\\u0E0A\\u0E33\\u0E23\\u0E30\\u0E40\\u0E07\\u0E34\\u0E19\\u0E43\\u0E2B\\u0E49\\u0E40\\u0E23\\u0E35\\u0E22\\u0E1A\\u0E23\\u0E49\\u0E2D\\u0E22 ",\n            "continue": "\\u0E14\\u0E33\\u0E40\\u0E19\\u0E34\\u0E19\\u0E01\\u0E32\\u0E23\\u0E15\\u0E48\\u0E2D"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SK": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SG": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "SE": {\n        "sv": {\n            "windowMessage": "Ser du inte den s\\u00E4kra PayPal-webbl\\u00E4saren? Vi hj\\u00E4lper dig att starta om f\\u00F6nstret f\\u00F6r att slutf\\u00F6ra ditt k\\u00F6p. ",\n            "continue": "Forts\\u00E4tt"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "RU": {\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "RO": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PT": {\n        "pt": {\n            "windowMessage": "N\\u00E3o v\\u00EA a indica\\u00E7\\u00E3o de sess\\u00E3o segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PL": {\n        "pl": {\n            "windowMessage": "Nie widzisz bezpiecznej przegl\\u0105darki PayPal? Pomo\\u017Cemy Ci ponownie uruchomi\\u0107 to okno w celu dokonania zakupu.\\u00A0 ",\n            "continue": "Kontynuuj"\n        },\n        "en": {\n            "windowMessage": "You don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "PH": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "NZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre paiement.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar su pago.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "NO": {\n        "no": {\n            "windowMessage": "Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med \\u00E5 starte vinduet p\\u00E5 nytt s\\u00E5 du kan fullf\\u00F8re kj\\u00F8pet.\\u00A0 ",\n            "continue": "Fortsett"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "NL": {\n        "nl": {\n            "windowMessage": "Ziet u geen beveiligde PayPal-browser? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.\\u00A0 ",\n            "continue": "Doorgaan"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MY": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "MX": {\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "LV": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 ",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "LU": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "de": {\n            "windowMessage": "Das PayPal-Fenster wird nicht angezeigt? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.",\n            "continue": "Weiter"\n        }\n    },\n    "LT": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 ",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "KR": {\n        "ko": {\n            "windowMessage": "\\uBCF4\\uC548 PayPal \\uBE0C\\uB77C\\uC6B0\\uC800\\uAC00 \\uBCF4\\uC774\\uC9C0 \\uC54A\\uC73C\\uC2E0\\uAC00\\uC694? \\uCC3D\\uC744 \\uB2E4\\uC2DC \\uC2E4\\uD589\\uD558\\uC5EC \\uACB0\\uC81C\\uB97C \\uC644\\uB8CC\\uD560 \\uC218 \\uC788\\uB3C4\\uB85D \\uB3C4\\uC640\\uB4DC\\uB9AC\\uACA0\\uC2B5\\uB2C8\\uB2E4.\\u00A0 ",\n            "continue": "\\uACC4\\uC18D"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "JP": {\n        "ja": {\n            "windowMessage": "\\u30BB\\u30AD\\u30E5\\u30A2\\u306A\\u30D6\\u30E9\\u30A6\\u30B6\\u304C\\u8868\\u793A\\u3055\\u308C\\u306A\\u3044\\u5834\\u5408\\u306F\\u3001\\u30A6\\u30A3\\u30F3\\u30C9\\u30A6\\u3092\\u518D\\u8D77\\u52D5\\u3057\\u3066\\u3001\\u652F\\u6255\\u3044\\u3092\\u5B8C\\u4E86\\u3067\\u304D\\u308B\\u3088\\u3046\\u304A\\u624B\\u4F1D\\u3044\\u3044\\u305F\\u3057\\u307E\\u3059\\u3002",\n            "continue": "\\u7D9A\\u884C"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.  ",\n            "continue": "Continue"\n        }\n    },\n    "IT": {\n        "it": {\n            "windowMessage": "Non vedi la pagina sicura di PayPal? Ti aiuteremo a riaprire la finestra per completare l\'acquisto.\\u00A0 ",\n            "continue": "Continua"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "IN": {\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "IL": {\n        "he": {\n            "windowMessage": "\\u05DC\\u05D0 \\u05E8\\u05D5\\u05D0\\u05D4 \\u05D0\\u05EA \\u05D3\\u05E4\\u05D3\\u05E4\\u05DF PayPal \\u05D4\\u05DE\\u05D0\\u05D5\\u05D1\\u05D8\\u05D7? \\u05E0\\u05E2\\u05D6\\u05D5\\u05E8 \\u05DC\\u05DA \\u05DC\\u05E4\\u05EA\\u05D5\\u05D7 \\u05DE\\u05D7\\u05D3\\u05E9 \\u05D0\\u05EA \\u05D4\\u05D7\\u05DC\\u05D5\\u05DF \\u05DB\\u05D3\\u05D9 \\u05DC\\u05D4\\u05E9\\u05DC\\u05D9\\u05DD \\u05D0\\u05EA \\u05D4\\u05E7\\u05E0\\u05D9\\u05D9\\u05D4 \\u05E9\\u05DC\\u05DA.\\u00A0 ",\n            "continue": "\\u05D4\\u05DE\\u05E9\\u05DA"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "IE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "HU": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ID": {\n        "id": {\n            "windowMessage": "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembayaran Anda.\\u00A0 ",\n            "continue": "Lanjutkan"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "HK": {\n        "zh": {\n            "windowMessage": "\\u770B\\u4E0D\\u5230\\u5B89\\u5168\\u7684 PayPal \\u700F\\u89BD\\u5668\\u8996\\u7A97\\uFF1F\\u6211\\u5011\\u6703\\u52A9\\u4F60\\u91CD\\u65B0\\u958B\\u555F\\u8996\\u7A97\\uFF0C\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002",\n            "continue": "\\u7E7C\\u7E8C"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "GROUP-LATAM": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.",\n            "continue": "Continue"\n        }\n    },\n    "GROUP-EMEA": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 ",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "pt": {\n            "windowMessage": "N\\u00E3o v\\u00EA a indica\\u00E7\\u00E3o de sess\\u00E3o segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",\n            "continue": "Continuar"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "de": {\n            "windowMessage": "Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.",\n            "continue": "Weiter"\n        },\n        "da": {\n            "windowMessage": "Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.",\n            "continue": "Forts\\u00E6t"\n        },\n        "ar": {\n            "windowMessage": "\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 ",\n            "continue": "\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629"\n        }\n    },\n    "GROUP-APAC": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ko": {\n            "windowMessage": "\\uBCF4\\uC548 PayPal \\uBE0C\\uB77C\\uC6B0\\uC800\\uAC00 \\uBCF4\\uC774\\uC9C0 \\uC54A\\uC73C\\uC2E0\\uAC00\\uC694? \\uCC3D\\uC744 \\uB2E4\\uC2DC \\uC2E4\\uD589\\uD558\\uC5EC \\uAD6C\\uB9E4\\uB97C \\uC644\\uB8CC\\uD560 \\uC218 \\uC788\\uB3C4\\uB85D \\uB3C4\\uC640\\uB4DC\\uB9AC\\uACA0\\uC2B5\\uB2C8\\uB2E4. ",\n            "continue": "\\uACC4\\uC18D"\n        },\n        "id": {\n            "windowMessage": "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembelian Anda. ",\n            "continue": "Lanjutkan"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. ",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  ",\n            "continue": "Continue"\n        }\n    },\n    "GR": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "FR": {\n        "fr": {\n            "windowMessage": "Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "ES": {\n        "es": {\n            "windowMessage": "\\u00BFNo ve el s\\u00EDmbolo de navegaci\\u00F3n segura de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar la compra. ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "FI": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "EE": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "ru": {\n            "windowMessage": "\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 ",\n            "continue": "\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "DK": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "da": {\n            "windowMessage": "Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.",\n            "continue": "Forts\\u00E6t"\n        }\n    },\n    "CZ": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "fr": {\n            "windowMessage": "Le navigateur s\\u00E9curis\\u00E9 de PayPal n\'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.",\n            "continue": "Continuer"\n        },\n        "es": {\n            "windowMessage": "\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "DE": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "de": {\n            "windowMessage": "Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.",\n            "continue": "Weiter"\n        }\n    },\n    "CH": {\n        "fr": {\n            "windowMessage": "Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        },\n        "de": {\n            "windowMessage": "Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.",\n            "continue": "Weiter"\n        }\n    },\n    "CA": {\n        "fr": {\n            "windowMessage": "Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 de PayPal\\u00A0? Nous vous aiderons \\u00E0 relancer la fen\\u00EAtre afin d\'effectuer votre achat.\\u00A0 ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you relaunch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "C2": {\n        "zh": {\n            "windowMessage": "\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 ",\n            "continue": "\\u7EE7\\u7EED"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "BE": {\n        "nl": {\n            "windowMessage": "Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.\\u00A0 ",\n            "continue": "Doorgaan"\n        },\n        "fr": {\n            "windowMessage": "Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 ",\n            "continue": "Continuer"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "BR": {\n        "pt": {\n            "windowMessage": "N\\u00E3o est\\u00E1 vendo o navegador seguro do PayPal? Ajudaremos voc\\u00EA a reabrir a janela para concluir a compra.\\u00A0 ",\n            "continue": "Continuar"\n        },\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    },\n    "AU": {\n        "en": {\n            "windowMessage": "Don\'t see the secure PayPal browser? We\'ll help you re-launch the window to complete your purchase.\\u00A0 ",\n            "continue": "Continue"\n        }\n    }\n}\n';
        },
        "./src/components/checkout/templates/container/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/checkout/templates/container/template.jsx");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__template__.a;
            });
        },
        "./src/components/checkout/templates/container/style.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getSandboxStyle(_ref) {
                var id = _ref.id, ANIMATION = _ref.ANIMATION;
                return "\n        #" + id + ".paypal-checkout-sandbox {\n            display: block;\n            position: fixed;\n            top: 0;\n            left: 0;\n\n            width: 100%;\n            height: 100%;\n            width: 100vw;\n            height: 100vh;\n            max-width: 100%;\n            max-height: 100%;\n            min-width: 100%;\n            min-height: 100%;\n\n            z-index: 2147483647;\n\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n\n            animation-fill-mode:forwards;\n            animation-iteration-count: 1;\n\n            -webkit-animation-fill-mode:forwards;\n            -webkit-animation-iteration-count: 1;\n        }\n\n        #" + id + ".paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n    ";
            }
            function getContainerStyle(_ref2) {
                var id = _ref2.id, tag = _ref2.tag, CONTEXT = _ref2.CONTEXT, CLASS = _ref2.CLASS, ANIMATION = _ref2.ANIMATION;
                return "\n        #" + id + " {\n            position: absolute;\n            z-index: 2147483647;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            -webkit-transform: translate3d(0, 0, 0);\n            -moz-transform: translate3d(0, 0, 0);\n            -ms-transform: translate3d(0, 0, 0);\n            -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.BLACK + " {\n            background-color: black;\n            background-color: rgba(0, 0, 0, 0.8);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.WHITE + " {\n            background-color: white;\n            background-color: rgba(255, 255, 255, 0.4);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.BLACK + " a {\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.WHITE + " a {\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.BLACK + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.BLACK + " .paypal-checkout-close:after {\n            background-color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.WHITE + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + __WEBPACK_IMPORTED_MODULE_0__constants__.a.WHITE + " .paypal-checkout-close:after {\n            background-color: #111;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + " a {\n            text-decoration: none;\n        }\n\n        #" + id + ' .paypal-checkout-modal {\n            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;\n            font-size: 14px;\n            text-align: center;\n\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -ms-box-sizing: border-box;\n            box-sizing: border-box;\n            width: 350px;\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            margin-left: -165px;\n            margin-top: -80px;\n            cursor: pointer;\n            text-align: center;\n        }\n\n        #' + id + "." + tag + "-loading .paypal-checkout-message, #" + id + "." + tag + "-loading .paypal-checkout-continue {\n            display: none;\n        }\n\n        .paypal-checkout-loader {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-loader {\n            display: block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo {\n            cursor: pointer;\n            margin-bottom: 30px;\n            display: inline-block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img {\n            height: 36px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img.paypal-checkout-logo-pp {\n            margin-right: 10px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-message {\n            font-size: 15px;\n            line-height: 1.5;\n            padding: 10px 0;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-message, #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-continue {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue {\n            font-size: 15px;\n            line-height: 1.35;\n            padding: 10px 0;\n            font-weight: bold;\n        }\n\n        #" + id + " .paypal-checkout-close {\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            width: 16px;\n            height: 16px;\n            opacity: 0.6;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-close {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-close:hover {\n            opacity: 1;\n        }\n\n        #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n            position: absolute;\n            left: 8px;\n            content: ' ';\n            height: 16px;\n            width: 2px;\n        }\n\n        #" + id + " .paypal-checkout-close:before {\n            transform: rotate(45deg);\n            -webkit-transform: rotate(45deg);\n            -moz-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n        }\n\n        #" + id + " .paypal-checkout-close:after {\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n            -moz-transform: rotate(-45deg);\n            -o-transform: rotate(-45deg);\n            -ms-transform: rotate(-45deg);\n        }\n\n        #" + id + " .paypal-checkout-iframe-container {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + ",\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + " > iframe {\n            max-height: 95vh;\n            max-width: 95vw;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container {\n\n            display: block;\n\n            position: absolute;\n\n            top: 50%;\n            left: 50%;\n\n            min-width: 450px;\n\n            transform: translate(-50%, -50%);\n            -webkit-transform: translate(-50%, -50%);\n            -moz-transform: translate(-50%, -50%);\n            -o-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n\n            transform: translate3d(-50%, -50%, 0);\n            -webkit-transform: translate3d(-50%, -50%, 0);\n            -moz-transform: translate3d(-50%, -50%, 0);\n            -o-transform: translate3d(-50%, -50%, 0);\n            -ms-transform: translate3d(-50%, -50%, 0);\n\n            border-radius: 10px;\n            overflow: hidden;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n\n            position: relative;\n\n            -webkit-transition: all 0.3s ease;\n            -moz-transition: all 0.3s ease;\n            -ms-transition: all 0.3s ease;\n            -o-transition: all 0.3 ease;\n            transition: all 0.3s ease;\n\n            -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n\n            min-width: 450px;\n            max-width: 450px;\n            width: 450px;\n            height: 535px;\n\n            background-color: white;\n\n            overflow: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: opacity .4s ease-in-out;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n            z-index: 100;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n            opacity: 1;\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n            opacity: 0;\n            z-index: 100;\n        }\n\n        @media screen and (max-width: 470px) {\n\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                min-width: 100%;\n                min-width: calc(100% - 20px);\n                min-width: -webkit-calc(100% - 20px);\n                min-width: -moz-calc(100% - 20px);\n                min-width: -o-calc(100% - 20px);\n                min-width: -ms-calc(100% - 20px);\n\n                max-width: 100%;\n                max-width: calc(100% - 20px);\n                max-width: -webkit-calc(100% - 20px);\n                max-width: -moz-calc(100% - 20px);\n                max-width: -o-calc(100% - 20px);\n                max-width: -ms-calc(100% - 20px);\n            }\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " iframe {\n            width: 1px;\n            min-width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        .paypal-spinner {\n            height: 30px;\n            width: 30px;\n            display: inline-block;\n            box-sizing: content-box;\n            opacity: 1;\n            filter: alpha(opacity=100);\n            -webkit-animation: rotation .7s infinite linear;\n            -moz-animation: rotation .7s infinite linear;\n            -o-animation: rotation .7s infinite linear;\n            animation: rotation .7s infinite linear;\n            border-left: 8px solid rgba(0, 0, 0, .2);\n            border-right: 8px solid rgba(0, 0, 0, .2);\n            border-bottom: 8px solid rgba(0, 0, 0, .2);\n            border-top: 8px solid #fff;\n            border-radius: 100%\n        }\n\n        @-webkit-keyframes rotation {\n            from {\n                -webkit-transform: rotate(0deg)\n            }\n            to {\n                -webkit-transform: rotate(359deg)\n            }\n        }\n        @-moz-keyframes rotation {\n            from {\n                -moz-transform: rotate(0deg)\n            }\n            to {\n                -moz-transform: rotate(359deg)\n            }\n        }\n        @-o-keyframes rotation {\n            from {\n                -o-transform: rotate(0deg)\n            }\n            to {\n                -o-transform: rotate(359deg)\n            }\n        }\n        @keyframes rotation {\n            from {\n                transform: rotate(0deg)\n            }\n            to {\n                transform: rotate(359deg)\n            }\n        }\n    ";
            }
            __webpack_exports__.b = getSandboxStyle;
            __webpack_exports__.a = getContainerStyle;
            var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/checkout/constants.js");
        },
        "./src/components/checkout/templates/container/template.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function containerTemplate(_ref) {
                function close(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    actions.close();
                }
                function focus(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    Object(__WEBPACK_IMPORTED_MODULE_4__lib__.C)() ? window.alert("Please switch tabs to reactivate the PayPal window") : actions.focus();
                }
                var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _props$locale$split = props.locale.split("_"), lang = _props$locale$split[0], country = _props$locale$split[1], content = componentContent[country][lang], style = props.style || {}, overlayColor = style.overlayColor || __WEBPACK_IMPORTED_MODULE_3__constants__.a.BLACK, logoColor = LOGO_COLOR[overlayColor], el = jsxDom("div", {
                    id: id,
                    onClick: focus,
                    class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor
                }, jsxDom("a", {
                    href: "#",
                    class: "paypal-checkout-close",
                    onClick: close
                }), jsxDom("div", {
                    class: "paypal-checkout-modal"
                }, jsxDom("div", {
                    class: "paypal-checkout-logo"
                }, jsxDom("img", {
                    class: "paypal-checkout-logo-pp",
                    alt: "pp",
                    src: "data:image/svg+xml;base64," + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__.btoa)(__WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__.b.pp[logoColor])
                }), jsxDom("img", {
                    class: "paypal-checkout-logo-paypal",
                    alt: "paypal",
                    src: "data:image/svg+xml;base64," + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__.btoa)(__WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__.b.paypal[logoColor])
                })), jsxDom("div", {
                    class: "paypal-checkout-message"
                }, content.windowMessage), jsxDom("div", {
                    class: "paypal-checkout-continue"
                }, jsxDom("a", {
                    onClick: focus,
                    href: "#"
                }, content.continue)), jsxDom("div", {
                    class: "paypal-checkout-loader"
                }, jsxDom("div", {
                    class: "paypal-spinner"
                }))), jsxDom("div", {
                    class: "paypal-checkout-iframe-container"
                }, outlet), jsxDom("style", null, Object(__WEBPACK_IMPORTED_MODULE_6__style__.a)({
                    id: id,
                    tag: tag,
                    CONTEXT: CONTEXT,
                    CLASS: CLASS,
                    ANIMATION: ANIMATION
                }))), container = jsxDom("html", null, jsxDom("body", null, el));
                on(EVENT.CLOSE, function() {
                    el.className += " " + tag + "-loading";
                });
                return jsxDom("div", {
                    id: id,
                    class: "paypal-checkout-sandbox"
                }, jsxDom("style", null, Object(__WEBPACK_IMPORTED_MODULE_6__style__.b)({
                    id: id,
                    ANIMATION: ANIMATION
                })), jsxDom("iframe", {
                    name: "__paypal_checkout_sandbox_" + id + "__",
                    scrolling: "no",
                    class: "paypal-checkout-sandbox-iframe"
                }, container));
            }
            __webpack_exports__.a = containerTemplate;
            var _LOGO_COLOR, __WEBPACK_IMPORTED_MODULE_0_Base64__ = __webpack_require__("./node_modules/Base64/base64.js"), __WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__ = (__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Base64__), 
            __webpack_require__("./src/components/button/templates/component/logos/index.js")), __WEBPACK_IMPORTED_MODULE_2__button_constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./src/components/checkout/constants.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_5__content_json__ = __webpack_require__("./src/components/checkout/templates/container/content.json"), __WEBPACK_IMPORTED_MODULE_5__content_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__content_json__), __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__("./src/components/checkout/templates/container/style.js"), componentContent = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__content_json___default.a), LOGO_COLOR = (_LOGO_COLOR = {}, 
            _LOGO_COLOR[__WEBPACK_IMPORTED_MODULE_3__constants__.a.BLACK] = __WEBPACK_IMPORTED_MODULE_2__button_constants__.f.WHITE, 
            _LOGO_COLOR[__WEBPACK_IMPORTED_MODULE_3__constants__.a.WHITE] = __WEBPACK_IMPORTED_MODULE_2__button_constants__.f.BLACK, 
            _LOGO_COLOR);
        },
        "./src/components/checkout/templates/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/checkout/templates/component/index.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__component__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./src/components/checkout/templates/container/index.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__container__.a;
            });
        },
        "./src/components/checkout/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function determineParameterFromToken(token) {
                return token && 0 === token.indexOf("BA-") ? "ba_token" : "token";
            }
            function getPaymentType(payment) {
                return 0 === payment.indexOf("BA-") ? __WEBPACK_IMPORTED_MODULE_1__config__.j.BA_TOKEN : 0 === payment.indexOf("PAY-") || 0 === payment.indexOf("PAYID-") ? __WEBPACK_IMPORTED_MODULE_1__config__.j.PAY_ID : (payment.indexOf("EC-"), 
                __WEBPACK_IMPORTED_MODULE_1__config__.j.EC_TOKEN);
            }
            function determineUrl(env, fundingSource, payment) {
                return getPaymentType(payment) === __WEBPACK_IMPORTED_MODULE_1__config__.j.BA_TOKEN ? __WEBPACK_IMPORTED_MODULE_1__config__.n.billingUrls[env] : fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__.f.CARD || fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__.f.ELV ? __WEBPACK_IMPORTED_MODULE_1__config__.n.guestUrls[env] : fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__.f.IDEAL ? __WEBPACK_IMPORTED_MODULE_1__config__.n.altpayUrls[env] : __WEBPACK_IMPORTED_MODULE_1__config__.n.checkoutUrls[env];
            }
            __webpack_exports__.a = determineParameterFromToken;
            __webpack_exports__.c = getPaymentType;
            __webpack_exports__.b = determineUrl;
            var __WEBPACK_IMPORTED_MODULE_1__config__ = (__webpack_require__("./src/lib/index.js"), 
            __webpack_require__("./src/config/index.js"));
        },
        "./src/components/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__("./src/components/button/index.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_0__button__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__checkout__ = __webpack_require__("./src/components/checkout/index.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__checkout__.a;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_1__checkout__.b;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_1__checkout__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_2__login__ = __webpack_require__("./src/components/login/index.js");
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_2__login__.a;
            });
        },
        "./src/components/login/component.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return Login;
            });
            var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__checkout_templates__ = __webpack_require__("./src/components/checkout/templates/index.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js"), Login = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src__.c)({
                tag: "paypal-checkout-login",
                scrolling: !0,
                get url() {
                    return __WEBPACK_IMPORTED_MODULE_2__config__.n.loginUrls;
                },
                get bridgeUrl() {
                    return __WEBPACK_IMPORTED_MODULE_2__config__.n.metaFrameUrls;
                },
                get bridgeDomain() {
                    return __WEBPACK_IMPORTED_MODULE_2__config__.n.paypalDomains;
                },
                defaultEnv: __WEBPACK_IMPORTED_MODULE_2__config__.d.PRODUCTION,
                contexts: {
                    iframe: !1,
                    popup: !0
                },
                dimensions: {
                    width: "450px",
                    height: "535px"
                },
                get version() {
                    return Object(__WEBPACK_IMPORTED_MODULE_4__lib__.r)();
                },
                sandboxContainer: !0,
                prerenderTemplate: __WEBPACK_IMPORTED_MODULE_3__checkout_templates__.a,
                containerTemplate: __WEBPACK_IMPORTED_MODULE_3__checkout_templates__.b,
                props: {
                    sessionID: {
                        type: "string",
                        value: Object(__WEBPACK_IMPORTED_MODULE_4__lib__.s)(),
                        def: function() {
                            return Object(__WEBPACK_IMPORTED_MODULE_4__lib__.s)();
                        },
                        queryParam: !0
                    },
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return __WEBPACK_IMPORTED_MODULE_2__config__.n.env;
                        },
                        validate: function(env) {
                            if (!__WEBPACK_IMPORTED_MODULE_2__config__.n.paypalUrls[env]) throw new Error("Invalid env: " + env);
                        }
                    },
                    style: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {};
                        }
                    },
                    locale: {
                        type: "string",
                        required: !1,
                        queryParam: "locale.x",
                        allowDelegate: !0,
                        def: function() {
                            var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_4__lib__.h)();
                            return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                        }
                    },
                    stage: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function(props) {
                            var env = props.env || __WEBPACK_IMPORTED_MODULE_2__config__.n.env;
                            if (env === __WEBPACK_IMPORTED_MODULE_2__config__.d.STAGE || env === __WEBPACK_IMPORTED_MODULE_2__config__.d.LOCAL) return __WEBPACK_IMPORTED_MODULE_2__config__.n.stage;
                        }
                    },
                    onAuthenticate: {
                        type: "function",
                        required: !0,
                        decorate: function(original) {
                            if (original) return function(data) {
                                var _this = this;
                                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                                    return original.call(_this, data);
                                }).catch(function(err) {
                                    return _this.error(err);
                                }).finally(function() {
                                    return _this.close();
                                });
                            };
                        }
                    },
                    onCancel: {
                        type: "function",
                        required: !1,
                        once: !0,
                        noop: !0,
                        decorate: function(original) {
                            if (original) return function(data) {
                                var _this2 = this;
                                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                                    return original.call(_this2, data);
                                }).catch(function(err) {
                                    return _this2.error(err);
                                }).finally(function() {
                                    _this2.close();
                                });
                            };
                        }
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        get value() {
                            return __WEBPACK_IMPORTED_MODULE_2__config__.n.logLevel;
                        }
                    },
                    test: {
                        type: "object",
                        required: !1,
                        def: function() {
                            return {
                                action: "login"
                            };
                        }
                    }
                },
                autoResize: {
                    width: !1,
                    height: !1
                }
            });
        },
        "./src/components/login/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_1__component__ = (__webpack_require__("./src/components/login/prerender.js"), 
            __webpack_require__("./src/components/login/component.js"));
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_1__component__.a;
            });
        },
        "./src/components/login/prerender.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./src/components/login/component.js"), prerender = __WEBPACK_IMPORTED_MODULE_1__component__.a.prerender;
            __WEBPACK_IMPORTED_MODULE_1__component__.a.prerender = function(props) {
                var component = prerender.apply(this, arguments), env = props && props.env || __WEBPACK_IMPORTED_MODULE_0__config__.n.env;
                component.html = component.html.then(function(html) {
                    return "\n            " + html + '\n\n            <script src="' + __WEBPACK_IMPORTED_MODULE_0__config__.n.scriptUrl + "\" async><\/script>\n\n            <script>\n                (function() {\n\n                    function ajaxifyForms() {\n                        Array.prototype.slice.call(document.querySelectorAll('form')).forEach(function(form) {\n                            form.addEventListener('submit', function(event) {\n                                event.preventDefault();\n\n                                var data = {};\n\n                                Array.prototype.slice.call(form.elements).forEach(function(el) {\n\n                                    if (el.disabled || !el.name) {\n                                        return;\n                                    }\n\n                                    if (['file', 'reset', 'submit', 'button'].indexOf(el.type) !== -1) {\n                                        return;\n                                    }\n\n                                    var value;\n\n                                    if (['checkbox', 'radio'].indexOf(el.type) !== -1 && el.checked) {\n                                        value = 'on';\n                                    } else {\n                                        value = el.value;\n                                    }\n\n                                    data[el.name] = value;\n                                });\n\n                                var serializedData = Object.keys(data).map(function(key) {\n                                    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])\n                                }).join('&').replace(/%20/g, '+');\n\n                                var req = new XMLHttpRequest();\n                                req.open(form.method || 'GET', '" + __WEBPACK_IMPORTED_MODULE_0__config__.n.paypalUrls[env] + "' + form.getAttribute('action'));\n                                req.setRequestHeader('Accept', 'application/json');\n                                req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');\n                                req.setRequestHeader('x-csrf-token', data._csrf);\n                                req.setRequestHeader('is-inline-ul', 'true');\n                                req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');\n                                req.send(serializedData);\n\n                                req.onload = function() {\n                                    if (req.status !== 200) {\n                                        return window.xchild.error(new Error('Login returned status: ' + req.status));\n                                    }\n\n                                    var data;\n\n                                    try {\n                                        data = JSON.parse(req.responseText);\n                                    } catch (err) {\n                                        return window.xchild.error(err + '\\n\\n' + req.responseText);\n                                    }\n\n                                    if (data.htmlResponse) {\n                                        document.write(data.htmlResponse);\n                                        return setTimeout(ajaxifyForms);\n                                    }\n\n                                    if (!data || !data.accessToken) {\n                                        return window.xchild.error('Could not find access token: \\n\\n' + JSON.stringify(data, null, 2));\n                                    }\n\n                                    window.xprops.onAuthenticate({\n                                        accessToken: data.accessToken\n                                    });\n                                };\n\n                                req.onerror = function() {\n                                    return window.xchild.error(new Error('Login error'));\n                                };\n                            });\n                        });\n                    }\n\n                    ajaxifyForms();\n\n                })();\n            <\/script>\n        ";
                });
                return component;
            };
        },
        "./src/config/config.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return config;
            });
            var _checkoutUris, _altpayUris, _guestUris, _billingUris, _buttonUris, _postBridgeUris, _legacyCheckoutUris, _buttonJSUrls, _locales, __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/config/constants.js"), config = {
                scriptUrl: "//www.paypalobjects.com/api/checkout.lib.js",
                paypal_domain_regex: /^(https?|mock):\/\/[a-zA-Z0-9_.-]+\.paypal\.com(:\d+)?$/,
                version: "4.0.173",
                cors: !0,
                env: __WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION,
                state: "checkoutjs",
                locale: {
                    country: __WEBPACK_IMPORTED_MODULE_0__constants__.d.US,
                    lang: __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN
                },
                stage: "msmaster",
                merchantID: "",
                logLevel: "warn",
                throttles: {
                    v4_mobile_device: 0
                },
                domain_settings: {
                    "walmart.com": {
                        log_domain_prefix: !0,
                        ie_full_page: !1,
                        allow_full_page_fallback: !0,
                        memoize_payment: !0,
                        force_bridge: !0,
                        log_authorize: !0,
                        disable_payment_timeout: !0
                    },
                    "ulta.com": {
                        disable_venmo: !0
                    },
                    "barnesandnoble.com": {
                        disable_venmo: !0
                    },
                    "bn.com": {
                        disable_venmo: !0
                    },
                    "agoratix.com": {
                        disable_venmo: !0
                    },
                    "tractorsupply.com": {
                        disable_venmo: !0
                    },
                    "etsy.com": {
                        log_domain_prefix: !0,
                        ie_full_page: !1,
                        allow_full_page_fallback: !0,
                        memoize_payment: !0,
                        force_bridge: !0,
                        log_authorize: !0,
                        disable_payment_timeout: !0
                    },
                    "ticketmaster.com": {
                        disable_venmo: !0
                    },
                    "livenation.com": {
                        disable_venmo: !0
                    },
                    "frontgatetickets.com": {
                        disable_venmo: !0
                    }
                },
                customCountry: !1,
                SUPPORTED_BROWSERS: {
                    msie: "9",
                    firefox: "30",
                    chrome: "27",
                    safari: "5.1",
                    opera: "16",
                    msedge: "12",
                    samsungBrowser: "2.1",
                    silk: "59.3",
                    ucbrowser: "10.0.0.488",
                    vivaldi: "1.91"
                },
                session_uid_lifetime: 3e5,
                _apiStage: "",
                get apiStage() {
                    return config._apiStage || config.stage;
                },
                set apiStage(value) {
                    config._apiStage = value;
                },
                ports: {
                    default: 8e3,
                    button: 8e3,
                    checkout: 8e3,
                    guest: 8001,
                    altpay: 3e3
                },
                get paypalUrls() {
                    var _ref;
                    return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "http://localhost.paypal.com:" + config.ports.default, 
                    _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "https://www." + config.stage + ".qa.paypal.com", 
                    _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "https://www.sandbox.paypal.com", 
                    _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "https://www.paypal.com", 
                    _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = window.location.protocol + "//" + window.location.host, 
                    _ref[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                    _ref;
                },
                get paypalDomains() {
                    var _ref2;
                    return _ref2 = {}, _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "http://localhost.paypal.com:" + config.ports.default, 
                    _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "https://www." + config.stage + ".qa.paypal.com", 
                    _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "https://www.sandbox.paypal.com", 
                    _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "https://www.paypal.com", 
                    _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "mock://www.paypal.com", 
                    _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                    _ref2;
                },
                get wwwApiUrls() {
                    var _ref3;
                    return _ref3 = {}, _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "https://www." + config.stage + ".qa.paypal.com", 
                    _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "https://www." + config.stage + ".qa.paypal.com", 
                    _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "https://www.sandbox.paypal.com", 
                    _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "https://www.paypal.com", 
                    _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = window.location.protocol + "//" + window.location.host, 
                    _ref3;
                },
                get corsApiUrls() {
                    var _ref4;
                    return _ref4 = {}, _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "https://" + config.apiStage + ".qa.paypal.com:11888", 
                    _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "https://" + config.apiStage + ".qa.paypal.com:11888", 
                    _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "https://cors.api.sandbox.paypal.com", 
                    _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "https://cors.api.paypal.com", 
                    _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = window.location.protocol + "//" + window.location.host, 
                    _ref4;
                },
                get apiUrls() {
                    var _ref5, domain = window.location.protocol + "//" + window.location.host, corsApiUrls = config.corsApiUrls, wwwApiUrls = config.wwwApiUrls;
                    return _ref5 = {}, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = domain === wwwApiUrls.local ? wwwApiUrls.local : corsApiUrls.local, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = domain === wwwApiUrls.stage ? wwwApiUrls.stage : corsApiUrls.stage, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = domain === wwwApiUrls.sandbox ? wwwApiUrls.sandbox : corsApiUrls.sandbox, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = domain === wwwApiUrls.production ? wwwApiUrls.production : corsApiUrls.production, 
                    _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = domain === wwwApiUrls.test ? wwwApiUrls.test : corsApiUrls.test, 
                    _ref5;
                },
                checkoutUris: (_checkoutUris = {}, _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/webapps/hermes?ul=0", 
                _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/webapps/hermes", 
                _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/checkoutnow", 
                _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/checkoutnow", 
                _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
                _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/checkout.htm", 
                _checkoutUris),
                altpayUris: (_altpayUris = {}, _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/latinumcheckout", 
                _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/latinumcheckout", 
                _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/latinumcheckout", 
                _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/latinumcheckout", 
                _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
                _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/checkout.htm", 
                _altpayUris),
                guestUris: (_guestUris = {}, _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/webapps/xoonboarding", 
                _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/webapps/xoonboarding", 
                _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/webapps/xoonboarding", 
                _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/webapps/xoonboarding", 
                _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/checkout/index.htm?guesturl=true", 
                _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/guest.htm", 
                _guestUris),
                billingUris: (_billingUris = {}, _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/webapps/hermes/agreements?ul=0", 
                _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/webapps/hermes/agreements", 
                _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/agreements/approve", 
                _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/agreements/approve", 
                _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/checkout/index.htm?billingurl=true", 
                _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/checkout.htm", 
                _billingUris),
                buttonUris: (_buttonUris = {}, _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/webapps/hermes/button", 
                _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/webapps/hermes/button", 
                _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/webapps/hermes/button", 
                _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/webapps/hermes/button", 
                _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/button/index.htm", 
                _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/button.htm", 
                _buttonUris),
                postBridgeUris: (_postBridgeUris = {}, _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/webapps/hermes/component-meta", 
                _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/webapps/hermes/component-meta", 
                _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/webapps/hermes/component-meta", 
                _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/webapps/hermes/component-meta", 
                _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/windows/component-meta/index.htm", 
                _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "/demo/dev/bridge.htm", 
                _postBridgeUris),
                legacyCheckoutUris: (_legacyCheckoutUris = {}, _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
                _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
                _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
                _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
                _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "#fallback", 
                _legacyCheckoutUris),
                buttonJSUrls: (_buttonJSUrls = {}, _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "https://www.paypalobjects.com/api/button.js", 
                _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "https://www.paypalobjects.com/api/button.js", 
                _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "https://www.paypalobjects.com/api/button.js", 
                _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "https://www.paypalobjects.com/api/button.js", 
                _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "/base/test/lib/button.js", 
                _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "https://www.paypalobjects.com/api/button.js", 
                _buttonJSUrls),
                get buttonJSUrl() {
                    return config.buttonJSUrls[config.env];
                },
                loginUri: "/signin/",
                loggerUri: "/webapps/hermes/api/logger",
                pptmUri: "/tagmanager/pptm.js",
                get postBridgeUri() {
                    return config.postBridgeUris[config.env] + "?xcomponent=1";
                },
                paymentStandardUri: "/webapps/xorouter?cmd=_s-xclick",
                authApiUri: "/v1/oauth2/token",
                paymentApiUri: "/v1/payments/payment",
                orderApiUri: "/v1/checkout/orders",
                billingApiUri: "/v1/billing-agreements/agreement-tokens",
                experienceApiUri: "/v1/payment-experience/web-profiles",
                get checkoutUrls() {
                    var _ref6, paypalUrls = config.paypalUrls;
                    return _ref6 = {}, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local + config.checkoutUris.local.replace(":" + config.ports.default, ":" + config.ports.checkout), 
                    _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.checkoutUris.stage, 
                    _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.checkoutUris.sandbox, 
                    _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.checkoutUris.production, 
                    _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.checkoutUris.test, 
                    _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.test + config.checkoutUris.demo, 
                    _ref6;
                },
                get guestUrls() {
                    var _ref7, paypalUrls = config.paypalUrls;
                    return _ref7 = {}, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.guest) + config.guestUris.local, 
                    _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.guestUris.stage, 
                    _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.guestUris.sandbox, 
                    _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.guestUris.production, 
                    _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.guestUris.test, 
                    _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.test + config.guestUris.demo, 
                    _ref7;
                },
                get altpayUrls() {
                    var _ref8, paypalUrls = config.paypalUrls;
                    return _ref8 = {}, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.altpay) + config.altpayUris.local, 
                    _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.altpayUris.stage, 
                    _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.altpayUris.sandbox, 
                    _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.altpayUris.production, 
                    _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.altpayUris.test, 
                    _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.test + config.altpayUris.demo, 
                    _ref8;
                },
                get billingUrls() {
                    var _ref9, paypalUrls = config.paypalUrls;
                    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.checkout) + config.billingUris.local, 
                    _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.billingUris.stage, 
                    _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.billingUris.sandbox, 
                    _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.billingUris.production, 
                    _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.billingUris.test, 
                    _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.test + config.billingUris.demo, 
                    _ref9;
                },
                get buttonUrls() {
                    var _ref10, paypalUrls = config.paypalUrls;
                    return _ref10 = {}, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.buttonUris.local, 
                    _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.buttonUris.stage, 
                    _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.buttonUris.sandbox, 
                    _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.buttonUris.production, 
                    _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.buttonUris.test, 
                    _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.demo + config.buttonUris.demo, 
                    _ref10;
                },
                get loginUrls() {
                    var _ref11, paypalUrls = config.paypalUrls;
                    return _ref11 = {}, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.stage + config.loginUri, 
                    _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.loginUri, 
                    _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.loginUri, 
                    _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.loginUri, 
                    _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.loginUri, 
                    _ref11;
                },
                get paymentsStandardUrls() {
                    var _ref12, paypalUrls = config.paypalUrls;
                    return _ref12 = {}, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local + config.paymentStandardUri, 
                    _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.paymentStandardUri, 
                    _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.paymentStandardUri, 
                    _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.paymentStandardUri, 
                    _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.paymentStandardUri, 
                    _ref12;
                },
                get metaFrameUrls() {
                    var _ref13, paypalUrls = config.paypalUrls;
                    return _ref13 = {}, _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.local + config.postBridgeUri + "&env=local", 
                    _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.postBridgeUri + "&env=stage&stage=" + config.stage, 
                    _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.postBridgeUri + "&env=sandbox", 
                    _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.postBridgeUri + "&env=production", 
                    _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.postBridgeUri + "&env=test", 
                    _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__.e.DEMO] = "" + paypalUrls.demo + config.postBridgeUri + "&env=demo", 
                    _ref13;
                },
                get legacyCheckoutUrls() {
                    var _ref14, paypalUrls = config.paypalUrls;
                    return _ref14 = {}, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + paypalUrls.stage + config.legacyCheckoutUris.local, 
                    _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + paypalUrls.stage + config.legacyCheckoutUris.stage, 
                    _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + paypalUrls.sandbox + config.legacyCheckoutUris.sandbox, 
                    _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + paypalUrls.production + config.legacyCheckoutUris.production, 
                    _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + paypalUrls.test + config.legacyCheckoutUris.test, 
                    _ref14;
                },
                get authApiUrls() {
                    var _ref15, apiUrls = config.apiUrls, authApiUri = config.authApiUri;
                    return _ref15 = {}, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + apiUrls.local + authApiUri, 
                    _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + apiUrls.stage + authApiUri, 
                    _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + apiUrls.sandbox + authApiUri, 
                    _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + apiUrls.production + authApiUri, 
                    _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + apiUrls.test + authApiUri, 
                    _ref15;
                },
                get paymentApiUrls() {
                    var _ref16, apiUrls = config.apiUrls, paymentApiUri = config.paymentApiUri;
                    return _ref16 = {}, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + apiUrls.local + paymentApiUri, 
                    _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + apiUrls.stage + paymentApiUri, 
                    _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + apiUrls.sandbox + paymentApiUri, 
                    _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + apiUrls.production + paymentApiUri, 
                    _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + apiUrls.test + paymentApiUri, 
                    _ref16;
                },
                get orderApiUrls() {
                    var _ref17, apiUrls = config.apiUrls, orderApiUri = config.orderApiUri;
                    return _ref17 = {}, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + apiUrls.local + orderApiUri, 
                    _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + apiUrls.stage + orderApiUri, 
                    _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + apiUrls.sandbox + orderApiUri, 
                    _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + apiUrls.production + orderApiUri, 
                    _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + apiUrls.test + orderApiUri, 
                    _ref17;
                },
                get billingApiUrls() {
                    var _ref18, apiUrls = config.apiUrls, billingApiUri = config.billingApiUri;
                    return _ref18 = {}, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + apiUrls.local + billingApiUri, 
                    _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + apiUrls.stage + billingApiUri, 
                    _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + apiUrls.sandbox + billingApiUri, 
                    _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + apiUrls.production + billingApiUri, 
                    _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + apiUrls.test + billingApiUri, 
                    _ref18;
                },
                get experienceApiUrls() {
                    var _ref19, apiUrls = config.apiUrls, experienceApiUri = config.experienceApiUri;
                    return _ref19 = {}, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL] = "" + apiUrls.local + experienceApiUri, 
                    _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] = "" + apiUrls.stage + experienceApiUri, 
                    _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__.e.SANDBOX] = "" + apiUrls.sandbox + experienceApiUri, 
                    _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__.e.PRODUCTION] = "" + apiUrls.production + experienceApiUri, 
                    _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__.e.TEST] = "" + apiUrls.test + experienceApiUri, 
                    _ref19;
                },
                _paypalUrl: "",
                get paypalUrl() {
                    return this._paypalUrl || config.paypalUrls[config.env];
                },
                set paypalUrl(value) {
                    this._paypalUrl = value;
                },
                get paypalDomain() {
                    return config.paypalDomains[config.env];
                },
                get corsApiUrl() {
                    return config.corsApiUrls[config.env];
                },
                get wwwApiUrl() {
                    return config.wwwApiUrls[config.env];
                },
                get apiUrl() {
                    var domain = window.location.protocol + "//" + window.location.host, corsApiUrl = config.corsApiUrl, wwwApiUrl = config.wwwApiUrl;
                    return domain === wwwApiUrl ? wwwApiUrl : corsApiUrl;
                },
                get checkoutUrl() {
                    return "" + config.paypalUrl + config.checkoutUris[config.env];
                },
                get billingUrl() {
                    return "" + config.paypalUrl + config.billingUris[config.env];
                },
                get buttonUrl() {
                    return "" + config.paypalUrl + config.buttonUris[config.env];
                },
                get legacyCheckoutUrl() {
                    return config.legacyCheckoutUrls[config.env];
                },
                get postBridgeUrl() {
                    return "" + config.paypalUrl + config.postBridgeUri;
                },
                get postBridgeDomain() {
                    return "" + config.paypalDomain;
                },
                get loggerUrl() {
                    return "" + config.paypalUrl + config.loggerUri;
                },
                get pptmUrl() {
                    return "" + (config.env === __WEBPACK_IMPORTED_MODULE_0__constants__.e.LOCAL ? config.paypalUrls[__WEBPACK_IMPORTED_MODULE_0__constants__.e.STAGE] : config.paypalUrl) + config.pptmUri;
                },
                get authApiUrl() {
                    return "" + config.apiUrl + config.authApiUri;
                },
                get paymentApiUrl() {
                    return "" + config.apiUrl + config.paymentApiUri;
                },
                get orderApiUrl() {
                    return "" + config.apiUrl + config.orderApiUri;
                },
                get billingApiUrl() {
                    return "" + config.apiUrl + config.billingApiUri;
                },
                get experienceApiUrl() {
                    return "" + config.apiUrl + config.experienceApiUri;
                },
                defaultLocale: {
                    country: __WEBPACK_IMPORTED_MODULE_0__constants__.d.US,
                    lang: __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN
                },
                locales: (_locales = {}, _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AD] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH, __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DE, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.AZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BB] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.NL, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BF] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BJ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.PT, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.BZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.C2] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CD] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DE, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CV] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.CZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DE, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DJ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DA, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.DZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.EC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.EE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.RU, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.EG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ER] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ES] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ET] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FJ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DA, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.FR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GB] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GD] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GF] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.DA, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GP] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.HK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.HN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.HR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.HU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ID] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ID, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.IE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.IL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.HE, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.IN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.IS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.IT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.IT, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.JM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.JO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.JP] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.JA, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.KO, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.KZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.RU, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.DE, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.LV] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.RU, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MD] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ME] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ML] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MQ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MV] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MX] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.MZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NF] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.NL, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.NO, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NP] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.NZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.OM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PF] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.PL, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.PT, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.PY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.QA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH, __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.RE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.RO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.RS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.RU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.RU, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.RW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SB] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.SV, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SI] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SJ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SK] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SL] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ST] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SV] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TD] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TH] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.TH, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TJ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TO] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TR] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.TR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TV] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.TZ] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.UA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.RU, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.UG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.US] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.UY] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VC] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VG] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VN] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.VU] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.WF] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.WS] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.YE] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.AR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.YT] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ZA] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ZM] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN, __WEBPACK_IMPORTED_MODULE_0__constants__.h.FR, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ES, __WEBPACK_IMPORTED_MODULE_0__constants__.h.ZH ], 
                _locales[__WEBPACK_IMPORTED_MODULE_0__constants__.d.ZW] = [ __WEBPACK_IMPORTED_MODULE_0__constants__.h.EN ], 
                _locales)
            };
        },
        "./src/config/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return ENV;
            });
            __webpack_require__.d(__webpack_exports__, "o", function() {
                return USERS;
            });
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return SOURCE;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return LOG_LEVEL;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return PAYMENT_TYPE;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return FPTI;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return PPTM_ID;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return FUNDING;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return CARD;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return CARD_PRIORITY;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return ATTRIBUTE;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return PLATFORM;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return COUNTRY;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return LANG;
            });
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return LANG_TO_DEFAULT_COUNTRY;
            });
            var _CONTEXT_TYPE, _LANG_TO_DEFAULT_COUN, ENV = {
                LOCAL: "local",
                STAGE: "stage",
                SANDBOX: "sandbox",
                PRODUCTION: "production",
                TEST: "test",
                DEMO: "demo"
            }, USERS = {
                ALL: "all",
                REMEMBERED: "remembered"
            }, SOURCE = {
                MANUAL: "manual",
                BUTTON_FACTORY: "button_factory"
            }, LOG_LEVEL = {
                DEBUG: "debug",
                INFO: "info",
                WARN: "warn",
                ERROR: "error"
            }, PAYMENT_TYPE = {
                EC_TOKEN: "ec_token",
                BA_TOKEN: "ba_token",
                PAY_ID: "pay_id"
            }, FPTI = {
                KEY: {
                    FEED: "feed_name",
                    STATE: "state_name",
                    TRANSITION: "transition_name",
                    BUTTON_TYPE: "button_type",
                    SESSION_UID: "page_session_id",
                    BUTTON_SESSION_UID: "button_session_id",
                    TOKEN: "token",
                    CONTEXT_ID: "context_id",
                    CONTEXT_TYPE: "context_type",
                    REFERER: "referer_url",
                    PAY_ID: "pay_id",
                    SELLER_ID: "seller_id",
                    DATA_SOURCE: "serverside_data_source",
                    BUTTON_SOURCE: "button_source",
                    ERROR_CODE: "ext_error_code",
                    ERROR_DESC: "ext_error_desc",
                    PAGE_LOAD_TIME: "page_load_time",
                    EXPERIMENT_NAME: "pxp_exp_id",
                    TREATMENT_NAME: "pxp_trtmnt_id",
                    TRANSITION_TIME: "transition_time",
                    FUNDING_LIST: "eligible_payment_methods",
                    FUNDING_COUNT: "eligible_payment_count",
                    CHOSEN_FUNDING: "selected_payment_method",
                    BUTTON_LAYOUT: "button_layout",
                    VERSION: "checkoutjs_version"
                },
                BUTTON_TYPE: {
                    IFRAME: "iframe",
                    HTML: "html",
                    CUSTOM: "custom"
                },
                DATA_SOURCE: {
                    CHECKOUT: "checkout"
                },
                CONTEXT_TYPE: (_CONTEXT_TYPE = {
                    BUTTON_SESSION_ID: "button_session_id"
                }, _CONTEXT_TYPE[PAYMENT_TYPE.PAY_ID] = "Pay-ID", _CONTEXT_TYPE[PAYMENT_TYPE.EC_TOKEN] = "EC-Token", 
                _CONTEXT_TYPE[PAYMENT_TYPE.BA_TOKEN] = "EC-Token", _CONTEXT_TYPE),
                FEED: {
                    CHECKOUTJS: "checkoutjs"
                },
                STATE: {
                    LOAD: "checkoutjs_load",
                    BUTTON: "checkoutjs_button",
                    CHECKOUT: "checkoutjs_checkout",
                    PPTM: "checkoutjs_pptm",
                    PXP: "PXP_CHECK"
                },
                TRANSITION: {
                    SCRIPT_LOAD: "process_script_load",
                    BUTTON_RENDER: "process_button_render",
                    BUTTON_LOAD: "process_button_load",
                    BUTTON_CLICK: "process_button_click",
                    CREATE_PAYMENT: "process_create_payment",
                    RECIEVE_PAYMENT: "process_recieve_payment",
                    CHECKOUT_INIT: "process_checkout_init",
                    CHECKOUT_AUTHORIZE: "process_checkout_authorize",
                    CHECKOUT_CANCEL: "process_checkout_cancel",
                    CHECKOUT_ERROR: "process_checkout_error",
                    EXTERNAL_EXPERIMENT: "process_external_experiment",
                    EXTERNAL_EXPERIMENT_COMPLETE: "process_external_experiment_complete",
                    PPTM_LOAD: "process_pptm_load",
                    PPTM_LOADED: "process_pptm_loaded",
                    PXP: "process_pxp_check"
                }
            }, PPTM_ID = "xo-pptm", FUNDING = {
                PAYPAL: "paypal",
                VENMO: "venmo",
                CREDIT: "credit",
                CARD: "card",
                IDEAL: "ideal",
                ELV: "elv"
            }, CARD = {
                VISA: "visa",
                MASTERCARD: "mastercard",
                AMEX: "amex",
                DISCOVER: "discover",
                SWITCH: "switch",
                MAESTRO: "maestro",
                HIPER: "hiper",
                ELO: "elo",
                JCB: "jcb",
                CUP: "cup",
                COFINOGA: "cofinoga",
                COFIDIS: "cofidis",
                CETELEM: "cetelem",
                CBNATIONALE: "cbnationale"
            }, CARD_PRIORITY = [ CARD.VISA, CARD.MASTERCARD, CARD.AMEX, CARD.DISCOVER, CARD.SWITCH, CARD.MAESTRO, CARD.HIPER, CARD.ELO, CARD.JCB, CARD.CUP, CARD.COFINOGA, CARD.COFIDIS, CARD.CETELEM, CARD.CBNATIONALE ], ATTRIBUTE = {
                BUTTON: "data-button",
                FUNDING_SOURCE: "data-funding-source",
                CARD: "data-card",
                VERSION: "data-version"
            }, PLATFORM = {
                DESKTOP: "desktop",
                MOBILE: "mobile"
            }, COUNTRY = {
                AD: "AD",
                AE: "AE",
                AG: "AG",
                AI: "AI",
                AL: "AL",
                AM: "AM",
                AN: "AN",
                AO: "AO",
                AR: "AR",
                AT: "AT",
                AU: "AU",
                AW: "AW",
                AZ: "AZ",
                BA: "BA",
                BB: "BB",
                BE: "BE",
                BF: "BF",
                BG: "BG",
                BH: "BH",
                BI: "BI",
                BJ: "BJ",
                BM: "BM",
                BN: "BN",
                BO: "BO",
                BR: "BR",
                BS: "BS",
                BT: "BT",
                BW: "BW",
                BY: "BY",
                BZ: "BZ",
                C2: "C2",
                CA: "CA",
                CD: "CD",
                CG: "CG",
                CH: "CH",
                CI: "CI",
                CK: "CK",
                CL: "CL",
                CM: "CM",
                CN: "CN",
                CO: "CO",
                CR: "CR",
                CV: "CV",
                CY: "CY",
                CZ: "CZ",
                DE: "DE",
                DJ: "DJ",
                DK: "DK",
                DM: "DM",
                DO: "DO",
                DZ: "DZ",
                EC: "EC",
                EE: "EE",
                EG: "EG",
                ER: "ER",
                ES: "ES",
                ET: "ET",
                FI: "FI",
                FJ: "FJ",
                FK: "FK",
                FM: "FM",
                FO: "FO",
                FR: "FR",
                GA: "GA",
                GB: "GB",
                GD: "GD",
                GE: "GE",
                GF: "GF",
                GI: "GI",
                GL: "GL",
                GM: "GM",
                GN: "GN",
                GP: "GP",
                GR: "GR",
                GT: "GT",
                GW: "GW",
                GY: "GY",
                HK: "HK",
                HN: "HN",
                HR: "HR",
                HU: "HU",
                ID: "ID",
                IE: "IE",
                IL: "IL",
                IN: "IN",
                IS: "IS",
                IT: "IT",
                JM: "JM",
                JO: "JO",
                JP: "JP",
                KE: "KE",
                KG: "KG",
                KH: "KH",
                KI: "KI",
                KM: "KM",
                KN: "KN",
                KR: "KR",
                KW: "KW",
                KY: "KY",
                KZ: "KZ",
                LA: "LA",
                LC: "LC",
                LI: "LI",
                LK: "LK",
                LS: "LS",
                LT: "LT",
                LU: "LU",
                LV: "LV",
                MA: "MA",
                MC: "MC",
                MD: "MD",
                ME: "ME",
                MG: "MG",
                MH: "MH",
                MK: "MK",
                ML: "ML",
                MN: "MN",
                MQ: "MQ",
                MR: "MR",
                MS: "MS",
                MT: "MT",
                MU: "MU",
                MV: "MV",
                MW: "MW",
                MX: "MX",
                MY: "MY",
                MZ: "MZ",
                NA: "NA",
                NC: "NC",
                NE: "NE",
                NF: "NF",
                NG: "NG",
                NI: "NI",
                NL: "NL",
                NO: "NO",
                NP: "NP",
                NR: "NR",
                NU: "NU",
                NZ: "NZ",
                OM: "OM",
                PA: "PA",
                PE: "PE",
                PF: "PF",
                PG: "PG",
                PH: "PH",
                PL: "PL",
                PM: "PM",
                PN: "PN",
                PT: "PT",
                PW: "PW",
                PY: "PY",
                QA: "QA",
                RE: "RE",
                RO: "RO",
                RS: "RS",
                RU: "RU",
                RW: "RW",
                SA: "SA",
                SB: "SB",
                SC: "SC",
                SE: "SE",
                SG: "SG",
                SH: "SH",
                SI: "SI",
                SJ: "SJ",
                SK: "SK",
                SL: "SL",
                SM: "SM",
                SN: "SN",
                SO: "SO",
                SR: "SR",
                ST: "ST",
                SV: "SV",
                SZ: "SZ",
                TC: "TC",
                TD: "TD",
                TG: "TG",
                TH: "TH",
                TJ: "TJ",
                TM: "TM",
                TN: "TN",
                TO: "TO",
                TR: "TR",
                TT: "TT",
                TV: "TV",
                TW: "TW",
                TZ: "TZ",
                UA: "UA",
                UG: "UG",
                US: "US",
                UY: "UY",
                VA: "VA",
                VC: "VC",
                VE: "VE",
                VG: "VG",
                VN: "VN",
                VU: "VU",
                WF: "WF",
                WS: "WS",
                YE: "YE",
                YT: "YT",
                ZA: "ZA",
                ZM: "ZM",
                ZW: "ZW"
            }, LANG = {
                EN: "en",
                FR: "fr",
                ES: "es",
                ZH: "zh",
                AR: "ar",
                DE: "de",
                NL: "nl",
                PT: "pt",
                DA: "da",
                RU: "ru",
                ID: "id",
                HE: "he",
                IT: "it",
                JA: "ja",
                KO: "ko",
                NO: "no",
                PL: "pl",
                SV: "sv",
                TH: "th",
                TR: "tr"
            }, LANG_TO_DEFAULT_COUNTRY = (_LANG_TO_DEFAULT_COUN = {}, _LANG_TO_DEFAULT_COUN[LANG.EN] = COUNTRY.US, 
            _LANG_TO_DEFAULT_COUN[LANG.FR] = COUNTRY.FR, _LANG_TO_DEFAULT_COUN[LANG.ES] = COUNTRY.ES, 
            _LANG_TO_DEFAULT_COUN[LANG.ZH] = COUNTRY.CN, _LANG_TO_DEFAULT_COUN[LANG.DE] = COUNTRY.DE, 
            _LANG_TO_DEFAULT_COUN[LANG.NL] = COUNTRY.NL, _LANG_TO_DEFAULT_COUN[LANG.PT] = COUNTRY.PT, 
            _LANG_TO_DEFAULT_COUN[LANG.DA] = COUNTRY.DK, _LANG_TO_DEFAULT_COUN[LANG.RU] = COUNTRY.RU, 
            _LANG_TO_DEFAULT_COUN[LANG.ID] = COUNTRY.ID, _LANG_TO_DEFAULT_COUN[LANG.HE] = COUNTRY.IL, 
            _LANG_TO_DEFAULT_COUN[LANG.IT] = COUNTRY.IT, _LANG_TO_DEFAULT_COUN[LANG.JA] = COUNTRY.JP, 
            _LANG_TO_DEFAULT_COUN[LANG.KO] = COUNTRY.KR, _LANG_TO_DEFAULT_COUN[LANG.NO] = COUNTRY.NO, 
            _LANG_TO_DEFAULT_COUN[LANG.PL] = COUNTRY.PL, _LANG_TO_DEFAULT_COUN[LANG.SV] = COUNTRY.SE, 
            _LANG_TO_DEFAULT_COUN[LANG.TH] = COUNTRY.TH, _LANG_TO_DEFAULT_COUN[LANG.TR] = COUNTRY.TR, 
            _LANG_TO_DEFAULT_COUN);
        },
        "./src/config/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/config.js");
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return __WEBPACK_IMPORTED_MODULE_0__config__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/config/constants.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.a;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.b;
            });
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.d;
            });
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.e;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.f;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.g;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.h;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.i;
            });
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.j;
            });
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.k;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.m;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.n;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.o;
            });
        },
        "./src/experiments.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function log(experiment, treatment, token, state) {
                Object(__WEBPACK_IMPORTED_MODULE_2__lib__.t)(function(session) {
                    var event = experiment + "_" + treatment + "_" + state, loggedEvents = session.loggedExperimentEvents = session.loggedExperimentEvents || [];
                    if (-1 !== loggedEvents.indexOf(event)) Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("duplicate_" + event); else {
                        var _track;
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)(event);
                        loggedEvents.push(event);
                        var edge = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/Edge\/[0-9]{2}/);
                        edge && (event = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)(edge[0].toLowerCase().replace("/", "_") + "_" + event));
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__.e.STATE.CHECKOUT, 
                        _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TRANSITION] = state, _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.EXPERIMENT_NAME] = experiment, 
                        _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TREATMENT_NAME] = treatment, 
                        _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TOKEN] = token, _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.CONTEXT_ID] = token, 
                        _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.CONTEXT_TYPE] = token ? __WEBPACK_IMPORTED_MODULE_1__config__.e.CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_1__config__.j.EC_TOKEN] : __WEBPACK_IMPORTED_MODULE_1__config__.e.CONTEXT_TYPE.BUTTON_SESSION_ID, 
                        _track));
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.i)();
                    }
                });
            }
            function logExperimentTreatment(_ref) {
                var experiment = _ref.experiment, treatment = _ref.treatment, state = _ref.state, token = _ref.token;
                if (experiment && treatment) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__lib__.t)(function(session) {
                        session.externalExperiment = experiment;
                        session.externalExperimentTreatment = treatment;
                        token && (session.externalExperimentToken = token);
                    });
                    log(experiment, treatment, token, state);
                }
            }
            function logReturn(token) {
                var _getSessionState = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.t)(function(session) {
                    return session;
                }), externalExperiment = _getSessionState.externalExperiment, externalExperimentTreatment = _getSessionState.externalExperimentTreatment, externalExperimentToken = _getSessionState.externalExperimentToken;
                externalExperiment && externalExperimentTreatment && externalExperimentToken === token ? log(externalExperiment, externalExperimentTreatment, token, "complete") : Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("experiment_mismatch", {
                    token: token,
                    externalExperiment: externalExperiment,
                    externalExperimentTreatment: externalExperimentTreatment,
                    externalExperimentToken: externalExperimentToken
                });
            }
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return onAuthorizeListener;
            });
            __webpack_exports__.a = logExperimentTreatment;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js"), onAuthorizeListener = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.e)();
            if (Object(__WEBPACK_IMPORTED_MODULE_2__lib__.k)("log_authorize")) {
                onAuthorizeListener.once(function(_ref2) {
                    var paymentToken = _ref2.paymentToken;
                    setTimeout(function() {
                        logReturn(paymentToken);
                    }, 1);
                });
                var returnToken = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.q)();
                returnToken && setTimeout(function() {
                    returnToken && logReturn(returnToken);
                }, 1);
            }
        },
        "./src/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./src/interface.js");
            __webpack_require__.d(__webpack_exports__, "postRobot", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.postRobot;
            });
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.Promise;
            });
            __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.PopupOpenError;
            });
            __webpack_require__.d(__webpack_exports__, "rest", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.rest;
            });
            __webpack_require__.d(__webpack_exports__, "Button", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.Button;
            });
            __webpack_require__.d(__webpack_exports__, "forceIframe", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.forceIframe;
            });
            __webpack_require__.d(__webpack_exports__, "isWebView", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.isWebView;
            });
            __webpack_require__.d(__webpack_exports__, "allowIframe", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.allowIframe;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.setup;
            });
            __webpack_require__.d(__webpack_exports__, "config", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.config;
            });
            __webpack_require__.d(__webpack_exports__, "ENV", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.ENV;
            });
            __webpack_require__.d(__webpack_exports__, "USERS", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.USERS;
            });
            __webpack_require__.d(__webpack_exports__, "SOURCE", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.SOURCE;
            });
            __webpack_require__.d(__webpack_exports__, "FUNDING", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.FUNDING;
            });
            __webpack_require__.d(__webpack_exports__, "CARD", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.CARD;
            });
            __webpack_require__.d(__webpack_exports__, "request", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.request;
            });
            __webpack_require__.d(__webpack_exports__, "isEligible", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.isEligible;
            });
            __webpack_require__.d(__webpack_exports__, "isFundingRemembered", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.isFundingRemembered;
            });
            __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.logExperimentTreatment;
            });
            __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.onPossiblyUnhandledException;
            });
            __webpack_require__.d(__webpack_exports__, "version", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.version;
            });
            __webpack_require__.d(__webpack_exports__, "checkout", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.checkout;
            });
            __webpack_require__.d(__webpack_exports__, "apps", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.apps;
            });
            __webpack_require__.d(__webpack_exports__, "Checkout", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.Checkout;
            });
            __webpack_require__.d(__webpack_exports__, "PayPalCheckout", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.PayPalCheckout;
            });
            __webpack_require__.d(__webpack_exports__, "Login", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.Login;
            });
            __webpack_require__.d(__webpack_exports__, "destroyAll", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.destroyAll;
            });
            __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", function() {
                return __WEBPACK_IMPORTED_MODULE_0__interface__.enableCheckoutIframe;
            });
            __webpack_exports__.default = __WEBPACK_IMPORTED_MODULE_0__interface__;
        },
        "./src/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            __webpack_require__.d(__webpack_exports__, "postRobot", function() {
                return postRobot;
            });
            __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", function() {
                return onPossiblyUnhandledException;
            });
            __webpack_require__.d(__webpack_exports__, "version", function() {
                return version;
            });
            __webpack_require__.d(__webpack_exports__, "checkout", function() {
                return checkout;
            });
            __webpack_require__.d(__webpack_exports__, "apps", function() {
                return apps;
            });
            __webpack_require__.d(__webpack_exports__, "Checkout", function() {
                return Checkout;
            });
            __webpack_require__.d(__webpack_exports__, "PayPalCheckout", function() {
                return PayPalCheckout;
            });
            __webpack_require__.d(__webpack_exports__, "Login", function() {
                return Login;
            });
            __webpack_require__.d(__webpack_exports__, "destroyAll", function() {
                return destroyAll;
            });
            __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", function() {
                return enableCheckoutIframe;
            });
            var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("./src/components/index.js");
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a;
            });
            __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() {
                return __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__.b;
            });
            var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("./src/api/index.js");
            __webpack_require__.d(__webpack_exports__, "rest", function() {
                return __WEBPACK_IMPORTED_MODULE_5__api__.a;
            });
            __webpack_require__.d(__webpack_exports__, "Button", function() {
                return __WEBPACK_IMPORTED_MODULE_4__components__.a;
            });
            __webpack_require__.d(__webpack_exports__, "forceIframe", function() {
                return __WEBPACK_IMPORTED_MODULE_4__components__.d;
            });
            __webpack_require__.d(__webpack_exports__, "isWebView", function() {
                return __WEBPACK_IMPORTED_MODULE_4__components__.d;
            });
            __webpack_require__.d(__webpack_exports__, "allowIframe", function() {
                return __WEBPACK_IMPORTED_MODULE_4__components__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_6__setup__ = __webpack_require__("./src/setup.js");
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return __WEBPACK_IMPORTED_MODULE_6__setup__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("./src/config/index.js");
            __webpack_require__.d(__webpack_exports__, "config", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.n;
            });
            __webpack_require__.d(__webpack_exports__, "ENV", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.d;
            });
            __webpack_require__.d(__webpack_exports__, "USERS", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.m;
            });
            __webpack_require__.d(__webpack_exports__, "SOURCE", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.l;
            });
            __webpack_require__.d(__webpack_exports__, "FUNDING", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.f;
            });
            __webpack_require__.d(__webpack_exports__, "CARD", function() {
                return __WEBPACK_IMPORTED_MODULE_7__config__.b;
            });
            __webpack_require__.d(__webpack_exports__, "request", function() {
                return __WEBPACK_IMPORTED_MODULE_3__lib__.Q;
            });
            __webpack_require__.d(__webpack_exports__, "isEligible", function() {
                return __WEBPACK_IMPORTED_MODULE_3__lib__.y;
            });
            __webpack_require__.d(__webpack_exports__, "isFundingRemembered", function() {
                return __WEBPACK_IMPORTED_MODULE_3__lib__.z;
            });
            var __WEBPACK_IMPORTED_MODULE_8__experiments__ = __webpack_require__("./src/experiments.js");
            __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", function() {
                return __WEBPACK_IMPORTED_MODULE_8__experiments__.a;
            });
            var postRobot = __WEBPACK_IMPORTED_MODULE_2_post_robot_src__, onPossiblyUnhandledException = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.onPossiblyUnhandledException, version = "4.0.173", checkout = void 0, apps = void 0, legacy = __webpack_require__("./src/legacy/index.js");
            checkout = legacy.checkout;
            apps = legacy.apps;
            var Checkout = void 0, PayPalCheckout = void 0, Login = void 0, destroyAll = void 0, enableCheckoutIframe = void 0;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__lib__.D)()) {
                Checkout = __WEBPACK_IMPORTED_MODULE_4__components__.b;
                PayPalCheckout = __WEBPACK_IMPORTED_MODULE_4__components__.b;
                Login = __WEBPACK_IMPORTED_MODULE_4__components__.c;
                enableCheckoutIframe = __WEBPACK_IMPORTED_MODULE_4__components__.e;
                destroyAll = __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__.d;
            }
        },
        "./src/legacy/button.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function renderButton(id, _ref) {
                var container = _ref.container, locale = _ref.locale, type = _ref.type, color = _ref.color, shape = _ref.shape, size = _ref.size;
                return loadButtonJS().then(function() {
                    if (locale) {
                        var _normalizeLocale = Object(__WEBPACK_IMPORTED_MODULE_6__common__.a)(locale), country = _normalizeLocale.country, lang = _normalizeLocale.lang;
                        locale = lang + "_" + country;
                    }
                    locale = locale || __WEBPACK_IMPORTED_MODULE_2__config__.n.locale.lang + "_" + __WEBPACK_IMPORTED_MODULE_2__config__.n.locale.country;
                    color = color || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__.b.GOLD;
                    shape = shape || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__.h.PILL;
                    size = size || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__.i.SMALL;
                    type = type || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__.c.CHECKOUT;
                    debug("render_button_lc_" + locale);
                    debug("render_button_color_" + color);
                    debug("render_button_shape_" + shape);
                    debug("render_button_size_" + size);
                    debug("render_button_label_" + type);
                    var el = window.paypal.button.create(id, {
                        lc: locale,
                        color: color,
                        shape: shape,
                        size: size
                    }, {
                        type: "button",
                        label: type
                    }).el;
                    container.appendChild(el);
                    try {
                        info("in_page_button_" + (Object(__WEBPACK_IMPORTED_MODULE_3__lib__.x)(el) ? "visible" : "not_visible"));
                    } catch (err) {}
                    return el.childNodes[0];
                });
            }
            function renderButtons(id, buttons) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.map(buttons, function(button) {
                    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.try(function() {
                        return button.container ? renderButton(id, button) : button.button;
                    }).then(function(element) {
                        var container = void 0, type = void 0, condition = button.condition, click = button.click;
                        if (button.container) {
                            container = button.container;
                            type = __WEBPACK_IMPORTED_MODULE_2__config__.e.BUTTON_TYPE.HTML;
                        } else {
                            container = button.button;
                            type = __WEBPACK_IMPORTED_MODULE_2__config__.e.BUTTON_TYPE.CUSTOM;
                        }
                        return {
                            container: container,
                            element: element,
                            type: type,
                            condition: condition,
                            click: click
                        };
                    });
                });
            }
            function getHijackTargetElement(button) {
                var form = button.form;
                if (form) {
                    debug("target_element_button_form");
                    return form;
                }
                var tagName = button.tagName && button.tagName.toLowerCase();
                if ("a" === tagName) {
                    debug("target_element_link");
                    return button;
                }
                var parentElement = button.parentElement, parentTagName = parentElement && parentElement.tagName && parentElement.tagName.toLowerCase();
                if (("img" === tagName || "button" === tagName) && "a" === parentTagName) {
                    debug("target_element_parent_link");
                    return parentElement;
                }
                var grandparentElement = parentElement && parentElement.parentElement, grandparentTagName = grandparentElement && grandparentElement.tagName && grandparentElement.tagName.toLowerCase();
                if ("button" === tagName && "a" === grandparentTagName) {
                    debug("target_element_grandparent_link");
                    return button.parentElement && button.parentElement.parentElement;
                }
            }
            __webpack_exports__.b = renderButtons;
            __webpack_exports__.a = getHijackTargetElement;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__components_button_constants__ = __webpack_require__("./src/components/button/constants.js"), __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("./src/legacy/constants.js"), __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__("./src/legacy/common.js"), _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_5__constants__.c), info = _prefix.info, debug = _prefix.debug, error = _prefix.error, loadButtonJS = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.G)(function() {
                debug("buttonjs_load");
                return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.E)(__WEBPACK_IMPORTED_MODULE_2__config__.n.buttonJSUrl).catch(function(err) {
                    info("buttonjs_load_error_retry", {
                        error: Object(__WEBPACK_IMPORTED_MODULE_3__lib__.T)(err)
                    });
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.E)(__WEBPACK_IMPORTED_MODULE_2__config__.n.buttonJSUrl);
                }).then(function(result) {
                    debug("buttonjs_load_success");
                    return result;
                }).catch(function(err) {
                    error("buttonjs_load_error", {
                        error: Object(__WEBPACK_IMPORTED_MODULE_3__lib__.T)(err)
                    });
                    throw err;
                });
            });
        },
        "./src/legacy/common.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function normalizeLocale(locale) {
                var _locale$split = locale.split("_"), lang = _locale$split[0], country = _locale$split[1];
                if (!country) if (__WEBPACK_IMPORTED_MODULE_1__config__.n.locales[lang]) {
                    country = lang;
                    lang = null;
                } else country = DEFAULT_COUNTRY;
                if (!__WEBPACK_IMPORTED_MODULE_1__config__.n.locales[country]) {
                    warn("invalid_user_country", {
                        country: country
                    });
                    country = DEFAULT_COUNTRY;
                }
                lang || (lang = DEFAULT_LANG);
                if (-1 === __WEBPACK_IMPORTED_MODULE_1__config__.n.locales[country].indexOf(lang)) {
                    warn("invalid_user_lang", {
                        lang: lang
                    });
                    lang = -1 !== __WEBPACK_IMPORTED_MODULE_1__config__.n.locales[country].indexOf(DEFAULT_LANG) ? DEFAULT_LANG : __WEBPACK_IMPORTED_MODULE_1__config__.n.locales[country][0];
                }
                return {
                    country: country,
                    lang: lang
                };
            }
            __webpack_exports__.a = normalizeLocale;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/legacy/constants.js"), _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_2__constants__.c), warn = _prefix.warn, DEFAULT_COUNTRY = __WEBPACK_IMPORTED_MODULE_1__config__.c.US, DEFAULT_LANG = __WEBPACK_IMPORTED_MODULE_1__config__.g.EN;
        },
        "./src/legacy/constants.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return LOG_PREFIX;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return ATTRIBUTES;
            });
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return CLASSES;
            });
            var LOG_PREFIX = "paypal_legacy", ATTRIBUTES = {
                BUTTON: "data-paypal-button",
                MERCHANT_ID: "data-paypal-id",
                ENV: "data-env",
                SANDBOX: "data-sandbox"
            }, CLASSES = {
                HIDDEN_BUTTON: "paypal-button-hidden"
            };
        },
        "./src/legacy/eligibility.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isLegacyEligible() {
                return !!Object(__WEBPACK_IMPORTED_MODULE_0__lib__.y)() && (!!Object(__WEBPACK_IMPORTED_MODULE_0__lib__.V)() && !Object(__WEBPACK_IMPORTED_MODULE_0__lib__.w)());
            }
            __webpack_exports__.a = isLegacyEligible;
            var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./src/lib/index.js");
        },
        "./src/legacy/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_1__button__ = (__webpack_require__("./src/legacy/ready.js"), 
            __webpack_require__("./src/legacy/button.js"));
            __webpack_require__.d(__webpack_exports__, "renderButtons", function() {
                return __WEBPACK_IMPORTED_MODULE_1__button__.b;
            });
            __webpack_require__.d(__webpack_exports__, "getHijackTargetElement", function() {
                return __WEBPACK_IMPORTED_MODULE_1__button__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/legacy/constants.js");
            __webpack_require__.d(__webpack_exports__, "LOG_PREFIX", function() {
                return __WEBPACK_IMPORTED_MODULE_2__constants__.c;
            });
            __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() {
                return __WEBPACK_IMPORTED_MODULE_2__constants__.a;
            });
            __webpack_require__.d(__webpack_exports__, "CLASSES", function() {
                return __WEBPACK_IMPORTED_MODULE_2__constants__.b;
            });
            var __WEBPACK_IMPORTED_MODULE_3__interface__ = __webpack_require__("./src/legacy/interface.js");
            __webpack_require__.d(__webpack_exports__, "checkout", function() {
                return __WEBPACK_IMPORTED_MODULE_3__interface__.b;
            });
            __webpack_require__.d(__webpack_exports__, "apps", function() {
                return __WEBPACK_IMPORTED_MODULE_3__interface__.a;
            });
            __webpack_require__.d(__webpack_exports__, "reset", function() {
                return __WEBPACK_IMPORTED_MODULE_3__interface__.c;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return __WEBPACK_IMPORTED_MODULE_3__interface__.d;
            });
        },
        "./src/legacy/interface.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function reset() {
                debug("reset");
                checkout.initXO = initXO;
                checkout.startFlow = startFlow;
                checkout.closeFlow = closeFlow;
            }
            function matchUrlAndPaymentToken(item) {
                if (!item || !item.trim()) {
                    error("startflow_no_url_or_token", {
                        item: item
                    });
                    throw new Error("startflow_no_url_or_token");
                }
                var paymentToken = Object(__WEBPACK_IMPORTED_MODULE_9__util__.b)(item), url = paymentToken && paymentToken === item ? "" : item;
                if (url) if (url.match(/^https?:\/\/|^\//)) paymentToken ? -1 !== url.indexOf(".paypal.com") ? debug("startflow_paypalurl_with_token", {
                    url: url
                }) : debug("startflow_url_with_token", {
                    url: url
                }) : debug("startflow_url_no_token", {
                    url: url
                }); else {
                    paymentToken ? info("startflow_relative_url_with_token", {
                        url: url
                    }) : info("startflow_relative_url_no_token", {
                        url: url
                    });
                    0 === url.toLowerCase().indexOf("ec-") && paymentToken && (url = "" + __WEBPACK_IMPORTED_MODULE_3__config__.n.checkoutUrl + url);
                } else {
                    if (!paymentToken) {
                        error("startflow_no_url_or_token", {
                            url: url
                        });
                        throw new Error('Could not determine url or token from "' + item + '"');
                    }
                    url = Object(__WEBPACK_IMPORTED_MODULE_4__lib__.g)(__WEBPACK_IMPORTED_MODULE_3__config__.n.checkoutUrl, {
                        token: paymentToken
                    });
                    debug("startflow_with_token", {
                        url: url
                    });
                }
                return {
                    paymentToken: paymentToken,
                    url: url
                };
            }
            function checkUrlAgainstEnv(url) {
                for (var paypalUrls = __WEBPACK_IMPORTED_MODULE_3__config__.n.paypalUrls, _iterator = Object.keys(paypalUrls), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var env = _ref, paypalUrl = paypalUrls[env];
                    if (env !== __WEBPACK_IMPORTED_MODULE_3__config__.d.TEST && env !== __WEBPACK_IMPORTED_MODULE_3__config__.d.DEMO && (env !== __WEBPACK_IMPORTED_MODULE_3__config__.n.env && (0 === url.indexOf(paypalUrl) || 0 === url.indexOf(paypalUrl.replace("//www.", "//"))))) {
                        warn("mismatched_env_startflow_url", {
                            env: __WEBPACK_IMPORTED_MODULE_3__config__.n.env,
                            url: url
                        });
                        Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(url);
                        throw new Error(url + " is not a " + __WEBPACK_IMPORTED_MODULE_3__config__.n.env + " url");
                    }
                }
            }
            function awaitPaymentTokenAndUrl() {
                var paymentTokenAndUrl = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve) {
                    checkout.initXO = function() {
                        warn("gettoken_initxo");
                    };
                    checkout.startFlow = Object(__WEBPACK_IMPORTED_MODULE_4__lib__.K)(function(item) {
                        debug("gettoken_startflow", {
                            item: item
                        });
                        var _matchUrlAndPaymentTo = matchUrlAndPaymentToken(item), url = _matchUrlAndPaymentTo.url, paymentToken = _matchUrlAndPaymentTo.paymentToken;
                        checkUrlAgainstEnv(url);
                        return resolve({
                            url: url,
                            paymentToken: paymentToken
                        });
                    });
                });
                return {
                    url: paymentTokenAndUrl.then(function(result) {
                        return result.url;
                    }),
                    paymentToken: paymentTokenAndUrl.then(function(result) {
                        return result.paymentToken;
                    })
                };
            }
            function initPayPalCheckout() {
                var props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                info("init_checkout");
                paypalCheckoutInited && __WEBPACK_IMPORTED_MODULE_3__config__.n.env !== __WEBPACK_IMPORTED_MODULE_3__config__.d.TEST && warn("multiple_init_paypal_checkout");
                closeFlowCalled && debug("init_after_closeflow");
                paypalCheckoutInited = !0;
                var paypalCheckout = __WEBPACK_IMPORTED_MODULE_2__components__.b.init(_extends({
                    onAuthorize: function(data, actions) {
                        info("payment_authorized");
                        Object(__WEBPACK_IMPORTED_MODULE_9__util__.a)(data.returnUrl);
                        return actions.redirect(window);
                    },
                    onCancel: function(data, actions) {
                        info("payment_canceled");
                        Object(__WEBPACK_IMPORTED_MODULE_9__util__.a)(data.cancelUrl);
                        return actions.redirect(window);
                    },
                    fallback: function(url) {
                        error("fallback_handler", {
                            url: url
                        });
                        this.destroy();
                        return Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(url);
                    }
                }, props));
                checkout.closeFlow = function(closeUrl) {
                    warn("closeflow");
                    closeFlowCalled = !0;
                    reset();
                    paypalCheckout.destroy();
                    if (closeUrl) {
                        warn("closeflow_with_url", {
                            closeUrl: closeUrl
                        });
                        return Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(closeUrl);
                    }
                };
                return paypalCheckout;
            }
            function renderPayPalCheckout() {
                var props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, hijackTarget = arguments[1], urlProp = __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(props.url), paymentToken = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve) {
                    props.init = function(data) {
                        resolve(data.paymentToken);
                    };
                }), errorHandler = Object(__WEBPACK_IMPORTED_MODULE_4__lib__.K)(function(err) {
                    error("component_error", {
                        error: err.stack || err.toString()
                    });
                    if (hijackTarget) {
                        warn("render_error_hijack_revert_target");
                        hijackTarget.removeAttribute("target");
                    }
                    urlProp.then(function(url) {
                        warn("render_error_redirect_using_url");
                        return Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(url);
                    });
                    paymentToken.then(function(token) {
                        warn("render_error_redirect_using_token");
                        return Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(Object(__WEBPACK_IMPORTED_MODULE_4__lib__.g)(__WEBPACK_IMPORTED_MODULE_3__config__.n.checkoutUrl, {
                            token: token
                        }));
                    });
                });
                props.onError = errorHandler;
                var paypalCheckout = void 0;
                if (hijackTarget) {
                    delete props.url;
                    paypalCheckout = initPayPalCheckout(props);
                    paypalCheckout.hijack(hijackTarget);
                    paypalCheckout.runTimeout();
                    urlProp.then(function(url) {
                        warn("hijack_then_url_passed");
                        paypalCheckout.loadUrl(url);
                    });
                } else paypalCheckout = initPayPalCheckout(props);
                var render = paypalCheckout.render(null, !hijackTarget);
                checkout.win = paypalCheckout.window;
                return render.catch(errorHandler);
            }
            function handleClick(clickHandler, event) {
                debug("button_click_handler");
                try {
                    clickHandler(event);
                } catch (err) {
                    error("click_handler_error", {
                        error: err.stack || err.toString()
                    });
                }
            }
            function handleClickHijack(element) {
                var targetElement = Object(__WEBPACK_IMPORTED_MODULE_8__button__.a)(element);
                if (!targetElement) return error("target_element_not_found");
                info("init_paypal_checkout_hijack");
                var _awaitPaymentTokenAnd = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd.url, paymentToken = _awaitPaymentTokenAnd.paymentToken, token = void 0;
                paymentToken.then(function(result) {
                    token = result;
                });
                renderPayPalCheckout({
                    url: url,
                    payment: function() {
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(token);
                    }
                }, targetElement);
            }
            function listenClick(container, button, clickHandler, condition, tracker) {
                var element = "a" === container.tagName.toLowerCase() ? container : button, isClick = clickHandler instanceof Function;
                if (element.hasAttribute("data-paypal-click-listener")) return warn("button_already_has_paypal_click_listener");
                element.setAttribute("data-paypal-click-listener", "");
                Object(__WEBPACK_IMPORTED_MODULE_8__button__.a)(element) && isClick && info("button_link_or_form");
                element.addEventListener("click", function(event) {
                    tracker();
                    var eligible = Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__.a)();
                    if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__.V)()) {
                        debug("click_popups_supported");
                        eligible || debug("click_popups_supported_but_ineligible");
                    } else {
                        debug("click_popups_not_supported");
                        eligible && debug("click_popups_not_supported_but_eligible");
                    }
                    if (!isClick && !eligible) return debug("ineligible_listenclick");
                    info("button_click");
                    if (condition instanceof Function) {
                        if (!condition.call()) return info("button_click_condition_disabled");
                        info("button_click_condition_enabled");
                    }
                    return isClick ? handleClick(clickHandler, event) : handleClickHijack(element);
                });
            }
            function instrumentButtonRender(type) {
                var _track;
                info("render_" + type + "_button");
                track((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_3__config__.e.STATE.LOAD, 
                _track[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_3__config__.e.TRANSITION.BUTTON_RENDER, 
                _track[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.BUTTON_TYPE] = type, _track));
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.g)();
            }
            function instrumentButtonClick(type) {
                var _track2;
                track((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_3__config__.e.STATE.LOAD, 
                _track2[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_3__config__.e.TRANSITION.BUTTON_CLICK, 
                _track2[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.BUTTON_TYPE] = type, _track2));
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.g)();
            }
            function setup(id) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                id = id || "merchant";
                info("setup", {
                    id: id,
                    env: options.environment,
                    options: Object(__WEBPACK_IMPORTED_MODULE_4__lib__.R)(options)
                });
                setupCalled && debug("setup_called_multiple_times");
                setupCalled = !0;
                Object(__WEBPACK_IMPORTED_MODULE_10__options__.a)(options);
                Object(__WEBPACK_IMPORTED_MODULE_10__options__.b)(options);
                Object(__WEBPACK_IMPORTED_MODULE_5__postBridge__.a)(__WEBPACK_IMPORTED_MODULE_3__config__.n.env);
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    return options.buttons.length ? Object(__WEBPACK_IMPORTED_MODULE_8__button__.b)(id, options.buttons).then(function(buttons) {
                        buttons.forEach(function(button) {
                            instrumentButtonRender(button.type);
                            listenClick(button.container, button.element, button.click, button.condition, function() {
                                instrumentButtonClick(button.type);
                            });
                        });
                    }) : instrumentButtonRender(__WEBPACK_IMPORTED_MODULE_3__config__.e.BUTTON_TYPE.CUSTOM);
                });
            }
            function initXO() {
                debug("initxo");
                if (!Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__.a)()) return debug("ineligible_initxo");
                var _awaitPaymentTokenAnd2 = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd2.url, paymentToken = _awaitPaymentTokenAnd2.paymentToken;
                info("init_paypal_checkout_initxo");
                renderPayPalCheckout({
                    url: url,
                    payment: function() {
                        return paymentToken;
                    }
                });
            }
            function startFlow(item) {
                debug("startflow", {
                    item: item
                });
                var _matchUrlAndPaymentTo2 = matchUrlAndPaymentToken(item), paymentToken = _matchUrlAndPaymentTo2.paymentToken, url = _matchUrlAndPaymentTo2.url;
                checkUrlAgainstEnv(url);
                if (Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__.a)()) {
                    info("init_paypal_checkout_startflow");
                    renderPayPalCheckout({
                        url: url,
                        payment: function() {
                            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve(paymentToken);
                        }
                    });
                } else {
                    debug("ineligible_startflow_global", {
                        url: url
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(url);
                }
            }
            function closeFlow(closeUrl) {
                warn("closeflow_not_opened");
                if (closeUrl) {
                    warn("closeflow_with_url", {
                        closeUrl: closeUrl
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_9__util__.c)(closeUrl);
                }
            }
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return checkout;
            });
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return apps;
            });
            __webpack_exports__.c = reset;
            __webpack_exports__.d = setup;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("./src/components/index.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_5__postBridge__ = __webpack_require__("./src/legacy/postBridge.js"), __WEBPACK_IMPORTED_MODULE_6__eligibility__ = __webpack_require__("./src/legacy/eligibility.js"), __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./src/legacy/constants.js"), __WEBPACK_IMPORTED_MODULE_8__button__ = __webpack_require__("./src/legacy/button.js"), __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("./src/legacy/util.js"), __WEBPACK_IMPORTED_MODULE_10__options__ = __webpack_require__("./src/legacy/options.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, _prefix = Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_7__constants__.c), info = _prefix.info, debug = _prefix.debug, warn = _prefix.warn, error = _prefix.error, track = _prefix.track, checkout = {}, apps = {
                checkout: checkout,
                Checkout: checkout
            };
            checkout.reset = reset;
            Object.defineProperty(checkout, "urlPrefix", {
                get: function() {
                    return __WEBPACK_IMPORTED_MODULE_3__config__.n.checkoutUrl + (-1 === __WEBPACK_IMPORTED_MODULE_3__config__.n.checkoutUrl.indexOf("?") ? "?" : "&") + "token=";
                }
            });
            window.xchild && !window.paypalCheckout && (window.paypalCheckout = window.xchild);
            var paypalCheckoutInited = !1, closeFlowCalled = !1, setupCalled = !1;
            checkout.setup = setup;
            checkout.initXO = initXO;
            checkout.startFlow = startFlow;
            checkout.closeFlow = closeFlow;
        },
        "./src/legacy/options.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function normalizeOptions(options) {
                if (options.environment) {
                    "live" === options.environment && (options.environment = __WEBPACK_IMPORTED_MODULE_1__config__.d.PRODUCTION);
                    if (!__WEBPACK_IMPORTED_MODULE_1__config__.n.paypalUrls[options.environment]) {
                        warn("invalid_env", {
                            badenv: options.environment
                        });
                        options.environment = __WEBPACK_IMPORTED_MODULE_1__config__.n.env;
                    }
                }
                if (options.button && !Array.isArray(options.button)) {
                    info("options_button_single_button_passed");
                    options.button = [ options.button ];
                }
                if (options.buttons && Object(__WEBPACK_IMPORTED_MODULE_2__lib__.l)(options.buttons).length) {
                    info("options_buttons_with_elements_passed");
                    options.button = options.buttons;
                    delete options.buttons;
                }
                if (options.button && 0 === options.button.length) {
                    info("options_button_empty");
                    delete options.button;
                }
                if (options.button && options.container) {
                    info("options_button_and_container_passed", {
                        button: options.button,
                        container: options.container
                    });
                    options.button = options.button.concat(options.container);
                    delete options.container;
                }
                if (options.button) {
                    var button = Object(__WEBPACK_IMPORTED_MODULE_2__lib__.l)(options.button);
                    if (button.length) options.button = button; else {
                        warn("options_button_element_not_found", {
                            element: JSON.stringify(options.button)
                        });
                        delete options.button;
                    }
                }
                if (options.button) {
                    options.buttons = options.button.map(function(button) {
                        return {
                            button: button,
                            click: options.click,
                            condition: options.condition
                        };
                    });
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                } else if (options.buttons && Array.isArray(options.buttons)) {
                    var buttons = [];
                    options.buttons.forEach(function(button) {
                        if (button) {
                            button.container && button.container !== options.container && warn("mismatched_container_and_button_passed", {
                                options: options.container,
                                button: button.container
                            });
                            Object(__WEBPACK_IMPORTED_MODULE_2__lib__.l)(button.container || button.button).forEach(function(element) {
                                var _buttons$push;
                                buttons.push((_buttons$push = {}, _buttons$push[button.container ? "container" : "button"] = element, 
                                _buttons$push.click = button.click || options.click, _buttons$push.condition = button.condition || options.condition, 
                                _buttons$push.type = button.type || options.type, _buttons$push.locale = button.locale || options.locale, 
                                _buttons$push.color = button.color || options.color, _buttons$push.shape = button.shape || options.shape, 
                                _buttons$push.size = button.size || options.size, _buttons$push));
                            });
                        }
                    });
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    buttons.length && (options.buttons = buttons);
                } else if (options.container && !Array.isArray(options.buttons)) {
                    var _buttons = [];
                    Object(__WEBPACK_IMPORTED_MODULE_2__lib__.l)(options.container).forEach(function(container, i) {
                        _buttons.push({
                            container: container,
                            click: options.click,
                            condition: options.condition,
                            type: Array.isArray(options.type) ? options.type[i] : options.type,
                            locale: Array.isArray(options.locale) ? options.locale[i] : options.locale,
                            color: Array.isArray(options.color) ? options.color[i] : options.color,
                            shape: Array.isArray(options.shape) ? options.shape[i] : options.shape,
                            size: Array.isArray(options.size) ? options.size[i] : options.size
                        });
                    });
                    delete options.container;
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    _buttons.length && (options.buttons = _buttons);
                }
                options.buttons || (options.buttons = []);
            }
            function setupConfig(options) {
                options.environment && __WEBPACK_IMPORTED_MODULE_1__config__.n.paypalUrls[options.environment] && (__WEBPACK_IMPORTED_MODULE_1__config__.n.env = options.environment);
                if (options.locale) {
                    __WEBPACK_IMPORTED_MODULE_1__config__.n.locale = Object(__WEBPACK_IMPORTED_MODULE_3__common__.a)(options.locale);
                    __WEBPACK_IMPORTED_MODULE_1__config__.n.customCountry = !0;
                }
            }
            __webpack_exports__.a = normalizeOptions;
            __webpack_exports__.b = setupConfig;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("./src/legacy/common.js"), __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./src/legacy/constants.js"), _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_4__constants__.c), info = _prefix.info, warn = _prefix.warn;
        },
        "./src/legacy/postBridge.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function setupPostBridge(env) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    var metaFrameDomain = __WEBPACK_IMPORTED_MODULE_3__config__.n.paypalDomains[env];
                    if (!__WEBPACK_IMPORTED_MODULE_2_post_robot_src__.bridge || !__WEBPACK_IMPORTED_MODULE_2_post_robot_src__.bridge.needsBridge({
                        domain: metaFrameDomain
                    })) return Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.e)("post_bridge_not_required", {
                        env: env
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.e)("setup_post_bridge", {
                        env: env
                    });
                    return Object(__WEBPACK_IMPORTED_MODULE_4__lib__.L)(env).then(__WEBPACK_IMPORTED_MODULE_4__lib__.H);
                });
            }
            __webpack_exports__.a = setupPostBridge;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js");
        },
        "./src/legacy/ready.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function invokeReady(method) {
                Object(__WEBPACK_IMPORTED_MODULE_1__lib__.I)(function() {
                    debug("paypal_checkout_ready");
                    setTimeout(function() {
                        window.paypal || error("paypal_checkout_ready_no_window_paypal");
                        method();
                    }, 1);
                });
            }
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./src/legacy/constants.js"), __WEBPACK_IMPORTED_MODULE_4__interface__ = __webpack_require__("./src/legacy/interface.js"), _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_3__constants__.c), error = _prefix.error, debug = _prefix.debug;
            Object(__WEBPACK_IMPORTED_MODULE_1__lib__.J)(window, "paypalCheckoutReady", function(method) {
                if ("function" == typeof method) {
                    var oneTimeReady = function() {
                        if (!method.called) {
                            method.called = !0;
                            return method.apply(this, arguments);
                        }
                    };
                    invokeReady(oneTimeReady);
                    return oneTimeReady;
                }
            });
            Object(__WEBPACK_IMPORTED_MODULE_1__lib__.I)(function() {
                var buttons = Array.prototype.slice.call(document.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_3__constants__.a.BUTTON + "]"));
                if (buttons && buttons.length) {
                    debug("data_paypal_button", {
                        number: buttons.length
                    });
                    for (var _iterator = buttons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        var button = _ref, id = button.getAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__.a.MERCHANT_ID), environment = void 0;
                        button.hasAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__.a.ENV) ? environment = button.getAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__.a.ENV) : button.hasAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__.a.SANDBOX) && (environment = __WEBPACK_IMPORTED_MODULE_2__config__.d.SANDBOX);
                        Object(__WEBPACK_IMPORTED_MODULE_4__interface__.d)(id, {
                            environment: environment,
                            button: button
                        });
                    }
                }
                Array.prototype.slice.call(document.getElementsByClassName(__WEBPACK_IMPORTED_MODULE_3__constants__.b.HIDDEN_BUTTON)).forEach(function(el) {
                    el.className = el.className.replace(__WEBPACK_IMPORTED_MODULE_3__constants__.b.HIDDEN_BUTTON, "");
                });
            });
        },
        "./src/legacy/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function logRedirect(location) {
                redirected && warn("multiple_redirects");
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.X)(location) && (redirected = !0);
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.g)();
            }
            function redirect(url) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    if (!url) throw new Error("Redirect url undefined");
                    if (__WEBPACK_IMPORTED_MODULE_2__config__.n.env === __WEBPACK_IMPORTED_MODULE_2__config__.d.TEST && Object(__WEBPACK_IMPORTED_MODULE_3__lib__.X)(url)) return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.O)(window, "#fullpageRedirect?url=" + url);
                    logRedirect(url);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__.O)(window, url);
                });
            }
            function parseToken(token) {
                if (token) {
                    token = decodeURIComponent(decodeURIComponent(token));
                    if (token.match(/^(EC-)?[A-Z0-9]{17}$/)) return token;
                    var match = token.match(/token=((EC-)?[A-Z0-9]{17})/);
                    if (match) return match[1];
                    match = token.match(/(EC-[A-Z0-9]{17})/);
                    return match ? match[1] : void 0;
                }
            }
            __webpack_exports__.a = logRedirect;
            __webpack_exports__.c = redirect;
            __webpack_exports__.b = parseToken;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./src/legacy/constants.js"), _prefix = Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.m)(__WEBPACK_IMPORTED_MODULE_4__constants__.c), warn = _prefix.warn, redirected = !1;
        },
        "./src/lib/beacon.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__("./src/config/index.js"), __webpack_require__("./src/lib/session.js"), 
            Object.assign;
        },
        "./src/lib/device.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getUserAgent() {
                return window.navigator.mockUserAgent || window.navigator.userAgent;
            }
            function isDevice() {
                return !!getUserAgent().match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i);
            }
            function isFacebookWebView() {
                var ua = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent();
                return -1 !== ua.indexOf("FBAN") || -1 !== ua.indexOf("FBAV");
            }
            function isFirefoxIOS() {
                return /FxiOS/i.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent());
            }
            function isOperaMini() {
                return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent()).indexOf("Opera Mini") > -1;
            }
            function isAndroid() {
                return /Android/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent());
            }
            function isIos() {
                return /iPhone|iPod|iPad/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent());
            }
            function isGoogleSearchApp() {
                return /\bGSA\b/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent());
            }
            function isQQBrowser() {
                return /QQBrowser/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent());
            }
            function isIosWebview() {
                var ua = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent();
                return !!isIos(ua) && (!!isGoogleSearchApp(ua) || /.+AppleWebKit(?!.*Safari)/.test(ua));
            }
            function isAndroidWebview() {
                var ua = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent();
                return !!isAndroid(ua) && (/Version\/[\d.]+/.test(ua) && !isOperaMini(ua));
            }
            function isIE() {
                return !!window.document.documentMode || Boolean(window.navigator && window.navigator.userAgent && /Edge|MSIE/i.test(window.navigator.userAgent));
            }
            function isIECompHeader() {
                var mHttp = window.document.querySelector('meta[http-equiv="X-UA-Compatible"]'), mContent = window.document.querySelector('meta[content="IE=edge"]');
                return !(!mHttp || !mContent);
            }
            function isIEIntranet() {
                if (window.document.documentMode) try {
                    var status = window.status;
                    window.status = "testIntranetMode";
                    if ("testIntranetMode" === window.status) {
                        window.status = status;
                        return !0;
                    }
                    return !1;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            function supportsPopups() {
                var ua = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getUserAgent();
                return !(isIosWebview(ua) || isAndroidWebview(ua) || isOperaMini(ua) || isFirefoxIOS(ua) || isFacebookWebView(ua) || isQQBrowser(ua));
            }
            __webpack_exports__.a = getUserAgent;
            __webpack_exports__.b = isDevice;
            __webpack_exports__.f = isIos;
            __webpack_exports__.c = isIE;
            __webpack_exports__.d = isIECompHeader;
            __webpack_exports__.e = isIEIntranet;
            __webpack_exports__.g = supportsPopups;
        },
        "./src/lib/dom.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function loadScript(src) {
                var timeout = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, attrs = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve, reject) {
                    var script = document.createElement("script");
                    script.onload = function() {
                        resolve();
                    };
                    script.onreadystatechange = function() {
                        "complete" !== this.readyState && "loaded" !== this.readyState || resolve();
                    };
                    var scriptLoadError = new Error("script_loading_error");
                    script.onerror = function() {
                        return reject(scriptLoadError);
                    };
                    timeout && setTimeout(function() {
                        return reject(new Error("script_loading_timed_out"));
                    }, timeout);
                    for (var _iterator = Object.keys(attrs), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                        var _ref;
                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }
                        var attr = _ref;
                        script.setAttribute(attr, attrs[attr]);
                    }
                    script.setAttribute("src", src);
                    document.getElementsByTagName("head")[0].appendChild(script);
                });
            }
            function getElement(item) {
                if (item) {
                    if (item instanceof HTMLElement) return item;
                    if ("string" == typeof item) {
                        if (document.querySelector) {
                            var result = document.querySelector(item);
                            if (result) return result;
                        }
                        return document.getElementById(item);
                    }
                }
            }
            function getElements(collection) {
                if (!collection) return [];
                if (collection instanceof HTMLElement || "string" == typeof collection) {
                    var element = getElement(collection);
                    return element ? [ element ] : [];
                }
                if (Array.isArray(collection) || collection instanceof NodeList || collection instanceof HTMLCollection) {
                    for (var result = [], i = 0; i < collection.length; i++) {
                        var el = getElement(collection[i]);
                        el && result.push(el);
                    }
                    return result;
                }
                return [];
            }
            function onDocumentReady(method) {
                return documentReady.then(method);
            }
            function getQueryParam(name) {
                return parseQuery(window.location.search.slice(1))[name];
            }
            function urlWillRedirectPage(url) {
                return -1 === url.indexOf("#") || 0 !== url.indexOf("#") && url.split("#")[0] !== window.location.href.split("#")[0];
            }
            function extendUrl(url) {
                var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, hasHash = url.indexOf("#") > 0, _url$split = url.split("#"), serverUrl = _url$split[0], hash = _url$split[1];
                if (hash && !serverUrl) {
                    var _ref3 = [ "#" + hash, "" ];
                    serverUrl = _ref3[0];
                    hash = _ref3[1];
                }
                var _serverUrl$split = serverUrl.split("?"), originalUrl = _serverUrl$split[0], originalQueryString = _serverUrl$split[1];
                if (originalQueryString) {
                    var originalQuery = parseQuery(originalQueryString);
                    for (var _key in originalQuery) params.hasOwnProperty(_key) || (params[_key] = originalQuery[_key]);
                }
                var newQueryString = Object.keys(params).filter(function(key) {
                    return key && params[key];
                }).sort().map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
                }).join("&"), newUrl = originalUrl;
                newQueryString && (newUrl = newUrl + "?" + newQueryString);
                hasHash && (newUrl = newUrl + "#" + (hash || ""));
                return newUrl;
            }
            function redirect() {
                var win = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window, url = arguments[1];
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("redirect", {
                        url: url
                    });
                    setTimeout(function() {
                        win.location = url;
                        urlWillRedirectPage(url) || resolve();
                    }, 1);
                });
            }
            function normalizeLocale(locale) {
                if (locale && locale.match(/^[a-z]{2}[-_][A-Z]{2}$/)) {
                    var _locale$split = locale.split(/[-_]/), lang = _locale$split[0], country = _locale$split[1];
                    if (__WEBPACK_IMPORTED_MODULE_2__config__.n.locales[country] && -1 !== __WEBPACK_IMPORTED_MODULE_2__config__.n.locales[country].indexOf(lang)) return {
                        country: country,
                        lang: lang
                    };
                }
            }
            function normalizeLang(lang) {
                if (lang && lang.match(/^[a-z]{2}$/) && __WEBPACK_IMPORTED_MODULE_2__config__.h[lang]) return {
                    country: __WEBPACK_IMPORTED_MODULE_2__config__.h[lang],
                    lang: lang
                };
            }
            function getBrowserLocale() {
                var nav = window.navigator, locales = nav.languages ? Array.prototype.slice.apply(nav.languages) : [];
                nav.language && locales.push(nav.language);
                nav.userLanguage && locales.push(nav.userLanguage);
                for (var _iterator3 = locales, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                    var _ref4;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref4 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref4 = _i3.value;
                    }
                    var locale = _ref4, loc = normalizeLocale(locale);
                    if (loc) return loc;
                }
                for (var _iterator4 = locales, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                    var _ref5;
                    if (_isArray4) {
                        if (_i4 >= _iterator4.length) break;
                        _ref5 = _iterator4[_i4++];
                    } else {
                        _i4 = _iterator4.next();
                        if (_i4.done) break;
                        _ref5 = _i4.value;
                    }
                    var _locale = _ref5, _loc = normalizeLang(_locale);
                    if (_loc) return _loc;
                }
                return __WEBPACK_IMPORTED_MODULE_2__config__.n.defaultLocale;
            }
            function isElementVisible(el) {
                return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
            }
            function getPageRenderTime() {
                return documentReady.then(function() {
                    if (enablePerformance()) {
                        var timing = window.performance.timing;
                        return timing.connectEnd && timing.domInteractive ? timing.domInteractive - timing.connectEnd : void 0;
                    }
                });
            }
            function getResourceLoadTime(url) {
                if (enablePerformance() && window.performance && "function" == typeof window.performance.getEntries) for (var entries = window.performance.getEntries(), i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry && entry.name === url && entry.duration && entry.duration >= 0 && entry.duration <= 6e4) return Math.floor(entry.duration);
                }
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return documentReady;
            });
            __webpack_exports__.j = loadScript;
            __webpack_exports__.d = getElement;
            __webpack_exports__.e = getElements;
            __webpack_exports__.k = onDocumentReady;
            __webpack_exports__.g = getQueryParam;
            __webpack_exports__.m = urlWillRedirectPage;
            __webpack_exports__.b = extendUrl;
            __webpack_exports__.l = redirect;
            __webpack_exports__.c = getBrowserLocale;
            __webpack_exports__.i = isElementVisible;
            __webpack_exports__.f = getPageRenderTime;
            __webpack_exports__.h = getResourceLoadTime;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js"), documentReady = (__webpack_require__("./src/lib/device.js"), 
            new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                if (isDocumentReady()) return resolve();
                var interval = setInterval(function() {
                    if (isDocumentReady()) {
                        clearInterval(interval);
                        return resolve();
                    }
                }, 10);
            })), parseQuery = (documentReady.then(function() {
                if (document.body) return document.body;
                throw new Error("Document ready but document.body not present");
            }), Object(__WEBPACK_IMPORTED_MODULE_3__util__.i)(function(queryString) {
                var params = {};
                if (!queryString) return params;
                if (-1 === queryString.indexOf("=")) return params;
                for (var _iterator2 = queryString.split("&"), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var pair = _ref2;
                    pair = pair.split("=");
                    pair[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
                }
                return params;
            })), enablePerformance = Object(__WEBPACK_IMPORTED_MODULE_3__util__.i)(function() {
                return Boolean(window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0);
            });
        },
        "./src/lib/eligibility.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getBowser() {
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _ref$clearCache = _ref.clearCache, clearCache = void 0 !== _ref$clearCache && _ref$clearCache, userAgent = Object(__WEBPACK_IMPORTED_MODULE_2__device__.a)();
                if (bowserCache[userAgent]) return bowserCache[userAgent];
                clearCache && delete __webpack_require__.c["./node_modules/bowser/bowser.min.js"];
                var bowser = __webpack_require__("./node_modules/bowser/bowser.min.js");
                bowserCache[userAgent] = bowser;
                return bowser;
            }
            function isBrowserEligible() {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__device__.e)()) return !1;
                for (var bowser = getBowser({
                    clearCache: !0
                }), _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__.n.SUPPORTED_BROWSERS), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref2 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref2 = _i.value;
                    }
                    var browser = _ref2;
                    if (bowser[browser] && bowser.version && bowser[browser] && -1 === bowser.compareVersions([ bowser.version, __WEBPACK_IMPORTED_MODULE_1__config__.n.SUPPORTED_BROWSERS[browser] ])) return !1;
                }
                return !0;
            }
            function isEligible() {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__device__.e)()) return !1;
                var userAgent = window.navigator.userAgent;
                if (userAgent && eligibilityResults.hasOwnProperty(userAgent)) return eligibilityResults[userAgent];
                var result = isBrowserEligible();
                eligibilityResults[userAgent] = result;
                return result;
            }
            __webpack_exports__.b = isEligible;
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return checkRecognizedBrowser;
            });
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__device__ = __webpack_require__("./src/lib/device.js"), __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js"), bowserCache = {}, eligibilityResults = {}, checkRecognizedBrowser = Object(__WEBPACK_IMPORTED_MODULE_3__util__.l)(function(state) {
                for (var bowser = getBowser(), _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__.n.SUPPORTED_BROWSERS), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref3;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref3 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref3 = _i2.value;
                    }
                    if (bowser[_ref3]) return;
                }
                var name = bowser.name, version = bowser.version, mobile = bowser.mobile, android = bowser.android, ios = bowser.ios;
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("unrecognized_browser_" + state, {
                    name: name,
                    version: version,
                    mobile: mobile,
                    android: android,
                    ios: ios
                });
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g)();
            });
        },
        "./src/lib/errors.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function logWarn(err) {
                if (window.console) {
                    if (window.console.warn) return window.console.warn(err);
                    if (window.console.log) return window.console.log(err);
                }
            }
            function checkForCommonErrors() {
                function foo(bar, baz, zomg) {}
                if ("[]" !== JSON.stringify([])) {
                    logWarn(Array.prototype.toJSON ? "Custom Array.prototype.toJSON is causing incorrect json serialization of arrays. This is likely to cause issues. Probable cause is Prototype.js" : "JSON.stringify is doing incorrect serialization of arrays. This is likely to cause issues.");
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("json_stringify_array_broken");
                }
                if ("{}" !== JSON.stringify({})) {
                    logWarn("JSON.stringify is doing incorrect serialization of objects. This is likely to cause issues.");
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("json_stringify_object_broken");
                }
                Object(__WEBPACK_IMPORTED_MODULE_1__device__.e)() && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("ie_intranet_mode");
                Object(__WEBPACK_IMPORTED_MODULE_1__device__.c)() && !Object(__WEBPACK_IMPORTED_MODULE_1__device__.d)() && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("ie_meta_compatibility_header_missing", {
                    message: 'Drop tag: <meta http-equiv="X-UA-Compatible" content="IE=edge">'
                });
                3 !== foo.bind({
                    a: 1
                }).length && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("function_bind_arrity_overwritten");
                window.opener && window.parent !== window && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("window_has_opener_and_parent");
                window.name && 0 === window.name.indexOf("__prerender") && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("prerender_running_checkoutjs");
            }
            __webpack_exports__.a = checkForCommonErrors;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__device__ = __webpack_require__("./src/lib/device.js");
        },
        "./src/lib/funding.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getRememberedFunding(handler) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__session__.e)(function(storage) {
                    storage.rememberedFunding = storage.rememberedFunding || [];
                    return handler(storage.rememberedFunding);
                });
            }
            function hasRememberedFunding(source) {
                return !!getRememberedFunding(function(rememberedFunding) {
                    return -1 !== rememberedFunding.indexOf(source);
                }) || !!Object(__WEBPACK_IMPORTED_MODULE_2__session__.d)(function(session) {
                    return session.recentlyCheckedRemembered;
                });
            }
            function isRememberedFunding(source) {
                if (getRememberedFunding(function(rememberedFunding) {
                    return -1 !== rememberedFunding.indexOf(source);
                })) return !0;
                if (Object(__WEBPACK_IMPORTED_MODULE_2__session__.d)(function(session) {
                    return session.recentlyCheckedRemembered;
                })) return !1;
                throw new Error("Can not find remembered funding result");
            }
            function getRememberedFundingPromises() {
                return Object(__WEBPACK_IMPORTED_MODULE_2__session__.b)(function(global) {
                    global.rememberFundingPromises = global.rememberFundingPromises || {};
                    return global.rememberFundingPromises;
                });
            }
            function getRememberedFundingPromise(source) {
                var promises = getRememberedFundingPromises(), promise = promises[source] = promises[source] || new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a();
                hasRememberedFunding(source) && promise.resolve(isRememberedFunding(source));
                return promise;
            }
            function flushRememberedFundingPromises() {
                for (var promises = getRememberedFundingPromises(), rememberedFunding = getRememberedFunding(function(sources) {
                    return sources;
                }), _iterator = Object.keys(promises), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var source = _ref;
                    promises[source].resolve(-1 !== rememberedFunding.indexOf(source));
                }
            }
            function rememberFunding(sources) {
                getRememberedFunding(function(rememberedFunding) {
                    for (var _iterator2 = sources, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }
                        var source = _ref2;
                        if (source !== __WEBPACK_IMPORTED_MODULE_1__config_constants__.g.VENMO || Object(__WEBPACK_IMPORTED_MODULE_3__device__.b)()) {
                            -1 === rememberedFunding.indexOf(source) && rememberedFunding.push(source);
                            flushRememberedFundingPromises();
                        }
                    }
                });
                Object(__WEBPACK_IMPORTED_MODULE_2__session__.d)(function(session) {
                    session.recentlyCheckedRemembered = !0;
                });
            }
            function loadMeta() {
                return Object(__WEBPACK_IMPORTED_MODULE_4__meta__.a)().then(function(_ref3) {
                    rememberFunding(_ref3.rememberedFunding || []);
                });
            }
            function isFundingRemembered() {
                var source = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__config_constants__.g.PAYPAL;
                return hasRememberedFunding(source) ? getRememberedFundingPromise(source) : loadMeta().then(function() {
                    return getRememberedFundingPromise(source);
                });
            }
            function precacheRememberedFunding() {
                return Object(__WEBPACK_IMPORTED_MODULE_2__session__.d)(function(session) {
                    return session.recentlyCheckedRemembered;
                }) ? __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve() : loadMeta();
            }
            __webpack_exports__.a = getRememberedFunding;
            __webpack_exports__.d = rememberFunding;
            __webpack_exports__.b = isFundingRemembered;
            __webpack_exports__.c = precacheRememberedFunding;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js"), __WEBPACK_IMPORTED_MODULE_2__session__ = __webpack_require__("./src/lib/session.js"), __WEBPACK_IMPORTED_MODULE_3__device__ = __webpack_require__("./src/lib/device.js"), __WEBPACK_IMPORTED_MODULE_4__meta__ = __webpack_require__("./src/lib/meta.js");
        },
        "./src/lib/http.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function parseHeaders() {
                for (var rawHeaders = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", result = {}, _iterator = rawHeaders.trim().split("\n"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var line = _ref, _line$split = line.split(":"), _key = _line$split[0], values = _line$split.slice(1);
                    result[_key.toLowerCase()] = values.join(":").trim();
                }
                return result;
            }
            function request(_ref2) {
                var url = _ref2.url, _ref2$method = _ref2.method, method = void 0 === _ref2$method ? "get" : _ref2$method, _ref2$headers = _ref2.headers, headers = void 0 === _ref2$headers ? {} : _ref2$headers, json = _ref2.json, data = _ref2.data, body = _ref2.body, _ref2$win = _ref2.win, win = void 0 === _ref2$win ? window : _ref2$win, _ref2$timeout = _ref2.timeout, timeout = void 0 === _ref2$timeout ? 0 : _ref2$timeout;
                return "/demo/checkout/api/braintree/client-token/" === url ? __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.resolve("eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJjMDFhZmRkM2Y1OTJmNWVhNTNlMzE5MWQwYmIyMWVjYjM5NzNlZGM1MzkwNDZiMjJmNTA2ODEyNzIzZmRlMTJifGNsaWVudF9pZD1jbGllbnRfaWQkc2FuZGJveCQ0ZHByYmZjNnBoNTk1Y2NqXHUwMDI2Y3JlYXRlZF9hdD0yMDE3LTA0LTI2VDIzOjI2OjU5Ljg3OTA3ODYwNiswMDAwXHUwMDI2bWVyY2hhbnRfaWQ9M3cydHR2d2QyNDY1NDhoZCIsImNvbmZpZ1VybCI6Imh0dHBzOi8vYXBpLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb206NDQzL21lcmNoYW50cy8zdzJ0dHZ3ZDI0NjU0OGhkL2NsaWVudF9hcGkvdjEvY29uZmlndXJhdGlvbiIsImNoYWxsZW5nZXMiOltdLCJlbnZpcm9ubWVudCI6InNhbmRib3giLCJjbGllbnRBcGlVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvM3cydHR2d2QyNDY1NDhoZC9jbGllbnRfYXBpIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9jbGllbnQtYW5hbHl0aWNzLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20vM3cydHR2d2QyNDY1NDhoZCJ9LCJ0aHJlZURTZWN1cmVFbmFibGVkIjpmYWxzZSwicGF5cGFsRW5hYmxlZCI6dHJ1ZSwicGF5cGFsIjp7ImRpc3BsYXlOYW1lIjoiYmFyY28uMDMtZmFjaWxpdGF0b3JAZ21haWwuY29tIiwiY2xpZW50SWQiOiJBV3VZdnFnMGtaN2Y5S0V4TVpqZU53T3RjQV8yZVhnOWpMZy1QSnBGX0pnYk44M0YyVml5aEdnV2JCNDg4RGU3MFpucGRBZEI2TUNqekNqSyIsInByaXZhY3lVcmwiOiJodHRwczovL2V4YW1wbGUuY29tIiwidXNlckFncmVlbWVudFVybCI6Imh0dHBzOi8vZXhhbXBsZS5jb20iLCJiYXNlVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhc3NldHNVcmwiOiJodHRwczovL2NoZWNrb3V0LnBheXBhbC5jb20iLCJkaXJlY3RCYXNlVXJsIjpudWxsLCJhbGxvd0h0dHAiOnRydWUsImVudmlyb25tZW50Tm9OZXR3b3JrIjpmYWxzZSwiZW52aXJvbm1lbnQiOiJvZmZsaW5lIiwidW52ZXR0ZWRNZXJjaGFudCI6ZmFsc2UsImJyYWludHJlZUNsaWVudElkIjoibWFzdGVyY2xpZW50MyIsImJpbGxpbmdBZ3JlZW1lbnRzRW5hYmxlZCI6dHJ1ZSwibWVyY2hhbnRBY2NvdW50SWQiOiJVU0QiLCJjdXJyZW5jeUlzb0NvZGUiOiJVU0QifSwiY29pbmJhc2VFbmFibGVkIjpmYWxzZSwibWVyY2hhbnRJZCI6IjN3MnR0dndkMjQ2NTQ4aGQiLCJ2ZW5tbyI6Im9mZiJ9") : new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a(function(resolve, reject) {
                    if (json && data || json && body || data && json) throw new Error("Only options.json or options.data or options.body should be passed");
                    for (var normalizedHeaders = {}, _iterator2 = Object.keys(headers), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                        var _ref3;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref3 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref3 = _i2.value;
                        }
                        var _key3 = _ref3;
                        normalizedHeaders[_key3.toLowerCase()] = headers[_key3];
                    }
                    json ? normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || "application/json" : (data || body) && (normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || "application/x-www-form-urlencoded; charset=utf-8");
                    normalizedHeaders[HEADERS.ACCEPT] = normalizedHeaders[HEADERS.ACCEPT] || "application/json";
                    for (var _iterator3 = headerBuilders, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator](); ;) {
                        var _ref4;
                        if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref4 = _iterator3[_i3++];
                        } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref4 = _i3.value;
                        }
                        for (var headerBuilder = _ref4, builtHeaders = headerBuilder(), _iterator4 = Object.keys(builtHeaders), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator](); ;) {
                            var _ref5;
                            if (_isArray4) {
                                if (_i4 >= _iterator4.length) break;
                                _ref5 = _iterator4[_i4++];
                            } else {
                                _i4 = _iterator4.next();
                                if (_i4.done) break;
                                _ref5 = _i4.value;
                            }
                            var _key4 = _ref5;
                            normalizedHeaders[_key4.toLowerCase()] = builtHeaders[_key4];
                        }
                    }
                    var xhr = new win.XMLHttpRequest();
                    xhr.addEventListener("load", function() {
                        var responseHeaders = parseHeaders(this.getAllResponseHeaders()), corrID = responseHeaders["paypal-debug-id"] || "unknown";
                        responseHeaders["paypal-debug-id"] && corrids.push(responseHeaders["paypal-debug-id"]);
                        if (!this.status) return reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: no response status code. Correlation id: " + corrID));
                        var contentType = responseHeaders["content-type"], isJSON = contentType && (0 === contentType.indexOf("application/json") || 0 === contentType.indexOf("text/json")), res = this.responseText;
                        try {
                            res = JSON.parse(this.responseText);
                        } catch (err) {
                            if (isJSON) return reject(new Error("Invalid json: " + this.responseText + ". Correlation id: " + corrID));
                        }
                        if (this.status >= 400) {
                            var message = "Request to " + method.toLowerCase() + " " + url + " failed with " + this.status + " error. Correlation id: " + corrID;
                            if (res) {
                                "object" === (void 0 === res ? "undefined" : _typeof(res)) && null !== res && (res = JSON.stringify(res, null, 4));
                                message = message + "\n\n" + res + "\n";
                            }
                            return reject(new Error(message));
                        }
                        return resolve(res);
                    }, !1);
                    xhr.addEventListener("error", function(evt) {
                        var corrID = this.getResponseHeader("paypal-debug-id");
                        reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: " + evt.toString() + ". Correlation id: " + corrID));
                    }, !1);
                    xhr.open(method, url, !0);
                    for (var _key2 in normalizedHeaders) normalizedHeaders.hasOwnProperty(_key2) && xhr.setRequestHeader(_key2, normalizedHeaders[_key2]);
                    json ? body = JSON.stringify(json) : data && (body = Object.keys(data).map(function(key) {
                        return encodeURIComponent(key) + "=" + (data ? encodeURIComponent(data[key]) : "");
                    }).join("&"));
                    xhr.timeout = timeout;
                    xhr.ontimeout = function() {
                        reject(new Error("Request to " + method.toLowerCase() + " " + url + " has timed out"));
                    };
                    xhr.send(body);
                });
            }
            __webpack_exports__.a = request;
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, HEADERS = {
                CONTENT_TYPE: "content-type",
                ACCEPT: "accept"
            }, headerBuilders = [], corrids = [];
            Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.b)(function() {
                return {
                    prev_corr_ids: corrids.join(",")
                };
            });
            request.get = function(url) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return request(_extends({
                    method: "get",
                    url: url
                }, options));
            };
            request.post = function(url, data) {
                var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return request(_extends({
                    method: "post",
                    url: url,
                    data: data
                }, options));
            };
            request.addHeaderBuilder = function(method) {
                headerBuilders.push(method);
            };
        },
        "./src/lib/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            var __WEBPACK_IMPORTED_MODULE_0__device__ = __webpack_require__("./src/lib/device.js");
            __webpack_require__.d(__webpack_exports__, "w", function() {
                return __WEBPACK_IMPORTED_MODULE_0__device__.b;
            });
            __webpack_require__.d(__webpack_exports__, "A", function() {
                return __WEBPACK_IMPORTED_MODULE_0__device__.c;
            });
            __webpack_require__.d(__webpack_exports__, "B", function() {
                return __WEBPACK_IMPORTED_MODULE_0__device__.e;
            });
            __webpack_require__.d(__webpack_exports__, "C", function() {
                return __WEBPACK_IMPORTED_MODULE_0__device__.f;
            });
            __webpack_require__.d(__webpack_exports__, "V", function() {
                return __WEBPACK_IMPORTED_MODULE_0__device__.g;
            });
            var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/lib/util.js");
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.a;
            });
            __webpack_require__.d(__webpack_exports__, "e", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.b;
            });
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.c;
            });
            __webpack_require__.d(__webpack_exports__, "k", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.d;
            });
            __webpack_require__.d(__webpack_exports__, "D", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.g;
            });
            __webpack_require__.d(__webpack_exports__, "F", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.h;
            });
            __webpack_require__.d(__webpack_exports__, "G", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.i;
            });
            __webpack_require__.d(__webpack_exports__, "H", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.j;
            });
            __webpack_require__.d(__webpack_exports__, "J", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.k;
            });
            __webpack_require__.d(__webpack_exports__, "K", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.l;
            });
            __webpack_require__.d(__webpack_exports__, "M", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.m;
            });
            __webpack_require__.d(__webpack_exports__, "R", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.n;
            });
            __webpack_require__.d(__webpack_exports__, "T", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.o;
            });
            __webpack_require__.d(__webpack_exports__, "U", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.p;
            });
            __webpack_require__.d(__webpack_exports__, "W", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.q;
            });
            __webpack_require__.d(__webpack_exports__, "Y", function() {
                return __WEBPACK_IMPORTED_MODULE_1__util__.r;
            });
            var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("./src/lib/logger.js");
            __webpack_require__.d(__webpack_exports__, "v", function() {
                return __WEBPACK_IMPORTED_MODULE_2__logger__.a;
            });
            __webpack_require__.d(__webpack_exports__, "S", function() {
                return __WEBPACK_IMPORTED_MODULE_2__logger__.b;
            });
            var __WEBPACK_IMPORTED_MODULE_3__eligibility__ = __webpack_require__("./src/lib/eligibility.js");
            __webpack_require__.d(__webpack_exports__, "c", function() {
                return __WEBPACK_IMPORTED_MODULE_3__eligibility__.a;
            });
            __webpack_require__.d(__webpack_exports__, "y", function() {
                return __WEBPACK_IMPORTED_MODULE_3__eligibility__.b;
            });
            var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__("./src/lib/errors.js");
            __webpack_require__.d(__webpack_exports__, "b", function() {
                return __WEBPACK_IMPORTED_MODULE_4__errors__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_5__dom__ = __webpack_require__("./src/lib/dom.js");
            __webpack_require__.d(__webpack_exports__, "d", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.a;
            });
            __webpack_require__.d(__webpack_exports__, "g", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.b;
            });
            __webpack_require__.d(__webpack_exports__, "h", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.c;
            });
            __webpack_require__.d(__webpack_exports__, "l", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.e;
            });
            __webpack_require__.d(__webpack_exports__, "m", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.f;
            });
            __webpack_require__.d(__webpack_exports__, "n", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.g;
            });
            __webpack_require__.d(__webpack_exports__, "p", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.h;
            });
            __webpack_require__.d(__webpack_exports__, "x", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.i;
            });
            __webpack_require__.d(__webpack_exports__, "E", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.j;
            });
            __webpack_require__.d(__webpack_exports__, "I", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.k;
            });
            __webpack_require__.d(__webpack_exports__, "O", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.l;
            });
            __webpack_require__.d(__webpack_exports__, "X", function() {
                return __WEBPACK_IMPORTED_MODULE_5__dom__.m;
            });
            var __WEBPACK_IMPORTED_MODULE_6__http__ = __webpack_require__("./src/lib/http.js");
            __webpack_require__.d(__webpack_exports__, "Q", function() {
                return __WEBPACK_IMPORTED_MODULE_6__http__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_8__throttle__ = (__webpack_require__("./src/lib/beacon.js"), 
            __webpack_require__("./src/lib/throttle.js"));
            __webpack_require__.d(__webpack_exports__, "q", function() {
                return __WEBPACK_IMPORTED_MODULE_8__throttle__.a;
            });
            __webpack_require__.d(__webpack_exports__, "u", function() {
                return __WEBPACK_IMPORTED_MODULE_8__throttle__.b;
            });
            var __WEBPACK_IMPORTED_MODULE_10__session__ = (__webpack_require__("./src/lib/namespace.js"), 
            __webpack_require__("./src/lib/session.js"));
            __webpack_require__.d(__webpack_exports__, "i", function() {
                return __WEBPACK_IMPORTED_MODULE_10__session__.a;
            });
            __webpack_require__.d(__webpack_exports__, "s", function() {
                return __WEBPACK_IMPORTED_MODULE_10__session__.c;
            });
            __webpack_require__.d(__webpack_exports__, "t", function() {
                return __WEBPACK_IMPORTED_MODULE_10__session__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_12__meta__ = (__webpack_require__("./src/lib/proxy.js"), 
            __webpack_require__("./src/lib/meta.js"));
            __webpack_require__.d(__webpack_exports__, "L", function() {
                return __WEBPACK_IMPORTED_MODULE_12__meta__.a;
            });
            var __WEBPACK_IMPORTED_MODULE_13__funding__ = __webpack_require__("./src/lib/funding.js");
            __webpack_require__.d(__webpack_exports__, "o", function() {
                return __WEBPACK_IMPORTED_MODULE_13__funding__.a;
            });
            __webpack_require__.d(__webpack_exports__, "z", function() {
                return __WEBPACK_IMPORTED_MODULE_13__funding__.b;
            });
            __webpack_require__.d(__webpack_exports__, "N", function() {
                return __WEBPACK_IMPORTED_MODULE_13__funding__.c;
            });
            __webpack_require__.d(__webpack_exports__, "P", function() {
                return __WEBPACK_IMPORTED_MODULE_13__funding__.d;
            });
            var __WEBPACK_IMPORTED_MODULE_14__script__ = __webpack_require__("./src/lib/script.js");
            __webpack_require__.d(__webpack_exports__, "j", function() {
                return __WEBPACK_IMPORTED_MODULE_14__script__.a;
            });
            __webpack_require__.d(__webpack_exports__, "r", function() {
                return __WEBPACK_IMPORTED_MODULE_14__script__.b;
            });
        },
        "./src/lib/logger.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getRefererDomain() {
                return window.xchild && window.xchild.getParentDomain ? window.xchild.getParentDomain() : window.location.host;
            }
            function getToken() {
                if (window.root && window.root.token) return window.root.token;
                var queryToken = Object(__WEBPACK_IMPORTED_MODULE_7__dom__.g)("token");
                return queryToken || void 0;
            }
            function initLogger() {
                setupProxyLogTransport();
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.b)(function() {
                    return {
                        referer: getRefererDomain(),
                        host: window.location.host,
                        path: window.location.pathname,
                        env: __WEBPACK_IMPORTED_MODULE_3__config__.n.env,
                        country: __WEBPACK_IMPORTED_MODULE_3__config__.n.locale.country,
                        lang: __WEBPACK_IMPORTED_MODULE_3__config__.n.locale.lang,
                        uid: Object(__WEBPACK_IMPORTED_MODULE_4__session__.c)(),
                        ver: "4.0.173"
                    };
                });
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.a)(function() {
                    return {
                        state: __WEBPACK_IMPORTED_MODULE_3__config__.n.state
                    };
                });
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.c)(function() {
                    var _ref, payload = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, sessionID = Object(__WEBPACK_IMPORTED_MODULE_4__session__.c)(), paymentToken = getToken(), buttonSessionID = payload[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.BUTTON_SESSION_UID] || Object(__WEBPACK_IMPORTED_MODULE_4__session__.a)(), contextType = void 0, contextID = void 0;
                    if (paymentToken) {
                        contextType = __WEBPACK_IMPORTED_MODULE_3__config__.e.CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_3__config__.j.EC_TOKEN];
                        contextID = paymentToken;
                    } else if (buttonSessionID) {
                        contextType = __WEBPACK_IMPORTED_MODULE_3__config__.e.CONTEXT_TYPE.BUTTON_SESSION_ID;
                        contextID = buttonSessionID;
                    } else {
                        contextType = payload[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.CONTEXT_TYPE];
                        contextID = payload[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.CONTEXT_ID];
                    }
                    return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.FEED] = __WEBPACK_IMPORTED_MODULE_3__config__.e.FEED.CHECKOUTJS, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.DATA_SOURCE] = __WEBPACK_IMPORTED_MODULE_3__config__.e.DATA_SOURCE.CHECKOUT, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.CONTEXT_TYPE] = contextType, _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.CONTEXT_ID] = contextID, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.SELLER_ID] = __WEBPACK_IMPORTED_MODULE_3__config__.n.merchantID, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.SESSION_UID] = sessionID, _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.BUTTON_SESSION_UID] = buttonSessionID, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.VERSION] = __WEBPACK_IMPORTED_MODULE_3__config__.n.version, 
                    _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.TOKEN] = paymentToken, _ref[__WEBPACK_IMPORTED_MODULE_3__config__.e.KEY.REFERER] = getRefererDomain(), 
                    _ref;
                });
                var prefix = "ppxo";
                Object(__WEBPACK_IMPORTED_MODULE_6__util__.d)("log_domain_prefix") && (prefix = prefix + "_" + window.location.host.replace(/[^a-zA-Z0-9_]/g, "_").replace(/^www_/, "").replace(/_com$/, ""));
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.k)({
                    uri: __WEBPACK_IMPORTED_MODULE_3__config__.n.loggerUrl,
                    heartbeat: !1,
                    logPerformance: !1,
                    prefix: prefix,
                    logLevel: "warn"
                });
            }
            function setLogLevel(logLevel) {
                if (-1 === __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.l.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
                __WEBPACK_IMPORTED_MODULE_3__config__.n.logLevel = logLevel;
                __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.d.logLevel = logLevel;
                __WEBPACK_IMPORTED_MODULE_0_post_robot_src__.CONFIG.LOG_LEVEL = logLevel;
                window.LOG_LEVEL = logLevel;
            }
            __webpack_exports__.a = initLogger;
            __webpack_exports__.b = setLogLevel;
            var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__("./src/lib/session.js"), __WEBPACK_IMPORTED_MODULE_5__proxy__ = __webpack_require__("./src/lib/proxy.js"), __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("./src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_7__dom__ = __webpack_require__("./src/lib/dom.js"), setupProxyLogTransport = Object(__WEBPACK_IMPORTED_MODULE_6__util__.l)(function() {
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.n)(Object(__WEBPACK_IMPORTED_MODULE_5__proxy__.a)("log", Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.l)(window), Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__.h)()));
            });
        },
        "./src/lib/meta.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return openMetaFrame;
            });
            var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__device__ = __webpack_require__("./src/lib/device.js"), __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_5__script__ = __webpack_require__("./src/lib/script.js"), __WEBPACK_IMPORTED_MODULE_6__dom__ = __webpack_require__("./src/lib/dom.js"), openMetaFrame = Object(__WEBPACK_IMPORTED_MODULE_4__util__.i)(function() {
                var env = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__config__.n.env;
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__device__.e)()) return {
                        iframeEligible: !1,
                        iframeEligibleReason: "ie_intranet",
                        rememberedFunding: []
                    };
                    var metaFrameUrl = __WEBPACK_IMPORTED_MODULE_2__config__.n.metaFrameUrls[env], metaFrameDomain = __WEBPACK_IMPORTED_MODULE_2__config__.n.paypalDomains[env];
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__.a.try(function() {
                        if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge) return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__.bridge.openBridge(Object(__WEBPACK_IMPORTED_MODULE_6__dom__.b)(metaFrameUrl, {
                            version: Object(__WEBPACK_IMPORTED_MODULE_5__script__.b)()
                        }), metaFrameDomain).then(__WEBPACK_IMPORTED_MODULE_4__util__.j);
                        throw new Error("Opening meta window without bridge support is not currently supported");
                    }).then(function(win) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__.once)("meta", {
                            domain: metaFrameDomain,
                            window: win
                        });
                    }).then(function(_ref) {
                        return _ref.data;
                    });
                });
            });
        },
        "./src/lib/namespace.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.assign;
        },
        "./src/lib/pptm.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function createPptmScript() {
                var _track;
                if (window.location.hostname) if (Boolean(Object(__WEBPACK_IMPORTED_MODULE_3__dom__.d)(__WEBPACK_IMPORTED_MODULE_1__config__.k))) Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("pptm_tried_loading_twice"); else {
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__.e.STATE.PPTM, 
                    _track[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__.e.TRANSITION.PPTM_LOAD, 
                    _track));
                    var fullUrl = Object(__WEBPACK_IMPORTED_MODULE_3__dom__.b)(__WEBPACK_IMPORTED_MODULE_1__config__.n.pptmUrl, {
                        t: "xo",
                        id: window.location.hostname,
                        mrid: __WEBPACK_IMPORTED_MODULE_1__config__.n.merchantID
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_3__dom__.j)(fullUrl, 0, {
                        async: !0,
                        id: __WEBPACK_IMPORTED_MODULE_1__config__.k
                    }).then(function() {
                        var _track2;
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__.e.STATE.PPTM, 
                        _track2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__.e.TRANSITION.PPTM_LOADED, 
                        _track2));
                    }).catch(function(err) {
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.f)("pptm_script_error", {
                            error: Object(__WEBPACK_IMPORTED_MODULE_2__util__.o)(err)
                        });
                    });
                }
            }
            __webpack_exports__.a = createPptmScript;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_3__dom__ = __webpack_require__("./src/lib/dom.js");
        },
        "./src/lib/proxy.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function proxyMethod(name, win, originalMethod) {
                if (win && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.f)() === __WEBPACK_IMPORTED_MODULE_2__config__.n.paypalDomain && !Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.u)(win)) {
                    win && Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.send)(win, "proxy_" + name, {
                        originalMethod: originalMethod
                    }).catch(__WEBPACK_IMPORTED_MODULE_3__util__.j);
                    return originalMethod;
                }
                var methods = [];
                Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__.on)("proxy_" + name, {
                    domain: __WEBPACK_IMPORTED_MODULE_2__config__.n.paypal_domain_regex
                }, function(_ref) {
                    var data = _ref.data;
                    methods.push(data.originalMethod);
                });
                return function() {
                    var _this = this, _arguments = arguments;
                    methods = methods.filter(function(method) {
                        return !Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__.y)(method.source);
                    });
                    return methods.length ? methods[methods.length - 1].apply(this, arguments).catch(function() {
                        return originalMethod.apply(_this, _arguments);
                    }) : originalMethod.apply(this, arguments);
                };
            }
            __webpack_exports__.a = proxyMethod;
            var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js"), __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js");
        },
        "./src/lib/script.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isPayPalObjects() {
                return Boolean(getCurrentScript());
            }
            function getScriptVersion() {
                return isPayPalObjects() ? "4" : "4.0.173";
            }
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return getCurrentScript;
            });
            __webpack_exports__.b = getScriptVersion;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js"), getCurrentScript = Object(__WEBPACK_IMPORTED_MODULE_2__util__.i)(function() {
                for (var scripts = Array.prototype.slice.call(document.getElementsByTagName("script")), _iterator = scripts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var script = _ref;
                    if (script.src && (script.src.replace(/^https?:/, "").split("?")[0] === __WEBPACK_IMPORTED_MODULE_1__config__.n.scriptUrl || script.hasAttribute("data-paypal-checkout"))) return script;
                    if (script.src && -1 !== script.src.indexOf("paypal.checkout.v4.js")) return script;
                }
                document.currentScript && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_not_recognized", {
                    src: document.currentScript.src
                });
            });
        },
        "./src/lib/session.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function getStorageState(handler) {
                var enabled = Object(__WEBPACK_IMPORTED_MODULE_1__util__.f)(), storage = void 0;
                if (accessedStorage) storage = accessedStorage; else if (enabled) {
                    var rawStorage = window.localStorage.getItem(LOCAL_STORAGE_KEY);
                    storage = rawStorage ? JSON.parse(rawStorage) : {};
                } else storage = window[LOCAL_STORAGE_KEY] = window.__pp_localstorage__ || {};
                accessedStorage = storage;
                var result = handler(storage);
                enabled ? window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage)) : window[LOCAL_STORAGE_KEY] = storage;
                accessedStorage = null;
                return result;
            }
            function getSession(handler) {
                return getStorageState(function(storage) {
                    var session = storage[SESSION_KEY], now = Date.now();
                    session && now - session.created > __WEBPACK_IMPORTED_MODULE_0__config__.n.session_uid_lifetime && (session = null);
                    session || (session = {
                        guid: Object(__WEBPACK_IMPORTED_MODULE_1__util__.q)(),
                        created: now
                    });
                    storage[SESSION_KEY] = session;
                    return handler(session);
                });
            }
            function getSessionState(handler) {
                return getSession(function(session) {
                    session.state = session.state || {};
                    return handler(session.state);
                });
            }
            function getSessionID() {
                if (window.xprops && window.xprops.sessionID) return window.xprops.sessionID;
                var querySessionID = Object(__WEBPACK_IMPORTED_MODULE_2__dom__.g)("sessionID");
                return Object(__WEBPACK_IMPORTED_MODULE_1__util__.g)() && querySessionID ? querySessionID : getSession(function(session) {
                    return session.guid;
                });
            }
            function getButtonSessionID() {
                if (window.xprops && window.xprops.buttonSessionID) return window.xprops.buttonSessionID;
                var querySessionID = Object(__WEBPACK_IMPORTED_MODULE_2__dom__.g)("buttonSessionID");
                return Object(__WEBPACK_IMPORTED_MODULE_1__util__.g)() && querySessionID ? querySessionID : getSessionID();
            }
            function getGlobalState(handler) {
                window[GLOBAL_KEY] = window[GLOBAL_KEY] || {};
                return handler(window[GLOBAL_KEY]);
            }
            __webpack_exports__.e = getStorageState;
            __webpack_exports__.d = getSessionState;
            __webpack_exports__.c = getSessionID;
            __webpack_exports__.a = getButtonSessionID;
            __webpack_exports__.b = getGlobalState;
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__("./src/lib/dom.js"), LOCAL_STORAGE_KEY = "__paypal_storage__", SESSION_KEY = "__paypal_session__", GLOBAL_KEY = "__paypal_global__", accessedStorage = void 0;
        },
        "./src/lib/throttle.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isCheckpointUnique(name) {
                return Object(__WEBPACK_IMPORTED_MODULE_3__session__.d)(function(state) {
                    state.loggedBeacons = state.loggedBeacons || [];
                    if (-1 === state.loggedBeacons.indexOf(name)) {
                        state.loggedBeacons.push(name);
                        return !0;
                    }
                    return !1;
                });
            }
            function getThrottle(name, sample) {
                var uid = Object(__WEBPACK_IMPORTED_MODULE_3__session__.c)(), throttle = Object(__WEBPACK_IMPORTED_MODULE_2__util__.e)(name + "_" + uid) % 1e4, group = void 0;
                group = throttle < sample ? "test" : sample >= 5e3 || sample <= throttle && throttle < 2 * sample ? "control" : "throttle";
                var treatment = name + "_" + group, started = !1, forced = !1;
                try {
                    window.localStorage && window.localStorage.getItem(name) && (forced = !0);
                } catch (err) {}
                return {
                    isEnabled: function() {
                        return "test" === group || forced;
                    },
                    isDisabled: function() {
                        return "test" !== group && !forced;
                    },
                    getTreatment: function() {
                        return treatment;
                    },
                    log: function(checkpointName) {
                        var payload = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (isCheckpointUnique(name + "_" + treatment)) {
                            var _extends2;
                            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)(_extends((_extends2 = {}, 
                            _extends2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__.e.STATE.PXP, 
                            _extends2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__.e.TRANSITION.PXP, 
                            _extends2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.EXPERIMENT_NAME] = name, _extends2[__WEBPACK_IMPORTED_MODULE_1__config__.e.KEY.TREATMENT_NAME] = treatment, 
                            _extends2), payload));
                        }
                        var event = name + "_" + treatment + "_" + checkpointName;
                        isCheckpointUnique(event) && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)(event, _extends({}, payload, {
                            expuid: uid
                        }));
                        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g)();
                        return this;
                    },
                    logStart: function() {
                        var payload = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        started = !0;
                        return this.log("start", payload);
                    },
                    logComplete: function() {
                        var payload = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return started ? this.log("complete", payload) : this;
                    }
                };
            }
            function getReturnToken() {
                var token = Object(__WEBPACK_IMPORTED_MODULE_2__util__.h)(window.location.href, /token=((EC-)?[A-Z0-9]+)/), payer = Object(__WEBPACK_IMPORTED_MODULE_2__util__.h)(window.location.href, /PayerID=([A-Z0-9]+)/);
                if (token && payer) return token;
            }
            __webpack_exports__.b = getThrottle;
            __webpack_exports__.a = getReturnToken;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js"), __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__("./src/lib/session.js"), _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            };
        },
        "./src/lib/util.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function isPayPalDomain() {
                return Boolean((window.location.protocol + "//" + window.location.host).match(__WEBPACK_IMPORTED_MODULE_3__config__.n.paypal_domain_regex)) || "mock://www.paypal.com" === window.mockDomain;
            }
            function memoize(method) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, cache = {};
                return function() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                    var key = void 0;
                    try {
                        key = JSON.stringify(Array.prototype.slice.call(arguments));
                    } catch (err) {
                        throw new Error("Arguments not serializable -- can not be used to memoize");
                    }
                    var time = options.time;
                    cache[key] && time && Date.now() - cache[key].time < time && delete cache[key];
                    window.__CACHE_START_TIME__ && cache[key] && cache[key].time < window.__CACHE_START_TIME__ && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    cache[key] = {
                        time: Date.now(),
                        value: method.apply(this, arguments)
                    };
                    return cache[key].value;
                };
            }
            function noop() {}
            function once(method) {
                var called = !1;
                return function() {
                    if (!called) {
                        called = !0;
                        return method.apply(this, arguments);
                    }
                };
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + __WEBPACK_IMPORTED_MODULE_0_hi_base32___default.a.encode(new Date().toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            function hashStr(str) {
                for (var hash = 0, i = 0; i < str.length; i++) hash += str[i].charCodeAt(0) * Math.pow(i % 10 + 1, 5);
                return Math.floor(Math.pow(Math.sqrt(hash), 5));
            }
            function match(str, pattern) {
                var regmatch = str.match(pattern);
                if (regmatch) return regmatch[1];
            }
            function safeJSON(item) {
                return JSON.stringify(item, function(key, val) {
                    if ("function" == typeof val) return "<" + (void 0 === val ? "undefined" : _typeof(val)) + ">";
                    try {
                        JSON.stringify(val);
                    } catch (err) {
                        return "<" + (void 0 === val ? "undefined" : _typeof(val)) + ">";
                    }
                    return val;
                });
            }
            function eventEmitter() {
                var listeners = [];
                return {
                    listen: function(method) {
                        listeners.push(method);
                        return {
                            cancel: function() {
                                listeners.splice(listeners.indexOf(method), 1);
                            }
                        };
                    },
                    once: function(method) {
                        var listener = this.listen(function() {
                            method.apply(null, arguments);
                            listener.cancel();
                        });
                    },
                    trigger: function() {
                        for (var _iterator = listeners, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            _ref.apply(void 0, arguments);
                        }
                    }
                };
            }
            function onKey(obj, key, callback) {
                if (obj) {
                    var value = obj[key];
                    value && (value = callback(value) || value);
                    try {
                        delete obj[key];
                        Object.defineProperty(obj, key, {
                            configurable: !0,
                            set: function(item) {
                                value = item;
                                value && (value = callback(value) || value);
                            },
                            get: function() {
                                return value;
                            }
                        });
                    } catch (err) {}
                }
            }
            function awaitKey(obj, key) {
                return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a(function(resolve) {
                    return onKey(obj, key, resolve);
                });
            }
            function stringifyError(err) {
                return err ? err instanceof Error ? err.stack : "function" == typeof err.toString ? err.toString() : Object.prototype.toString.call(err) : "<unknown error: " + Object.prototype.toString.call(err) + ">";
            }
            function stringifyErrorMessage(err) {
                var defaultMessage = "<unknown error: " + Object.prototype.toString.call(err) + ">";
                return err ? err instanceof Error ? err.message || defaultMessage : "string" == typeof err.message ? err.message || defaultMessage : defaultMessage : defaultMessage;
            }
            function getDomainSetting(name, def) {
                var hostname = window.xchild ? window.xchild.getParentDomain() : Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__.f)();
                hostname = hostname.split("://")[1];
                if (__WEBPACK_IMPORTED_MODULE_3__config__.n.domain_settings) for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_3__config__.n.domain_settings), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator](); ;) {
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var domain = _ref2, index = hostname.indexOf(domain);
                    if (-1 !== index && hostname.slice(index) === domain) return __WEBPACK_IMPORTED_MODULE_3__config__.n.domain_settings[domain][name];
                }
                return def;
            }
            function patchMethod(obj, name, handler) {
                var original = obj[name];
                obj[name] = function() {
                    var _this = this, _arguments = arguments;
                    return handler({
                        context: this,
                        args: arguments,
                        original: original,
                        callOriginal: function() {
                            return original.apply(_this, _arguments);
                        }
                    });
                };
            }
            function extend(obj, source) {
                if (!source) return obj;
                for (var _key2 in source) source.hasOwnProperty(_key2) && (obj[_key2] = source[_key2]);
                return obj;
            }
            function values(obj) {
                var result = [];
                for (var _key5 in obj) obj.hasOwnProperty(_key5) && result.push(obj[_key5]);
                return result;
            }
            __webpack_exports__.g = isPayPalDomain;
            __webpack_exports__.i = memoize;
            __webpack_exports__.j = noop;
            __webpack_exports__.l = once;
            __webpack_exports__.q = uniqueID;
            __webpack_exports__.e = hashStr;
            __webpack_exports__.h = match;
            __webpack_exports__.n = safeJSON;
            __webpack_exports__.b = eventEmitter;
            __webpack_exports__.k = onKey;
            __webpack_exports__.a = awaitKey;
            __webpack_exports__.o = stringifyError;
            __webpack_exports__.p = stringifyErrorMessage;
            __webpack_require__.d(__webpack_exports__, "f", function() {
                return isLocalStorageEnabled;
            });
            __webpack_exports__.d = getDomainSetting;
            __webpack_exports__.m = patchMethod;
            __webpack_exports__.c = extend;
            __webpack_exports__.r = values;
            var __WEBPACK_IMPORTED_MODULE_0_hi_base32__ = __webpack_require__("./node_modules/hi-base32/src/base32.js"), __WEBPACK_IMPORTED_MODULE_0_hi_base32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hi_base32__), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js"), __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js"), _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            }, isLocalStorageEnabled = memoize(function() {
                try {
                    if (window.localStorage) {
                        var _value = Math.random().toString();
                        window.localStorage.setItem("__test__localStorage__", _value);
                        var result = window.localStorage.getItem("__test__localStorage__");
                        window.localStorage.removeItem("__test__localStorage__");
                        if (_value === result) return !0;
                    }
                } catch (err) {}
                return !1;
            });
        },
        "./src/setup.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            function domainToEnv(domain) {
                for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_2__config__.n.paypalUrls), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var _env = _ref;
                    if (__WEBPACK_IMPORTED_MODULE_2__config__.n.paypalUrls[_env] === domain) return _env;
                }
            }
            function configure() {
                var _ref2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, env = _ref2.env, stage = _ref2.stage, apiStage = _ref2.apiStage, state = _ref2.state, logLevel = _ref2.logLevel, merchantID = _ref2.merchantID;
                if (env) {
                    if (!__WEBPACK_IMPORTED_MODULE_2__config__.n.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    delete __WEBPACK_IMPORTED_MODULE_2__config__.n.env;
                    __WEBPACK_IMPORTED_MODULE_2__config__.n.env = env;
                }
                if (stage) {
                    delete __WEBPACK_IMPORTED_MODULE_2__config__.n.stage;
                    __WEBPACK_IMPORTED_MODULE_2__config__.n.stage = stage;
                }
                if (apiStage) {
                    delete __WEBPACK_IMPORTED_MODULE_2__config__.n.apiStage;
                    __WEBPACK_IMPORTED_MODULE_2__config__.n.apiStage = apiStage;
                }
                if (state) {
                    delete __WEBPACK_IMPORTED_MODULE_2__config__.n.state;
                    __WEBPACK_IMPORTED_MODULE_2__config__.n.state = state;
                }
                merchantID && (__WEBPACK_IMPORTED_MODULE_2__config__.n.merchantID = merchantID);
                logLevel ? Object(__WEBPACK_IMPORTED_MODULE_3__lib__.S)(logLevel) : Object(__WEBPACK_IMPORTED_MODULE_3__lib__.S)(__WEBPACK_IMPORTED_MODULE_2__config__.n.logLevel);
            }
            function setup() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                configure(options);
                init(options);
            }
            __webpack_exports__.a = setup;
            var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js"), __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js"), __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js"), __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js"), __WEBPACK_IMPORTED_MODULE_4__lib_pptm__ = __webpack_require__("./src/lib/pptm.js");
            !function(domain) {
                var currentDomainEnv = domainToEnv(domain);
                currentDomainEnv && "test" !== currentDomainEnv && (__WEBPACK_IMPORTED_MODULE_2__config__.n.env = currentDomainEnv);
            }(window.location.protocol + "//" + window.location.host);
            __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__.a.onPossiblyUnhandledException(function(err) {
                var _track;
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.f)("unhandled_error", {
                    stack: Object(__WEBPACK_IMPORTED_MODULE_3__lib__.T)(err),
                    errtype: {}.toString.call(err)
                });
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.ERROR_CODE] = "checkoutjs_error", 
                _track[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.ERROR_DESC] = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.U)(err), 
                _track));
                return Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.g)().catch(function(err2) {
                    if (window.console) try {
                        window.console.error ? window.console.error("Error flushing:", err2.stack || err2.toString()) : window.console.log && window.console.log("Error flushing:", err2.stack || err2.toString());
                    } catch (err3) {
                        setTimeout(function() {
                            throw err3;
                        }, 1);
                    }
                });
            });
            var currentScript = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.j)(), currentProtocol = window.location.protocol.split(":")[0], init = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.K)(function(_ref3) {
                var precacheRemembered = _ref3.precacheRemembered;
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.y)() || Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.p)("ineligible");
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.b)();
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.v)();
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.D)() || Object(__WEBPACK_IMPORTED_MODULE_4__lib_pptm__.a)();
                precacheRemembered && Object(__WEBPACK_IMPORTED_MODULE_3__lib__.N)();
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__.k)("force_bridge") && !Object(__WEBPACK_IMPORTED_MODULE_3__lib__.D)() && Object(__WEBPACK_IMPORTED_MODULE_3__lib__.L)(__WEBPACK_IMPORTED_MODULE_2__config__.n.env);
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.j)("setup_" + __WEBPACK_IMPORTED_MODULE_2__config__.n.env);
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_protocol_" + currentProtocol);
            });
            currentScript ? setup({
                env: currentScript.getAttribute("data-env"),
                stage: currentScript.getAttribute("data-stage"),
                apiStage: currentScript.getAttribute("data-api-stage"),
                state: currentScript.getAttribute("data-state"),
                logLevel: currentScript.getAttribute("data-log-level"),
                merchantID: currentScript.getAttribute("data-merchant-id"),
                precacheRemembered: currentScript.hasAttribute("data-precache-remembered-funding")
            }) : setup();
            if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib__.D)()) if (currentScript) {
                var _track2, scriptProtocol = currentScript.src.split(":")[0], loadTime = Object(__WEBPACK_IMPORTED_MODULE_3__lib__.p)(currentScript.src);
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_protocol_" + scriptProtocol);
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_protocol_" + (currentProtocol === scriptProtocol ? "match" : "mismatch"));
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_version_" + __WEBPACK_IMPORTED_MODULE_2__config__.n.version.replace(/[^0-9a-zA-Z]+/g, "_"));
                if (loadTime) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_time", {
                        loadTime: loadTime
                    });
                    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_time_" + Math.floor(loadTime / 1e3));
                }
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_2__config__.e.STATE.LOAD, 
                _track2[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_2__config__.e.TRANSITION.SCRIPT_LOAD, 
                _track2[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.TRANSITION_TIME] = loadTime, 
                _track2));
            } else {
                var _track3;
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("no_current_script");
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("no_current_script_version_" + __WEBPACK_IMPORTED_MODULE_2__config__.n.version.replace(/[^0-9a-zA-Z]+/g, "_"));
                document.currentScript && Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.e)("current_script_not_recognized", {
                    src: document.currentScript.src
                });
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__.o)((_track3 = {}, _track3[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.STATE] = __WEBPACK_IMPORTED_MODULE_2__config__.e.STATE.LOAD, 
                _track3[__WEBPACK_IMPORTED_MODULE_2__config__.e.KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_2__config__.e.TRANSITION.SCRIPT_LOAD, 
                _track3));
            }
        }
    });
});
//# sourceMappingURL=checkout.lib.js.map

/***/ }),

/***/ 1083:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return B; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return C; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return D; });
/* unused harmony export E */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_routes_Checkout_components_NewUserForm__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_routes_Checkout_components_GiftRecipient__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_routes_Checkout_components_BonusOffers__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_Checkout_components_PaymentOptions__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_components_Order__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_AddressOptions__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_Checkout_components_NewShippingAddressForm__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_routes_Checkout_components_OrderSummary__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__ = __webpack_require__(1125);
/* eslint-disable react/prop-types */












var A = {
  id: 'A',
  path: 'user',
  children: function children(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__["a" /* default */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_routes_Checkout_components_NewUserForm__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_routes_Checkout_components_GiftRecipient__["a" /* default */], null)
    );
  },
  // subheading: 'Have an account? Log in for faster checkout',
  subheading: ' ',
  buttonText: 'Review order >',
  buttonTextInvalid: 'Enter Your Info to Continue'
};

var B = {
  id: 'B',
  path: 'options',
  children: function children(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__["a" /* default */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_routes_Checkout_components_BonusOffers__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_routes_Checkout_components_PaymentOptions__["a" /* default */], { totalIsZero: props.totalIsZero })
    );
  },
  subheading: 'Your purchase',
  subheadingIsZero: 'Your order',
  buttonText: 'Select payment method >',
  buttonTextInvalid: 'Select an Option',
  buttonTextIsZero: 'Continue'
};

var C = {
  id: 'C',
  path: 'address',
  children: function children(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__["a" /* default */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_AddressOptions__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_routes_Checkout_components_NewShippingAddressForm__["a" /* default */], null)
    );
  },
  subheading: 'Your shipping info',
  buttonText: 'Review order >',
  buttonTextInvalid: 'Enter Your Info to Continue'
};

var D = {
  id: 'D',
  path: 'order',
  children: function children(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__["a" /* default */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_routes_Checkout_components_Order__["a" /* default */], {
        processOrder: props.processOrder,
        startBraintree: props.startBraintree,
        totalIsZero: props.totalIsZero
      })
    );
  },
  subheading: 'Payment Method',
  subheadingIsZero: 'Confirmation',
  buttonText: 'Enter credit card details',
  buttonTextInvalid: 'Enter credit card details'
  //button Text for zero order is set on zero order component
};

var E = {
  id: 'E',
  children: function children(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_routes_Checkout_containers_OrderForm_Step__["a" /* default */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_routes_Checkout_components_OrderSummary__["a" /* default */], null)
    );
  },
  subheading: 'Order Summary',
  buttonText: 'Place order',
  buttonTextInvalid: 'Review Your Order'
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(A, 'A', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Steps/index.jsx');

  __REACT_HOT_LOADER__.register(B, 'B', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Steps/index.jsx');

  __REACT_HOT_LOADER__.register(C, 'C', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Steps/index.jsx');

  __REACT_HOT_LOADER__.register(D, 'D', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Steps/index.jsx');

  __REACT_HOT_LOADER__.register(E, 'E', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Steps/index.jsx');
}();

;

/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewUserForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_NewBillingZipForm__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_modal__ = __webpack_require__(100);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-duplicate-props */












var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    button: theme.button,
    Input: theme.Input,
    input: theme.input
  };
};

var NewUserForm = function (_React$Component) {
  _inherits(NewUserForm, _React$Component);

  function NewUserForm(props) {
    _classCallCheck(this, NewUserForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);

    if (props.newUser) {
      _this.state = { user: props.newUser };
    } else {
      _this.state = {
        user: {
          email: '',
          firstName: '',
          lastName: '',
          phone: ''
        }
      };
    }
    return _this;
  }

  NewUserForm.prototype.componentWillMount = function componentWillMount() {
    this.props.updateStepValidity();
  };

  NewUserForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newUser = nextProps.newUser;

    this.setState({ user: newUser });
  };

  NewUserForm.prototype.handleChange = function handleChange(name) {
    var _this2 = this;

    var _props = this.props,
        updateStepValidity = _props.updateStepValidity,
        setNewUser = _props.setNewUser;

    return function (event) {
      var user = _this2.state.user;

      user[name] = event.target.value;
      var newUser = _extends({}, user);
      setNewUser(newUser);
      updateStepValidity();
    };
  };

  NewUserForm.prototype.render = function render() {
    var _props2 = this.props,
        classes = _props2.classes,
        productName = _props2.productName;
    var _state$user = this.state.user,
        email = _state$user.email,
        firstName = _state$user.firstName,
        lastName = _state$user.lastName,
        phone = _state$user.phone;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { paddingBottom: '16px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12, style: { paddingBottom: '0' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
            {
              type: 'subheading'
            },
            'To complete your ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              productName
            ),
            ' purchase, please enter your name, email, phone number and billing postal code below.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
            {
              style: { padding: '1.0em 0 0.5em 0' },
              type: 'subheading'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Your Billing Information'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'firstName' },
            name: 'firstName',
            placeholder: 'First Name',
            required: true,
            value: firstName,
            onChange: this.handleChange('firstName')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'lastName' },
            name: 'lastName',
            placeholder: 'Last Name',
            required: true,
            value: lastName,
            onChange: this.handleChange('lastName')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'email' },
            name: 'email',
            placeholder: 'Email',
            required: true,
            value: email,
            onChange: this.handleChange('email')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'phone' },
            name: 'phone',
            placeholder: 'Billing Phone Number',
            value: phone,
            onChange: this.handleChange('phone')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_NewBillingZipForm__["a" /* default */], null)
      )
    );
  };

  return NewUserForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewUserForm.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    textField: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
  }).isRequired,
  newUser: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    firstName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    lastName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    email: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    phone: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    emailIsValid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
  }).isRequired,
  productName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  setNewUser: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

NewUserForm.defaultProps = {
  productName: ''
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    newUser: state.checkout.newUser,
    productName: state.checkout.Product.name
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateStepValidity: function updateStepValidity() {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].updateStepValidity('A'));
    },
    login: function login() {
      dispatch(__WEBPACK_IMPORTED_MODULE_9_modules_modal__["a" /* actions */].openModal('login'));
    },
    setNewUser: function setNewUser(user) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].setNewUser(user));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(muiThemeStyles)(NewUserForm));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewUserForm/index.jsx');

  __REACT_HOT_LOADER__.register(NewUserForm, 'NewUserForm', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewUserForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewUserForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewUserForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewUserForm/index.jsx');
}();

;

/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewBillingZip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-duplicate-props */










var _updateStepValidity = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].updateStepValidity,
    _setNewAddress = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].setNewAddress,
    _setSelectedBillingAddress = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].setSelectedBillingAddress,
    _loadTotals = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].loadTotals;


var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    Input: theme.Input,
    input: theme.input
  };
};

var NewBillingZip = function (_Component) {
  _inherits(NewBillingZip, _Component);

  function NewBillingZip(props) {
    _classCallCheck(this, NewBillingZip);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    var newBillingAddress = props.newBillingAddress;

    if (newBillingAddress && newBillingAddress.postalCode) {
      _this.state = { postalCode: newBillingAddress.postalCode };
    } else {
      _this.state = { postalCode: '' };
    }
    return _this;
  }

  NewBillingZip.prototype.componentWillMount = function componentWillMount() {
    // this.props.updateStepValidity();
  };

  NewBillingZip.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (newProps.newBillingAddress.postalCode !== this.state.postalCode) {
      this.setState({ postalCode: newProps.newBillingAddress.postalCode });
    }
  };

  NewBillingZip.prototype.handleChange = function handleChange(event) {
    this.props.setNewAddress({ postalCode: event.target.value });
    if (this.props.selectedBillingAddressId !== '0') {
      this.props.setSelectedBillingAddress('0');
    }
    this.props.updateStepValidity();
  };

  NewBillingZip.prototype.handleBlur = function handleBlur() {
    this.props.loadTotals();
  };

  NewBillingZip.prototype.render = function render() {
    var postalCode = this.state.postalCode;
    var classes = this.props.classes;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
        className: classes.textField,
        InputProps: { className: classes.Input },
        inputProps: { className: classes.input, id: 'postalCode' },
        name: 'postalCode',
        placeholder: 'ZIP / Postal code',
        value: postalCode,
        required: true,
        onChange: this.handleChange,
        onFocus: this.handleChange,
        onBlur: this.handleBlur
      })
    );
  };

  return NewBillingZip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

NewBillingZip.propTypes = {
  newBillingAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ postalCode: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string }).isRequired,
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  selectedBillingAddressId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  loadTotals: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setNewAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setSelectedBillingAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    newBillingAddress: state.checkout.newBillingAddress,
    newShippingAddress: state.checkout.newShippingAddress,
    selectedBillingAddressId: state.checkout.selectedBillingAddressId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateStepValidity: function updateStepValidity() {
      dispatch(_updateStepValidity('A'));
    },
    setNewAddress: function setNewAddress(address) {
      var addressType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'newBillingAddress';

      dispatch(_setNewAddress(address, addressType));
    },
    setSelectedBillingAddress: function setSelectedBillingAddress(id) {
      dispatch(_setSelectedBillingAddress(id));
    },
    loadTotals: function loadTotals() {
      dispatch(_loadTotals());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(muiThemeStyles)(NewBillingZip));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_updateStepValidity, 'updateStepValidity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(_setNewAddress, 'setNewAddress', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(_setSelectedBillingAddress, 'setSelectedBillingAddress', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(_loadTotals, 'loadTotals', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(NewBillingZip, 'NewBillingZip', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewBillingZipForm/index.jsx');
}();

;

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._1uT_u{margin:0;padding-right:6px;border-bottom:1px solid #d3d3d3}._1uT_u,.B25pO{color:grey;font-family:Helvetica}.B25pO{margin-top:-30px;z-index:0;font-size:1.2rem}", ""]);

// exports
exports.locals = {
	"zipTextField": "_1uT_u",
	"floater": "B25pO"
};

/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GiftRecipient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-duplicate-props */












var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    button: theme.button,
    Input: theme.Input,
    input: theme.input
  };
};

var GiftRecipient = function (_React$Component) {
  _inherits(GiftRecipient, _React$Component);

  function GiftRecipient(props) {
    _classCallCheck(this, GiftRecipient);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleChange = function () {
      return _this.__handleChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleToggle = function () {
      return _this.__handleToggle__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  GiftRecipient.prototype.__handleChange__REACT_HOT_LOADER__ = function __handleChange__REACT_HOT_LOADER__(name) {
    var _props = this.props,
        giftRecipient = _props.giftRecipient,
        setGiftRecipient = _props.setGiftRecipient,
        updateStepValidity = _props.updateStepValidity;

    return function (event) {
      giftRecipient[name] = event.target.value;
      var newGiftRecipient = _extends({}, giftRecipient);
      setGiftRecipient(newGiftRecipient);
      updateStepValidity();
    };
  };

  GiftRecipient.prototype.__handleToggle__REACT_HOT_LOADER__ = function __handleToggle__REACT_HOT_LOADER__() {
    var _props2 = this.props,
        isGift = _props2.isGift,
        toggleIsGift = _props2.toggleIsGift,
        updateStepValidity = _props2.updateStepValidity;

    toggleIsGift(!isGift);
    updateStepValidity();
  };

  GiftRecipient.prototype.render = function render() {
    var _props3 = this.props,
        classes = _props3.classes,
        giftable = _props3.giftable,
        _props3$giftRecipient = _props3.giftRecipient,
        firstName = _props3$giftRecipient.firstName,
        lastName = _props3$giftRecipient.lastName,
        email = _props3$giftRecipient.email,
        isGift = _props3.isGift;


    if (!giftable) {
      return null;
    }

    var giftRecipientInputStyle = { marginRight: '8px' };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12, id: 'giftRecipientComponent', className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.border, style: { margin: '0 8px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { container: true, justify: 'center', className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.hover, onClick: this.handleToggle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 1 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default.a, {
            inputProps: { id: 'giftRecipientCheckbox' },
            color: 'primary',
            checked: isGift
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 11 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            { id: 'giftRecipientPrompt',
              unselectable: 'on',
              style: { marginTop: '10px', marginLeft: '16px', userSelect: 'none' },
              type: 'subheading'
            },
            'Click here if this is a gift for someone else.'
          )
        )
      ),
      isGift ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { id: 'giftRecipientForm', container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12, style: { paddingLeft: '12px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            {
              type: 'subheading'
            },
            'Recipient\'s name and email.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input, style: giftRecipientInputStyle },
            inputProps: { className: classes.input, id: 'giftRecipientFirstName' },
            placeholder: 'First Name',
            required: true,
            value: firstName,
            onChange: this.handleChange('firstName')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input, style: giftRecipientInputStyle },
            inputProps: { className: classes.input, id: 'giftRecipientLastName' },
            placeholder: 'Last Name',
            required: true,
            value: lastName,
            onChange: this.handleChange('lastName')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12, style: { paddingBottom: '16px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input, style: giftRecipientInputStyle },
            inputProps: { className: classes.input, id: 'giftRecipientEmail' },
            placeholder: 'Email',
            required: true,
            value: email,
            onChange: this.handleChange('email')
          })
        )
      ) : null
    );
  };

  return GiftRecipient;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

GiftRecipient.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    textField: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired
  }).isRequired,
  giftRecipient: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    firstName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    lastName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    email: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  }).isRequired,
  giftable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  isGift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  setGiftRecipient: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  toggleIsGift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    giftable: state.checkout.giftable,
    giftRecipient: state.checkout.giftRecipient,
    isGift: state.checkout.isGift
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateStepValidity: function updateStepValidity() {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].updateStepValidity('A'));
    },
    setGiftRecipient: function setGiftRecipient(giftRecipient) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].setGiftRecipient(giftRecipient));
    },
    toggleIsGift: function toggleIsGift(bool) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].toggleIsGift(bool));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(muiThemeStyles)(GiftRecipient));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/GiftRecipient/index.jsx');

  __REACT_HOT_LOADER__.register(GiftRecipient, 'GiftRecipient', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/GiftRecipient/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/GiftRecipient/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/GiftRecipient/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/GiftRecipient/index.jsx');
}();

;

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = __webpack_require__(1090);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _IndeterminateCheckBox = __webpack_require__(1094);

var _IndeterminateCheckBox2 = _interopRequireDefault(_IndeterminateCheckBox);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

function Checkbox(props) {
  var _classNames;

  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties3.default)(props, ['checkedIcon', 'classes', 'color', 'icon', 'indeterminate', 'indeterminateIcon']);

  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      default: classes.default,
      checked: checkedClass,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Checkbox.defaultProps = {
  color: 'secondary',
  indeterminate: false,
  indeterminateIcon: _react2.default.createElement(_IndeterminateCheckBox2.default, null)
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCheckbox' })(Checkbox);

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(19);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(17);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(20);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _CheckBoxOutlineBlank = __webpack_require__(1091);

var _CheckBoxOutlineBlank2 = _interopRequireDefault(_CheckBoxOutlineBlank);

var _CheckBox = __webpack_require__(1092);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(1014);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none'
  },
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  },
  default: {},
  checked: {},
  disabled: {}
};

/**
 * @ignore - internal component.
 */

var SwitchBase = function (_React$Component) {
  (0, _inherits3.default)(SwitchBase, _React$Component);

  function SwitchBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwitchBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwitchBase.__proto__ || (0, _getPrototypeOf2.default)(SwitchBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.input = null, _this.isControlled = null, _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({ checked: checked });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SwitchBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;


      this.isControlled = props.checked != null;

      if (!this.isControlled) {
        // not controlled, use internal state
        this.setState({
          checked: props.defaultChecked !== undefined ? props.defaultChecked : false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          checkedProp = _props.checked,
          checkedIcon = _props.checkedIcon,
          classes = _props.classes,
          classNameProp = _props.className,
          disabledProp = _props.disabled,
          iconProp = _props.icon,
          id = _props.id,
          inputProps = _props.inputProps,
          inputRef = _props.inputRef,
          name = _props.name,
          onChange = _props.onChange,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'checkedIcon', 'classes', 'className', 'disabled', 'icon', 'id', 'inputProps', 'inputRef', 'name', 'onChange', 'tabIndex', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var className = (0, _classnames2.default)(classes.root, classes.default, classNameProp, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checked, checked), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames));

      var icon = checked ? checkedIcon : iconProp;

      var hasLabelFor = type === 'checkbox' || type === 'radio';

      return _react2.default.createElement(
        _IconButton2.default,
        (0, _extends3.default)({
          component: 'span',
          className: className,
          disabled: disabled,
          tabIndex: null,
          role: undefined
        }, other),
        icon,
        _react2.default.createElement('input', (0, _extends3.default)({
          id: hasLabelFor && id,
          type: type,
          name: name,
          checked: checked,
          onChange: this.handleInputChange,
          className: classes.input,
          disabled: disabled,
          tabIndex: tabIndex,
          value: value,
          ref: inputRef
        }, inputProps))
      );
    }
  }]);
  return SwitchBase;
}(_react2.default.Component);

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

SwitchBase.defaultProps = {
  checkedIcon: _react2.default.createElement(_CheckBox2.default, null),
  disableRipple: false,
  icon: _react2.default.createElement(_CheckBoxOutlineBlank2.default, null),
  type: 'checkbox'
};

SwitchBase.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitchBase' })(SwitchBase);

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(122);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(250);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });

var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBoxOutlineBlank = (0, _pure2.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = CheckBoxOutlineBlank;

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(122);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(250);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });

var CheckBox = function CheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBox = (0, _pure2.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';

exports.default = CheckBox;

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(252);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(51);

var _reactHelpers = __webpack_require__(166);

__webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ensure CSS specificity

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: theme.spacing.unit * 6,
      height: theme.spacing.unit * 6,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      })
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};

/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */
function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled']);


  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), className),
      centerRipple: true,
      focusRipple: true,
      disabled: disabled
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      _react2.default.Children.map(children, function (child) {
        if ((0, _reactHelpers.isMuiElement)(child, ['Icon', 'SvgIcon'])) {
          return _react2.default.cloneElement(child, { fontSize: true });
        }
        return child;
      })
    )
  );
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes2.default.bool
} : {};

IconButton.defaultProps = {
  color: 'default',
  disabled: false,
  disableRipple: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIconButton' })(IconButton);

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(122);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(250);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' });

var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
IndeterminateCheckBox = (0, _pure2.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = IndeterminateCheckBox;

/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1096);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, ".h9TfH{background-color:#f7fff1;border:2px solid #289b18;border-radius:4px}._2Ia4a:hover{cursor:pointer}", ""]);

// exports
exports.locals = {
	"border": "h9TfH",
	"hover": "_2Ia4a"
};

/***/ }),

/***/ 1097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Checkbox__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_RadioButtonUnchecked__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_RadioButtonUnchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_RadioButtonUnchecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Select__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-unused-prop-types */
















var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    Input: theme.Input,
    input: theme.input
  };
};

var _loadTotals = __WEBPACK_IMPORTED_MODULE_12_modules_checkout__["a" /* actions */].loadTotals,
    updateBumpOfferQuantity = __WEBPACK_IMPORTED_MODULE_12_modules_checkout__["a" /* actions */].updateBumpOfferQuantity,
    updateQuantity = __WEBPACK_IMPORTED_MODULE_12_modules_checkout__["a" /* actions */].updateQuantity,
    _updateStepValidity = __WEBPACK_IMPORTED_MODULE_12_modules_checkout__["a" /* actions */].updateStepValidity;

var BonusOffers = function (_PureComponent) {
  _inherits(BonusOffers, _PureComponent);

  function BonusOffers(props) {
    _classCallCheck(this, BonusOffers);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.handleChangeProductQuantity = function () {
      return _this.__handleChangeProductQuantity__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleChangeBumpOfferQuantity = function () {
      return _this.__handleChangeBumpOfferQuantity__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.formatDescription = function () {
      return _this.__formatDescription__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = { currentOption: { id: 'init', BumpOffers: [] } };
    return _this;
  }

  BonusOffers.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        OfferPaymentOptions = _props.OfferPaymentOptions,
        selectedPaymentOption = _props.selectedPaymentOption;

    if (!!OfferPaymentOptions && this.state.currentOption.id !== selectedPaymentOption) {
      OfferPaymentOptions.map(function (option) {
        if (option.id === selectedPaymentOption) {
          _this2.setState({ currentOption: option });
        }
      });
    }
    this.props.updateStepValidity();
  };

  BonusOffers.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    var OfferPaymentOptions = nextProps.OfferPaymentOptions,
        selectedPaymentOption = nextProps.selectedPaymentOption;

    if (this.state.currentOption.id !== selectedPaymentOption && OfferPaymentOptions) {
      OfferPaymentOptions.map(function (option) {
        if (option.id === selectedPaymentOption) {
          _this3.setState({ currentOption: option });
        }
      });
    }
  };

  BonusOffers.prototype.__handleChangeProductQuantity__REACT_HOT_LOADER__ = function __handleChangeProductQuantity__REACT_HOT_LOADER__(e) {
    var newQuantity = Number(e.target.value);
    if (newQuantity >= 1) {
      this.props.selectProductQuantity(newQuantity);
    }

    this.props.loadTotals();
  };

  BonusOffers.prototype.__handleChangeBumpOfferQuantity__REACT_HOT_LOADER__ = function __handleChangeBumpOfferQuantity__REACT_HOT_LOADER__(option) {
    var _this4 = this;

    return function (e) {
      var BumpOffers = _this4.props.BumpOffers;

      if (e.target.value === 0) {
        for (var i in BumpOffers) {
          if (BumpOffers[i].id === option.id) {
            if (BumpOffers[i].selected) {
              _this4.props.toggleOffer(BumpOffers[i]);
            }
          }
        }
      } else if (e.target.value !== 0) {
        var isSelected = false;

        for (var _i in BumpOffers) {
          if (BumpOffers[_i].id === option.id) {
            isSelected = true;
          }
        }

        if (!isSelected) {
          _this4.props.toggleOffer(option);
        }
      }

      _this4.props.selectBumpOfferQuantity(e.target.value, option.id);
      _this4.props.loadTotals();
    };
  };

  BonusOffers.prototype.__formatDescription__REACT_HOT_LOADER__ = function __formatDescription__REACT_HOT_LOADER__() {
    var _props2 = this.props,
        isGift = _props2.isGift,
        OfferPaymentOptions = _props2.OfferPaymentOptions;

    if (isGift) {
      return '';
    } else if (OfferPaymentOptions.length > 2) {
      return 'or multi-payments';
    } else if (OfferPaymentOptions.length === 1) {
      return '';
    }
    var otherOption = void 0;
    OfferPaymentOptions.map(function (option) {
      if (option.numInstallments !== 1) {
        otherOption = option;
      }
    });
    return 'or ' + otherOption.numInstallments + ' ' + otherOption.interval + 'ly payments';
  };

  BonusOffers.prototype.render = function render() {
    var _this5 = this;

    var _props3 = this.props,
        BumpOffers = _props3.BumpOffers,
        bumpOfferQuantities = _props3.bumpOfferQuantities,
        classes = _props3.classes,
        Product = _props3.Product,
        quantity = _props3.quantity,
        selectProductQuantity = _props3.selectProductQuantity;
    var currentOption = this.state.currentOption;

    var currentBumpOffers = currentOption.BumpOffers;
    var selectedBumpOfferIds = [];
    BumpOffers.map(function (bumpOffer) {
      selectedBumpOfferIds.push(bumpOffer.OfferPaymentOptionBumpOffer.BumpOfferId);
    });

    var description = Product.description || '';
    var contentUrl = "https://cdn.foodrevolution.org/checkout/";
    var thisProductUrl = this.props.thisProductUrl ? this.props.thisProductUrl : 'placeholder.png';

    var MenuProps = {
      className: classes.Input,
      PaperProps: {
        style: {
          maxHeight: '240px',
          width: 250
        }
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { marginTop: '12px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default.a,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItem"],
          {
            className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.listItemThisProduct,
            dense: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
            { container: true, direction: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
              { item: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.imageContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a, {
                  item: true,
                  xs: 3,
                  className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.imageItem,
                  style: {
                    backgroundImage: 'url(' + contentUrl + thisProductUrl + ')'
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { item: true, xs: 9, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.headlineItem },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                    {
                      className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.headlineTypography,
                      variant: 'headline',
                      color: 'primary'
                    },
                    Product.name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                    {
                      variant: 'body1',
                      className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.descriptionTypography,
                      color: 'primary'
                    },
                    description
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
              { item: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { item: true, xs: 3, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainerItem1 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkboxContainer },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Checkbox___default.a, {
                      checked: true,
                      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_RadioButtonUnchecked___default.a, { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.radioButtonUnchecked }),
                      checkedIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkCircleShadow, color: 'primary' })
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                      {
                        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.inCartTypography,
                        style: { color: '#289B18' },
                        variant: 'body1'
                      },
                      'In cart'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { item: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.minWidth },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { container: true, alignItems: 'baseline', style: { alignItems: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                      { item: true },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                        { container: true, alignItems: 'flex-end' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                          {
                            className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.amountTypography,
                            style: {
                              color: '#289B18'
                            },
                            color: 'primary',
                            type: 'body1'
                          },
                          '$' + currentOption.amount + ' '
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                      { item: true },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                        {
                          className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.paymentOptionsTypography,
                          style: { color: '#289B18', maxWidth: '300px', marginLeft: '8px' },
                          color: 'primary',
                          type: 'body1'
                        },
                        currentOption.numInstallments === 1 ? '' + this.formatDescription() : 'today & ' + (currentOption.numInstallments - 1) + ' ' + currentOption.interval + 'ly payments'
                      )
                    )
                  )
                )
              )
            ),
            Product.quantifiable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { container: true, alignItems: 'center', style: { paddingLeft: '16px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { item: true, xs: 3, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainerItem1 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                    {
                      className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.inCartTypography,
                      color: 'primary',
                      variant: 'body1'
                    },
                    'Quantity:'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { item: true, xs: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_material_ui_Select___default.a,
                    {
                      className: classes.textField,
                      MenuProps: MenuProps,
                      color: 'primary',
                      disableUnderline: true,
                      inputProps: { id: 'quantity', className: classes.input },
                      name: 'quantity',
                      value: quantity,
                      style: {
                        fontSize: '1.2rem',
                        color: '#289B18',
                        transform: 'translateX(-18px) translateY(4px)',
                        width: '58px'
                      },
                      onChange: this.handleChangeProductQuantity
                    },
                    Array.apply(undefined, Array(99)).map(function (u, index) {
                      var hackyIndex = index + 100;
                      if (index !== 0) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__["MenuItem"],
                          { style: { fontSize: '1.2rem' }, value: index },
                          index
                        );
                      }
                    })
                  )
                )
              )
            ) : null
          )
        ),
        currentBumpOffers.map(function (option) {
          var _ref;

          if (!option) return null;
          var thisBumpOfferQuantity = 0;

          for (var i in BumpOffers) {
            if (BumpOffers[i].id === option.id) {
              thisBumpOfferQuantity = BumpOffers[i].quantity;
              break;
            }
          }

          option.selected = selectedBumpOfferIds.includes(option.OfferPaymentOptionBumpOffer.BumpOfferId);
          var border = thisBumpOfferQuantity > 0 ? __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.solidBorder : __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.dashedBorder;
          var image = option.image ? option.image : 'placeholder.png';

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItem"],
            {
              color: 'secondary',
              className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.listItemBumpOffer + ' ' + border,
              style: { backgroundColor: 'rgba(255,153,0,0.05)' },
              key: option.name,
              button: true,
              disableRipple: true,
              dense: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
              { container: true, direction: 'column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { item: true, onClick: function onClick() {
                    return _this5.props.toggleOffer(option);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.imageContainer },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a, {
                    item: true,
                    xs: 3,
                    className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.imageItem,
                    style: { backgroundImage: 'url(' + contentUrl + image + ')' }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true, xs: 9, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.headlineItem },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                      {
                        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.headlineTypography,
                        variant: 'headline'
                      },
                      option.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                      {
                        style: { fontSize: '1rem' },
                        variant: 'body1'
                      },
                      option.description
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { item: true, onClick: function onClick() {
                    return _this5.props.toggleOffer(option);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainer },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true, xs: 3, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainerItem1 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                      { container: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkboxContainer },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Checkbox___default.a, {
                        checked: option.selected,
                        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_RadioButtonUnchecked___default.a, { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.radioButtonUnchecked }),
                        checkedIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.checkCircleShadow, color: 'secondary' })
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                        {
                          className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.inCartTypography,
                          style: { color: 'black' },
                          variant: 'body1'
                        },
                        'Add it!'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.minWidth },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                      { container: true, alignItems: 'baseline', style: { alignItems: 'center' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                        { item: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                          { container: true, alignItems: 'flex-end' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                            {
                              className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.amountTypography,
                              style: { color: 'black' },
                              type: 'body1'
                            },
                            '$' + option.OfferPaymentOptionBumpOffer.amount + ' '
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                        { item: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                          {
                            className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.paymentOptionsTypography,
                            style: { color: 'black', maxWidth: '300px', marginLeft: '8px' },
                            type: 'body1'
                          },
                          currentOption.numInstallments === 1 ? '' + _this5.formatDescription() : 'today & ' + (currentOption.numInstallments - 1) + ' ' + currentOption.interval + 'ly payments'
                        )
                      )
                    )
                  )
                )
              ),
              option.Product.quantifiable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                  { container: true, alignItems: 'center', style: { paddingLeft: '16px' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true, xs: 3, className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.lowerContainerItem1 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                      {
                        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.inCartTypography,
                        style: { color: 'black' },
                        variant: 'body1'
                      },
                      'Quantity:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_material_ui_Select___default.a,
                      {
                        className: classes.textField,
                        MenuProps: MenuProps,
                        inputProps: { id: 'bumpOffer' + option.id, className: classes.input },
                        name: 'bumpOfferQuantity',
                        disableUnderline: true,
                        value: thisBumpOfferQuantity,
                        style: (_ref = {
                          fontSize: '1.2rem', width: '100%', transform: 'translateX(-18px) translateY(4px)' }, _ref['width'] = '58px', _ref),
                        onChange: _this5.handleChangeBumpOfferQuantity(option)
                      },
                      Array.apply(undefined, Array(99)).map(function (u, index) {
                        var hackyIndex = index + 100;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__["MenuItem"],
                          { style: { fontSize: '1.2rem' }, value: index },
                          index
                        );
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,
                    { item: true, xs: 7, onClick: function onClick() {
                        return _this5.props.toggleOffer(option);
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a, null)
                  )
                )
              ) : null
            )
          );
        })
      )
    );
  };

  return BonusOffers;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

BonusOffers.propTypes = {
  BumpOffers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  isGift: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  OfferPaymentOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  Product: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  }),
  selectedPaymentOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  thisProductUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  toggleOffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

BonusOffers.defaultProps = {
  thisProductUrl: 'placeholder.png',
  OfferPaymentOptions: {}
};

BonusOffers.defaultProps = {
  BumpOffers: [],
  Product: {
    description: ''
  },
  selectedPaymentOption: 0
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    BumpOffers: state.checkout.BumpOffers,
    bumpOfferQuanties: state.checkout.bumpOfferQuanties,
    description: state.checkout.description,
    isGift: state.checkout.isGift,
    OfferPaymentOptions: state.checkout.OfferPaymentOptions,
    productAmount: state.checkout.productAmount,
    Product: state.checkout.Product,
    quantity: state.checkout.quantity,
    selectedPaymentOption: state.checkout.selectedPaymentOption,
    thisProductUrl: state.checkout.image,
    totals: state.checkout.totals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadTotals: function loadTotals() {
      dispatch(_loadTotals());
    },
    toggleOffer: function toggleOffer(option) {
      dispatch(__WEBPACK_IMPORTED_MODULE_12_modules_checkout__["a" /* actions */].clickBumpOffer(option));
    },
    updateStepValidity: function updateStepValidity() {
      dispatch(_updateStepValidity('B'));
    },
    selectProductQuantity: function selectProductQuantity(quantity) {
      dispatch(updateQuantity(quantity));
    },
    selectBumpOfferQuantity: function selectBumpOfferQuantity(quantity, id) {
      dispatch(updateBumpOfferQuantity(quantity, id));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__["withStyles"])(muiThemeStyles)(BonusOffers));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(_loadTotals, 'loadTotals', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(updateBumpOfferQuantity, 'updateBumpOfferQuantity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(updateQuantity, 'updateQuantity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(_updateStepValidity, 'updateStepValidity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(BonusOffers, 'BonusOffers', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BonusOffers/index.jsx');
}();

;

/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ListItem = __webpack_require__(396);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      height: theme.spacing.unit * 3,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),
    selected: {}
  };
}; // @inheritedComponent ListItem

function MenuItem(props) {
  var classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'selected', 'role']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.selected, selected), classNameProp);

  return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: className,
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * Use to apply selected styling.
   */
  selected: _propTypes2.default.bool
} : {};

MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenuItem' })(MenuItem);

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1100);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._2i_Jw{background-color:#f7fff1;border:2px solid #289b18;border-radius:4px;padding:.75rem}._2UqzS{background-color:#ffcc80;border:2px solid #ff8100;border-radius:4px;padding:.75rem;margin-top:16px}._25wHz{border:2px solid #ff8100}._2Bvkk{border:2px dashed #ff8100}._2Pp5e{padding:1rem;padding-left:\"8px\"}._3gGyu{height:5rem;background-size:contain,cover;background-position:top;background-repeat:no-repeat}._2S7WG{padding-top:0}._3T1ks{padding-right:0;overflow:none;line-height:1}._3b0dl{font-size:1rem}._3Nl6g{height:3.5em;align-items:baseline}._2Ze5F{padding-right:0}._3y4ux{align-items:baseline;textDecoration:none}._1gXkX{min-width:100px}._2WOUz,._2zu6o{transform:translateY(6px)}._3F0sV{font-weight:400;font-size:.75rem;margin-left:-4px}.li5ui{text-decoration:none;line-height:1;padding-left:8px}._3lsC9{font-size:.8rem;padding-right:0}@media only screen and (min-width:530px){._3F0sV{font-size:1rem}}", ""]);

// exports
exports.locals = {
	"listItemThisProduct": "_2i_Jw",
	"listItemBumpOffer": "_2UqzS",
	"solidBorder": "_25wHz",
	"dashedBorder": "_2Bvkk",
	"imageContainer": "_2Pp5e",
	"imageItem": "_3gGyu",
	"headlineItem": "_2S7WG",
	"headlineTypography": "_3T1ks",
	"descriptionTypography": "_3b0dl",
	"lowerContainer": "_3Nl6g",
	"lowerContainerItem1": "_2Ze5F",
	"checkboxContainer": "_3y4ux",
	"minWidth": "_1gXkX",
	"radioButtonUnchecked": "_2WOUz",
	"checkCircleShadow": "_2zu6o",
	"inCartTypography": "_3F0sV",
	"amountTypography": "li5ui",
	"paymentOptionsTypography": "_3lsC9"
};

/***/ }),

/***/ 1101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_SVG_CheckCircleShadow__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_icons_RadioButtonUnchecked__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_icons_RadioButtonUnchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_icons_RadioButtonUnchecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var loadTotals = __WEBPACK_IMPORTED_MODULE_9_modules_checkout__["a" /* actions */].loadTotals,
    _updateStepValidity = __WEBPACK_IMPORTED_MODULE_9_modules_checkout__["a" /* actions */].updateStepValidity,
    setSelectedPaymentOption = __WEBPACK_IMPORTED_MODULE_9_modules_checkout__["a" /* actions */].setSelectedPaymentOption;

var PaymentOptions = function (_PureComponent) {
  _inherits(PaymentOptions, _PureComponent);

  function PaymentOptions(props) {
    _classCallCheck(this, PaymentOptions);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.formatDescription = function () {
      return _this.__formatDescription__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.numberWithCommas = function () {
      return _this.__numberWithCommas__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    var options = [];
    _this.state = { options: options };
    return _this;
  }

  PaymentOptions.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.options && this.props.options.length) {
      var options = [];

      if (this.props.options.length === 1) {
        this.props.clickPaymentOption(this.props.options[0].id);
      }

      this.props.options.map(function (option) {
        if (option.numInstallments !== 1) {
          options.push(option);
        } else {
          // default: add the numInstallments = 1 option to the top of the list
          _this2.props.clickPaymentOption(option.id);
          options.unshift(option);
        }
      });
      this.setState({ options: options, haveOptions: true });
    }
    // if (this.props.totals.default === true) {
    //   this.props.updateTotals();
    // }
  };

  PaymentOptions.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this3 = this;

    if (newProps.totals.default) {
      this.props.updateTotals();
    }

    if (newProps.options.length && !this.state.haveOptions) {
      if (!newProps.selectedPaymentOption) {
        this.props.clickPaymentOption(newProps.options[0].id);
      }

      var options = [];
      newProps.options.map(function (option) {
        if (option.numInstallments !== 1) {
          options.push(option);
        } else {
          _this3.props.clickPaymentOption(option.id);
          options.unshift(option);
        }
      });
      this.setState({ options: options, haveOptions: true });
    }
  };

  PaymentOptions.prototype.__formatDescription__REACT_HOT_LOADER__ = function __formatDescription__REACT_HOT_LOADER__(option) {
    if (option.numInstallments === 1) {
      return ' 1 payment today';
    }
    return ' ' + option.numInstallments + ' ' + option.interval + 'ly payments';
  };

  PaymentOptions.prototype.__numberWithCommas__REACT_HOT_LOADER__ = function __numberWithCommas__REACT_HOT_LOADER__(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  PaymentOptions.prototype.render = function render() {
    var _this4 = this;

    if (!this.state.options.length || this.props.totalIsZero) {
      return null;
    }

    var _props = this.props,
        selectedPaymentOption = _props.selectedPaymentOption,
        clickPaymentOption = _props.clickPaymentOption,
        isGift = _props.isGift,
        totals = _props.totals;
    var options = this.state.options;
    var dynamicSize = __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.dynamicSize;


    var TAX = totals.default || !totals[selectedPaymentOption] ? '0.00' : totals[selectedPaymentOption].transaction.tax;
    var SHIPPING = totals.default || !totals[selectedPaymentOption] ? '0.00' : totals[selectedPaymentOption].transaction.shipping;

    var taxAndShippingMessage = '';

    if (TAX !== '0.00') {
      taxAndShippingMessage = 'Based on your postal code, we are required to collect $' + TAX + ' CA sales tax.';
    }

    if (SHIPPING !== '0.00') {
      taxAndShippingMessage = (taxAndShippingMessage !== '' ? ' ' : '') + ('There is a $' + SHIPPING + ' shipping and handling fee for your location.');
    }

    var optionsArray = void 0;
    if (isGift) {
      optionsArray = options.filter(function (option) {
        return option.numInstallments === 1;
      });
    } else {
      optionsArray = options;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { marginTop: '12px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
        {
          style: { marginBottom: '8px', fontWeight: 400 },
          variant: 'headline',
          align: 'center'
        },
        'How would you like to pay?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_List___default.a,
            { style: { borderRadius: '8px', padding: '0' } },
            optionsArray.map(function (value, index) {
              var checked = selectedPaymentOption === value.id;
              var description = _this4.formatDescription(value);
              var total = totals.default || !selectedPaymentOption ? '0.00' : totals[value.id].transaction.subtotal;
              var total1 = total.slice(0, total.length - 3);
              var total2 = total.slice(total.length - 3);

              window.total = total;

              var border = void 0;

              if (optionsArray.length === 1) {
                border = __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.onlyOption;
              }
              if (optionsArray.length > 1 && index === 0) {
                border = __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.topOption;
              }
              if (optionsArray.length > 1 && index < optionsArray.length - 1 && index > 0) {
                border = __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.middleOption;
              }
              if (index === optionsArray.length - 1 && optionsArray.length > 1) {
                border = __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.lastOption;
              }

              var color = checked ? __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.green : __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.black;
              var gradient = checked ? __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.checkedGradient : __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.uncheckedGradient;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],
                {
                  className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.option + ' ' + gradient + ' ' + border,
                  key: value.id,
                  button: true,
                  dense: true,
                  onClick: function onClick() {
                    _this4.props.updateStepValidity();
                    clickPaymentOption(value.id);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                  { container: true, direction: 'row', style: { alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                    { item: true, xs: 1, style: { padding: '0' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default.a, {
                      onChange: function onChange() {
                        return clickPaymentOption(value.id);
                      },
                      checked: checked,
                      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_icons_RadioButtonUnchecked___default.a, null),
                      checkedIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_images_SVG_CheckCircleShadow__["a" /* default */], { color: 'primary' })
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                    { item: true, xs: 11 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                      {
                        container: true,
                        direction: 'row',
                        wrap: 'nowrap',
                        alignItems: 'center',
                        style: { paddingLeft: '4px' }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        {
                          className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.sup + ' ' + color,
                          style: { marginLeft: '8px' },
                          variant: 'display2'
                        },
                        '$'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        {
                          className: color,
                          variant: 'display2'
                        },
                        _this4.numberWithCommas(total1) + ' '
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        {
                          className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.sup + ' ' + color,
                          variant: 'display2'
                        },
                        '' + _this4.numberWithCommas(total2)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                        { item: true, xs: 8 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                          { container: true, alignItems: 'flex-end', spacing: 8, style: { paddingLeft: "8px" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                            {
                              className: color + ' ' + dynamicSize,
                              variant: 'body1',
                              noWrap: true
                            },
                            description
                          ),
                          value.numInstallments !== 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                            {
                              className: color,
                              style: { fontSize: '.75em', marginLeft: '8px', transform: 'translateY(-.4em)' },
                              variant: 'body1'
                            },
                            ' (1 today)'
                          ) : null
                        )
                      )
                    )
                  )
                )
              );
            })
          ),
          taxAndShippingMessage.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            {
              style: { margin: '16px', fontSize: '1em' },
              variant: 'body1'
            },
            taxAndShippingMessage
          ) : null
        )
      )
    );
  };

  return PaymentOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

PaymentOptions.propTypes = {
  clickPaymentOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateTotals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  selectedPaymentOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  totals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    default: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }).isRequired,
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

PaymentOptions.defaultProps = {
  options: [],
  selectedPaymentOption: 0
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    amount: state.checkout.productAmount,
    isGift: state.checkout.isGift,
    options: state.checkout.OfferPaymentOptions,
    selectedPaymentOption: state.checkout.selectedPaymentOption,
    totals: state.checkout.totals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateTotals: function updateTotals() {
      dispatch(loadTotals());
    },
    clickPaymentOption: function clickPaymentOption(id) {
      dispatch(setSelectedPaymentOption(id));
    },
    updateStepValidity: function updateStepValidity() {
      dispatch(_updateStepValidity('B'));
    },
    updateProductAmount: function updateProductAmount(amount) {
      dispatch(__WEBPACK_IMPORTED_MODULE_9_modules_checkout__["a" /* actions */].updateProductAmount(amount));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PaymentOptions);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(loadTotals, 'loadTotals', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(_updateStepValidity, 'updateStepValidity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(setSelectedPaymentOption, 'setSelectedPaymentOption', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(PaymentOptions, 'PaymentOptions', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/PaymentOptions/index.jsx');
}();

;

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._3p2CN{height:75px;border-right:1px solid grey;border-left:1px solid grey;padding-left:12px;padding-right:0}._12RA4{border-radius:8px 8px 8px 8px;border:1px solid grey}._3s8zg{border-radius:8px 8px 0 0}._1uZuG,._3s8zg{border-top:1px solid grey;border-bottom:0}._1uZuG{border-radius:0 0 0 0}._3ZL_i{border-top:1px solid grey;border-bottom:1px solid grey;border-radius:0 0 8px 8px}._2zyBk{background-image:linear-gradient(-180deg,#eee,#d8d8d8)}._3KoaW{background-image:linear-gradient(0deg,#fff,#e4e4e4)}._1aikq{color:#000}._1aikq,.fXTOg{font-weight:400}.fXTOg{color:#289b18}._2WZBJ{font-size:1.25em;padding-right:2px;transform:translateY(-.33em)}._1PSqF{font-size:1em}@media only screen and (min-width:425px){._1PSqF{font-size:1.5em;margin-left:8px}}", ""]);

// exports
exports.locals = {
	"option": "_3p2CN",
	"onlyOption": "_12RA4",
	"topOption": "_3s8zg",
	"middleOption": "_1uZuG",
	"lastOption": "_3ZL_i",
	"checkedGradient": "_2zyBk",
	"uncheckedGradient": "_3KoaW",
	"black": "_1aikq",
	"green": "fXTOg",
	"sup": "_2WZBJ",
	"dynamicSize": "_1PSqF"
};

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_SVG_Amex__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_SVG_Discover__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_SVG_MasterCard__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_SVG_Visa__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_SVG_PayPal__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_icons_RadioButtonUnchecked__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_icons_RadioButtonUnchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_icons_RadioButtonUnchecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ZeroOrder__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_routes_Checkout_components_BraintreeForm__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var setPaymentMethod = __WEBPACK_IMPORTED_MODULE_17_modules_checkout__["a" /* actions */].setPaymentMethod,
    _setSelectedUserPaymentId = __WEBPACK_IMPORTED_MODULE_17_modules_checkout__["a" /* actions */].setSelectedUserPaymentId;


var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    button: theme.button
  };
};

var Order = function (_React$Component) {
  _inherits(Order, _React$Component);

  function Order() {
    _classCallCheck(this, Order);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.handleClick = function () {
      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.numberWithCommas = function () {
      return _this.__numberWithCommas__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    var CollapseProps = {};

    var iOSversion = function iOSversion() {
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later
        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
      } else {
        return null;
      };
    };

    var ver = iOSversion();

    if (ver && ver[0] && ver[0] <= 9) {
      CollapseProps = { style: { transition: 'none', transitionDuration: '0ms' } };
    }

    _this.CollapseProps = CollapseProps;
    return _this;
  }

  Order.prototype.componentDidMount = function componentDidMount() {
    this.props.startBraintree();
  };

  Order.prototype.__handleClick__REACT_HOT_LOADER__ = function __handleClick__REACT_HOT_LOADER__(method) {
    var _this2 = this;

    return function () {
      _this2.props.setMethod(method);
      _this2.props.setSelectedUserPaymentId('0');
    };
  };

  Order.prototype.__numberWithCommas__REACT_HOT_LOADER__ = function __numberWithCommas__REACT_HOT_LOADER__(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  Order.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        selectedPaymentOption = _props.selectedPaymentOption,
        totals = _props.totals,
        classes = _props.classes,
        paymentMethod = _props.paymentMethod,
        processOrder = _props.processOrder,
        setMethod = _props.setMethod,
        totalIsZero = _props.totalIsZero;


    var greyStyle = 'linear-gradient(0deg, #FFFFFF 0%, #E4E4E4 100%)';
    var gradientStyle = 'linear-gradient(-180deg, #EEEEEE 0%, #D8D8D8 100%)';
    var _props$braintreeValid = this.props.braintreeValidity,
        cvvValid = _props$braintreeValid.cvvValid,
        numberValid = _props$braintreeValid.numberValid,
        expirationDateValid = _props$braintreeValid.expirationDateValid;

    var disabled = !cvvValid || !numberValid || !expirationDateValid;

    var TOTAL = totals.default || !totals[selectedPaymentOption] ? '0.00' : totals[selectedPaymentOption].transaction.total;
    var TAX = totals.default || !totals[selectedPaymentOption] ? '0.00' : totals[selectedPaymentOption].transaction.tax;

    var taxMessage = TAX === '' || TAX === '0.00' ? '' : '$' + TAX + ' CA sales tax';
    var SHIPPING = totals.default || !totals[selectedPaymentOption] ? '0.00' : totals[selectedPaymentOption].transaction.shipping;
    var shippingMessage = SHIPPING === '' || SHIPPING === '0.00' ? '' : '$' + SHIPPING + ' S&H';

    var shippingTaxMessage = '' + taxMessage + (shippingMessage && taxMessage ? ' and ' : '') + shippingMessage;
    shippingTaxMessage = shippingTaxMessage ? ' (incl. ' + shippingTaxMessage + ')' : '';

    var total = function total() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_material_ui_Typography___default.a,
        {
          type: 'body2',
          style: { fontWeight: 400 }
        },
        'Your total for today is: $' + _this3.numberWithCommas(TOTAL) + shippingTaxMessage
      );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
      {
        item: true,
        xs: 12,
        className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.gridItem
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: totalIsZero ? 'none' : null } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel___default.a,
          {
            style: { marginBottom: '0px' },
            elevation: 0,
            expanded: paymentMethod === 'braintree',
            onClick: this.handleClick('braintree'),
            CollapseProps: this.CollapseProps
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__["ExpansionPanelSummary"],
            {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.expansionPanelSummary,
              style: {
                backgroundImage: paymentMethod !== 'braintree' ? gradientStyle : greyStyle
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
              { item: true, xs: 12, style: { textAlign: "center" }, className: (paymentMethod === 'braintree' ? __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethodActive : __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethodInactive) + ' ' + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethod },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { position: 'absolute', left: '20px', top: '50%', marginTop: '-14px' } },
                paymentMethod === 'braintree' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__["a" /* default */], { color: 'primary' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_icons_RadioButtonUnchecked___default.a, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_images_SVG_Visa__["a" /* default */], { style: { paddingRight: "5px" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_images_SVG_MasterCard__["a" /* default */], { style: { paddingRight: "5px" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_images_SVG_Amex__["a" /* default */], { style: { paddingRight: "5px" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_images_SVG_Discover__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__["ExpansionPanelDetails"],
            {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.expansionPanelDetails
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
              { container: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_routes_Checkout_components_BraintreeForm__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_material_ui_Button___default.a,
                  {
                    className: classes.button,
                    style: { width: '100%', height: '65px' },
                    id: 'submitCreditCardOrder',
                    variant: 'raised',
                    color: 'primary',
                    disabled: disabled
                  },
                  disabled ? 'Enter Credit Card Details' : 'Order Now'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                total()
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel___default.a,
          {
            style: { marginTop: '0px', marginBottom: '0px' },
            elevation: 0,
            expanded: paymentMethod === 'paypal',
            onClick: function onClick() {
              return setMethod('paypal');
            },
            CollapseProps: { style: { transition: 'none', transitionDuration: '0ms' } }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__["ExpansionPanelSummary"],
            {
              style: {
                backgroundImage: paymentMethod !== 'paypal' ? gradientStyle : greyStyle,
                border: '1px solid grey',
                borderRadius: paymentMethod !== 'paypal' ? '0 0 8px 8px' : '0 0 0 0',
                height: '75px',
                borderTop: paymentMethod === 'paypal' ? '0' : '1px solid grey'
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
              { item: true, xs: 12, style: { textAlign: "center" }, className: (paymentMethod === 'paypal' ? __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethodActive : __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethodInactive) + ' ' + __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.paymentMethod },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { position: 'absolute', left: '20px', top: '50%', marginTop: '-14px' } },
                paymentMethod === 'paypal' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_images_SVG_CheckCircleShadow__["a" /* default */], { color: 'primary' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_icons_RadioButtonUnchecked___default.a, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_images_SVG_PayPal__["a" /* default */], { height: '28px' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_ExpansionPanel__["ExpansionPanelDetails"],
            {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a.expansionPanelDetails,
              style: {
                borderBottom: '1px solid grey',
                borderRadius: '0 0 8px 8px'
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
              { container: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
                  id: '#paypal-button',
                  style: { marginBottom: '16px', marginTop: '16px' }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,
                { item: true, xs: 12 },
                total()
              )
            )
          )
        )
      ),
      totalIsZero ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ZeroOrder__["a" /* default */], { processOrder: processOrder, styles: __WEBPACK_IMPORTED_MODULE_18__styles_scss___default.a }) : null
    );
  };

  return Order;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Order.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  braintreeValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    cvvValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    numberValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    expirationDateValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired,
  paymentMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  selectedPaymentOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedUserPaymentId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  startBraintree: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  stepValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  totalIsZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  totals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

Order.defaultProps = {
  selectedPaymentOption: 0
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    method: state.checkout.paymentMethod,
    stepValidity: state.checkout.stepValidity.D,
    braintreeValidity: state.checkout.braintreeValidity,
    paymentMethod: state.checkout.paymentMethod,
    selectedUserPaymentMethodId: state.checkout.selectedUserPaymentMethodId,
    selectedPaymentOption: state.checkout.selectedPaymentOption,
    totals: state.checkout.totals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setMethod: function setMethod(method) {
      dispatch(setPaymentMethod(method));
    },
    setSelectedUserPaymentId: function setSelectedUserPaymentId(id) {
      dispatch(_setSelectedUserPaymentId(id));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__["withStyles"])(muiThemeStyles)(Order));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(setPaymentMethod, 'setPaymentMethod', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(_setSelectedUserPaymentId, 'setSelectedUserPaymentId', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(Order, 'Order', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/index.jsx');
}();

;

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(19);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(17);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(20);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Collapse = __webpack_require__(1106);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _Paper = __webpack_require__(169);

var _Paper2 = _interopRequireDefault(_Paper);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };

  return {
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': {
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },
    expanded: {
      margin: theme.spacing.unit * 2 + 'px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
}; // @inheritedComponent Paper

var ExpansionPanel = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpansionPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanel.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.isControlled = null, _this.handleChange = function (event) {
      var onChange = _this.props.onChange;

      var expanded = !_this.state.expanded;

      if (onChange) {
        onChange(event, expanded);
      }

      if (!_this.isControlled) {
        _this.setState({ expanded: expanded });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpansionPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          expanded = _props.expanded,
          defaultExpanded = _props.defaultExpanded;

      this.isControlled = expanded != null;
      this.setState({
        expanded: this.isControlled ? expanded : defaultExpanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlled) {
        this.setState({
          expanded: nextProps.expanded
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props2 = this.props,
          childrenProp = _props2.children,
          classes = _props2.classes,
          classNameProp = _props2.className,
          CollapsePropsProp = _props2.CollapseProps,
          defaultExpanded = _props2.defaultExpanded,
          disabled = _props2.disabled,
          expandedProp = _props2.expanded,
          onChange = _props2.onChange,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'classes', 'className', 'CollapseProps', 'defaultExpanded', 'disabled', 'expanded', 'onChange']);
      var expanded = this.state.expanded;


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);

      var summary = null;

      var children = _react2.default.Children.map(childrenProp, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react2.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({ className: className, elevation: 1, square: true }, other),
        summary,
        _react2.default.createElement(
          _Collapse2.default,
          (0, _extends3.default)({ 'in': expanded, timeout: 'auto' }, CollapseProps, CollapsePropsProp),
          children
        )
      );
    }
  }]);
  return ExpansionPanel;
}(_react2.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Properties applied to the `Collapse` element.
   */
  CollapseProps: _propTypes2.default.object,
  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes2.default.bool,
  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes2.default.func
} : {};

ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanel' })(ExpansionPanel);

/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(19);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(17);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(20);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(170);

var _Transition2 = _interopRequireDefault(_Transition);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _transitions = __webpack_require__(168);

var _utils = __webpack_require__(253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },
    entered: {
      height: 'auto'
    },
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },
    wrapperInner: {
      width: '100%'
    }
  };
};

/**
 * The Collapes transition is used by the
 * [Vetical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
// @inheritedComponent Transition

var Collapse = function (_React$Component) {
  (0, _inherits3.default)(Collapse, _React$Component);

  function Collapse() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf2.default)(Collapse)).call.apply(_ref, [this].concat(args))), _this), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.timer = null, _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = wrapperHeight + 'px';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
      node.style.height = wrapperHeight + 'px';

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Collapse, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          collapsedHeight = _props.collapsedHeight,
          Component = _props.component,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          style = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'collapsedHeight', 'component', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExiting', 'style', 'theme', 'timeout']);


      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          onEntering: this.handleEntering,
          onEnter: this.handleEnter,
          onEntered: this.handleEntered,
          onExiting: this.handleExiting,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        function (state, childProps) {
          return _react2.default.createElement(
            Component,
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.container, (0, _defineProperty3.default)({}, classes.entered, state === 'entered'), className),
              style: (0, _extends3.default)({}, style, {
                minHeight: collapsedHeight
              })
            }, childProps),
            _react2.default.createElement(
              'div',
              {
                className: classes.wrapper,
                ref: function ref(node) {
                  _this2.wrapper = node;
                }
              },
              _react2.default.createElement(
                'div',
                { className: classes.wrapperInner },
                children
              )
            )
          );
        }
      );
    }
  }]);
  return Collapse;
}(_react2.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};

exports.default = (0, _withStyles2.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: theme.spacing.unit * 2 + 'px ' + theme.spacing.unit + 'px'
    },
    action: {
      marginLeft: theme.spacing.unit
    }
  };
};

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

ExpansionPanelActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelActions' })(ExpansionPanelActions);

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px'
    }
  };
};

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelDetails' })(ExpansionPanelDetails);

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(9);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(19);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(17);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(20);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(22);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = __webpack_require__(252);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _IconButton = __webpack_require__(1014);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    root: {
      display: 'flex',
      minHeight: theme.spacing.unit * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 ' + theme.spacing.unit * 3 + 'px 0 ' + theme.spacing.unit * 3 + 'px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      }
    },
    expanded: {
      minHeight: 64
    },
    focused: {
      backgroundColor: theme.palette.grey[300]
    },
    disabled: {
      opacity: 0.38
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: theme.spacing.unit * 4
      }
    },
    contentExpanded: {
      margin: '20px 0'
    },
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: theme.spacing.unit,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition)
    },
    expandIconExpanded: {
      transform: 'translateY(-50%) rotate(180deg)'
    }
  };
};

var ExpansionPanelSummary = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    }, _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }
      if (onClick) {
        onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpansionPanelSummary, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          expanded = _props.expanded,
          expandIcon = _props.expandIcon,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disabled', 'expanded', 'expandIcon', 'onChange']);
      var focused = this.state.focused;


      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends3.default)({
          focusRipple: false,
          disableRipple: true,
          disabled: disabled,
          component: 'div',
          'aria-expanded': expanded,
          className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.focused, focused), _classNames), className)
        }, other, {
          onKeyboardFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleChange
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(classes.content, (0, _defineProperty3.default)({}, classes.contentExpanded, expanded)) },
          children
        ),
        expandIcon && _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: disabled,
            className: (0, _classnames2.default)(classes.expandIcon, (0, _defineProperty3.default)({}, classes.expandIconExpanded, expanded)),
            component: 'div',
            tabIndex: -1,
            'aria-hidden': 'true'
          },
          expandIcon
        )
      );
    }
  }]);
  return ExpansionPanelSummary;
}(_react2.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes2.default.bool,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func
} : {};

ExpansionPanelSummary.defaultProps = {
  disabled: false
};

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelSummary' })(ExpansionPanelSummary);

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_pure__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Amex = function Amex(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({}, props, { width: '43', height: '28', dangerouslySetInnerHTML: { __html: '<defs><path id="a" d="M.175.173h33.361v7.169H.176z"/></defs><g fill="none" fill-rule="evenodd"><path d="M41.867 25.2c0 1.546-1.24 2.8-2.77 2.8H3.103c-1.53 0-2.77-1.254-2.77-2.8V2.8c0-1.546 1.24-2.8 2.77-2.8h35.995c1.529 0 2.769 1.254 2.769 2.8v22.4z" fill="#3473DB" class="inactiveBlack"/><path d="M.333 13.063h1.998l.45-1.114h1.01l.449 1.114h3.93v-.852l.352.856h2.04l.351-.869v.865h9.77l-.005-1.83h.19c.132.006.17.018.17.242v1.588h5.053v-.426c.408.224 1.042.426 1.876.426h2.125l.455-1.114h1.009L32 13.063h4.096v-1.059l.62 1.059H40V6.067h-3.249v.826l-.455-.826h-3.333v.826l-.418-.826h-4.503c-.753 0-1.416.108-1.95.408v-.408h-3.108v.408c-.34-.31-.805-.408-1.32-.408H10.31l-.76 1.807-.783-1.807H5.192v.826l-.393-.826h-3.05L.333 9.393v3.67zm38.625-.985H37.3l-2.217-3.765v3.765h-2.381l-.455-1.12h-2.43l-.441 1.12h-1.368c-.569 0-1.288-.13-1.696-.555-.41-.426-.625-1.003-.625-1.915 0-.744.128-1.424.63-1.962.379-.4.97-.585 1.777-.585h1.132v1.075h-1.109c-.426 0-.667.065-.9.297-.199.212-.336.61-.336 1.137 0 .537.105.925.322 1.178.18.198.507.258.815.258h.525l1.648-3.944h1.752l1.98 4.744V7.062h1.78l2.056 3.493V7.062h1.198v5.016zm-15.036 0h1.194V7.06h-1.194v5.017zm-.678-3.666c0 .8-.52 1.213-.824 1.337.256.1.475.277.579.423.165.25.193.472.193.92v.986h-1.18l-.004-.633c0-.302.029-.736-.184-.977-.171-.177-.431-.215-.852-.215h-1.256v1.825h-1.169V7.06h2.69c.597 0 1.038.017 1.416.24.37.225.591.552.591 1.111zm-5.507 3.666H13.83V7.06h3.907v1.045H15v.904h2.67v1.028H15v1.002h2.737v1.038zm-4.778 0H11.76l-.005-3.929-1.695 3.929H9.033l-1.7-3.933v3.933H4.955l-.45-1.12H2.072l-.454 1.12H.347L2.441 7.06h1.737l1.99 4.75V7.06h1.908l1.53 3.403 1.406-3.403h1.947v5.017zm18.89-2.165l-.809-2-.805 2h1.614zm-10.134-.796c-.16.1-.35.103-.578.103h-1.421V8.106h1.44c.204 0 .416.01.554.09.152.073.246.23.246.444 0 .22-.09.395-.241.477zm-17.632.796l-.8-2-.796 2h1.596z" fill="#FFF"/><g transform="translate(8.733 14.467)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M14.581 2.886c0 1.427-1.015 1.721-2.038 1.721h-1.46V6.33H8.807l-1.442-1.7-1.497 1.7H1.232V1.195H5.94l1.44 1.683 1.489-1.683h3.74c.928 0 1.972.27 1.972 1.691zM5.276 5.26H2.398V4.238h2.57V3.19h-2.57v-.933h2.935l1.28 1.496L5.276 5.26zm4.64.603L8.12 3.77l1.797-2.025v4.117zm2.679-2.298h-1.513V2.257h1.527c.422 0 .715.18.715.63 0 .444-.28.678-.729.678zm7.897-2.37h3.906v1.062h-2.74v.933h2.673v1.048h-2.674V5.26l2.741.004V6.33h-3.906V1.195zm-1.479 2.749c.26.1.474.281.573.43.166.251.19.485.194.938V6.33h-1.175v-.643c0-.309.029-.766-.189-1.005-.17-.184-.431-.228-.858-.228h-1.251V6.33H15.13V1.195h2.702c.592 0 1.024.027 1.408.242.37.234.602.555.602 1.14 0 .82-.522 1.238-.83 1.367zm-.707-.64c-.156.098-.35.106-.578.106h-1.421V2.257h1.44c.209 0 .418.005.56.093.15.083.242.242.242.462 0 .22-.091.396-.243.492zm10.561.317c.228.248.35.56.35 1.089 0 1.104-.658 1.62-1.838 1.62h-2.28V5.229h2.27c.223 0 .38-.031.479-.127a.465.465 0 0 0 .138-.335.45.45 0 0 0-.143-.34c-.09-.078-.213-.114-.417-.114-1.094-.039-2.465.036-2.465-1.59 0-.744.447-1.528 1.674-1.528h2.346v1.093h-2.147c-.213 0-.351.008-.469.093-.128.083-.176.206-.176.37 0 .193.11.325.256.382.124.045.257.058.456.058l.63.018c.635.016 1.071.131 1.336.412zm4.67 2.052c-.285.436-.839.657-1.59.657h-2.26V5.229h2.252c.223 0 .38-.031.473-.127a.461.461 0 0 0 .139-.335.43.43 0 0 0-.143-.34c-.085-.078-.209-.114-.412-.114-1.1-.039-2.47.036-2.47-1.59 0-.744.45-1.528 1.679-1.528h2.331V.173H31.37c-.654 0-1.128.164-1.465.42v-.42h-3.204c-.512 0-1.114.133-1.398.42v-.42h-5.721v.42c-.455-.345-1.224-.42-1.578-.42H14.23v.42c-.36-.366-1.162-.42-1.65-.42H8.356L7.39 1.27 6.485.173H.175v7.165h6.191l.996-1.114.938 1.114 3.816.004V5.656h.375c.506.009 1.103-.013 1.63-.252v1.934h3.148V5.471h.151c.194 0 .213.008.213.211v1.656h9.561c.607 0 1.242-.163 1.593-.459v.459h3.033c.631 0 1.247-.093 1.716-.33V5.673zm0-3.385h-2.134c-.213 0-.354.008-.474.092-.123.084-.17.207-.17.37 0 .194.104.325.255.382.124.045.257.059.451.059l.635.017c.64.017 1.067.132 1.328.413.047.04.076.084.108.128V2.288z" fill="#FFF" mask="url(#b)"/></g></g>' } }));
};

Amex = __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default()(Amex);

var _default = Amex;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Amex, 'Amex', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Amex.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Amex.jsx');
}();

;

/***/ }),

/***/ 1111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_pure__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Discover = function Discover(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({}, props, { width: '43', height: '28', dangerouslySetInnerHTML: { __html: '<defs><path id="c" d="M0 27.533h41.067V0H0z"/></defs><g fill="none" fill-rule="evenodd"><path d="M41.067 25.144c0 1.537-1.226 2.782-2.738 2.782H2.738C1.226 27.926 0 26.68 0 25.144V2.891C0 1.354 1.226.109 2.738.109h35.59c1.513 0 2.739 1.245 2.739 2.782v22.253z" fill="#EBEDEE" class="inactiveBlack"/><path d="M38.404 28c1.516 0 2.663-1.089 2.663-2.609v-8.124S30.527 24.74 11.074 28h27.33z" fill="#E67E22" class="inactiveMdGrey"/><path d="M11.074 28c23.18 0 29.993-10.733 29.993-10.733S30.5 24.763 11.074 28z" fill-opacity=".1" fill="#231F20" class="inactiveWhite"/><path d="M5.65 12.607c-.343.31-.789.445-1.495.445H3.86V9.349h.294c.706 0 1.135.126 1.496.453.378.336.605.857.605 1.394 0 .538-.227 1.075-.605 1.41M4.374 8.4H2.769V14h1.596c.85 0 1.462-.2 2-.647a2.809 2.809 0 0 0 1.018-2.149c0-1.653-1.236-2.804-3.01-2.804" fill="#231F20" class="inactiveWhite"/><mask id="d" fill="#fff"><use xlink:href="#c"/></mask><path fill="#231F20" class="inactiveWhite" mask="url(#d)" d="M7.844 14h.923V8.4h-.923zM12.114 10.734c-.703-.253-.91-.42-.91-.734 0-.368.369-.647.874-.647.35 0 .64.14.945.473l.613-.78A2.676 2.676 0 0 0 11.87 8.4c-1.063 0-1.874.716-1.874 1.67 0 .804.378 1.215 1.479 1.6.459.156.692.261.81.331.234.149.351.359.351.604 0 .472-.387.822-.91.822-.559 0-1.009-.271-1.279-.778l-.757.708c.54.769 1.188 1.11 2.08 1.11 1.218 0 2.073-.786 2.073-1.915 0-.926-.395-1.345-1.729-1.818M13.843 11.438c0 1.706 1.379 3.029 3.153 3.029.502 0 .931-.096 1.46-.339v-1.332c-.465.453-.878.635-1.406.635-1.173 0-2.006-.826-2.006-2.002 0-1.114.86-1.993 1.952-1.993.556 0 .977.192 1.46.653V8.757c-.51-.253-.931-.357-1.433-.357-1.765 0-3.18 1.35-3.18 3.038M27.219 12.373L25.683 8.4h-1.228l2.445 6.067h.604L29.993 8.4h-1.218zM30.454 14h3.23v-.948h-2.092V11.54h2.015v-.95h-2.015V9.35h2.092V8.4h-3.23zM35.577 10.978h-.323V9.282h.341c.691 0 1.067.285 1.067.83 0 .563-.376.866-1.085.866m2.226-.925c0-1.048-.733-1.653-2.013-1.653h-1.645V14h1.109v-2.25h.144L36.934 14h1.364l-1.79-2.36c.835-.167 1.295-.73 1.295-1.587"/><path d="M24.455 11.433c0 1.675-1.342 3.034-2.999 3.034-1.656 0-3-1.359-3-3.034 0-1.675 1.344-3.033 3-3.033 1.657 0 3 1.358 3 3.033" fill="#E67E22" class="inactiveMdGrey" mask="url(#d)"/></g>' } }));
};

Discover = __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default()(Discover);

var _default = Discover;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Discover, 'Discover', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Discover.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Discover.jsx');
}();

;

/***/ }),

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_pure__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var MasterCard = function MasterCard(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({}, props, { width: '43', height: '28', dangerouslySetInnerHTML: { __html: '<g fill="none" fill-rule="evenodd"><path d="M42.733 25.2a2.8 2.8 0 0 1-2.8 2.8h-36.4a2.8 2.8 0 0 1-2.8-2.8V2.8a2.8 2.8 0 0 1 2.8-2.8h36.4a2.8 2.8 0 0 1 2.8 2.8v22.4z" fill="#34495E" class="inactiveBlack"/><path d="M24.533 13.767a8.167 8.167 0 1 1-16.333 0 8.167 8.167 0 0 1 16.333 0" fill="#E74C3C" class="inactiveBlack"/><path d="M35.733 13.767a8.167 8.167 0 1 1-16.333 0 8.167 8.167 0 0 1 16.333 0" fill="#F1C40F" class="inactiveLtGrey"/><path d="M19.4 14c0 2.405 1.08 4.568 2.8 6.067C23.92 18.568 25 16.405 25 14c0-2.405-1.08-4.568-2.8-6.067-1.72 1.499-2.8 3.662-2.8 6.067" fill="#F39C12" class="inactiveMdGrey"/><path d="M18.415 16.651l.147-.962c-.08 0-.198.033-.302.033-.409 0-.454-.21-.428-.364l.33-1.964h.621l.15-1.065h-.585l.119-.662h-1.174c-.026.025-.693 3.724-.693 4.174 0 .667.388.964.935.959.429-.004.763-.118.88-.149M20.995 13.163c.663 0 .541.73.541.789h-1.305c0-.075.123-.789.764-.789m-2.062 1.625c0 1.626 1.097 2.012 2.031 2.012.862 0 1.242-.189 1.242-.189l.207-1.11s-.656.284-1.248.284c-1.263 0-1.042-.921-1.042-.921h2.39s.154-.746.154-1.05c0-.757-.386-1.68-1.677-1.68-1.182 0-2.057 1.246-2.057 2.654M28.3 16.645l.221-1.232s-.606.278-1.021.278c-.875 0-1.226-.613-1.226-1.27 0-1.335.753-2.07 1.591-2.07a2.33 2.33 0 0 1 1.134.324l.201-1.198s-.748-.277-1.39-.277c-1.424 0-2.81 1.132-2.81 3.259 0 1.41.748 2.341 2.22 2.341.417 0 1.08-.155 1.08-.155M11.995 14.725c.021.195-.122 1.106-.818 1.106-.359 0-.452-.274-.452-.436 0-.317.172-.696 1.018-.696.197 0 .218.02.252.026m-.248-2.592c-.792 0-1.4.255-1.4.255l-.167.996s.501-.204 1.259-.204c.43 0 .745.048.745.398 0 .213-.039.291-.039.291s-.34-.028-.496-.028c-1 0-2.049.426-2.049 1.713 0 1.013.689 1.246 1.115 1.246.815 0 1.167-.53 1.185-.53l-.038.44h1.017l.454-3.183c0-1.35-1.177-1.394-1.586-1.394M14.642 16.8c.262 0 1.763.066 1.763-1.48 0-1.445-1.39-1.16-1.39-1.74 0-.289.227-.38.641-.38.165 0 .797.052.797.052l.147-1.027s-.41-.092-1.076-.092c-.862 0-1.737.344-1.737 1.52 0 1.332 1.46 1.198 1.46 1.759 0 .374-.409.405-.723.405-.544 0-1.034-.186-1.035-.177l-.156 1.017c.028.008.33.143 1.309.143M37.695 14.236c0 .615-.316 1.435-.97 1.435-.435 0-.639-.352-.639-.903 0-.901.42-1.496.951-1.496.435 0 .658.287.658.964zm.56-3.034l-.26 1.556s-.454-.605-1.166-.605c-1.107 0-2.029 1.285-2.029 2.76 0 .953.492 1.887 1.498 1.887a1.53 1.53 0 0 0 1.124-.485l-.053.414h1.175l.923-5.529-1.211.002zM5.573 16.8l.699-4.222.102 4.222h.791l1.475-4.222-.653 4.222h1.175l.905-5.6H8.25l-1.132 3.436L7.06 11.2H5.385l-.918 5.6z" fill="#FFF"/><path d="M23.846 16.8c.334-1.968.396-3.565 1.194-3.273.14-.761.274-1.056.427-1.378 0 0-.072-.016-.222-.016-.514 0-.895.728-.895.728l.102-.668h-1.069l-.716 4.607h1.179zM31.128 14.725c.022.195-.122 1.106-.818 1.106-.359 0-.452-.274-.452-.436 0-.317.172-.696 1.018-.696.198 0 .218.02.252.026m-.248-2.592c-.792 0-1.4.255-1.4.255l-.167.996s.501-.204 1.259-.204c.43 0 .745.048.745.398 0 .213-.039.291-.039.291s-.339-.028-.496-.028c-1 0-2.049.426-2.049 1.713 0 1.013.689 1.246 1.115 1.246.815 0 1.167-.53 1.185-.53l-.037.44h1.017l.454-3.183c0-1.35-1.178-1.394-1.587-1.394M33.646 16.8c.334-1.968.396-3.565 1.194-3.273.14-.761.274-1.056.427-1.378 0 0-.072-.016-.222-.016-.514 0-.895.728-.895.728l.102-.668h-1.07l-.715 4.607h1.179z" fill="#FFF"/></g>' } }));
};

MasterCard = __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default()(MasterCard);

var _default = MasterCard;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MasterCard, 'MasterCard', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/MasterCard.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/MasterCard.jsx');
}();

;

/***/ }),

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_pure__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Visa = function Visa(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({}, props, { width: '43', height: '28', dangerouslySetInnerHTML: { __html: '<g fill="none" fill-rule="evenodd"><path d="M42 25.2a2.8 2.8 0 0 1-2.8 2.8H2.8A2.8 2.8 0 0 1 0 25.2V2.8A2.8 2.8 0 0 1 2.8 0h36.4A2.8 2.8 0 0 1 42 2.8v22.4z" fill="#0054A4" class="inactiveBlack"/><path fill="#FFF" d="M16.8 18.2l1.437-8.867h2.296L19.097 18.2zM27.533 9.246a5.775 5.775 0 0 0-2.09-.38c-2.306 0-3.93 1.228-3.944 2.985-.014 1.3 1.16 2.024 2.044 2.456.909.443 1.214.726 1.21 1.122-.006.606-.725.883-1.396.883-.934 0-1.43-.136-2.197-.474l-.3-.144-.327 2.024c.544.252 1.553.47 2.6.482 2.45 0 4.044-1.212 4.062-3.088.009-1.031-.613-1.812-1.96-2.457-.815-.42-1.315-.697-1.31-1.121.001-.376.423-.779 1.337-.779a4.1 4.1 0 0 1 1.746.348l.21.103.315-1.96M30.688 15.052c.194-.51.932-2.48.932-2.48-.013.023.193-.515.31-.847l.159.765s.449 2.118.541 2.562h-1.942zm2.886-5.719h-1.808c-.56 0-.98.157-1.226.736L27.067 18.2h2.457s.4-1.094.491-1.334l2.996.005c.07.31.285 1.329.285 1.329h2.17l-1.892-8.867zM14.418 9.333l-2.201 6.055-.236-1.23c-.41-1.419-1.686-2.956-3.114-3.726L10.88 18.2l2.38-.002 3.54-8.865h-2.382"/><path d="M10.748 9.333H7.03L7 9.511c2.892.711 4.806 2.427 5.6 4.489l-.808-3.943c-.14-.544-.544-.705-1.044-.724" fill="#F39C12" class="inactiveLtGrey"/></g>' } }));
};

Visa = __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default()(Visa);

var _default = Visa;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Visa, 'Visa', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Visa.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/Visa.jsx');
}();

;

/***/ }),

/***/ 1114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_pure__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var PayPal = function PayPal(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({}, props, { viewBox: '0 0 300 79.079', dangerouslySetInnerHTML: { __html: '<defs><clipPath id="a"><path d="M0 51h157V0H0v51z"/></clipPath></defs><g transform="matrix(2.0768 0 0 -2.0768 -11.153 92.77)"><path d="M32.419 40.982c-1.674 1.908-4.7 2.726-8.571 2.726H12.613a1.609 1.609 0 0 1-1.589-1.357L6.346 12.682a.964.964 0 0 1 .953-1.115h6.936l1.742 11.049-.054-.346a1.604 1.604 0 0 0 1.583 1.357h3.296c6.475 0 11.545 2.63 13.026 10.238.044.225.082.444.115.658.441 2.812-.003 4.726-1.524 6.459" fill="#003087" class="inactiveBlack"/><path d="M117.33 26.863c-.424-2.784-2.55-2.784-4.607-2.784h-1.17l.821 5.198c.049.314.32.545.638.545h.537c1.4 0 2.722 0 3.404-.797.408-.477.531-1.185.377-2.162m-.895 7.264h-7.756c-.531 0-.982-.386-1.065-.91l-3.136-19.888a.647.647 0 0 1 .638-.747h3.98c.371 0 .687.27.745.636l.89 5.639c.082.524.534.91 1.064.91h2.454c5.109 0 8.058 2.472 8.828 7.373.347 2.142.014 3.826-.989 5.005-1.103 1.296-3.058 1.982-5.653 1.982" fill="#009cde" class="inactiveBlack"/><path d="M62.012 26.863c-.424-2.784-2.55-2.784-4.607-2.784h-1.17l.821 5.198c.049.314.32.545.638.545h.537c1.4 0 2.722 0 3.404-.797.408-.477.531-1.185.377-2.162m-.895 7.264h-7.756c-.531 0-.982-.386-1.065-.91L49.16 13.329a.646.646 0 0 1 .638-.747h3.704c.53 0 .981.386 1.064.909l.847 5.366c.082.524.534.91 1.064.91h2.454c5.109 0 8.058 2.472 8.828 7.373.347 2.142.014 3.826-.989 5.005-1.103 1.296-3.058 1.982-5.653 1.982M79.123 19.723c-.359-2.122-2.043-3.547-4.192-3.547-1.077 0-1.94.347-2.494 1.003-.549.65-.756 1.577-.582 2.608.334 2.104 2.046 3.574 4.162 3.574 1.055 0 1.911-.35 2.476-1.012.569-.667.793-1.599.63-2.626m5.176 7.229h-3.714a.647.647 0 0 1-.639-.546l-.163-1.038-.259.376c-.805 1.167-2.598 1.558-4.388 1.558-4.103 0-7.608-3.11-8.29-7.471-.355-2.176.149-4.255 1.383-5.706 1.133-1.333 2.75-1.888 4.677-1.888 3.308 0 5.142 2.124 5.142 2.124l-.166-1.032a.646.646 0 0 1 .639-.747h3.344c.531 0 .982.385 1.065.909l2.008 12.714a.647.647 0 0 1-.639.747" fill="#003087" class="inactiveBlack"/><path d="M134.44 19.723c-.359-2.122-2.043-3.547-4.192-3.547-1.077 0-1.94.347-2.494 1.003-.55.65-.756 1.577-.582 2.608.334 2.104 2.046 3.574 4.162 3.574 1.055 0 1.911-.35 2.476-1.012.569-.667.793-1.599.63-2.626m5.176 7.229h-3.714a.647.647 0 0 1-.639-.546l-.163-1.038-.26.376c-.804 1.167-2.597 1.558-4.387 1.558-4.103 0-7.608-3.11-8.29-7.471-.355-2.176.149-4.255 1.383-5.706 1.133-1.333 2.75-1.888 4.677-1.888 3.308 0 5.142 2.124 5.142 2.124l-.166-1.032a.646.646 0 0 1 .639-.747h3.344c.531 0 .982.385 1.065.909l2.008 12.714a.647.647 0 0 1-.639.747" fill="#009cde" class="inactiveBlack"/><path d="M104.08 26.952h-3.733c-.357 0-.691-.177-.891-.473l-5.15-7.584-2.182 7.288a1.08 1.08 0 0 1-1.033.769h-3.669a.647.647 0 0 1-.612-.855l4.11-12.066-3.866-5.455a.647.647 0 0 1 .528-1.02h3.729c.353 0 .684.173.886.463l12.414 17.918a.646.646 0 0 1-.531 1.015" fill="#003087" class="inactiveBlack"/><path d="M144 33.581l-3.183-20.252a.646.646 0 0 1 .638-.747h3.202c.53 0 .982.386 1.064.91l3.139 19.888a.646.646 0 0 1-.639.747h-3.582a.645.645 0 0 1-.639-.546" fill="#009cde" class="inactiveBlack"/><path d="M32.419 40.982c-1.674 1.908-4.7 2.726-8.571 2.726H12.613a1.609 1.609 0 0 1-1.589-1.357L6.346 12.682a.964.964 0 0 1 .953-1.115h6.936l1.742 11.049-.054-.346a1.604 1.604 0 0 0 1.583 1.357h3.296c6.475 0 11.545 2.63 13.026 10.238.044.225.082.444.115.658.441 2.812-.003 4.726-1.524 6.459" fill="#003087" class="inactiveBlack"/><path d="M17.849 34.485a1.408 1.408 0 0 0 1.389 1.187h8.808c1.043 0 2.016-.068 2.905-.211a12.206 12.206 0 0 0 1.441-.321 7.957 7.957 0 0 0 1.551-.618c.441 2.813-.003 4.726-1.524 6.459-1.675 1.908-4.7 2.726-8.571 2.726H12.612a1.609 1.609 0 0 1-1.588-1.357L6.346 12.682a.964.964 0 0 1 .952-1.115h6.937l1.742 11.049 1.872 11.869z" fill="#003087" class="inactiveBlack"/><path d="M33.943 34.523a18.294 18.294 0 0 0-.115-.658c-1.481-7.607-6.551-10.238-13.026-10.238h-3.297a1.602 1.602 0 0 1-1.582-1.357l-1.688-10.702-.479-3.036a.844.844 0 0 1 .833-.976h5.847c.692 0 1.281.504 1.389 1.187l.057.298 1.102 6.984.071.386a1.407 1.407 0 0 0 1.389 1.187h.875c5.664 0 10.099 2.301 11.395 8.956.541 2.781.261 5.103-1.17 6.734a5.584 5.584 0 0 1-1.601 1.235" fill="#009cde" class="inactiveMdGrey"/><path d="M32.392 35.141c-.226.066-.459.126-.699.179s-.488.1-.742.141c-.89.144-1.862.212-2.906.212h-8.807a1.404 1.404 0 0 1-1.389-1.188l-1.872-11.869-.054-.346a1.602 1.602 0 0 0 1.582 1.357h3.297c6.475 0 11.545 2.63 13.026 10.238.044.225.081.443.115.658a7.998 7.998 0 0 1-1.218.514c-.109.036-.22.071-.333.104" fill="#012169" class="inactiveDarkGrey"/></g>' } }));
};

PayPal = __WEBPACK_IMPORTED_MODULE_1_recompose_pure___default()(PayPal);

var _default = PayPal;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PayPal, 'PayPal', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/PayPal.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/images/SVG/PayPal.jsx');
}();

;

/***/ }),

/***/ 1115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_ExpansionPanel__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    button: theme.button
  };
};

var ZeroOrder = function (_React$Component) {
  _inherits(ZeroOrder, _React$Component);

  function ZeroOrder() {
    var _temp, _this, _ret;

    _classCallCheck(this, ZeroOrder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function () {
      var _this2;

      return (_this2 = _this).__handleClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ZeroOrder.prototype.__handleClick__REACT_HOT_LOADER__ = function __handleClick__REACT_HOT_LOADER__() {
    var _this3 = this;

    this.props.processOrder('manual').then(function (resp) {
      if (resp) _this3.props.addProducts(resp);
    }).catch(function (err) {
      _this3.props.setOrderFormMessage(999);
    });
  };

  ZeroOrder.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        processOrder = _props.processOrder;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      {
        item: true,
        xs: 12,
        className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.gridItem
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_ExpansionPanel___default.a,
        {
          style: { marginBottom: '0px' },
          elevation: 0,
          expanded: true,
          onClick: this.handleClick
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_ExpansionPanel__["ExpansionPanelDetails"],
          {
            style: { paddingLeft: 0, paddingRight: 0 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
            { container: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default.a,
                {
                  className: classes.button,
                  style: { width: '100%', height: '65px', fontSize: '22px' },
                  variant: 'raised',
                  color: 'primary'
                },
                'Place your order'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
                {
                  type: 'body2',
                  style: { fontWeight: 400 }
                },
                'Your total for today is: $0.00'
              )
            )
          )
        )
      )
    );
  };

  return ZeroOrder;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ZeroOrder.propTypes = {
  addProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  processOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setOrderFormMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

// const mapStateToProps = state => ({
//   method: state.checkout.paymentMethod,
//   stepValidity: state.checkout.stepValidity.D,
//   braintreeValidity: state.checkout.braintreeValidity,
//   paymentMethod: state.checkout.paymentMethod,
//   selectedUserPaymentMethodId: state.checkout.selectedUserPaymentMethodId,
//   selectedPaymentOption: state.checkout.selectedPaymentOption,
//   totals: state.checkout.totals
// });

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addProducts: function addProducts(respProducts) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].addProducts(respProducts));
    },
    setOrderFormMessage: function setOrderFormMessage(id) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].setOrderFormMessage(id));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__["withStyles"])(muiThemeStyles)(ZeroOrder));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/components/ZeroOrder/index.jsx');

  __REACT_HOT_LOADER__.register(ZeroOrder, 'ZeroOrder', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/components/ZeroOrder/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/components/ZeroOrder/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/Order/components/ZeroOrder/index.jsx');
}();

;

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._2RiaF{border-radius:8px;margin:5px;margin-top:12px;padding:0}._0kOn{border:1px solid grey;border-radius:8px 8px 0 0;height:75px}._1-ve0{border-left:1px solid grey;border-right:1px solid grey}._4dYYi{padding-left:0!important;padding-right:0!important}._1dUfF .inactiveBlack{fill:#000}._1dUfF .inactive,._1dUfF .inactiveLtGrey{fill:#999}._1dUfF .inactive,._1dUfF .inactiveMdGrey{fill:#666}._1dUfF .inactive,._1dUfF .inactiveDarkGrey{fill:#333}._1dUfF .inactive,._1dUfF .inactiveWhite{fill:#fff}._1dUfF .inactiveBlack,._1dUfF .inactiveDarkGrey,._1dUfF .inactiveLtGrey,._1dUfF .inactiveMdGrey,._1dUfF .inactiveWhite,._2b5PA .inactiveBlack,._2b5PA .inactiveDarkGrey,._2b5PA .inactiveLtGrey,._2b5PA .inactiveMdGrey,._2b5PA .inactiveWhite{transition-duration:1s}", ""]);

// exports
exports.locals = {
	"gridItem": "_2RiaF",
	"expansionPanelSummary": "_0kOn",
	"expansionPanelDetails": "_1-ve0",
	"paymentMethod": "_4dYYi",
	"paymentMethodInactive": "_1dUfF",
	"paymentMethodActive": "_2b5PA"
};

/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);







var BraintreeForm = function BraintreeForm(props) {
  var _props$braintreeValid = props.braintreeValidity,
      numberBlurred = _props$braintreeValid.numberBlurred,
      numberValid = _props$braintreeValid.numberValid,
      cvvBlurred = _props$braintreeValid.cvvBlurred,
      cvvValid = _props$braintreeValid.cvvValid,
      expirationDateBlurred = _props$braintreeValid.expirationDateBlurred,
      expirationDateValid = _props$braintreeValid.expirationDateValid;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
    { item: true, xs: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { item: true, xs: 12, style: { marginTop: '24px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'card-number',
          className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["form"]
        }),
        numberBlurred && !numberValid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
          {
            type: 'body',
            className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["warning"]
          },
          'Invalid Credit Card Number'
        ) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { item: true, xs: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'expiration-date',
          className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["form"]
        }),
        expirationDateBlurred && !expirationDateValid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
          {
            type: 'body',
            className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["warning"]
          },
          'Invalid Exp. Date'
        ) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { item: true, xs: 6, style: { paddingBottom: '8px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'cvv',
          className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["form"]
        }),
        cvvBlurred && !cvvValid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
          {
            type: 'body',
            className: __WEBPACK_IMPORTED_MODULE_5__styles_scss__["warning"]
          },
          'Invalid Security Code'
        ) : null
      )
    )
  );
};

BraintreeForm.propTypes = {
  braintreeValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    numberBlurred: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    cvvBlurred: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    expirationDateBlurred: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    numberValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    cvvValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    expirationDateValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    braintreeValidity: state.checkout.braintreeValidity
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(BraintreeForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BraintreeForm, 'BraintreeForm', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BraintreeForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BraintreeForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/BraintreeForm/index.jsx');
}();

;

/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._18VAb{height:24px;margin-left:12px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #d3d3d3}._2Cnwx{font-weight:400;font-size:.75em;color:red;margin-left:16px}", ""]);

// exports
exports.locals = {
	"form": "_18VAb",
	"warning": "_2Cnwx"
};

/***/ }),

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_Checkout_components_AddressList__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_checkout__ = __webpack_require__(249);







var setSelectedShippingAddress = __WEBPACK_IMPORTED_MODULE_5_modules_checkout__["a" /* actions */].setSelectedShippingAddress;


var AddressOptions = function AddressOptions(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
    { container: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_routes_Checkout_components_AddressList__["a" /* default */], {
        addresses: props.isAuthenticated ? props.addresses : [],
        onToggle: function onToggle(id) {
          return props.onToggle(id);
        },
        selectedId: props.selectedAddressId,
        addressType: props.addressType
      })
    )
  );
};

AddressOptions.propTypes = {
  isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  addresses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  onToggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedAddressId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  addressType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

AddressOptions.defaultProps = {
  selectedAddressId: '0'
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: state.user.isAuthenticated,
    addresses: state.user.addresses,
    selectedAddressId: state.checkout.selectedShippingAddressId,
    addressType: 'shipping'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onToggle: function onToggle(id) {
      dispatch(setSelectedShippingAddress(id));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(AddressOptions);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(setSelectedShippingAddress, 'setSelectedShippingAddress', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressOptions/index.jsx');

  __REACT_HOT_LOADER__.register(AddressOptions, 'AddressOptions', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressOptions/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressOptions/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressOptions/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressOptions/index.jsx');
}();

;

/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_checkout__ = __webpack_require__(249);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _checkFormValidity = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].checkFormValidity;

var AddressList = function (_React$Component) {
  _inherits(AddressList, _React$Component);

  function AddressList(props) {
    _classCallCheck(this, AddressList);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var addresses = props.addresses;

    var addressesList = [];
    if (addresses.length > 0) {
      addresses.map(function (address) {
        // TODO make this component agnostic billing vs shipping
        if (address.type === 'shipping') {
          addressesList.push(address);
        }
      });
    }
    _this.state = {
      addressesList: addressesList
    };
    return _this;
  }

  AddressList.prototype.toggleBilling = function toggleBilling(id, checked) {
    if (checked) {
      this.props.onToggle(id);
    } else {
      this.props.onToggle('0');
    }
  };

  AddressList.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default.a,
        { dense: true },
        this.state.addressesList.map(function (address) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItem"],
            {
              button: true,
              key: address.id,
              style: { paddingLeft: '12px' },
              onClick: _this2.props.checkFormValidity
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItemText"], {
              primary: address.name,
              secondary: address.address1 + ' ' + address.address2 + ' ' + address.state + ' ' + address.postalCode
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItemSecondaryAction"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default.a, {
                key: address.id,
                onChange: function onChange() {
                  return _this2.props.onToggle(address.id.toString());
                },
                value: address.id.toString(),
                checked: _this2.props.selectedId === address.id.toString()
              })
            )
          );
        })
      ),
      this.state.addressesList.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_List___default.a,
        { dense: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItem"],
          { button: true, style: { paddingLeft: '12px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItemText"], {
            primary: 'New',
            secondary: 'Enter a new shipping address'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_List__["ListItemSecondaryAction"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default.a, {
              onChange: function onChange() {
                return _this2.props.onToggle('0');
              },
              value: '0',
              checked: this.props.selectedId === '0'
            })
          )
        )
      ) : null
    );
  };

  return AddressList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AddressList.propTypes = {
  onToggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  checkFormValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addresses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  selectedId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedId: state.checkout.selectedShippingAddressId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    checkFormValidity: function checkFormValidity() {
      dispatch(_checkFormValidity());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(AddressList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_checkFormValidity, 'checkFormValidity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressList/index.jsx');

  __REACT_HOT_LOADER__.register(AddressList, 'AddressList', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressList/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressList/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressList/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/AddressList/index.jsx');
}();

;

/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NewShippingAddressForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Select__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__countries__ = __webpack_require__(1123);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-duplicate-props */












var _updateStepValidity = __WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].updateStepValidity,
    _setNewAddress = __WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].setNewAddress,
    _setSelectedShippingAddress = __WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].setSelectedShippingAddress,
    _loadTotals = __WEBPACK_IMPORTED_MODULE_8_modules_checkout__["a" /* actions */].loadTotals;


var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    Input: theme.Input,
    input: theme.input
  };
};

var NewShippingAddressForm = function (_React$Component) {
  _inherits(NewShippingAddressForm, _React$Component);

  function NewShippingAddressForm(props) {
    _classCallCheck(this, NewShippingAddressForm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleChange = function () {
      return _this.__handleChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    var address = _this.props.newShippingAddress;
    _this.state = {
      address: {
        name: address.name || '',
        address1: address.address1 || '',
        address2: address.address2 || '',
        city: address.city || '',
        state: address.state || '',
        postalCode: address.postalCode || '',
        country: address.country || 'USA'
      }
    };
    return _this;
  }

  NewShippingAddressForm.prototype.componentWillMount = function componentWillMount() {
    this.props.updateStepValidity();
  };

  NewShippingAddressForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newShippingAddress = nextProps.newShippingAddress;

    this.setState({ address: newShippingAddress });
  };

  NewShippingAddressForm.prototype.__handleChange__REACT_HOT_LOADER__ = function __handleChange__REACT_HOT_LOADER__(name) {
    var _this2 = this;

    return function (event) {
      var address = _this2.state.address;

      address[name] = event.target.value;
      var newShippingAddress = _extends({}, address);
      _this2.props.setNewAddress(newShippingAddress);
      if (_this2.props.selectedShippingAddress !== '0') {
        _this2.props.setSelectedShippingAddress('0');
      }
      _this2.props.updateStepValidity();
    };
  };

  NewShippingAddressForm.prototype.render = function render() {
    var classes = this.props.classes;
    var _state$address = this.state.address,
        name = _state$address.name,
        address1 = _state$address.address1,
        address2 = _state$address.address2,
        city = _state$address.city,
        state = _state$address.state,
        postalCode = _state$address.postalCode,
        country = _state$address.country;


    var countryValue = country || 'USA';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { marginBottom: '24px', paddingLeft: '12px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            name: 'name',
            placeholder: 'Name',
            value: name,
            style: { width: '100%' },
            inputProps: { id: 'name', className: classes.input },
            onChange: this.handleChange('name')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            name: 'address1',
            placeholder: 'Address',
            value: address1,
            style: { width: '100%' },
            inputProps: { id: 'address1', className: classes.input },
            onChange: this.handleChange('address1')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            name: 'address2',
            placeholder: 'Address2',
            value: address2,
            style: { width: '100%' },
            inputProps: { id: 'address2', className: classes.input },
            onChange: this.handleChange('address2')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            placeholder: 'City',
            value: city,
            inputProps: { id: 'city', className: classes.input },
            onChange: this.handleChange('city')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            name: 'state',
            placeholder: 'State',
            value: state,
            inputProps: { id: 'state', className: classes.input },
            onChange: this.handleChange('state')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            required: true,
            name: 'postalCode',
            placeholder: 'ZIP',
            value: postalCode,
            inputProps: { id: 'postalCode', className: classes.input },
            onChange: this.handleChange('postalCode'),
            onBlur: this.props.loadTotals
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Select___default.a,
            {
              className: classes.textField,
              MenuProps: { className: classes.Input },
              inputProps: { id: 'country', className: classes.input },
              required: true,
              name: 'country',
              placeholder: 'USA',
              value: countryValue,
              style: { fontSize: '1.2rem', width: '100%' },
              onChange: this.handleChange('country'),
              onBlur: this.props.loadTotals
            },
            __WEBPACK_IMPORTED_MODULE_9__countries__["a" /* default */].map(function (countryObj) {
              var country = countryObj.name;
              var alpha3 = countryObj.alpha3;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],
                { style: { fontSize: '1.2rem' }, value: alpha3 },
                country
              );
            })
          )
        )
      )
    );
  };

  return NewShippingAddressForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewShippingAddressForm.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    textField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  newShippingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  updateStepValidity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loadTotals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedShippingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setNewAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedShippingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

NewShippingAddressForm.defaultProps = {
  newShippingAddress: {
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    country: 'USA',
    empty: true
  },
  selectedShippingAddress: null
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    addresses: state.user.addresses,
    selectedShippingAddress: state.checkout.selectedShippingAddressId,
    newShippingAddress: state.checkout.newShippingAddress
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateStepValidity: function updateStepValidity() {
      dispatch(_updateStepValidity('C'));
    },
    setNewAddress: function setNewAddress(address) {
      var addressType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'newShippingAddress';

      dispatch(_setNewAddress(address, addressType));
    },
    setSelectedShippingAddress: function setSelectedShippingAddress(id) {
      dispatch(_setSelectedShippingAddress(id));
    },
    loadTotals: function loadTotals() {
      dispatch(_loadTotals());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles__["withStyles"])(muiThemeStyles)(NewShippingAddressForm));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_updateStepValidity, 'updateStepValidity', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(_setNewAddress, 'setNewAddress', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(_setSelectedShippingAddress, 'setSelectedShippingAddress', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(_loadTotals, 'loadTotals', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(NewShippingAddressForm, 'NewShippingAddressForm', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/index.jsx');
}();

;

/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _default = [{ "name": "United States", "countryCode": "840", "alpha3": "USA" }, { "name": "Mexico", "countryCode": "484", "alpha3": "MEX" }, { "name": "Canada", "countryCode": "124", "alpha3": "CAN" }, { "name": "Afghanistan", "countryCode": "004", "alpha3": "AFG" }, { "name": "Åland Islands", "countryCode": "248", "alpha3": "ALA" }, { "name": "Albania", "countryCode": "008", "alpha3": "ALB" }, { "name": "Algeria", "countryCode": "012", "alpha3": "DZA" }, { "name": "American Samoa", "countryCode": "016", "alpha3": "ASM" }, { "name": "Andorra", "countryCode": "020", "alpha3": "AND" }, { "name": "Angola", "countryCode": "024", "alpha3": "AGO" }, { "name": "Anguilla", "countryCode": "660", "alpha3": "AIA" }, { "name": "Antarctica", "countryCode": "010", "alpha3": "ATA" }, { "name": "Antigua and Barbuda", "countryCode": "028", "alpha3": "ATG" }, { "name": "Argentina", "countryCode": "032", "alpha3": "ARG" }, { "name": "Armenia", "countryCode": "051", "alpha3": "ARM" }, { "name": "Aruba", "countryCode": "533", "alpha3": "ABW" }, { "name": "Australia", "countryCode": "036", "alpha3": "AUS" }, { "name": "Austria", "countryCode": "040", "alpha3": "AUT" }, { "name": "Azerbaijan", "countryCode": "031", "alpha3": "AZE" }, { "name": "Bahamas", "countryCode": "044", "alpha3": "BHS" }, { "name": "Bahrain", "countryCode": "048", "alpha3": "BHR" }, { "name": "Bangladesh", "countryCode": "050", "alpha3": "BGD" }, { "name": "Barbados", "countryCode": "052", "alpha3": "BRB" }, { "name": "Belarus", "countryCode": "112", "alpha3": "BLR" }, { "name": "Belgium", "countryCode": "056", "alpha3": "BEL" }, { "name": "Belize", "countryCode": "084", "alpha3": "BLZ" }, { "name": "Benin", "countryCode": "204", "alpha3": "BEN" }, { "name": "Bermuda", "countryCode": "060", "alpha3": "BMU" }, { "name": "Bhutan", "countryCode": "064", "alpha3": "BTN" }, { "name": "Bolivia (Plurinational State of)", "countryCode": "068", "alpha3": "BOL" }, { "name": "Bonaire, Sint Eustatius and Saba", "countryCode": "535", "alpha3": "BES" }, { "name": "Bosnia and Herzegovina", "countryCode": "070", "alpha3": "BIH" }, { "name": "Botswana", "countryCode": "072", "alpha3": "BWA" }, { "name": "Bouvet Island", "countryCode": "074", "alpha3": "BVT" }, { "name": "Brazil", "countryCode": "076", "alpha3": "BRA" }, { "name": "British Indian Ocean Territory", "countryCode": "086", "alpha3": "IOT" }, { "name": "Brunei Darussalam", "countryCode": "096", "alpha3": "BRN" }, { "name": "Bulgaria", "countryCode": "100", "alpha3": "BGR" }, { "name": "Burkina Faso", "countryCode": "854", "alpha3": "BFA" }, { "name": "Burundi", "countryCode": "108", "alpha3": "BDI" }, { "name": "Cabo Verde", "countryCode": "132", "alpha3": "CPV" }, { "name": "Cambodia", "countryCode": "116", "alpha3": "KHM" }, { "name": "Cameroon", "countryCode": "120", "alpha3": "CMR" }, { "name": "Cayman Islands", "countryCode": "136", "alpha3": "CYM" }, { "name": "Central African Republic", "countryCode": "140", "alpha3": "CAF" }, { "name": "Chad", "countryCode": "148", "alpha3": "TCD" }, { "name": "Chile", "countryCode": "152", "alpha3": "CHL" }, { "name": "China", "countryCode": "156", "alpha3": "CHN" }, { "name": "Christmas Island", "countryCode": "162", "alpha3": "CXR" }, { "name": "Cocos (Keeling) Islands", "countryCode": "166", "alpha3": "CCK" }, { "name": "Colombia", "countryCode": "170", "alpha3": "COL" }, { "name": "Comoros", "countryCode": "174", "alpha3": "COM" }, { "name": "Congo", "countryCode": "178", "alpha3": "COG" }, { "name": "Congo (Democratic Republic of the)", "countryCode": "180", "alpha3": "COD" }, { "name": "Cook Islands", "countryCode": "184", "alpha3": "COK" }, { "name": "Costa Rica", "countryCode": "188", "alpha3": "CRI" }, { "name": "Côte d'Ivoire", "countryCode": "384", "alpha3": "CIV" }, { "name": "Croatia", "countryCode": "191", "alpha3": "HRV" }, { "name": "Cuba", "countryCode": "192", "alpha3": "CUB" }, { "name": "Curaçao", "countryCode": "531", "alpha3": "CUW" }, { "name": "Cyprus", "countryCode": "196", "alpha3": "CYP" }, { "name": "Czechia", "countryCode": "203", "alpha3": "CZE" }, { "name": "Denmark", "countryCode": "208", "alpha3": "DNK" }, { "name": "Djibouti", "countryCode": "262", "alpha3": "DJI" }, { "name": "Dominica", "countryCode": "212", "alpha3": "DMA" }, { "name": "Dominican Republic", "countryCode": "214", "alpha3": "DOM" }, { "name": "Ecuador", "countryCode": "218", "alpha3": "ECU" }, { "name": "Egypt", "countryCode": "818", "alpha3": "EGY" }, { "name": "El Salvador", "countryCode": "222", "alpha3": "SLV" }, { "name": "Equatorial Guinea", "countryCode": "226", "alpha3": "GNQ" }, { "name": "Eritrea", "countryCode": "232", "alpha3": "ERI" }, { "name": "Estonia", "countryCode": "233", "alpha3": "EST" }, { "name": "Ethiopia", "countryCode": "231", "alpha3": "ETH" }, { "name": "Falkland Islands (Malvinas)", "countryCode": "238", "alpha3": "FLK" }, { "name": "Faroe Islands", "countryCode": "234", "alpha3": "FRO" }, { "name": "Fiji", "countryCode": "242", "alpha3": "FJI" }, { "name": "Finland", "countryCode": "246", "alpha3": "FIN" }, { "name": "France", "countryCode": "250", "alpha3": "FRA" }, { "name": "French Guiana", "countryCode": "254", "alpha3": "GUF" }, { "name": "French Polynesia", "countryCode": "258", "alpha3": "PYF" }, { "name": "French Southern Territories", "countryCode": "260", "alpha3": "ATF" }, { "name": "Gabon", "countryCode": "266", "alpha3": "GAB" }, { "name": "Gambia", "countryCode": "270", "alpha3": "GMB" }, { "name": "Georgia", "countryCode": "268", "alpha3": "GEO" }, { "name": "Germany", "countryCode": "276", "alpha3": "DEU" }, { "name": "Ghana", "countryCode": "288", "alpha3": "GHA" }, { "name": "Gibraltar", "countryCode": "292", "alpha3": "GIB" }, { "name": "Greece", "countryCode": "300", "alpha3": "GRC" }, { "name": "Greenland", "countryCode": "304", "alpha3": "GRL" }, { "name": "Grenada", "countryCode": "308", "alpha3": "GRD" }, { "name": "Guadeloupe", "countryCode": "312", "alpha3": "GLP" }, { "name": "Guam", "countryCode": "316", "alpha3": "GUM" }, { "name": "Guatemala", "countryCode": "320", "alpha3": "GTM" }, { "name": "Guernsey", "countryCode": "831", "alpha3": "GGY" }, { "name": "Guinea", "countryCode": "324", "alpha3": "GIN" }, { "name": "Guinea-Bissau", "countryCode": "624", "alpha3": "GNB" }, { "name": "Guyana", "countryCode": "328", "alpha3": "GUY" }, { "name": "Haiti", "countryCode": "332", "alpha3": "HTI" }, { "name": "Heard Island and McDonald Islands", "countryCode": "334", "alpha3": "HMD" }, { "name": "Holy See", "countryCode": "336", "alpha3": "VAT" }, { "name": "Honduras", "countryCode": "340", "alpha3": "HND" }, { "name": "Hong Kong", "countryCode": "344", "alpha3": "HKG" }, { "name": "Hungary", "countryCode": "348", "alpha3": "HUN" }, { "name": "Iceland", "countryCode": "352", "alpha3": "ISL" }, { "name": "India", "countryCode": "356", "alpha3": "IND" }, { "name": "Indonesia", "countryCode": "360", "alpha3": "IDN" }, { "name": "Iran (Islamic Republic of)", "countryCode": "364", "alpha3": "IRN" }, { "name": "Iraq", "countryCode": "368", "alpha3": "IRQ" }, { "name": "Ireland", "countryCode": "372", "alpha3": "IRL" }, { "name": "Isle of Man", "countryCode": "833", "alpha3": "IMN" }, { "name": "Israel", "countryCode": "376", "alpha3": "ISR" }, { "name": "Italy", "countryCode": "380", "alpha3": "ITA" }, { "name": "Jamaica", "countryCode": "388", "alpha3": "JAM" }, { "name": "Japan", "countryCode": "392", "alpha3": "JPN" }, { "name": "Jersey", "countryCode": "832", "alpha3": "JEY" }, { "name": "Jordan", "countryCode": "400", "alpha3": "JOR" }, { "name": "Kazakhstan", "countryCode": "398", "alpha3": "KAZ" }, { "name": "Kenya", "countryCode": "404", "alpha3": "KEN" }, { "name": "Kiribati", "countryCode": "296", "alpha3": "KIR" }, { "name": "Korea (Democratic People's Republic of)", "countryCode": "408", "alpha3": "PRK" }, { "name": "Korea (Republic of)", "countryCode": "410", "alpha3": "KOR" }, { "name": "Kuwait", "countryCode": "414", "alpha3": "KWT" }, { "name": "Kyrgyzstan", "countryCode": "417", "alpha3": "KGZ" }, { "name": "Lao People's Democratic Republic", "countryCode": "418", "alpha3": "LAO" }, { "name": "Latvia", "countryCode": "428", "alpha3": "LVA" }, { "name": "Lebanon", "countryCode": "422", "alpha3": "LBN" }, { "name": "Lesotho", "countryCode": "426", "alpha3": "LSO" }, { "name": "Liberia", "countryCode": "430", "alpha3": "LBR" }, { "name": "Libya", "countryCode": "434", "alpha3": "LBY" }, { "name": "Liechtenstein", "countryCode": "438", "alpha3": "LIE" }, { "name": "Lithuania", "countryCode": "440", "alpha3": "LTU" }, { "name": "Luxembourg", "countryCode": "442", "alpha3": "LUX" }, { "name": "Macao", "countryCode": "446", "alpha3": "MAC" }, { "name": "Macedonia (the former Yugoslav Republic of)", "countryCode": "807", "alpha3": "MKD" }, { "name": "Madagascar", "countryCode": "450", "alpha3": "MDG" }, { "name": "Malawi", "countryCode": "454", "alpha3": "MWI" }, { "name": "Malaysia", "countryCode": "458", "alpha3": "MYS" }, { "name": "Maldives", "countryCode": "462", "alpha3": "MDV" }, { "name": "Mali", "countryCode": "466", "alpha3": "MLI" }, { "name": "Malta", "countryCode": "470", "alpha3": "MLT" }, { "name": "Marshall Islands", "countryCode": "584", "alpha3": "MHL" }, { "name": "Martinique", "countryCode": "474", "alpha3": "MTQ" }, { "name": "Mauritania", "countryCode": "478", "alpha3": "MRT" }, { "name": "Mauritius", "countryCode": "480", "alpha3": "MUS" }, { "name": "Mayotte", "countryCode": "175", "alpha3": "MYT" }, { "name": "Micronesia (Federated States of)", "countryCode": "583", "alpha3": "FSM" }, { "name": "Moldova (Republic of)", "countryCode": "498", "alpha3": "MDA" }, { "name": "Monaco", "countryCode": "492", "alpha3": "MCO" }, { "name": "Mongolia", "countryCode": "496", "alpha3": "MNG" }, { "name": "Montenegro", "countryCode": "499", "alpha3": "MNE" }, { "name": "Montserrat", "countryCode": "500", "alpha3": "MSR" }, { "name": "Morocco", "countryCode": "504", "alpha3": "MAR" }, { "name": "Mozambique", "countryCode": "508", "alpha3": "MOZ" }, { "name": "Myanmar", "countryCode": "104", "alpha3": "MMR" }, { "name": "Namibia", "countryCode": "516", "alpha3": "NAM" }, { "name": "Nauru", "countryCode": "520", "alpha3": "NRU" }, { "name": "Nepal", "countryCode": "524", "alpha3": "NPL" }, { "name": "Netherlands", "countryCode": "528", "alpha3": "NLD" }, { "name": "New Caledonia", "countryCode": "540", "alpha3": "NCL" }, { "name": "New Zealand", "countryCode": "554", "alpha3": "NZL" }, { "name": "Nicaragua", "countryCode": "558", "alpha3": "NIC" }, { "name": "Niger", "countryCode": "562", "alpha3": "NER" }, { "name": "Nigeria", "countryCode": "566", "alpha3": "NGA" }, { "name": "Niue", "countryCode": "570", "alpha3": "NIU" }, { "name": "Norfolk Island", "countryCode": "574", "alpha3": "NFK" }, { "name": "Northern Mariana Islands", "countryCode": "580", "alpha3": "MNP" }, { "name": "Norway", "countryCode": "578", "alpha3": "NOR" }, { "name": "Oman", "countryCode": "512", "alpha3": "OMN" }, { "name": "Pakistan", "countryCode": "586", "alpha3": "PAK" }, { "name": "Palau", "countryCode": "585", "alpha3": "PLW" }, { "name": "Palestine, State of", "countryCode": "275", "alpha3": "PSE" }, { "name": "Panama", "countryCode": "591", "alpha3": "PAN" }, { "name": "Papua New Guinea", "countryCode": "598", "alpha3": "PNG" }, { "name": "Paraguay", "countryCode": "600", "alpha3": "PRY" }, { "name": "Peru", "countryCode": "604", "alpha3": "PER" }, { "name": "Philippines", "countryCode": "608", "alpha3": "PHL" }, { "name": "Pitcairn", "countryCode": "612", "alpha3": "PCN" }, { "name": "Poland", "countryCode": "616", "alpha3": "POL" }, { "name": "Portugal", "countryCode": "620", "alpha3": "PRT" }, { "name": "Puerto Rico", "countryCode": "630", "alpha3": "PRI" }, { "name": "Qatar", "countryCode": "634", "alpha3": "QAT" }, { "name": "Réunion", "countryCode": "638", "alpha3": "REU" }, { "name": "Romania", "countryCode": "642", "alpha3": "ROU" }, { "name": "Russian Federation", "countryCode": "643", "alpha3": "RUS" }, { "name": "Rwanda", "countryCode": "646", "alpha3": "RWA" }, { "name": "Saint Barthélemy", "countryCode": "652", "alpha3": "BLM" }, { "name": "Saint Helena, Ascension and Tristan da Cunha", "countryCode": "654", "alpha3": "SHN" }, { "name": "Saint Kitts and Nevis", "countryCode": "659", "alpha3": "KNA" }, { "name": "Saint Lucia", "countryCode": "662", "alpha3": "LCA" }, { "name": "Saint Martin (French part)", "countryCode": "663", "alpha3": "MAF" }, { "name": "Saint Pierre and Miquelon", "countryCode": "666", "alpha3": "SPM" }, { "name": "Saint Vincent and the Grenadines", "countryCode": "670", "alpha3": "VCT" }, { "name": "Samoa", "countryCode": "882", "alpha3": "WSM" }, { "name": "San Marino", "countryCode": "674", "alpha3": "SMR" }, { "name": "Sao Tome and Principe", "countryCode": "678", "alpha3": "STP" }, { "name": "Saudi Arabia", "countryCode": "682", "alpha3": "SAU" }, { "name": "Senegal", "countryCode": "686", "alpha3": "SEN" }, { "name": "Serbia", "countryCode": "688", "alpha3": "SRB" }, { "name": "Seychelles", "countryCode": "690", "alpha3": "SYC" }, { "name": "Sierra Leone", "countryCode": "694", "alpha3": "SLE" }, { "name": "Singapore", "countryCode": "702", "alpha3": "SGP" }, { "name": "Sint Maarten (Dutch part)", "countryCode": "534", "alpha3": "SXM" }, { "name": "Slovakia", "countryCode": "703", "alpha3": "SVK" }, { "name": "Slovenia", "countryCode": "705", "alpha3": "SVN" }, { "name": "Solomon Islands", "countryCode": "090", "alpha3": "SLB" }, { "name": "Somalia", "countryCode": "706", "alpha3": "SOM" }, { "name": "South Africa", "countryCode": "710", "alpha3": "ZAF" }, { "name": "South Georgia and the South Sandwich Islands", "countryCode": "239", "alpha3": "SGS" }, { "name": "South Sudan", "countryCode": "728", "alpha3": "SSD" }, { "name": "Spain", "countryCode": "724", "alpha3": "ESP" }, { "name": "Sri Lanka", "countryCode": "144", "alpha3": "LKA" }, { "name": "Sudan", "countryCode": "729", "alpha3": "SDN" }, { "name": "Suriname", "countryCode": "740", "alpha3": "SUR" }, { "name": "Svalbard and Jan Mayen", "countryCode": "744", "alpha3": "SJM" }, { "name": "Swaziland", "countryCode": "748", "alpha3": "SWZ" }, { "name": "Sweden", "countryCode": "752", "alpha3": "SWE" }, { "name": "Switzerland", "countryCode": "756", "alpha3": "CHE" }, { "name": "Syrian Arab Republic", "countryCode": "760", "alpha3": "SYR" }, { "name": "Taiwan, Province of China", "countryCode": "158", "alpha3": "TWN" }, { "name": "Tajikistan", "countryCode": "762", "alpha3": "TJK" }, { "name": "Tanzania, United Republic of", "countryCode": "834", "alpha3": "TZA" }, { "name": "Thailand", "countryCode": "764", "alpha3": "THA" }, { "name": "Timor-Leste", "countryCode": "626", "alpha3": "TLS" }, { "name": "Togo", "countryCode": "768", "alpha3": "TGO" }, { "name": "Tokelau", "countryCode": "772", "alpha3": "TKL" }, { "name": "Tonga", "countryCode": "776", "alpha3": "TON" }, { "name": "Trinidad and Tobago", "countryCode": "780", "alpha3": "TTO" }, { "name": "Tunisia", "countryCode": "788", "alpha3": "TUN" }, { "name": "Turkey", "countryCode": "792", "alpha3": "TUR" }, { "name": "Turkmenistan", "countryCode": "795", "alpha3": "TKM" }, { "name": "Turks and Caicos Islands", "countryCode": "796", "alpha3": "TCA" }, { "name": "Tuvalu", "countryCode": "798", "alpha3": "TUV" }, { "name": "Uganda", "countryCode": "800", "alpha3": "UGA" }, { "name": "Ukraine", "countryCode": "804", "alpha3": "UKR" }, { "name": "United Arab Emirates", "countryCode": "784", "alpha3": "ARE" }, { "name": "United Kingdom of Great Britain and Northern Ireland", "countryCode": "826", "alpha3": "GBR" }, { "name": "United States Minor Outlying Islands", "countryCode": "581", "alpha3": "UMI" }, { "name": "Uruguay", "countryCode": "858", "alpha3": "URY" }, { "name": "Uzbekistan", "countryCode": "860", "alpha3": "UZB" }, { "name": "Vanuatu", "countryCode": "548", "alpha3": "VUT" }, { "name": "Venezuela (Bolivarian Republic of)", "countryCode": "862", "alpha3": "VEN" }, { "name": "Viet Nam", "countryCode": "704", "alpha3": "VNM" }, { "name": "Virgin Islands (British)", "countryCode": "092", "alpha3": "VGB" }, { "name": "Virgin Islands (U.S.)", "countryCode": "850", "alpha3": "VIR" }, { "name": "Wallis and Futuna", "countryCode": "876", "alpha3": "WLF" }, { "name": "Western Sahara", "countryCode": "732", "alpha3": "ESH" }, { "name": "Yemen", "countryCode": "887", "alpha3": "YEM" }, { "name": "Zambia", "countryCode": "894", "alpha3": "ZMB" }, { "name": "Zimbabwe", "countryCode": "716", "alpha3": "ZWE" }];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/NewShippingAddressForm/countries.js");
}();

;

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_checkout__ = __webpack_require__(249);








var _processOrder = __WEBPACK_IMPORTED_MODULE_6_modules_checkout__["a" /* actions */].processOrder;


var OrderSummary = function OrderSummary(props) {
  var product = props.product,
      paymentMethod = props.paymentMethod,
      subTotal = props.subTotal,
      totals = props.totals;


  var paypalButtenHidden = paymentMethod === 'paypal' ? 'visible' : 'hidden';
  var paypalButtonStyle = { visibility: paypalButtenHidden };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
    { item: true, xs: 12, style: { marginTop: '12px' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
      { type: 'title' },
      'Order Summary'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body2' },
          product.name
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 8 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body2' },
          'Subtotal'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body1' },
          '$',
          totals.subtotal || subTotal
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 8 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body2' },
          'Tax'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body1' },
          '$',
          totals.tax || 0
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 8 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body2' },
          'Shipping'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body1' },
          '$',
          totals.shipping || 0
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 8 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body2' },
          'Total'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { item: true, xs: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
          { type: 'body1' },
          '$',
          totals.total || subTotal
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Button___default.a,
        {
          id: 'submitCreditCardOrder',
          variant: 'raised',
          color: 'primary',
          style: { width: '100%', display: paymentMethod === 'braintree' ? 'inline' : 'none' },
          disabled: false /*! formComplete */
        },
        'Order Now'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Button___default.a,
        {
          variant: 'raised',
          color: 'primary',
          style: { width: '100%', display: paymentMethod === 'existing' ? 'inline' : 'none' },
          onClick: props.processOrder,
          disabled: false /*! formComplete */
        },
        'Order Now'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: '#paypal-button', style: paypalButtonStyle })
    )
  );
};

OrderSummary.propTypes = {
  paymentMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  processOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  subTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  totals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    paymentMethod: state.checkout.paymentMethod,
    product: state.checkout.Product,
    subTotal: state.checkout.subTotal,
    totals: state.checkout.totals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    processOrder: function processOrder() {
      dispatch(_processOrder());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(OrderSummary);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_processOrder, 'processOrder', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderSummary/index.jsx');

  __REACT_HOT_LOADER__.register(OrderSummary, 'OrderSummary', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderSummary/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderSummary/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderSummary/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderSummary/index.jsx');
}();

;

/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);









var Step = function Step(props) {
  var Components = props.children;
  var orderFormMessage = props.orderFormMessage || {};
  var display = props.display ? 'inline' : 'none';
  var arrow = props.stepNumber > 1 ? '< ' : '';
  var validity = props.validity,
      previousStep = props.previousStep,
      buttonText = props.buttonText,
      buttonTextInvalid = props.buttonTextInvalid,
      buttonTextIsZero = props.buttonTextIsZero,
      nextStep = props.nextStep,
      stepId = props.stepId,
      stepNumber = props.stepNumber,
      subheading = props.subheading,
      subheadingIsZero = props.subheadingIsZero,
      totalIsZero = props.totalIsZero,
      totalSteps = props.totalSteps;

  var buttonTextString = void 0;

  if (totalIsZero) {
    buttonTextString = buttonTextIsZero || buttonText;
  } else {
    buttonTextString = validity ? buttonText : buttonTextInvalid;
  }

  var subheadingString = void 0;
  if (totalIsZero) {
    subheadingString = subheadingIsZero || subheading;
  } else {
    subheadingString = props.subheading;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
    { container: true, style: { display: display } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      {
        item: true,
        xs: 12
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
        {
          style: { color: 'red' },
          variant: 'subheading'
        },
        !!orderFormMessage && orderFormMessage.text ? orderFormMessage.text : ' '
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { container: true, style: { alignItems: 'flex-end' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
          { item: true, xs: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
            {
              variant: 'display2'
            },
            'Checkout'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
          { item: true, xs: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
            {
              variant: 'headline',
              align: 'right'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { onClick: previousStep, className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.backButton },
              arrow
            ),
            '\xA0\xA0',
            'Step ' + stepNumber + ' of ' + totalSteps
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { paddingBottom: '0' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
          { item: true, xs: stepId !== 'A' ? 5 : 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default.a,
            {
              variant: 'body1',
              onClick: previousStep
            },
            subheadingString
          )
        )
      )
    ),
    Components,
    props.stepId !== 'D' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { paddingRight: '8px', paddingLeft: '8px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default.a,
        {
          className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.stepButton,
          color: 'primary',
          onClick: nextStep,
          variant: 'raised',
          disabled: !validity
        },
        buttonTextString
      )
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_material_ui_Grid___default.a,
      { container: true, justify: 'center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { style: { width: '300px', height: '74px', marginTop: '16px' }, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 257 64', fill: '#9B9B9B' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M232 7H51.94A32 32 0 1 0 32 64a31.79 31.79 0 0 0 19.94-7H232a25 25 0 0 0 0-50zM2 32a30 30 0 1 1 30 30A30 30 0 0 1 2 32z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M38.5 28.42h-1.17v-2.34a5.83 5.83 0 0 0-11.66 0v2.34H24.5a2.34 2.34 0 0 0-2.33 2.33v11.67a2.34 2.34 0 0 0 2.33 2.33h14a2.34 2.34 0 0 0 2.33-2.33V30.75a2.34 2.34 0 0 0-2.33-2.33zm-7 10.5a2.34 2.34 0 1 1 2.33-2.34 2.34 2.34 0 0 1-2.33 2.34zm3.62-10.5h-7.24v-2.34a3.62 3.62 0 0 1 7.24 0z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { style: { isolation: 'isolate' }, fill: '#fff' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M77.25 36.99v-7.75l-1.78 1.81-1.29-1.36 3.36-3.38h2v10.68zM81.12 31.66c0-2.76 1.36-5.51 4.42-5.51S90 28.9 90 31.66s-1.36 5.52-4.42 5.52-4.46-2.77-4.46-5.52zm6.52 0c0-2-.57-3.49-2.1-3.49s-2.1 1.52-2.1 3.49.58 3.5 2.1 3.5 2.1-1.53 2.1-3.5zM91 31.66c0-2.76 1.36-5.51 4.42-5.51s4.42 2.75 4.42 5.51-1.36 5.52-4.42 5.52S91 34.41 91 31.66zm6.52 0c0-2-.57-3.49-2.1-3.49s-2.1 1.52-2.1 3.49.58 3.5 2.1 3.5 2.14-1.53 2.14-3.5zM100.83 28.82a2.72 2.72 0 1 1 2.71 2.68 2.59 2.59 0 0 1-2.71-2.68zm4 0a1.28 1.28 0 1 0-1.28 1.4 1.29 1.29 0 0 0 1.27-1.4zm-2.32 8.17l6.82-10.68h1.21l-6.84 10.68zm4.2-2.49a2.71 2.71 0 1 1 2.7 2.64 2.57 2.57 0 0 1-2.7-2.64zm4 0a1.28 1.28 0 1 0-2.54 0 1.28 1.28 0 1 0 2.54 0zM117 35.5l1.24-1.77a4.72 4.72 0 0 0 3.4 1.45c1.26 0 1.85-.56 1.85-1.18 0-1.86-6.14-.56-6.14-4.58 0-1.78 1.53-3.25 4-3.25a5.94 5.94 0 0 1 4.16 1.49l-1.27 1.7a4.57 4.57 0 0 0-3.1-1.17c-1 0-1.51.41-1.51 1.06 0 1.68 6.13.54 6.13 4.52 0 2-1.4 3.43-4.27 3.43a6.14 6.14 0 0 1-4.49-1.7zM126.77 33.11a3.94 3.94 0 0 1 4-4.05c2.32 0 3.87 1.73 3.87 4.25v.48h-5.74a2.07 2.07 0 0 0 2.22 1.71 3.25 3.25 0 0 0 2-.76l.91 1.35a4.83 4.83 0 0 1-3.18 1.07 3.91 3.91 0 0 1-4.08-4.05zm4-2.38a1.78 1.78 0 0 0-1.89 1.65h3.81a1.77 1.77 0 0 0-1.92-1.65zM135.62 33.11a3.93 3.93 0 0 1 4.09-4.05 3.58 3.58 0 0 1 3.06 1.4l-1.33 1.25a1.87 1.87 0 0 0-1.63-.84 2.07 2.07 0 0 0-2.1 2.24 2.08 2.08 0 0 0 2.1 2.26 1.93 1.93 0 0 0 1.63-.85l1.33 1.25a3.58 3.58 0 0 1-3.06 1.41 3.93 3.93 0 0 1-4.09-4.07zM149.31 36.99v-1a3.64 3.64 0 0 1-2.72 1.17 2.21 2.21 0 0 1-2.49-2.43v-5.47h2v4.69a1.24 1.24 0 0 0 1.42 1.42 2.26 2.26 0 0 0 1.76-.88v-5.23h2v7.73zM153.36 36.99v-7.73h2v1a3.38 3.38 0 0 1 2.47-1.24v2a2.75 2.75 0 0 0-.56-.05 2.62 2.62 0 0 0-1.91.88v5.11zM158.62 33.11a4 4 0 0 1 4-4.05c2.33 0 3.88 1.73 3.88 4.25v.48h-5.75A2.08 2.08 0 0 0 163 35.5a3.27 3.27 0 0 0 2.05-.76l.91 1.35a4.86 4.86 0 0 1-3.19 1.07 3.92 3.92 0 0 1-4.15-4.05zm4-2.38a1.78 1.78 0 0 0-1.88 1.65h3.8a1.76 1.76 0 0 0-1.92-1.65zM171.62 31.66a5.41 5.41 0 0 1 5.69-5.52 4.85 4.85 0 0 1 4.45 2.6l-1.95 1a2.9 2.9 0 0 0-2.5-1.55 3.33 3.33 0 0 0-3.31 3.47 3.33 3.33 0 0 0 3.36 3.5 2.9 2.9 0 0 0 2.5-1.55l1.95.94a4.89 4.89 0 0 1-4.45 2.63 5.43 5.43 0 0 1-5.74-5.52zM188.3 36.99v-4.71c0-1.07-.56-1.41-1.42-1.41a2.24 2.24 0 0 0-1.76.9v5.22h-2.05V26.31h2.05v3.94a3.58 3.58 0 0 1 2.7-1.19 2.23 2.23 0 0 1 2.52 2.44v5.49zM191.85 33.11a4 4 0 0 1 4-4.05c2.32 0 3.87 1.73 3.87 4.25v.48H194a2.09 2.09 0 0 0 2.21 1.71 3.25 3.25 0 0 0 2-.76l.91 1.35a4.86 4.86 0 0 1-3.12 1.09 3.92 3.92 0 0 1-4.15-4.07zm4-2.38a1.78 1.78 0 0 0-1.85 1.65h3.81a1.78 1.78 0 0 0-1.95-1.65zM200.7 33.11a3.94 3.94 0 0 1 4.1-4.05 3.59 3.59 0 0 1 3.06 1.4l-1.33 1.25a1.87 1.87 0 0 0-1.63-.84 2.07 2.07 0 0 0-2.1 2.24 2.08 2.08 0 0 0 2.1 2.26 1.93 1.93 0 0 0 1.63-.85l1.33 1.25a3.6 3.6 0 0 1-3.06 1.41 3.94 3.94 0 0 1-4.1-4.07zM214.19 36.99l-2.05-3-.93 1v2h-2V26.31h2v6.39l2.93-3.44h2.5l-3.06 3.5 3.16 4.23zM217.15 33.11a4.09 4.09 0 1 1 4.08 4.07 3.92 3.92 0 0 1-4.08-4.07zm6.07 0a2 2 0 1 0-4 0 2 2 0 1 0 4 0zM232.06 36.99v-1a3.64 3.64 0 0 1-2.72 1.17 2.21 2.21 0 0 1-2.49-2.43v-5.47h2v4.69a1.24 1.24 0 0 0 1.42 1.42 2.26 2.26 0 0 0 1.76-.88v-5.23h2v7.73zM236.53 35.05v-4h-1.28v-1.79h1.28v-2.12h2v2.12h1.57v1.77h-1.57v3.47c0 .49.26.86.7.86a1 1 0 0 0 .71-.24l.43 1.55a2.47 2.47 0 0 1-1.7.5 1.92 1.92 0 0 1-2.14-2.12z' })
        )
      )
    )
  );
};

Step.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  buttonTextInvalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  nextStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  orderFormMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  previousStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  stepId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  stepNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  subheading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  totalSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  validity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    orderFormMessage: state.checkout.orderFormMessage
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a)(Step));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Step, 'Step', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Step/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Step/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/OrderForm/Step/index.jsx');
}();

;

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._7HQyv,.UQkpL{margin-top:16px}.UQkpL{font-weight:200;width:100%;height:75px;border-radius:8px;font-size:1.5em;text-transform:none}._2GNy5:hover{cursor:pointer}.EwO-e a{text-decoration:underline;color:#289b18}.EwO-e a:hover{cursor:pointer;text-decoration:none}", ""]);

// exports
exports.locals = {
	"top": "_7HQyv",
	"stepButton": "UQkpL",
	"backButton": "_2GNy5",
	"helpButton": "EwO-e"
};

/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_Checkout_components_OrderConfirmation__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_Upsell__ = __webpack_require__(397);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Receipt = function (_Component) {
  _inherits(Receipt, _Component);

  function Receipt(props) {
    _classCallCheck(this, Receipt);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var _props$offer = props.offer,
        OfferPaymentOptions = _props$offer.OfferPaymentOptions,
        selectedPaymentOption = _props$offer.selectedPaymentOption;

    OfferPaymentOptions && OfferPaymentOptions.map(function (option) {
      if (option.id == selectedPaymentOption) {
        if (option.UpSells && option.UpSells.length) {
          _this.UpSells = true;
        }
      }
    });
    return _this;
  }

  Receipt.prototype.componentDidMount = function componentDidMount() {
    this.props.history.replace('/checkout/' + this.props.offer.slug + '/#/thankyou');
    this.props.hideModal();
    // if (window.modalReceipt === true && !this.props.offer.upsellExpired) {
    //   this.props.openModal('upsell');
    // }
  };

  Receipt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.history.location.hash.substring(2) !== 'receipt' && nextProps.offer.upsellExpired) {
      this.props.history.push('/checkout/' + this.props.offer.slug + '/#/receipt');
    }
  };

  Receipt.prototype.render = function render() {
    var hash = this.props.history.location.hash.substring(2);
    var _props$offer2 = this.props.offer,
        isGift = _props$offer2.isGift,
        receiptMessage = _props$offer2.receiptMessage;

    if (!isGift && this.UpSells && !this.props.offer.upsellExpired && hash === 'thankyou') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_routes_Checkout_components_Upsell__["a" /* default */], null)
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
        {
          style: { color: 'red' },
          variant: 'subheading'
        },
        !!receiptMessage && receiptMessage.text ? receiptMessage.text : ' '
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_routes_Checkout_components_OrderConfirmation__["a" /* default */], null)
    );
  };

  return Receipt;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Receipt.propTypes = {
  offer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    isGift: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    receiptMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,
    slug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    upsellExpired: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
  }).isRequired,
  hideModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      hash: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
    }),
    push: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    replace: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }).isRequired,
  openModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* withRouter */])(Receipt);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Receipt, 'Receipt', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/Receipt/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/Receipt/index.jsx');
}();

;

/***/ }),

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderConfirmation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_List__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);








var USER_CONTENT_URL = "https://cdn.foodrevolution.org/checkout/";


var OrderConfirmation = function OrderConfirmation(props) {
  var _props$offer = props.offer,
      isGift = _props$offer.isGift,
      upsellPageMessage = _props$offer.upsellPageMessage;
  var order = props.offer.order;


  if (!order || !order.id) return null;

  var transactionSummary = order.OrderTransactions.reduce(function (acc, val) {
    acc.total += Number(val.amount);
    return acc;
  }, { subtotal: 0.0, shipping: 0.0, tax: 0.0, total: 0.0 });

  var numberWithCommas = function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (!order || !order.id) return null;

  var isPPT = props.offer.slug.slice(0, 3) === 'ppt';
  var logoUrl = isPPT ? 'assets/images/ppt-logo.svg' : 'assets/images/frs18-logo.svg';

  var congratulations = isGift ? 'Congratulations, you\u2019ve just shared a tremendous gift towards a healthier life and a healthier world for someone special!' : 'Congratulations, you\'ve taken a tremendous step towards a healthier life and a healthier world.';

  var instructions = isGift ? 'Soon, they\'ll receive an email with instructions for enjoying this life-changing content. Please ask them to check their email inbox, and let them know that if they don\u2019t receive login instructions from us in the next 10 minutes, to check their spam and promotions folders.' : 'Soon, you will get an email with instructions for enjoying your content. Please check your email inbox, and if you don\u2019t get your login instructions from us in the next 10 minutes, check your spam and promotions folders.';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
    { container: true, justify: 'center', style: { maxWidth: '100%' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
      { item: true, xs: 12, md: 9, style: { marginTop: '16px', maxWidth: '600px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
        { container: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
            { container: true, style: { maxWidth: '100%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
              { item: true, style: { width: '100%', maxWidth: '600px', paddingLeft: '16px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'logo', src: '' + USER_CONTENT_URL + logoUrl })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12, className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.top },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            { variant: 'display2', align: 'center' },
            'Thank you!'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.margin + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.top + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.orderProcessed, variant: 'subheading', style: { fontSize: "1.5em", textAlign: "justify", lineHeight: "1.1em" } },
            congratulations
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.margin + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.top + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.orderProcessed, variant: 'subheading' },
            instructions
          ),
          !!upsellPageMessage && upsellPageMessage.text ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
            { item: true, xs: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
              {
                type: 'title'
              },
              'Unfortunately, we were unable to add the limited offer items to your order.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
              {
                id: 'upsellPageMessage',
                style: { color: 'red' },
                type: 'subheading'
              },
              upsellPageMessage.text
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.margin, variant: 'headline' },
            'Order #',
            order.id
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
          { item: true, xs: 12, className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.margin },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_List___default.a,
            null,
            order.OrderTransactions.reduce(function (a, v) {
              return a.concat(v.TransactionProducts);
            }, []).map(function (product, i) {
              var OrderProduct = order.OrderProducts.find(function (el) {
                return el.ProductId === product.ProductId;
              });
              var productName = OrderProduct ? OrderProduct.Product.name : '';
              var hackyIndex = i + 100;
              var quantityMessage = product.qtyOrdered > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: "0.75em" } },
                ' (Qty: ',
                product.qtyOrdered,
                ')'
              ) : '';
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_List__["ListItem"],
                { style: { paddingLeft: 0, paddingRight: 0 }, key: hackyIndex },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                  { xs: 8, style: { wordWrap: 'break-word', whiteSpace: 'normal' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                    null,
                    productName,
                    quantityMessage
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                  { xs: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                    { align: 'right' },
                    '$' + numberWithCommas(Number(product.amount).toFixed(2))
                  )
                )
              );
            }),
            order.shipping > 0 || order.tax > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_List__["ListItem"],
              { style: { paddingLeft: 0, paddingRight: 0, borderTop: '1px solid', paddingBottom: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 8 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.nameWidth },
                  'Subtotal'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { align: 'right', className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.priceWidth },
                  '$' + numberWithCommas(order.subtotal)
                )
              )
            ) : null,
            order.shipping > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_List__["ListItem"],
              { style: { padding: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 8 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.nameWidth },
                  'Shipping'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { align: 'right', className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.priceWidth },
                  '$' + numberWithCommas(order.shipping)
                )
              )
            ) : null,
            order.tax > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_List__["ListItem"],
              { style: { padding: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 8 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.nameWidth },
                  'Tax'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { align: 'right', className: '' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.priceWidth },
                  '$' + numberWithCommas(order.tax)
                )
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_List__["ListItem"],
              { style: { paddingLeft: 0, paddingRight: 0, paddingTop: 0, borderTop: order.shipping > 0 || order.tax > 0 ? '' : '1px solid' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 8 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.bold + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.nameWidth },
                  'Total'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Grid___default.a,
                { item: true, xs: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                  { align: 'right', className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.bold + ' ' + __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.priceWidth },
                  '$' + numberWithCommas(transactionSummary.total.toFixed(2))
                )
              )
            )
          )
        )
      )
    )
  );
};

OrderConfirmation.propTypes = {
  offer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return { offer: state.checkout };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(OrderConfirmation);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(USER_CONTENT_URL, 'USER_CONTENT_URL', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderConfirmation/index.jsx');

  __REACT_HOT_LOADER__.register(OrderConfirmation, 'OrderConfirmation', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderConfirmation/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderConfirmation/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/components/OrderConfirmation/index.jsx');
}();

;

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1131);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(983)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--1-2!../../../../../node_modules/sass-loader/lib/loader.js??ref--1-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(982)(undefined);
// imports


// module
exports.push([module.i, "._3DLZN{margin-top:16px}._11epP{margin-left:16px;margin-right:16px}.VjAIa{margin-right:0;text-align:justify}._6QrZA{width:100%;color:grey}._6QrZA:hover{cursor:pointer}._2sFxB{background-color:#d3d3d3}._2Yasu{font-weight:700}nameWidth{width:75%}priceWidth{margin-left:8px}", ""]);

// exports
exports.locals = {
	"top": "_3DLZN",
	"margin": "_11epP",
	"orderProcessed": "VjAIa",
	"myProductsButton": "_6QrZA",
	"grey": "_2sFxB",
	"bold": "_2Yasu"
};

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_checkout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_product__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_user__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_modal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderForm__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receipt__ = __webpack_require__(1128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */











// inject reducers that might not have been originally there
Object(__WEBPACK_IMPORTED_MODULE_6_store__["c" /* injectAsyncReducers */])({
  checkout: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["b" /* default */],
  products: __WEBPACK_IMPORTED_MODULE_3_modules_product__["b" /* default */]
});

var Checkout = (_dec = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    modalOpen: state.modal.showModal,
    offer: state.checkout,
    location: state.router.location,
    isAuthenticated: state.user.isAuthenticated,
    user: state.user
    // DefaultBillingAddress: state.user.DefaultBillingAddress,
    // DefaultShippingAddress: state.user.DefaultShippingAddress,
  };
}, {
  createUser: __WEBPACK_IMPORTED_MODULE_4_modules_user__["a" /* actions */].createUser,
  loadOffer: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].loadOffer,
  loadTotals: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].loadTotals,
  disableUpsell: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].disableUpsell,
  updateProductAmount: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].updateProductAmount,
  setPaymentMethod: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setPaymentMethod,
  setNewAddress: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setNewAddress,
  setOrderFormMessage: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setOrderFormMessage,
  setCurrentStep: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setCurrentStep,
  setUpsellPageMessage: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setUpsellPageMessage,
  addPhysicalProduct: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].addPhysicalProduct,
  clickBumpOffer: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].clickBumpOffer,
  processOrder: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].processOrder,
  processUpSell: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].processUpSell,
  receiveOffer: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].receiveOffer,
  resetOnLeavePage: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].resetOnLeavePage,
  checkFormValidity: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].checkFormValidity,
  saveNewUserInfo: __WEBPACK_IMPORTED_MODULE_4_modules_user__["a" /* actions */].receiveUpdateProfile,
  setSelectedBillingAddress: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setSelectedBillingAddress,
  setSelectedShippingAddress: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setSelectedShippingAddress,
  setSelectedUserPaymentId: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setSelectedUserPaymentId,
  setSelectedPaymentOption: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setSelectedPaymentOption,
  setSteps: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setSteps,
  splitTestOptionsFirst: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].splitTestOptionsFirst,
  openModal: __WEBPACK_IMPORTED_MODULE_5_modules_modal__["a" /* actions */].openModal,
  hideModal: __WEBPACK_IMPORTED_MODULE_5_modules_modal__["a" /* actions */].hideModal,
  addProducts: __WEBPACK_IMPORTED_MODULE_3_modules_product__["a" /* actions */].addProductsToAll,
  setBraintreeValidity: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].setBraintreeValidity,
  blurBraintreeField: __WEBPACK_IMPORTED_MODULE_2_modules_checkout__["a" /* actions */].blurBraintreeField
}), _dec(_class = function (_Component) {
  _inherits(Checkout, _Component);

  function Checkout() {
    _classCallCheck(this, Checkout);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Checkout.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        location = _props.location,
        offer = _props.offer,
        loadOffer = _props.loadOffer,
        user = _props.user,
        isAuthenticated = _props.isAuthenticated,
        setSelectedBillingAddress = _props.setSelectedBillingAddress,
        setSelectedShippingAddress = _props.setSelectedShippingAddress,
        splitTestOptionsFirst = _props.splitTestOptionsFirst;


    window.SPLIT_TEST_OPTIONS_FIRST = splitTestOptionsFirst;

    // parse pathname for offer slug
    var slug = location.pathname.split('/')[2];

    // Only load the slug if undefined or different than before
    if (slug !== offer.slug) loadOffer(slug);

    if (!offer.submitted) {
      // Load default addresses from user profile if logged in and form name is blank
      if (offer.newBillingAddress.name === '' && user.isAuthenticated && user.DefaultBillingAddress) {
        setSelectedBillingAddress(user.DefaultBillingAddress.id.toString());
      }

      if (offer.newShippingAddress.name === '' && user.isAuthenticated && user.DefaultShippingAddress) {
        setSelectedShippingAddress(user.DefaultShippingAddress.id.toString());
      }

      // If the user logs out on the page then reset to default address ids
      if (!isAuthenticated && offer.selectedBillingAddressId !== '0') setSelectedBillingAddress('0');
      if (!isAuthenticated && offer.selectedShippingAddressId !== '0') setSelectedShippingAddress('0');
    }
  };

  Checkout.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.hideModal();
  };

  Checkout.prototype.render = function render() {
    var _props$offer = this.props.offer,
        optionsFirst = _props$offer.optionsFirst,
        submitted = _props$offer.submitted;
    //changing the key will cause OrderForm to remount, and reset steps

    var key = optionsFirst ? 1 : 2;
    return !submitted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OrderForm__["a" /* default */], _extends({ key: key }, this.props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Receipt__["a" /* default */], this.props);
    // return <Receipt {...this.props} />;
  };

  return Checkout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])) || _class);
var _default = Checkout;


/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Checkout, 'Checkout', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Checkout/containers/index.jsx');
}();

;

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enumerate = __webpack_require__(995);

/**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */
function BraintreeError(options) {
  if (!BraintreeError.types.hasOwnProperty(options.type)) {
    throw new Error(options.type + ' is not a valid type.');
  }

  if (!options.code) {
    throw new Error('Error code required.');
  }

  if (!options.message) {
    throw new Error('Error message required.');
  }

  this.name = 'BraintreeError';

  /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */
  this.code = options.code;

  /**
   * @type {string}
   * @description A short description of the error.
   */
  this.message = options.message;

  /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */
  this.type = options.type;

  /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */
  this.details = options.details;
}

BraintreeError.prototype = Object.create(Error.prototype);
BraintreeError.prototype.constructor = BraintreeError;

/**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */
BraintreeError.types = enumerate([
  'CUSTOMER',
  'MERCHANT',
  'NETWORK',
  'INTERNAL',
  'UNKNOWN'
]);

BraintreeError.findRootError = function (err) {
  if (err instanceof BraintreeError && err.details && err.details.originalError) {
    return BraintreeError.findRootError(err.details.originalError);
  }

  return err;
};

module.exports = BraintreeError;


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Promise = global.Promise || __webpack_require__(1040);

module.exports = Promise;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deferred = __webpack_require__(1044);
var once = __webpack_require__(1045);
var promiseOrCallback = __webpack_require__(1046);

function wrapPromise(fn) {
  return function () {
    var callback;
    var args = Array.prototype.slice.call(arguments);
    var lastArg = args[args.length - 1];

    if (typeof lastArg === 'function') {
      callback = args.pop();
      callback = once(deferred(callback));
    }
    return promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
  };
}

wrapPromise.wrapPrototype = function (target, options) {
  var methods, ignoreMethods, includePrivateMethods;

  options = options || {};
  ignoreMethods = options.ignoreMethods || [];
  includePrivateMethods = options.transformPrivateMethods === true;

  methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
    var isNotPrivateMethod;
    var isNonConstructorFunction = method !== 'constructor' &&
      typeof target.prototype[method] === 'function';
    var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;

    if (includePrivateMethods) {
      isNotPrivateMethod = true;
    } else {
      isNotPrivateMethod = method.charAt(0) !== '_';
    }

    return isNonConstructorFunction &&
      isNotPrivateMethod &&
      isNotAnIgnoredMethod;
  });

  methods.forEach(function (method) {
    var original = target.prototype[method];

    target.prototype[method] = wrapPromise(original);
  });

  return target;
};

module.exports = wrapPromise;


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = "3.30.0";
var PLATFORM = 'web';

module.exports = {
  ANALYTICS_PREFIX: 'web.',
  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
  INTEGRATION_TIMEOUT_MS: 60000,
  VERSION: VERSION,
  INTEGRATION: 'custom',
  SOURCE: 'client',
  PLATFORM: PLATFORM,
  BRAINTREE_LIBRARY_VERSION: 'braintree/' + PLATFORM + '/' + VERSION
};


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);

module.exports = {
  INVALID_USE_OF_INTERNAL_FUNCTION: {
    type: BraintreeError.types.INTERNAL,
    code: 'INVALID_USE_OF_INTERNAL_FUNCTION'
  },
  CALLBACK_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'CALLBACK_REQUIRED'
  },
  INSTANTIATION_OPTION_REQUIRED: {
    type: BraintreeError.types.MERCHANT,
    code: 'INSTANTIATION_OPTION_REQUIRED'
  },
  INVALID_OPTION: {
    type: BraintreeError.types.MERCHANT,
    code: 'INVALID_OPTION'
  },
  INCOMPATIBLE_VERSIONS: {
    type: BraintreeError.types.MERCHANT,
    code: 'INCOMPATIBLE_VERSIONS'
  },
  METHOD_CALLED_AFTER_TEARDOWN: {
    type: BraintreeError.types.MERCHANT,
    code: 'METHOD_CALLED_AFTER_TEARDOWN'
  },
  BRAINTREE_API_ACCESS_RESTRICTED: {
    type: BraintreeError.types.MERCHANT,
    code: 'BRAINTREE_API_ACCESS_RESTRICTED',
    message: 'Your access is restricted and cannot use this part of the Braintree API.'
  }
};


/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assignNormalized = typeof Object.assign === 'function' ? Object.assign : assignPolyfill;

function assignPolyfill(destination) {
  var i, source, key;

  for (i = 1; i < arguments.length; i++) {
    source = arguments[i];
    for (key in source) {
      if (source.hasOwnProperty(key)) {
        destination[key] = source[key];
      }
    }
  }

  return destination;
}

module.exports = {
  assign: assignNormalized,
  _assign: assignPolyfill
};


/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(989);
var addMetadata = __webpack_require__(1009);

function _millisToSeconds(millis) {
  return Math.floor(millis / 1000);
}

function sendAnalyticsEvent(client, kind, callback) {
  var configuration = client.getConfiguration();
  var request = client._request;
  var timestamp = _millisToSeconds(Date.now());
  var url = configuration.gatewayConfiguration.analytics.url;
  var data = {
    analytics: [{
      kind: constants.ANALYTICS_PREFIX + kind,
      timestamp: timestamp
    }]
  };

  request({
    url: url,
    method: 'post',
    data: addMetadata(configuration, data),
    timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
  }, callback);
}

module.exports = {
  sendEvent: sendAnalyticsEvent
};


/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BraintreeError = __webpack_require__(986);

module.exports = {
  HOSTED_FIELDS_TIMEOUT: {
    type: BraintreeError.types.UNKNOWN,
    code: 'HOSTED_FIELDS_TIMEOUT',
    message: 'Hosted Fields timed out when attempting to set up.'
  },
  HOSTED_FIELDS_INVALID_FIELD_KEY: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_INVALID_FIELD_KEY'
  },
  HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_INVALID_FIELD_SELECTOR',
    message: 'Selector does not reference a valid DOM node.'
  },
  HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME',
    message: 'Element already contains a Braintree iframe.'
  },
  HOSTED_FIELDS_FIELD_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_INVALID'
  },
  HOSTED_FIELDS_FIELD_NOT_PRESENT: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_NOT_PRESENT'
  },
  HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
    type: BraintreeError.types.NETWORK,
    code: 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR',
    message: 'A tokenization network error occurred.'
  },
  HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE',
    message: 'This credit card already exists in the merchant\'s vault.'
  },
  HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED',
    message: 'CVV verification failed during tokenization.'
  },
  HOSTED_FIELDS_FAILED_TOKENIZATION: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FAILED_TOKENIZATION',
    message: 'The supplied card data failed tokenization.'
  },
  HOSTED_FIELDS_FIELDS_EMPTY: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FIELDS_EMPTY',
    message: 'All fields are empty. Cannot tokenize empty card fields.'
  },
  HOSTED_FIELDS_FIELDS_INVALID: {
    type: BraintreeError.types.CUSTOMER,
    code: 'HOSTED_FIELDS_FIELDS_INVALID',
    message: 'Some payment input fields are invalid. Cannot tokenize invalid card fields.'
  },
  HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED'
  },
  HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED'
  },
  HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
    type: BraintreeError.types.MERCHANT,
    code: 'HOSTED_FIELDS_FIELD_PROPERTY_INVALID'
  }
};


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(1089);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function enumerate(values, prefix) {
  prefix = prefix == null ? '' : prefix;

  return values.reduce(function (enumeration, value) {
    enumeration[value] = prefix + value;

    return enumeration;
  }, {});
}

module.exports = enumerate;


/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isIe9(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('MSIE 9') !== -1;
};


/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;


/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;

    return v.toString(16);
  });
}

module.exports = uuid;


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (obj) {
  return Object.keys(obj).filter(function (key) {
    return typeof obj[key] === 'function';
  });
};


/***/ })

});


// WEBPACK FOOTER //
// checkout-ae654c63.js